
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kId2E", function(module, exports) {
/* ForYou.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $65DSU = parcelRequire("65DSU");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * @generated SignedSource<<7fced045dc47410034aa0c4ada4a2094>>
 * @relayHash 1863df8f5b437509db01b53adb690a5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f
const $bdc4704ef838d750$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1863df8f5b437509db01b53adb690a5e",
            "id": "562db4f12c4ad9eae28ba6c51ae8da8b69fd2ce5bffe3434f22e60bb0283413f",
            "metadata": {},
            "name": "useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForPersonalizedTemplatesV2GetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$bdc4704ef838d750$var$node.hash = "c5200736e1bf2cb94aae4951d21860dd";
var $bdc4704ef838d750$export$2e2bcd8739ae039 = $bdc4704ef838d750$var$node;






var $jb2R2 = parcelRequire("jb2R2");


var $bQm3c = parcelRequire("bQm3c");








var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

var $1gy7x = parcelRequire("1gy7x");


var $dCb9P = parcelRequire("dCb9P");


var $2FNNv = parcelRequire("2FNNv");


var $1ytiN = parcelRequire("1ytiN");


var $7c4rV = parcelRequire("7c4rV");


var $jMyy4 = parcelRequire("jMyy4");

const $c40f927ec91fa029$export$ec209108e9c3bdab = (0, $bdc4704ef838d750$export$2e2bcd8739ae039);
const $c40f927ec91fa029$export$1cb684a5f5ad885 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2)
        });
    }, [
        experienceTracker
    ]);
    // First check if they are even a founding admin
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
    ], !isSiteAdmin);
    const { data: personalSpaceKeyData, loading: personalSpaceKeyLoading, error: personalSpaceKeyError } = (0, $jMyy4.useQueryInterop)($c40f927ec91fa029$export$ec209108e9c3bdab, {
        skip: !userId,
        __callerPackage__: "experiment-personalized-templates-v2"
    });
    const { data: accountTraitsData, loading: accountTraitsLoading, error: accountTraitsError } = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: !isSiteAdmin
    });
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt, hasDismissedOnboardingActions: hasDismissedOnboardingActions, isTemplateListDismissed: isTemplateListDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const personalSpaceKey = personalSpaceKeyData?.user?.confluence?.hasPersonalSpace && personalSpaceKeyData?.user?.confluence?.space?.key || '';
    const hasDismissedTakeover = hasDismissedOnboardingActions && isTemplateListDismissed;
    const isInOnboardingPeriod = Boolean(takeoverSeenAt) && (0, $jb2R2.default)(new Date(), new Date(takeoverSeenAt)) <= 14;
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $jb2R2.default)(new Date(), new Date(takeoverSeenAt)) > 14;
    const isEstablishedUser = accountTraitsData?.attributes?.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const potentiallyEligibleUserForPTV2 = isFoundingAdmin && !takeoverExpired && !hasDismissedTakeover && !isEstablishedUser;
    // If both founding admin + !established user, then we can check if they are a land founding admin
    const { isLandUser: isLandUser, isXflowUser: isXflowUser, error: userTypeError, loading: userTypeLoading } = (0, $dCb9P.useUserByLicensedProducts)({
        skip: !potentiallyEligibleUserForPTV2
    });
    /**
   * 1. If they have seen it, then they are simply eligible for the takeover.
   * 2. If they haven't seen it yet,  then we need to check the other eligibility conditions
   * 		to determine if we should set `takeoverSeenAt` later -> show the takeover.
   *   a. They need to be not established
   *   b. They need to be a founding admin
   *   c. They need to have a personal space
   */ const isGenerallyEligible = takeoverSeenAt !== undefined || Boolean(isFoundingAdmin && !isEstablishedUser && Boolean(personalSpaceKey));
    if (personalSpaceKeyLoading || userTypeLoading || onboardingStateLoading || accountTraitsLoading) return {
        isEligibleForLand: false,
        isEligibleForXflow: false,
        loading: true,
        isVisible: false
    };
    if (userTypeError || onboardingStateError || personalSpaceKeyError || accountTraitsError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2),
        error: userTypeError || onboardingStateError || personalSpaceKeyError || accountTraitsError
    });
    return {
        isEligibleForLand: isLandUser && isGenerallyEligible,
        isEligibleForXflow: isXflowUser && isGenerallyEligible,
        loading: false,
        isVisible: (isLandUser || isXflowUser) && isGenerallyEligible && (takeoverSeenAt === undefined || isInOnboardingPeriod) && !hasDismissedTakeover,
        wasPTV2TakeoverSeen: Boolean(takeoverSeenAt)
    };
};


/**
 * @generated SignedSource<<74cec05ad81d867be20bf6ae2e66f9f7>>
 * @relayHash fcde14ee9d1ec0e3c9fb1781be4474aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a
const $a0f70f5b02f4883d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fcde14ee9d1ec0e3c9fb1781be4474aa",
            "id": "8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a",
            "metadata": {},
            "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a0f70f5b02f4883d$var$node.hash = "2d292d6e6d3ff58f591364b4a8548ff0";
var $a0f70f5b02f4883d$export$2e2bcd8739ae039 = $a0f70f5b02f4883d$var$node;












var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $9wGTI = parcelRequire("9wGTI");





var $eyUJP = parcelRequire("eyUJP");







var $d9tcB = parcelRequire("d9tcB");


var $JCGnt = parcelRequire("JCGnt");


var $c8Y4F = parcelRequire("c8Y4F");




const $7464c4ddf12420b1$var$useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery = (0, $c8Y4F.default);
const $7464c4ddf12420b1$export$4c79b4b8a009727d = (skip)=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($7464c4ddf12420b1$var$useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery, {
        skip: skip,
        __callerPackage__: "experiment-personalized-templates-v2"
    });
    const licensedUserCount = data?.license?.licenseConsumingUserCount ?? 0;
    return {
        loading: loading,
        error: error,
        licensedUserCount: licensedUserCount
    };
};


const $d7cf94dbebfcc162$var$useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery = (0, $a0f70f5b02f4883d$export$2e2bcd8739ae039);
const $d7cf94dbebfcc162$export$4fd12986b310e943 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensedUser = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        IS_FOUNDING_ADMIN: (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...(0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS)
    }), !isLicensedUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'));
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isNthUser = isLicensedUser && !onboardingStateLoading && !onboardingStateError && !isFoundingAdmin;
    const { licensedUserCount: licensedUserCount, loading: userCountDataLoading, error: userCountDataError } = (0, $7464c4ddf12420b1$export$4c79b4b8a009727d)(!isNthUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'));
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: 15
    }, !isNthUser || !(0, $9wGTI.fg)('cc-activation-unify-home-onboarding-kill-switch'));
    const isOverTenUserInstance = Boolean(licensedUserCount && licensedUserCount > 10);
    const { data: userData, loading: userDataLoading, error: userDataError } = (0, $jMyy4.useQueryInterop)($d7cf94dbebfcc162$var$useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery, {
        skip: !isNthUser || !(0, $9wGTI.fg)('cc-enable-nth-user-home-onboarding-revamp'),
        __callerPackage__: "experiment-personalized-templates-v2"
    });
    const personalSpaceKey = userData?.user?.confluence?.hasPersonalSpace && userData?.user?.confluence?.space?.key;
    const isExperienceWithinFourteenDays = (0, $cozmU.useMemo)(()=>{
        if (!takeoverSeenAt) return true;
        return (0, $jb2R2.default)(new Date(), new Date(takeoverSeenAt)) <= 14;
    }, [
        takeoverSeenAt
    ]);
    const eligibilityError = onboardingStateError || userCountDataError || userDataError;
    if (eligibilityError && ((0, $1uFM6.isUnauthorizedError)(eligibilityError) || (0, $95rLf.isExpectedApolloError)(eligibilityError))) (0, $7Sm4c.markErrorAsHandled)(eligibilityError);
    const loading = onboardingStateLoading || userCountDataLoading || userDataLoading || Boolean(isNewUserLoading);
    const isEligible = Boolean(!eligibilityError && !loading && isNthUser && isOverTenUserInstance && !!personalSpaceKey && isNewUser === true);
    return {
        isEligible: isEligible,
        isVisible: isEligible && isExperienceWithinFourteenDays,
        loading: loading,
        error: eligibilityError
    };
};









var $apWEJ = parcelRequire("apWEJ");

var $7SvHK = parcelRequire("7SvHK");

var $esV19 = parcelRequire("esV19");

const $105c1ec9298e5371$export$1d2f395a0e4c4b9f = (timestamp)=>{
    if (!timestamp || timestamp.trim() === '') return false;
    const timestampDate = new Date(timestamp);
    if (!(0, $esV19.default)(timestampDate)) return false;
    const now = new Date();
    // If the date is in the future, check if it's within 2 weeks from now
    if ((0, $7SvHK.default)(timestampDate)) return (0, $apWEJ.default)(timestampDate, now) < 2;
    // If the date is in the past, check if it's within 2 weeks ago
    return (0, $apWEJ.default)(now, timestampDate) < 2;
};


const $6f0db1142174f95f$export$93613d399942f4cb = ()=>{
    const { data: data, loading: onboardingLoading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER
    ]);
    const { viewedAt: viewedAt, headerDismissed: headerDismissed } = (0, $ivb8S.deserializeState)(data);
    const isWithinValidTimeWindow = (0, $105c1ec9298e5371$export$1d2f395a0e4c4b9f)(viewedAt);
    // We only want to show useCasesInNthUserOnboarding if we are within the 14 days onboarding period
    // and the header has not already been dismissed.
    const isEligibleForUseCasesHomeChanges = isWithinValidTimeWindow && !headerDismissed && !error;
    return {
        loading: onboardingLoading,
        isEligible: isEligibleForUseCasesHomeChanges,
        error: error
    };
};



var $i3jcY = parcelRequire("i3jcY");


var $aDe4X = parcelRequire("aDe4X");

function $f869c0d94495260f$export$fa48385168985af8() {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading, isVisible: v2NthUserVisible } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    const { isEligibleForLand: ptv2Eligible, isEligibleForXflow: ptv2EligibleXflow, loading: ptv2Loading, isVisible: isPTV2Visible } = (0, $c40f927ec91fa029$export$1cb684a5f5ad885)();
    const { isEligible: nthUserHomeOnboardingRevampEligible, loading: nthUserHomeOnboardingRevampLoading, isVisible: nthUserHomeOnboardingRevampVisible } = (0, $d7cf94dbebfcc162$export$4fd12986b310e943)();
    const { loading: useCasesLoading, isEligible: isEligibleForUseCasesHomeChanges } = (0, $6f0db1142174f95f$export$93613d399942f4cb)();
    (0, $cozmU.useEffect)(()=>{
        if (!ptv2Loading && !(ptv2Eligible || ptv2EligibleXflow)) experienceTracker.abort({
            name: (0, $irVI7.ONBOARDING_PERSONALIZED_TEMPLATES_V2),
            reason: 'Not eligible for v2 takeover'
        });
    }, [
        ptv2Eligible,
        ptv2EligibleXflow,
        ptv2Loading,
        experienceTracker
    ]);
    // Early return for loading states
    const loading = [
        ptv2Loading,
        nthUserHomeOnboardingRevampLoading,
        useCasesLoading,
        v2NthUserLoading
    ];
    if (loading.some(Boolean)) return {
        onboardingTakeoverType: null,
        loading: true
    };
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return {
        onboardingTakeoverType: null
    };
    if (isEligibleForUseCasesHomeChanges) return {
        onboardingTakeoverType: 'use-cases-in-nth-user-onboarding'
    };
    // Check for nth user home onboarding revamp
    if (nthUserHomeOnboardingRevampEligible && (0, $6mKj3.expValEquals)('cc-nth-user-home-onboarding-revamp', 'cohort', 'experiment')) {
        if (nthUserHomeOnboardingRevampVisible) return {
            onboardingTakeoverType: 'nth-user-home-onboarding-revamp'
        };
        return {
            onboardingTakeoverType: null
        };
    }
    if (ptv2Eligible) return isPTV2Visible ? {
        onboardingTakeoverType: 'personalized-templates-v2'
    } : {
        onboardingTakeoverType: null
    };
    else if (ptv2EligibleXflow) return isPTV2Visible ? {
        onboardingTakeoverType: 'personalized-templates-v2-xflow'
    } : {
        onboardingTakeoverType: null
    };
    if (v2NthUserEligible) return v2NthUserVisible ? {
        onboardingTakeoverType: 'nth-user'
    } : {
        onboardingTakeoverType: null
    };
    return {
        onboardingTakeoverType: null
    };
}



var $dS3n9 = parcelRequire("dS3n9");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");





var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $1A7bE = parcelRequire("1A7bE");


var $aJPUt = parcelRequire("aJPUt");


var $iqPSe = parcelRequire("iqPSe");


var $7boqA = parcelRequire("7boqA");


var $bxcP5 = parcelRequire("bxcP5");


var $kLaAt = parcelRequire("kLaAt");


var $eSLr0 = parcelRequire("eSLr0");


var $i1Y90 = parcelRequire("i1Y90");


var $lt6Lx = parcelRequire("lt6Lx");




var $4Cx0V = parcelRequire("4Cx0V");






var $5mBfb = parcelRequire("5mBfb");




var $jmjWc = parcelRequire("jmjWc");


const $f8c0187a09ac9108$export$76c223fce296f63d = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EsZsn",
    name: "LazyAutomationExecutionLimit",
    loader: async ()=>(await (parcelRequire("2lwv0"))).AutomationExecutionLimitMessageComponent
});









var $bjj9l = parcelRequire("bjj9l");


var $gkVDU = parcelRequire("gkVDU");

/* RightPanel.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $b3j2Y = parcelRequire("b3j2Y");


var $kvJHJ = parcelRequire("kvJHJ");





var $h1Vf7 = parcelRequire("h1Vf7");





var $iMnC5 = parcelRequire("iMnC5");








var $4PPzL = parcelRequire("4PPzL");













var $7Ndnw = parcelRequire("7Ndnw");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $9fBoq = parcelRequire("9fBoq");


var $dizL5 = parcelRequire("dizL5");


var $4lbme = parcelRequire("4lbme");

const $c911dd4d390b4089$var$CollapsibleForgeApps = ({ forgeApps: forgeApps })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [appInitialStates, setAppInitialStates] = (0, $cozmU.useState)(new Map());
    const onInitialRender = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.HOME_RIGHT_PANEL_FORGE_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, forgeApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            key: app.id,
            module: app
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4lbme.CollapsibleSection), {
            sectionId: app.id,
            header: (0, $9fBoq.extensionTitle)(app),
            initialStateOverride: appInitialStates.get(app.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_FORGE_EXPERIENCE),
            id: app.id
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.HomepageFeedForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED)
            },
            onInitialRender: onInitialRender
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                const oldValue = appInitialStates.get(app.id);
                const newValue = oldValue === 'EXPANDED' ? 'COLLAPSED' : 'EXPANDED';
                setAppInitialStates(new Map(appInitialStates.set(app.id, newValue)));
            }
        }))));
};
const $c911dd4d390b4089$export$48874bdb6736064e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c911dd4d390b4089$var$CollapsibleForgeApps, {
                forgeApps: forgeModules
            }));
        }
    });
};


/* RightPanelDragHandle.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $edb12c54129d5bfa$var$dragHandleStyles = {
    default: "_23rrnHGqpH _3JzbaeTjXh _39xV02uFDC _0jFU0VN91d _2IhTondnbC _1mT5xdWVPG _0wOv4QYNYw _2XsHFMB0rP _0hPERGJrlu",
    isDown: "_3vBAKHJrlu"
};
const $edb12c54129d5bfa$export$47ecfdcf2282c863 = ({ onResizeDrag: onResizeDrag, onResizeComplete: onResizeComplete })=>{
    const handleRef = (0, $cozmU.useRef)(null);
    const [isDown, setIsDown] = (0, $cozmU.useState)(false);
    const previousUpdate = (0, $cozmU.useRef)({
        clientX: 0,
        time: 0
    });
    (0, $cozmU.useEffect)(()=>{
        const downListener = (e)=>{
            if (e.button !== 0) return;
            setIsDown(true);
            previousUpdate.current = {
                clientX: e.clientX,
                time: Date.now()
            };
            document.body.style.cursor = 'col-resize';
            e.preventDefault();
        };
        const handleRefCurrent = handleRef.current;
        handleRefCurrent?.addEventListener('mousedown', downListener);
        return ()=>{
            document.body.style.cursor = 'default';
            handleRefCurrent?.removeEventListener('mousedown', downListener);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const upListener = (e)=>{
            if (e.button !== 0) return;
            setIsDown(false);
            document.body.style.cursor = 'default';
            onResizeComplete();
        };
        const moveListener = (e)=>{
            if (e.button !== 0) return;
            if (isDown) {
                const now = Date.now();
                if (now - previousUpdate.current.time > 30) {
                    onResizeDrag(e.clientX - previousUpdate.current.clientX);
                    previousUpdate.current = {
                        clientX: e.clientX,
                        time: now
                    };
                }
                e.preventDefault();
            }
        };
        window.addEventListener('mouseup', upListener);
        window.addEventListener('mousemove', moveListener);
        return ()=>{
            window.removeEventListener('mouseup', upListener);
            window.removeEventListener('mousemove', moveListener);
        };
    }, [
        isDown,
        onResizeDrag,
        onResizeComplete
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: handleRef,
        "data-testid": "resize-handle",
        className: (0, $hekY6.default)([
            $edb12c54129d5bfa$var$dragHandleStyles['default'],
            $edb12c54129d5bfa$var$dragHandleStyles['isDown']
        ])
    });
};



var $jYZYm = parcelRequire("jYZYm");

/* eslint react-hooks/exhaustive-deps: 0 */ 



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $58fab37e09524ad2$export$f94783f43423b3cb = 'right-panel-compact';
const $58fab37e09524ad2$export$430e07f935c066f6 = ({ rightPanelRef: rightPanelRef, defaultWidth: defaultWidth, minWidth: minWidth, maxWidth: maxWidth, compactThreshold: compactThreshold })=>{
    const totalOffset = (0, $cozmU.useRef)(0);
    const [initialWidth, setInitialWidth] = (0, $cozmU.useState)(parseInt((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).HOME_SIDEBAR_WIDTH)) || defaultWidth);
    const applyCompactStyling = ()=>{
        if (!rightPanelRef.current) return;
        if (rightPanelRef.current.offsetWidth < compactThreshold) rightPanelRef.current.classList.add($58fab37e09524ad2$export$f94783f43423b3cb);
        else rightPanelRef.current.classList.remove($58fab37e09524ad2$export$f94783f43423b3cb);
    };
    const onResizeDrag = (0, $cozmU.useCallback)((offset)=>{
        totalOffset.current += offset;
        const newWidth = Math.max(Math.min(initialWidth - totalOffset.current, maxWidth), minWidth);
        requestAnimationFrame(()=>{
            rightPanelRef.current.style.setProperty('width', `${newWidth}px`);
            applyCompactStyling();
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rightPanelRef,
        totalOffset,
        initialWidth
    ]);
    const onResizeComplete = (0, $cozmU.useCallback)(()=>{
        // Tests require this fallback to style.width because jsdom doesn't give elements an actual width
        const finalWidth = rightPanelRef.current.offsetWidth || parseInt(rightPanelRef.current.style.width || '');
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).HOME_SIDEBAR_WIDTH, finalWidth);
        setInitialWidth(finalWidth);
        totalOffset.current = 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        totalOffset,
        (0, $17wUi.confluenceLocalStorageInstance)
    ]);
    (0, $cozmU.useEffect)(()=>{
        applyCompactStyling();
        const resizeListener = ()=>{
            applyCompactStyling();
        };
        window.addEventListener('resize', resizeListener);
        return ()=>window.removeEventListener('resize', resizeListener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        rightPanelRef: rightPanelRef,
        onResizeDrag: onResizeDrag,
        onResizeComplete: onResizeComplete,
        initialWidth: initialWidth
    };
};


const $6a570c156dcdbd2e$var$DEFAULT_WIDTH = 475;
const $6a570c156dcdbd2e$var$MIN_WIDTH = 350;
const $6a570c156dcdbd2e$var$MAX_WIDTH = 818;
const $6a570c156dcdbd2e$var$POPULAR_COMPACT_THRESHOLD = 500;
const $6a570c156dcdbd2e$var$resizeablePanelStyles = null;
const $6a570c156dcdbd2e$var$panelContainerStyles = null;
const $6a570c156dcdbd2e$var$collectRightPanelExperiences = (events, experience)=>{
    (0, $1A7bE.collectAll)([
        (0, $irVI7.HOME_RIGHT_PANEL_WELCOME_MESSAGE_EXPERIENCE),
        (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE),
        (0, $irVI7.HOME_SPACES_EXPERIENCE)
    ])(events, experience);
};
const $6a570c156dcdbd2e$export$364a989a35814102 = ({ widthMode: widthMode = 'resizable' })=>{
    const rightPanelRef = (0, $cozmU.useRef)(null);
    const { shouldShowForgeApps: shouldShowForgeApps } = (0, $jYZYm.useRightPanelVisible)();
    const { onResizeDrag: onResizeDrag, onResizeComplete: onResizeComplete, initialWidth: initialWidth } = (0, $58fab37e09524ad2$export$430e07f935c066f6)({
        rightPanelRef: rightPanelRef,
        defaultWidth: $6a570c156dcdbd2e$var$DEFAULT_WIDTH,
        minWidth: $6a570c156dcdbd2e$var$MIN_WIDTH,
        maxWidth: $6a570c156dcdbd2e$var$MAX_WIDTH,
        compactThreshold: $6a570c156dcdbd2e$var$POPULAR_COMPACT_THRESHOLD
    }); // Query for widget state here so that the data is ready by the time the CollapsibleSections render
    const { error: error, loading: preferencesLoading } = (0, $h1Vf7.useHomeWidgetState)('right-panel');
    const widthStyle = $6a570c156dcdbd2e$var$useWidthStyle(widthMode, initialWidth);
    if (preferencesLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("aside", {
        ref: rightPanelRef,
        style: widthStyle,
        className: (0, $hekY6.default)([
            widthMode === 'resizable' && "_4FKVYE8HPE _24h04i2Njc _0jFU0VN91d _2WAcuGIZbP _3W2Oc8wPeg _0KLXruqi9L",
            widthMode !== 'resizable' && "_24h04i2Njc _0jFU0VIedJ _3W2Oc8wPeg _1DCdHiNHnM"
        ])
    }, widthMode === 'resizable' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $edb12c54129d5bfa$export$47ecfdcf2282c863), {
        onResizeDrag: onResizeDrag,
        onResizeComplete: onResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_EXPERIENCE),
        collect: $6a570c156dcdbd2e$var$collectRightPanelExperiences
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "right-panel-content"
    }, shouldShowForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c911dd4d390b4089$export$48874bdb6736064e), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT)
    })));
};
const $6a570c156dcdbd2e$var$useWidthStyle = (widthMode, initialWidth)=>{
    const width = widthMode === 'fullwidth' ? 'auto' : initialWidth;
    return {
        width: width
    };
};









const $caf885298d603c5d$export$cae2a62921ed768b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "t5WgZ",
    name: "HomeWelcomeMessage",
    loader: async ()=>(await (parcelRequire("kzakG"))).HomeWelcomeMessage
});


// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports







var $kOUwv = parcelRequire("kOUwv");


var $bEEQ6 = parcelRequire("bEEQ6");


var $aG3WN = parcelRequire("aG3WN");


var $7zvyU = parcelRequire("7zvyU");

const $f61f7456930c6af1$var$SITE_ACTIVATION_DATE_TRAIT = 'confluence.ondemand.activationDate';
const $f61f7456930c6af1$var$ANNOUNCEMENTS_NEW_TENANT_CUTOFF = '2026-07-01T00:00:00Z';
const $f61f7456930c6af1$var$ANNOUNCEMENTS_NEW_TENANT_CUTOFF_MS = Date.parse($f61f7456930c6af1$var$ANNOUNCEMENTS_NEW_TENANT_CUTOFF);
const $f61f7456930c6af1$var$getSiteTraitValue = (siteTraitsData, traitName)=>siteTraitsData?.attributes?.find((attribute)=>attribute?.name === traitName)?.value;
const $f61f7456930c6af1$var$isTenantCreatedAtOrAfterAnnouncementsCutoff = (activationDate)=>{
    if (typeof activationDate !== 'string') return false;
    const activationDateMs = Date.parse(activationDate);
    if (Number.isNaN(activationDateMs)) return false;
    return activationDateMs >= $f61f7456930c6af1$var$ANNOUNCEMENTS_NEW_TENANT_CUTOFF_MS;
};
const $f61f7456930c6af1$export$e98880dfa68e39f5 = ({ welcomeMessageHtml: welcomeMessageHtml, isWelcomeMessageCustomized: isWelcomeMessageCustomized, welcomeMessageLoading: welcomeMessageLoading, welcomeMessageError: welcomeMessageError, siteTraitsData: siteTraitsData, siteTraitsLoading: siteTraitsLoading, siteTraitsError: siteTraitsError })=>{
    // Wait until both the welcome-message query and the site-trait fetch have settled.
    // `useSiteTraits` reports `loading: false` with `data: null` on the very first render
    // because it starts its fetch inside an effect, so a bare `siteTraitsLoading` check is not
    // enough: treat "no data and no error yet" as still-resolving. This keeps the SSR output
    // and the first client render on the same branch (tab omitted) and prevents the
    // Announcements tab from briefly flashing for a new tenant before the activation-date
    // trait arrives. Once the traits resolve, a missing/invalid/errored trait fails open below.
    const siteTraitsResolved = Boolean(siteTraitsData) || Boolean(siteTraitsError);
    if (welcomeMessageLoading || siteTraitsLoading || !siteTraitsResolved) return {
        loading: true,
        shouldShowAnnouncementsPanel: false
    };
    const activationDate = $f61f7456930c6af1$var$getSiteTraitValue(siteTraitsData, $f61f7456930c6af1$var$SITE_ACTIVATION_DATE_TRAIT);
    // Hide for tenants created at/after the cutoff.
    if (!siteTraitsError && $f61f7456930c6af1$var$isTenantCreatedAtOrAfterAnnouncementsCutoff(activationDate)) return {
        loading: false,
        shouldShowAnnouncementsPanel: false
    };
    // Welcome-message query errors default to keeping the announcements tab.
    if (welcomeMessageError) return {
        loading: false,
        shouldShowAnnouncementsPanel: true
    };
    // The announcement should not be shown if it is the default message.
    if (!isWelcomeMessageCustomized) return {
        loading: false,
        shouldShowAnnouncementsPanel: false
    };
    // Empty-content rule still applies even when tenant age is unknown or the trait errored.
    if (!(0, $bEEQ6.hasVisibleWelcomeMessageContent)(welcomeMessageHtml)) return {
        loading: false,
        shouldShowAnnouncementsPanel: false
    };
    // Else, default to showing the announcements panel.
    return {
        loading: false,
        shouldShowAnnouncementsPanel: true
    };
};
const $f61f7456930c6af1$export$5c24975fa7716110 = ()=>{
    const { data: welcomeMessagesData, loading: welcomeMessageLoading, error: welcomeMessageError } = (0, $jMyy4.useQueryInterop)((0, $7zvyU.WelcomeMessagesQuery), {
        fetchPolicy: 'cache-first',
        __callerPackage__: "home"
    });
    const { data: siteTraitsData, loading: siteTraitsLoading, error: siteTraitsError } = (0, $kOUwv.useSiteTraits)();
    // The welcome-message GraphQL error is handled intentionally below (we fail open and keep the
    // Announcements tab), so mark it handled to stop the GraphQL error processor from reporting it as
    // unhandled.
    if (welcomeMessageError) (0, $7Sm4c.markErrorAsHandled)(welcomeMessageError);
    const { welcomeMessageHtml: welcomeMessageHtml, isWelcomeMessageCustomized: isWelcomeMessageCustomized } = (0, $aG3WN.transformData)(welcomeMessagesData);
    return $f61f7456930c6af1$export$e98880dfa68e39f5({
        welcomeMessageHtml: welcomeMessageHtml,
        isWelcomeMessageCustomized: isWelcomeMessageCustomized,
        welcomeMessageLoading: welcomeMessageLoading,
        welcomeMessageError: welcomeMessageError,
        siteTraitsData: siteTraitsData,
        siteTraitsLoading: siteTraitsLoading,
        siteTraitsError: siteTraitsError
    });
};









var $9DHhW = parcelRequire("9DHhW");


var $bDjCi = parcelRequire("bDjCi");













const $33df235db03da5e3$var$CALENDARS_SECTION_ID = 'com.atlassian.confluence.extra.team-calendars:newDashboadUpcomingEvents';
const $33df235db03da5e3$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "home.calendar.title",
        defaultMessage: "Calendars"
    }
});
const $33df235db03da5e3$export$39d78c94fb91ad03 = /*#__PURE__*/ (0, $cozmU.memo)(({ completeKey: completeKey, noCollapse: noCollapse = false, inRightPanel: inRightPanel = false, showCalendarEmptyStateBanner: showCalendarEmptyStateBanner = false, keepCalendarEmptyStateBannerVisible: keepCalendarEmptyStateBannerVisible = false, onEmptyStateChange: onEmptyStateChange })=>{
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $33df235db03da5e3$var$i18n.heading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { widgetState: widgetState } = (0, $h1Vf7.useHomeWidgetState)(completeKey);
    const isCollapsed = widgetState === 'COLLAPSED';
    const firedRenderedEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isCollapsed) firedRenderedEventRef.current = false;
        else if (!firedRenderedEventRef.current && inRightPanel) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'collapsibleSectionContent',
                    actionSubjectId: $33df235db03da5e3$var$CALENDARS_SECTION_ID,
                    source: 'rightPanel',
                    attributes: {
                        homeVersion: '1.5'
                    }
                }
            }).fire();
            firedRenderedEventRef.current = true;
        }
    }, [
        isCollapsed,
        inRightPanel,
        createAnalyticsEvent
    ]);
    if (inRightPanel) {
        if (noCollapse) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyHomepageCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4lbme.CollapsibleSection), {
            sectionId: completeKey,
            header: header,
            key: completeKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyHomepageCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyHomepageCard), {
        showCalendarEmptyStateBanner: showCalendarEmptyStateBanner,
        keepCalendarEmptyStateBannerVisible: keepCalendarEmptyStateBannerVisible,
        onEmptyStateChange: onEmptyStateChange
    });
});






const $65ae8040b45ec07e$export$480e92afeb9f3ea1 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FYF0E",
    name: "LazyCalendarIcon",
    loader: async ()=>(await Promise.resolve((parcelRequire("824lD")))).default
});

const $65ae8040b45ec07e$export$eaac0a9bd05d5448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "D2S7I",
    name: "LazyFeedbackIcon",
    loader: async ()=>(await Promise.resolve((parcelRequire("f3HCt")))).default
});


/* HomeBannerContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 





/* OnboardingTakeover.tsx generated by @compiled/babel-plugin v3.0.2 */ 





/**
 * @generated SignedSource<<c9b79a03ff97e0587ea0a6832f09ba68>>
 * @relayHash 516e6c99eaf113013654fcd3aebcb5e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678
const $a2d98364ec0cb107$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "516e6c99eaf113013654fcd3aebcb5e2",
            "id": "e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678",
            "metadata": {},
            "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a2d98364ec0cb107$var$node.hash = "5891a9fd74f90ddceb310fcec3a040ef";
var $a2d98364ec0cb107$export$2e2bcd8739ae039 = $a2d98364ec0cb107$var$node;















var $4ez2K = parcelRequire("4ez2K");


var $2LyZS = parcelRequire("2LyZS");


var $ad7Ou = parcelRequire("ad7Ou");


var $j6vyT = parcelRequire("j6vyT");


var $7sJoX = parcelRequire("7sJoX");














var $hSqtY = parcelRequire("hSqtY");





var $gfIPU = parcelRequire("gfIPU");









var $b4VFP = parcelRequire("b4VFP");

/* HTV2NthUserLearningOpportunityCardsList.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $3pCca = parcelRequire("3pCca");


var $dinVW = parcelRequire("dinVW");





var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");











var $kA6Zo = parcelRequire("kA6Zo");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $eKMV3 = parcelRequire("eKMV3");




const $de74dc0c412c0211$var$contentContainerStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    height: '100%'
});
const $de74dc0c412c0211$var$cardStyles = (0, $buxP3.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.large',
    background: "var(--ds-surface, #FFFFFF)"
});
const $de74dc0c412c0211$export$95f80ed95aeb19f6 = ({ title: title, description: description, cta: cta, link: link, onboardingPeriodDay: onboardingPeriodDay })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverNthUserlearningOpportunityCta',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay,
                    learningOpportunity: title.defaultMessage
                },
                source: 'onboarding'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $de74dc0c412c0211$var$cardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $de74dc0c412c0211$var$contentContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        onClick: handleClick,
        href: link,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), cta)))));
};



var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $ad82bda774949b47$var$HTV2Store = (0, $8s9DV.createStore)({
    initialState: {
        takeoverType: 'v2-land',
        personalSpaceKey: ''
    },
    actions: {
        getIsLandTakeoverType: ()=>({ getState: getState })=>getState().takeoverType === 'v2-land',
        getIsXflowTakeoverType: ()=>({ getState: getState })=>getState().takeoverType === 'v2-xflow'
    },
    name: 'htv2Store'
});
const $ad82bda774949b47$export$a6c1b621697476fb = (0, $kBr4q.createActionsHook)($ad82bda774949b47$var$HTV2Store);
const $ad82bda774949b47$export$40b715800492930d = (0, $kBr4q.createStateHook)($ad82bda774949b47$var$HTV2Store);
const $ad82bda774949b47$export$23a4a1a2301bbb22 = (0, $j8on0.createContainer)($ad82bda774949b47$var$HTV2Store, {
    onInit: ()=>({ setState: setState }, { takeoverType: takeoverType, personalSpaceKey: personalSpaceKey })=>{
            setState({
                takeoverType: takeoverType,
                personalSpaceKey: personalSpaceKey
            });
        }
});


const $38041ee5c4c2068e$var$gridStyles = {
    root: "_2iEGP2C3U3"
};
const $38041ee5c4c2068e$export$a0b6e8d3a8b5e662 = 'https://university.atlassian.com/student/collection/850385/path/1083904?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:uni-ondemand*O:university*W:confluence*H:fy25-q1*I:in-product-onboarding-confluence*';
const $38041ee5c4c2068e$export$4aafac32beb7c015 = 'https://support.atlassian.com/confluence-cloud/';
const $38041ee5c4c2068e$export$417c8e846f672c6a = 'https://community.atlassian.com/forums/New-to-Confluence/gh-p/newtoconfluence';
const $38041ee5c4c2068e$var$i18n = (0, $kSwu1.defineMessages)({
    learningPathTitle: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.title",
        defaultMessage: "Free learning path on Atlassian University"
    },
    learningPathDescription: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.description",
        defaultMessage: "Follow short, self-paced courses to get up and running in Confluence quickly."
    },
    learningPathCta: {
        id: "experiment-home-onboarding-takeover-v2.learning-path.cta",
        defaultMessage: "Get started"
    },
    supportResourcesTitle: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.title",
        defaultMessage: "Discover Atlassian Support resources"
    },
    supportResourcesDescription: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.description",
        defaultMessage: "Browse articles on all things Confluence on the Atlassian Support site."
    },
    supportResourcesCta: {
        id: "experiment-home-onboarding-takeover-v2.support-resources.cta",
        defaultMessage: "Learn more"
    },
    joinCommunityTitle: {
        id: "experiment-home-onboarding-takeover-v2.join-community.title",
        defaultMessage: "Join users like you on Atlassian Community"
    },
    joinCommunityDescription: {
        id: "experiment-home-onboarding-takeover-v2.join-community.description",
        defaultMessage: "Learn from new users like you or share your wisdom with others in the community."
    },
    joinCommunityCta: {
        id: "experiment-home-onboarding-takeover-v2.join-community.cta",
        defaultMessage: "Join Community"
    },
    heading: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-learning-opportunity.heading",
        defaultMessage: "Learn with more resources"
    },
    dismissLearningResources: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-learning-opportunity.dismiss-learning-resources",
        defaultMessage: "Dismiss learning resources"
    }
});
const $38041ee5c4c2068e$var$HTV2NthUserLearningOpportunityCards = [
    {
        title: $38041ee5c4c2068e$var$i18n.learningPathTitle,
        description: $38041ee5c4c2068e$var$i18n.learningPathDescription,
        cta: $38041ee5c4c2068e$var$i18n.learningPathCta,
        link: $38041ee5c4c2068e$export$a0b6e8d3a8b5e662
    },
    {
        title: $38041ee5c4c2068e$var$i18n.joinCommunityTitle,
        description: $38041ee5c4c2068e$var$i18n.joinCommunityDescription,
        cta: $38041ee5c4c2068e$var$i18n.joinCommunityCta,
        link: $38041ee5c4c2068e$export$417c8e846f672c6a
    },
    {
        title: $38041ee5c4c2068e$var$i18n.supportResourcesTitle,
        description: $38041ee5c4c2068e$var$i18n.supportResourcesDescription,
        cta: $38041ee5c4c2068e$var$i18n.supportResourcesCta,
        link: $38041ee5c4c2068e$export$4aafac32beb7c015
    }
];
const $38041ee5c4c2068e$export$a7dd6259deee6f55 = ({ onboardingPeriodDay: onboardingPeriodDay, onDismissSection: onDismissSection })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflowTakeoverType = getIsXflowTakeoverType();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "htv2-learning-resources",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38041ee5c4c2068e$var$i18n.heading)), onDismissSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "htv2-learning-resources-dismiss-button",
        onClick: onDismissSection,
        label: formatMessage($38041ee5c4c2068e$var$i18n.dismissLearningResources),
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                size: "small"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        gap: "space.200",
        xcss: $38041ee5c4c2068e$var$gridStyles.root
    }, $38041ee5c4c2068e$var$HTV2NthUserLearningOpportunityCards.map((learningOpportunityCardContent)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de74dc0c412c0211$export$95f80ed95aeb19f6), {
            key: `${formatMessage(learningOpportunityCardContent.title)}`,
            ...learningOpportunityCardContent,
            onboardingPeriodDay: onboardingPeriodDay
        });
    })));
};









var $9oezN = parcelRequire("9oezN");










var $2cb51d39911d0f3d$exports = {};
$2cb51d39911d0f3d$exports = new URL("addProfilePictureDark.b3507081.svg", import.meta.url).toString();


var $d9a2e233474f213b$exports = {};
$d9a2e233474f213b$exports = new URL("addProfilePictureLight.d50a6145.svg", import.meta.url).toString();


var $1f79c1dfa147a5d3$exports = {};
$1f79c1dfa147a5d3$exports = new URL("changeSiteThemeDark.d8e951cf.svg", import.meta.url).toString();


var $89fc6035c9afe644$exports = {};
$89fc6035c9afe644$exports = new URL("changeSiteThemeLight.40f63e13.svg", import.meta.url).toString();


var $a509a91833cc20bf$exports = {};
$a509a91833cc20bf$exports = new URL("createPageDark.67a6d96c.svg", import.meta.url).toString();


var $e5066a03c9dd2f60$exports = {};
$e5066a03c9dd2f60$exports = new URL("createPageLight.65781bf0.svg", import.meta.url).toString();


var $7236b697d85b27a9$exports = {};
$7236b697d85b27a9$exports = new URL("createSpaceDark.8179e65e.svg", import.meta.url).toString();


var $62efc5f222008a19$exports = {};
$62efc5f222008a19$exports = new URL("createSpaceLight.3798bf79.svg", import.meta.url).toString();


var $0162f23a645d5b61$exports = {};
$0162f23a645d5b61$exports = new URL("createWhiteboardDark.5cebd92e.svg", import.meta.url).toString();


var $ecc903df8952a92c$exports = {};
$ecc903df8952a92c$exports = new URL("createWhiteboardLight.29b7b77d.svg", import.meta.url).toString();


var $68b896071a50d4d0$exports = {};
$68b896071a50d4d0$exports = new URL("downloadMobileAppDark.acae3e72.svg", import.meta.url).toString();


var $8f0a700dcf27828a$exports = {};
$8f0a700dcf27828a$exports = new URL("downloadMobileAppLight.cfce9d68.svg", import.meta.url).toString();


var $c0c43da6cb8fd896$exports = {};
$c0c43da6cb8fd896$exports = new URL("explorePremiumDark.681b018f.svg", import.meta.url).toString();


var $0e080128138bc4b3$exports = {};
$0e080128138bc4b3$exports = new URL("explorePremiumLight.8f219783.svg", import.meta.url).toString();


var $6c8af4614e0ce4f2$exports = {};
$6c8af4614e0ce4f2$exports = new URL("marketplaceLight.244efc33.svg", import.meta.url).toString();


var $a669f36e637b0873$exports = {};
$a669f36e637b0873$exports = new URL("marketplaceDark.2db71a9a.svg", import.meta.url).toString();


var $46b14302baf22930$exports = {};
$46b14302baf22930$exports = new URL("viewPopularContentLight.8a22cd39.svg", import.meta.url).toString();


var $7f73ff448d584042$exports = {};
$7f73ff448d584042$exports = new URL("viewPopularContentDark.9bd259ee.svg", import.meta.url).toString();


var $ff4aa60becd896c2$exports = {};
$ff4aa60becd896c2$exports = new URL("aiLight.946c95dd.svg", import.meta.url).toString();


var $33c1e785e7b576de$exports = {};
$33c1e785e7b576de$exports = new URL("aiDark.0a919ea0.svg", import.meta.url).toString();


const $605aec3e62fc613c$export$f9417f756858637d = {
    createPage: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($e5066a03c9dd2f60$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a509a91833cc20bf$exports)))
    },
    createSpace: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($62efc5f222008a19$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7236b697d85b27a9$exports)))
    },
    createWhiteboard: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($ecc903df8952a92c$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($0162f23a645d5b61$exports)))
    },
    addProfilePicture: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($d9a2e233474f213b$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($2cb51d39911d0f3d$exports)))
    },
    changeSiteTheme: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($89fc6035c9afe644$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1f79c1dfa147a5d3$exports)))
    },
    explorePremium: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($0e080128138bc4b3$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($c0c43da6cb8fd896$exports)))
    },
    downloadMobileApp: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($8f0a700dcf27828a$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($68b896071a50d4d0$exports)))
    },
    exploreMarketplace: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($6c8af4614e0ce4f2$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a669f36e637b0873$exports)))
    },
    exploreAI: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($ff4aa60becd896c2$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($33c1e785e7b576de$exports)))
    },
    viewPopularContent: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($46b14302baf22930$exports))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7f73ff448d584042$exports)))
    }
};









var $iITVA = parcelRequire("iITVA");





var $dD7ks = parcelRequire("dD7ks");

const $cb50a626fa424824$var$HTV2ActionCardLinkCTA = ({ onClick: onClick, href: href, children: children, icon: icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        iconBefore: icon,
        onClick: onClick,
        href: href,
        target: "_blank"
    }, children);
};
const $cb50a626fa424824$export$cfda3af46d74ac3 = ({ children: children, onClick: onClick })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { href: href } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb50a626fa424824$var$HTV2ActionCardLinkCTA, {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA))),
        onClick: onClick,
        href: href
    }, children);
};









var $bDjVc = parcelRequire("bDjVc");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");


const $aa9c686096fb5b3d$var$HTV2CreateContentCTA = ({ appearance: appearance, children: children, contentType: contentType, onClick: onClick, source: source, icon: icon, openTemplatesGallery: openTemplatesGallery })=>{
    const { personalSpaceKey: personalSpaceKey } = (0, $ad82bda774949b47$export$40b715800492930d)();
    const getButtonHref = ()=>{
        return (0, $bZSO8.buildCreationLink)({
            contentType: contentType,
            source: source,
            spaceKey: personalSpaceKey,
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            openTemplatesGallery: openTemplatesGallery || undefined
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        onClick: onClick,
        isDisabled: !personalSpaceKey,
        href: getButtonHref(),
        appearance: appearance,
        iconBefore: icon
    }, children);
};
const $aa9c686096fb5b3d$export$7044ebf8ab34fd95 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa9c686096fb5b3d$var$HTV2CreateContentCTA, {
        source: "homeOnboardingTakeoverV2CreateWhiteboard",
        contentType: "whiteboard",
        onClick: onClick,
        appearance: "default",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc)))
    }, children);
};
const $aa9c686096fb5b3d$export$3ce14525978eb5aa = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa9c686096fb5b3d$var$HTV2CreateContentCTA, {
        source: "homeOnboardingTakeoverV2CreateIntro",
        contentType: "page",
        onClick: onClick,
        appearance: "default",
        openTemplatesGallery: true
    }, children);
};









var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");

const $3b605859dbf463d0$export$62446e0882debc0e = ({ children: children, onClick: onClick })=>{
    const { feedType: feedType, updateFeedType: updateFeedType } = (0, $fJ5kL.useFeedTypeSelector)();
    const handleFeedSelectorChange = (0, $cozmU.useCallback)((updatedFeedType)=>{
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        // Update feed type if it is popular feed is not selected
        if (feedType !== (0, $4yg2A.FeedType).POPULAR) handleFeedSelectorChange((0, $4yg2A.FeedType).POPULAR);
        // Mark the onboarding action card as completed
        onClick();
        // Scroll to the feed section
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const feedSection = document.querySelector('[data-testid="activity-feed"]');
        feedSection?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        feedType,
        handleFeedSelectorChange,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleClick,
        appearance: "default"
    }, children);
};





const $8a1fa21a7f518231$export$be7e46fee04363c = (0, $kSwu1.defineMessages)({
    createWhiteboardTitle: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.title",
        defaultMessage: "Brainstorm on a whiteboard"
    },
    createWhiteboardDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.description",
        defaultMessage: "Dream up new ideas and visualize your work."
    },
    createWhiteboardCTA: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard.cta",
        defaultMessage: "Create whiteboard"
    },
    addProfilePictureTitle: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture.title",
        defaultMessage: "Add your profile photo"
    },
    addProfilePictureCTA: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture.cta",
        defaultMessage: "Add photo"
    }
});


const $c1c2e6c8520ca16f$var$i18n = (0, $kSwu1.defineMessages)({
    addProfilePictureDescription: {
        id: "experiment-home-onboarding-takeover-v2.add-profile-picture-nth-user.description",
        defaultMessage: "Help teammates recognize you by adding a profile photo."
    },
    createIntroBlogTitle: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.title",
        defaultMessage: "Introduce yourself to your new peers"
    },
    createIntroBlogDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.description",
        defaultMessage: "Easily share your stories and interests with teammates by personalizing the intro template."
    },
    createIntroBlogCTA: {
        id: "experiment-home-onboarding-takeover-v2.create-intro-blog.cta",
        defaultMessage: "See templates"
    },
    createWhiteboardDescription: {
        id: "experiment-home-onboarding-takeover-v2.create-whiteboard-nth-user.description",
        defaultMessage: "Dream up new ideas by collaborating and visualizing in a freefrom way using whiteboards."
    },
    viewPopularContentTitle: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.title",
        defaultMessage: "Discover & react to trending content"
    },
    viewPopularContentDescription: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.description",
        defaultMessage: "Dive into popular content and share your thoughts with a fun reaction or comment."
    },
    viewPopularContentCTA: {
        id: "experiment-home-onboarding-takeover-v2.view-popular-content.cta",
        defaultMessage: "View popular content"
    }
});
const $c1c2e6c8520ca16f$export$43cedd252f50b9ab = [
    {
        id: 'viewPopularContent',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.viewPopularContentTitle),
        description: $c1c2e6c8520ca16f$var$i18n.viewPopularContentDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).viewPopularContent,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b605859dbf463d0$export$62446e0882debc0e), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.viewPopularContentCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'createIntroBlog',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.createIntroBlogTitle),
        description: $c1c2e6c8520ca16f$var$i18n.createIntroBlogDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).createPage,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa9c686096fb5b3d$export$3ce14525978eb5aa), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c1c2e6c8520ca16f$var$i18n.createIntroBlogCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'createWhiteboard',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).createWhiteboardTitle),
        description: $c1c2e6c8520ca16f$var$i18n.createWhiteboardDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).createWhiteboard,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa9c686096fb5b3d$export$7044ebf8ab34fd95), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).createWhiteboardCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    },
    {
        id: 'addProfilePicture',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).addProfilePictureTitle),
        description: $c1c2e6c8520ca16f$var$i18n.addProfilePictureDescription,
        image: (0, $605aec3e62fc613c$export$f9417f756858637d).addProfilePicture,
        cta: ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb50a626fa424824$export$cfda3af46d74ac3), {
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8a1fa21a7f518231$export$be7e46fee04363c).addProfilePictureCTA)),
        fadeCardOnComplete: true,
        keepCtaOnCompleted: true
    }
];
const $c1c2e6c8520ca16f$export$69b5d0ca55ec4c6e = ({ onboardingActionStates: onboardingActionStates })=>{
    return $c1c2e6c8520ca16f$export$43cedd252f50b9ab.map((action)=>({
            ...action,
            state: onboardingActionStates[action.id] || 'pending'
        }));
};


const $e208299f3fd02b06$var$DUPLICATED_ONBOARDING_ACTION_IDS = [
    ...(0, $c1c2e6c8520ca16f$export$43cedd252f50b9ab)
].map((action)=>action.id);
const $e208299f3fd02b06$export$c4d8be815289b698 = [
    ...new Set($e208299f3fd02b06$var$DUPLICATED_ONBOARDING_ACTION_IDS)
];
const $e208299f3fd02b06$export$82740826f5d31d6 = [
    'pending',
    'dismissed',
    'completed'
];



function $f5be8383e833e00b$var$deserializeOnboardingActionStates(serializedValues) {
    try {
        const values = JSON.parse(serializedValues || '{}');
        if (typeof values !== 'object') return {};
        // There's no control over the shape of the object that's deserialized,
        // so we need to filter out any keys and values that aren't valid.
        const isValidState = (value)=>(0, $e208299f3fd02b06$export$82740826f5d31d6).includes(value);
        return (0, $e208299f3fd02b06$export$c4d8be815289b698).reduce((states, id)=>isValidState(values[id]) ? {
                ...states,
                [id]: values[id]
            } : states, {});
    } catch (e) {
        return {};
    }
}
function $f5be8383e833e00b$var$serializeOnboardingActionStates(onboardingActionStates) {
    return JSON.stringify(onboardingActionStates);
}
function $f5be8383e833e00b$export$5d769c20b5d59814() {
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)));
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { onboardingActionStates: serializedOnboardingActionStates, hasSeenConfetti: hasSeenConfetti } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const onboardingActionStates = (0, $cozmU.useMemo)(()=>{
        return $f5be8383e833e00b$var$deserializeOnboardingActionStates(serializedOnboardingActionStates);
    }, [
        serializedOnboardingActionStates
    ]);
    const complete = (0, $cozmU.useMemo)(()=>(id)=>{
            setOnboardingState({
                key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).onboardingActionStates,
                value: $f5be8383e833e00b$var$serializeOnboardingActionStates({
                    ...onboardingActionStates,
                    [id]: 'completed'
                })
            });
        }, [
        onboardingActionStates,
        setOnboardingState
    ]);
    const errors = [
        onboardingStateError
    ].filter(Boolean);
    const actions = (0, $cozmU.useMemo)(()=>{
        return (0, $c1c2e6c8520ca16f$export$69b5d0ca55ec4c6e)({
            onboardingActionStates: onboardingActionStates
        });
    }, [
        onboardingActionStates
    ]);
    const isFinished = actions.every((action)=>action.state !== 'pending');
    const hasPoppedConfetti = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStateLoading || !isFinished) return;
        const popConfettiIfVisible = ()=>{
            if (hasSeenConfetti || hasPoppedConfetti.current || document.visibilityState !== 'visible') return;
            hasPoppedConfetti.current = true;
            (0, $9oezN.popOnboardingConfetti)();
            setOnboardingState([
                {
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenConfetti,
                    value: 'true'
                },
                {
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isCollapsed,
                    value: 'true'
                }
            ]);
        };
        // Check to see if the user is still viewing the page. The timeout is used
        // to ensure that the confetti doesn't pop if the user is navigating away.
        const timeout = setTimeout(popConfettiIfVisible, 50);
        document.addEventListener('visibilitychange', popConfettiIfVisible);
        return ()=>{
            // Cleanup timeout and event listener
            clearTimeout(timeout);
            document.removeEventListener('visibilitychange', popConfettiIfVisible);
        };
    }, [
        onboardingStateLoading,
        hasSeenConfetti,
        isFinished,
        setOnboardingState
    ]);
    return {
        actions: actions,
        complete: complete,
        errors: errors,
        loading: onboardingStateLoading,
        isFinished: isFinished
    };
}









var $kgt0V = parcelRequire("kgt0V");


var $ePK6j = parcelRequire("ePK6j");


var $aDSIl = parcelRequire("aDSIl");


var $iW7aI = parcelRequire("iW7aI");








var $3izAL = parcelRequire("3izAL");





var $9iaFM = parcelRequire("9iaFM");


var $kz1Yj = parcelRequire("kz1Yj");








var $IQ4Dz = parcelRequire("IQ4Dz");





var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");

/* HTV2ActionCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $cJ0FD = parcelRequire("cJ0FD");








var $chu6R = parcelRequire("chu6R");



















const $ec39d532218c9094$var$dismissIconStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    cursor: 'pointer'
});
const $ec39d532218c9094$export$b93d522d630e54a4 = ({ onDismiss: onDismiss, label: label })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ec39d532218c9094$var$dismissIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        onClick: onDismiss,
        label: formatMessage(label),
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), iconProps)
    }));
};



const $eba8001c579a2419$var$contentContainerStyles = (0, $buxP3.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200',
    height: '100%'
});
const $eba8001c579a2419$var$cardStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.large',
    background: "var(--ds-surface, #FFFFFF)"
});
const $eba8001c579a2419$var$fadeStyles = (0, $buxP3.xcss)({
    opacity: '0.3'
});
const $eba8001c579a2419$var$imageContainerStyles = (0, $buxP3.xcss)({
    position: 'relative'
});
const $eba8001c579a2419$var$imageStyles = null;
const $eba8001c579a2419$var$descriptionContainerStyles = (0, $buxP3.xcss)({
    // Ensure the description text is always 3 lines tall
    height: '4.28em' // (20px line height * 3 lines) / 14px font size
});
const $eba8001c579a2419$var$i18n = (0, $kSwu1.defineMessages)({
    dismissButtonLabel: {
        id: "experiment-home-onboarding-takeover-v2.dismiss-card-button-label",
        defaultMessage: "Dismiss this action"
    },
    completedCardText: {
        id: "experiment-home-onboarding-takeover-v2.completed-card-text",
        defaultMessage: "You completed this step."
    }
});
const $eba8001c579a2419$export$2fef0751517155f4 = ({ action: action, dismiss: dismiss, complete: complete, onboardingPeriodDay: onboardingPeriodDay, fadeCardOnComplete: fadeCardOnComplete = false, keepCtaOnComplete: keepCtaOnComplete = false })=>{
    const Cta = action.cta;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflow = getIsXflowTakeoverType();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        complete?.(action.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2ActionCta',
                attributes: {
                    onboardingAction: action.id,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                },
                source: 'onboarding'
            }
        }).fire();
    }, [
        complete,
        createAnalyticsEvent,
        action.id,
        onboardingPeriodDay,
        isXflow
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (dismiss) dismiss(action.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2ActionDismiss',
                attributes: {
                    onboardingAction: action.id,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                },
                source: 'onboarding'
            }
        }).fire();
    }, [
        dismiss,
        createAnalyticsEvent,
        action.id,
        onboardingPeriodDay,
        isXflow
    ]);
    const isCompleted = action.state === 'completed';
    return /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
        testId: isCompleted ? 'htv2-onboarding-action-completed' : 'htv2-onboarding-action-pending',
        direction: "column",
        xcss: $eba8001c579a2419$var$cardStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.default), {
        xcss: [
            $eba8001c579a2419$var$imageContainerStyles,
            fadeCardOnComplete && isCompleted && $eba8001c579a2419$var$fadeStyles
        ]
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: action.image.light,
        srcDark: action.image.dark,
        alt: "",
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d"
        ])
    }), dismiss && /*#__PURE__*/ $cozmU.createElement((0, $ec39d532218c9094$export$b93d522d630e54a4), {
        label: {
            ...$eba8001c579a2419$var$i18n.dismissButtonLabel
        },
        onDismiss: handleDismiss
    })), /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
        xcss: $eba8001c579a2419$var$contentContainerStyles,
        justifyContent: "space-between",
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, action.title), isCompleted && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: "var(--ds-icon-success)",
        label: "completed"
    })), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.default), {
        xcss: $eba8001c579a2419$var$descriptionContainerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
        color: isCompleted ? 'color.text.subtlest' : undefined,
        maxLines: 3
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), isCompleted ? $eba8001c579a2419$var$i18n.completedCardText : action.description)))), (!isCompleted || keepCtaOnComplete) && /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ $cozmU.createElement(Cta, {
        onClick: handleClick
    }))));
};




function $f30dd92ebe48cdb9$export$2df8346413809f96(items, pageSize) {
    const [idx, setIdx] = (0, $cozmU.useState)(0);
    const pages = (0, (/*@__PURE__*/$parcel$interopDefault($kgt0V)))([
        ...items.keys()
    ], pageSize);
    const effectiveIdx = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(idx, 0, items.length - 1);
    const currentPage = pages.findIndex((page)=>page.includes(effectiveIdx));
    const hasNext = currentPage < pages.length - 1;
    const hasPrevious = currentPage > 0;
    const nextIdx = pages[currentPage + 1]?.[0];
    const previousIdx = pages[currentPage - 1]?.[0];
    return {
        next: hasNext ? ()=>setIdx(nextIdx) : undefined,
        previous: hasPrevious ? ()=>setIdx(previousIdx) : undefined,
        visible: (pages[currentPage] || []).map((i)=>items[i]),
        pageKey: effectiveIdx
    };
}
/**
 * Custom hook that preloads all card images based on the current color mode.
 *
 * This hook uses the `useThemeObserver` to get the current color mode (light or dark)
 * and preloads the appropriate images for each card. It returns an array of `Image` objects
 * with their `src` set to the preloaded image URLs.
 *
 * Images are memo'd to make sure the image objects aren't GC'd by the browser.
 *
 * Preloading is gated on `process.env.REACT_SSR` because `Image` is a browser-only global
 * — constructing it during SSR (where this hook still runs, e.g. on the edit route) would
 * crash the server with a ReferenceError.
 *
 */ function $f30dd92ebe48cdb9$var$usePreloadCardImages() {
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    (0, $cozmU.useMemo)(()=>{
        const imageSrcs = Object.values((0, $605aec3e62fc613c$export$f9417f756858637d)).map(({ light: light, dark: dark })=>colorMode === 'dark' ? dark : light);
        return imageSrcs.map((src)=>{
            const img = new Image();
            img.src = src;
            return img;
        });
    }, [
        colorMode
    ]);
}
/**
 * Custom hook that checks the homeIsSingleColumn CSS variable.
 *
 * @returns {Object} An object containing:
 * - `ref`: A ref that must be attached to an element that has the
 *   `--homeIsSingleColumn` CSS variable. It should be an element that spans
 *   the width of the home content area, since we will watch its width to
 *   decide when to update.
 * - `isSingleColumn`: A boolean indicating the value of the
 *   `--homeIsSingleColumn` CSS variable (true if '1', false otherwise).
 */ function $f30dd92ebe48cdb9$var$useHomeIsSingleColumn() {
    const ref = (0, $cozmU.useRef)(null);
    const [isSingleColumn, setIsSingleColumn] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        // We watch the carousel for size changes (via the ref), as it's possible that --homeIsSingleColumn
        // can change without a re-render (e.g. if the user resizes the window or the sidebar).
        const resizeObserver = new ResizeObserver(()=>{
            setIsSingleColumn(Boolean(ref.current && window.getComputedStyle(ref.current).getPropertyValue('--homeIsSingleColumn') === '1'));
        });
        resizeObserver.observe(ref.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return {
        ref: ref,
        isSingleColumn: isSingleColumn
    };
}
/**
 * Sorts an array of onboarding actions into buckets based on their state.
 *
 * @param actions - The array of onboarding actions to be sorted.
 * @returns An object where the keys are the states ('pending', 'completed', 'dismissed')
 * and the values are arrays of actions that correspond to each state.
 */ function $f30dd92ebe48cdb9$var$sortActions(actions) {
    return actions.reduce((buckets, action)=>({
            ...buckets,
            [action.state]: [
                ...buckets[action.state] || [],
                action
            ]
        }), {
        pending: [],
        completed: [],
        dismissed: []
    });
}
const $f30dd92ebe48cdb9$var$gridStyles = (0, $buxP3.xcss)({
    minHeight: '320px'
});
const $f30dd92ebe48cdb9$var$headingWrapper = (0, $buxP3.xcss)({
    minHeight: '24px'
});
const $f30dd92ebe48cdb9$var$carouselItemsWrapper = (0, $buxP3.xcss)({
    overflow: 'hidden'
});
const $f30dd92ebe48cdb9$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "experiment-home-onboarding-takeover-v2.carousel.heading",
        defaultMessage: "Get to know Confluence (Completed {completed} of {total} cards)"
    },
    previousItem: {
        id: "experiment-home-onboarding-takeover-v2.carousel.previous-item",
        defaultMessage: "Show previous item"
    },
    nextItem: {
        id: "experiment-home-onboarding-takeover-v2.carousel.next-item",
        defaultMessage: "Show next item"
    },
    dismissCarousel: {
        id: "experiment-home-onboarding-takeover-v2.carousel.dismiss-carousel",
        defaultMessage: "Dismiss carousel"
    }
});
function $f30dd92ebe48cdb9$export$cee2d9eac04047dd({ actions: actions, dismiss: dismiss, complete: complete, onboardingPeriodDay: onboardingPeriodDay, suppressSorting: suppressSorting, onDismissSection: onDismissSection }) {
    $f30dd92ebe48cdb9$var$usePreloadCardImages();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { ref: ref, isSingleColumn: isSingleColumn } = $f30dd92ebe48cdb9$var$useHomeIsSingleColumn();
    const numVisible = isSingleColumn ? 2 : 3;
    const { pending: pending, completed: completed } = (0, $cozmU.useMemo)(()=>$f30dd92ebe48cdb9$var$sortActions(actions), [
        actions
    ]);
    const cardsToDisplay = suppressSorting ? actions : [
        ...pending,
        ...completed
    ];
    const { next: next, previous: previous, visible: visible, pageKey: pageKey } = $f30dd92ebe48cdb9$export$2df8346413809f96(cardsToDisplay, numVisible);
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $ad82bda774949b47$export$a6c1b621697476fb)();
    const isXflowTakeoverType = getIsXflowTakeoverType();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Hide the carousel controls if all cards can be shown at once.
    const showControls = pending.length + completed.length > numVisible;
    const [enterFrom, setEnterFrom] = (0, $cozmU.useState)('left');
    const createClickHandler = (callback, direction)=>{
        if (!callback) return;
        return ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'homeOnboardingTakeoverV2ActionCarouselScroll',
                    source: 'onboarding',
                    attributes: {
                        direction: direction,
                        isXflow: isXflowTakeoverType
                    }
                }
            }).fire();
            setEnterFrom(direction);
            setTimeout(callback, 10);
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        testId: "htv2-carousel",
        ref: ref,
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        gap: "space.100",
        justifyContent: "space-between",
        xcss: $f30dd92ebe48cdb9$var$headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$f30dd92ebe48cdb9$var$i18n.heading,
        values: {
            completed: completed.length,
            total: completed.length + pending.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, showControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.previousItem),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            }),
        onClick: createClickHandler(previous, 'left'),
        isDisabled: !previous,
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.nextItem),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        onClick: createClickHandler(next, 'right'),
        isDisabled: !next,
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle'
    })), onDismissSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: "htv2-carousel-dismiss-button",
        onClick: onDismissSection,
        label: formatMessage($f30dd92ebe48cdb9$var$i18n.dismissCarousel),
        spacing: isXflowTakeoverType ? 'default' : 'compact',
        appearance: isXflowTakeoverType ? 'default' : 'subtle',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                size: "small"
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $f30dd92ebe48cdb9$var$carouselItemsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        exitThenEnter: true,
        appear: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        key: pageKey,
        enterFrom: enterFrom,
        exitTo: enterFrom === 'right' ? 'left' : 'right'
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            xcss: $f30dd92ebe48cdb9$var$gridStyles,
            gap: "space.200",
            templateColumns: "repeat(calc(3 - var(--homeIsSingleColumn, 0)), 1fr)"
        }, visible.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eba8001c579a2419$export$2fef0751517155f4), {
                key: action.id,
                action: action,
                dismiss: dismiss,
                complete: complete,
                onboardingPeriodDay: onboardingPeriodDay,
                fadeCardOnComplete: action.fadeCardOnComplete,
                keepCtaOnComplete: action.keepCtaOnCompleted
            }))))))));
}



const $0e79497324363eb1$var$i18n = (0, $kSwu1.defineMessages)({
    collapse: {
        id: "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.collapse",
        defaultMessage: "Collapse onboarding"
    },
    expand: {
        id: "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.expand",
        defaultMessage: "Expand onboarding"
    }
});
const $0e79497324363eb1$var$GetPersonalSpaceKeyQuery = (0, $a2d98364ec0cb107$export$2e2bcd8739ae039);
const $0e79497324363eb1$var$CollapseExpandButton = ({ isCollapsed: isCollapsed, toggleIsCollapsed: toggleIsCollapsed })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "nth-user-home-onboarding-takeover-collapse-expand-button",
        iconBefore: (iconProps)=>isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps,
                size: "small"
            }),
        appearance: "subtle",
        onClick: toggleIsCollapsed
    }, formatMessage(isCollapsed ? $0e79497324363eb1$var$i18n.expand : $0e79497324363eb1$var$i18n.collapse));
};
const $0e79497324363eb1$export$729f5f3a19e7fe8b = ()=>{
    const { actions: actions, complete: complete, loading: loading, errors: errors, isFinished: isFinished } = (0, $f5be8383e833e00b$export$5d769c20b5d59814)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isCollapsed: isCollapsed, takeoverSeenAt: takeoverSeenAt, hasDismissedCarousel: hasDismissedCarousel, hasDismissedLearningResources: hasDismissedLearningResources } = (0, $ivb8S.deserializeState)(onboardingStateData);
    (0, $cozmU.useEffect)(()=>{
        if (!onboardingStateLoading && !takeoverSeenAt) setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).takeoverSeenAt,
            value: new Date().toISOString()
        });
    }, [
        onboardingStateLoading,
        takeoverSeenAt,
        setOnboardingState
    ]);
    const onboardingPeriodDay = takeoverSeenAt ? (0, $jb2R2.default)(new Date(), new Date(takeoverSeenAt)) : 0;
    (0, $cozmU.useEffect)(()=>{
        if (!onboardingStateLoading && !errors.length) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'NthUserHomeOnboardingTakeover',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay,
                    isFinished: isFinished
                }
            }
        }).fire();
    }, [
        errors,
        isFinished,
        onboardingStateLoading,
        onboardingPeriodDay,
        createAnalyticsEvent
    ]);
    const resizingHeight = (0, $2LyZS.useResizingHeight)();
    const toggleIsCollapsed = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isCollapsed,
            value: isCollapsed ? 'false' : 'true'
        });
    }, [
        isCollapsed,
        setOnboardingState
    ]);
    const dismissCarousel = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasDismissedCarousel,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2CarouselDismiss',
                source: 'homeOnboardingTakeover'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    const dismissLearningResources = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasDismissedLearningResources,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2LearningResourcesDismiss',
                source: 'homeOnboardingTakeover'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    if (loading || onboardingStateLoading) return null;
    // This error is blocking because if onboarding state fails, then a lot of the functionality will be broken
    if (errors.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            ...errors
        ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", resizingHeight, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            ...errors
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        testId: "nth-user-home-onboarding-takeover",
        direction: "column",
        gap: "space.200"
    }, !isCollapsed && !hasDismissedCarousel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f30dd92ebe48cdb9$export$cee2d9eac04047dd), {
        actions: actions,
        complete: complete,
        onboardingPeriodDay: onboardingPeriodDay,
        suppressSorting: true,
        onDismissSection: dismissCarousel
    }), isFinished && !hasDismissedCarousel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$var$CollapseExpandButton, {
        isCollapsed: isCollapsed,
        toggleIsCollapsed: toggleIsCollapsed
    })), !hasDismissedLearningResources && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38041ee5c4c2068e$export$a7dd6259deee6f55), {
        onboardingPeriodDay: onboardingPeriodDay,
        onDismissSection: dismissLearningResources
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
    }));
};
const $0e79497324363eb1$var$HTV2Errors = ({ errors: errors })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, errors.map((error, index)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            key: `${error.message}-${index}`,
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
            error: error
        })) : null;
    }));
};
const $0e79497324363eb1$export$a4d10729329192ad = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU,
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$var$HomeOnboardingTakeoverV2Store, null));
};
const $0e79497324363eb1$var$HomeOnboardingTakeoverV2Store = ()=>{
    const { data: personalSpaceKeyData, loading: personalSpaceKeyLoading, error: personalSpaceKeyError } = (0, $jMyy4.useQueryInterop)($0e79497324363eb1$var$GetPersonalSpaceKeyQuery, {
        __callerPackage__: "experiment-home-onboarding-takeover-v2"
    });
    if (personalSpaceKeyLoading) return null;
    const personalSpaceKey = personalSpaceKeyData?.user?.confluence?.hasPersonalSpace && personalSpaceKeyData?.user?.confluence?.space?.key || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad82bda774949b47$export$23a4a1a2301bbb22), {
        takeoverType: "nth-user",
        personalSpaceKey: personalSpaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$var$HTV2Errors, {
        errors: [
            personalSpaceKeyError
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e79497324363eb1$export$729f5f3a19e7fe8b, null));
};






const $a8561b2cf16e3af7$export$a761578900d36b98 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "m1RfB",
    name: "PersonalizedTemplatesV2Loadable",
    loader: async ()=>(await (parcelRequire("3nne7"))).PersonalizedTemplatesV2ErrorBoundary
});


/**
 * @generated SignedSource<<07e016e3f7260fd4ee1dbe83ab747f91>>
 * @relayHash 4e5e32f92903b0ddb3e0d216186ab7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63
const $a5ce719234afd4e6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4e5e32f92903b0ddb3e0d216186ab7d9",
            "id": "db8b39ea6d26e658656d63752a19397755fa6f89a774cfd8721920766e16cd63",
            "metadata": {},
            "name": "NthUserHomeOnboardingRevampGetUserDataQuery",
            "operationKind": "query",
            "text": "query NthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,displayName,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$a5ce719234afd4e6$var$node.hash = "851093c14fc8eb32514cb97641783e65";
var $a5ce719234afd4e6$export$2e2bcd8739ae039 = $a5ce719234afd4e6$var$node;


















































/* UseCasesHomeWelcomeBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 



























var $4aRua = parcelRequire("4aRua");





var $1l0kj = parcelRequire("1l0kj");








var $hxdG1 = parcelRequire("hxdG1");

var $48dcb9eaf86e2736$exports = {};
$48dcb9eaf86e2736$exports = new URL("WelcomeBannerIllustrationLight.7011b7ae.svg", import.meta.url).toString();


var $81509ab5fd4e14b5$exports = {};
$81509ab5fd4e14b5$exports = new URL("WelcomeBannerIllustrationDark.f7a5edcb.svg", import.meta.url).toString();


const $3b19b5a183dfb573$var$i18n = (0, $kSwu1.defineMessages)({
    useCasesHomeWelcomeBannerTitle: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.title",
        defaultMessage: "Welcome to Confluence, {name}"
    },
    useCasesHomeWelcomeBannerAction: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.action",
        defaultMessage: "Get started with a template below, or click <b>Create</b> to start from scratch."
    },
    useCasesHomeWelcomeBannerDismiss: {
        id: "experiment-personalized-templates-v2.use-cases-in-nth-user-onboarding.welcome-banner.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $3b19b5a183dfb573$var$styles = {
    container: "_0bjKvD8fU6 _1mT5xdRAKS _4kiQYAymWf",
    textSection: "_2mHwu82ADO _0Of8r2Va5s _1wydGWVa5s _2Zuz6QVa5s _1ZnuxbS40j",
    dismiss: "_2IhTon5zaO _4ApkO25zaO _1mT5xdWVPG _0wOv4Q7zJH"
};
const $3b19b5a183dfb573$export$2d42ab2f37bfa9f6 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isTemplateListDismissed: isTemplateListDismissed } = (0, $hxdG1.usePTV2State)(); //TODO: Fix this
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)((0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER);
    const { headerViewedAt: headerViewedAt } = (0, $ivb8S.deserializeState)(data);
    const onboardingPeriodDay = headerViewedAt ? (0, $jb2R2.default)(new Date(), new Date(headerViewedAt)) : 0;
    (0, $cozmU.useEffect)(()=>{
        if (!headerViewedAt) {
            setOnboardingState({
                key: (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER,
                value: new Date().toISOString()
            });
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'useCasesHomeWelcomeBanner',
                    attributes: {
                        onboardingPeriodDay: onboardingPeriodDay
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        headerViewedAt,
        onboardingPeriodDay
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'useCasesHomeWelcomeBannerDismiss',
                source: 'cc-experiment-use-cases-in-nth-user-onboarding',
                attributes: {
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]); // Do not show the banner under the following criteria:
    // 1. If the banner has already been dismissed (this is handled in useOnboardingTakeoverType)
    // 2. We are outside of the 14 day onboarding period (this is handled in useOnboardingTakeoverType)
    // 3. The templates list is already dismissed
    if (isTemplateListDismissed || loading || error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.accent.blue.subtlest",
        xcss: $3b19b5a183dfb573$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $3b19b5a183dfb573$var$styles.textSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerTitle,
        values: {
            name: name
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerAction,
        values: {
            b: (words)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, words)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($48dcb9eaf86e2736$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($81509ab5fd4e14b5$exports))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3b19b5a183dfb573$var$styles.dismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: handleDismiss,
        spacing: "default",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($3b19b5a183dfb573$var$i18n.useCasesHomeWelcomeBannerDismiss),
        isTooltipDisabled: false
    })));
};





/* NthUserHomeOnboardingActionCards.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $aRGok = parcelRequire("aRGok");





var $3wfPC = parcelRequire("3wfPC");


var $dG9Mj = parcelRequire("dG9Mj");





var $9uxfR = parcelRequire("9uxfR");
















/* NthUserCards.tsx generated by @compiled/babel-plugin v3.0.2 */ 














const $0d6c8c89db8717c2$var$styles = {
    imageStyles: "_39xV02N91d _00EA0eiObl _3v5uP0EKa8 _3iDTPbvLZJ _1yltTqr4vv",
    imageContainer: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _3v5uP0EKa8 _1yltTqa6YE"
};
// Memoized Image component to prevent unnecessary re-renders during transitions
const $0d6c8c89db8717c2$var$MemoizedCardImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ src: src, srcDark: srcDark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0d6c8c89db8717c2$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: src,
        srcDark: srcDark,
        alt: "",
        className: (0, $hekY6.default)([
            $0d6c8c89db8717c2$var$styles.imageStyles
        ])
    })));
$0d6c8c89db8717c2$var$MemoizedCardImage.displayName = 'CardImage';
const $0d6c8c89db8717c2$var$createImageComponent = (src, srcDark)=>{
    return {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d6c8c89db8717c2$var$MemoizedCardImage, {
            src: src,
            srcDark: srcDark
        })
    };
}; /**
    * CDN URLs for all images
    * Provides reliable SSR rendering with browser caching benefits
    */ 
const $0d6c8c89db8717c2$export$33dcd44cdbd7c6b = {
    pageImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d0x4rv1mqv3pvoma7b0r3w66hutj4s4f.svg',
    pageImageDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/60a3avoj78460elv2g254c15h356spe4.svg',
    brainstormWhiteboard: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gsy48bdsie2x0jl4bwwqa251ow5vc65s.svg',
    brainstormWhiteboardDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5j4oiocdk42kkk6567oh3j21u1ar2et3.svg',
    aiTeammate: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1608esypf8aw3u06t0i235yp27p45utr.svg',
    aiTeammateDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0l17d633654t1u8c8171o0xh48cbs375.svg',
    addProfilePicture: 'https://dam-cdn.atl.orangelogic.com/AssetLink/385i88hx73177r8l53036061ca7wquy4.svg',
    addProfilePictureDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/20pg03c85k301om1xm75652h821e55gx.svg',
    followPeopleAndSpaces: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5iljf6lua6c42o33qf34l0nt23r7078o.svg',
    followPeopleAndSpacesDark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vn1217d2v8yw2lq888gp0b84e7u5g3tu.svg'
}; // Use CDN URLs for all images - SSR friendly and cacheable
const $0d6c8c89db8717c2$var$IMAGES = {
    pageImage: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.pageImage, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.pageImageDark),
    brainstormWhiteboard: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.brainstormWhiteboard, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.brainstormWhiteboardDark),
    aiTeammate: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.aiTeammate, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.aiTeammateDark),
    addProfilePicture: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.addProfilePicture, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.addProfilePictureDark),
    followPeopleAndSpaces: $0d6c8c89db8717c2$var$createImageComponent($0d6c8c89db8717c2$export$33dcd44cdbd7c6b.followPeopleAndSpaces, $0d6c8c89db8717c2$export$33dcd44cdbd7c6b.followPeopleAndSpacesDark)
};
const $0d6c8c89db8717c2$var$i18n = (0, $kSwu1.defineMessages)({
    createPage: {
        id: "experiment-personalized-templates-v2.nth-user.create.page",
        defaultMessage: "Create a page"
    },
    createPageDescription: {
        id: "experiment-personalized-templates-v2.nth-user.create.page.description",
        defaultMessage: "Plan projects, take notes, and track tasks."
    },
    createPageCTA: {
        id: "experiment-personalized-templates-v2.nth-user.create.page.cta",
        defaultMessage: "Create page"
    },
    brainstormOnWhiteboard: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard",
        defaultMessage: "Brainstorm on a whiteboard"
    },
    brainstormOnWhiteboardDescription: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard.description",
        defaultMessage: "Dream up new ideas and visualize your work."
    },
    brainstormOnWhiteboardCTA: {
        id: "experiment-personalized-templates-v2.nth-user.brainstorm.on.whiteboard.cta",
        defaultMessage: "Create whiteboard"
    },
    followPeopleAndSpaces: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces",
        defaultMessage: "Follow people and spaces"
    },
    followPeopleAndSpacesDescription: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces.description",
        defaultMessage: "Customize your following feed to stay up to date with what matters to you."
    },
    followPeopleAndSpacesCTA: {
        id: "experiment-personalized-templates-v2.nth-user.follow.people.and.spaces.cta",
        defaultMessage: "Customize feed"
    },
    meetAITeammate: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate",
        defaultMessage: "Meet your AI teammate"
    },
    meetAITeammateDescription: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate.description",
        defaultMessage: "Rovo connects your knowledge and streamlines work, so you can focus on what matters."
    },
    meetAITeammateCTA: {
        id: "experiment-personalized-templates-v2.nth-user.meet.your.ai.teammate.cta",
        defaultMessage: "Chat with Rovo"
    },
    addProfilePicture: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture",
        defaultMessage: "Add your profile photo"
    },
    addProfilePictureDescription: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture.description",
        defaultMessage: "Welcome your teammates to Confluence with a familiar face."
    },
    addProfilePictureCTA: {
        id: "experiment-personalized-templates-v2.nth-user.add.profile.picture.cta",
        defaultMessage: "Add photo"
    },
    completedCTAText: {
        id: "experiment-personalized-templates-v2.nth-user.completed.cta",
        defaultMessage: "Completed"
    },
    dismissLabel: {
        id: "experiment-personalized-templates-v2.nth-user.dismiss.label",
        defaultMessage: "Dismiss"
    }
});
const $0d6c8c89db8717c2$export$43cedd252f50b9ab = [
    {
        id: 'createPage',
        image: $0d6c8c89db8717c2$var$IMAGES.pageImage,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPageDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.createPageCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{} // This will be handled by the card's onDismiss prop
    },
    {
        id: 'brainstormOnWhiteboard',
        image: $0d6c8c89db8717c2$var$IMAGES.brainstormWhiteboard,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboard),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboardDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.brainstormOnWhiteboardCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'followPeopleAndSpaces',
        image: $0d6c8c89db8717c2$var$IMAGES.followPeopleAndSpaces,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpaces),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpacesDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.followPeopleAndSpacesCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'meetAITeammate',
        image: $0d6c8c89db8717c2$var$IMAGES.aiTeammate,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammate),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammateDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.meetAITeammateCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    },
    {
        id: 'addProfilePicture',
        image: $0d6c8c89db8717c2$var$IMAGES.addProfilePicture,
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePicture),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePictureDescription),
        ctaText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.addProfilePictureCTA),
        ctaCompletedText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.completedCTAText),
        dismissTooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d6c8c89db8717c2$var$i18n.dismissLabel),
        onDismiss: ()=>{}
    }
];


const $c1ddb20c20a4b62a$export$33a6b2d2157bcee2 = (dismissedCardIds)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const actionCardsToDisplay = (0, $cozmU.useMemo)(()=>{
        const isCardDismissed = (cardId)=>dismissedCardIds.has(cardId);
        const shouldShowCard = (cardId)=>{
            if (isCardDismissed(cardId)) return false;
            if (cardId === 'meetAITeammate') return isRovoLLMEnabled;
            if (cardId === 'followPeopleAndSpaces') return !isRovoLLMEnabled;
            return true;
        };
        return (0, $0d6c8c89db8717c2$export$43cedd252f50b9ab).filter((card)=>shouldShowCard(card.id));
    }, [
        dismissedCardIds,
        isRovoLLMEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (actionCardsToDisplay.length === 0) setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).areAllActionsDismissed,
            value: 'true'
        });
    }, [
        actionCardsToDisplay,
        setOnboardingState
    ]);
    return {
        areAllActionsDismissed: actionCardsToDisplay.length === 0,
        actionCardsToDisplay: actionCardsToDisplay
    };
};
















var $8cmRU = parcelRequire("8cmRU");


var $lEClu = parcelRequire("lEClu");
















var $hdBxM = parcelRequire("hdBxM");

const $c3fa5e5d9d23f949$var$SOURCE = 'nth-user-home-onboarding-revamp';
function $c3fa5e5d9d23f949$export$78b73ffb475465cf(openActivityFilterModal) {
    const { personalSpaceKey: personalSpaceKey, onboardingPeriodDay: onboardingPeriodDay } = (0, $hxdG1.usePTV2State)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { href: profilePictureHref } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    const pageCreationLink = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: '`${SOURCE}--create-page`',
        spaceKey: personalSpaceKey,
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
        openTemplatesGallery: true
    });
    const whiteboardCreationLink = (0, $bZSO8.buildCreationLink)({
        contentType: 'whiteboard',
        source: `${$c3fa5e5d9d23f949$var$SOURCE}--create-whiteboard`,
        spaceKey: personalSpaceKey
    });
    const hrefMap = (0, $cozmU.useMemo)(()=>({
            createPage: pageCreationLink,
            brainstormOnWhiteboard: whiteboardCreationLink,
            addProfilePicture: profilePictureHref
        }), [
        pageCreationLink,
        whiteboardCreationLink,
        profilePictureHref
    ]);
    const handleActionClick = (0, $cozmU.useCallback)((id, complete)=>{
        complete(id);
        if (id === 'meetAITeammate') publish({
            type: 'chat-new',
            data: {
                name: 'Ask Rovo',
                dialogues: [],
                prompt: '',
                sourceId: `${$c3fa5e5d9d23f949$var$SOURCE}--meet-ai-teammate`
            },
            source: 'confluence',
            interactionSource: $c3fa5e5d9d23f949$var$SOURCE,
            openChat: true
        });
        else if (id === 'followPeopleAndSpaces') openActivityFilterModal();
        else {
            // Handle href navigation for other actions
            const href = hrefMap[id];
            if (href) {
                const isExternalLink = href && !href.includes('wiki');
                if (isExternalLink) window.open(href, '_blank');
                else window.location.href = href;
            }
        }
        // Track analytics
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gettingStartedCardNthUserHomeRevamp',
                source: $c3fa5e5d9d23f949$var$SOURCE,
                attributes: {
                    onboardingAction: id,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onboardingPeriodDay,
        openActivityFilterModal,
        hrefMap,
        publish
    ]);
    return {
        handleActionClick: handleActionClick
    };
}
function $c3fa5e5d9d23f949$export$471002be235b55c9() {
    const { activityFilterModalOpen: activityFilterModalOpen, closeActivityFilterModal: closeActivityFilterModal, openActivityFilterModal: openActivityFilterModal } = (0, $8cmRU.useActivityFilterModalState)();
    const { updateFeedType: updateFeedType } = (0, $fJ5kL.useFeedTypeSelector)();
    const { followingFeedSortBy: followingFeedSortBy, followingFeedQuery: feedContentQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const handleFeedSelectorChange = (0, $cozmU.useCallback)((updatedFeedType)=>{
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType
    ]);
    const handleActivityFilterModalSave = (0, $cozmU.useCallback)(()=>{
        feedContentQuery.refetch?.({
            sortBy: followingFeedSortBy
        });
        handleFeedSelectorChange((0, $4yg2A.FeedType).FOLLOWING);
    }, [
        feedContentQuery,
        followingFeedSortBy,
        handleFeedSelectorChange
    ]);
    return {
        activityFilterModalOpen: activityFilterModalOpen,
        closeActivityFilterModal: closeActivityFilterModal,
        openActivityFilterModal: openActivityFilterModal,
        handleActivityFilterModalSave: handleActivityFilterModalSave
    };
}


const $7eaa5db0ad110548$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $7eaa5db0ad110548$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "experiment-personalized-templates-v2.nth-user.action.cards.heading",
        defaultMessage: "Getting started"
    }
});
const $7eaa5db0ad110548$var$styles = {
    containerStyles: "_1wydGWNHnM",
    headerStyles: "_0hPCNLDIqT _1wydGW8HPE",
    gridStyles: "_2iEGP2Lmr7 _4cQPhCshXd"
};
const $7eaa5db0ad110548$export$1712ed5fe64b4d6e = ({ onboardingStateData: onboardingStateData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { onboardingPeriodDay: onboardingPeriodDay } = (0, $hxdG1.usePTV2State)();
    const { actions: actions, dismiss: dismiss, complete: complete } = (0, $9uxfR.usePersonalizedTemplateOnboardingActions)((0, $0d6c8c89db8717c2$export$43cedd252f50b9ab), onboardingStateData, (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).onboardingActionStates);
    const { activityFilterModalOpen: activityFilterModalOpen, closeActivityFilterModal: closeActivityFilterModal, handleActivityFilterModalSave: handleActivityFilterModalSave, openActivityFilterModal: openActivityFilterModal } = (0, $c3fa5e5d9d23f949$export$471002be235b55c9)();
    const { handleActionClick: handleActionClick } = (0, $c3fa5e5d9d23f949$export$78b73ffb475465cf)(openActivityFilterModal);
    const handleClick = (0, $cozmU.useCallback)((id, _event)=>{
        handleActionClick(id, complete);
    }, [
        handleActionClick,
        complete
    ]);
    const handleDismiss = (0, $cozmU.useCallback)((id)=>{
        dismiss?.(id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissGettingStartedCardNthUserHomeRevamp',
                source: $7eaa5db0ad110548$var$SOURCE,
                attributes: {
                    onboardingAction: id,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        dismiss,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]); // Filter and sort actions
    const actionsMap = (0, $cozmU.useMemo)(()=>Object.fromEntries(actions.map((action)=>[
                action.id,
                action
            ])), [
        actions
    ]);
    const dismissedCardIds = (0, $cozmU.useMemo)(()=>new Set(Object.values(actionsMap).filter((action)=>action.state === 'dismissed').map((action)=>action.id)), [
        actionsMap
    ]);
    const { actionCardsToDisplay: filteredOnboardingActionCards } = (0, $c1ddb20c20a4b62a$export$33a6b2d2157bcee2)(dismissedCardIds);
    (0, $cozmU.useEffect)(()=>{
        if (filteredOnboardingActionCards.length > 0) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'homeRevampActionCards',
                source: $7eaa5db0ad110548$var$SOURCE,
                attributes: {
                    numberOfCards: filteredOnboardingActionCards.length,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        filteredOnboardingActionCards.length,
        createAnalyticsEvent,
        onboardingPeriodDay
    ]);
    if (filteredOnboardingActionCards.length === 0) return null;
    const nonCompletedCards = filteredOnboardingActionCards.filter((card)=>actionsMap[card.id]?.state !== 'completed');
    const completedCards = filteredOnboardingActionCards.filter((card)=>actionsMap[card.id]?.state === 'completed');
    const sortedOnboardingActionCards = [
        ...nonCompletedCards,
        ...completedCards
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7eaa5db0ad110548$var$styles.containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $7eaa5db0ad110548$var$styles.headerStyles,
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7eaa5db0ad110548$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $7eaa5db0ad110548$var$styles.gridStyles,
        gap: "space.200"
    }, sortedOnboardingActionCards.map((card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3wfPC.default), {
            key: card.id,
            image: card.image,
            heading: card.heading,
            description: card.description,
            ctaText: card.ctaText,
            ctaCompletedText: card.ctaCompletedText,
            dismissTooltip: card.dismissTooltip,
            onClick: (event)=>handleClick(card.id, event),
            onDismiss: ()=>handleDismiss(card.id),
            cardCompleted: actionsMap[card.id]?.state === 'completed',
            hasBorder: true,
            headingSize: "xsmall"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, activityFilterModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dG9Mj.ActivityFilterDialog), {
        onChanged: handleActivityFilterModalSave,
        onClose: closeActivityFilterModal
    })));
};


/**
 * @generated SignedSource<<a31f80551dda64564043d60a000ba9f2>>
 * @relayHash a318c6cf4c9eb18c3a3da37ca363ccc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48
const $4e7f171d842d0a92$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "usePersonalSpace"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "usePersonalSpace",
                    "variableName": "usePersonalSpace"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NthUserTemplatesAllTemplatesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NthUserTemplatesAllTemplatesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a318c6cf4c9eb18c3a3da37ca363ccc1",
            "id": "3ad70d54f9d11fe1f125e5eb474fba169e08e62a8d9e0d7d7b53b29042f9ea48",
            "metadata": {},
            "name": "NthUserTemplatesAllTemplatesQuery",
            "operationKind": "query",
            "text": "query NthUserTemplatesAllTemplatesQuery($usePersonalSpace:Boolean!){allTemplates(usePersonalSpace:$usePersonalSpace){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
        }
    };
}();
$4e7f171d842d0a92$var$node.hash = "832d03e1fc006e98443bb93d481b50bc";
var $4e7f171d842d0a92$export$2e2bcd8739ae039 = $4e7f171d842d0a92$var$node;









var $6RlQ2 = parcelRequire("6RlQ2");
















var $8E5P5 = parcelRequire("8E5P5");


var $lNMA9 = parcelRequire("lNMA9");


var $aZID8 = parcelRequire("aZID8");


var $k70KU = parcelRequire("k70KU");


var $7eJWX = parcelRequire("7eJWX");


var $25bKr = parcelRequire("25bKr");


var $bTccH = parcelRequire("bTccH");

/* NthUserTemplateList.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $w6R6I = parcelRequire("w6R6I");































const $e07ad381e43da202$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    heading: {
        id: "experiment-personalized-templates-v2.nth-user.template.heading",
        defaultMessage: "Templates trusted by {teamType} teams like yours"
    },
    subheading: {
        id: "experiment-personalized-templates-v2.nth-user.template.subheading",
        defaultMessage: "Chosen to help you move fast and make an impact from day one"
    },
    label: {
        id: "experiment-personalized-templates-v2.nth-user.template.dismiss.label",
        defaultMessage: "Dismiss recommendations"
    },
    expand: {
        id: "experiment-personalized-templates-v2.nth-user.template.see.more.templates.button",
        defaultMessage: "Show {numberTemplateSuggestions} more"
    },
    collapse: {
        id: "experiment-personalized-templates-v2.nth-user.template.show.fewer.button",
        defaultMessage: "Show fewer"
    }
});
const $e07ad381e43da202$var$styles = {
    gridStyles: "_2iEGP2vGZi",
    textContainerStyles: "_1wydGW8HPE",
    listResetStyles: "_1LMyvKYbGa _43nrzTPgdg _0rIjykPgdg _0GTcwRPgdg _2xTnZxPgdg _0LQT5EPgdg"
};
const $e07ad381e43da202$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $e07ad381e43da202$export$3381bde4f3f682c5 = ({ cards: cards, teamType: teamType, shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const [{ onboardingPeriodDay: onboardingPeriodDay }, { setIsTemplateListDismissed: setIsTemplateListDismissed }] = (0, $hxdG1.usePTV2Store)();
    const [isTemplateListExpanded, setIsTemplateExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resizingHeight = (0, $2LyZS.useResizingHeight)();
    const remainingTemplates = (cards?.length || 0) - 4;
    const expandButtonMessage = isTemplateListExpanded ? formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.collapse) : formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.expand, {
        numberTemplateSuggestions: remainingTemplates
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] ? 'teamType' : 'popular';
    const handleToggleButtonClick = (0, $cozmU.useCallback)(()=>{
        setIsTemplateExpanded(!isTemplateListExpanded);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openCloseHomeRevampTemplates',
                source: $e07ad381e43da202$var$SOURCE,
                attributes: {
                    isExpanding: !isTemplateListExpanded,
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        isTemplateListExpanded,
        setIsTemplateExpanded,
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay
    ]);
    const handleDismissTemplateListClick = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).isTemplateListDismissed,
            value: 'true'
        });
        setIsTemplateListDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissHomeRevampTemplates',
                source: $e07ad381e43da202$var$SOURCE,
                attributes: {
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        setOnboardingState,
        setIsTemplateListDismissed,
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", resizingHeight, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e07ad381e43da202$var$styles.textContainerStyles,
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$e07ad381e43da202$export$a7357cdd1f0b0168.heading,
        values: {
            teamType: teamType.toLocaleLowerCase()
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e07ad381e43da202$export$a7357cdd1f0b0168.subheading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, remainingTemplates > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleToggleButtonClick
    }, expandButtonMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        appearance: "subtle",
        onClick: handleDismissTemplateListClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($e07ad381e43da202$export$a7357cdd1f0b0168.label)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        as: "ul",
        xcss: (0, $w6R6I.cx)($e07ad381e43da202$var$styles.gridStyles, $e07ad381e43da202$var$styles.listResetStyles),
        gap: "space.200"
    }, cards.filter((card)=>card).splice(0, isTemplateListExpanded ? cards.length : 4).map((card, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: card.key ?? i
        }, card))));
};


const $bb2b741b44f9896d$var$AllTemplatesQuery = (0, $4e7f171d842d0a92$export$2e2bcd8739ae039);
const $bb2b741b44f9896d$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $bb2b741b44f9896d$export$a0d0c2ff6dc2cf52 = ({ templateUsageValues: templateUsageValues, shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const { teamType: teamType, personalSpaceKey: personalSpaceKey, onboardingPeriodDay: onboardingPeriodDay, isTemplateListDismissed: isTemplateListDismissed } = (0, $hxdG1.usePTV2State)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: allTemplatesData } = (0, $jMyy4.useQueryInterop)($bb2b741b44f9896d$var$AllTemplatesQuery, {
        variables: {
            usePersonalSpace: true
        },
        skip: !personalSpaceKey || isTemplateListDismissed,
        __callerPackage__: "experiment-personalized-templates-v2"
    });
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] ? 'teamType' : 'popular';
    const blueprintModuleKeyToTemplate = (0, $8E5P5.mapBlueprintModuleKeyToTemplate)(allTemplatesData);
    // Read use case selected templates from onboarding state
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES
    ]);
    // Determine needed templates
    const neededTemplates = (0, $cozmU.useMemo)(()=>{
        let templates = [];
        if (!loading && !error) {
            const { selectedTemplates: selectedTemplates } = (0, $ivb8S.deserializeState)(data);
            // Try to use use case selected templates if available
            if (shouldShowUseCasesHomeWelcomeBanner && selectedTemplates) try {
                // Parse the stored use case template selection data
                const { teamType: selectedTeamType, useCases: useCases } = JSON.parse(selectedTemplates);
                // Fetch templates based on team type and use cases
                const useCaseTemplates = (0, $6RlQ2.fetchUseCaseTemplatesByTempTypeAndUseCaseId)(selectedTeamType, useCases);
                if (useCaseTemplates && useCaseTemplates.length > 0) for(let uctIndex = 0; uctIndex < useCaseTemplates.length; uctIndex++){
                    if (useCaseTemplates[uctIndex].templateType === 'page') {
                        for (const blueprintName of Object.keys((0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)))if ((0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)[blueprintName]?.blueprintModuleCompleteKey == useCaseTemplates[uctIndex].templateId) {
                            templates.push(blueprintName);
                            break;
                        }
                    } else if (Object.values((0, $aZID8.WHITEBOARD_TEMPLATE_IDS)).includes(useCaseTemplates[uctIndex].templateId)) templates.push(useCaseTemplates[uctIndex].templateId);
                }
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'useCaseTemplate',
                        source: 'cc-experiment-use-cases-in-nth-user-onboarding',
                        attributes: {
                            errorMessage: error.message
                        }
                    }
                }).fire();
            }
        }
        // Fallback to team-based templates if no templates were set
        if (templates.length === 0) templates = (0, $lNMA9.teamToTemplatesMapping)[teamType.toLocaleUpperCase()] || (0, $k70KU.DEFAULT_POPULAR_TEMPLATES);
        return templates;
    }, [
        shouldShowUseCasesHomeWelcomeBanner,
        data,
        teamType,
        loading,
        error,
        createAnalyticsEvent
    ]);
    const { deserializedTemplateUsage: deserializedTemplateUsage, incrementTemplateUsage: incrementTemplateUsage } = (0, $7eJWX.usePTV2TemplateUsage)(templateUsageValues, neededTemplates, (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).templateUsageValues);
    (0, $cozmU.useEffect)(()=>{
        if (!isTemplateListDismissed) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'homeRevampTemplates',
                source: $bb2b741b44f9896d$var$SOURCE,
                attributes: {
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        personalizationHeuristic,
        onboardingPeriodDay,
        isTemplateListDismissed
    ]);
    if (isTemplateListDismissed) return null;
    const cards = neededTemplates.reduce((current, templateName)=>{
        if ((0, $8E5P5.BLUEPRINT_NAMES_SET).has(templateName)) return [
            ...current,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bTccH.PTV2BlueprintTemplateCard), {
                key: templateName,
                usage: deserializedTemplateUsage[templateName] || 0,
                onClick: ()=>{
                    incrementTemplateUsage(templateName);
                },
                templateName: templateName,
                blueprintModuleKeyToTemplate: blueprintModuleKeyToTemplate
            })
        ];
        else return [
            ...current,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25bKr.PTV2WhiteboardTemplateCard), {
                key: templateName,
                usage: deserializedTemplateUsage[templateName] || 0,
                onClick: ()=>{
                    incrementTemplateUsage(templateName);
                },
                templateName: templateName
            })
        ];
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e07ad381e43da202$export$3381bde4f3f682c5), {
        cards: cards,
        teamType: teamType,
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    });
};


const $5fb3c229f2bf9813$var$GetUserDataQuery = (0, $a5ce719234afd4e6$export$2e2bcd8739ae039);
const $5fb3c229f2bf9813$var$SOURCE = 'nth-user-home-onboarding-revamp';
const $5fb3c229f2bf9813$export$734fda6f2c76c665 = ({ shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        IS_FOUNDING_ADMIN: (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...(0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS)
    }));
    const { data: userData, loading: userDataLoading, error: userDataError } = (0, $jMyy4.useQueryInterop)($5fb3c229f2bf9813$var$GetUserDataQuery, {
        __callerPackage__: "experiment-personalized-templates-v2"
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isTemplateListDismissed: isTemplateListDismissed, takeoverSeenAt: takeoverSeenAt, templateUsageValues: templateUsageValues } = (0, $ivb8S.deserializeState)(onboardingStateData) || {};
    (0, $cozmU.useEffect)(()=>{
        if (!onboardingStateLoading && !userDataLoading && !takeoverSeenAt) setOnboardingState({
            key: (0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS).takeoverSeenAt,
            value: new Date().toISOString()
        });
    }, [
        onboardingStateLoading,
        userDataLoading,
        takeoverSeenAt,
        setOnboardingState
    ]);
    const personalSpaceKey = userData?.user?.confluence?.hasPersonalSpace && userData?.user?.confluence?.space?.key || '';
    const teamType = userData?.user?.team || '';
    const displayName = userData?.user?.displayName;
    const onboardingPeriodDay = takeoverSeenAt ? (0, $jb2R2.default)(new Date(), new Date(takeoverSeenAt)) : 0;
    const isReadyToRender = !onboardingStateLoading && !userDataLoading && Boolean(personalSpaceKey);
    const personalizationHeuristic = shouldShowUseCasesHomeWelcomeBanner ? 'useCases' : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (isReadyToRender) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'nthUserHomeOnboardingRevamp',
                source: $5fb3c229f2bf9813$var$SOURCE,
                attributes: {
                    teamType: teamType,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isTemplateListDismissed: Boolean(isTemplateListDismissed),
                    personalizationHeuristic: personalizationHeuristic
                }
            }
        }).fire();
    }, [
        isReadyToRender,
        teamType,
        onboardingPeriodDay,
        isTemplateListDismissed,
        createAnalyticsEvent,
        personalizationHeuristic
    ]);
    if (userDataError) {
        if ((0, $1uFM6.isUnauthorizedError)(userDataError) || (0, $95rLf.isExpectedApolloError)(userDataError)) {
            (0, $7Sm4c.markErrorAsHandled)(userDataError);
            experienceTracker.abort({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
                reason: 'User is not permitted'
            });
        }
        experienceTracker.stopOnError({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
            error: userDataError
        });
        return null;
    }
    if (!isReadyToRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hxdG1.PTV2StoreContainer), {
        teamType: teamType,
        personalSpaceKey: personalSpaceKey,
        isTemplateListDismissed: isTemplateListDismissed,
        onboardingPeriodDay: onboardingPeriodDay,
        personalizationHeuristic: personalizationHeuristic,
        source: $5fb3c229f2bf9813$var$SOURCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.200",
        "data-vc": "nth-user-home-onboarding-revamp"
    }, shouldShowUseCasesHomeWelcomeBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b19b5a183dfb573$export$2d42ab2f37bfa9f6), {
        name: displayName ?? ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7eaa5db0ad110548$export$1712ed5fe64b4d6e), {
        onboardingStateData: onboardingStateData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb2b741b44f9896d$export$a0d0c2ff6dc2cf52), {
        templateUsageValues: templateUsageValues,
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP)
    }));
};
const $5fb3c229f2bf9813$export$b2aea928da4324ae = ({ shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT,
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP),
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5fb3c229f2bf9813$export$734fda6f2c76c665, {
        shouldShowUseCasesHomeWelcomeBanner: shouldShowUseCasesHomeWelcomeBanner
    }));
};






const $1bab1e21869236aa$export$ff08963ad63f51b1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Tlv72",
    name: "TemplateCollectionsLoader",
    loader: async ()=>(await (parcelRequire("atAUv"))).TemplateCollections
});


const $5b23f4939f96a023$var$onboardingExperienceContainerStyles = null;
const $5b23f4939f96a023$var$templatesContainerStyles = null;
const $5b23f4939f96a023$export$20dcb875488cce60 = ({ onboardingTakeoverType: onboardingTakeoverType, isTemplatesCollectionEligible: isTemplatesCollectionEligible })=>{
    if (onboardingTakeoverType === 'nth-user') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QRAVF _1mT5xdRAKS _1DCdHiQVkd"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e79497324363eb1$export$a4d10729329192ad), null));
    if (onboardingTakeoverType === 'personalized-templates-v2' || onboardingTakeoverType === 'personalized-templates-v2-xflow') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QRAVF _1mT5xdRAKS _1DCdHiQVkd"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8561b2cf16e3af7$export$a761578900d36b98), {
        isXflow: onboardingTakeoverType === 'personalized-templates-v2-xflow'
    }));
    if (onboardingTakeoverType === 'use-cases-in-nth-user-onboarding') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QRAVF _1mT5xdRAKS _1DCdHiQVkd"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fb3c229f2bf9813$export$b2aea928da4324ae), {
        shouldShowUseCasesHomeWelcomeBanner: true
    }));
    if (onboardingTakeoverType === 'nth-user-home-onboarding-revamp') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QRAVF _1mT5xdRAKS _1DCdHiQVkd"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fb3c229f2bf9813$export$b2aea928da4324ae), null));
    if (isTemplatesCollectionEligible && onboardingTakeoverType !== 'personalized-templates-v2-xflow' && onboardingTakeoverType !== 'personalized-templates-v2') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QRAVF _1mT5xdRAKS _313842dnbC _1DCdHiNHnM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1bab1e21869236aa$export$ff08963ad63f51b1), null));
    return null;
};


const $64913c7d2c985501$var$homeBannerContainerStyles = null;
const $64913c7d2c985501$export$addeb901e1836ce1 = ({ onboardingTakeoverType: onboardingTakeoverType, isTemplatesCollectionEligible: isTemplatesCollectionEligible })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QLlEU _3iDTPbcK7c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b23f4939f96a023$export$20dcb875488cce60), {
        onboardingTakeoverType: onboardingTakeoverType,
        isTemplatesCollectionEligible: isTemplatesCollectionEligible
    }));
};






const $ee623245de766b92$export$fd2c2dc14e3653d2 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tyi7n",
    name: "RovoAgentsForYouLoadable",
    loader: async ()=>(await (parcelRequire("lunzW"))).RovoAgentsForYou
});








const $8c01d222d553c3f1$export$656d36e9ec7d41a7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return(// Each expVal() is evaluated inline, experiment-last per lint rules.
    isAdminHubAIEnabled && isAIEarlyAccessEnabled && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cc_ootb_for_you_agent_card_nudge', 'cohort', 'experiment'));
};


/* RecentList.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $hjygH = parcelRequire("hjygH");





var $56QzY = parcelRequire("56QzY");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");





var $kDja4 = parcelRequire("kDja4");


var $yuLaV = parcelRequire("yuLaV");











var $iKWdo = parcelRequire("iKWdo");


var $ctLrB = parcelRequire("ctLrB");


var $y9T5W = parcelRequire("y9T5W");

const $35f0a51da435cb9c$export$66fe4c20f5d2846f = (data, isShowingMore, firstPageSize = (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH))=>{
    const recents = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))((data?.activity?.myActivity?.all?.edges || []).map((edge)=>edge?.node).map((node)=>(0, $ctLrB.transformActivityData)(node, true)).filter((0, $ctLrB.notEmpty)).filter((node)=>(0, $ctLrB.notEmpty)(node.object?.data)).filter((node)=>(0, $ctLrB.notArchived)(node.object?.data)).filter((node)=>(0, $ctLrB.notDeleted)(node.object?.data)), (node)=>node.object?.data?.id);
    if (isShowingMore) return recents;
    return recents.slice(0, firstPageSize);
};






const $1cabba32dee45c1f$export$b148c50d4e535e1f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KPVWG",
    name: "AgentSessionListItemLoadable",
    loader: async ()=>(await (parcelRequire("iQ6OW"))).AgentSessionListItem
});









var $gC2EJ = parcelRequire("gC2EJ");


var $c8bBH = parcelRequire("c8bBH");


var $eDtFr = parcelRequire("eDtFr");


var $5ZtfK = parcelRequire("5ZtfK");




/* NarrowPageCardView.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $lpNn5 = parcelRequire("lpNn5");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $8lYIw = parcelRequire("8lYIw");


var $1YXTQ = parcelRequire("1YXTQ");





var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $2HmqS = parcelRequire("2HmqS");

/* NarrowPageCardLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 








// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e180d36b0a6d313$var$Card = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKOeNX _0bjKvD8fU6 _4FKVYE5zaO _1mT5xdRAKS _0wOv4Q7zJH _0KLXrulfZc _3fSdSTzwhj",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$InvisibleLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $8lYIw.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKjg0e _0bjKvD8fU6 _1mT5xdWVPG _39xV02N91d _0jFU0VN91d _2IhTonA17z _3OE6xYA17z",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$Header = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1DCdHiEbN9",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardIcon = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0adFHsgVvo",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardPrimarySecondary = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardPrimary = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgEqul _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardSecondary = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzZpcK _0gKGieZpcK _3bFj0TZpcK _1E1xWzZpcK",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$var$CardActions = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFM1Y8M _3YEZNOdnbC",
            __cmplp.className
        ])
    });
});
const $9e180d36b0a6d313$export$4e84ecf8cf7987d = ({ icon: icon, primary: primary, secondary: secondary, lastModified: lastModified, actions: actions, className: className, testId: testId, url: url, onClick: onClick, ariaLabel: ariaLabel })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$Card, {
        className: className,
        "data-testid": testId,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$InvisibleLink, {
        href: url,
        onClick: onClick,
        "aria-label": ariaLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardIcon, {
        "data-testid": "list-item-icon"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardPrimarySecondary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardPrimary, null, primary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardSecondary, null, secondary)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardActions, null, actions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e180d36b0a6d313$var$CardSecondary, null, lastModified))));
};


/* StatusLozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $9KSWX = parcelRequire("9KSWX");





var $aqBZ0 = parcelRequire("aqBZ0");


var $bvJMy = parcelRequire("bvJMy");




const $f9db21cd493ae1c7$export$1e65fa6807627361 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _2O5Vij7dHp _2fwxA5ecOK _2XsHFM1Y8M _313842A17z _0jFU0Vey7F _3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
const $f9db21cd493ae1c7$var$LozengeContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842HZdu _0adFHsyrFs _1DCdHidnbC _2XsHFMyrFs",
            __cmplp.className
        ])
    });
});
const $f9db21cd493ae1c7$var$inlineStarContainerStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025'
});
const $f9db21cd493ae1c7$export$f72db4ad1e9b3e6d = ({ status: status, unpublished: unpublished = false, scheduled: scheduled = false, showStar: showStar = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (scheduled) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'StatusLozenge'
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9db21cd493ae1c7$export$1e65fa6807627361, null, status === 'draft' || status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), status === 'draft' ? (0, $2HmqS.i18n).contentDraft : (0, $2HmqS.i18n).contentArchived))) : null, scheduled && unpublished || scheduled && !unpublished ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral",
        isBold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2HmqS.i18n).contentScheduled))) : unpublished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9db21cd493ae1c7$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2HmqS.i18n).contentUnpublished))), showStar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $f9db21cd493ae1c7$var$inlineStarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvJMy.StarSelectedIcon), {
        size: "small",
        label: "Favorite"
    })) : null);
};












var $9NPFC = parcelRequire("9NPFC");





var $bCECL = parcelRequire("bCECL");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");

const $7019f18d0f63dcba$var$iconBorderStyles = (0, $buxP3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    height: '32px',
    width: '32px'
});
const $7019f18d0f63dcba$export$529be498da43e377 = ({ contentType: contentType, emoji: emoji, subType: subType })=>{
    if ((0, $9wGTI.fg)('confluence_frontend_tile_object_system_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        size: "medium",
        backgroundColor: "transparent",
        hasBorder: true,
        testId: "emoji-content-icon-tile"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        subType: subType,
        emoji: emoji
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $7019f18d0f63dcba$var$iconBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        subType: subType,
        emoji: emoji
    }));
};
const $7019f18d0f63dcba$export$c6f6399581f183bf = (content)=>{
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiProperty = content.status === 'draft' ? emojiPropertyDraft : emojiPropertyPublished;
    const emoji = emojiProperty || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiProperty),
        emoji: emoji
    };
};
const $7019f18d0f63dcba$export$70d1bf7729efff40 = (originalTitle, hasEmojiProperty)=>hasEmojiProperty ? originalTitle : (0, $brn6e.removeEmojiFromTitle)(originalTitle);


const $3b08a451faa582d7$var$SpaceLinkWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_42Yu6B7dHp _3iDTPbQ4SZ _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$SpaceLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $8lYIw.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _39HuIbz8Lp",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$LastModifiedWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1RrJLiQame",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$titleSelector = 'home.recents.Title';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b08a451faa582d7$var$TitleAndStatus = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2Qtkad98eZ _2lw4AYYbGa _1tegbc6wH8 _25vAN1ZpcK _41x675y7kJ _0BRgPvA17z _3LVdJQA17z",
            __cmplp.className
        ])
    });
});
const $3b08a451faa582d7$var$Title = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1mT5xdRAKS _1ANEUSLRg7 _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
$3b08a451faa582d7$var$Title.defaultProps = {
    'data-styled-selector': $3b08a451faa582d7$var$titleSelector
};
const $3b08a451faa582d7$export$5c759a6f26335296 = ({ content: content, onClick: onClick, onSpaceClick: onSpaceClick, action: action, lastActionI18n: lastActionI18n })=>{
    const isLivePage = content?.type === 'page' && content?.subType === 'live' && content?.status !== 'archived';
    const EMOJI_CONTENT_TYPES = (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles') ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const url = `${(0, $jlIaF.CONTEXT_PATH)}${content?.links?.webui}`;
    const isEmojiContentType = content?.type && EMOJI_CONTENT_TYPES.includes(content.type);
    const emoji = content?.title?.emoji;
    const title = isEmojiContentType ? (0, $7019f18d0f63dcba$export$70d1bf7729efff40)(content?.title?.text, Boolean(emoji)) : content?.title?.text;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7019f18d0f63dcba$export$529be498da43e377), {
        emoji: emoji,
        contentType: content?.type || '',
        subType: content?.subType || ''
    });
    const primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b08a451faa582d7$var$TitleAndStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2HmqS.i18n).contentUntitled),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b08a451faa582d7$var$Title, {
            href: url,
            tabIndex: -1,
            "aria-hidden": true,
            ...tooltipProps
        }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2HmqS.i18n).contentUntitled))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9db21cd493ae1c7$export$f72db4ad1e9b3e6d), {
        status: content?.status || ''
    }));
    const space = content?.space;
    const spaceKey = space?.spaceKey;
    const spaceName = space?.name || '';
    const secondary = spaceName && (spaceKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b08a451faa582d7$var$SpaceLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b08a451faa582d7$var$SpaceLink, {
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }),
        onClick: onSpaceClick
    }, spaceName)) : spaceName);
    const lastModifiedComponent = content?.lastAction?.when && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b08a451faa582d7$var$LastModifiedWrapper, null, lastActionI18n && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), lastActionI18n), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: content.lastAction.when
    }));
    const preloadOptions = (0, $1NBp8.SPACE_OVERVIEW).match(url) ? (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData : (0, $hXDOc.PreloadingPresets).onlyJS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "narrow-page-card",
        preloadUrl: url,
        preloadOptions: preloadOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e180d36b0a6d313$export$4e84ecf8cf7987d), {
        icon: icon,
        primary: primary,
        secondary: secondary,
        lastModified: lastModifiedComponent,
        actions: action,
        url: url,
        onClick: onClick,
        ariaLabel: title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2HmqS.i18n).contentUntitled),
        testId: "narrow-page-card"
    })));
};


/* RecentWorkListItemView.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxRuntime classic */ 









var $7vK9E = parcelRequire("7vK9E");





var $aOjGz = parcelRequire("aOjGz");




















var $lTWbV = parcelRequire("lTWbV");


var $hA174 = parcelRequire("hA174");




var $dbXpw = parcelRequire("dbXpw");


var $e6wiu = parcelRequire("e6wiu");

const $c66c384e48e0550b$var$styles = {
    titleAndStatus: "_3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _4ouGXIdnbC _17lj8p1Y8M",
    title: "_1EqgXlN91d _4ouGXIdnbC",
    titleText: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbvLZJ _1UtDYzy7kJ _1kk5Tk7GSX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
    metadata: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7",
    separator: "_3YEZNOdnbC _0GTcwR1Y8M _2xTnZx1Y8M",
    spaceLinkWrapper: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _17lj8p1Y8M",
    spaceLink: "_4bt5LAnQyn _2WAcuGnQyn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _39HuIbz8Lp _4DXJrK98eZ _4yBLMOYbGa _2QcX5c6wH8 _2nTuUYKGUX _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMKGUX"
};
const $c66c384e48e0550b$export$11907c8ee4cc0378 = ({ content: content, onClick: onClick, onSpaceClick: onSpaceClick, action: action, lastActionI18n: lastActionI18n })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isLivePage = content.type === 'page' && content.subType === 'live' && content.status !== 'archived';
    const url = `${(0, $jlIaF.CONTEXT_PATH)}${content.links?.webui}`;
    const title = (0, $7019f18d0f63dcba$export$70d1bf7729efff40)(content.title?.text, Boolean(content.title?.emoji));
    const titleContent = title || formatMessage((0, $hA174.recentWorkMessages).contentUntitled);
    const contentTypeMessage = (0, $e6wiu.getContentTypeMessage)(content.type, content.subType);
    const space = content.space;
    const primary = /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c66c384e48e0550b$var$styles.titleAndStatus
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: titleContent,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $c66c384e48e0550b$var$styles.title,
            testId: "recent-card-title",
            ...tooltipProps
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $c66c384e48e0550b$var$styles.titleText
            ])
        }, titleContent))), /*#__PURE__*/ $cozmU.createElement((0, $f9db21cd493ae1c7$export$f72db4ad1e9b3e6d), {
        status: content.status || ''
    }));
    const secondary = /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c66c384e48e0550b$var$styles.metadata
        ])
    }, contentTypeMessage && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), contentTypeMessage), contentTypeMessage && space?.name && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $c66c384e48e0550b$var$styles.separator,
        "aria-hidden": "true"
    }, "\xb7"), space?.name && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c66c384e48e0550b$var$styles.spaceLinkWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        testId: "recent-work-space-icon"
    }), space.spaceKey ? /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        xcss: $c66c384e48e0550b$var$styles.spaceLink,
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: space.spaceKey
        }),
        onClick: onSpaceClick
    }, space.name) : space.name));
    const icon = (0, $e6wiu.getContentIcon)(content.type, content.subType, content.title?.emoji);
    const card = /*#__PURE__*/ $cozmU.createElement((0, $lTWbV.RecentWorkListItemLayout), {
        url: url,
        ariaLabel: titleContent,
        onClick: onClick,
        testId: "recent-work-list-item",
        icon: icon,
        secondary: secondary,
        lastModified: content.lastAction?.when ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, lastActionI18n && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), lastActionI18n), ' ', /*#__PURE__*/ $cozmU.createElement((0, $1YXTQ.TimeAgo), {
            date: content.lastAction.when
        })) : undefined,
        actions: action
    }, primary);
    return /*#__PURE__*/ $cozmU.createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ $cozmU.createElement((0, $hXDOc.HoverPreloader), {
        name: "recent-work-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, card));
};
const $c66c384e48e0550b$export$3f110ad00123adad = (0, $dbXpw.AgentSessionListItemView);



var $2mfTa = parcelRequire("2mfTa");




const $05a91a1e1489ca6c$var$i18n = (0, $kSwu1.defineMessages)({
    edited: {
        id: "home.views.overview.recent-work.action.edited",
        defaultMessage: "You edited {timeAgo}"
    },
    visited: {
        id: "home.views.overview.recent-work.action.visited",
        defaultMessage: "You visited {timeAgo}"
    },
    created: {
        id: "home.views.overview.recent-work.action.created",
        defaultMessage: "You created {timeAgo}"
    },
    liked: {
        id: "home.views.overview.recent-work.action.liked",
        defaultMessage: "You liked {timeAgo}"
    },
    commented: {
        id: "home.views.overview.recent-work.action.commented",
        defaultMessage: "You commented {timeAgo}"
    },
    unpublished: {
        id: "home.views.overview.recent-work.lozenge.unpublished",
        defaultMessage: "unpublished changes"
    },
    editedShort: {
        id: "home.views.overview.recent-work.action.edited.short",
        defaultMessage: "Edited"
    },
    visitedShort: {
        id: "home.views.overview.recent-work.action.visited.short",
        defaultMessage: "Visited"
    },
    createdShort: {
        id: "home.views.overview.recent-work.action.created.short",
        defaultMessage: "Created"
    },
    likedShort: {
        id: "home.views.overview.recent-work.action.liked.short",
        defaultMessage: "Liked"
    },
    commentedShort: {
        id: "home.views.overview.recent-work.action.commented.short",
        defaultMessage: "Commented"
    }
});
const $05a91a1e1489ca6c$var$ActionIconStrings = {
    VIEWED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    EDITED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    UPDATED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    CREATED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.created,
        $05a91a1e1489ca6c$var$i18n.createdShort
    ],
    PUBLISHED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    LIKED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))),
        $05a91a1e1489ca6c$var$i18n.liked,
        $05a91a1e1489ca6c$var$i18n.likedShort
    ],
    COMMENTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
        $05a91a1e1489ca6c$var$i18n.commented,
        $05a91a1e1489ca6c$var$i18n.commentedShort
    ],
    SNAPSHOTTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.edited,
        $05a91a1e1489ca6c$var$i18n.editedShort
    ],
    STARTED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        $05a91a1e1489ca6c$var$i18n.created,
        $05a91a1e1489ca6c$var$i18n.createdShort
    ],
    // these shouldn't be possible for Confluence but are listed for completion
    ASSIGNED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    UNASSIGNED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ],
    TRANSITIONED: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))),
        $05a91a1e1489ca6c$var$i18n.visited,
        $05a91a1e1489ca6c$var$i18n.visitedShort
    ]
};
const $05a91a1e1489ca6c$export$2ce63fa6fe9fb735 = ({ recent: recent, index: index, onItemClick: onItemClick, onItemSpaceClick: onItemSpaceClick, shouldAutofocus: shouldAutofocus, useAgenticSessionsAppearance: useAgenticSessionsAppearance = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const transformedRecent = (0, $cozmU.useMemo)(()=>(0, $ctLrB.transformActivityData)(recent, true), [
        recent
    ]);
    const content = (0, $cozmU.useMemo)(()=>(0, $2mfTa.transformRecentToPageCard)(transformedRecent, '', false, true), [
        transformedRecent
    ]);
    const action = transformedRecent.event?.eventType || (0, $ctLrB.ActivityEventType).VIEWED;
    const { status: status, id: contentId, type: type } = content;
    const spaceKey = content.space.spaceKey;
    const linkRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (shouldAutofocus && linkRef.current) linkRef.current.focus();
    }, [
        shouldAutofocus,
        linkRef
    ]);
    const CardView = useAgenticSessionsAppearance ? (0, $c66c384e48e0550b$export$11907c8ee4cc0378) : (0, $3b08a451faa582d7$export$5c759a6f26335296);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardView, {
        key: index,
        content: content,
        lastActionI18n: $05a91a1e1489ca6c$var$ActionIconStrings[action]?.[2] ?? $05a91a1e1489ca6c$var$i18n.visitedShort,
        onClick: ()=>onItemClick(index, action, status, contentId, spaceKey, cloudId, type),
        onSpaceClick: ()=>onItemSpaceClick(index)
    });
};


/* RecentWorkEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $7ZB0A = parcelRequire("7ZB0A");











var $jhwJP = parcelRequire("jhwJP");





var $VHj6G = parcelRequire("VHj6G");


var $288YL = parcelRequire("288YL");


var $1jsae = parcelRequire("1jsae");


var $lKplK = parcelRequire("lKplK");

var $54aa3a992605c4ed$exports = {};
$54aa3a992605c4ed$exports = new URL("RecentEmptyStateBannerDark.7094fc88.svg", import.meta.url).toString();


var $cc5a0c924fe505e1$exports = {};
$cc5a0c924fe505e1$exports = new URL("RecentEmptyStateBannerLight.6e76de4a.svg", import.meta.url).toString();


const $d6d562fa774e9838$var$CREATE_DOC_SOURCE = 'recentWorkEmptyState';
const $d6d562fa774e9838$var$emptyStateStyles = null;
const $d6d562fa774e9838$var$headerStyles = null;
const $d6d562fa774e9838$var$contentStyles = null;
const $d6d562fa774e9838$var$imageStyles = null;
const $d6d562fa774e9838$var$listContainerStyles = null;
const $d6d562fa774e9838$var$emptyStateBannerStyles = {
    banner: "_0bjKvDyzSk _4c065UkG2W _2Y7lL45zaO _2fwxA5DIqT"
};
const $d6d562fa774e9838$var$i18nBase = (0, $kSwu1.defineMessages)({
    header: {
        id: "home.views.overview.recent-empty-state.header",
        defaultMessage: "Get out there and explore"
    },
    body: {
        id: "home.views.overview.recent-empty-state.body",
        defaultMessage: "Once you visit, edit, or create pages, you\u2019ll find the most recent ones here."
    }
});
const $d6d562fa774e9838$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    body: {
        id: "home.views.overview.recent-empty-state.body.livedocs",
        defaultMessage: "Once you visit, edit, or create pages or live docs, you\u2019ll find the most recent ones here."
    }
});
const $d6d562fa774e9838$var$i18nBanner = (0, $kSwu1.defineMessages)({
    header: {
        id: "home.views.overview.recent-empty-state.banner.header",
        defaultMessage: "Start something great"
    },
    body: {
        id: "home.views.overview.recent-empty-state.banner.body",
        defaultMessage: "Kick things off with a new doc and your most recent updates will show up here."
    },
    ctaCreateDoc: {
        id: "home.views.overview.recent-empty-state.banner.cta.create-doc",
        defaultMessage: "Create doc"
    }
});
const $d6d562fa774e9838$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d6d562fa774e9838$var$i18nBase, $d6d562fa774e9838$var$i18nLiveDocs);
const $d6d562fa774e9838$var$RecentWorkEmptyStateCard = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "recent-work-empty-list-container",
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _30huDKOeNX _0Of8r28HPE _0KLXruqi9L"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4FKVYENHnM _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3 _1mT5xdRAKS _0jFU0VNNui"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1EqgXlHakr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgEqul _1DCdHi2ADO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d6d562fa774e9838$var$i18n.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d6d562fa774e9838$var$i18n.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $288YL.CreatePageButton), {
        appearance: "default",
        creationLinkSource: "home-overview-recentList",
        showCreateLivePageButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lKplK))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1jsae))),
        alt: "",
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO2NHnM _2IhTonNHnM"
        ])
    })));
};
const $d6d562fa774e9838$var$RecentWorkEmptyStateBanner = ()=>{
    const { createDoc: createDoc } = (0, $VHj6G.useCreateHomeEmptyStateDoc)({
        source: $d6d562fa774e9838$var$CREATE_DOC_SOURCE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        backgroundColor: "elevation.surface.sunken",
        xcss: $d6d562fa774e9838$var$emptyStateBannerStyles.banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc5a0c924fe505e1$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($54aa3a992605c4ed$exports))),
        width: "52",
        height: "49",
        alt: "",
        testId: "recent-work-empty-state-banner-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d6d562fa774e9838$var$i18nBanner.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d6d562fa774e9838$var$i18nBanner.body)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: createDoc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d6d562fa774e9838$var$i18nBanner.ctaCreateDoc))));
};
const $d6d562fa774e9838$export$723865f954913f68 = ()=>{
    if ((0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6d562fa774e9838$var$RecentWorkEmptyStateBanner, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6d562fa774e9838$var$RecentWorkEmptyStateCard, null);
};


















var $2Ujef = parcelRequire("2Ujef");


var $fFEmG = parcelRequire("fFEmG");

/**
 * @generated SignedSource<<6dda330d8966e8ab51b63b0263204299>>
 * @relayHash cc6e35fb990db7cbb822759a08f51cce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b65896953c1233c97ea3a94bae2c96f584f836e4e148c3ec4385046c740df330
const $2aec62439454282d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "aqlQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shardingContext"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "aqlQuery",
            "variableName": "aqlQuery"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "shardingContext",
            "variableName": "shardingContext"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "conversationId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "invocationType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subEntityId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "AgentSession",
        "kind": "LinkedField",
        "name": "agentSession",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentAgentSessionAssociationsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionAssociationConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionAssociationQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSessionAssociation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentAgentSessionAssociationsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionAssociationConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionAssociationQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSessionAssociation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cc6e35fb990db7cbb822759a08f51cce",
            "id": "b65896953c1233c97ea3a94bae2c96f584f836e4e148c3ec4385046c740df330",
            "metadata": {},
            "name": "HomeRecentAgentSessionAssociationsQuery",
            "operationKind": "query",
            "text": "query HomeRecentAgentSessionAssociationsQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first){nodes{conversationId,invocationType,subEntityId,agentSession{id},id}}}"
        }
    };
}();
$2aec62439454282d$var$node.hash = "3b039a916c2f6c4b0c17b1e027de3469";
var $2aec62439454282d$export$2e2bcd8739ae039 = $2aec62439454282d$var$node;



var $ka7BG = parcelRequire("ka7BG");


var $kCweT = parcelRequire("kCweT");


var $a67vB = parcelRequire("a67vB");





var $6SsN4 = parcelRequire("6SsN4");


var $7W8i8 = parcelRequire("7W8i8");




/**
 * @generated SignedSource<<fe3e6beb95cbedf73c66c617a1002397>>
 * @relayHash c9351072966dcc87a9b68886d355a3fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cd830dde491b8a12d8e22ef282c1c20e1aded042de2b09fada0c205de9cd813
const $0833269e678468ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "ConvoAiInboxSessionChanged",
            "kind": "LinkedField",
            "name": "convoai_onInboxSessionChanged",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sessionId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HomeRecentAgentSessionsSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HomeRecentAgentSessionsSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c9351072966dcc87a9b68886d355a3fb",
            "id": "5cd830dde491b8a12d8e22ef282c1c20e1aded042de2b09fada0c205de9cd813",
            "metadata": {},
            "name": "HomeRecentAgentSessionsSubscription",
            "operationKind": "subscription",
            "text": "subscription HomeRecentAgentSessionsSubscription($accountId:String!,$cloudId:ID!,$workspaceAri:ID!){convoai_onInboxSessionChanged(accountId:$accountId,cloudId:$cloudId,workspaceAri:$workspaceAri)@optIn(to:\"ConvoAiInboxSessionChanged\"){sessionId}}"
        }
    };
}();
$0833269e678468ca$var$node.hash = "6ad85edfea368dcc0a351fba1b2dfab9";
var $0833269e678468ca$export$2e2bcd8739ae039 = $0833269e678468ca$var$node;


const $7f89de2f7693783c$var$logger = (0, $7W8i8.getLogger)('home-recent-agent-sessions-subscription');
function $7f89de2f7693783c$export$6f23b4a09c0a8f05(agentSessionsQueryResult, rovoActivationId) {
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const agentSessionsQueryRefetchRef = (0, $cozmU.useRef)(agentSessionsQueryResult.refetch);
    agentSessionsQueryRefetchRef.current = agentSessionsQueryResult.refetch;
    (0, $cozmU.useEffect)(()=>{
        if (!userId || !cloudId || !rovoActivationId) return;
        let refreshTimer;
        const subscription = (0, $6SsN4.requestSubscription)(environment, {
            subscription: (0, $0833269e678468ca$export$2e2bcd8739ae039),
            variables: {
                accountId: userId,
                cloudId: cloudId,
                workspaceAri: `ari:cloud:rovo::workspace/${rovoActivationId}`
            },
            onNext: (response)=>{
                if (!response?.convoai_onInboxSessionChanged) return;
                clearTimeout(refreshTimer);
                refreshTimer = setTimeout(()=>{
                    refreshTimer = undefined;
                    agentSessionsQueryRefetchRef.current().catch((error)=>$7f89de2f7693783c$var$logger.error`Home agent sessions refetch failed: ${error}`);
                }, 250);
            },
            onError: (error)=>$7f89de2f7693783c$var$logger.error`Home agent session subscription failed: ${error}`
        });
        return ()=>{
            clearTimeout(refreshTimer);
            subscription.dispose();
        };
    }, [
        cloudId,
        environment,
        rovoActivationId,
        userId
    ]);
}


const $77f51db044e9798b$export$4b7c4c3babb9aee3 = ({ isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isDatabaseEnabled: isDatabaseEnabled, isSlidesEnabled: isSlidesEnabled, first: first })=>{
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2Ujef.default), {
        ...(0, $a67vB.getRecentWorkQueryOptions)({
            cloudId: cloudId,
            isLoggedIn: isLoggedIn,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            isSlidesEnabled: isSlidesEnabled,
            first: first
        }),
        interopApolloAggClient: true,
        __callerPackage__: "home"
    });
    return {
        data: data,
        loading: loading,
        error: error
    };
};
const $77f51db044e9798b$export$9cdc273e75839d3c = ({ first: first } = {})=>{
    const { cloudId: cloudId, isLoggedIn: isLoggedIn, userId: userId } = (0, $bQm3c.useSessionData)();
    const rovoActivationQueryResult = (0, $jMyy4.useQueryInterop)((0, $ka7BG.default), {
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        skip: !isLoggedIn || !userId,
        __callerPackage__: "home"
    });
    const rovoActivationId = rovoActivationQueryResult.data?.tenantContexts?.[0]?.activationIdByProduct?.active;
    const skip = !isLoggedIn || !userId || !rovoActivationId;
    const agentSessionsQueryResult = (0, $jMyy4.useQueryInterop)((0, $fFEmG.default), {
        variables: skip ? {
            aqlQuery: '',
            first: 1,
            shardingContext: ''
        } : (0, $kCweT.getRecentAgentSessionsQueryVariables)({
            userId: userId,
            rovoActivationId: rovoActivationId,
            first: first
        }),
        interopApolloAggClient: true,
        skip: skip,
        __callerPackage__: "home"
    });
    const agentSessionsData = (0, $cozmU.useMemo)(()=>(agentSessionsQueryResult.data?.agent_sessionQuery?.nodes ?? []).filter((0, $ctLrB.notEmpty)).slice(0, (0, $kCweT.RECENT_AGENT_SESSIONS_DISPLAY_COUNT)), [
        agentSessionsQueryResult.data?.agent_sessionQuery?.nodes
    ]);
    const associationsBySessionId = $77f51db044e9798b$var$useHomeRecentAgentSessionAssociationsData({
        agentSessionsData: agentSessionsData,
        rovoActivationId: rovoActivationId
    });
    (0, $7f89de2f7693783c$export$6f23b4a09c0a8f05)(agentSessionsQueryResult, rovoActivationId);
    return {
        data: agentSessionsData,
        loading: rovoActivationQueryResult.loading || agentSessionsQueryResult.loading,
        error: rovoActivationQueryResult.error || agentSessionsQueryResult.error,
        associationsBySessionId: associationsBySessionId
    };
};
const $77f51db044e9798b$var$useHomeRecentAgentSessionAssociationsData = ({ agentSessionsData: agentSessionsData, rovoActivationId: rovoActivationId })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const associatedEntities = (0, $cozmU.useMemo)(()=>agentSessionsData.flatMap((session)=>session.id ? (session.associatedEntities ?? []).flatMap((entity)=>entity?.__typename === 'ConfluencePage' ? [
                    {
                        entityId: entity.id,
                        sessionId: session.id
                    }
                ] : []) : []), [
        agentSessionsData
    ]);
    const skip = !rovoActivationId || !userId || associatedEntities.length === 0;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2aec62439454282d$export$2e2bcd8739ae039), {
        variables: skip ? {
            aqlQuery: '',
            first: 1,
            shardingContext: ''
        } : (0, $kCweT.getRecentAgentSessionAssociationsQueryVariables)({
            associatedEntities: associatedEntities,
            rovoActivationId: rovoActivationId,
            userId: userId
        }),
        interopApolloAggClient: true,
        skip: skip,
        __callerPackage__: "home"
    });
    const associationsBySessionId = (0, $cozmU.useMemo)(()=>{
        const bySessionId = {};
        for (const node of data?.agent_sessionAssociationQuery?.nodes ?? []){
            const association = {
                invocationType: node?.invocationType,
                subEntityId: node?.subEntityId
            };
            // Keyed under both ids because either can be the one the session node reports.
            // They are the same value today, so the Set stops a single association being recorded twice.
            const sessionIdsForNode = new Set([
                node?.agentSession?.id,
                node?.conversationId
            ].filter((sessionId)=>Boolean(sessionId)));
            for (const sessionId of sessionIdsForNode)bySessionId[sessionId] = [
                ...bySessionId[sessionId] ?? [],
                association
            ];
        }
        return bySessionId;
    }, [
        data
    ]);
    return {
        data: associationsBySessionId,
        loading: loading,
        error: error
    };
};


const $4a2a6fb115c84f19$var$gridContainerStyles = {
    default: "_2mHwu85zaO _3iDTPbgBM8 _0ca6V7EgmZ _2iEGP2wD78",
    shouldShowRightPanel: "_2iEGP27s7Z"
};
const $4a2a6fb115c84f19$var$agenticSessionsStyles = {
    list: "_3iDTPbQ4SZ _0aFT5vbt8w _42d1HA1Y8M",
    itemPlaceholder: "_4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAfI2J",
    iconPlaceholder: "_0bjKvDKxmn _3YEZNOdnbC _39xV02Uofl _0jFU0VUofl _2xTnZx8HPE _0KLXruGsB2",
    titleAndMetadataPlaceholder: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4ouGXIdnbC _42d1HA1Y8M",
    titlePlaceholder: "_0bjKvDKxmn _39xV02njap _0jFU0Vey7F _0KLXruGsB2",
    metadataPlaceholder: "_0bjKvDKxmn _39xV02r1As _0jFU0VxpxF _0KLXruGsB2",
    lastActionPlaceholder: "_0bjKvDKxmn _3YEZNOdnbC _39xV02FFh0 _0jFU0VxpxF _0GTcwR5zaO _0KLXruGsB2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$293c6df601f14bb7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNO7dHp _37wbyuI7V3 _4ouGXIgZxp _0adFHs8HPE",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$titleAndCreatorAndSpaceStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$b8681802889370f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEwkAZ _3iDTPbQ4SZ _0jFU0VOYQB",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$itemPlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$7c901fb2027bd1cd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02oWWg _0jFU0VoWWg _313842FQfX _0adFHsEbN9 _0KLXruGsB2",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$iconPlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$3a57d38764f05898 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0jFU0V70UD _39xV02ygnw _0KLXruGsB2",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$titlePlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$bcafb2f622d94fc5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0jFU0Vey7F _39xV02R1Le _0KLXruGsB2",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$creatorAndSpacePlaceholderStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4a2a6fb115c84f19$export$1ad04d0e2f5bb038 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0jFU0VxpxF _39xV02xav9 _0KLXruGsB2 _313842FQfX",
            __cmplp.className
        ])
    });
});
const $4a2a6fb115c84f19$var$lastActionPlaceholderStyles = null;
const $4a2a6fb115c84f19$var$AgenticSessionsRecentList = ({ recents: recents, loading: loading, error: error, onItemClick: onItemClick, onItemSpaceClick: onItemSpaceClick })=>{
    const { data: agentSessions, loading: agentSessionsLoading, error: agentSessionsError, associationsBySessionId: associationsBySessionId } = (0, $77f51db044e9798b$export$9cdc273e75839d3c)();
    const displayedRecents = recents.slice(0, Math.max((0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH) - agentSessions.length, 0));
    const isLoading = loading || agentSessionsLoading;
    const combinedError = error || agentSessionsError;
    const hasItems = agentSessions.length > 0 || displayedRecents.length > 0;
    if (!isLoading && !hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6d562fa774e9838$export$723865f954913f68), null), combinedError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: combinedError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: combinedError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...!isLoading && hasItems && {
            role: 'list'
        },
        className: (0, $hekY6.default)([
            $4a2a6fb115c84f19$var$agenticSessionsStyles.list
        ])
    }, isLoading ? new Array((0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)).fill(0).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: i,
            "data-testid": "item-placeholder",
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.itemPlaceholder
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.iconPlaceholder
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.titleAndMetadataPlaceholder
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.titlePlaceholder
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.metadataPlaceholder
            ])
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $4a2a6fb115c84f19$var$agenticSessionsStyles.lastActionPlaceholder
            ])
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, agentSessions.map((session, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1cabba32dee45c1f$export$b148c50d4e535e1f), {
            key: session.id || `agent-session-${index}`,
            session: session,
            associations: session.id ? associationsBySessionId.data[session.id] : undefined
        })), displayedRecents.map((recent, index)=>{
        const ranking = agentSessions.length + index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05a91a1e1489ca6c$export$2ce63fa6fe9fb735), {
            key: recent.id,
            recent: recent,
            index: ranking,
            onItemClick: onItemClick,
            onItemSpaceClick: onItemSpaceClick,
            useAgenticSessionsAppearance: true
        });
    })), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, combinedError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: combinedError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: combinedError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    })));
};
const $4a2a6fb115c84f19$export$6caf97677f3b2063 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const { shouldShowRightPanel: shouldShowRightPanel } = (0, $jYZYm.useRightPanelVisible)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { data: data, loading: loading, error: error } = (0, $77f51db044e9798b$export$4b7c4c3babb9aee3)({
        isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        isSlidesEnabled: isSlidesEnabled,
        first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
    });
    const recents = (0, $35f0a51da435cb9c$export$66fe4c20f5d2846f)(data, false, (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH));
    const onItemClick = (index, action, status, contentId, spaceKey, tenantId, objectType)=>{
        if (objectType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'link',
                actionSubjectId: 'recentWorkItem',
                action: 'clicked',
                source: 'overviewScreen',
                attributes: {
                    platformCtx: 'recentWork',
                    destinationProduct: 'confluence',
                    destinationTenantId: tenantId,
                    destinationContainerType: 'space',
                    destinationContainerId: spaceKey,
                    destinationObjectType: objectType,
                    destinationObjectId: contentId,
                    pageLocation: 'home',
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    lastAction: action,
                    contentStatus: status
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'homeRecentWorkItem',
                action: 'clicked',
                source: 'overviewScreen',
                containerType: 'spaceKey',
                containerId: spaceKey,
                objectType: objectType,
                objectId: contentId,
                attributes: {
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    lastAction: action,
                    contentStatus: status
                }
            }
        }).fire();
    };
    const onItemSpaceClick = (index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'homeRecentWorkItemSpace',
                action: 'clicked',
                source: 'overviewScreen',
                attributes: {
                    ranking: index,
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
    if (isAdminHubAIEnabled && isAIEarlyAccessEnabled && (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4a2a6fb115c84f19$var$AgenticSessionsRecentList, {
        recents: recents,
        loading: loading,
        error: error,
        onItemClick: onItemClick,
        onItemSpaceClick: onItemSpaceClick
    });
    if (!loading && !recents.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6d562fa774e9838$export$723865f954913f68), null), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...!loading && recents.length > 0 && {
            role: 'list'
        },
        className: (0, $hekY6.default)([
            $4a2a6fb115c84f19$var$gridContainerStyles['default'],
            shouldShowRightPanel && $4a2a6fb115c84f19$var$gridContainerStyles['shouldShowRightPanel']
        ])
    }, loading && !recents.length ? new Array((0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)).fill(0).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: i,
            "data-testid": "item-placeholder",
            className: (0, $hekY6.default)([
                "_4FKVYEwkAZ _3iDTPbQ4SZ _0jFU0VOYQB"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _39xV02oWWg _0jFU0VoWWg _313842FQfX _0adFHsEbN9 _0KLXruGsB2"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNO7dHp _37wbyuI7V3 _4ouGXIgZxp _0adFHs8HPE"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _0jFU0V70UD _39xV02ygnw _0KLXruGsB2"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _0jFU0Vey7F _39xV02R1Le _0KLXruGsB2"
            ])
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _0jFU0VxpxF _39xV02xav9 _0KLXruGsB2 _313842FQfX"
            ])
        }))) : recents.map((recent, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05a91a1e1489ca6c$export$2ce63fa6fe9fb735), {
            key: recent.id,
            recent: recent,
            index: index,
            onItemClick: onItemClick,
            onItemSpaceClick: onItemSpaceClick,
            shouldAutofocus: index === (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
        })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    })));
};


/* RecentListError.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $aQbeC = parcelRequire("aQbeC");


var $edxGF = parcelRequire("edxGF");


var $iGOxg = parcelRequire("iGOxg");

const $4bcc8da6462294cb$var$errorContainerStyles = null;
const $4bcc8da6462294cb$var$errorImageStyles = null;
const $4bcc8da6462294cb$export$3a789051d4f2a5b2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r2Uofl _1ZnuxbSPN1 _1wydGWUofl _2Zuz6QSPN1 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGOxg))),
        alt: "",
        className: (0, $hekY6.default)([
            "_39xV02QEt6 _0jFU0VIZbP"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $edxGF.i18n).errorHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $edxGF.i18n).errorAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aQbeC.ErrorDetail), null)));
















const $d5ea26583237ee93$export$24088281b62f310b = ()=>{
    const { isNewUser: isNewUser } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: 28
    }, false);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabaseEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { data: data, loading: loading } = (0, $77f51db044e9798b$export$4b7c4c3babb9aee3)({
        isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        isSlidesEnabled: isSlidesEnabled,
        first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
    });
    const recents = (0, $35f0a51da435cb9c$export$66fe4c20f5d2846f)(data, false, (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH));
    return !loading && !recents.length && isNewUser;
};


const $ebb5220839af7526$var$i18n = (0, $kSwu1.defineMessages)({
    homeTitle: {
        id: "home.title",
        defaultMessage: "Home"
    },
    forYouTitle: {
        id: "home.for-you.title",
        defaultMessage: "For you"
    },
    recentWork: {
        id: "home.views.overview.recent-work",
        defaultMessage: "Pick up where you left off"
    },
    calendarTitle: {
        id: "home.feed.calendar.title",
        defaultMessage: "Calendars"
    },
    announcementsTitle: {
        id: "home.feed.announcements.title",
        defaultMessage: "Announcements"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ebb5220839af7526$var$OverviewContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPostOfficeHomeBannerEligible: isPostOfficeHomeBannerEligible, shouldShowRightPanel: shouldShowRightPanel, isOnboardingExperienceEligible: isOnboardingExperienceEligible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbgBM8 _1OagtcVa5s",
            __cmplp.isPostOfficeHomeBannerEligible ? "_0ca6V7LvAo" : "_0ca6V7GL8t",
            __cmplp.shouldShowRightPanel ? "_2iEGP2GR6z" : "_2iEGP2x0p7",
            __cmplp.shouldShowRightPanel ? "_23rrnHngV3" : "_23rrnHYbGa",
            __cmplp.isOnboardingExperienceEligible ? "_1VceBU7dHp" : "_1VceBUdnbC",
            __cmplp.isPostOfficeHomeBannerEligible ? "_1a5quv7dHp" : "_1a5quvdnbC",
            __cmplp.className
        ])
    });
});
const $ebb5220839af7526$var$recentContainerStyles = null;
const $ebb5220839af7526$var$bannerContainerStyles = null; // Rendered above the banners segment (see JSX order). Pinned to the main column so
// grid auto-placement does not squeeze it into the sidebar.
const $ebb5220839af7526$var$rovoAgentsContainerStyles = null;
const $ebb5220839af7526$var$feedContainerStyles = null;
const $ebb5220839af7526$var$rightPanelContainerStyles = null;
const $ebb5220839af7526$var$recentHeaderStyles = null;
const $ebb5220839af7526$var$limitContainerStyles = null;
const $ebb5220839af7526$export$e720d1bfc39dda01 = (events, experience)=>{
    const collection = [
        (0, $irVI7.FEED_EXPERIENCE),
        (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    ];
    (0, $1A7bE.collectAll)(collection)(events, experience);
};
const $ebb5220839af7526$var$RecentHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _1DCdHi5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ebb5220839af7526$var$i18n.recentWork)));
const $ebb5220839af7526$export$5c177581408c0b49 = ({ customPanels: customPanels, appsLoading: appsLoading, appsError: appsError, testId: testId = 'feed-section' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "feed-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QtBcU"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.FEED_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kLaAt.Feed), {
        renderPopularFeed: true,
        customPanels: customPanels
    }), !appsLoading && !appsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.HOME_RIGHT_PANEL_APPS_EXPERIENCE)
    }) : null));
const $ebb5220839af7526$export$ae369b3cff36adeb = ({ announcementsPanel: announcementsPanel, feedCustomWebPanels: feedCustomWebPanels, appsLoading: appsLoading, appsError: appsError })=>{
    const { loading: loading, shouldShowAnnouncementsPanel: shouldShowAnnouncementsPanel } = (0, $f61f7456930c6af1$export$5c24975fa7716110)();
    const customPanels = !loading && shouldShowAnnouncementsPanel ? [
        announcementsPanel,
        ...feedCustomWebPanels
    ] : feedCustomWebPanels;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb5220839af7526$export$5c177581408c0b49, {
        customPanels: customPanels,
        appsLoading: appsLoading,
        appsError: appsError,
        testId: "announcements-visibility-feed-section"
    });
}; //previously called Overview or homeOverview
const $ebb5220839af7526$export$d6cf4bb669b36f29 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { onboardingTakeoverType: onboardingTakeoverType } = (0, $f869c0d94495260f$export$fa48385168985af8)();
    const { isTemplatesCollectionEligible: isTemplatesCollectionEligible } = (0, $i1Y90.useTemplatesCollectionEligible)();
    const { isEligible: isPostOfficeHomeBannerEligible } = (0, $5mBfb.usePostOfficeHomeBannerEligible)();
    const { shouldShowRightPanel: shouldShowRightPanel } = (0, $jYZYm.useRightPanelVisible)();
    const isRovoAgentsForYouEligible = (0, $8c01d222d553c3f1$export$656d36e9ec7d41a7)(); // Passed from child panels rendered inside Feed custom panels.
    // e.g. for calendar: ForYou > Feed custom panel > Calendars > HomepageCard.
    // Feed owns the wrapper, but child panels report when they are showing an empty state.
    const [panelEmptyStates, setPanelEmptyStates] = (0, $cozmU.useState)({});
    const handlePanelEmptyStateChange = (0, $cozmU.useCallback)((completeKey, isEmptyState)=>{
        // null means the panel is still pending, so keep the last known empty-state value.
        if (isEmptyState !== null) setPanelEmptyStates((previousEmptyStates)=>previousEmptyStates[completeKey] === isEmptyState ? previousEmptyStates : {
                ...previousEmptyStates,
                [completeKey]: isEmptyState
            });
    }, []);
    const isEligibleForHideRecents = (0, $d5ea26583237ee93$export$24088281b62f310b)();
    const { panels: panels, loading: appsLoading, error: appsError } = (0, $dS3n9.useWebPanelLocation)({
        //no way to conditionally load this? Because hooks can't be conditional
        location: (0, $eSLr0.DASHBOARD_SECONDARY),
        fetchPolicy: 'cache-first'
    });
    const sortedPanels = (0, $cozmU.useMemo)(()=>panels ? [
            ...panels
        ].sort(({ weight: i }, { weight: j })=>i > j ? 1 : -1) : [], [
        panels
    ]);
    const feedCustomWebPanels = (0, $cozmU.useMemo)(()=>sortedPanels.map(({ html: html, completeKey: completeKey, label: label })=>{
            const isTeamCalendarsPanel = completeKey.includes('team-calendars');
            const shouldUseCalendarEmptyStateBanner = isTeamCalendarsPanel && (0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true);
            const isPanelEmptyState = Boolean(panelEmptyStates[completeKey]);
            return isTeamCalendarsPanel ? {
                title: intl.formatMessage($ebb5220839af7526$var$i18n.calendarTitle),
                key: completeKey,
                icon: (0, $65ae8040b45ec07e$export$480e92afeb9f3ea1),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33df235db03da5e3$export$39d78c94fb91ad03), {
                    completeKey: completeKey,
                    key: completeKey,
                    noCollapse: true,
                    showCalendarEmptyStateBanner: shouldUseCalendarEmptyStateBanner,
                    keepCalendarEmptyStateBannerVisible: shouldUseCalendarEmptyStateBanner && isPanelEmptyState,
                    onEmptyStateChange: shouldUseCalendarEmptyStateBanner ? (isEmptyState)=>handlePanelEmptyStateChange(completeKey, isEmptyState) : undefined
                }),
                renderWithoutWrapper: shouldUseCalendarEmptyStateBanner && isPanelEmptyState
            } : {
                title: label,
                icon: undefined,
                key: completeKey,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                    html: html
                })
            };
        }), [
        handlePanelEmptyStateChange,
        intl,
        panelEmptyStates,
        sortedPanels
    ]);
    const announcementsPanel = {
        title: intl.formatMessage($ebb5220839af7526$var$i18n.announcementsTitle),
        key: 'confluence.home.announcements',
        icon: (0, $65ae8040b45ec07e$export$eaac0a9bd05d5448),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caf885298d603c5d$export$cae2a62921ed768b), {
            noCollapse: true
        })
    };
    const feedCustomPanels = [
        announcementsPanel,
        ...feedCustomWebPanels
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb5220839af7526$var$OverviewContainer, {
        isOnboardingExperienceEligible: Boolean(onboardingTakeoverType || isTemplatesCollectionEligible // Only one of the two can show up at once, so we only need one styling variable
        ),
        isPostOfficeHomeBannerEligible: isPostOfficeHomeBannerEligible && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner'),
        shouldShowRightPanel: shouldShowRightPanel,
        "data-testid": "home_overview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage($ebb5220839af7526$var$i18n.forYouTitle),
        isHomePage: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
        collect: $ebb5220839af7526$export$e720d1bfc39dda01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.HOME_OVERVIEW_RECENT_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).HOME
    }), isRovoAgentsForYouEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "rovo-agents-for-you"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee623245de766b92$export$fd2c2dc14e3653d2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "banners"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64913c7d2c985501$export$addeb901e1836ce1), {
        onboardingTakeoverType: onboardingTakeoverType,
        isTemplatesCollectionEligible: isTemplatesCollectionEligible
    }), !isEligibleForHideRecents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2Qhvja _1mT5xdRAKS _313842dnbC _1DCdHiNHnM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RECENT_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb5220839af7526$var$RecentHeader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        renderOnError: (0, $4bcc8da6462294cb$export$3a789051d4f2a5b2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a2a6fb115c84f19$export$6caf97677f3b2063), null)))), isPostOfficeHomeBannerEligible && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2j3gqALlEU _3B2K2QM4pF"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Cx0V.PostOfficeHomeBanner), null))), (0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb5220839af7526$export$ae369b3cff36adeb, {
        announcementsPanel: announcementsPanel,
        feedCustomWebPanels: feedCustomWebPanels,
        appsLoading: appsLoading,
        appsError: appsError
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb5220839af7526$export$5c177581408c0b49, {
        customPanels: feedCustomPanels,
        appsLoading: appsLoading,
        appsError: appsError
    }), shouldShowRightPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_23rrnHOPl2 _2j3gqAiZR3 _313842Hdxz _1EKLiy7dHp _2V51w18OLE _4ouGXIBfNa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $gkVDU.HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a570c156dcdbd2e$export$364a989a35814102), {
        widthMode: "fullwidth"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "automation-limit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _1mT5xdy1CL _3OE6xYyFLW _42Yu6BC5zv _0Bm75GyFLW _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8c0187a09ac9108$export$76c223fce296f63d), null))), (0, $9wGTI.fg)('post-office_enable_cc-agents-awareness-modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bjj9l.AgentsAwarenessModalLoadable), null));
};
module.exports["collectOverview"] = $ebb5220839af7526$export$e720d1bfc39dda01;
module.exports["FeedSection"] = $ebb5220839af7526$export$5c177581408c0b49;
module.exports["AnnouncementsVisibilityFeedSection"] = $ebb5220839af7526$export$ae369b3cff36adeb;
module.exports["ForYou"] = $ebb5220839af7526$export$d6cf4bb669b36f29;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = Object.values($071869849092e495$export$d8593f7ef284bfd8);
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("dCb9P", function(module, exports) {

var $aSQ2H = parcelRequire("aSQ2H");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");

const $fa67f73cddf7e8a7$var$useUserByLicensedProductsQuery = (0, $aSQ2H.default);
const $fa67f73cddf7e8a7$export$d4bea0d69a8d983f = ({ skip: skip = false })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipConditions = skip || !isLicensed;
    const { data: licensedProductsData, loading: licensedProductsLoading, error: licensedProductsError } = (0, $jMyy4.useQueryInterop)($fa67f73cddf7e8a7$var$useUserByLicensedProductsQuery, {
        errorPolicy: 'all',
        skip: skipConditions,
        __callerPackage__: "onboarding-helpers"
    });
    if (licensedProductsLoading || licensedProductsError || skipConditions) return {
        isLandUser: false,
        isXflowUser: false,
        loading: licensedProductsLoading,
        error: licensedProductsError
    };
    const licensedProducts = licensedProductsData?.confluence_tenantContext?.licensedProducts;
    const userByLicensedProducts = $fa67f73cddf7e8a7$var$checkUserByLicensedProducts(licensedProducts);
    return {
        isLandUser: skipConditions ? false : userByLicensedProducts.isLandUser,
        isXflowUser: skipConditions ? false : userByLicensedProducts.isXflowUser,
        loading: licensedProductsLoading,
        error: licensedProductsError
    };
};
/**
 *
 * @param licensedProducts
 * @returns
 * isXflowUser - if user has any active jira product
 * isLandUser - if user has only 1 active product and it's confluence
 *
 */ function $fa67f73cddf7e8a7$var$checkUserByLicensedProducts(licensedProducts) {
    if (!licensedProducts) return {
        isXflowUser: false,
        isLandUser: false
    };
    const isXflowUser = licensedProducts.some((product)=>product.productKey.toLowerCase().includes('jira'));
    return {
        isXflowUser: isXflowUser,
        isLandUser: !isXflowUser
    };
}
module.exports["useUserByLicensedProducts"] = $fa67f73cddf7e8a7$export$d4bea0d69a8d983f;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("7c4rV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $5a7a73b748300e1f$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $5a7a73b748300e1f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $5a7a73b748300e1f$export$9bcfef244f363dbe = (0, $8s9DV.createStore)({
    initialState: $5a7a73b748300e1f$var$initialState,
    actions: $5a7a73b748300e1f$var$actions,
    name: 'atlassianAccountTraitsStore'
});
const $5a7a73b748300e1f$export$c35c4239c4894215 = (0, $kBr4q.createHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
const $5a7a73b748300e1f$export$aa4cdf7390fbf455 = (0, $kBr4q.createActionsHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
async function $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $5a7a73b748300e1f$var$hasFetched = false;
function $5a7a73b748300e1f$export$f1fbc6ad89f91b89() {
    $5a7a73b748300e1f$var$hasFetched = false;
}
function $5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.user);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.user);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $5a7a73b748300e1f$export$88411c3a679154ab({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $5a7a73b748300e1f$export$c35c4239c4894215();
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($5a7a73b748300e1f$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !userId) return;
        $5a7a73b748300e1f$var$hasFetched = true;
        storeActions.start();
        $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useAtlassianAccountTraits"] = $5a7a73b748300e1f$export$88411c3a679154ab;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = Object.values($37b72543ace58c19$export$a266d7c13575e674);
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("apWEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7959bd06e7aba5a6$export$2e2bcd8739ae039);

var $jb2R2 = parcelRequire("jb2R2");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $7959bd06e7aba5a6$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $jb2R2.default)(dateLeft, dateRight) / 7;
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("7SvHK", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bc62b679797e948$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $5bc62b679797e948$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $dkBOe.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("aDe4X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $b4VFP = parcelRequire("b4VFP");

var $dBcar = parcelRequire("dBcar");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess);
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $6Mfv2.default)(Date.now(), (0, $gkHoc.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: !hasAdminOrUseAccess || takeoverExpired,
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin);
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};
module.exports["useNthUserHomeOnboardingTakeoverV2Eligibility"] = $d12c0291e106b88f$export$de7bc1ba49cd35c5;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("30D0J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $CIjCq = parcelRequire("CIjCq");


var $7c4rV = parcelRequire("7c4rV");

const $0f856dd8e4045e89$var$mapPersonalizationResponse = (response)=>({
        experimentalUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
        }
    });
const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    const lastHandledTraitErrorRef = (0, $cozmU.useRef)(null);
    const atlassianAccountTraitsResult = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: skip || !variables.userId
    });
    (0, $cozmU.useEffect)(()=>{
        const traitError = atlassianAccountTraitsResult.error;
        if (skip || !variables.userId || !traitError || lastHandledTraitErrorRef.current === traitError) return;
        lastHandledTraitErrorRef.current = traitError;
        onError?.(traitError);
    }, [
        atlassianAccountTraitsResult.error,
        onError,
        skip,
        variables.userId
    ]);
    if (skip || !variables.userId) return {
        data: undefined,
        loading: false,
        error: undefined
    };
    return {
        data: atlassianAccountTraitsResult.data ? $0f856dd8e4045e89$var$mapPersonalizationResponse(atlassianAccountTraitsResult.data) : undefined,
        loading: atlassianAccountTraitsResult.loading,
        error: atlassianAccountTraitsResult.error ?? undefined
    };
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: timeout,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("bxcP5", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $57ed722ec78a151a$export$bdce15adff7bb212 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_FEED_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_FEED_PAGE_SEGMENT"] = $57ed722ec78a151a$export$bdce15adff7bb212;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("5x1q6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2e8856ce776f15424e7dc36cf77a623>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $407122d2fee1e831$var$_react = $407122d2fee1e831$var$_interopRequireDefault((parcelRequire("cozmU")));

var $407122d2fee1e831$var$_iconNew = $407122d2fee1e831$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $407122d2fee1e831$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WelcomeFeed".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/welcome-feed
 * Usage guidance:
 * Known uses: Intro blog feed picker on Hello
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $407122d2fee1e831$var$WelcomeFeedIcon = (props)=>/*#__PURE__*/ $407122d2fee1e831$var$_react.default.createElement($407122d2fee1e831$var$_iconNew.default, Object.assign({
        name: "WelcomeFeedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM4.5 5A1.25 1.25 0 1 1 7 5a1.25 1.25 0 0 1-2.5 0M9 5a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 9 5M6.085 8.783C6.571 9.16 7.225 9.5 8 9.5s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69C10.196 10.464 9.226 11 8 11s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$407122d2fee1e831$var$WelcomeFeedIcon.displayName = 'WelcomeFeedIcon';
var $407122d2fee1e831$var$_default = module.exports.default = $407122d2fee1e831$var$WelcomeFeedIcon;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("2U3gG", function(module, exports) {

let $21d358ba49a47ed5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21d358ba49a47ed5$var$load("c831e"),
    $21d358ba49a47ed5$var$load("7EorR"),
    $21d358ba49a47ed5$var$load("gRvAH")
]).then(()=>parcelRequire('5t5Ni'));

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        },
        __callerPackage__: "feature-discovery"
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${featureKey}-featureDiscoveryOverride`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache,
        __callerPackage__: "feature-discovery"
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<de9fe90553f5e4890bae7c7ad707e3ad>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("fEmGS", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bFdYQ = parcelRequire("bFdYQ");


var $bqzdu = parcelRequire("bqzdu");


var $aSAi6 = parcelRequire("aSAi6");


var $9xOXQ = parcelRequire("9xOXQ");


var $7M67g = parcelRequire("7M67g");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Relay builds field storage keys from the operation's *resolved* variables, so a query declaring
    // `$first: Int = 20` normalizes under `field(...,first:20)` even when the caller omits `first`.
    // Resolving the artifact's declared defaults here keeps every Relay write below on the same
    // records Relay normalized and the UI subscribes to; using the raw variables would silently
    // write to a sibling record nobody reads. See getRelayOperationVariablesWithDefaults.
    const variables = (0, $7M67g.getRelayOperationVariablesWithDefaults)(params.query, params.variables);
    // Inside a Relay-native optimistic layer (commitMutation optimisticUpdater/updater), route the
    // write onto the provided store proxy so it participates in Relay's disposable layer instead of
    // committing permanently. This upserts records (incl. connection list changes) via the store
    // proxy — the capability the in-place path lacks — so no snapshot/replay rollback is needed;
    // Relay reverts the whole layer atomically. The cache bridge is intentionally skipped here.
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (ambientStore && source === 'relay' && params.data) {
        const queryNode = params.query;
        const selections = queryNode?.operation?.selections;
        if (selections) {
            (0, $9xOXQ.writeQueryPayloadToStore)(ambientStore, // Normalization selections are a superset of the reader selections the primitive walks
            // (scalar/linked/inline-fragment/condition); matches the cast in writeQueryInteropRelay.
            selections, params.data, variables);
            return;
        }
    }
    const didWrite = source === 'relay' ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
    if (didWrite) (0, $bFdYQ.syncQueryCacheBridge)({
        source: // The bridge mirrors into the *other* cache, which applies its own document defaults, so it
        // keeps receiving the caller's variables rather than the Relay-resolved ones.
        source,
        query: params.query,
        variables: params.variables,
        data: params.data
    });
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data } = params;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for writeQueryInterop; ${params.__callerPackage__}.`);
    if (!data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $aSAi6.writeQueryFields)(root, queryFields, data, variables);
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables);
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("aSAi6", function(module, exports) {

var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 
module.exports["writeQueryFields"] = $52093bfafa102098$export$77bf2d076cc42a0e;

});

parcelRegister("9xOXQ", function(module, exports) {
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity -- bounded recursive walk of a Relay operation's reader selections, matching the sibling relayQueryWriteOperations/fragmentCacheOperations modules */ 
var $2ItkX = parcelRequire("2ItkX");

// Writes a query/mutation-response-shaped payload into a Relay store via a RecordSourceProxy,
// UPSERTING records (creating missing ones) as it goes. This is the capability the optimistic
// interop needs that `writeQueryInterop`'s in-place path lacks: it can append/remove nodes in a
// connection (a list-length change) inside a Relay optimistic layer, where `commitPayload` cannot
// run. Records with an `id` field are normalised under that id; id-less embedded records (e.g. a
// union `location`) use Relay's client ids via getOrCreateLinkedRecord.
//
// The traversal is driven by the operation's reader selections so field storage keys, aliases,
// @include/@skip, plural fields, and concrete-type inline-fragment narrowing all match how Relay
// itself reads the data back.
const $25b015eeee02787d$var$TYPENAME_KEY = '__typename';
function $25b015eeee02787d$var$isObjectRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
function $25b015eeee02787d$var$inlineFragmentApplies(record, inlineFragment) {
    const abstractKey = inlineFragment.abstractKey;
    if (abstractKey != null) return true;
    // Concrete narrowing: only descend when the payload's __typename matches. When the payload has
    // no __typename we descend so we never drop fields the caller intended to write.
    const typename = record?.[$25b015eeee02787d$var$TYPENAME_KEY];
    return typename == null ? true : typename === inlineFragment.type;
}
// Compute the normalized dataID the way this environment stores id-bearing records: `Type:id`
// (matching the interop's fragmentCacheOperations convention and the store's actual keys, e.g.
// `Comment:123`, `ConfluenceContentModified:456`). Using the raw id here would miss the canonical
// record on store.get and create an orphan duplicate that collides with other writes for the same id.
function $25b015eeee02787d$var$dataIdFromValue(value, typeName) {
    const id = value.id;
    if (typeof id !== 'string' && typeof id !== 'number') return null;
    const idString = String(id);
    return idString.startsWith(`${typeName}:`) ? idString : `${typeName}:${idString}`;
}
function $25b015eeee02787d$var$resolveTypeName(value, linkedField) {
    const typename = value[$25b015eeee02787d$var$TYPENAME_KEY];
    if (typeof typename === 'string') return typename;
    // ReaderLinkedField carries the concrete type for non-abstract fields.
    return linkedField.concreteType ?? 'ClientRecord';
}
// Get or create the singular child record for a linked field. Id-bearing children are normalised
// under their id; id-less embedded children get a stable Relay client id from the parent.
function $25b015eeee02787d$var$getOrCreateSingularChild(store, parent, linkedField, value, fieldKey) {
    const typeName = $25b015eeee02787d$var$resolveTypeName(value, linkedField);
    const id = $25b015eeee02787d$var$dataIdFromValue(value, typeName);
    if (id != null) return store.get(id) ?? store.create(id, typeName);
    return parent.getOrCreateLinkedRecord(fieldKey, typeName);
}
function $25b015eeee02787d$var$getOrCreatePluralChild(store, parent, linkedField, value, fieldKey, index) {
    const typeName = $25b015eeee02787d$var$resolveTypeName(value, linkedField);
    const id = $25b015eeee02787d$var$dataIdFromValue(value, typeName);
    if (id != null) return store.get(id) ?? store.create(id, typeName);
    // Stable client id per index for id-less plural items so re-writes reuse the same record.
    const clientId = `${parent.getDataID()}:${fieldKey}:${index}`;
    return store.get(clientId) ?? store.create(clientId, typeName);
}
function $25b015eeee02787d$var$writeSelections(store, record, selections, data, variables) {
    for (const field of selections){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) $25b015eeee02787d$var$writeSelections(store, record, field.selections, data, variables);
            continue;
        }
        if (field.kind === 'InlineFragment') {
            const inlineFragment = field;
            if ($25b015eeee02787d$var$inlineFragmentApplies(data, inlineFragment)) $25b015eeee02787d$var$writeSelections(store, record, inlineFragment.selections, data, variables);
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            record.setValue(data[responseKey], (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (fieldData == null) {
                if (linkedField.plural) record.setLinkedRecords(null, fieldKey);
                else record.setLinkedRecord(null, fieldKey);
                continue;
            }
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                const children = fieldData.map((item, index)=>{
                    if (item == null) return null;
                    if (!$25b015eeee02787d$var$isObjectRecord(item)) return null;
                    const pluralChild = $25b015eeee02787d$var$getOrCreatePluralChild(store, record, linkedField, item, fieldKey, index);
                    $25b015eeee02787d$var$writeSelections(store, pluralChild, linkedField.selections, item, variables);
                    return pluralChild;
                });
                record.setLinkedRecords(children, fieldKey);
                continue;
            }
            if (!$25b015eeee02787d$var$isObjectRecord(fieldData)) continue;
            const child = $25b015eeee02787d$var$getOrCreateSingularChild(store, record, linkedField, fieldData, fieldKey);
            $25b015eeee02787d$var$writeSelections(store, child, linkedField.selections, fieldData, variables);
            record.setLinkedRecord(child, fieldKey);
        }
    }
}
function $25b015eeee02787d$export$26fe3b45bb24fd81(store, selections, data, variables = {}) {
    $25b015eeee02787d$var$writeSelections(store, store.getRoot(), selections, data, variables);
}
module.exports["writeQueryPayloadToStore"] = $25b015eeee02787d$export$26fe3b45bb24fd81;

});

parcelRegister("l1uFv", function(module, exports) {

var $jWnFe = parcelRequire("jWnFe");


var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

const $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
function $65c7b8940c778902$var$cloneRelayQueryResult(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jWnFe)))(data, (value, key)=>{
        // Relay fragment refs can contain operation descriptors and client-edge reader nodes.
        // Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
        if (key === (0, $eqEJl.FRAGMENT_OWNER_KEY) || key === $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY) return value;
        return undefined;
    });
}
function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : $65c7b8940c778902$var$cloneRelayQueryResult(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("jWnFe", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $e845ca4b0059397d$var$CLONE_DEEP_FLAG = 1, $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $e845ca4b0059397d$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $hGc5T(value, $e845ca4b0059397d$var$CLONE_DEEP_FLAG | $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG, customizer);
}
module.exports = $e845ca4b0059397d$var$cloneDeepWith;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("fgRQY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $40c43516853cc93d$export$951d3821f04440e9 = (elementRef, onSeen, t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const threshold = t0 === undefined ? 1 : t0;
    const observerRef = (0, $cozmU.useRef)();
    const hasIntersected = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== elementRef || $[1] !== onSeen || $[2] !== threshold) {
        t1 = ()=>{
            const disconnectObserver = ()=>{
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = undefined;
                }
            };
            const handleIntersect = (entries)=>{
                if (!hasIntersected.current && entries[0].isIntersecting) {
                    onSeen();
                    hasIntersected.current = true;
                    disconnectObserver();
                }
            };
            observerRef.current = new IntersectionObserver(handleIntersect, {
                threshold: threshold
            });
            if (elementRef.current) observerRef.current.observe(elementRef.current);
            return disconnectObserver;
        };
        t2 = [
            onSeen,
            elementRef,
            threshold
        ];
        $[0] = elementRef;
        $[1] = onSeen;
        $[2] = threshold;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useElementSeenCallback"] = $40c43516853cc93d$export$951d3821f04440e9;

});

parcelRegister("j0RU5", function(module, exports) {
const $4417c16353652d2d$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4417c16353652d2d$var$isExpectedGraphqlError);
    return false;
};
const $4417c16353652d2d$var$isExpectedGraphqlError = (error)=>{
    return $4417c16353652d2d$export$96764ac307b61f82(error) || $4417c16353652d2d$export$76be013bd4365c41(error) || $4417c16353652d2d$export$d03792e4e1b785d4(error);
};
const $4417c16353652d2d$var$feedConfigSpacesPath = [
    'getFeedUserConfig',
    'spaces'
];
const $4417c16353652d2d$export$d03792e4e1b785d4 = (error)=>{
    return $4417c16353652d2d$var$feedConfigSpacesPath.every((path)=>error.path?.includes(path)) && error.message?.includes('Cannot find space with id:');
};
const $4417c16353652d2d$export$96764ac307b61f82 = (error)=>{
    return $4417c16353652d2d$var$feedConfigSpacesPath.every((path)=>error.path?.includes(path)) && error.message?.includes('Not permitted to view space with id:');
};
const $4417c16353652d2d$var$feedConfigUsersPath = [
    'getFeedUserConfig',
    'users'
];
const $4417c16353652d2d$export$76be013bd4365c41 = (error)=>{
    return $4417c16353652d2d$var$feedConfigUsersPath.every((path)=>error.path?.includes(path)) && error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4417c16353652d2d$export$288e4801a340fb3c;
module.exports["isFeedConfigSpacePermissionError"] = $4417c16353652d2d$export$96764ac307b61f82;
module.exports["isFeedConfigUserPermissionError"] = $4417c16353652d2d$export$76be013bd4365c41;
module.exports["isFeedConfigDeletedSpaceError"] = $4417c16353652d2d$export$d03792e4e1b785d4;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $iITVA = parcelRequire("iITVA");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_30huDKdnbC _3YEZNOdnbC _0KLXruGsB2",
    loaded: "_0KLXrujOvk"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_0bjKvDKxmn _39xV02SPN1 _0jFU0VSPN1",
    small: "_0bjKvDcjp5 _39xV02oWWg _0jFU0VoWWg",
    medium: "_0bjKvDzXzM _39xV02Uofl _0jFU0VUofl",
    large: "_0bjKvDzXzM _39xV02UF4f _0jFU0VUF4f",
    xlarge: "_0bjKvDKTcp _39xV02JgOI _0jFU0VJgOI"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $hekY6.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    const setLoaded = (0, $cozmU.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("fs6LW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $arQY7 = parcelRequire("arQY7");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $buxP3.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $buxP3.xcss)({
        display: 'flex'
    }),
    cursor: (0, $buxP3.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $kSwu1.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $cozmU.useRef)(null);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $cozmU.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $cozmU.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]);
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $w6R6I.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_0jFU0VN91d _39xV02N91d"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("l8oxh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $cozmU.useRef)(null);
    const previousCursor = (0, $cozmU.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $cozmU.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $cozmU.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $cozmU.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "comments-hooks"
    });
    const data = queryResult.data;
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ // oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("hkYAW"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("hkYAW"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $b3Wpp = parcelRequire("b3Wpp");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b35Wv = parcelRequire("b35Wv");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        ...t3,
        __callerPackage__: "reactions"
    });
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0wOv4QsJSq _313842FQfX _1DCdHiFQfX _2XsHFMdnbC"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $hekY6.default)([
                    "_2uo31faVjy _0bjKvDS5Zs _39xV02xpxF _0jFU0VxpxF _2XsHFMgVvo"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $hekY6.default)([
            "_2uo31faVjy _0bjKvDS5Zs _39xV02hzUg _0jFU0VoWWg _0adFHs1Y8M"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<1d6855ec0a749a41169ad18fea189d4c>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $iKpb2 = parcelRequire("iKpb2");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_0KLXruGsB2",
    wrapperStyles: "_2Zuz6Q2ADO _1Znuxb8HPE _313842Ll21",
    countSkeletonStyles: "_0bjKvDS5Zs _39xV02uFDC _0jFU0VuFDC _0KLXruGsB2"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("hkYAW", function(module, exports) {

let $c9f34ece6ba76655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c9f34ece6ba76655$var$load("7BHAC"),
    $c9f34ece6ba76655$var$load("N3TvS"),
    $c9f34ece6ba76655$var$load("8lMr1"),
    $c9f34ece6ba76655$var$load("1vUE6"),
    $c9f34ece6ba76655$var$load("h0X0x"),
    $c9f34ece6ba76655$var$load("7l4Nc"),
    $c9f34ece6ba76655$var$load("7g00Y"),
    $c9f34ece6ba76655$var$load("30b92"),
    $c9f34ece6ba76655$var$load("6wr18"),
    $c9f34ece6ba76655$var$load("59hV4"),
    $c9f34ece6ba76655$var$load("keazL"),
    $c9f34ece6ba76655$var$load("dhXIT"),
    $c9f34ece6ba76655$var$load("6TLS9"),
    $c9f34ece6ba76655$var$load("ea3NB"),
    $c9f34ece6ba76655$var$load("fuOfV"),
    $c9f34ece6ba76655$var$load("jL1Ke"),
    $c9f34ece6ba76655$var$load("5MQ0D"),
    $c9f34ece6ba76655$var$load("ffEVr"),
    $c9f34ece6ba76655$var$load("5gsbh"),
    $c9f34ece6ba76655$var$load("h4Nf7"),
    $c9f34ece6ba76655$var$load("Wowvf"),
    $c9f34ece6ba76655$var$load("4g6rd"),
    $c9f34ece6ba76655$var$load("ayJxT"),
    $c9f34ece6ba76655$var$load("hhss7"),
    $c9f34ece6ba76655$var$load("43z9c"),
    $c9f34ece6ba76655$var$load("7EorR"),
    $c9f34ece6ba76655$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("cJWDj"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("cJWDj", function(module, exports) {

let $94672b4b116d1a7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $94672b4b116d1a7d$var$load("7BHAC"),
    $94672b4b116d1a7d$var$load("N3TvS"),
    $94672b4b116d1a7d$var$load("h0X0x"),
    $94672b4b116d1a7d$var$load("7l4Nc"),
    $94672b4b116d1a7d$var$load("7A87G"),
    $94672b4b116d1a7d$var$load("6wr18"),
    $94672b4b116d1a7d$var$load("ffEVr"),
    $94672b4b116d1a7d$var$load("4Ldt2"),
    $94672b4b116d1a7d$var$load("5gsbh"),
    $94672b4b116d1a7d$var$load("8lMr1"),
    $94672b4b116d1a7d$var$load("1vUE6"),
    $94672b4b116d1a7d$var$load("8OeKT"),
    $94672b4b116d1a7d$var$load("ayJxT"),
    $94672b4b116d1a7d$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fa619d4dc0abdbd4993ef2902e26740>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_iconNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_iconNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("7uUnJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1f248bc2c3d9f18f$export$ef69bde44521bba7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q9h_Y",
    name: "LiveDocsIconTile",
    loader: async ()=>(await (parcelRequire("l5GVA"))).LiveDocsIconTile
});
module.exports["LiveDocsIconTile"] = $1f248bc2c3d9f18f$export$ef69bde44521bba7;

});

parcelRegister("l5GVA", function(module, exports) {

let $f5ab5d272f1b92ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f5ab5d272f1b92ce$var$load("h0X0x"),
    $f5ab5d272f1b92ce$var$load("7l4Nc"),
    $f5ab5d272f1b92ce$var$load("fuOfV"),
    $f5ab5d272f1b92ce$var$load("jL1Ke"),
    $f5ab5d272f1b92ce$var$load("e19Zv")
]).then(()=>parcelRequire('nSMSQ'));

});

parcelRegister("bvJMy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6Cex3 = parcelRequire("6Cex3");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $82c992371ed08bb5$export$fd017b91d8968d63 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { label: label, size: size, testId: testId, spacing: spacing } = t0;
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const primaryColor = theme.colorMode === "dark" ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    let t1;
    if ($[0] !== size) {
        t1 = size && {
            size: size
        };
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== testId) {
        t2 = testId && {
            testId: testId
        };
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== label || $[5] !== primaryColor || $[6] !== spacing || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
            label: label,
            color: primaryColor,
            ...t1,
            ...t2,
            spacing: spacing
        });
        $[4] = label;
        $[5] = primaryColor;
        $[6] = spacing;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ label: label, size: size, testId: testId, spacing: spacing })=>{
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const primaryColor = (0, $cozmU.useMemo)(()=>{
        return theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    }, [
        theme.colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        label: label,
        color: primaryColor,
        ...size && {
            size: size
        },
        ...testId && {
            testId: testId
        },
        spacing: spacing
    });
};
module.exports["StarSelectedIcon"] = $82c992371ed08bb5$export$fd017b91d8968d63;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("4krqA", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $f7B1p = parcelRequire("f7B1p");

const $205c154f2fef63b0$export$ab2f49a861856bab = '/gateway/api';
const $205c154f2fef63b0$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
function $205c154f2fef63b0$var$handleCapabilitiesResponse(response) {
    const directInvite = new Set();
    const invitePendingApproval = new Set();
    if (Array.isArray(response)) response.forEach((entry)=>{
        if (!directInvite.has(entry.resourceARI) && 'NONE' !== entry.directInvite.mode) directInvite.add(entry.resourceARI);
        if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
    });
    return {
        directInvite: [
            ...directInvite
        ],
        invitePendingApproval: [
            ...invitePendingApproval
        ]
    };
}
// This closely follows the implementation of the client from the Invite People package
// platform/packages/people-and-teams/invite-people/src/clients/InviteApiClient.ts
// This logic is subject to change at any time and should only be used for experimental purposes
const $205c154f2fef63b0$var$getInvitePermissions = async (cloudId)=>{
    const resource = `ari:cloud:platform::site/${cloudId}`;
    try {
        const response = await (0, $f7B1p.cfetch)(`${$205c154f2fef63b0$export$ab2f49a861856bab}${$205c154f2fef63b0$export$df4d1d71f09676b7}?resource=${resource}`);
        const inviteResponse = await response.json();
        return $205c154f2fef63b0$var$handleCapabilitiesResponse(inviteResponse);
    } catch (error) {
        return error;
    }
};
const $205c154f2fef63b0$export$669226fe425132b5 = (0, $dOBRD.default)($205c154f2fef63b0$var$getInvitePermissions);
module.exports["memoizedGetInvitePermissions"] = $205c154f2fef63b0$export$669226fe425132b5;

});

parcelRegister("cg30H", function(module, exports) {
/**
 * A thin hook that reads the `confluence_cloud_site_has_over_10_enabled_users` TAP site trait
 * and returns a boolean indicating whether the site has more than 10 enabled users.
 *
 * The trait value is a boolean string:
 *   "true"  → site has >10 enabled users
 *   "false" → site has ≤10 enabled users
 *
 * This is SSR-compatible: `useSiteTraits()` reads from `window.__SSR_TAP_CONTEXT__` when available,
 * so there is no client-side flash on initial load.
 */ 
var $kOUwv = parcelRequire("kOUwv");

const $f7cb6b1073657758$export$a0ce94feb7bb36f9 = 'confluence_cloud_site_has_over_10_enabled_users';
function $f7cb6b1073657758$export$722db84a79bb844e({ skipBootstrap: skipBootstrap } = {}) {
    const { data: data, loading: loading, error: error } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skipBootstrap
    });
    const traitValue = data?.attributes?.find((attr)=>attr.name === $f7cb6b1073657758$export$a0ce94feb7bb36f9)?.value;
    const isOverTenEU = traitValue !== undefined ? traitValue === 'true' : null;
    return {
        isOverTenEU: isOverTenEU,
        loading: loading,
        error: error
    };
}
module.exports["useIsOverTenEnabledUsers"] = $f7cb6b1073657758$export$722db84a79bb844e;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("7EIq6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dd33Q = parcelRequire("dd33Q");


var $9Pmcg = parcelRequire("9Pmcg");


var $6SsN4 = parcelRequire("6SsN4");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$spaceEnabledContentTypesFragment = (0, $9Pmcg.default);
function $649b778bbd82b1bb$export$67a7293b6dfe9c76(spaceFragmentRef) {
    const $ = (0, $bDgLe.c)(2);
    const space = (0, $6SsN4.useFragment)($649b778bbd82b1bb$var$spaceEnabledContentTypesFragment, spaceFragmentRef);
    const t0 = space.spaceTypeSettings?.enabledContentTypes;
    let t1;
    if ($[0] !== t0) {
        t1 = $649b778bbd82b1bb$var$getEnabledContentTypes(t0, false);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    return $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, isDefaultSpaceKeyLoading || isAnyContentTypesLoading);
}
function $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, loading) {
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = loading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypesFragment"] = $649b778bbd82b1bb$export$67a7293b6dfe9c76;
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "b239b4c898f62763088962d6011df617";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("9Pmcg", function(module, exports) {
/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1a2866ab6e1d474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypes_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isBlogsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDatabasesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEmbedsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLivePagesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSlidesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWhiteboardsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFoldersEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$e1a2866ab6e1d474$var$node.hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";
var $e1a2866ab6e1d474$export$2e2bcd8739ae039 = $e1a2866ab6e1d474$var$node;
module.exports["default"] = $e1a2866ab6e1d474$export$2e2bcd8739ae039;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined,
    onSubmitCallback: undefined,
    editorInsertionAcknowledgement: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, onSubmitCallback: onSubmitCallback, editorInsertionAcknowledgement: editorInsertionAcknowledgement, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined,
                onSubmitCallback: onSubmitCallback ?? undefined,
                editorInsertionAcknowledgement: editorInsertionAcknowledgement ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined,
                onSubmitCallback: undefined,
                editorInsertionAcknowledgement: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("82duu", function(module, exports) {

var $fZVBk = parcelRequire("fZVBk");


var $dO7mL = parcelRequire("dO7mL");


var $75pPj = parcelRequire("75pPj");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");





var $1TsWe = parcelRequire("1TsWe");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");

// Defined at module scope so the same GraphQL tagged node can be reused both for the
// initial useQueryInterop fetch and for refetchQueries on the createPersonalSpace mutation.
// (Relay disallows defining the same named query twice, so we must share one node.)
const $26216eef1f989057$var$personalSpaceKeyQuery = (0, $75pPj.default);
const $26216eef1f989057$var$isPersonalSpaceExistsError = (error)=>/A personal space already exists for this user/.test(error?.message);
var $26216eef1f989057$export$7aefc512332241b2 = /*#__PURE__*/ function(CreationSource) {
    CreationSource["NTH_USER_ACCOUNT_SETUP"] = "nthUserAccountSetup";
    CreationSource["ADMIN_ACCOUNT_SETUP"] = "adminAccountSetup";
    CreationSource["ADMIN_STO_V2"] = "adminStoV2AccountSetup";
    return CreationSource;
}({});
const $26216eef1f989057$export$9f41a1d789fd2ac8 = ({ source: source, hasPublicSpace: hasPublicSpace, isFoundingAdmin: isFoundingAdmin })=>{
    const { userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: nameData, loading: nameLoading, error: nameError } = (0, $jMyy4.useQueryInterop)((0, $dO7mL.default), {
        variables: {
            accountId: userId || ''
        },
        skip: !isLicensed || !isLoggedIn,
        __callerPackage__: "onboarding-helpers"
    });
    const { data: personalSpaceKeyData, loading: personalSpaceKeyLoading, error: personalSpaceKeyError } = (0, $jMyy4.useQueryInterop)($26216eef1f989057$var$personalSpaceKeyQuery, {
        skip: !isLoggedIn,
        __callerPackage__: "onboarding-helpers"
    });
    const [createPersonalSpaceMutation, { loading: createPersonalSpaceLoading, error: createPersonalSpaceError, data: personalSpaceData, called: createPersonalSpaceCalled }] = (0, $308Wd.useMutationInterop)((0, $fZVBk.default), {
        // After a successful mutation, fire-and-forget a re-fetch of the personal space
        // key query so the Apollo/Relay cache is warm for any subsequent consumer
        // (e.g. home page components that mount shortly after the onboarding redirect).
        // We intentionally do NOT set awaitRefetchQueries here: the primary fix for the
        // landing-destination timing bug is in NthUserOnboarding.tsx, which now reads
        // the key directly from the mutation result rather than from this cached query.
        // We pass the shared GraphQL tagged node (not a string query name): the Relay
        // variant of useMutationInterop rejects string refetchQueries entries at runtime.
        // Experiment: cc_ce_onboarding_personal_space_key_refetch
        ...(0, $6mKj3.expValEquals)('cc_ce_onboarding_personal_space_key_refetch', 'isEnabled', true) ? {
            refetchQueries: [
                {
                    query: $26216eef1f989057$var$personalSpaceKeyQuery
                }
            ]
        } : {},
        onCompleted: ()=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'created',
                    actionSubject: 'personalSpace',
                    source: source
                }
            }).fire();
        },
        onError: (err)=>{
            if ($26216eef1f989057$var$isPersonalSpaceExistsError(err) && !(0, $7Sm4c.isErrorMarkedAsHandled)(err)) {
                (0, $7Sm4c.markErrorAsHandled)(err);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'duplicated',
                        actionSubject: 'personalSpaceAttempt',
                        source: source,
                        attributes: {
                            error: err?.message,
                            hasPublicSpace: hasPublicSpace,
                            isFoundingAdmin: isFoundingAdmin,
                            personalSpaceKeyData: JSON.stringify(personalSpaceKeyData),
                            personalSpaceKey: personalSpaceKeyData?.user?.confluence?.space?.key
                        }
                    }
                }).fire();
                return;
            }
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'personalSpace',
                    source: source,
                    attributes: {
                        error: err?.message
                    }
                }
            }).fire();
            (0, $7Sm4c.markErrorAsHandled)(err);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const confluenceUser = nameData?.confluenceUsers?.nodes?.[0];
    const publicName = confluenceUser?.__typename === 'KnownUser' ? confluenceUser.publicName : undefined;
    const createPersonalSpace = (0, $cozmU.useCallback)(()=>{
        if (publicName) return createPersonalSpaceMutation({
            variables: {
                name: publicName,
                initialPermissionOption: (0, $1TsWe.InitialPermissionOptions).DEFAULT,
                copySpacePermissionsFromSpaceKey: undefined
            }
        });
        return Promise.resolve();
    }, [
        publicName,
        createPersonalSpaceMutation
    ]);
    return {
        createPersonalSpace: createPersonalSpace,
        queryLoading: nameLoading || personalSpaceKeyLoading,
        mutationLoading: createPersonalSpaceLoading,
        error: nameError || createPersonalSpaceError,
        personalSpaceData: personalSpaceData,
        createPersonalSpaceCalled: createPersonalSpaceCalled,
        personalSpaceKeyData: personalSpaceKeyData,
        personalSpaceKeyLoading: personalSpaceKeyLoading,
        personalSpaceKeyError: personalSpaceKeyError
    };
};
module.exports["CreationSource"] = $26216eef1f989057$export$7aefc512332241b2;
module.exports["useCreatePersonalSpace"] = $26216eef1f989057$export$9f41a1d789fd2ac8;

});

parcelRegister("fZVBk", function(module, exports) {
/**
 * @generated SignedSource<<c14e87c6a5c8d064e6865c1808c6572b>>
 * @relayHash 98ac0db350bb8c8dd9706e193c50dad9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5aae8cdb77fefc33d2854b7ff3153441b2a076543f6f377bf8d6bda4d945c5ac
const $a21c5d5516b3156a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "copySpacePermissionsFromSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialPermissionOption"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "copySpacePermissionsFromSpaceKey",
                            "variableName": "copySpacePermissionsFromSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "initialPermissionOption",
                            "variableName": "initialPermissionOption"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceName",
                            "variableName": "name"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "createPersonalSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "98ac0db350bb8c8dd9706e193c50dad9",
            "id": "5aae8cdb77fefc33d2854b7ff3153441b2a076543f6f377bf8d6bda4d945c5ac",
            "metadata": {},
            "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation($name:String!,$initialPermissionOption:InitialPermissionOptions,$copySpacePermissionsFromSpaceKey:String){createPersonalSpace(input:{spaceName:$name,initialPermissionOption:$initialPermissionOption,copySpacePermissionsFromSpaceKey:$copySpacePermissionsFromSpaceKey}){id,key,name,icon{path},homepageId}}"
        }
    };
}();
$a21c5d5516b3156a$var$node.hash = "f5230085dddd4a6aaddfaffc37105490";
var $a21c5d5516b3156a$export$2e2bcd8739ae039 = $a21c5d5516b3156a$var$node;
module.exports["default"] = $a21c5d5516b3156a$export$2e2bcd8739ae039;

});

parcelRegister("dO7mL", function(module, exports) {
/**
 * @generated SignedSource<<373c332ca5a43d7a2d16ee7cec3cbda6>>
 * @relayHash 14e5a988e61fa67579bfc9b50b93870d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e58823bd142c5ef352c216e453ac1dff672a243ee6303171aa797a69ff103ee
const $63b6b01c25967477$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "accountIds.0",
                            "variableName": "accountId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "accountIds"
                }
            ],
            "concreteType": "PaginatedPersonList",
            "kind": "LinkedField",
            "name": "confluenceUsers",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                }
                            ],
                            "type": "KnownUser"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreatePersonalSpaceGetPublicNameQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreatePersonalSpaceGetPublicNameQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "14e5a988e61fa67579bfc9b50b93870d",
            "id": "0e58823bd142c5ef352c216e453ac1dff672a243ee6303171aa797a69ff103ee",
            "metadata": {},
            "name": "useCreatePersonalSpaceGetPublicNameQuery",
            "operationKind": "query",
            "text": "query useCreatePersonalSpaceGetPublicNameQuery($accountId:String!){confluenceUsers(accountIds:[$accountId]){nodes{__typename,...on KnownUser{__typename,publicName}}}}"
        }
    };
}();
$63b6b01c25967477$var$node.hash = "6eaa36d7e7d2eafc735855845cb44bed";
var $63b6b01c25967477$export$2e2bcd8739ae039 = $63b6b01c25967477$var$node;
module.exports["default"] = $63b6b01c25967477$export$2e2bcd8739ae039;

});

parcelRegister("75pPj", function(module, exports) {
/**
 * @generated SignedSource<<99b74515756f5969c81db13e93f89929>>
 * @relayHash d7779a130b8ee8e7f4bf2c9cc74026a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fa3c8a61564b090daf303b68254b63c6a12c72ad6f5419ac85a3d67d637cccc
const $2cdd1ff7e1a1e501$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCreatePersonalSpacepersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCreatePersonalSpacepersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d7779a130b8ee8e7f4bf2c9cc74026a8",
            "id": "4fa3c8a61564b090daf303b68254b63c6a12c72ad6f5419ac85a3d67d637cccc",
            "metadata": {},
            "name": "useCreatePersonalSpacepersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useCreatePersonalSpacepersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$2cdd1ff7e1a1e501$var$node.hash = "577d75cb353f98a77b430fa0a7b68deb";
var $2cdd1ff7e1a1e501$export$2e2bcd8739ae039 = $2cdd1ff7e1a1e501$var$node;
module.exports["default"] = $2cdd1ff7e1a1e501$export$2e2bcd8739ae039;

});

parcelRegister("1TsWe", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $b640935c21ba3409$export$2f1aab60b03054b9 = /*#__PURE__*/ function(InitialPermissionOptions) {
    InitialPermissionOptions["COPY_FROM_SPACE"] = "COPY_FROM_SPACE";
    InitialPermissionOptions["DEFAULT"] = "DEFAULT";
    InitialPermissionOptions["PRIVATE"] = "PRIVATE";
    return InitialPermissionOptions;
}({});
module.exports["InitialPermissionOptions"] = $b640935c21ba3409$export$2f1aab60b03054b9;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    showCreateWithRovo: (0, $hQnHK.SHOW_CREATE_WITH_ROVO_QUERY_PARAM),
    journeyId: 'journeyId',
    rovoAgentId: 'rovoAgentId',
    templateKey: 'templateKey',
    templateId: 'templateId',
    onboardingEntryPoint: 'onboardingEntryPoint',
    cwrWelcome: 'cwrWelcome'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('showCreateWithRovo' in options && options.showCreateWithRovo !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.showCreateWithRovo] = options.showCreateWithRovo;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('rovoAgentId' in options && options.rovoAgentId) queryParams[$e7afa99020494478$var$queryParamKeys.rovoAgentId] = options.rovoAgentId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    if ('templateId' in options && options.templateId) queryParams[$e7afa99020494478$var$queryParamKeys.templateId] = options.templateId;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) return contentType;
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const rovoAgentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.rovoAgentId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const cwrWelcome = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cwrWelcome);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const showCreateWithRovoParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.showCreateWithRovo);
    const showCreateWithRovo = showCreateWithRovoParam ? showCreateWithRovoParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    const templateId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateId);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        showCreateWithRovo: showCreateWithRovo,
        journeyId: journeyId,
        rovoAgentId: rovoAgentId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey,
        templateId: templateId,
        cwrWelcome: cwrWelcome
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("76C68", function(module, exports) {

let $52c6a561ce9437b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $52c6a561ce9437b3$var$load("7g00Y"),
    $52c6a561ce9437b3$var$load("6wr18"),
    $52c6a561ce9437b3$var$load("4YkJj"),
    $52c6a561ce9437b3$var$load("Wowvf"),
    $52c6a561ce9437b3$var$load("dxcsb"),
    $52c6a561ce9437b3$var$load("4flC1"),
    $52c6a561ce9437b3$var$load("fDXJE"),
    $52c6a561ce9437b3$var$load("lrpUd"),
    $52c6a561ce9437b3$var$load("4LY4N"),
    $52c6a561ce9437b3$var$load("ffEVr"),
    $52c6a561ce9437b3$var$load("75rxG")
]).then(()=>parcelRequire('kIUcT'));

});

parcelRegister("4styE", function(module, exports) {
/**
 * @generated SignedSource<<9c7dc573a7fcaa6202100cfff82de616>>
 * @relayHash 0aa2cd372d50977766be55729cd7417e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a652340b68ed0805e1873b59a6383d4bb2ad5ac253f84f74d38978500eaad64
const $b0eaa91389ac865b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeEnd"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeStart"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudIds",
            "variableName": "cloudIds"
        }
    ], v6 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "pricingType"
    }, v9 = {
        "concreteType": "CcpOffering",
        "kind": "LinkedField",
        "name": "offering",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v10 = {
        "concreteType": "CcpEntitlement",
        "kind": "LinkedField",
        "name": "entitlement",
        "plural": false,
        "selections": [
            v9 /*: any*/ 
        ]
    }, v11 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "jira-software.ondemand"
        }
    ], v12 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v13 = {
        "args": v12 /*: any*/ ,
        "concreteType": "LoomSettings",
        "kind": "LinkedField",
        "name": "loom_settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "meetingRecordingsAvailable"
            }
        ]
    }, v14 = {
        "args": v12 /*: any*/ ,
        "concreteType": "LoomConnectedCalendar",
        "kind": "LinkedField",
        "name": "loom_connectedCalendars",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "guid"
            }
        ]
    }, v15 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": "DESC"
        },
        {
            "kind": "Variable",
            "name": "rangeEnd",
            "variableName": "rangeEnd"
        },
        {
            "kind": "Variable",
            "name": "rangeStart",
            "variableName": "rangeStart"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteAri"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "title"
    }, v18 = {
        "kind": "ScalarField",
        "name": "startsAt"
    }, v19 = {
        "kind": "ScalarField",
        "name": "recorderId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v23 = [
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "inviteeAris"
    }, v25 = {
        "concreteType": "LoomVideo",
        "kind": "LinkedField",
        "name": "video",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "isMeeting"
            },
            {
                "kind": "ScalarField",
                "name": "meetingAri"
            },
            {
                "kind": "ScalarField",
                "name": "shortSummary"
            }
        ]
    }, v26 = {
        "concreteType": "LoomMeetingOneClickAction",
        "kind": "LinkedField",
        "name": "oneClickActions",
        "plural": true,
        "selections": [
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "action"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "confluenceContentType"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "timestampSeconds"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "recurring"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v29 = {
        "concreteType": "CcpOffering",
        "kind": "LinkedField",
        "name": "offering",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v30 = {
        "concreteType": "CcpEntitlement",
        "kind": "LinkedField",
        "name": "entitlement",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v31 = [
        v28 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useMeetingsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        },
                        {
                            "alias": "jiraEntitlementInfo",
                            "args": v11 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v10 /*: any*/ 
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "LoomMeetingConnection",
                    "kind": "LinkedField",
                    "name": "loom_recordedMeetings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LoomMeetingEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "LoomMeeting",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "recorder",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "invitees",
                                            "plural": true,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useMeetingsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v30 /*: any*/ 
                                                    ]
                                                },
                                                v29 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        },
                        {
                            "alias": "jiraEntitlementInfo",
                            "args": v11 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v30 /*: any*/ 
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "LoomMeetingConnection",
                    "kind": "LinkedField",
                    "name": "loom_recordedMeetings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LoomMeetingEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "LoomMeeting",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "recorder",
                                            "plural": false,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "invitees",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0aa2cd372d50977766be55729cd7417e",
            "id": "3a652340b68ed0805e1873b59a6383d4bb2ad5ac253f84f74d38978500eaad64",
            "metadata": {},
            "name": "useMeetingsQuery",
            "operationKind": "query",
            "text": "query useMeetingsQuery($cloudId:ID!,$cloudIds:[ID!]!,$siteAri:ID!,$rangeStart:String,$rangeEnd:String){tenantContexts(cloudIds:$cloudIds){confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipType,entitlement{offering{pricingType,id},id}},offering{pricingType,id},id}}},jiraEntitlementInfo:entitlementInfo(hamsProductKey:\"jira-software.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{offering{pricingType,id},id}}}},loom_settings(siteId:$cloudId){meetingRecordingsAvailable},loom_connectedCalendars(siteId:$cloudId){guid},loom_recordedMeetings(siteId:$siteAri,rangeStart:$rangeStart,rangeEnd:$rangeEnd,order:DESC){edges{node{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri,shortSummary},oneClickActions{id,action,type,confluenceContentType,status,timestampSeconds},recurring}}}}"
        }
    };
}();
$b0eaa91389ac865b$var$node.hash = "f7f434f94f9e4ebc90a3406cdad23741";
var $b0eaa91389ac865b$export$2e2bcd8739ae039 = $b0eaa91389ac865b$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $6a5d9fe3938507ad$var$DAY_MS = 86400000;
/** Returns the local midnight (start of day) for a given timestamp. */ const $6a5d9fe3938507ad$var$startOfDay = (d)=>new Date(d.getFullYear(), d.getMonth(), d.getDate());
const $6a5d9fe3938507ad$export$89742084765bfc42 = (startsAt, now = new Date())=>{
    const start = $6a5d9fe3938507ad$var$startOfDay(new Date(startsAt)).getTime();
    const today = $6a5d9fe3938507ad$var$startOfDay(now).getTime();
    const diffDays = Math.round((today - start) / $6a5d9fe3938507ad$var$DAY_MS);
    if (diffDays <= 0) return 'today';
    if (diffDays === 1) return 'yesterday';
    if (diffDays <= 6) return 'thisWeek';
    return 'earlier';
};
const $6a5d9fe3938507ad$var$GROUP_ORDER = [
    'today',
    'yesterday',
    'thisWeek',
    'earlier'
];
const $6a5d9fe3938507ad$export$cb1886553760624b = (meetings, now = new Date())=>{
    const buckets = new Map();
    for (const meeting of meetings){
        const key = $6a5d9fe3938507ad$export$89742084765bfc42(meeting.startsAt, now);
        const existing = buckets.get(key);
        if (existing) existing.push(meeting);
        else buckets.set(key, [
            meeting
        ]);
    }
    return $6a5d9fe3938507ad$var$GROUP_ORDER.filter((key)=>buckets.has(key)).map((key)=>({
            key: key,
            meetings: buckets.get(key).slice().sort((a, b)=>new Date(b.startsAt).getTime() - new Date(a.startsAt).getTime())
        }));
};



var $f7B1p = parcelRequire("f7B1p");

const $595fa67a6de3b558$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $595fa67a6de3b558$export$e36fc9e5c75fc113 = 'jira-software.ondemand';
const $595fa67a6de3b558$export$5f81ba9b97257582 = 'loom';
const $595fa67a6de3b558$var$CONFLUENCE_PREMIUM = 'premium';
const $595fa67a6de3b558$var$JIRA_PREMIUM = 'premium';
const $595fa67a6de3b558$var$LOOM_BUSINESS_AI = 'business-ai';
const $595fa67a6de3b558$export$a573b79a27d213cc = async (cloudId)=>{
    const response = await (0, $f7B1p.cfetch)(`/gateway/api/xflow/${cloudId}/license-information`);
    return response.json();
};
const $595fa67a6de3b558$var$editionOf = (info, productKey)=>info?.products?.[productKey]?.edition ?? undefined;
const $595fa67a6de3b558$export$ec1304b00469b372 = (info)=>$595fa67a6de3b558$var$editionOf(info, $595fa67a6de3b558$export$5f81ba9b97257582) === $595fa67a6de3b558$var$LOOM_BUSINESS_AI;
const $595fa67a6de3b558$export$eb59708d2df4f242 = (info)=>{
    const confluencePremium = $595fa67a6de3b558$var$editionOf(info, $595fa67a6de3b558$export$b65b36d21c9a62a9) === $595fa67a6de3b558$var$CONFLUENCE_PREMIUM;
    const jiraPremium = $595fa67a6de3b558$var$editionOf(info, $595fa67a6de3b558$export$e36fc9e5c75fc113) === $595fa67a6de3b558$var$JIRA_PREMIUM;
    const loomBusinessAi = $595fa67a6de3b558$export$ec1304b00469b372(info);
    const inCollection = (info?.products?.[$595fa67a6de3b558$export$5f81ba9b97257582]?.relatesFromEntitlements ?? []).some((relationship)=>relationship?.relationshipType === 'COLLECTION');
    return confluencePremium && jiraPremium && loomBusinessAi && inCollection;
};
const $595fa67a6de3b558$export$ad808b751a3a49a6 = (info)=>$595fa67a6de3b558$export$ec1304b00469b372(info) || $595fa67a6de3b558$export$eb59708d2df4f242(info);



var $2fiui = parcelRequire("2fiui");

const $cdc4942d5849db22$var$toPerson = (raw, fallbackAccountId = '')=>({
        accountId: raw?.accountId ?? fallbackAccountId,
        displayName: raw?.name ?? 'Unknown',
        avatarUrl: raw?.picture ?? undefined
    });
const $cdc4942d5849db22$var$ACTION_TYPES = [
    'CONFLUENCE',
    'JIRA',
    'MESSAGE'
];
const $cdc4942d5849db22$var$CONTENT_TYPES = [
    'LIVE_DOC',
    'WHITEBOARD',
    'DATABASE',
    'SLIDES'
];
const $cdc4942d5849db22$var$ACTION_STATUSES = [
    'PENDING',
    'ACCEPTED',
    'DISMISSED'
];
/** Normalise a raw enum string (any case, e.g. "live_doc") to the typed union. */ const $cdc4942d5849db22$var$asEnum = (raw, allowed)=>{
    const upper = raw?.toUpperCase();
    return allowed.find((v)=>v === upper);
};
/**
 * Map a raw `LoomMeetingOneClickAction` node into the UI `MeetingActionItem`.
 * Returns `null` for actions that are DISMISSED (filtered out) or that lack the
 * fields needed to render.
 */ const $cdc4942d5849db22$var$toActionItem = (raw)=>{
    if (!raw?.id) return null;
    const status = $cdc4942d5849db22$var$asEnum(raw.status, $cdc4942d5849db22$var$ACTION_STATUSES) ?? 'PENDING';
    // Dismissed actions are never rendered.
    if (status === 'DISMISSED') return null;
    const type = $cdc4942d5849db22$var$asEnum(raw.type, $cdc4942d5849db22$var$ACTION_TYPES);
    // `raw.action` is the AGG-provided descriptive line (e.g. "Turn this into a
    // PRD"). It remains the item's `content`; the CTA button text is derived
    // deterministically from the typed enums below.
    const content = raw.action ?? '';
    const confluenceContentType = type === 'CONFLUENCE' ? $cdc4942d5849db22$var$asEnum(raw.confluenceContentType, $cdc4942d5849db22$var$CONTENT_TYPES) : undefined;
    // A CTA payload is only meaningful when we know the target product.
    const action = type ? (()=>{
        const labelKey = (0, $2fiui.getActionLabelKey)({
            type: type,
            confluenceContentType: confluenceContentType
        });
        return {
            labelKey: labelKey,
            label: (0, $2fiui.ACTION_LABEL_FALLBACK)[labelKey],
            type: type,
            confluenceContentType: confluenceContentType
        };
    })() : undefined;
    return {
        id: raw.id,
        content: content,
        timestampSeconds: raw.timestampSeconds ?? undefined,
        status: status,
        action: action
    };
};
const $cdc4942d5849db22$export$474012fbfeb9867d = (raw)=>({
        id: raw?.id ?? '',
        title: raw?.title ?? 'Untitled meeting',
        startsAt: raw?.startsAt ?? '',
        recorderId: raw?.recorderId ?? '',
        owner: $cdc4942d5849db22$var$toPerson(raw?.recorder ?? null, raw?.recorderId ?? ''),
        invitees: (raw?.invitees ?? []).filter((p)=>Boolean(p)).map((p)=>$cdc4942d5849db22$var$toPerson(p)),
        videoAri: raw?.video?.id ?? '',
        videoUrl: raw?.video?.url ?? '',
        summary: raw?.video?.shortSummary ?? undefined,
        actionItems: (raw?.oneClickActions ?? []).map($cdc4942d5849db22$var$toActionItem).filter((item)=>item !== null),
        recurring: raw?.recurring ?? undefined
    });









const $1d3ae1b7f2dc0406$export$43dff8a87432f73d = (enabled)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $cozmU.useState)({
        loading: enabled,
        info: null
    });
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !cloudId) {
            setState({
                loading: false,
                info: null
            });
            return;
        }
        let cancelled = false;
        setState({
            loading: true,
            info: null
        });
        (0, $595fa67a6de3b558$export$a573b79a27d213cc)(cloudId).then((info)=>{
            if (!cancelled) setState({
                loading: false,
                info: info
            });
        }).catch(()=>{
            if (!cancelled) setState({
                loading: false,
                info: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        cloudId
    ]);
    return state;
};


/**
 * Live Relay-backed implementation of the Meetings data hook.
 *
 * This is the single seam between the UI and the data layer — every consuming
 * component depends only on the `UseMeetingsResult` contract, never on the query.
 *
 * Data sources (see tech spec https://hello.atlassian.net/wiki/spaces/Growth/pages/7345509583):
 * - `loom_recordedMeetings(siteId, rangeStart, rangeEnd)` → the user's recorded
 *   (notetaker) meetings, participation-based (any meeting on their connected
 *   calendars that was recorded, regardless of who recorded it). Returns a
 *   `{ edges { node } }` connection with a real server-side date range (7-day
 *   default), so no client-side date filtering is needed.
 * - `loom_settings(siteId)` → drives eligibility (TWC / connect-calendar / show).
 *
 * The AI recap ("Your recap") is sourced from `video.shortSummary`.
 *
 * One-click action items (M1CA) are read from `oneClickActions` nested on each
 * meeting and rendered by the swappable `ActionItem` boundary. The CTA redirect
 * recipes + acceptance mutation are a later layer (STARB-3845); this layer only
 * renders the items (pending + accepted; dismissed are filtered out).
 */ const $09d06ace83a30dd6$var$MEETINGS_QUERY = (0, $b0eaa91389ac865b$export$2e2bcd8739ae039);
const $09d06ace83a30dd6$export$bd23c793f5479882 = (tenantContext)=>{
    const relatesFromEntitlements = tenantContext?.confluenceEntitlementInfo?.entitlement?.relatesFromEntitlements ?? [];
    return relatesFromEntitlements.some((relationship)=>relationship?.relationshipType === 'COLLECTION');
};
const $09d06ace83a30dd6$export$9ec6f0867af01c56 = (tenantContext)=>{
    const relatesFromEntitlements = tenantContext?.confluenceEntitlementInfo?.entitlement?.relatesFromEntitlements ?? [];
    return relatesFromEntitlements.some((relationship)=>relationship?.relationshipType === 'COLLECTION' && relationship?.entitlement?.offering?.pricingType === 'PAID');
};
const $09d06ace83a30dd6$export$be133d4c8feee9f9 = (info)=>info?.entitlement != null;
const $09d06ace83a30dd6$export$91e7e3cbf9af876b = (info)=>info?.entitlement?.offering?.pricingType === 'PAID';
const $09d06ace83a30dd6$export$375abd893c9f1a84 = (data, license)=>{
    // Premium tier (Loom Business + AI / TWC Premium) → co-use, regardless of
    // whether the site has the TWC bundle. Checked first: a standalone Loom
    // Business + AI site (no TWC, no Jira) is co-use eligible.
    if ((0, $595fa67a6de3b558$export$ad808b751a3a49a6)(license)) {
        const hasConnectedCalendar = (data?.loom_connectedCalendars ?? []).some(Boolean);
        // Require recordings to be explicitly available. `meetingRecordingsAvailable`
        // is `boolean | null`; treat null (unknown) the same as false so we don't
        // surface a dead-end "eligible" state when availability is unconfirmed.
        const recordingsAvailable = data?.loom_settings?.meetingRecordingsAvailable === true;
        if (!hasConnectedCalendar || !recordingsAvailable) return 'noConnectedCalendar';
        return 'eligible';
    }
    // Not premium tier. A site that already has TWC (paid or free) but isn't
    // premium is excluded — it's neither a co-use nor a cross-flow target.
    if ($09d06ace83a30dd6$export$bd23c793f5479882(data?.tenantContexts?.[0])) return 'excluded';
    // No TWC and not premium tier: cross-flow only for paid Atlassian customers.
    return $09d06ace83a30dd6$export$c362aebb0d8008f0(data) ? 'noTwc' : 'excluded';
};
const $09d06ace83a30dd6$export$c362aebb0d8008f0 = (data)=>{
    const tenantContext = data?.tenantContexts?.[0];
    if ($09d06ace83a30dd6$export$bd23c793f5479882(tenantContext)) return false;
    return $09d06ace83a30dd6$export$91e7e3cbf9af876b(tenantContext?.confluenceEntitlementInfo) || $09d06ace83a30dd6$export$91e7e3cbf9af876b(tenantContext?.jiraEntitlementInfo);
};
// Gate off → treat as not eligible; still fetching (either the AGG query or the
// license-info request) → loading; else derive.
const $09d06ace83a30dd6$var$deriveEligibilityState = (enabled, loading, data, license)=>{
    if (!enabled) return 'excluded';
    if (loading) return 'loading';
    return $09d06ace83a30dd6$export$375abd893c9f1a84(data, license);
};
/** Whether an eligibility state is one where the pill is allowed to show. */ const $09d06ace83a30dd6$var$isPillVisibleState = (eligibility)=>eligibility === 'eligible' || eligibility === 'noTwc' || eligibility === 'noConnectedCalendar';
/**
 * Shared query + eligibility derivation for the Meetings surface.
 *
 * This is the single place the `useMeetingsQuery` is issued. Both the
 * feed-level visibility hook and the panel-level data hook call this; because
 * the query uses identical variables + `cache-first`, only ONE network request
 * is made (the second call is a cache hit). It deliberately does NOT read the
 * experiment — exposure is owned solely by `useMeetingsVisibility`.
 */ const $09d06ace83a30dd6$var$useMeetingsQueryData = (enabled, dateRange)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const rangeStart = dateRange?.rangeStart;
    const rangeEnd = dateRange?.rangeEnd;
    // Stable reference so the query isn't re-executed on every render. When no
    // range is supplied the args are omitted, so the server default window (7
    // days) applies — and the visibility + panel hooks share one cache entry.
    // loom_recordedMeetings resolves the Loom workspace via a site ARI, unlike
    // loom_settings/loom_connectedCalendars which accept the bare cloudId.
    const siteAri = `ari:cloud:loom::site/${cloudId}`;
    const variables = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            cloudIds: [
                cloudId
            ],
            siteAri: siteAri,
            rangeStart: rangeStart,
            rangeEnd: rangeEnd
        }), [
        cloudId,
        siteAri,
        rangeStart,
        rangeEnd
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($09d06ace83a30dd6$var$MEETINGS_QUERY, {
        variables: variables,
        errorPolicy: 'all',
        fetchPolicy: 'cache-first',
        // Gate off → skip the query (no request on the feed critical path).
        skip: !enabled,
        __callerPackage__: "feed"
    });
    // License information supplies the premium-tier targeting signal. Gated by
    // the same `enabled` flag so no extra request is made when the gate is off.
    const { loading: licenseLoading, info: license } = (0, $1d3ae1b7f2dc0406$export$43dff8a87432f73d)(enabled);
    // Eligibility depends on both sources, so we're "loading" until both resolve.
    const combinedLoading = loading || licenseLoading;
    // Gate off → never fetching, so not "loading".
    const eligibility = $09d06ace83a30dd6$var$deriveEligibilityState(enabled, combinedLoading, data, license);
    return {
        data: data,
        loading: combinedLoading,
        error: error ?? undefined,
        eligibility: eligibility
    };
};
const $09d06ace83a30dd6$export$423ccbc70bde7dfa = (options = {})=>{
    const { enabled: enabled = true } = options;
    const { eligibility: eligibility } = $09d06ace83a30dd6$var$useMeetingsQueryData(enabled);
    // Read the experiment only once targeting passes, so exposure fires for the
    // targeted cohort only. `excluded`/`loading` never expose and never show.
    const shouldShow = $09d06ace83a30dd6$var$isPillVisibleState(eligibility) && (0, $6mKj3.expValEquals)('meetings_tab_in_confluence_for_you_page', 'cohort', 'variant');
    return {
        shouldShow: shouldShow
    };
};
const $09d06ace83a30dd6$export$883dee3e15a6531 = (options = {})=>{
    const { dateRange: dateRange, enabled: enabled = true } = options;
    const { data: data, loading: loading, error: error, eligibility: eligibility } = $09d06ace83a30dd6$var$useMeetingsQueryData(enabled, dateRange);
    const groups = (0, $cozmU.useMemo)(()=>{
        if (loading || eligibility !== 'eligible') return [];
        // `loom_recordedMeetings` already scopes to the user's recorded meetings
        // within the requested (server-side) date range, so no participant/date
        // filtering is needed here — just keep meetings with a playable recording.
        const edges = data?.loom_recordedMeetings?.edges ?? [];
        const meetings = [];
        for (const edge of edges){
            const node = edge?.node;
            if (!node?.video?.url) continue;
            meetings.push((0, $cdc4942d5849db22$export$474012fbfeb9867d)(node));
        }
        meetings.sort((a, b)=>Date.parse(b.startsAt) - Date.parse(a.startsAt));
        return (0, $6a5d9fe3938507ad$export$cb1886553760624b)(meetings);
    }, [
        loading,
        eligibility,
        data
    ]);
    const totalCount = (0, $cozmU.useMemo)(()=>groups.reduce((sum, group)=>sum + group.meetings.length, 0), [
        groups
    ]);
    return {
        eligibility: eligibility,
        loading: loading,
        error: error,
        groups: groups,
        totalCount: totalCount,
        // Visibility/exposure is owned by `useMeetingsVisibility` at the feed
        // level; the panel is only mounted for treatment users. Kept in the
        // contract for back-compat; the panel does not gate on it.
        shouldShow: $09d06ace83a30dd6$var$isPillVisibleState(eligibility)
    };
};
module.exports["useMeetingsVisibility"] = $09d06ace83a30dd6$export$423ccbc70bde7dfa;
module.exports["useMeetings"] = $09d06ace83a30dd6$export$883dee3e15a6531;

});

parcelRegister("2fiui", function(module, exports) {
const $1a79790439bc27bb$export$5b51e0228dbd0227 = {
    CREATE_PAGE: 'Create page',
    CREATE_WHITEBOARD: 'Create whiteboard',
    CREATE_DATABASE: 'Create database',
    CREATE_SLIDES: 'Create slides',
    AUTO_UPDATE_JIRA: 'Auto-update Jira',
    GENERATE_MESSAGE: 'Generate message',
    CUSTOMIZE_RECORDINGS: 'Customize recordings'
};
const $1a79790439bc27bb$export$5a11fe15dff7f5bb = (action)=>{
    switch(action.type){
        case 'JIRA':
            return 'AUTO_UPDATE_JIRA';
        case 'MESSAGE':
            return 'GENERATE_MESSAGE';
        case 'CONFLUENCE':
        default:
            switch(action.confluenceContentType){
                case 'WHITEBOARD':
                    return 'CREATE_WHITEBOARD';
                case 'DATABASE':
                    return 'CREATE_DATABASE';
                case 'SLIDES':
                    return 'CREATE_SLIDES';
                case 'LIVE_DOC':
                default:
                    return 'CREATE_PAGE';
            }
    }
};
const $1a79790439bc27bb$export$ca609d2d1a8e5706 = (action)=>$1a79790439bc27bb$export$5b51e0228dbd0227[action.labelKey ?? $1a79790439bc27bb$export$5a11fe15dff7f5bb(action)];
module.exports["ACTION_LABEL_FALLBACK"] = $1a79790439bc27bb$export$5b51e0228dbd0227;
module.exports["getActionLabelKey"] = $1a79790439bc27bb$export$5a11fe15dff7f5bb;

});

parcelRegister("kijQ0", function(module, exports) {
const $d25de9b113b7e89d$export$c5731692e18a3b07 = 'meetings-pill-new-lozenge:firstSeenAt';
const $d25de9b113b7e89d$export$cea43ec254f1512b = 'meetings-pill-new-lozenge:clickCount';
const $d25de9b113b7e89d$export$78eeb8847faa424a = [
    $d25de9b113b7e89d$export$c5731692e18a3b07,
    $d25de9b113b7e89d$export$cea43ec254f1512b
];
module.exports["MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY"] = $d25de9b113b7e89d$export$c5731692e18a3b07;
module.exports["MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY"] = $d25de9b113b7e89d$export$cea43ec254f1512b;
module.exports["MeetingsPillNewLozengeOnboardingKeys"] = $d25de9b113b7e89d$export$78eeb8847faa424a;

});

parcelRegister("i1Y90", function(module, exports) {
/**
 * @generated SignedSource<<9322824d2b8aa7fe5b4023bb5bbd1178>>
 * @relayHash ea99db2d334a94ff820ac76b168b5dab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f
const $c9b2249f57db9450$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useTemplatesCollectionEligibleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useTemplatesCollectionEligibleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea99db2d334a94ff820ac76b168b5dab",
            "id": "fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f",
            "metadata": {},
            "name": "useTemplatesCollectionEligibleQuery",
            "operationKind": "query",
            "text": "query useTemplatesCollectionEligibleQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c9b2249f57db9450$var$node.hash = "4c6390ae7a1c60c33ec38b4eadda65e8";
var $c9b2249f57db9450$export$2e2bcd8739ae039 = $c9b2249f57db9450$var$node;



var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $aaa38d1e755eea36$var$useTemplatesCollectionEligibleQuery = (0, $c9b2249f57db9450$export$2e2bcd8739ae039);
const $aaa38d1e755eea36$export$a812daf120cf5caa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isUserEligibleForTemplatesCollection, setisUserEligibleForTemplatesCollection] = (0, $cozmU.useState)(false);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const skipConditionsForQueries = !isLicensed || !(0, $9wGTI.fg)('cc_onboarding_experience');
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        variables: {
            userId: userId ?? ''
        },
        skip: skipConditionsForQueries
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $dBcar.TEMPLATES_COLLECTION),
        ...(0, $dBcar.ONBOARDING_EXPERIENCES)
    }), skipConditionsForQueries);
    // check if user is a founding admin or/and if the user is tagged already
    const { isFoundingAdmin: isFoundingAdmin, isTaggedForTemplatesCollectionExperiment: isTaggedForTemplatesCollectionExperiment, isTemplatesSectionDismissed: isTemplatesSectionDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { data: productsTeamAndSpaceQueryData, loading: productsTeamAndSpaceQueryLoading, error: productsTeamAndSpaceQueryError } = (0, $jMyy4.useQueryInterop)($aaa38d1e755eea36$var$useTemplatesCollectionEligibleQuery, {
        skip: skipConditionsForQueries || isTemplatesSectionDismissed,
        __callerPackage__: "onboarding-helpers"
    });
    const hasPersonalSpace = productsTeamAndSpaceQueryData?.user?.confluence?.hasPersonalSpace;
    const isXFlowUser = productsTeamAndSpaceQueryData?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey.toLowerCase().includes('jira') && product.licenseStatus === 'ACTIVE');
    const isUserEligible = isLicensed && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isUserEligibleForTemplatesCollectionTagging = isUserEligible && isFoundingAdmin && isXFlowUser;
    (0, $cozmU.useEffect)(()=>{
        if (// queries have finished loading
        !userPersonalizationQueryError && !userPersonalizationQueryLoading && !onboardingStateLoading && !onboardingStateError && !productsTeamAndSpaceQueryError && !productsTeamAndSpaceQueryLoading && // conditions to meet to be eligible
        !isEstablishedUser && isUserEligibleForTemplatesCollectionTagging && !isTaggedForTemplatesCollectionExperiment) {
            // newly tagged user for the experiment
            setisUserEligibleForTemplatesCollection(true);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        name: 'templatesCollection',
                        hasPersonalSpace: hasPersonalSpace
                    }
                }
            }).fire();
            setOnboardingState({
                key: (0, $dBcar.TEMPLATES_COLLECTION).EXPERIMENT_ELIGIBLE,
                value: String(true)
            });
        }
    }, [
        userPersonalizationQueryError,
        userPersonalizationQueryLoading,
        onboardingStateError,
        onboardingStateLoading,
        productsTeamAndSpaceQueryError,
        productsTeamAndSpaceQueryLoading,
        isEstablishedUser,
        isUserEligibleForTemplatesCollectionTagging,
        isTaggedForTemplatesCollectionExperiment,
        setisUserEligibleForTemplatesCollection,
        setOnboardingState,
        createAnalyticsEvent,
        hasPersonalSpace
    ]);
    const isUserPreviouslyTaggedAndEnrolled = Boolean(isTaggedForTemplatesCollectionExperiment);
    const isTemplatesCollectionEligible = !isTemplatesSectionDismissed && Boolean(hasPersonalSpace) && (isUserEligibleForTemplatesCollection || isUserPreviouslyTaggedAndEnrolled);
    return {
        isTemplatesCollectionEligible: isTemplatesCollectionEligible,
        shouldShowGuidingArrow: isTemplatesCollectionEligible && !isEstablishedUser,
        teamType: productsTeamAndSpaceQueryData?.user?.team,
        teamTypeLoading: productsTeamAndSpaceQueryLoading,
        teamTypeError: productsTeamAndSpaceQueryError,
        personalSpaceKey: productsTeamAndSpaceQueryData?.user?.confluence?.space?.key
    };
};
module.exports["useTemplatesCollectionEligible"] = $aaa38d1e755eea36$export$a812daf120cf5caa;

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("6U5eU", function(module, exports) {

var $7rM80 = parcelRequire("7rM80");

const $9db2e529afbaed9d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $7rM80.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $9db2e529afbaed9d$export$8a57effc6307f916;

});

parcelRegister("7rM80", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");


var $1RMKR = parcelRequire("1RMKR");


var $gswTK = parcelRequire("gswTK");


var $1NJu1 = parcelRequire("1NJu1");


var $1722n = parcelRequire("1722n");


var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");

const $63c899b662d40d3e$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $8BCsI.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $1RMKR.useStableObject)(context);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gswTK.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $63c899b662d40d3e$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $63c899b662d40d3e$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1722n.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $1NJu1.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $63c899b662d40d3e$export$8a57effc6307f916;

});

parcelRegister("1RMKR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $323d99f2c95b5263$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $323d99f2c95b5263$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>obj, $323d99f2c95b5263$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $323d99f2c95b5263$export$ed02d4adf2068b08;

});

parcelRegister("1722n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c99625c3d1d9a9b2$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $cozmU.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $c99625c3d1d9a9b2$export$3d127465d22fe4e5;

});

parcelRegister("2tp0D", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $4OYR1 = parcelRequire("4OYR1");


var $jTNdj = parcelRequire("jTNdj");


var $o0RSX = parcelRequire("o0RSX");


var $k4HA2 = parcelRequire("k4HA2");


var $b4B1V = parcelRequire("b4B1V");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $bP5wt = parcelRequire("bP5wt");


var $44R0O = parcelRequire("44R0O");


var $jS1GQ = parcelRequire("jS1GQ");


var $1NVwf = parcelRequire("1NVwf");


var $8BCsI = parcelRequire("8BCsI");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $g7aP0 = parcelRequire("g7aP0");


var $1dHYE = parcelRequire("1dHYE");

const $210c900388def499$var$STABLE_EMPTY_OBJECT = {};
const $210c900388def499$export$7192d943ff7d5979 = 'post-office_enable_narrow-exposure-classic';
const $210c900388def499$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        ...props,
        children: children
    });
};
const $210c900388def499$export$7b7e5a348ef9a7c1 = (messageComponents, _placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $cozmU.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), ...data })=>{
            const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $cozmU.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $4OYR1.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $o0RSX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $o0RSX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                        name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
                const isNarrowExposureClassicEnabled = (0, $cXtTj.default).checkGate($210c900388def499$export$7192d943ff7d5979);
                const narrowExposureConfig = isNarrowExposureClassicEnabled ? inAppNarrowExposureExperiment : undefined;
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    inAppNarrowExposureExperiment: narrowExposureConfig
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $cozmU.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId,
                    messageCategory
                ]);
                if (inAppNarrowExposureExperiment && !isNarrowExposureClassicEnabled) return null;
                const message = /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                    fallback: loadingComponent,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
                        waitForTrigger: waitForTrigger,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                                isManual: !!waitForTrigger,
                                children: [
                                    !waitForTrigger && messageSuccessComponent,
                                    /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                                        onError: onError,
                                        messageInstanceId: messageInstanceId,
                                        ...componentProps,
                                        waitForTrigger: waitForTrigger
                                    })
                                ]
                            })
                        })
                    })
                });
                const withMessageContext = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                            value: recommendationSession ?? $210c900388def499$var$STABLE_EMPTY_OBJECT,
                            children: children
                        })
                    });
                // MaybeChoreographerWrapper sits above the lazy chunk so it can claim its slot while
                // loading; it no-ops for client-triggered messages, which handle their own
                // choreography via MaybeTriggeredMessageValidator.
                const withChoreographer = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
                        ChoreographerWrapper: (0, $g7aP0.ChoreographerWrapper),
                        enabled: !waitForTrigger,
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        inAppNarrowExposureExperiment: narrowExposureConfig,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: children
                        })
                    });
                // A narrow exposure shouldClaim needs message and recommendation context above the
                // choreographer to post a dropped event for this message.
                return isNarrowExposureClassicEnabled ? withMessageContext(withChoreographer(message)) : withChoreographer(withMessageContext(message));
            };
            return (0, $8BCsI.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $210c900388def499$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $210c900388def499$export$7b7e5a348ef9a7c1;

});

parcelRegister("4OYR1", function(module, exports) {

var $jAbAo = parcelRequire("jAbAo");


var $8fXDz = parcelRequire("8fXDz");

const $baf07cb19e3d1dfe$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jAbAo.MessagePerformanceTracker,
    PlacementPerformanceTracker: $8fXDz.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $baf07cb19e3d1dfe$export$96236906ebaa7f87;

});

parcelRegister("jAbAo", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

class $01005f2678a8118a$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $01005f2678a8118a$export$ae5c73c7c4f454e6;

});

parcelRegister("8UDja", function(module, exports) {
const $21c39d458f004fb5$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $21c39d458f004fb5$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $21c39d458f004fb5$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $21c39d458f004fb5$export$6d482cfa20c9d220;

});

parcelRegister("8fXDz", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

const $e2ea1aa57de97a70$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $gZFfs.ExperienceTypes).Load,
    platform: {
        component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e2ea1aa57de97a70$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).PLACEMENT, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).PLACEMENT}.${placementId}`, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $e2ea1aa57de97a70$export$8b48c2105ba0b35a;

});

parcelRegister("o0RSX", function(module, exports) {
//#region src/index.ts

var $ddnoW = parcelRequire("ddnoW");

let $0482ea6551d2dfec$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $0482ea6551d2dfec$export$46f86d28cd0a5d38 = class extends Error {
};
var $0482ea6551d2dfec$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $0482ea6551d2dfec$export$66e065cfeb491a4d = class HydrationAbortError extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $0482ea6551d2dfec$export$69be53c018c89481 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6452976adc01572 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(cause, code){
        super($0482ea6551d2dfec$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $0482ea6551d2dfec$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $0482ea6551d2dfec$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $0482ea6551d2dfec$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $0482ea6551d2dfec$export$ed601cd0dc1a1be7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2833d4759f81601b = class extends $0482ea6551d2dfec$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8d39b103586e9fd4 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$f649da38897d27f7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2852c1c4d9aba3e = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4b7b4e09547e4bb3 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$360a094a97597d87 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4d068b43eb55165b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ac007ee150add337 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$19cb89dd679394cb = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$78651662ad470cc5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$43b3b4535703ed1b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8a5041670cdd8db2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1240ddc25cf964e6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3c4884b7ae7fe517 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$913b8e68dc7ae8fe = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3dfc27a8d3942f4d = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e5ccdf8bbfead7a2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$823733742d803ae6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1caa32527f23acd2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$a6f2aad8fa094b39 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2296e5dc6a1bf3d2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2f1e27130c2bf271 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d0dc094613469f2b = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5603eab37ce562f5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e0e9aa0e9c6b37ff = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3ad818f64601e141 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$25470bb6cba4fba0 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ce14d445679448b6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $0482ea6551d2dfec$export$c9a26a17db1045c8 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8ab4fb362168b928 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2afd69f57fe5285f = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$7635d2b1a281d626 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6d1a4929f6ff1a32 = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$c504492f06c975b5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $0482ea6551d2dfec$export$1c932b9d1680ee0b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $0482ea6551d2dfec$export$85497ede72633b85 = class extends $0482ea6551d2dfec$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $0482ea6551d2dfec$export$359a331da49d1ec8 = class extends $0482ea6551d2dfec$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $0482ea6551d2dfec$export$8506e646874f88f6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $0482ea6551d2dfec$export$6a4077faeb1c609 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $0482ea6551d2dfec$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map
module.exports["InvalidMessageTemplateIdError"] = $0482ea6551d2dfec$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0482ea6551d2dfec$export$3dfc27a8d3942f4d;

});

parcelRegister("g7aP0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $9TNXZ = parcelRequire("9TNXZ");


var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");

const $2adf26225a469e82$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $2adf26225a469e82$export$8db7ba034addcd65;

});

parcelRegister("5KMtM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aeEJA = parcelRequire("aeEJA");

const $1ae28466f611f1b1$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $cozmU.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $aeEJA.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $1ae28466f611f1b1$export$5523c5f3222291d0;

});

parcelRegister("b2eRs", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $632fca0b42d87e9c$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            if (rendered === null) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $632fca0b42d87e9c$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $632fca0b42d87e9c$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $632fca0b42d87e9c$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $632fca0b42d87e9c$export$803c53721d530406 = ()=>(hydrateExample, config)=>$632fca0b42d87e9c$var$exampleHydrator(hydrateExample, config);
const $632fca0b42d87e9c$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $632fca0b42d87e9c$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $632fca0b42d87e9c$export$62864968b8b09cdf(),
        createHydrateExample: $632fca0b42d87e9c$export$803c53721d530406(),
        createTransformMetadata: $632fca0b42d87e9c$export$b4a84c754a962eee()
    });
const $632fca0b42d87e9c$export$7d57dbe7f7617174 = ()=>({
        createValidate: $632fca0b42d87e9c$var$initializeValidate(),
        createRender: $632fca0b42d87e9c$export$7693b71d48f1bf7e()
    });
module.exports["createServerPipeline"] = $632fca0b42d87e9c$export$b8fedcd4634de5cd;
module.exports["createClientPipeline"] = $632fca0b42d87e9c$export$7d57dbe7f7617174;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("3jNKT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kEPax = parcelRequire("kEPax");


var $8xFOz = parcelRequire("8xFOz");

const $e6e72577d521fafd$export$ee30c4b9efd02415 = ()=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $kEPax.useMessageInstanceEvent)();
    const record = (0, $cozmU.useCallback)((interaction)=>{
        // Dispatch is fire-and-forget: the caller must not wait for analytics before
        // continuing a UI action, and recording an interaction must never break the
        // message.
        messageInstanceClicked((0, $8xFOz.mapInteractionToClickedEvent)(interaction)).catch(()=>{});
    }, [
        messageInstanceClicked
    ]);
    const onCtaActioned = (0, $cozmU.useCallback)((input)=>record({
            kind: 'ctaActioned',
            ...input
        }), [
        record
    ]);
    const onAcknowledged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'acknowledged',
            ...input
        }), [
        record
    ]);
    const onDeclined = (0, $cozmU.useCallback)((input)=>record({
            kind: 'declined',
            ...input
        }), [
        record
    ]);
    const onSnoozed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'snoozed',
            ...input
        }), [
        record
    ]);
    const onClosed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'closed',
            ...input
        }), [
        record
    ]);
    const onStepChanged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'stepChanged',
            ...input
        }), [
        record
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onCtaActioned: onCtaActioned,
            onAcknowledged: onAcknowledged,
            onDeclined: onDeclined,
            onSnoozed: onSnoozed,
            onClosed: onClosed,
            onStepChanged: onStepChanged
        }), [
        onCtaActioned,
        onAcknowledged,
        onDeclined,
        onSnoozed,
        onClosed,
        onStepChanged
    ]);
};
module.exports["usePostOfficeUserInteractions"] = $e6e72577d521fafd$export$ee30c4b9efd02415;

});

parcelRegister("8xFOz", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

/**
 * The legacy `clickedElement` shape for kinds that downstream consumers still read as a
 * primary click. Presentation is not intent — this is emitted for backward compatibility
 * only and is removed once consumers read `action.actionType` alone.
 */ const $8935800689fede97$var$primaryButton = (interactionIdentifier)=>({
        clickIdentifier: interactionIdentifier,
        clickedElement: 'button',
        buttonType: 'primary'
    });
/**
 * The legacy `clickedElement` shape for kinds whose meaning does not depend on a rendered
 * element. `closed` in particular covers Escape, click-outside and navigating away.
 *
 * Delegates to `notApplicableClickedElement` rather than building the literal directly —
 * that factory is the only way to produce this branded, PO-owned value.
 */ const $8935800689fede97$var$notApplicable = (interactionIdentifier)=>(0, $kEPax.notApplicableClickedElement)(interactionIdentifier);
/**
 * Maps a semantic interaction to the `clickedElement` and `action` pair defined by the
 * canonical compatibility mapping.
 *
 * The switch is deliberately exhaustive with no `default`: adding a kind to
 * `SemanticInteraction` without mapping it here is a compile error.
 *
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/7480820497/LYT+IPMs+Semantic+Interaction+Contract+Proposal+Rationale+and+Mapping#1.7-End-to-end-mapping
 */ const $8935800689fede97$var$toClickedEventCore = (interaction)=>{
    const identifier = interaction.interactionIdentifier;
    switch(interaction.kind){
        case 'ctaActioned':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'open',
                    ...interaction.destinationUrl !== undefined && {
                        destinationUrl: interaction.destinationUrl
                    },
                    ...interaction.trackingLinkId !== undefined && {
                        trackingLinkId: interaction.trackingLinkId
                    }
                }
            };
        case 'acknowledged':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'acknowledge'
                }
            };
        case 'declined':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'snoozed':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'snooze',
                    snoozeDuration: interaction.durationDays
                }
            };
        case 'closed':
            // Compatibility mode: `closed` maps to `dismiss` because there is no native
            // `close` actionType yet. Native support is tracked separately, and the split
            // between `declined` and `closed` is preserved in `interactionIdentifier`.
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'stepChanged':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: interaction.direction,
                    currentStep: interaction.toStep,
                    previousStep: interaction.fromStep,
                    ...interaction.stepName !== undefined && {
                        stepName: interaction.stepName
                    }
                }
            };
    }
};
const $8935800689fede97$export$4f02cad8854e08a4 = (interaction)=>({
        messageEventType: 'clicked',
        interactionIdentifier: interaction.interactionIdentifier,
        ...$8935800689fede97$var$toClickedEventCore(interaction),
        ...interaction.additionalMetadata !== undefined && {
            additionalMetadataFromFrontend: interaction.additionalMetadata
        }
    });
module.exports["mapInteractionToClickedEvent"] = $8935800689fede97$export$4f02cad8854e08a4;

});

parcelRegister("lb2UL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $cctzu = parcelRequire("cctzu");


var $6DRr2 = parcelRequire("6DRr2");

const $3a5717d07385498a$var$packageName = "platform-pkg";
const $3a5717d07385498a$var$packageVersion = "0.0.0-use.local";
const $3a5717d07385498a$var$progressIndicatorGapMap = {
    comfortable: {
        default: 'space.100',
        large: 'space.150'
    },
    cozy: {
        default: 'space.075',
        large: 'space.100'
    },
    compact: {
        default: 'space.050',
        large: 'space.075'
    }
};
const $3a5717d07385498a$var$sizes = {
    default: 8,
    large: 12
};
const $3a5717d07385498a$var$varDotsSize = '--ds-dots-size';
const $3a5717d07385498a$var$varDotsMargin = '--ds-dots-margin';
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $3a5717d07385498a$var$ProgressDots = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { appearance: t1, ariaControls: t2, ariaLabel: t3, getAriaLabel: getAriaLabel, size: t4, spacing: t5, selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const ariaControls = t2 === undefined ? "panel" : t2;
    const ariaLabel = t3 === undefined ? "tab" : t3;
    const size = t4 === undefined ? "default" : t4;
    const gutter = t5 === undefined ? "comfortable" : t5;
    const tablistRef = (0, $cozmU.useRef)(null);
    const t6 = onSelect || (0, $dpsRj.default);
    let t7;
    if ($[0] !== t6) {
        t7 = {
            fn: t6,
            action: "selected",
            componentName: "progressIndicator",
            packageName: $3a5717d07385498a$var$packageName,
            packageVersion: $3a5717d07385498a$var$packageVersion
        };
        $[0] = t6;
        $[1] = t7;
    } else t7 = $[1];
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t7);
    const gap = $3a5717d07385498a$var$progressIndicatorGapMap[gutter][size];
    let t8;
    if ($[2] !== onSelect || $[3] !== onSelectWithAnalytics || $[4] !== selectedIndex || $[5] !== values.length) {
        t8 = (event)=>{
            const indicators = Array.from(tablistRef.current.children);
            if (!indicators.includes(event.target)) return;
            const isLeft = event.key === "ArrowLeft";
            const isRight = event.key === "ArrowRight";
            if (!isLeft && !isRight) return;
            const isAlpha = isLeft && selectedIndex === 0;
            const isOmega = isRight && selectedIndex === values.length - 1;
            if (isAlpha || isOmega) return;
            const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
            if (onSelect) onSelectWithAnalytics({
                event: event,
                index: index
            });
            if (typeof indicators[index].focus === "function") indicators[index].focus();
        };
        $[2] = onSelect;
        $[3] = onSelectWithAnalytics;
        $[4] = selectedIndex;
        $[5] = values.length;
        $[6] = t8;
    } else t8 = $[6];
    const handleKeyDown = t8;
    let t10;
    let t9;
    if ($[7] !== handleKeyDown || $[8] !== onSelect) {
        t9 = ()=>{
            if (!onSelect) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(document, {
                type: "keydown",
                listener: handleKeyDown,
                options: {
                    capture: false
                }
            });
        };
        t10 = [
            onSelect,
            handleKeyDown
        ];
        $[7] = handleKeyDown;
        $[8] = onSelect;
        $[9] = t10;
        $[10] = t9;
    } else {
        t10 = $[9];
        t9 = $[10];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const t11 = `${$3a5717d07385498a$var$sizes[size]}px`;
    let t12;
    if ($[11] !== gap || $[12] !== t11) {
        t12 = {
            [$3a5717d07385498a$var$varDotsSize]: t11,
            [$3a5717d07385498a$var$varDotsMargin]: gap
        };
        $[11] = gap;
        $[12] = t11;
        $[13] = t12;
    } else t12 = $[13];
    const t13 = t12;
    const t14 = onSelect && "tablist";
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (r)=>{
            tablistRef.current = r;
        };
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] !== appearance || $[16] !== ariaControls || $[17] !== ariaLabel || $[18] !== getAriaLabel || $[19] !== onSelect || $[20] !== onSelectWithAnalytics || $[21] !== selectedIndex || $[22] !== testId || $[23] !== values) {
        let t17;
        if ($[25] !== appearance || $[26] !== ariaControls || $[27] !== ariaLabel || $[28] !== getAriaLabel || $[29] !== onSelect || $[30] !== onSelectWithAnalytics || $[31] !== selectedIndex || $[32] !== testId) {
            t17 = (_, index_0)=>{
                const isSelected = selectedIndex === index_0;
                const tabId = `${ariaLabel}${index_0}`;
                const panelId = `${ariaControls}${index_0}`;
                const label = getAriaLabel ? getAriaLabel(index_0) : tabId;
                const indicatorTestId = testId && `${testId}-ind-${index_0}`;
                return onSelect ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cctzu.ButtonIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected,
                    tabId: tabId,
                    panelId: panelId,
                    label: label,
                    onClick: (event_0)=>onSelectWithAnalytics({
                            event: event_0,
                            index: index_0
                        })
                }, index_0) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6DRr2.PresentationalIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected
                }, index_0);
            };
            $[25] = appearance;
            $[26] = ariaControls;
            $[27] = ariaLabel;
            $[28] = getAriaLabel;
            $[29] = onSelect;
            $[30] = onSelectWithAnalytics;
            $[31] = selectedIndex;
            $[32] = testId;
            $[33] = t17;
        } else t17 = $[33];
        t16 = values.map(t17);
        $[15] = appearance;
        $[16] = ariaControls;
        $[17] = ariaLabel;
        $[18] = getAriaLabel;
        $[19] = onSelect;
        $[20] = onSelectWithAnalytics;
        $[21] = selectedIndex;
        $[22] = testId;
        $[23] = values;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[34] !== gap || $[35] !== t16 || $[36] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            testId: testId,
            ref: t15,
            alignInline: "center",
            space: gap,
            children: t16
        });
        $[34] = gap;
        $[35] = t16;
        $[36] = testId;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== t13 || $[39] !== t14 || $[40] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            style: t13,
            role: t14,
            children: t17
        });
        $[38] = t13;
        $[39] = t14;
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    return t18;
} : ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', getAriaLabel: getAriaLabel, size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $cozmU.useRef)(null);
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $dpsRj.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $3a5717d07385498a$var$packageName,
        packageVersion: $3a5717d07385498a$var$packageVersion
    });
    const gap = $3a5717d07385498a$var$progressIndicatorGapMap[gutter][size];
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!onSelect) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        style: {
            [$3a5717d07385498a$var$varDotsSize]: `${$3a5717d07385498a$var$sizes[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3a5717d07385498a$var$varDotsMargin]: gap
        },
        role: onSelect && 'tablist',
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            testId: testId,
            ref: (r)=>{
                tablistRef.current = r;
            },
            alignInline: "center",
            space: gap,
            children: values.map((_, index_0)=>{
                const isSelected = selectedIndex === index_0;
                const tabId = `${ariaLabel}${index_0}`;
                const panelId = `${ariaControls}${index_0}`;
                const label = getAriaLabel ? getAriaLabel(index_0) : tabId;
                const indicatorTestId = testId && `${testId}-ind-${index_0}`;
                return onSelect ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cctzu.ButtonIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected,
                    tabId: tabId,
                    panelId: panelId,
                    label: label,
                    onClick: (event_0)=>onSelectWithAnalytics({
                            event: event_0,
                            index: index_0
                        })
                }, index_0) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6DRr2.PresentationalIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected
                }, index_0);
            })
        })
    });
};
var $3a5717d07385498a$export$2e2bcd8739ae039 = $3a5717d07385498a$var$ProgressDots;
module.exports["default"] = $3a5717d07385498a$export$2e2bcd8739ae039;

});

parcelRegister("cctzu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $hBYtq = parcelRequire("hBYtq");


var $9GVkD = parcelRequire("9GVkD");

const $5c6d14f695de5ef7$var$commonStyles = {
    common: "_0bjKvDS5Zs _39xV02kKXV _0jFU0VkKXV _1mT5xdRAKS _0OU75rvLZJ _3ScelFWeOv _1lBcDcWeOv _3dCYwDWVPG _3Ku51Iogpp _1cR5ZLooq2 _2jTvwtooq2"
};
const $5c6d14f695de5ef7$var$colorBorderMap = {
    default: "_30huDK2TT5",
    help: "_30huDK2TT5",
    inverted: "_30huDKPrhC",
    primary: "_30huDK2TT5"
};
const $5c6d14f695de5ef7$var$buttonStyle = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _0wOv4Q7zJH"
};
const $5c6d14f695de5ef7$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $5c6d14f695de5ef7$export$3716cb524d6018c1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { appearance: appearance, panelId: panelId, tabId: tabId, label: label, isSelected: isSelected, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== isSelected) {
        t1 = $5c6d14f695de5ef7$var$backgroundColor(isSelected);
        $[0] = isSelected;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = t1[appearance];
    let t3;
    if ($[2] !== t2) {
        t3 = {
            backgroundColor: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = $5c6d14f695de5ef7$var$colorBorderMap[appearance];
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $k12R1.cx)($5c6d14f695de5ef7$var$commonStyles.common, $5c6d14f695de5ef7$var$buttonStyle.root, t4);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isSelected ? -1 : undefined;
    let t7;
    if ($[6] !== label) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: label
        });
        $[6] = label;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== isSelected || $[9] !== onClick || $[10] !== panelId || $[11] !== t3 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== tabId || $[16] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            role: "tab",
            style: t3,
            xcss: t5,
            "aria-controls": panelId,
            "aria-selected": isSelected,
            id: tabId,
            onClick: onClick,
            tabIndex: t6,
            testId: testId,
            children: t7
        });
        $[8] = isSelected;
        $[9] = onClick;
        $[10] = panelId;
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = tabId;
        $[16] = testId;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ appearance: appearance, panelId: panelId, tabId: tabId, label: label, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        role: "tab",
        style: {
            backgroundColor: $5c6d14f695de5ef7$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $k12R1.cx)($5c6d14f695de5ef7$var$commonStyles.common, $5c6d14f695de5ef7$var$buttonStyle.root, $5c6d14f695de5ef7$var$colorBorderMap[appearance]),
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: label
        })
    });
};
module.exports["ButtonIndicator"] = $5c6d14f695de5ef7$export$3716cb524d6018c1;

});

parcelRegister("6DRr2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iMnC5 = parcelRequire("iMnC5");

const $0f900a2c58811e36$var$commonStyles = {
    common: "_0bjKvDS5Zs _39xV02kKXV _0jFU0VkKXV _1mT5xdRAKS _0OU75rvLZJ _3ScelFWeOv _1lBcDcWeOv _3dCYwDWVPG _3Ku51Iogpp _1cR5ZLooq2 _2jTvwtooq2"
};
const $0f900a2c58811e36$var$colorBorderMap = {
    default: "_30huDK2TT5",
    help: "_30huDK2TT5",
    inverted: "_30huDKPrhC",
    primary: "_30huDK2TT5"
};
const $0f900a2c58811e36$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $0f900a2c58811e36$export$ec3c81af58a0c4e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { appearance: appearance, isSelected: isSelected, testId: testId } = t0;
    let t1;
    if ($[0] !== isSelected) {
        t1 = $0f900a2c58811e36$var$backgroundColor(isSelected);
        $[0] = isSelected;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = t1[appearance];
    let t3;
    if ($[2] !== t2) {
        t3 = {
            backgroundColor: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = $0f900a2c58811e36$var$colorBorderMap[appearance];
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $k12R1.cx)($0f900a2c58811e36$var$commonStyles.common, t4);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t3 || $[7] !== t5 || $[8] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            style: t3,
            xcss: t5
        });
        $[6] = t3;
        $[7] = t5;
        $[8] = testId;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ appearance: appearance, isSelected: isSelected, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        style: {
            backgroundColor: $0f900a2c58811e36$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $k12R1.cx)($0f900a2c58811e36$var$commonStyles.common, $0f900a2c58811e36$var$colorBorderMap[appearance])
    });
};
module.exports["PresentationalIndicator"] = $0f900a2c58811e36$export$ec3c81af58a0c4e7;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("8NccQ")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("c25Cq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $lpNn5 = parcelRequire("lpNn5");


var $9TNXZ = parcelRequire("9TNXZ");


var $k4HA2 = parcelRequire("k4HA2");


var $3jNKT = parcelRequire("3jNKT");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $21rdx = parcelRequire("21rdx");


var $92b2W = parcelRequire("92b2W");


var $2bWU6 = parcelRequire("2bWU6");

const $6828282bee2050b6$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, spacing: spacing = 'default', ariaLabelledby: ariaLabelledby, ...triggerProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const ariaLabel = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.aria-label",
        defaultMessage: "{messageInstanceId} options menu"
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: "post-office.ad-controls.dropdown-menu-trigger.tooltip",
        defaultMessage: "More actions"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $lpNn5.default), {
        content: tooltip,
        isScreenReaderAnnouncementDisabled: true,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                hidden: true,
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                label: tooltip,
                id: "ad-controls-trigger",
                appearance: "subtle",
                ref: triggerRef,
                spacing: spacing,
                icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        ...iconProps,
                        color: iconColor,
                        size: iconSize
                    }),
                "aria-labelledby": ariaLabelledby ? `${ariaLabelledby} ad-controls-trigger` : 'ad-controls-trigger'
            })
        ]
    });
};
const $6828282bee2050b6$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, onRemindMeLater: onRemindMeLater, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis, showRemindMeLater: showRemindMeLater, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex, spacing: spacing = 'default', customDropdownItems: customDropdownItems, ariaLabelledby: ariaLabelledby })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $cozmU.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $baFbJ.useMessageEvent)();
    const { onSnoozed: onSnoozed, onDeclined: onDeclined, onAcknowledged: onAcknowledged } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $cozmU.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { messageSnoozed: messageSnoozed } = (0, $baFbJ.useMessageEvent)();
    const handleRemindMeLater = async ()=>{
        // https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
        messageSnoozed(1); // DEPRECATED, but retained alongside the semantic snooze event for legacy consumers. See above page for documentation
        onSnoozed({
            interactionIdentifier: 'remindMeLater',
            durationDays: 1,
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remindMeLater'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onRemindMeLater === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onRemindMeLater(messageInstanceId);
        // rendered outside this component's tree, since onRemindMeLater above unmounts it immediately
        (0, $2bWU6.showStandaloneAdControlsFlag)(messageInstanceId, intl);
    };
    const handleNotInterested = async ()=>{
        await messageDismissed();
        onDeclined({
            interactionIdentifier: 'notInterested',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        // rendered outside this component's tree, since onDismissed above unmounts it immediately
        (0, $2bWU6.showStandaloneAdControlsFlag)(messageInstanceId, intl);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        onAcknowledged({
            interactionIdentifier: 'adControlsReasons',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    const fireDropdownMenuOpenAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsDropdown'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)($6828282bee2050b6$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        spacing: spacing,
                        ariaLabelledby: ariaLabelledby,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireDropdownMenuOpenAnalyticsEvent();
                        setCurrIconColor("var(--ds-icon-selected, #1868DB)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $21rdx.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    onRemindMeLater: handleRemindMeLater,
                    showWhyAmISeeingThis: showWhyAmISeeingThis,
                    showRemindMeLater: showRemindMeLater ? true : false,
                    customDropdownItems: customDropdownItems
                })
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $92b2W.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            })
        ]
    });
};
module.exports["AdControls"] = $6828282bee2050b6$export$c25b8b7217045de9;

});

parcelRegister("21rdx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $kSwu1 = parcelRequire("kSwu1");

const $eae1bdf84f77b888$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?"
        })
    });
const $eae1bdf84f77b888$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested"
        })
    });
const $eae1bdf84f77b888$export$c3a3ff4a62111967 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dropdown-item.remind-me-later.label",
            defaultMessage: "Remind me later"
        })
    });
const $eae1bdf84f77b888$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, onRemindMeLater: onRemindMeLater, showWhyAmISeeingThis: showWhyAmISeeingThis = true, showRemindMeLater: showRemindMeLater, customDropdownItems: customDropdownItems })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
        children: [
            customDropdownItems?.map((item)=>item),
            showRemindMeLater && /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$c3a3ff4a62111967, {
                testId: "ad-controls-dropdown-remind-me-later",
                onClick: onRemindMeLater
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $8aG6j.jsx)($eae1bdf84f77b888$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });
module.exports["AdControlsDropdown"] = $eae1bdf84f77b888$export$ba7539b3ac68f9f1;

});

parcelRegister("92b2W", function(module, exports) {
/* modal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $i1t43 = parcelRequire("i1t43");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6vJjN = parcelRequire("6vJjN");

const $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content'; /*--Modal--*/ 
const $82c56ad253185b59$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $6vJjN.portalZIndexFix)($82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: onClose,
            testId: $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                id: $82c56ad253185b59$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $82c56ad253185b59$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK"
        })
    }); /*--Title--*/ 
const $82c56ad253185b59$var$titleContainerStyles = {
    font: "_2sNsIgWSk4"
};
const $82c56ad253185b59$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $82c56ad253185b59$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?"
        })
    }); /*--Body--*/ 
const $82c56ad253185b59$var$DefaultBody = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:"
        })
    }); /*--Reasons List--*/ 
const $82c56ad253185b59$var$reasonsListStyles = null;
const $82c56ad253185b59$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        className: (0, $hekY6.default)([
            "_0aNu0LC2EI _2Zuz6QkG2W _3138428HPE"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                children: reason
            }, index))
    }); /*--Privacy Policy Link--*/ 
const $82c56ad253185b59$var$privacyPolicyLinkWrapperStyles = null; /**
                                              * Translated link to Atlassian's privacy policy.
                                              */ 
const $82c56ad253185b59$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3138428HPE"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian"
            })
        })
    }); /*--Reason Modal--*/ 
const $82c56ad253185b59$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    children: content?.title || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: content?.body || /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$DefaultBody, {}),
                        content?.reasons && /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$ReasonsList, {
                            reasons: content.reasons
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $82c56ad253185b59$export$b29014abf8076d54 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        onClose: props.onClose,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($82c56ad253185b59$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
module.exports["WhyAmISeeingThisModal"] = $82c56ad253185b59$export$b29014abf8076d54;

});

parcelRegister("6vJjN", function(module, exports) {
const $3ad15545469fd5b2$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $3ad15545469fd5b2$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$3ad15545469fd5b2$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $3ad15545469fd5b2$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $3ad15545469fd5b2$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};
module.exports["portalZIndexFix"] = $3ad15545469fd5b2$export$cef2f5415067aeab;

});

parcelRegister("2bWU6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $fRQ3t = parcelRequire("fRQ3t");


var $kSwu1 = parcelRequire("kSwu1");


var $cUA7n = parcelRequire("cUA7n");

const $287f979bb2ca7b6a$var$pendingCleanups = new Set();
const $287f979bb2ca7b6a$export$4d2a53109859e81a = (messageInstanceId, intl)=>{
    const container = globalThis.document.createElement('div');
    container.dataset.testid = 'post-office-standalone-ad-controls-flag-container';
    globalThis.document.body.appendChild(container);
    const root = (0, $fRQ3t.createRoot)(container);
    const cleanup = ()=>{
        $287f979bb2ca7b6a$var$pendingCleanups.delete(cleanup);
        root.unmount();
        container.remove();
    };
    $287f979bb2ca7b6a$var$pendingCleanups.add(cleanup);
    root.render(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: intl.messages,
        onError: intl.onError,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cUA7n.AdControlsFlag), {
            messageInstanceId: messageInstanceId,
            onCloseFlag: cleanup
        })
    }));
};
const $287f979bb2ca7b6a$export$9623f4d81475c62a = ()=>{
    $287f979bb2ca7b6a$var$pendingCleanups.forEach((cleanup)=>cleanup());
};
module.exports["showStandaloneAdControlsFlag"] = $287f979bb2ca7b6a$export$4d2a53109859e81a;

});

parcelRegister("cUA7n", function(module, exports) {
/* dismissalFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");


var $kSwu1 = parcelRequire("kSwu1");


var $6vJjN = parcelRequire("6vJjN");

const $414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper'; /**-Title--**/ 
const $414b7ed3020225de$var$titleContainerStyles = {
    font: "_2sNsIgEqul"
};
const $414b7ed3020225de$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $414b7ed3020225de$var$titleContainerStyles.font,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.dismiss-flag.feedback.title",
            defaultMessage: "Thanks for your feedback"
        })
    }); /**--Confirm Icon--*/ 
const $414b7ed3020225de$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #6A9A23)"
    }); /**-Confirm Dismiss Flag--*/ 
const $414b7ed3020225de$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $6vJjN.portalZIndexFix)($414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: $414b7ed3020225de$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2foB.default), {
                icon: /*#__PURE__*/ (0, $8aG6j.jsx)($414b7ed3020225de$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $8aG6j.jsx)($414b7ed3020225de$var$Title, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};
module.exports["AdControlsFlag"] = $414b7ed3020225de$export$6eb98925a948bca3;

});

parcelRegister("0VqrM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $4Df0x = parcelRequire("4Df0x");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b1390b168e69241b$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
const $b1390b168e69241b$export$bf4c5f97b468e8d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
            svg: $b1390b168e69241b$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function JiraLogoCS({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
        svg: $b1390b168e69241b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraLogoCS"] = $b1390b168e69241b$export$bf4c5f97b468e8d6;

});

parcelRegister("4Df0x", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6cf4ce054ddb9b6b$var$styles = {
    root: "_3iDTPbvbI6 _26BoRwdnbC",
    TEMP_assets: "_0C0F9q1qiM"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $6cf4ce054ddb9b6b$var$logoTextColorMap = {
    light: "_1UtDYzRvDB",
    dark: "_1UtDYzZU00"
};
const $6cf4ce054ddb9b6b$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textLightAppearanceMap = {
    brand: "_07PX8Iy7kJ",
    neutral: "_07PX8IBRVV",
    inverse: "_07PX8It28M",
    legacy: "_07PX8It28M"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textDarkAppearanceMap = {
    brand: "_07PX8Iy7kJ",
    neutral: "_07PX8InrF4",
    inverse: "_07PX8ICl79",
    legacy: "_07PX8It28M"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z66PYH _05MzPYmPNR _0Yajk0kYsX _40KAGSJ5Ia",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
const $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LogoWrapper(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { appearance: t1, size: t2, svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: t3, type: t4 } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const size = t2 === undefined ? "small" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    const t5 = customIconColor === "inherit" ? customTextColor : customIconColor;
    const t6 = customTextColor || "inherit";
    let t7;
    if ($[0] !== t5 || $[1] !== t6) {
        t7 = {
            "--themed-icon-color": t5,
            "--themed-text-color": t6
        };
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = t7;
    const t9 = label ? label : undefined;
    const t10 = label ? "img" : undefined;
    const t11 = label === "" ? true : undefined;
    const t12 = isCustomThemed ? customThemeSvg : svg;
    let t13;
    if ($[3] !== t12) {
        t13 = {
            __html: t12
        };
        $[3] = t12;
        $[4] = t13;
    } else t13 = $[4];
    const t14 = $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? "light"];
    const t15 = $6cf4ce054ddb9b6b$var$sizeMap[size];
    const t16 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance];
    const t17 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance];
    const t18 = type === "rovo" ? colorMode === "dark" ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance];
    let t19;
    if ($[5] !== appearance || $[6] !== isAssets || $[7] !== t14 || $[8] !== t15 || $[9] !== t16 || $[10] !== t17 || $[11] !== t18) {
        t19 = (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            t14,
            t15,
            t16,
            t17,
            t18,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ]);
        $[5] = appearance;
        $[6] = isAssets;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
    } else t19 = $[12];
    let t20;
    if ($[13] !== t10 || $[14] !== t11 || $[15] !== t13 || $[16] !== t19 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t20 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: t8,
            "data-testid": testId,
            "aria-label": t9,
            role: t10,
            "aria-hidden": t11,
            dangerouslySetInnerHTML: t13,
            className: t19
        });
        $[13] = t10;
        $[14] = t11;
        $[15] = t13;
        $[16] = t19;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t20;
    } else t20 = $[20];
    return t20;
} : function LogoWrapper({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? 'light'],
            $6cf4ce054ddb9b6b$var$sizeMap[size],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ])
    });
};
module.exports["LogoWrapper"] = $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644;

});

parcelRegister("9oJIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("MyxIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("5kbLE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $7L44N = parcelRequire("7L44N");


var $6U5eU = parcelRequire("6U5eU");


var $ll379 = parcelRequire("ll379");


var $cozmU = parcelRequire("cozmU");


var $fcLDg = parcelRequire("fcLDg");


var $jBS9T = parcelRequire("jBS9T");

const $a0d19ad2319e4e34$var$STABLE_OBJECT = {};
const $a0d19ad2319e4e34$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $cozmU.useMemo)(()=>(0, $6U5eU.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $1RMKR.useStableObject)(placementProps ?? $a0d19ad2319e4e34$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7L44N.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcLDg.default), {
                    analyticsChannel: (0, $jBS9T.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $a0d19ad2319e4e34$var$PlacementMemoized = /*#__PURE__*/ (0, $cozmU.memo)($a0d19ad2319e4e34$var$Placement);
var $a0d19ad2319e4e34$export$2e2bcd8739ae039 = $a0d19ad2319e4e34$var$PlacementMemoized;
module.exports["default"] = $a0d19ad2319e4e34$export$2e2bcd8739ae039;

});

parcelRegister("7L44N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f1G3w = parcelRequire("f1G3w");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");


var $4OYR1 = parcelRequire("4OYR1");


var $gswTK = parcelRequire("gswTK");


var $9aSEF = parcelRequire("9aSEF");


var $4PX6o = parcelRequire("4PX6o");


var $3raeL = parcelRequire("3raeL");

const $17d7b5e1361d82f3$var$useInitialDataIfEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $bDgLe.c)(10);
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $cozmU.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $17d7b5e1361d82f3$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $17d7b5e1361d82f3$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $17d7b5e1361d82f3$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $a33Aa.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $a33Aa.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $17d7b5e1361d82f3$var$Placement = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $1RMKR.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        $17d7b5e1361d82f3$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb29: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb29;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb29;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb29;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb29;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    const stableContextWithRoute = (0, $1RMKR.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $cozmU.useMemo)(()=>isUFOEnabled ? new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $cozmU.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    $17d7b5e1361d82f3$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $17d7b5e1361d82f3$export$2e2bcd8739ae039 = $17d7b5e1361d82f3$var$Placement;
module.exports["default"] = $17d7b5e1361d82f3$export$2e2bcd8739ae039;

});

parcelRegister("5h1mk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $1RMKR = parcelRequire("1RMKR");

const $a524e85936787c13$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a524e85936787c13$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a524e85936787c13$var$usePostOfficeRouteStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
};
const $a524e85936787c13$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a524e85936787c13$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a524e85936787c13$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a524e85936787c13$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $cozmU.createContext)($a524e85936787c13$var$initialState);
const $a524e85936787c13$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $a524e85936787c13$export$98c77e1bd702ed15(props);
    const route = $a524e85936787c13$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a524e85936787c13$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $a524e85936787c13$export$79301b66f7808cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f);
} : ()=>(0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $a524e85936787c13$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $a524e85936787c13$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $a524e85936787c13$export$79301b66f7808cd8;

});

parcelRegister("9aSEF", function(module, exports) {
const $94018a62770928ba$export$85183a312807388d = 'postOffice';
const $94018a62770928ba$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $94018a62770928ba$export$f7109619a5e9e0d6;

});

parcelRegister("3raeL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");

var $jdpvF = parcelRequire("jdpvF");

const $04b3f6e864eb8426$export$83d6c58b7ab7ae67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    return (0, $cozmU.useMemo)(()=>(0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $04b3f6e864eb8426$export$83d6c58b7ab7ae67;

});

parcelRegister("fcLDg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lzgC6 = parcelRequire("lzgC6");


var $cozmU = parcelRequire("cozmU");

class $45465d036124c3a6$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $45465d036124c3a6$var$ErrorBoundaryWithAnalytics = (0, $lzgC6.default)()($45465d036124c3a6$var$ErrorBoundary);
var $45465d036124c3a6$export$2e2bcd8739ae039 = $45465d036124c3a6$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $45465d036124c3a6$export$2e2bcd8739ae039;

});

parcelRegister("jBS9T", function(module, exports) {
const $27b0c301be1a67fd$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $27b0c301be1a67fd$export$85183a312807388d;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2lwv0", function(module, exports) {

let $1b56c0961b36ae0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b56c0961b36ae0c$var$load("6Ci2O").then(()=>parcelRequire('jpPFR'));

});

parcelRegister("bjj9l", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7ff73ce59b909ea5$export$ac9258c1e2a42c0e = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "U0FPT",
    name: "AgentsAwarenessModalLoadable",
    loader: async ()=>(await (parcelRequire("ikkFW"))).AgentsAwarenessModalConnected
});
module.exports["AgentsAwarenessModalLoadable"] = $7ff73ce59b909ea5$export$ac9258c1e2a42c0e;

});

parcelRegister("ikkFW", function(module, exports) {

let $d57a21fd4797db67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d57a21fd4797db67$var$load("64FEU"),
    $d57a21fd4797db67$var$load("h0X0x"),
    $d57a21fd4797db67$var$load("7l4Nc"),
    $d57a21fd4797db67$var$load("fEvpQ"),
    $d57a21fd4797db67$var$load("dlYE2"),
    $d57a21fd4797db67$var$load("60a9E"),
    $d57a21fd4797db67$var$load("7EorR"),
    $d57a21fd4797db67$var$load("jqoep"),
    $d57a21fd4797db67$var$load("6wr18"),
    $d57a21fd4797db67$var$load("59hV4"),
    $d57a21fd4797db67$var$load("cN2rp"),
    $d57a21fd4797db67$var$load("VXbA1"),
    $d57a21fd4797db67$var$load("ffEVr"),
    $d57a21fd4797db67$var$load("31AYA"),
    $d57a21fd4797db67$var$load("n2DB9"),
    $d57a21fd4797db67$var$load("4jVw5")
]).then(()=>parcelRequire('8WeUp'));

});

parcelRegister("gkVDU", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");


var $bxcP5 = parcelRequire("bxcP5");

const $b122e413b2e9a2d7$export$6e008bd122a517f = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RECENT_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$export$818919f7ea82fa05 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY),
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $b122e413b2e9a2d7$var$expectedPageSegments = [
    $b122e413b2e9a2d7$export$6e008bd122a517f,
    (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT),
    $b122e413b2e9a2d7$export$818919f7ea82fa05
];
const $b122e413b2e9a2d7$export$238b3665fb2c4c64 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.CONFLUENCE_HOME_LOAD_KEY),
    timings: (0, $i3c1S.getWaterfallTimings)($b122e413b2e9a2d7$var$expectedPageSegments),
    include: $b122e413b2e9a2d7$var$expectedPageSegments,
    // Set FMP = FCP if SSR (normally FMP = TTI)
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["HOME_OVERVIEW_RECENT_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$6e008bd122a517f;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT"] = $b122e413b2e9a2d7$export$818919f7ea82fa05;
module.exports["CONFLUENCE_HOME_PAGE_LOAD"] = $b122e413b2e9a2d7$export$238b3665fb2c4c64;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("5tx03"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("5tx03", function(module, exports) {

let $3fc94240cbfcef2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3fc94240cbfcef2f$var$load("aLbuU"),
    $3fc94240cbfcef2f$var$load("hhss7"),
    $3fc94240cbfcef2f$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("8CoyJ"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("fln8Q"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("7wqtP"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("aSm6f"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("6LLF4"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("fdwhW"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("i7McC"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("4PDvd"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3OJGs"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2keEU"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("lGCvn"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1L9Do"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("lDlMC"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("8CoyJ", function(module, exports) {

let $6464ec4b11e0139e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6464ec4b11e0139e$var$load("hUbK8"),
    $6464ec4b11e0139e$var$load("LWh5V"),
    $6464ec4b11e0139e$var$load("eRlPy"),
    $6464ec4b11e0139e$var$load("30b92"),
    $6464ec4b11e0139e$var$load("9cVML"),
    $6464ec4b11e0139e$var$load("4AElS"),
    $6464ec4b11e0139e$var$load("7G12e"),
    $6464ec4b11e0139e$var$load("1Gr4q"),
    $6464ec4b11e0139e$var$load("e95jE"),
    $6464ec4b11e0139e$var$load("cKPFM"),
    $6464ec4b11e0139e$var$load("7SteV"),
    $6464ec4b11e0139e$var$load("6dLts"),
    $6464ec4b11e0139e$var$load("jdPbE"),
    $6464ec4b11e0139e$var$load("L98h8"),
    $6464ec4b11e0139e$var$load("dfVn7"),
    $6464ec4b11e0139e$var$load("aLwQm"),
    $6464ec4b11e0139e$var$load("lkHIj"),
    $6464ec4b11e0139e$var$load("b8BFA"),
    $6464ec4b11e0139e$var$load("keazL"),
    $6464ec4b11e0139e$var$load("dhXIT"),
    $6464ec4b11e0139e$var$load("kHXvF"),
    $6464ec4b11e0139e$var$load("ea3NB"),
    $6464ec4b11e0139e$var$load("59hV4"),
    $6464ec4b11e0139e$var$load("9zpfi"),
    $6464ec4b11e0139e$var$load("9pNir"),
    $6464ec4b11e0139e$var$load("fuOfV"),
    $6464ec4b11e0139e$var$load("jL1Ke"),
    $6464ec4b11e0139e$var$load("5MQ0D"),
    $6464ec4b11e0139e$var$load("cvcNg"),
    $6464ec4b11e0139e$var$load("iZR3N"),
    $6464ec4b11e0139e$var$load("jXM1T"),
    $6464ec4b11e0139e$var$load("6wr18"),
    $6464ec4b11e0139e$var$load("4N1MY"),
    $6464ec4b11e0139e$var$load("ffEVr"),
    $6464ec4b11e0139e$var$load("7BHAC"),
    $6464ec4b11e0139e$var$load("N3TvS"),
    $6464ec4b11e0139e$var$load("5gsbh"),
    $6464ec4b11e0139e$var$load("8lMr1"),
    $6464ec4b11e0139e$var$load("1vUE6"),
    $6464ec4b11e0139e$var$load("h0X0x"),
    $6464ec4b11e0139e$var$load("7l4Nc"),
    $6464ec4b11e0139e$var$load("fwbNS"),
    $6464ec4b11e0139e$var$load("fEvpQ"),
    $6464ec4b11e0139e$var$load("h4Nf7"),
    $6464ec4b11e0139e$var$load("Wowvf"),
    $6464ec4b11e0139e$var$load("4g6rd"),
    $6464ec4b11e0139e$var$load("7A87G"),
    $6464ec4b11e0139e$var$load("hhss7"),
    $6464ec4b11e0139e$var$load("1sii7"),
    $6464ec4b11e0139e$var$load("lnKog"),
    $6464ec4b11e0139e$var$load("kT6dz"),
    $6464ec4b11e0139e$var$load("aAWLw"),
    $6464ec4b11e0139e$var$load("7EorR"),
    $6464ec4b11e0139e$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("fln8Q", function(module, exports) {

let $b2bac4a6264562ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2bac4a6264562ea$var$load("hUbK8"),
    $b2bac4a6264562ea$var$load("LWh5V"),
    $b2bac4a6264562ea$var$load("eRlPy"),
    $b2bac4a6264562ea$var$load("30b92"),
    $b2bac4a6264562ea$var$load("9cVML"),
    $b2bac4a6264562ea$var$load("4AElS"),
    $b2bac4a6264562ea$var$load("7G12e"),
    $b2bac4a6264562ea$var$load("1Gr4q"),
    $b2bac4a6264562ea$var$load("e95jE"),
    $b2bac4a6264562ea$var$load("cKPFM"),
    $b2bac4a6264562ea$var$load("7SteV"),
    $b2bac4a6264562ea$var$load("6dLts"),
    $b2bac4a6264562ea$var$load("jdPbE"),
    $b2bac4a6264562ea$var$load("L98h8"),
    $b2bac4a6264562ea$var$load("dfVn7"),
    $b2bac4a6264562ea$var$load("aLwQm"),
    $b2bac4a6264562ea$var$load("lkHIj"),
    $b2bac4a6264562ea$var$load("b8BFA"),
    $b2bac4a6264562ea$var$load("keazL"),
    $b2bac4a6264562ea$var$load("dhXIT"),
    $b2bac4a6264562ea$var$load("kHXvF"),
    $b2bac4a6264562ea$var$load("ea3NB"),
    $b2bac4a6264562ea$var$load("59hV4"),
    $b2bac4a6264562ea$var$load("9zpfi"),
    $b2bac4a6264562ea$var$load("9pNir"),
    $b2bac4a6264562ea$var$load("fuOfV"),
    $b2bac4a6264562ea$var$load("jL1Ke"),
    $b2bac4a6264562ea$var$load("5MQ0D"),
    $b2bac4a6264562ea$var$load("cvcNg"),
    $b2bac4a6264562ea$var$load("iZR3N"),
    $b2bac4a6264562ea$var$load("jXM1T"),
    $b2bac4a6264562ea$var$load("6wr18"),
    $b2bac4a6264562ea$var$load("4N1MY"),
    $b2bac4a6264562ea$var$load("ffEVr"),
    $b2bac4a6264562ea$var$load("7BHAC"),
    $b2bac4a6264562ea$var$load("N3TvS"),
    $b2bac4a6264562ea$var$load("5gsbh"),
    $b2bac4a6264562ea$var$load("8lMr1"),
    $b2bac4a6264562ea$var$load("1vUE6"),
    $b2bac4a6264562ea$var$load("h0X0x"),
    $b2bac4a6264562ea$var$load("7l4Nc"),
    $b2bac4a6264562ea$var$load("fwbNS"),
    $b2bac4a6264562ea$var$load("fEvpQ"),
    $b2bac4a6264562ea$var$load("h4Nf7"),
    $b2bac4a6264562ea$var$load("Wowvf"),
    $b2bac4a6264562ea$var$load("4g6rd"),
    $b2bac4a6264562ea$var$load("7A87G"),
    $b2bac4a6264562ea$var$load("hhss7"),
    $b2bac4a6264562ea$var$load("1sii7"),
    $b2bac4a6264562ea$var$load("lnKog"),
    $b2bac4a6264562ea$var$load("kT6dz"),
    $b2bac4a6264562ea$var$load("aAWLw"),
    $b2bac4a6264562ea$var$load("7EorR"),
    $b2bac4a6264562ea$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("7wqtP", function(module, exports) {

let $57a00ff211860b2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57a00ff211860b2f$var$load("hUbK8"),
    $57a00ff211860b2f$var$load("LWh5V"),
    $57a00ff211860b2f$var$load("eRlPy"),
    $57a00ff211860b2f$var$load("30b92"),
    $57a00ff211860b2f$var$load("9cVML"),
    $57a00ff211860b2f$var$load("4AElS"),
    $57a00ff211860b2f$var$load("7G12e"),
    $57a00ff211860b2f$var$load("1Gr4q"),
    $57a00ff211860b2f$var$load("e95jE"),
    $57a00ff211860b2f$var$load("cKPFM"),
    $57a00ff211860b2f$var$load("7SteV"),
    $57a00ff211860b2f$var$load("6dLts"),
    $57a00ff211860b2f$var$load("jdPbE"),
    $57a00ff211860b2f$var$load("L98h8"),
    $57a00ff211860b2f$var$load("dfVn7"),
    $57a00ff211860b2f$var$load("aLwQm"),
    $57a00ff211860b2f$var$load("lkHIj"),
    $57a00ff211860b2f$var$load("b8BFA"),
    $57a00ff211860b2f$var$load("keazL"),
    $57a00ff211860b2f$var$load("dhXIT"),
    $57a00ff211860b2f$var$load("kHXvF"),
    $57a00ff211860b2f$var$load("ea3NB"),
    $57a00ff211860b2f$var$load("59hV4"),
    $57a00ff211860b2f$var$load("9zpfi"),
    $57a00ff211860b2f$var$load("9pNir"),
    $57a00ff211860b2f$var$load("fuOfV"),
    $57a00ff211860b2f$var$load("jL1Ke"),
    $57a00ff211860b2f$var$load("5MQ0D"),
    $57a00ff211860b2f$var$load("cvcNg"),
    $57a00ff211860b2f$var$load("iZR3N"),
    $57a00ff211860b2f$var$load("jXM1T"),
    $57a00ff211860b2f$var$load("6wr18"),
    $57a00ff211860b2f$var$load("4N1MY"),
    $57a00ff211860b2f$var$load("ffEVr"),
    $57a00ff211860b2f$var$load("7BHAC"),
    $57a00ff211860b2f$var$load("N3TvS"),
    $57a00ff211860b2f$var$load("5gsbh"),
    $57a00ff211860b2f$var$load("8lMr1"),
    $57a00ff211860b2f$var$load("1vUE6"),
    $57a00ff211860b2f$var$load("h0X0x"),
    $57a00ff211860b2f$var$load("7l4Nc"),
    $57a00ff211860b2f$var$load("fwbNS"),
    $57a00ff211860b2f$var$load("fEvpQ"),
    $57a00ff211860b2f$var$load("h4Nf7"),
    $57a00ff211860b2f$var$load("Wowvf"),
    $57a00ff211860b2f$var$load("4g6rd"),
    $57a00ff211860b2f$var$load("7A87G"),
    $57a00ff211860b2f$var$load("hhss7"),
    $57a00ff211860b2f$var$load("1sii7"),
    $57a00ff211860b2f$var$load("lnKog"),
    $57a00ff211860b2f$var$load("kT6dz"),
    $57a00ff211860b2f$var$load("aAWLw"),
    $57a00ff211860b2f$var$load("7EorR"),
    $57a00ff211860b2f$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("aSm6f", function(module, exports) {

let $7eb01712d39004cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7eb01712d39004cb$var$load("hUbK8"),
    $7eb01712d39004cb$var$load("LWh5V"),
    $7eb01712d39004cb$var$load("eRlPy"),
    $7eb01712d39004cb$var$load("30b92"),
    $7eb01712d39004cb$var$load("9cVML"),
    $7eb01712d39004cb$var$load("4AElS"),
    $7eb01712d39004cb$var$load("7G12e"),
    $7eb01712d39004cb$var$load("1Gr4q"),
    $7eb01712d39004cb$var$load("e95jE"),
    $7eb01712d39004cb$var$load("cKPFM"),
    $7eb01712d39004cb$var$load("7SteV"),
    $7eb01712d39004cb$var$load("6dLts"),
    $7eb01712d39004cb$var$load("jdPbE"),
    $7eb01712d39004cb$var$load("L98h8"),
    $7eb01712d39004cb$var$load("dfVn7"),
    $7eb01712d39004cb$var$load("aLwQm"),
    $7eb01712d39004cb$var$load("lkHIj"),
    $7eb01712d39004cb$var$load("b8BFA"),
    $7eb01712d39004cb$var$load("keazL"),
    $7eb01712d39004cb$var$load("dhXIT"),
    $7eb01712d39004cb$var$load("kHXvF"),
    $7eb01712d39004cb$var$load("ea3NB"),
    $7eb01712d39004cb$var$load("59hV4"),
    $7eb01712d39004cb$var$load("9zpfi"),
    $7eb01712d39004cb$var$load("9pNir"),
    $7eb01712d39004cb$var$load("fuOfV"),
    $7eb01712d39004cb$var$load("jL1Ke"),
    $7eb01712d39004cb$var$load("5MQ0D"),
    $7eb01712d39004cb$var$load("cvcNg"),
    $7eb01712d39004cb$var$load("iZR3N"),
    $7eb01712d39004cb$var$load("jXM1T"),
    $7eb01712d39004cb$var$load("6wr18"),
    $7eb01712d39004cb$var$load("4N1MY"),
    $7eb01712d39004cb$var$load("ffEVr"),
    $7eb01712d39004cb$var$load("7BHAC"),
    $7eb01712d39004cb$var$load("N3TvS"),
    $7eb01712d39004cb$var$load("5gsbh"),
    $7eb01712d39004cb$var$load("8lMr1"),
    $7eb01712d39004cb$var$load("1vUE6"),
    $7eb01712d39004cb$var$load("h0X0x"),
    $7eb01712d39004cb$var$load("7l4Nc"),
    $7eb01712d39004cb$var$load("fwbNS"),
    $7eb01712d39004cb$var$load("fEvpQ"),
    $7eb01712d39004cb$var$load("h4Nf7"),
    $7eb01712d39004cb$var$load("Wowvf"),
    $7eb01712d39004cb$var$load("4g6rd"),
    $7eb01712d39004cb$var$load("7A87G"),
    $7eb01712d39004cb$var$load("hhss7"),
    $7eb01712d39004cb$var$load("1sii7"),
    $7eb01712d39004cb$var$load("lnKog"),
    $7eb01712d39004cb$var$load("kT6dz"),
    $7eb01712d39004cb$var$load("aAWLw"),
    $7eb01712d39004cb$var$load("7EorR"),
    $7eb01712d39004cb$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("6LLF4", function(module, exports) {

let $4edc1a6da3659c4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4edc1a6da3659c4d$var$load("h0X0x"),
    $4edc1a6da3659c4d$var$load("7l4Nc"),
    $4edc1a6da3659c4d$var$load("hUbK8"),
    $4edc1a6da3659c4d$var$load("9cVML"),
    $4edc1a6da3659c4d$var$load("4AElS"),
    $4edc1a6da3659c4d$var$load("7G12e"),
    $4edc1a6da3659c4d$var$load("1Gr4q"),
    $4edc1a6da3659c4d$var$load("e95jE"),
    $4edc1a6da3659c4d$var$load("cKPFM"),
    $4edc1a6da3659c4d$var$load("7SteV"),
    $4edc1a6da3659c4d$var$load("6dLts"),
    $4edc1a6da3659c4d$var$load("jdPbE"),
    $4edc1a6da3659c4d$var$load("L98h8"),
    $4edc1a6da3659c4d$var$load("dfVn7"),
    $4edc1a6da3659c4d$var$load("aLwQm"),
    $4edc1a6da3659c4d$var$load("lkHIj"),
    $4edc1a6da3659c4d$var$load("b8BFA"),
    $4edc1a6da3659c4d$var$load("kHXvF"),
    $4edc1a6da3659c4d$var$load("ea3NB"),
    $4edc1a6da3659c4d$var$load("9zpfi"),
    $4edc1a6da3659c4d$var$load("9pNir"),
    $4edc1a6da3659c4d$var$load("cvcNg"),
    $4edc1a6da3659c4d$var$load("iZR3N"),
    $4edc1a6da3659c4d$var$load("jXM1T"),
    $4edc1a6da3659c4d$var$load("6wr18"),
    $4edc1a6da3659c4d$var$load("4N1MY"),
    $4edc1a6da3659c4d$var$load("ffEVr"),
    $4edc1a6da3659c4d$var$load("7BHAC"),
    $4edc1a6da3659c4d$var$load("N3TvS"),
    $4edc1a6da3659c4d$var$load("5gsbh"),
    $4edc1a6da3659c4d$var$load("8lMr1"),
    $4edc1a6da3659c4d$var$load("1vUE6"),
    $4edc1a6da3659c4d$var$load("1sii7"),
    $4edc1a6da3659c4d$var$load("fEvpQ"),
    $4edc1a6da3659c4d$var$load("h4Nf7"),
    $4edc1a6da3659c4d$var$load("Wowvf"),
    $4edc1a6da3659c4d$var$load("4g6rd"),
    $4edc1a6da3659c4d$var$load("7A87G"),
    $4edc1a6da3659c4d$var$load("hhss7"),
    $4edc1a6da3659c4d$var$load("kT6dz"),
    $4edc1a6da3659c4d$var$load("aAWLw"),
    $4edc1a6da3659c4d$var$load("7EorR"),
    $4edc1a6da3659c4d$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("fdwhW", function(module, exports) {

let $b1411db00e0dc856$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b1411db00e0dc856$var$load("h0X0x"),
    $b1411db00e0dc856$var$load("7l4Nc"),
    $b1411db00e0dc856$var$load("hUbK8"),
    $b1411db00e0dc856$var$load("9cVML"),
    $b1411db00e0dc856$var$load("4AElS"),
    $b1411db00e0dc856$var$load("7G12e"),
    $b1411db00e0dc856$var$load("1Gr4q"),
    $b1411db00e0dc856$var$load("e95jE"),
    $b1411db00e0dc856$var$load("cKPFM"),
    $b1411db00e0dc856$var$load("7SteV"),
    $b1411db00e0dc856$var$load("6dLts"),
    $b1411db00e0dc856$var$load("jdPbE"),
    $b1411db00e0dc856$var$load("L98h8"),
    $b1411db00e0dc856$var$load("dfVn7"),
    $b1411db00e0dc856$var$load("aLwQm"),
    $b1411db00e0dc856$var$load("lkHIj"),
    $b1411db00e0dc856$var$load("b8BFA"),
    $b1411db00e0dc856$var$load("kHXvF"),
    $b1411db00e0dc856$var$load("ea3NB"),
    $b1411db00e0dc856$var$load("9zpfi"),
    $b1411db00e0dc856$var$load("9pNir"),
    $b1411db00e0dc856$var$load("cvcNg"),
    $b1411db00e0dc856$var$load("iZR3N"),
    $b1411db00e0dc856$var$load("jXM1T"),
    $b1411db00e0dc856$var$load("6wr18"),
    $b1411db00e0dc856$var$load("4N1MY"),
    $b1411db00e0dc856$var$load("ffEVr"),
    $b1411db00e0dc856$var$load("7BHAC"),
    $b1411db00e0dc856$var$load("N3TvS"),
    $b1411db00e0dc856$var$load("5gsbh"),
    $b1411db00e0dc856$var$load("8lMr1"),
    $b1411db00e0dc856$var$load("1vUE6"),
    $b1411db00e0dc856$var$load("1sii7"),
    $b1411db00e0dc856$var$load("fEvpQ"),
    $b1411db00e0dc856$var$load("h4Nf7"),
    $b1411db00e0dc856$var$load("Wowvf"),
    $b1411db00e0dc856$var$load("4g6rd"),
    $b1411db00e0dc856$var$load("7A87G"),
    $b1411db00e0dc856$var$load("hhss7"),
    $b1411db00e0dc856$var$load("kT6dz"),
    $b1411db00e0dc856$var$load("aAWLw"),
    $b1411db00e0dc856$var$load("7EorR"),
    $b1411db00e0dc856$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("i7McC", function(module, exports) {

let $d31e4577521d4629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d31e4577521d4629$var$load("h0X0x"),
    $d31e4577521d4629$var$load("7l4Nc"),
    $d31e4577521d4629$var$load("hUbK8"),
    $d31e4577521d4629$var$load("9cVML"),
    $d31e4577521d4629$var$load("4AElS"),
    $d31e4577521d4629$var$load("7G12e"),
    $d31e4577521d4629$var$load("1Gr4q"),
    $d31e4577521d4629$var$load("e95jE"),
    $d31e4577521d4629$var$load("cKPFM"),
    $d31e4577521d4629$var$load("7SteV"),
    $d31e4577521d4629$var$load("6dLts"),
    $d31e4577521d4629$var$load("jdPbE"),
    $d31e4577521d4629$var$load("L98h8"),
    $d31e4577521d4629$var$load("dfVn7"),
    $d31e4577521d4629$var$load("aLwQm"),
    $d31e4577521d4629$var$load("lkHIj"),
    $d31e4577521d4629$var$load("b8BFA"),
    $d31e4577521d4629$var$load("kHXvF"),
    $d31e4577521d4629$var$load("ea3NB"),
    $d31e4577521d4629$var$load("9zpfi"),
    $d31e4577521d4629$var$load("9pNir"),
    $d31e4577521d4629$var$load("cvcNg"),
    $d31e4577521d4629$var$load("iZR3N"),
    $d31e4577521d4629$var$load("jXM1T"),
    $d31e4577521d4629$var$load("6wr18"),
    $d31e4577521d4629$var$load("4N1MY"),
    $d31e4577521d4629$var$load("ffEVr"),
    $d31e4577521d4629$var$load("7BHAC"),
    $d31e4577521d4629$var$load("N3TvS"),
    $d31e4577521d4629$var$load("5gsbh"),
    $d31e4577521d4629$var$load("8lMr1"),
    $d31e4577521d4629$var$load("1vUE6"),
    $d31e4577521d4629$var$load("1sii7"),
    $d31e4577521d4629$var$load("fEvpQ"),
    $d31e4577521d4629$var$load("h4Nf7"),
    $d31e4577521d4629$var$load("Wowvf"),
    $d31e4577521d4629$var$load("4g6rd"),
    $d31e4577521d4629$var$load("7A87G"),
    $d31e4577521d4629$var$load("hhss7"),
    $d31e4577521d4629$var$load("kT6dz"),
    $d31e4577521d4629$var$load("aAWLw"),
    $d31e4577521d4629$var$load("7EorR"),
    $d31e4577521d4629$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("4PDvd", function(module, exports) {

let $384a9132593faf2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $384a9132593faf2a$var$load("h0X0x"),
    $384a9132593faf2a$var$load("7l4Nc"),
    $384a9132593faf2a$var$load("hUbK8"),
    $384a9132593faf2a$var$load("9cVML"),
    $384a9132593faf2a$var$load("4AElS"),
    $384a9132593faf2a$var$load("7G12e"),
    $384a9132593faf2a$var$load("1Gr4q"),
    $384a9132593faf2a$var$load("e95jE"),
    $384a9132593faf2a$var$load("cKPFM"),
    $384a9132593faf2a$var$load("7SteV"),
    $384a9132593faf2a$var$load("6dLts"),
    $384a9132593faf2a$var$load("jdPbE"),
    $384a9132593faf2a$var$load("L98h8"),
    $384a9132593faf2a$var$load("dfVn7"),
    $384a9132593faf2a$var$load("aLwQm"),
    $384a9132593faf2a$var$load("lkHIj"),
    $384a9132593faf2a$var$load("b8BFA"),
    $384a9132593faf2a$var$load("kHXvF"),
    $384a9132593faf2a$var$load("ea3NB"),
    $384a9132593faf2a$var$load("9zpfi"),
    $384a9132593faf2a$var$load("9pNir"),
    $384a9132593faf2a$var$load("cvcNg"),
    $384a9132593faf2a$var$load("iZR3N"),
    $384a9132593faf2a$var$load("jXM1T"),
    $384a9132593faf2a$var$load("6wr18"),
    $384a9132593faf2a$var$load("4N1MY"),
    $384a9132593faf2a$var$load("ffEVr"),
    $384a9132593faf2a$var$load("7BHAC"),
    $384a9132593faf2a$var$load("N3TvS"),
    $384a9132593faf2a$var$load("5gsbh"),
    $384a9132593faf2a$var$load("8lMr1"),
    $384a9132593faf2a$var$load("1vUE6"),
    $384a9132593faf2a$var$load("fEvpQ"),
    $384a9132593faf2a$var$load("h4Nf7"),
    $384a9132593faf2a$var$load("Wowvf"),
    $384a9132593faf2a$var$load("4g6rd"),
    $384a9132593faf2a$var$load("7A87G"),
    $384a9132593faf2a$var$load("hhss7"),
    $384a9132593faf2a$var$load("1sii7"),
    $384a9132593faf2a$var$load("lnKog"),
    $384a9132593faf2a$var$load("kT6dz"),
    $384a9132593faf2a$var$load("aAWLw"),
    $384a9132593faf2a$var$load("7EorR"),
    $384a9132593faf2a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3OJGs", function(module, exports) {

let $2c797a725c1ae67a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c797a725c1ae67a$var$load("hUbK8"),
    $2c797a725c1ae67a$var$load("30b92"),
    $2c797a725c1ae67a$var$load("9cVML"),
    $2c797a725c1ae67a$var$load("4AElS"),
    $2c797a725c1ae67a$var$load("7G12e"),
    $2c797a725c1ae67a$var$load("1Gr4q"),
    $2c797a725c1ae67a$var$load("e95jE"),
    $2c797a725c1ae67a$var$load("cKPFM"),
    $2c797a725c1ae67a$var$load("7SteV"),
    $2c797a725c1ae67a$var$load("6dLts"),
    $2c797a725c1ae67a$var$load("jdPbE"),
    $2c797a725c1ae67a$var$load("L98h8"),
    $2c797a725c1ae67a$var$load("dfVn7"),
    $2c797a725c1ae67a$var$load("aLwQm"),
    $2c797a725c1ae67a$var$load("lkHIj"),
    $2c797a725c1ae67a$var$load("b8BFA"),
    $2c797a725c1ae67a$var$load("keazL"),
    $2c797a725c1ae67a$var$load("dhXIT"),
    $2c797a725c1ae67a$var$load("kHXvF"),
    $2c797a725c1ae67a$var$load("ea3NB"),
    $2c797a725c1ae67a$var$load("59hV4"),
    $2c797a725c1ae67a$var$load("9zpfi"),
    $2c797a725c1ae67a$var$load("9pNir"),
    $2c797a725c1ae67a$var$load("fuOfV"),
    $2c797a725c1ae67a$var$load("jL1Ke"),
    $2c797a725c1ae67a$var$load("5MQ0D"),
    $2c797a725c1ae67a$var$load("cvcNg"),
    $2c797a725c1ae67a$var$load("iZR3N"),
    $2c797a725c1ae67a$var$load("jXM1T"),
    $2c797a725c1ae67a$var$load("6wr18"),
    $2c797a725c1ae67a$var$load("4N1MY"),
    $2c797a725c1ae67a$var$load("ffEVr"),
    $2c797a725c1ae67a$var$load("7BHAC"),
    $2c797a725c1ae67a$var$load("N3TvS"),
    $2c797a725c1ae67a$var$load("5gsbh"),
    $2c797a725c1ae67a$var$load("8lMr1"),
    $2c797a725c1ae67a$var$load("1vUE6"),
    $2c797a725c1ae67a$var$load("h0X0x"),
    $2c797a725c1ae67a$var$load("7l4Nc"),
    $2c797a725c1ae67a$var$load("fwbNS"),
    $2c797a725c1ae67a$var$load("fEvpQ"),
    $2c797a725c1ae67a$var$load("h4Nf7"),
    $2c797a725c1ae67a$var$load("Wowvf"),
    $2c797a725c1ae67a$var$load("4g6rd"),
    $2c797a725c1ae67a$var$load("7A87G"),
    $2c797a725c1ae67a$var$load("hhss7"),
    $2c797a725c1ae67a$var$load("1sii7"),
    $2c797a725c1ae67a$var$load("lnKog"),
    $2c797a725c1ae67a$var$load("kT6dz"),
    $2c797a725c1ae67a$var$load("aAWLw"),
    $2c797a725c1ae67a$var$load("7EorR"),
    $2c797a725c1ae67a$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2keEU", function(module, exports) {

let $1b18d1fd65a78b59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b18d1fd65a78b59$var$load("hUbK8"),
    $1b18d1fd65a78b59$var$load("30b92"),
    $1b18d1fd65a78b59$var$load("9cVML"),
    $1b18d1fd65a78b59$var$load("4AElS"),
    $1b18d1fd65a78b59$var$load("7G12e"),
    $1b18d1fd65a78b59$var$load("1Gr4q"),
    $1b18d1fd65a78b59$var$load("e95jE"),
    $1b18d1fd65a78b59$var$load("cKPFM"),
    $1b18d1fd65a78b59$var$load("7SteV"),
    $1b18d1fd65a78b59$var$load("6dLts"),
    $1b18d1fd65a78b59$var$load("jdPbE"),
    $1b18d1fd65a78b59$var$load("L98h8"),
    $1b18d1fd65a78b59$var$load("dfVn7"),
    $1b18d1fd65a78b59$var$load("aLwQm"),
    $1b18d1fd65a78b59$var$load("lkHIj"),
    $1b18d1fd65a78b59$var$load("b8BFA"),
    $1b18d1fd65a78b59$var$load("keazL"),
    $1b18d1fd65a78b59$var$load("dhXIT"),
    $1b18d1fd65a78b59$var$load("kHXvF"),
    $1b18d1fd65a78b59$var$load("ea3NB"),
    $1b18d1fd65a78b59$var$load("59hV4"),
    $1b18d1fd65a78b59$var$load("9zpfi"),
    $1b18d1fd65a78b59$var$load("9pNir"),
    $1b18d1fd65a78b59$var$load("fuOfV"),
    $1b18d1fd65a78b59$var$load("jL1Ke"),
    $1b18d1fd65a78b59$var$load("5MQ0D"),
    $1b18d1fd65a78b59$var$load("cvcNg"),
    $1b18d1fd65a78b59$var$load("iZR3N"),
    $1b18d1fd65a78b59$var$load("jXM1T"),
    $1b18d1fd65a78b59$var$load("6wr18"),
    $1b18d1fd65a78b59$var$load("4N1MY"),
    $1b18d1fd65a78b59$var$load("ffEVr"),
    $1b18d1fd65a78b59$var$load("7BHAC"),
    $1b18d1fd65a78b59$var$load("N3TvS"),
    $1b18d1fd65a78b59$var$load("5gsbh"),
    $1b18d1fd65a78b59$var$load("8lMr1"),
    $1b18d1fd65a78b59$var$load("1vUE6"),
    $1b18d1fd65a78b59$var$load("h0X0x"),
    $1b18d1fd65a78b59$var$load("7l4Nc"),
    $1b18d1fd65a78b59$var$load("fwbNS"),
    $1b18d1fd65a78b59$var$load("fEvpQ"),
    $1b18d1fd65a78b59$var$load("h4Nf7"),
    $1b18d1fd65a78b59$var$load("Wowvf"),
    $1b18d1fd65a78b59$var$load("4g6rd"),
    $1b18d1fd65a78b59$var$load("7A87G"),
    $1b18d1fd65a78b59$var$load("hhss7"),
    $1b18d1fd65a78b59$var$load("1sii7"),
    $1b18d1fd65a78b59$var$load("lnKog"),
    $1b18d1fd65a78b59$var$load("kT6dz"),
    $1b18d1fd65a78b59$var$load("aAWLw"),
    $1b18d1fd65a78b59$var$load("7EorR"),
    $1b18d1fd65a78b59$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("lGCvn", function(module, exports) {

let $fc9b638b32ba4f63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc9b638b32ba4f63$var$load("h0X0x"),
    $fc9b638b32ba4f63$var$load("7l4Nc"),
    $fc9b638b32ba4f63$var$load("hUbK8"),
    $fc9b638b32ba4f63$var$load("9cVML"),
    $fc9b638b32ba4f63$var$load("4AElS"),
    $fc9b638b32ba4f63$var$load("7G12e"),
    $fc9b638b32ba4f63$var$load("1Gr4q"),
    $fc9b638b32ba4f63$var$load("e95jE"),
    $fc9b638b32ba4f63$var$load("cKPFM"),
    $fc9b638b32ba4f63$var$load("7SteV"),
    $fc9b638b32ba4f63$var$load("6dLts"),
    $fc9b638b32ba4f63$var$load("jdPbE"),
    $fc9b638b32ba4f63$var$load("L98h8"),
    $fc9b638b32ba4f63$var$load("dfVn7"),
    $fc9b638b32ba4f63$var$load("aLwQm"),
    $fc9b638b32ba4f63$var$load("lkHIj"),
    $fc9b638b32ba4f63$var$load("b8BFA"),
    $fc9b638b32ba4f63$var$load("kHXvF"),
    $fc9b638b32ba4f63$var$load("ea3NB"),
    $fc9b638b32ba4f63$var$load("9zpfi"),
    $fc9b638b32ba4f63$var$load("9pNir"),
    $fc9b638b32ba4f63$var$load("cvcNg"),
    $fc9b638b32ba4f63$var$load("iZR3N"),
    $fc9b638b32ba4f63$var$load("jXM1T"),
    $fc9b638b32ba4f63$var$load("6wr18"),
    $fc9b638b32ba4f63$var$load("4N1MY"),
    $fc9b638b32ba4f63$var$load("ffEVr"),
    $fc9b638b32ba4f63$var$load("7BHAC"),
    $fc9b638b32ba4f63$var$load("N3TvS"),
    $fc9b638b32ba4f63$var$load("5gsbh"),
    $fc9b638b32ba4f63$var$load("8lMr1"),
    $fc9b638b32ba4f63$var$load("1vUE6"),
    $fc9b638b32ba4f63$var$load("1sii7"),
    $fc9b638b32ba4f63$var$load("fEvpQ"),
    $fc9b638b32ba4f63$var$load("h4Nf7"),
    $fc9b638b32ba4f63$var$load("Wowvf"),
    $fc9b638b32ba4f63$var$load("4g6rd"),
    $fc9b638b32ba4f63$var$load("7A87G"),
    $fc9b638b32ba4f63$var$load("hhss7"),
    $fc9b638b32ba4f63$var$load("kT6dz"),
    $fc9b638b32ba4f63$var$load("aAWLw"),
    $fc9b638b32ba4f63$var$load("7EorR"),
    $fc9b638b32ba4f63$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1L9Do", function(module, exports) {

let $1481a76df074217e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1481a76df074217e$var$load("h0X0x"),
    $1481a76df074217e$var$load("7l4Nc"),
    $1481a76df074217e$var$load("hUbK8"),
    $1481a76df074217e$var$load("9cVML"),
    $1481a76df074217e$var$load("4AElS"),
    $1481a76df074217e$var$load("7G12e"),
    $1481a76df074217e$var$load("1Gr4q"),
    $1481a76df074217e$var$load("e95jE"),
    $1481a76df074217e$var$load("cKPFM"),
    $1481a76df074217e$var$load("7SteV"),
    $1481a76df074217e$var$load("6dLts"),
    $1481a76df074217e$var$load("jdPbE"),
    $1481a76df074217e$var$load("L98h8"),
    $1481a76df074217e$var$load("dfVn7"),
    $1481a76df074217e$var$load("aLwQm"),
    $1481a76df074217e$var$load("lkHIj"),
    $1481a76df074217e$var$load("b8BFA"),
    $1481a76df074217e$var$load("kHXvF"),
    $1481a76df074217e$var$load("ea3NB"),
    $1481a76df074217e$var$load("9zpfi"),
    $1481a76df074217e$var$load("9pNir"),
    $1481a76df074217e$var$load("cvcNg"),
    $1481a76df074217e$var$load("iZR3N"),
    $1481a76df074217e$var$load("jXM1T"),
    $1481a76df074217e$var$load("6wr18"),
    $1481a76df074217e$var$load("4N1MY"),
    $1481a76df074217e$var$load("ffEVr"),
    $1481a76df074217e$var$load("7BHAC"),
    $1481a76df074217e$var$load("N3TvS"),
    $1481a76df074217e$var$load("5gsbh"),
    $1481a76df074217e$var$load("8lMr1"),
    $1481a76df074217e$var$load("1vUE6"),
    $1481a76df074217e$var$load("fEvpQ"),
    $1481a76df074217e$var$load("h4Nf7"),
    $1481a76df074217e$var$load("Wowvf"),
    $1481a76df074217e$var$load("4g6rd"),
    $1481a76df074217e$var$load("7A87G"),
    $1481a76df074217e$var$load("hhss7"),
    $1481a76df074217e$var$load("1sii7"),
    $1481a76df074217e$var$load("lnKog"),
    $1481a76df074217e$var$load("kT6dz"),
    $1481a76df074217e$var$load("aAWLw"),
    $1481a76df074217e$var$load("7EorR"),
    $1481a76df074217e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("lDlMC", function(module, exports) {

let $04107c702544292c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $04107c702544292c$var$load("h0X0x"),
    $04107c702544292c$var$load("7l4Nc"),
    $04107c702544292c$var$load("hUbK8"),
    $04107c702544292c$var$load("9cVML"),
    $04107c702544292c$var$load("4AElS"),
    $04107c702544292c$var$load("7G12e"),
    $04107c702544292c$var$load("1Gr4q"),
    $04107c702544292c$var$load("e95jE"),
    $04107c702544292c$var$load("cKPFM"),
    $04107c702544292c$var$load("7SteV"),
    $04107c702544292c$var$load("6dLts"),
    $04107c702544292c$var$load("jdPbE"),
    $04107c702544292c$var$load("L98h8"),
    $04107c702544292c$var$load("dfVn7"),
    $04107c702544292c$var$load("aLwQm"),
    $04107c702544292c$var$load("lkHIj"),
    $04107c702544292c$var$load("b8BFA"),
    $04107c702544292c$var$load("kHXvF"),
    $04107c702544292c$var$load("ea3NB"),
    $04107c702544292c$var$load("9zpfi"),
    $04107c702544292c$var$load("9pNir"),
    $04107c702544292c$var$load("cvcNg"),
    $04107c702544292c$var$load("iZR3N"),
    $04107c702544292c$var$load("jXM1T"),
    $04107c702544292c$var$load("6wr18"),
    $04107c702544292c$var$load("4N1MY"),
    $04107c702544292c$var$load("ffEVr"),
    $04107c702544292c$var$load("7BHAC"),
    $04107c702544292c$var$load("N3TvS"),
    $04107c702544292c$var$load("5gsbh"),
    $04107c702544292c$var$load("8lMr1"),
    $04107c702544292c$var$load("1vUE6"),
    $04107c702544292c$var$load("fEvpQ"),
    $04107c702544292c$var$load("h4Nf7"),
    $04107c702544292c$var$load("Wowvf"),
    $04107c702544292c$var$load("4g6rd"),
    $04107c702544292c$var$load("7A87G"),
    $04107c702544292c$var$load("hhss7"),
    $04107c702544292c$var$load("1sii7"),
    $04107c702544292c$var$load("lnKog"),
    $04107c702544292c$var$load("43z9c"),
    $04107c702544292c$var$load("kT6dz"),
    $04107c702544292c$var$load("aAWLw"),
    $04107c702544292c$var$load("7EorR"),
    $04107c702544292c$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("gkfdt"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("gkfdt", function(module, exports) {

let $be2a513de0ab94be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be2a513de0ab94be$var$load("1sii7"),
    $be2a513de0ab94be$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("4lbme", function(module, exports) {
/* CollapsibleSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $9DHhW = parcelRequire("9DHhW");


var $b3j2Y = parcelRequire("b3j2Y");


var $h1Vf7 = parcelRequire("h1Vf7");

const $b317972e35a48dec$var$collapsibleStyles = null;
const $b317972e35a48dec$var$collapsibleCollapsedStyles = null;
const $b317972e35a48dec$var$headerExpandCollapseButtonStyles = {
    default: "_2sNsIgmnOE _4FKVYE2ADO _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _30huDKPgdg _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _39xV02N91d _0KLXruqi9L _1mT5xdHE3j _2IhTonB0rP _42Yu6B7dHp _2C2kUQ8fU6 _1Lz9lo8fU6 _0ReiIH7zJH",
    collapsed: "_0bjKvD8fU6",
    expanded: "_1x1D3gPgdg"
};
const $b317972e35a48dec$var$headerActionsWrapperStyles = null;
const $b317972e35a48dec$var$collasibleContentStyles = null; /**
                                       * CollapsibleSection should be used within the right rail on the home screen. All sections of the right rail should
                                       * be placed inside of a CollapsibleSection. Local storage and collapsed state will be handled within this component.
                                       *
                                       * By default the header will be displayed when the section is expanded, to hide the header use the prop
                                       * hideHeaderWhenExpanded. If hideHeaderWhenExpanded is false, the content of the section will occupy the full width
                                       * with 24px of left and right padding. If hidHeaderWhenExpanded is true the content will only occupy the space left
                                       * of the expand/collapse button with 24px of left padding and 40px of right padding.
                                       *
                                       * @param sectionId: Unique identifier for the section, used for local storage
                                       * @param header: React node to appear in the header. By default the header will be rendered in the expanded state
                                       * @param hideHeaderWhenExpanded: Boolean value that, when true, will hide the header when the section is expanded
                                       * @param children: React node to be rendered in the expanded state. Children must be styled appropriately.
                                       */ 
const $b317972e35a48dec$export$55b973e094275b13 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ sectionId: sectionId, header: header, headerActions: headerActions, children: children, defaultState: defaultState, initialStateOverride: initialStateOverride, onInitialCollapse: onInitialCollapse, ariaLabel: ariaLabel }, ref)=>{
    const { widgetState: widgetState, setWidgetState: setWidgetState, loading: loading, error: error } = (0, $h1Vf7.useHomeWidgetState)(sectionId, defaultState, initialStateOverride);
    const isCollapsed = widgetState === 'COLLAPSED';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const checkedInitialState = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (loading || checkedInitialState.current) return;
        checkedInitialState.current = true;
        if (widgetState === 'COLLAPSED') onInitialCollapse?.();
    }, [
        loading,
        widgetState,
        onInitialCollapse
    ]);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'collapsibleSection',
                actionSubjectId: sectionId,
                source: 'rightPanel',
                attributes: {
                    homeVersion: '1.5'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        sectionId
    ]);
    const onClick = (0, $cozmU.useCallback)(()=>{
        const onCollapse = ()=>{
            setWidgetState('COLLAPSED');
            fireAnalyticsEvent('collapsed');
        };
        const onExpand = ()=>{
            setWidgetState('EXPANDED');
            fireAnalyticsEvent('expanded');
        };
        isCollapsed ? onExpand() : onCollapse();
    }, [
        isCollapsed,
        setWidgetState,
        fireAnalyticsEvent
    ]);
    if (loading) return null;
    const Icon = isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const headerId = `home-right-panel-header-${sectionId}`;
    const sectionHeaderCompiled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        id: headerId,
        onClick: onClick,
        "aria-expanded": !isCollapsed,
        "aria-controls": "collapsible-content",
        "aria-label": ariaLabel,
        className: (0, $hekY6.default)([
            $b317972e35a48dec$var$headerExpandCollapseButtonStyles['default'],
            isCollapsed && $b317972e35a48dec$var$headerExpandCollapseButtonStyles['collapsed'],
            !isCollapsed && $b317972e35a48dec$var$headerExpandCollapseButtonStyles['expanded']
        ])
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO2Va5s _2IhTon2ADO _42Yu6B7dHp"
        ])
    }, headerActions));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": sectionId,
        className: (0, $hekY6.default)([
            "_30huDKOeNX _0bjKvD8fU6 _0KLXruqi9L _1mT5xdRAKS _1DCdHi8HPE",
            isCollapsed && "_3fSdSTzwhj"
        ])
    }, sectionHeaderCompiled, isCollapsed ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "collapsible-content",
        role: "region",
        "aria-labelledby": headerId,
        className: (0, $hekY6.default)([
            "_4FKVYE2ADO"
        ])
    }, children), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
});
module.exports["CollapsibleSection"] = $b317972e35a48dec$export$55b973e094275b13;

});

parcelRegister("jYZYm", function(module, exports) {

var $3b6WO = parcelRequire("3b6WO");


var $7Ndnw = parcelRequire("7Ndnw");

const $092337d0b1510a67$var$useForgeAppsVisible = ()=>{
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED)
    });
    return Array.isArray(extensions) && extensions.length > 0;
};
const $092337d0b1510a67$export$4da380cd3efc4347 = ()=>{
    const shouldShowForgeApps = $092337d0b1510a67$var$useForgeAppsVisible();
    const shouldShowRightPanel = shouldShowForgeApps;
    return {
        shouldShowRightPanel: shouldShowRightPanel,
        shouldShowForgeApps: shouldShowForgeApps
    };
};
module.exports["useRightPanelVisible"] = $092337d0b1510a67$export$4da380cd3efc4347;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    let t6;
    if ($[4] !== cloudId || $[5] !== contentId || $[6] !== locale || $[7] !== moduleType || $[8] !== queryOptions || $[9] !== resolvedAttachmentId || $[10] !== returnBlockedExtensions || $[11] !== skipQuery || $[12] !== spaceContextOnly || $[13] !== spaceKey) {
        t6 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[4] = cloudId;
        $[5] = contentId;
        $[6] = locale;
        $[7] = moduleType;
        $[8] = queryOptions;
        $[9] = resolvedAttachmentId;
        $[10] = returnBlockedExtensions;
        $[11] = skipQuery;
        $[12] = spaceContextOnly;
        $[13] = spaceKey;
        $[14] = t6;
    } else t6 = $[14];
    const options = t6;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t7;
    let t8;
    if ($[15] !== extsError || $[16] !== spaceError) {
        t7 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t8 = [
            extsError,
            spaceError
        ];
        $[15] = extsError;
        $[16] = spaceError;
        $[17] = t7;
        $[18] = t8;
    } else {
        t7 = $[17];
        t8 = $[18];
    }
    (0, $cozmU.useEffect)(t7, t8);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t9;
        if ($[19] !== ssrExtensionResult.error || $[20] !== ssrExtensionResult.extensions) {
            t9 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[19] = ssrExtensionResult.error;
            $[20] = ssrExtensionResult.extensions;
            $[21] = t9;
        } else t9 = $[21];
        return t9;
    }
    let t9;
    if ($[22] !== extsData || $[23] !== extsError || $[24] !== extsLoading) {
        t9 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[22] = extsData;
        $[23] = extsError;
        $[24] = extsLoading;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $89u2G = parcelRequire("89u2G");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    const canUseSharedDetail = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (!includeSpaceTypeSettings || sharedDetail?.space?.spaceTypeSettings !== undefined);
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== canUseSharedDetail || $[6] !== skip) {
        t5 = skip || canUseSharedDetail ? {
            skip: true
        } : {};
        $[5] = canUseSharedDetail;
        $[6] = skip;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const options = t6;
    const legacyResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    let t7;
    if ($[12] !== canUseSharedDetail || $[13] !== legacyResult || $[14] !== sharedDetail) {
        t7 = canUseSharedDetail && sharedDetail ? {
            loading: sharedDetail.loading,
            data: sharedDetail.space ? {
                space: sharedDetail.space
            } : undefined,
            error: undefined
        } : legacyResult;
        $[12] = canUseSharedDetail;
        $[13] = legacyResult;
        $[14] = sharedDetail;
        $[15] = t7;
    } else t7 = $[15];
    const { loading: loading, data: data, error: error } = t7;
    let t8;
    if ($[16] !== data || $[17] !== includeSpaceTypeSettings) {
        t8 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[16] = data;
        $[17] = includeSpaceTypeSettings;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== error || $[20] !== loading || $[21] !== t8) {
        t9 = {
            loading: loading,
            data: t8,
            error: error
        };
        $[19] = error;
        $[20] = loading;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("89u2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $452d11e5a10e2733$export$4ae6180efef498fb = (0, $cozmU.createContext)(undefined);
module.exports["SpaceDetailContext"] = $452d11e5a10e2733$export$4ae6180efef498fb;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("kzakG", function(module, exports) {

let $ef8f175e6299359f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef8f175e6299359f$var$load("aRNbZ").then(()=>parcelRequire('h5BLU'));

});

parcelRegister("bEEQ6", function(module, exports) {
const $c82e65c5c2902855$var$HTML_COMMENT = /<!--[\s\S]*?-->/g;
const $c82e65c5c2902855$var$HTML_TAG = /<[^>]*>/g;
const $c82e65c5c2902855$var$NON_BREAKING_SPACE_ENTITY = /&nbsp;|&#0*160;|&#x0*a0;/gi;
const $c82e65c5c2902855$var$HTML_ENTITY = /&(#\d+|#x[0-9a-f]+|[a-z][a-z0-9]*);/gi;
const $c82e65c5c2902855$export$53566f8da078c4e8 = (messageHtml)=>{
    if (!messageHtml) return false;
    const textContent = messageHtml.replace($c82e65c5c2902855$var$HTML_COMMENT, '').replace($c82e65c5c2902855$var$HTML_TAG, '').replace($c82e65c5c2902855$var$NON_BREAKING_SPACE_ENTITY, ' ').replace($c82e65c5c2902855$var$HTML_ENTITY, 'x');
    return textContent.trim().length > 0;
};
module.exports["hasVisibleWelcomeMessageContent"] = $c82e65c5c2902855$export$53566f8da078c4e8;

});

parcelRegister("aG3WN", function(module, exports) {

var $lqPdm = parcelRequire("lqPdm");


var $g8ETs = parcelRequire("g8ETs");

const $d9239c45a3f6799f$var$decToHex = (dec)=>{
    return Number(dec).toString(16).toUpperCase();
};
const $d9239c45a3f6799f$var$padToTwo = (str)=>{
    return str.padStart(2, '0');
};
const $d9239c45a3f6799f$var$rgbToHex = (r, g, b)=>{
    const hexR = $d9239c45a3f6799f$var$padToTwo($d9239c45a3f6799f$var$decToHex(r));
    const hexG = $d9239c45a3f6799f$var$padToTwo($d9239c45a3f6799f$var$decToHex(g));
    const hexB = $d9239c45a3f6799f$var$padToTwo($d9239c45a3f6799f$var$decToHex(b));
    return `#${hexR}${hexG}${hexB}`;
};
const $d9239c45a3f6799f$var$rgbRegex = RegExp("rgb\\((?<red>\\d+), ?(?<green>\\d+), ?(?<blue>\\d+)\\)", "i");
const $d9239c45a3f6799f$export$10c7415ad1921d7e = (color)=>{
    const rgbMatch = color.match($d9239c45a3f6799f$var$rgbRegex);
    if (rgbMatch) {
        const red = rgbMatch.groups?.red ?? '';
        const green = rgbMatch.groups?.green ?? '';
        const blue = rgbMatch.groups?.blue ?? '';
        return $d9239c45a3f6799f$var$rgbToHex(red, green, blue);
    }
    return color;
};


const $90eec90e6b0288fc$var$customTextColors = {
    '#0000FF': "var(--ds-link, #1868DB)",
    '#7A869A': "var(--ds-text-subtlest, #6B6E76)",
    '#808080': "var(--ds-text-subtlest, #6B6E76)",
    '#1D1C1D': "var(--ds-text, #292A2E)",
    '#000000': "var(--ds-text, #292A2E)"
};
const $90eec90e6b0288fc$var$getTextColor = (color)=>{
    const paletteColor = (0, $g8ETs.hexToEditorTextPaletteColor)(color);
    if (paletteColor) return paletteColor;
    return $90eec90e6b0288fc$var$customTextColors[color];
};
const $90eec90e6b0288fc$var$replaceColor = (oldColor, newColor, cssProperty, html)=>{
    if (!newColor) return html;
    const stringToMatch = `${cssProperty}: ${oldColor}`;
    const stringToReplace = `${cssProperty}: ${newColor}`;
    return html.replaceAll(stringToMatch, stringToReplace);
};
// @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
const $90eec90e6b0288fc$var$styleAttributeRegex = RegExp('style=".*?"', "gis");
const $90eec90e6b0288fc$var$colorRegex = // @ts-expect-error - TS1503, TS1503, TS1501 Typescript 5.9.2 upgrade
RegExp("(?<cssProperty>background-color|color): (?<cssValue>rgb\\(\\d+,\\d+,\\d+\\)|#[A-F0-9]{3,6});?", "gis");
const $90eec90e6b0288fc$export$e6a03cef30ccf7b2 = (welcomeMessageHtml)=>{
    const backgroundColors = new Set();
    const textColors = new Set();
    const styleTags = welcomeMessageHtml.matchAll($90eec90e6b0288fc$var$styleAttributeRegex);
    for (const styleTag of styleTags){
        const colorDeclarations = styleTag[0].matchAll($90eec90e6b0288fc$var$colorRegex);
        for (const colorDeclaration of colorDeclarations){
            const cssProperty = colorDeclaration.groups?.cssProperty;
            const cssValue = colorDeclaration.groups?.cssValue;
            if (cssValue && cssProperty === 'background-color') backgroundColors.add(cssValue);
            else if (cssValue && cssProperty === 'color') textColors.add(cssValue);
        }
    }
    backgroundColors.forEach((backgroundColor)=>{
        const hexColor = (0, $d9239c45a3f6799f$export$10c7415ad1921d7e)(backgroundColor);
        const newColor = (0, $lqPdm.hexToEditorBackgroundPaletteColor)(hexColor);
        welcomeMessageHtml = $90eec90e6b0288fc$var$replaceColor(backgroundColor, newColor, 'background-color', welcomeMessageHtml);
    });
    textColors.forEach((textColor)=>{
        const hexColor = (0, $d9239c45a3f6799f$export$10c7415ad1921d7e)(textColor);
        const newColor = $90eec90e6b0288fc$var$getTextColor(hexColor);
        welcomeMessageHtml = $90eec90e6b0288fc$var$replaceColor(textColor, newColor, 'color', welcomeMessageHtml);
    });
    return welcomeMessageHtml;
};


const $d6455ec006a125e0$export$4de80e2f3cf2ffef = {
    welcomeMessageEditUrl: '',
    welcomeMessageHtml: '',
    isWelcomeMessageCustomized: false,
    showWelcomeMessageEditHint: false,
    showEditButton: false,
    resourceKeys: [
        ''
    ],
    resourceContexts: [
        ''
    ]
};
function $d6455ec006a125e0$var$nonNull(item) {
    return item != null;
}
const $d6455ec006a125e0$export$3ceb62baab058c6b = (data)=>{
    if (!data) return $d6455ec006a125e0$export$4de80e2f3cf2ffef;
    const { welcomeMessageEditUrl: welcomeMessageEditUrl, welcomeMessageHtml: welcomeMessageHtml, isWelcomeMessageCustomized: isWelcomeMessageCustomized, resourceKeys: resourceKeys, resourceContexts: resourceContexts, showWelcomeMessageEditHint: showWelcomeMessageEditHint, showEditButton: showEditButton } = data.spaViewContext || {};
    const contextData = {
        welcomeMessageEditUrl: welcomeMessageEditUrl,
        welcomeMessageHtml: welcomeMessageHtml,
        isWelcomeMessageCustomized: isWelcomeMessageCustomized,
        showWelcomeMessageEditHint: showWelcomeMessageEditHint,
        showEditButton: showEditButton,
        resourceKeys: resourceKeys?.filter($d6455ec006a125e0$var$nonNull),
        resourceContexts: resourceContexts?.filter($d6455ec006a125e0$var$nonNull)
    };
    // replace null values from query data with default values
    for (const [key, value] of Object.entries(contextData))if (value === null || value === undefined) contextData[key] = $d6455ec006a125e0$export$4de80e2f3cf2ffef[key];
    contextData.welcomeMessageHtml = (0, $90eec90e6b0288fc$export$e6a03cef30ccf7b2)(contextData.welcomeMessageHtml ?? '');
    return contextData;
};
module.exports["transformData"] = $d6455ec006a125e0$export$3ceb62baab058c6b;

});

parcelRegister("7zvyU", function(module, exports) {

var $cMfVN = parcelRequire("cMfVN");

const $63356045f46a9126$export$b219f21d745a9c1c = (0, $cMfVN.default);
module.exports["WelcomeMessagesQuery"] = $63356045f46a9126$export$b219f21d745a9c1c;

});

parcelRegister("2LyZS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4j4gm = parcelRequire("4j4gm");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

const $88dfee758a89de6e$export$da99457d6430d83 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { duration: t2, timingFunction: t3 } = t1;
    let t4;
    if ($[2] !== t2) {
        t4 = t2 === undefined ? $88dfee758a89de6e$var$_temp : t2;
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const calcDuration = t4;
    let t5;
    if ($[4] !== t3) {
        t5 = t3 === undefined ? $88dfee758a89de6e$var$_temp2 : t3;
        $[4] = t3;
        $[5] = t5;
    } else t5 = $[5];
    const calcTimingFunction = t5;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            cleanup: "next-effect"
        };
        $[6] = t6;
    } else t6 = $[6];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t6);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t7;
    if ($[7] !== element) {
        t7 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            prevDimensions.current = element.getBoundingClientRect();
        };
        $[7] = element;
        $[8] = t7;
    } else t7 = $[8];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t7);
    let t8;
    if ($[9] !== calcDuration || $[10] !== calcTimingFunction || $[11] !== element || $[12] !== requestAnimationFrame || $[13] !== setTimeout) {
        t8 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const nextDimensions = element.getBoundingClientRect();
            if (nextDimensions.height === prevDimensions.current.height) return;
            const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
            const newStyles = {
                height: `${prevDimensions.current.height}px`,
                willChange: "height",
                transitionProperty: "height",
                transitionDuration: `${duration}ms`,
                boxSizing: "border-box",
                transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                    }, duration);
                });
            });
        };
        $[9] = calcDuration;
        $[10] = calcTimingFunction;
        $[11] = element;
        $[12] = requestAnimationFrame;
        $[13] = setTimeout;
        $[14] = t8;
    } else t8 = $[14];
    (0, $7BVQi.useLayoutEffect)(t8);
    let t9;
    if ($[15] !== setElementRef) {
        t9 = {
            ref: setElementRef
        };
        $[15] = setElementRef;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ duration: calcDuration = ()=>(0, $4dGdo.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $4j4gm.easeInOut) } = {})=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
function $88dfee758a89de6e$var$_temp() {
    return (0, $4dGdo.durations).medium;
}
function $88dfee758a89de6e$var$_temp2() {
    return 0, $4j4gm.easeInOut;
}
module.exports["useResizingHeight"] = $88dfee758a89de6e$export$da99457d6430d83;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("9oezN", function(module, exports) {

const $6b7b6fc399a60c96$export$47e445a2288f991 = async ({ resetAfter: resetAfter = 3000 } = {})=>{
    let confetti = null;
    try {
        confetti = (await (parcelRequire("kKI5W"))).default;
    } catch (error) {
        return;
    }
    if (!confetti) return;
    // mirrors the confetti animation in Atlas
    const baseProps = {
        particleCount: 120,
        spread: 55,
        ticks: 225,
        zIndex: 2000,
        scalar: 1.5,
        startVelocity: 100,
        colors: [
            '#6554C0',
            '#0065FF',
            '#00B8D9',
            '#FF5630',
            '#FFAB00',
            '#36B37E'
        ]
    };
    // right corner
    confetti({
        ...baseProps,
        origin: {
            x: 1,
            y: 1
        },
        angle: 120
    });
    // left corner
    confetti({
        ...baseProps,
        origin: {
            x: 0,
            y: 1
        },
        angle: 60
    });
    if (resetAfter) setTimeout(()=>{
        confetti?.reset();
    }, resetAfter);
};
module.exports["popOnboardingConfetti"] = $6b7b6fc399a60c96$export$47e445a2288f991;

});

parcelRegister("kKI5W", function(module, exports) {

let $f1ba4ed9657a2954$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1ba4ed9657a2954$var$load("PPycq").then(()=>parcelRequire('f47tV'));

});

parcelRegister("9iaFM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $3LWAs = parcelRequire("3LWAs");

function $f21d3adc78722ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f21d3adc78722ef1$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $f21d3adc78722ef1$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $f21d3adc78722ef1$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $f21d3adc78722ef1$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $f21d3adc78722ef1$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $f21d3adc78722ef1$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $f21d3adc78722ef1$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $f21d3adc78722ef1$var$baseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$f21d3adc78722ef1$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$f21d3adc78722ef1$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$f21d3adc78722ef1$var$gridTemplateRowsVar})`
});
const $f21d3adc78722ef1$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $f21d3adc78722ef1$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $cozmU.useMemo)(()=>({
            [$f21d3adc78722ef1$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$f21d3adc78722ef1$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$f21d3adc78722ef1$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f21d3adc78722ef1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $3LWAs.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $3LWAs.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $3LWAs.spaceStylesMap).rowGap[rowGap],
            alignItems && $f21d3adc78722ef1$var$alignItemsMap[alignItems],
            alignContent && $f21d3adc78722ef1$var$alignContentMap[alignContent],
            justifyContent && $f21d3adc78722ef1$var$justifyContentMap[justifyContent],
            autoFlow && $f21d3adc78722ef1$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f21d3adc78722ef1$export$ef2184bd89960b14.displayName = 'Grid';
module.exports["Grid"] = $f21d3adc78722ef1$export$ef2184bd89960b14;

});

parcelRegister("3nne7", function(module, exports) {

let $2755896a03916d84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2755896a03916d84$var$load("alg5Q"),
    $2755896a03916d84$var$load("6wr18"),
    $2755896a03916d84$var$load("7PNtH"),
    $2755896a03916d84$var$load("eqGBA"),
    $2755896a03916d84$var$load("8yk9S"),
    $2755896a03916d84$var$load("hE9re"),
    $2755896a03916d84$var$load("dChty"),
    $2755896a03916d84$var$load("Wowvf"),
    $2755896a03916d84$var$load("ffEVr"),
    $2755896a03916d84$var$load("kGjlO")
]).then(()=>parcelRequire('blj77'));

});

parcelRegister("hxdG1", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $c9db3b2bd4f34a4a$var$PTV2Store = (0, $8s9DV.createStore)({
    initialState: {
        teamType: '',
        subAnchor: '',
        personalSpaceKey: '',
        isTemplateListDismissed: true,
        personalizationHeuristic: '',
        onboardingPeriodDay: 0,
        isXflow: false,
        source: ''
    },
    actions: {
        setIsTemplateListDismissed: (isTemplateListDismissed)=>({ setState: setState })=>{
                setState({
                    isTemplateListDismissed: isTemplateListDismissed
                });
            }
    },
    name: 'PTV2Store'
});
const $c9db3b2bd4f34a4a$export$2011a7877d539b4d = (0, $kBr4q.createStateHook)($c9db3b2bd4f34a4a$var$PTV2Store);
const $c9db3b2bd4f34a4a$export$e08a7878fceccdd4 = (0, $kBr4q.createHook)($c9db3b2bd4f34a4a$var$PTV2Store);
const $c9db3b2bd4f34a4a$export$94a688c7da2f7e6d = (0, $j8on0.createContainer)($c9db3b2bd4f34a4a$var$PTV2Store, {
    onInit: ()=>({ setState: setState }, { teamType: teamType, subAnchor: subAnchor, personalSpaceKey: personalSpaceKey, isTemplateListDismissed: isTemplateListDismissed, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source })=>{
            setState({
                teamType: teamType,
                subAnchor: subAnchor,
                personalSpaceKey: personalSpaceKey,
                isTemplateListDismissed: isTemplateListDismissed,
                personalizationHeuristic: personalizationHeuristic,
                onboardingPeriodDay: onboardingPeriodDay,
                isXflow: isXflow,
                source: source
            });
        }
});
module.exports["usePTV2State"] = $c9db3b2bd4f34a4a$export$2011a7877d539b4d;
module.exports["usePTV2Store"] = $c9db3b2bd4f34a4a$export$e08a7878fceccdd4;
module.exports["PTV2StoreContainer"] = $c9db3b2bd4f34a4a$export$94a688c7da2f7e6d;

});

parcelRegister("3wfPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a18c9eb6ca149354$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");

const $a18c9eb6ca149354$var$cssStyles = {
    borderStyles: "_0bjKvD8fU6 _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8",
    cardContainerStyles: "_1mT5xdRAKS _0NUa3rs38O",
    pressableStyles: "_39xV02N91d _0KLXrunmFW _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1eOmH6o126",
    imageContainerStyles: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3rNNui _1Lz9lo8fU6 _2C2kUQ8fU6",
    imageHiddenStyles: "_3iDTPbYbGa",
    completedCardStyles: "_1YKVNsVx3j",
    contentContainerStyles: "_2mHwu8NHnM _0NUa3rVazu _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _4xdlr0FlnN",
    textStyles: "_2fwxA5ecOK",
    ctaStyles: "_2mHwu81Y8M _1UtDYzZpcK",
    dismissIconStyles: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO _0wOv4Q7zJH"
};
// This styling is used in case an image that is too small is passed in to fit the card width
const $a18c9eb6ca149354$var$imageStyles = null;
const $a18c9eb6ca149354$var$ellipsisTextStyles = null; //  This styling is for setting limits on text for heading and will truncate with ellipses
const $a18c9eb6ca149354$var$headingTextOverflowStyles = null;
const $a18c9eb6ca149354$var$descriptionTextOverflowStyles = null;
function $a18c9eb6ca149354$export$2e2bcd8739ae039({ image: image, heading: heading, description: description, onClick: onClick, hrefLink: hrefLink, showAsExternalLink: showAsExternalLink, onDismiss: onDismiss, ctaText: ctaText, ctaCompletedText: ctaCompletedText, dismissTooltip: dismissTooltip, headingSize: headingSize, hasBorder: hasBorder, cardCompleted: cardCompleted, enableCompletedOnClick: enableCompletedOnClick = true }) {
    const [gif, img, component] = [
        image,
        image,
        image
    ];
    const isComponentImage = Boolean(component.component);
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    const [dismissed, setDismissed] = (0, $cozmU.useState)(false);
    const [hasClicked, setHasClicked] = (0, $cozmU.useState)(false); // Component image doens't require skeleton loading. Can set this to true straight away.
    const [imageLoaded, setImageLoaded] = (0, $cozmU.useState)(isComponentImage);
    const isCardCompleted = hasClicked || cardCompleted === true; // If showAsExternalLink is true, it will always be shown an external link, otherwise it will only be an external link if the hrefLink does not include 'wiki'.
    const isExternalLink = hrefLink && (showAsExternalLink ?? !hrefLink.includes('wiki'));
    const handleCardClick = (event)=>{
        if (onClick) onClick(event);
        if (hrefLink) {
            if (isExternalLink) window.open(hrefLink, '_blank');
            else window.location.href = hrefLink;
        }
        if (enableCompletedOnClick) setHasClicked(true);
    };
    const handleDismiss = ()=>{
        onDismiss();
        setDismissed(true);
    };
    if (dismissed) return null;
    let [imageSrc, darkModeImageSrc] = [
        img.src,
        img.srcDark || img.src
    ]; // Have dark mode default to light mode in case it was not passed in
    if (gif.gif && gif.staticImageGif) {
        if (hovered) [imageSrc, darkModeImageSrc] = [
            gif.gif,
            gif.darkModeGif || gif.gif
        ];
        else [imageSrc, darkModeImageSrc] = [
            gif.staticImageGif,
            gif.staticDarkModeImageGif || gif.staticImageGif
        ];
    }
    let componentSrc;
    if (isComponentImage) componentSrc = colorMode === 'dark' && component.componentDark || component.component;
    const headingComponentSize = headingSize ? headingSize : 'small';
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a18c9eb6ca149354$var$cssStyles.cardContainerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onClick: handleCardClick,
        xcss: (0, $w6R6I.cx)($a18c9eb6ca149354$var$cssStyles.pressableStyles, isCardCompleted && $a18c9eb6ca149354$var$cssStyles.completedCardStyles, hasBorder && $a18c9eb6ca149354$var$cssStyles.borderStyles)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, !imageLoaded && /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: "128px",
        width: "100%",
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: !imageLoaded ? $a18c9eb6ca149354$var$cssStyles.imageHiddenStyles : $a18c9eb6ca149354$var$cssStyles.imageContainerStyles
    }, isComponentImage ? componentSrc : /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: imageSrc,
        srcDark: darkModeImageSrc,
        alt: "",
        onLoad: ()=>setImageLoaded(true),
        className: (0, $hekY6.default)([
            "_39xV02N91d _00EA0eiObl"
        ])
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $a18c9eb6ca149354$var$cssStyles.contentContainerStyles,
        alignItems: "start",
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        alignItems: "start",
        gap: "space.050",
        xcss: $a18c9eb6ca149354$var$cssStyles.textStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: heading,
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1ANEUSzUZr _39HuIbz8Lp _1U1ZhbbI28",
            "_0NUa3rSPN1 _4Gn54R7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: headingComponentSize
    }, heading))), /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: description,
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VUofl"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest"
    }, description)))), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $a18c9eb6ca149354$var$cssStyles.ctaStyles
    }, isCardCompleted ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, ctaCompletedText)) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, ctaText), isExternalLink && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: "",
        testId: "shortcut-icon"
    })))))), hovered && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a18c9eb6ca149354$var$cssStyles.dismissIconStyles,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        testId: "button-dismiss",
        isTooltipDisabled: false,
        onClick: handleDismiss,
        label: dismissTooltip,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), iconProps)
    })));
}

});

parcelRegister("9uxfR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ivb8S = parcelRequire("ivb8S");


var $1gy7x = parcelRequire("1gy7x");

function $bbea2b83a9125021$var$deserializeOnboardingActionStates(serializedValues, OnboardingActionCards) {
    try {
        const values = JSON.parse(serializedValues || '{}');
        if (typeof values !== 'object') return {};
        const ONBOARDING_ACTION_IDS = OnboardingActionCards.map((action)=>action.id);
        // Return a mapping of all onboarding action IDs to their states.
        const states = ONBOARDING_ACTION_IDS.reduce((states, id)=>({
                ...states,
                [id]: values[id]
            }), {});
        return states;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        return {};
    }
}
function $bbea2b83a9125021$var$serializeOnboardingActionStates(onboardingActionStates) {
    return JSON.stringify(onboardingActionStates);
}
function $bbea2b83a9125021$export$8eb8c3792bd3aae4(HomeOnboardingTakeoverCardsList, onboardingStateData, onboardingActionStatesKey = (0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS).onboardingActionStates) {
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { onboardingActionStates: serializedOnboardingActionStates, hasUserPublished: hasUserPublished, hasDismissedOnboardingActions: hasDismissedOnboardingActions } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const onboardingActionStates = (0, $cozmU.useMemo)(()=>{
        return $bbea2b83a9125021$var$deserializeOnboardingActionStates(serializedOnboardingActionStates, HomeOnboardingTakeoverCardsList);
    }, [
        serializedOnboardingActionStates,
        HomeOnboardingTakeoverCardsList
    ]);
    const actions = (0, $cozmU.useMemo)(()=>{
        const mappedActions = HomeOnboardingTakeoverCardsList.map((action)=>({
                id: action.id,
                state: onboardingActionStates[action.id] || 'pending'
            }));
        return mappedActions;
    }, [
        HomeOnboardingTakeoverCardsList,
        onboardingActionStates
    ]);
    const dismiss = (0, $cozmU.useMemo)(()=>(id)=>{
            const newState = {
                ...onboardingActionStates,
                [id]: 'dismissed'
            };
            setOnboardingState({
                key: onboardingActionStatesKey,
                value: $bbea2b83a9125021$var$serializeOnboardingActionStates(newState)
            });
        }, [
        onboardingActionStates,
        setOnboardingState,
        onboardingActionStatesKey
    ]);
    const complete = (0, $cozmU.useMemo)(()=>(id)=>{
            const newState = {
                ...onboardingActionStates,
                [id]: 'completed'
            };
            setOnboardingState({
                key: onboardingActionStatesKey,
                value: $bbea2b83a9125021$var$serializeOnboardingActionStates(newState)
            });
        }, [
        onboardingActionStates,
        setOnboardingState,
        onboardingActionStatesKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        const hasntCreatedPage = actions.some((action)=>action.id === 'createPage' && action.state === 'pending');
        if (hasUserPublished && hasntCreatedPage) complete('createPage');
    }, [
        hasUserPublished,
        complete,
        actions
    ]);
    return {
        actions: actions,
        dismiss: dismiss,
        complete: complete,
        hasDismissedOnboardingActions: hasDismissedOnboardingActions
    };
}
module.exports["usePersonalizedTemplateOnboardingActions"] = $bbea2b83a9125021$export$8eb8c3792bd3aae4;

});

parcelRegister("6RlQ2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $lRWIF = parcelRequire("lRWIF");

const $06dec2aa340c091a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    useCasePlanAndTrackProjects: {
        id: "confluence-account-setup.use-cases.plan-and-track-projects",
        defaultMessage: "Plan and track projects \uD83D\uDDD3\uFE0F"
    },
    useCaseCaptureMeetingNotesAndActions: {
        id: "confluence-account-setup.use-cases.capture-meeting-notes-and-actions",
        defaultMessage: "Capture meeting notes and actions \uD83D\uDCDD"
    },
    useCaseBrainstormAndExploreIdeas: {
        id: "confluence-account-setup.use-cases.brainstorm-and-explore-ideas",
        defaultMessage: "Brainstorm and explore ideas \uD83D\uDCA1"
    },
    useCaseDocumentTechSpecsAndDecisions: {
        id: "confluence-account-setup.use-cases.document-tech-specs-and-decisions",
        defaultMessage: "Document tech specs and decisions \uD83D\uDCDD"
    },
    useCaseCentralizeCodebaseAndProcessGuides: {
        id: "confluence-account-setup.use-cases.centralize-codebase-and-process-guides",
        defaultMessage: "Centralize codebase and process guides \uD83D\uDCDA"
    },
    useCasePlanSprintsAndRunRetros: {
        id: "confluence-account-setup.use-cases.plan-sprints-and-run-retros",
        defaultMessage: "Plan sprints and run retros \uD83D\uDD01"
    },
    useCaseDocumentMeetingsAndRunRetros: {
        id: "confluence-account-setup.use-cases.document-meetings-and-run-retros",
        defaultMessage: "Document meetings and run retros \uD83D\uDCDD"
    },
    useCaseTrackGoalsAndOkrs: {
        id: "confluence-account-setup.use-cases.track-goals-and-okrs",
        defaultMessage: "Track goals and OKRs \uD83C\uDFAF"
    },
    useCasePlanAndTrackCampaigns: {
        id: "confluence-account-setup.use-cases.plan-and-track-campaigns",
        defaultMessage: "Plan and track campaigns \uD83D\uDCE3"
    },
    useCaseDraftMarketingContent: {
        id: "confluence-account-setup.use-cases.draft-marketing-content",
        defaultMessage: "Draft marketing content \uD83D\uDCDD"
    },
    useCaseCentralizeMarketingInsightsAndGuides: {
        id: "confluence-account-setup.use-cases.centralize-marketing-insights-and-guides",
        defaultMessage: "Centralize marketing insights and guides \uD83C\uDFDB\uFE0F"
    },
    useCaseConductWorkshopsAndReviews: {
        id: "confluence-account-setup.use-cases.conduct-workshops-and-reviews",
        defaultMessage: "Conduct workshops and reviews \uD83D\uDDE3\uFE0F"
    },
    useCaseDocumentDesignDecisionsAndFlows: {
        id: "confluence-account-setup.use-cases.document-design-decisions-and-flows",
        defaultMessage: "Document design decisions and flows \uD83C\uDFA8"
    },
    useCaseCentralizeUserInsightsAndJourneys: {
        id: "confluence-account-setup.use-cases.centralize-user-insights-and-journeys",
        defaultMessage: "Centralize user insights and journeys \uD83D\uDDC2\uFE0F"
    },
    useCaseWriteProductRequirements: {
        id: "confluence-account-setup.use-cases.write-product-requirements",
        defaultMessage: "Write product requirements \uD83E\uDDFE"
    },
    useCaseCraftStrategiesAndRoadmaps: {
        id: "confluence-account-setup.use-cases.craft-strategies-and-roadmaps",
        defaultMessage: "Craft strategies and roadmaps \uD83D\uDDFA\uFE0F"
    },
    useCaseDocumentSopsAndWorkflows: {
        id: "confluence-account-setup.use-cases.document-sops-and-workflows",
        defaultMessage: "Document SOPs and workflows \uD83D\uDCCB"
    },
    useCaseShareHowToAndTroubleshootingDocs: {
        id: "confluence-account-setup.use-cases.share-how-to-and-troubleshooting-docs",
        defaultMessage: "Share how-to and troubleshooting docs \uD83D\uDCDA"
    },
    useCaseStoreTeamProceduresAndReferences: {
        id: "confluence-account-setup.use-cases.store-team-procedures-and-references",
        defaultMessage: "Store team procedures and references \uD83D\uDCCB"
    },
    useCaseDocumentIncidentsAndResolutions: {
        id: "confluence-account-setup.use-cases.document-incidents-and-resolutions",
        defaultMessage: "Document incidents and resolutions \uD83D\uDEE0\uFE0F"
    },
    useCaseShareFinancialResultsAndPlans: {
        id: "confluence-account-setup.use-cases.share-financial-results-and-plans",
        defaultMessage: "Share financial results and plans \uD83D\uDCCA"
    },
    useCaseShareHrPoliciesAndGuides: {
        id: "confluence-account-setup.use-cases.share-hr-policies-and-guides",
        defaultMessage: "Share HR policies and guides \uD83D\uDCD6"
    },
    useCaseAcquireAndOnboardNewTalent: {
        id: "confluence-account-setup.use-cases.acquire-and-onboard-new-talent",
        defaultMessage: "Acquire and onboard new talent \uD83D\uDC64"
    },
    useCaseShareLegalTemplatesAndGuides: {
        id: "confluence-account-setup.use-cases.share-legal-templates-and-guides",
        defaultMessage: "Share legal templates and guides \uD83D\uDCAC"
    },
    useCaseCreateTeamPlaybooks: {
        id: "confluence-account-setup.use-cases.create-team-playbooks",
        defaultMessage: "Create team playbooks \uD83D\uDCD6"
    },
    useCaseManageLeadsAndDeals: {
        id: "confluence-account-setup.use-cases.manage-leads-and-deals",
        defaultMessage: "Manage leads and deals \uD83D\uDDC2\uFE0F"
    },
    useCaseReportProgressAndPerformance: {
        id: "confluence-account-setup.use-cases.report-progress-and-performance",
        defaultMessage: "Report progress and performance \uD83D\uDCC8"
    },
    useCaseTemplateProjectPlan: {
        id: "confluence-account-setup.use-cases.templates.project-plan",
        defaultMessage: "Project Plan"
    },
    useCaseTemplateWeeklyStatusReport: {
        id: "confluence-account-setup.use-cases.templates.weekly-status-report",
        defaultMessage: "Weekly status report"
    },
    useCaseTemplateMeetingNotes: {
        id: "confluence-account-setup.use-cases.templates.meeting-notes",
        defaultMessage: "Meeting Notes"
    },
    useCaseTemplateToDoList: {
        id: "confluence-account-setup.use-cases.templates.to-do-list",
        defaultMessage: "To-do list"
    },
    useCaseTemplateCrazy8s: {
        id: "confluence-account-setup.use-cases.templates.crazy-8s",
        defaultMessage: "Crazy 8s"
    },
    useCaseTemplateBrainstormSession: {
        id: "confluence-account-setup.use-cases.templates.brainstorm-session",
        defaultMessage: "Brainstorm session"
    },
    useCaseTemplateFlowchart: {
        id: "confluence-account-setup.use-cases.templates.flowchart",
        defaultMessage: "Flowchart"
    },
    useCaseTemplateDaciDecisionDocumentation: {
        id: "confluence-account-setup.use-cases.templates.daci-decision-documentation",
        defaultMessage: "DACI: Decision Documentation"
    },
    useCaseTemplateArchitectureDiagram: {
        id: "confluence-account-setup.use-cases.templates.architecture-diagram",
        defaultMessage: "Architecture diagram"
    },
    useCaseTemplateDevopsRunbook: {
        id: "confluence-account-setup.use-cases.templates.devops-runbook",
        defaultMessage: "DevOps Runbook"
    },
    useCaseTemplateSprintPlanning: {
        id: "confluence-account-setup.use-cases.templates.sprint-planning",
        defaultMessage: "Sprint planning"
    },
    useCaseTemplateRetrospective: {
        id: "confluence-account-setup.use-cases.templates.retrospective",
        defaultMessage: "Retrospective"
    },
    useCaseTemplateOkrs: {
        id: "confluence-account-setup.use-cases.templates.okrs",
        defaultMessage: "OKRs"
    },
    useCaseTemplateBusinessReview: {
        id: "confluence-account-setup.use-cases.templates.business-review",
        defaultMessage: "Business review"
    },
    useCaseTemplateMarketingCampaign: {
        id: "confluence-account-setup.use-cases.templates.marketing-campaign",
        defaultMessage: "Marketing Campaign"
    },
    useCaseTemplateBusinessStatusUpdate: {
        id: "confluence-account-setup.use-cases.templates.business-status-update",
        defaultMessage: "Business status update"
    },
    useCaseTemplateMarketingBlogPost: {
        id: "confluence-account-setup.use-cases.templates.marketing-blog-post",
        defaultMessage: "Marketing blog post"
    },
    useCaseTemplateElevatorPitchBrainstorm: {
        id: "confluence-account-setup.use-cases.templates.elevator-pitch-brainstorm",
        defaultMessage: "Elevator pitch brainstorm"
    },
    useCaseTemplateMessageHouse: {
        id: "confluence-account-setup.use-cases.templates.message-house",
        defaultMessage: "Message house"
    },
    useCaseTemplateUserPersona: {
        id: "confluence-account-setup.use-cases.templates.user-persona",
        defaultMessage: "User Persona"
    },
    useCaseTemplateDesignReview: {
        id: "confluence-account-setup.use-cases.templates.design-review",
        defaultMessage: "Design Review"
    },
    useCaseTemplateDesignSprint: {
        id: "confluence-account-setup.use-cases.templates.design-sprint",
        defaultMessage: "Design Sprint"
    },
    useCaseTemplateDesignDecision: {
        id: "confluence-account-setup.use-cases.templates.design-decision",
        defaultMessage: "Design decision"
    },
    useCaseTemplateCustomerInterviewReport: {
        id: "confluence-account-setup.use-cases.templates.customer-interview-report",
        defaultMessage: "Customer interview report"
    },
    useCaseTemplateProductRequirements: {
        id: "confluence-account-setup.use-cases.templates.product-requirements",
        defaultMessage: "Product Requirements"
    },
    useCaseTemplateProductRoadmap: {
        id: "confluence-account-setup.use-cases.templates.product-roadmap",
        defaultMessage: "Product roadmap"
    },
    useCaseTemplateProductVisionBoard: {
        id: "confluence-account-setup.use-cases.templates.product-vision-board",
        defaultMessage: "Product Vision Board"
    },
    useCaseTemplateSop: {
        id: "confluence-account-setup.use-cases.templates.sop",
        defaultMessage: "SOP"
    },
    useCaseTemplateWorkflow: {
        id: "confluence-account-setup.use-cases.templates.workflow",
        defaultMessage: "Workflow"
    },
    useCaseTemplateHowToArticle: {
        id: "confluence-account-setup.use-cases.templates.how-to-article",
        defaultMessage: "How-to article"
    },
    useCaseTemplateTroubleshootingArticle: {
        id: "confluence-account-setup.use-cases.templates.troubleshooting-article",
        defaultMessage: "Troubleshooting article"
    },
    useCaseTemplateItsmRunbook: {
        id: "confluence-account-setup.use-cases.templates.itsm-runbook",
        defaultMessage: "ITSM runbook"
    },
    useCaseTemplateItsmKnownErrors: {
        id: "confluence-account-setup.use-cases.templates.itsm-known-errors",
        defaultMessage: "ITSM Known Errors"
    },
    useCaseTemplateIncidentPostmortem: {
        id: "confluence-account-setup.use-cases.templates.incident-postmortem",
        defaultMessage: "Incident Postmortem"
    },
    useCaseTemplateWeeklyIncidentReport: {
        id: "confluence-account-setup.use-cases.templates.weekly-incident-report",
        defaultMessage: "Weekly incident report"
    },
    useCaseTemplateAnnualPlanOnePager: {
        id: "confluence-account-setup.use-cases.templates.annual-plan-one-pager",
        defaultMessage: "Annual Plan One Pager"
    },
    useCaseTemplateHrKnowledgeBase: {
        id: "confluence-account-setup.use-cases.templates.hr-knowledge-base",
        defaultMessage: "HR Knowledge Base"
    },
    useCaseTemplateOrganizationalChart: {
        id: "confluence-account-setup.use-cases.templates.organizational-chart",
        defaultMessage: "Organizational chart"
    },
    useCaseTemplateHiringProcess: {
        id: "confluence-account-setup.use-cases.templates.hiring-process",
        defaultMessage: "Hiring Process"
    },
    useCaseTemplateNinetyDayPlan: {
        id: "confluence-account-setup.use-cases.templates.90-day-plan",
        defaultMessage: "90 Day Plan"
    },
    useCaseTemplateVendorAgreement: {
        id: "confluence-account-setup.use-cases.templates.vendor-agreement",
        defaultMessage: "Vendor Agreement"
    },
    useCaseTemplateRiskAssessment: {
        id: "confluence-account-setup.use-cases.templates.risk-assessment",
        defaultMessage: "Risk Assessment"
    },
    useCaseTemplateSalesPortal: {
        id: "confluence-account-setup.use-cases.templates.sales-portal",
        defaultMessage: "Sales Portal"
    },
    useCaseTemplateSalesAccountPlanning: {
        id: "confluence-account-setup.use-cases.templates.sales-account-planning",
        defaultMessage: "Sales Account Planning"
    },
    useCaseTemplateMutualActionPlan: {
        id: "confluence-account-setup.use-cases.templates.mutual-action-plan",
        defaultMessage: "Mutual Action Plan"
    },
    useCaseTemplateExecutiveBusinessReview: {
        id: "confluence-account-setup.use-cases.templates.executive-business-review",
        defaultMessage: "Executive Business Review"
    },
    useCaseTemplatePresenterMode: {
        id: "confluence-account-setup.use-cases.templates.presenter-mode",
        defaultMessage: "Presenter mode"
    }
});
var $06dec2aa340c091a$export$76ba949a27a98dfc = /*#__PURE__*/ function(UseCaseTemplate) {
    UseCaseTemplate["NinetyDayPlan"] = "ninety-day-plan";
    UseCaseTemplate["AnnualPlanOnePager"] = "annual-plan-one-pager";
    UseCaseTemplate["ArchitectureDiagram"] = "architecture-diagram";
    UseCaseTemplate["BrainstormSession"] = "brainstorm-session";
    UseCaseTemplate["BusinessReview"] = "business-review";
    UseCaseTemplate["BusinessStatusUpdate"] = "business-status-update";
    UseCaseTemplate["Crazy8s"] = "crazy-8s";
    // Whiteboard
    UseCaseTemplate["CustomerInterviewReport"] = "customer-interview-report";
    UseCaseTemplate["DaciDecisionDocumentation"] = "daci-decision-documentation";
    UseCaseTemplate["DesignDecision"] = "design-decision";
    UseCaseTemplate["DesignReview"] = "design-review";
    UseCaseTemplate["DesignSprint"] = "design-sprint";
    UseCaseTemplate["DevopsRunbook"] = "devops-runbook";
    UseCaseTemplate["ElevatorPitchBrainstorm"] = "elevator-pitch";
    // Whiteboard
    UseCaseTemplate["ExecutiveBusinessReview"] = "executive-business-review";
    UseCaseTemplate["Flowchart"] = "flow-chart";
    // Whiteboard
    UseCaseTemplate["HiringProcess"] = "hiring-process";
    UseCaseTemplate["HowToArticle"] = "how-to-article";
    UseCaseTemplate["HrKnowledgeBase"] = "hr-knowledge-base";
    UseCaseTemplate["IncidentPostmortem"] = "incident-postmortem";
    UseCaseTemplate["ItsmKnownErrors"] = "itsm-known-errors";
    UseCaseTemplate["ItsmRunbook"] = "itsm-runbook";
    UseCaseTemplate["MarketingBlogPost"] = "marketing-blog-post";
    UseCaseTemplate["MarketingCampaign"] = "marketing-campaign";
    UseCaseTemplate["MeetingNotes"] = "meeting-notes";
    UseCaseTemplate["MessageHouse"] = "message-house";
    UseCaseTemplate["MutualActionPlan"] = "mutual-action-plan";
    UseCaseTemplate["Okrs"] = "okrs";
    UseCaseTemplate["OrganizationalChart"] = "org-chart";
    // Whiteboard
    UseCaseTemplate["PresenterMode"] = "presenter-mode";
    UseCaseTemplate["ProductRequirements"] = "product-requirements";
    UseCaseTemplate["ProductRoadmap"] = "product-roadmap";
    UseCaseTemplate["ProductVisionBoard"] = "product-vision-board";
    // Whiteboard
    UseCaseTemplate["ProjectPlan"] = "project-plan";
    UseCaseTemplate["Retrospective"] = "simple-retrospective";
    // Whiteboard
    UseCaseTemplate["RiskAssessment"] = "risk-assessment";
    UseCaseTemplate["SalesAccountPlanning"] = "sales-account-planning";
    UseCaseTemplate["SalesPortal"] = "sales-portal";
    UseCaseTemplate["Sop"] = "sop";
    UseCaseTemplate["SprintPlanning"] = "sprint-planning";
    UseCaseTemplate["ToDoList"] = "to-do-list";
    UseCaseTemplate["TroubleshootingArticle"] = "troubleshooting-article";
    UseCaseTemplate["UserPersona"] = "user-persona";
    UseCaseTemplate["VendorAgreement"] = "vendor-agreement";
    UseCaseTemplate["WeeklyIncidentReport"] = "weekly-incident-report";
    UseCaseTemplate["WeeklyStatusReport"] = "weekly-status-report";
    UseCaseTemplate["Workflow"] = "workflow";
    return UseCaseTemplate;
}({});
var $06dec2aa340c091a$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["PlanAndTrackProjects"] = "plan-and-track-projects";
    UseCase["CaptureMeetingNotesAndActions"] = "capture-meeting-notes-and-actions";
    UseCase["BrainstormAndExploreIdeas"] = "brainstorm-and-explore-ideas";
    UseCase["DocumentTechSpecsAndDecisions"] = "document-tech-specs-and-decisions";
    UseCase["CentralizeCodebaseAndProcessGuides"] = "centralize-codebase-and-process-guides";
    UseCase["PlanSprintsAndRunRetros"] = "plan-sprints-and-run-retros";
    UseCase["DocumentMeetingsAndRunRetros"] = "document-meetings-and-run-retros";
    UseCase["TrackGoalsAndOkrs"] = "track-goals-and-okrs";
    UseCase["PlanAndTrackCampaigns"] = "plan-and-track-campaigns";
    UseCase["DraftMarketingContent"] = "draft-marketing-content";
    UseCase["CentralizeMarketingInsightsAndGuides"] = "centralize-marketing-insights-and-guides";
    UseCase["ConductWorkshopsAndReviews"] = "conduct-workshops-and-reviews";
    UseCase["DocumentDesignDecisionsAndFlows"] = "document-design-decisions-and-flows";
    UseCase["CentralizeUserInsightsAndJourneys"] = "centralize-user-insights-and-journeys";
    UseCase["WriteProductRequirements"] = "write-product-requirements";
    UseCase["CraftStrategiesAndRoadmaps"] = "craft-strategies-and-roadmaps";
    UseCase["DocumentSopsAndWorkflows"] = "document-sops-and-workflows";
    UseCase["ShareHowToAndTroubleshootingDocs"] = "share-how-to-and-troubleshooting-docs";
    UseCase["StoreTeamProceduresAndReferences"] = "store-team-procedures-and-references";
    UseCase["DocumentIncidentsAndResolutions"] = "document-incidents-and-resolutions";
    UseCase["ShareFinancialResultsAndPlans"] = "share-financial-results-and-plans";
    UseCase["ShareHrPoliciesAndGuides"] = "share-hr-policies-and-guides";
    UseCase["AcquireAndOnboardNewTalent"] = "acquire-and-onboard-new-talent";
    UseCase["ShareLegalTemplatesAndGuides"] = "share-legal-templates-and-guides";
    UseCase["CreateTeamPlaybooks"] = "create-team-playbooks";
    UseCase["ManageLeadsAndDeals"] = "manage-leads-and-deals";
    UseCase["ReportProgressAndPerformance"] = "report-progress-and-performance";
    return UseCase;
}({});
const $06dec2aa340c091a$var$teamTypeToUseCaseMap = {
    [(0, $lRWIF.Team).Other]: [
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "capture-meeting-notes-and-actions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCaptureMeetingNotesAndActions,
            templates: [
                {
                    id: "meeting-notes",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMeetingNotes,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
                    templateType: 'page'
                },
                {
                    id: "to-do-list",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateToDoList,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "brainstorm-and-explore-ideas",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseBrainstormAndExploreIdeas,
            templates: [
                {
                    id: "crazy-8s",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateCrazy8s,
                    templateId: 'crazy-8s',
                    templateType: 'whiteboard'
                },
                {
                    id: "brainstorm-session",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBrainstormSession,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).SoftwareDevelopment]: [
        {
            id: "document-tech-specs-and-decisions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentTechSpecsAndDecisions,
            templates: [
                {
                    id: "flow-chart",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateFlowchart,
                    templateId: 'flow-chart',
                    templateType: 'whiteboard'
                },
                {
                    id: "daci-decision-documentation",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDaciDecisionDocumentation,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "centralize-codebase-and-process-guides",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCentralizeCodebaseAndProcessGuides,
            templates: [
                {
                    id: "architecture-diagram",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateArchitectureDiagram,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
                    templateType: 'page'
                },
                {
                    id: "devops-runbook",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDevopsRunbook,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "plan-sprints-and-run-retros",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanSprintsAndRunRetros,
            templates: [
                {
                    id: "sprint-planning",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateSprintPlanning,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
                    templateType: 'page'
                },
                {
                    id: "simple-retrospective",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateRetrospective,
                    templateId: 'simple-retrospective',
                    templateType: 'whiteboard'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).ProjectManagement]: [
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "document-meetings-and-run-retros",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentMeetingsAndRunRetros,
            templates: [
                {
                    id: "simple-retrospective",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateRetrospective,
                    templateId: 'simple-retrospective',
                    templateType: 'whiteboard'
                },
                {
                    id: "meeting-notes",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMeetingNotes,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "track-goals-and-okrs",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTrackGoalsAndOkrs,
            templates: [
                {
                    id: "okrs",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateOkrs,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
                    templateType: 'page'
                },
                {
                    id: "business-review",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBusinessReview,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Marketing]: [
        {
            id: "plan-and-track-campaigns",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackCampaigns,
            templates: [
                {
                    id: "marketing-campaign",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMarketingCampaign,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
                    templateType: 'page'
                },
                {
                    id: "business-status-update",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBusinessStatusUpdate,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "draft-marketing-content",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDraftMarketingContent,
            templates: [
                {
                    id: "marketing-blog-post",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMarketingBlogPost,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
                    templateType: 'page'
                },
                {
                    id: "elevator-pitch",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateElevatorPitchBrainstorm,
                    templateId: 'elevator-pitch',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "centralize-marketing-insights-and-guides",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCentralizeMarketingInsightsAndGuides,
            templates: [
                {
                    id: "message-house",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMessageHouse,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
                    templateType: 'page'
                },
                {
                    id: "user-persona",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateUserPersona,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Design]: [
        {
            id: "conduct-workshops-and-reviews",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseConductWorkshopsAndReviews,
            templates: [
                {
                    id: "design-review",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDesignReview,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
                    templateType: 'page'
                },
                {
                    id: "design-sprint",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDesignSprint,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "document-design-decisions-and-flows",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentDesignDecisionsAndFlows,
            templates: [
                {
                    id: "design-decision",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDesignDecision,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
                    templateType: 'page'
                },
                {
                    id: "flow-chart",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateFlowchart,
                    templateId: 'flow-chart',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "centralize-user-insights-and-journeys",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCentralizeUserInsightsAndJourneys,
            templates: [
                {
                    id: "user-persona",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateUserPersona,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
                    templateType: 'page'
                },
                {
                    id: "customer-interview-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateCustomerInterviewReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).ProductManagement]: [
        {
            id: "write-product-requirements",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseWriteProductRequirements,
            templates: [
                {
                    id: "product-requirements",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProductRequirements,
                    templateId: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
                    templateType: 'page'
                },
                {
                    id: "daci-decision-documentation",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDaciDecisionDocumentation,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "craft-strategies-and-roadmaps",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCraftStrategiesAndRoadmaps,
            templates: [
                {
                    id: "product-roadmap",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProductRoadmap,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
                    templateType: 'page'
                },
                {
                    id: "product-vision-board",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProductVisionBoard,
                    templateId: 'product-vision-board',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "capture-meeting-notes-and-actions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCaptureMeetingNotesAndActions,
            templates: [
                {
                    id: "meeting-notes",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMeetingNotes,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
                    templateType: 'page'
                },
                {
                    id: "to-do-list",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateToDoList,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Operations]: [
        {
            id: "document-sops-and-workflows",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentSopsAndWorkflows,
            templates: [
                {
                    id: "sop",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateSop,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
                    templateType: 'page'
                },
                {
                    id: "workflow",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWorkflow,
                    templateId: 'workflow',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "track-goals-and-okrs",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTrackGoalsAndOkrs,
            templates: [
                {
                    id: "okrs",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateOkrs,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
                    templateType: 'page'
                },
                {
                    id: "business-review",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBusinessReview,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).ITSupport]: [
        {
            id: "share-how-to-and-troubleshooting-docs",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseShareHowToAndTroubleshootingDocs,
            templates: [
                {
                    id: "how-to-article",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateHowToArticle,
                    templateId: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
                    templateType: 'page'
                },
                {
                    id: "troubleshooting-article",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateTroubleshootingArticle,
                    templateId: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "store-team-procedures-and-references",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseStoreTeamProceduresAndReferences,
            templates: [
                {
                    id: "itsm-runbook",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateItsmRunbook,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
                    templateType: 'page'
                },
                {
                    id: "itsm-known-errors",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateItsmKnownErrors,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "document-incidents-and-resolutions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentIncidentsAndResolutions,
            templates: [
                {
                    id: "incident-postmortem",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateIncidentPostmortem,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-incident-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyIncidentReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Finance]: [
        {
            id: "share-financial-results-and-plans",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseShareFinancialResultsAndPlans,
            templates: [
                {
                    id: "business-status-update",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBusinessStatusUpdate,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
                    templateType: 'page'
                },
                {
                    id: "annual-plan-one-pager",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateAnnualPlanOnePager,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "capture-meeting-notes-and-actions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCaptureMeetingNotesAndActions,
            templates: [
                {
                    id: "meeting-notes",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMeetingNotes,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
                    templateType: 'page'
                },
                {
                    id: "to-do-list",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateToDoList,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).HumanResources]: [
        {
            id: "share-hr-policies-and-guides",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseShareHrPoliciesAndGuides,
            templates: [
                {
                    id: "hr-knowledge-base",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateHrKnowledgeBase,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
                    templateType: 'page'
                },
                {
                    id: "org-chart",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateOrganizationalChart,
                    templateId: 'org-chart',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "acquire-and-onboard-new-talent",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseAcquireAndOnboardNewTalent,
            templates: [
                {
                    id: "hiring-process",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateHiringProcess,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
                    templateType: 'page'
                },
                {
                    id: "ninety-day-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateNinetyDayPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Legal]: [
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "capture-meeting-notes-and-actions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCaptureMeetingNotesAndActions,
            templates: [
                {
                    id: "meeting-notes",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMeetingNotes,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
                    templateType: 'page'
                },
                {
                    id: "to-do-list",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateToDoList,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "share-legal-templates-and-guides",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseShareLegalTemplatesAndGuides,
            templates: [
                {
                    id: "vendor-agreement",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateVendorAgreement,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
                    templateType: 'page'
                },
                {
                    id: "risk-assessment",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateRiskAssessment,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).Sales]: [
        {
            id: "create-team-playbooks",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseCreateTeamPlaybooks,
            templates: [
                {
                    id: "sales-portal",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateSalesPortal,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
                    templateType: 'page'
                },
                {
                    id: "elevator-pitch",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateElevatorPitchBrainstorm,
                    templateId: 'elevator-pitch',
                    templateType: 'whiteboard'
                }
            ]
        },
        {
            id: "manage-leads-and-deals",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseManageLeadsAndDeals,
            templates: [
                {
                    id: "sales-account-planning",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateSalesAccountPlanning,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
                    templateType: 'page'
                },
                {
                    id: "mutual-action-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateMutualActionPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "report-progress-and-performance",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseReportProgressAndPerformance,
            templates: [
                {
                    id: "executive-business-review",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateExecutiveBusinessReview,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
                    templateType: 'page'
                },
                {
                    id: "presenter-mode",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplatePresenterMode,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).DataScience]: [
        {
            id: "document-tech-specs-and-decisions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentTechSpecsAndDecisions,
            templates: [
                {
                    id: "flow-chart",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateFlowchart,
                    templateId: 'flow-chart',
                    templateType: 'whiteboard'
                },
                {
                    id: "daci-decision-documentation",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateDaciDecisionDocumentation,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "brainstorm-and-explore-ideas",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseBrainstormAndExploreIdeas,
            templates: [
                {
                    id: "crazy-8s",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateCrazy8s,
                    templateId: 'crazy-8s',
                    templateType: 'whiteboard'
                },
                {
                    id: "brainstorm-session",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateBrainstormSession,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "plan-and-track-projects",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCasePlanAndTrackProjects,
            templates: [
                {
                    id: "project-plan",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateProjectPlan,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-status-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyStatusReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ],
    [(0, $lRWIF.Team).CustomerService]: [
        {
            id: "share-how-to-and-troubleshooting-docs",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseShareHowToAndTroubleshootingDocs,
            templates: [
                {
                    id: "how-to-article",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateHowToArticle,
                    templateId: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
                    templateType: 'page'
                },
                {
                    id: "troubleshooting-article",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateTroubleshootingArticle,
                    templateId: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "store-team-procedures-and-references",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseStoreTeamProceduresAndReferences,
            templates: [
                {
                    id: "itsm-runbook",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateItsmRunbook,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
                    templateType: 'page'
                },
                {
                    id: "itsm-known-errors",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateItsmKnownErrors,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
                    templateType: 'page'
                }
            ]
        },
        {
            id: "document-incidents-and-resolutions",
            nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseDocumentIncidentsAndResolutions,
            templates: [
                {
                    id: "incident-postmortem",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateIncidentPostmortem,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
                    templateType: 'page'
                },
                {
                    id: "weekly-incident-report",
                    nameDescriptor: $06dec2aa340c091a$export$defe85febe8b728c.useCaseTemplateWeeklyIncidentReport,
                    templateId: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
                    templateType: 'page'
                }
            ]
        }
    ]
};
const $06dec2aa340c091a$export$e6c51989282f68de = (teamType)=>{
    return $06dec2aa340c091a$var$teamTypeToUseCaseMap[teamType];
};
const $06dec2aa340c091a$export$60a743008d7a6635 = (teamType, useCases)=>{
    let useCaseTemplates = [];
    let useCasesForTeamType = [
        ...$06dec2aa340c091a$var$teamTypeToUseCaseMap[teamType]
    ];
    // Add any selected Use Cases first
    for(let ucIndex = 0; ucIndex < useCases.length; ucIndex++)for(let index = 0; index < useCasesForTeamType.length; index++){
        const entry = useCasesForTeamType[index];
        if (entry.id === useCases[ucIndex] && entry.templates.length >= 2) {
            useCaseTemplates.push(entry.templates[0]);
            useCaseTemplates.push(entry.templates[1]);
            useCasesForTeamType.splice(index, 1);
        }
    }
    // Add the remaining Team Type Use Cases
    for(let index = 0; index < useCasesForTeamType.length; index++){
        const entry = useCasesForTeamType[index];
        if (entry.templates.length >= 2) {
            useCaseTemplates.push(entry.templates[0]);
            useCaseTemplates.push(entry.templates[1]);
        }
    }
    return useCaseTemplates;
};
module.exports["fetchUseCasesWithTemplatesForTeamType"] = $06dec2aa340c091a$export$e6c51989282f68de;
module.exports["fetchUseCaseTemplatesByTempTypeAndUseCaseId"] = $06dec2aa340c091a$export$60a743008d7a6635;

});

parcelRegister("lRWIF", function(module, exports) {
var $eb1132679219975b$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["SoftwareDevelopment"] = "software-development";
    Team["ProductManagement"] = "product-management";
    Team["Marketing"] = "marketing";
    Team["Design"] = "design";
    Team["ProjectManagement"] = "project-management";
    Team["Operations"] = "operations";
    Team["ITSupport"] = "it-support";
    Team["Finance"] = "finance";
    Team["HumanResources"] = "human-resources";
    Team["Legal"] = "legal";
    Team["Sales"] = "sales";
    Team["DataScience"] = "data-science";
    Team["CustomerService"] = "customer-service";
    Team["Other"] = "other";
    return Team;
}({});
const $eb1132679219975b$export$77134aba51f821f8 = {
    ["software-development"]: 'onboarding-helpers.team.software.development.modern.branding',
    ["product-management"]: 'onboarding-helpers.team.productManagement',
    ["marketing"]: 'onboarding-helpers.team.marketing.modern.branding',
    ["design"]: 'onboarding-helpers.team.design',
    ["project-management"]: 'onboarding-helpers.team.projectManagement',
    ["operations"]: 'onboarding-helpers.team.operations.modern.branding',
    ["it-support"]: 'onboarding-helpers.team.it.support.modern.branding',
    ["finance"]: 'onboarding-helpers.team.finance.modern.branding',
    ["human-resources"]: 'onboarding-helpers.team.human.resources.modern.branding',
    ["legal"]: 'onboarding-helpers.team.legal.modern.branding',
    ["sales"]: 'onboarding-helpers.team.sales.modern.branding',
    ["data-science"]: 'onboarding-helpers.team.data.science.modern.branding',
    ["customer-service"]: 'onboarding-helpers.team.customer.service.modern.branding',
    ["other"]: 'onboarding-helpers.team.other'
};
var $eb1132679219975b$export$a0b0994d6b76cdaa = /*#__PURE__*/ function(FocusArea) {
    FocusArea["PlanOutProjects"] = "plan-out-projects";
    FocusArea["CreateTechnicalDocumentation"] = "create-technical-documentation";
    FocusArea["CreateMarketingCampaigns"] = "create-marketing-campaigns";
    FocusArea["ShareStatusUpdates"] = "share-status-updates";
    FocusArea["BrainstormAndStrategize"] = "brainstorm-and-strategize";
    FocusArea["PlanAndPrioritize"] = "plan-and-prioritize";
    FocusArea["GetAlignment"] = "get-alignment";
    FocusArea["ImproveTeamProcesses"] = "improve-team-processes";
    FocusArea["ShareUpdatesWithStakeholders"] = "share-updates-with-stakeholders";
    FocusArea["StrategizeOnMarketingContent"] = "strategize-on-marketing-content";
    FocusArea["ShareWeeklyMeetingNotes"] = "share-weekly-meeting-notes";
    return FocusArea;
}({});
const $eb1132679219975b$export$8764a1262502aaf9 = {
    itProjectPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
    sprintPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    productRequirements: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    softwareArchitectureReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
    howToArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    architectureDiagram: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
    incidentCommunication: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
    experimentPlanAndResults: 'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint',
    dailyStandUp: 'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint',
    projectPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    strategicPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    productRoadmap: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
    workingAgreements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint',
    teamPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
    rolesAndResponsibilities: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    stakeholderCommunications: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
    endOfWeekStatusReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    marketingCampaign: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    marketingPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
    brainstorming: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
    swotAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
    competitiveAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
    meetingNotes: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    daci: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    customerJourneyMapping: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
    toDoList: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
    retrospective: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    devOpsRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
    sop: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
    itsmKnownErrors: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
    businessStatusUpdate: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    workshopPlanner: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
    designSystems: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
    designReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
    businessPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
    riskAssessmentMatrix: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
    vendorAgreement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
    visionToValues: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
    careerDevelopmentPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
    hrKnowledgeBaseManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
    salesAccountPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
    salesPortal: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
    smartGoals: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
    projectStatus: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
    itsmChangeManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
    itsmPostIncidentReviews: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
    itsmRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
    troubleshootingArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
    mvpIdeation: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint',
    designSprint: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
    elevatorPitch: 'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint',
    mutualActionPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
    executiveBusinessReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
    fiveWhysAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
    okrs: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
    employeeHandbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    hiringProcess: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
    contentStrategy: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
    blankPage: '',
    customerImpactAssessment: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
    lennysProductRequirements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
    designDecision: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
    persona: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
    messageHouse: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
    annualPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
    allHandsMeeting: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    customerInterviewReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
    presenterMode: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
    qtcAcquisition: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
    jobDescription: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
    ninetyDayPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
    lennysPerformanceReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
    projectKickoff: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint'
};
var $eb1132679219975b$export$14416b8d99d47caa = /*#__PURE__*/ function(Template) {
    Template["ITProjectPoster"] = "it-project-poster";
    Template["SprintPlanning"] = "sprint-planning";
    Template["ProductRequirements"] = "product-requirements";
    Template["SoftwareArchitectureReview"] = "software-architecture-review";
    Template["HowToArticle"] = "how-to-article";
    Template["ArchitectureDiagram"] = "architecture-diagram";
    Template["IncidentCommunication"] = "incident-communication";
    Template["ExperimentPlanAndResults"] = "experiment-plan-and-results";
    Template["DailyStandUp"] = "daily-stand-up";
    Template["ProjectPlan"] = "project-plan";
    Template["StrategicPlan"] = "strategic-plan";
    Template["ProductRoadmap"] = "product-roadmap";
    Template["BlankPage"] = "blank-page";
    Template["WorkingAgreements"] = "working-agreements";
    Template["TeamPoster"] = "team-poster";
    Template["RolesAndResponsibilities"] = "roles-and-responsibilities";
    Template["StakeholderCommunications"] = "stakeholder-communications";
    Template["EndOfWeekStatusReport"] = "end-of-week-status-report";
    Template["MarketingCampaign"] = "marketing-campaign";
    Template["MarketingPlan"] = "marketing-plan";
    Template["Brainstorming"] = "brainstorming";
    Template["SWOTAnalysis"] = "swot-analysis";
    Template["CompetitiveAnalysis"] = "competitive-analysis";
    Template["MeetingNotes"] = "meeting-notes";
    Template["DACI"] = "daci";
    Template["CustomerJourneyMapping"] = "customer-journey-mapping";
    Template["ToDoList"] = "to-do-list";
    Template["Retrospective"] = "retrospective";
    Template["DevOpsRunbook"] = "dev-ops-runbook";
    Template["ITSMKnownErrors"] = "itsm-known-errors";
    Template["BusinessStatusUpdate"] = "business-status-update";
    Template["WorkshopPlanner"] = "workshop-planner";
    Template["DesignSystems"] = "design-systems";
    Template["DesignReview"] = "design-review";
    Template["BusinessPlanOnePager"] = "business-plan-one-pager";
    Template["RiskAssessmentMatrix"] = "risk-assessment-matrix";
    Template["VendorAgreement"] = "vendor-agreement";
    Template["VisionToValues"] = "vision-to-values";
    Template["CareerDevelopmentPlan"] = "career-development-plan";
    Template["HRKnowledgeBaseManagement"] = "hr-knowledge-base-management";
    Template["SalesAccountPlanning"] = "sales-account-planning";
    Template["SalesPortal"] = "sales-portal";
    Template["SMARTGoals"] = "smart-goals";
    Template["ProjectStatus"] = "project-status";
    Template["ITSMChangeManagement"] = "itsm-change-management";
    Template["ITSMPostIncidentReviews"] = "itsm-post-incident-reviews";
    Template["ITSMRunbook"] = "itsm-runbook";
    Template["TroubleshootingArticle"] = "troubleshooting-article";
    Template["MVPIdeation"] = "mvp-ideation";
    Template["DesignSprint"] = "design-sprint";
    Template["ElevatorPitch"] = "elevator-pitch";
    Template["MutualActionPlan"] = "mutual-action-plan";
    Template["ExecutiveBusinessReview"] = "executive-business-review";
    Template["FiveWhysAnalysis"] = "five-whys-analysis";
    Template["OKRs"] = "okrs";
    Template["EmployeeHandbook"] = "employee-handbook";
    Template["HiringProcess"] = "hiring-process";
    Template["CustomerImpactAssessment"] = "customer-impact-assessment";
    Template["LennysProductRequirements"] = "lennys-product-requirements";
    Template["ContentStrategy"] = "content-strategy";
    Template["DesignDecision"] = "design-decision";
    Template["Persona"] = "persona";
    Template["MessageHouse"] = "message-house";
    Template["AnnualPlanOnePager"] = "annual-plan-one-pager";
    Template["AllHandsMeeting"] = "all-hands-meeting";
    Template["CustomerInterviewReport"] = "customer-interview-report";
    Template["PresenterMode"] = "presenter-mode";
    Template["QtcAcquisition"] = "qtc-acquisition";
    Template["JobDescription"] = "job-description";
    Template["NinetyDayPlan"] = "ninety-day-plan";
    Template["LennysPerformanceReview"] = "lennys-performance-review";
    Template["ProjectKickoff"] = "project-kickoff";
    return Template;
}({});
var $eb1132679219975b$export$a6ffeca29f180ace = /*#__PURE__*/ function(WhiteboardTemplate) {
    WhiteboardTemplate["Brainwriting"] = "brainwriting";
    // Name: Brainwriting
    WhiteboardTemplate["Flowchart"] = "flow-chart";
    // Name: Flowchart
    WhiteboardTemplate["FourlsRetro"] = "4ls-retro";
    // Name: 4 Ls Retro
    WhiteboardTemplate["PrioritizationMatrix"] = "prioritization";
    // Name: Prioritization matrix
    WhiteboardTemplate["ProductRoadmap"] = "product-roadmap";
    // Name: Product roadmap
    WhiteboardTemplate["SimpleRetrospective"] = "simple-retrospective";
    // Name: Simple retrospective
    WhiteboardTemplate["SwimlanesProcessMap"] = "swimlanes";
    return WhiteboardTemplate;
}({});
var $eb1132679219975b$export$8b6f874ad242ca1b = /*#__PURE__*/ function(KnowledgeHubTemplate) {
    KnowledgeHubTemplate["FAQ"] = "faq";
    KnowledgeHubTemplate["Team"] = "team";
    KnowledgeHubTemplate["Project"] = "project";
    return KnowledgeHubTemplate;
}({});
var $eb1132679219975b$export$32da9fe1f998b96c = /*#__PURE__*/ function(ContentKeys) {
    ContentKeys["BRAINSTORMING"] = "BRAINSTORMING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-page'
    ContentKeys["REQUIREMENTS_DOC"] = "REQUIREMENTS_DOC";
    // 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint'
    ContentKeys["TASK_TRACKING"] = "TASK_TRACKING";
    // 'com.atlassian.confluence.plugins.confluence-space-blueprints:task-tracker-template'
    ContentKeys["FLOWCHART_AND_DIAGRAMS"] = "FLOWCHART_AND_DIAGRAMS";
    // 'whiteboard:flow-chart'
    ContentKeys["MEETING_NOTES"] = "MEETING_NOTES";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-page'
    ContentKeys["KNOWLEDGE_HUB"] = "KNOWLEDGE_HUB";
    // 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-blueprint'
    ContentKeys["PROJECT_PLAN"] = "PROJECT_PLAN";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-page'
    ContentKeys["GANTT_CHART"] = "GANTT_CHART";
    // 'whiteboard:product-roadmap'
    ContentKeys["CREATIVE_BREIFS"] = "CREATIVE_BRIEFS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint'
    ContentKeys["CUSTOMER_JOURNEYS"] = "CUSTOMER_JOURNEYS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint'
    ContentKeys["CAMPAIGN_PLANNING"] = "CAMPAIGN_PLANNING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-content'
    ContentKeys["PROCESS_MAPPING"] = "PROCESS_MAPPING";
    // 'whiteboard:swimlanes'
    ContentKeys["TEAM_STATUS_UPDATE"] = "TEAM_STATUS_UPDATE";
    return ContentKeys;
}({});
var $eb1132679219975b$export$64e2ed2cf579d2ef = /*#__PURE__*/ function(AccountSetupScreens) {
    AccountSetupScreens["TEAM"] = "onboarding-account-setup-modal.teamScreen";
    AccountSetupScreens["TEAM_NO_SKIP"] = "onboarding-account-setup-modal.teamScreen.branding";
    AccountSetupScreens["JTBD"] = "onboarding-account-setup-modal.jtbdScreen";
    AccountSetupScreens["JTBD_MODERN_BRANDING"] = "onboarding-account-setup-modal.jtbdScreen.branding";
    AccountSetupScreens["LOADING"] = "onboarding-account-setup-modal.loadingScreen";
    AccountSetupScreens["LOADING_MODERN_BRANDING"] = "onboarding-account-setup-modal.loadingScreen.branding";
    AccountSetupScreens["TEMPLATE"] = "onboarding-account-setup-modal.templateScreen";
    AccountSetupScreens["TEMPLATE_MODERN_BRANDING"] = "onboarding-account-setup-modal.templateScreen.branding";
    AccountSetupScreens["INVITE"] = "onboarding-account-setup-modal.inviteScreen";
    AccountSetupScreens["INVITE_MODERN_BRANDING"] = "onboarding-account-setup-modal.inviteScreen.branding";
    AccountSetupScreens["CONTENTTYPE"] = "onboarding-account-setup-modal.contentTypeScreen";
    // founding admin
    AccountSetupScreens["NTH_USER_CONTENT_TYPE"] = "onboarding-account-setup-modal.nthUserContentTypeScreen";
    // nth user
    AccountSetupScreens["SPACESTOFOLLOW"] = "onboarding-account-setup-modal.spacesToFollowScreen";
    AccountSetupScreens["EDITION"] = "onboarding-account-setup-modal.editionCommunicationScreen";
    AccountSetupScreens["AUTOPROVISIONING_EDITION"] = "onboarding-account-setup-modal.autoprovisioningEditionScreen";
    AccountSetupScreens["JTBD_CONTENT"] = "onboarding-account-setup-modal.jtbdContentScreen";
    AccountSetupScreens["USE_CASES"] = "onboarding-account-setup-modal.useCasesScreen";
    AccountSetupScreens["TEAMMATE_CONTENT"] = "onboarding-account-setup-modal.teammateContentScreen";
    AccountSetupScreens["AIFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.aifcContentTeamTypeScreen";
    AccountSetupScreens["AIFC_TEAM_TYPE_V2"] = "onboarding-account-setup-modal.aifcTeamTypeV2Screen";
    AccountSetupScreens["AIFC_CONTENT_TYPE_V2"] = "onboarding-account-setup-modal.aifcContentTypeV2Screen";
    AccountSetupScreens["GFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.gfcContentTeamTypeScreen";
    AccountSetupScreens["AIFC_ONBOARDING_INPUT"] = "onboarding-account-setup-modal.aifcOnboardingInputScreen";
    AccountSetupScreens["GFC_TEMPLATE_ROVO_CREATE"] = "onboarding-account-setup-modal.gfcTemplateScreen";
    AccountSetupScreens["RECOMMENDED_SPACES"] = "onboarding-account-setup-modal.recommendedSpacesScreen";
    AccountSetupScreens["MULTI_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.multiAppInlineConnectionScreen";
    AccountSetupScreens["SINGLE_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.singleAppInlineConnectionScreen";
    AccountSetupScreens["CWR_NTH_USER_ONBOARDING"] = "onboarding-account-setup-modal.cwrNthUserOnboardingScreen";
    AccountSetupScreens["CHOOSE_YOUR_PATH"] = "onboarding-account-setup-modal.chooseYourPathScreen";
    AccountSetupScreens["INVITE_XFLOW_TEAM"] = "onboarding-account-setup-modal.inviteScreen.xflowTeam";
    return AccountSetupScreens;
}({});
var $eb1132679219975b$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["LIVE_DOC"] = "live-doc";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    ContentType["KNOWLEDGE_HUB"] = "knowledge-hub";
    return ContentType;
}({});
var $eb1132679219975b$export$6435071f58aaae6a = /*#__PURE__*/ function(NthUserContentType) {
    NthUserContentType["PAGE"] = "page";
    NthUserContentType["WHITEBOARD"] = "whiteboard";
    NthUserContentType["LIVE_DOC"] = "live-doc";
    NthUserContentType["DATABASE"] = "database";
    return NthUserContentType;
}({});
var $eb1132679219975b$export$3a8c8363200890be = /*#__PURE__*/ function(RecommendationType) {
    RecommendationType["POPULAR"] = "popular";
    RecommendationType["TEAM_SPACE"] = "teammates";
    return RecommendationType;
}({});
var $eb1132679219975b$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["Team"] = $eb1132679219975b$export$3e5d0af8e738b082;
module.exports["TEAM_ID_MAP"] = $eb1132679219975b$export$77134aba51f821f8;
module.exports["FocusArea"] = $eb1132679219975b$export$a0b0994d6b76cdaa;
module.exports["TemplateBlueprintModuleCompleteKey"] = $eb1132679219975b$export$8764a1262502aaf9;
module.exports["Template"] = $eb1132679219975b$export$14416b8d99d47caa;
module.exports["WhiteboardTemplate"] = $eb1132679219975b$export$a6ffeca29f180ace;
module.exports["KnowledgeHubTemplate"] = $eb1132679219975b$export$8b6f874ad242ca1b;
module.exports["AccountSetupScreens"] = $eb1132679219975b$export$64e2ed2cf579d2ef;
module.exports["ContentType"] = $eb1132679219975b$export$e2e108cbe2e4f865;
module.exports["NthUserContentType"] = $eb1132679219975b$export$6435071f58aaae6a;
module.exports["RecommendationType"] = $eb1132679219975b$export$3a8c8363200890be;
module.exports["ConfluenceEdition"] = $eb1132679219975b$export$68577d543b14ae02;

});

parcelRegister("8E5P5", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ var $522761dd0b51db26$export$82e276cacb9013c9 = /*#__PURE__*/ function(BLUEPRINT_NAMES) {
    BLUEPRINT_NAMES["NINETY_DAY_PLAN"] = "90-day plan";
    BLUEPRINT_NAMES["ALL_HANDS_MEETING"] = "All hands meeting";
    BLUEPRINT_NAMES["ANNUAL_PLAN_ONE_PAGER"] = "Annual plan one-pager";
    BLUEPRINT_NAMES["EXECUTIVE_BUSINESS_REVIEW"] = "Executive business review";
    BLUEPRINT_NAMES["BUSINESS_STATUS_UPDATE"] = "Business status update";
    BLUEPRINT_NAMES["BUSINESS_PLAN_ONE_PAGER"] = "Business plan one-pager";
    BLUEPRINT_NAMES["CAREER_DEVELOPMENT_PLAN"] = "Career development plan";
    BLUEPRINT_NAMES["COMPETITIVE_ANALYSIS"] = "Competitive analysis";
    BLUEPRINT_NAMES["CONTENT_DESIGN_GLOSSARY"] = "Content design glossary";
    BLUEPRINT_NAMES["CONTENT_STRATEGY"] = "Content strategy";
    BLUEPRINT_NAMES["CUSTOMER_IMPACT_ASSESSMENT"] = "Customer Impact Assessment";
    BLUEPRINT_NAMES["CUSTOMER_INTERVIEW_REPORT"] = "Customer Interview Report";
    BLUEPRINT_NAMES["DACI_DECISION_DOCUMENTATION"] = "DACI: Decision documentation";
    BLUEPRINT_NAMES["DESIGN_DECISION"] = "Design decision";
    BLUEPRINT_NAMES["DESIGN_REVIEW"] = "Design review";
    BLUEPRINT_NAMES["DESIGN_SPRINT"] = "Design sprint";
    BLUEPRINT_NAMES["DESIGN_SYSTEMS"] = "Design systems";
    BLUEPRINT_NAMES["DEVOPS_RUNBOOK"] = "DevOps runbook";
    BLUEPRINT_NAMES["EMPLOYEE_HANDBOOK"] = "Employee handbook";
    BLUEPRINT_NAMES["HR_KNOWLEDGE_BASE_MANAGEMENT"] = "HR Knowledge Base Management";
    BLUEPRINT_NAMES["HOW_TO_ARTICLE"] = "How-to article";
    BLUEPRINT_NAMES["ITSM_KNOWN_ERRORS"] = "ITSM Known Errors";
    BLUEPRINT_NAMES["ITSM_CHANGE_MANAGEMENT"] = "ITSM change management";
    BLUEPRINT_NAMES["ITSM_POST_INCIDENT_REVIEWS"] = "ITSM post incident reviews";
    BLUEPRINT_NAMES["ITSM_RUNBOOK"] = "ITSM runbook";
    BLUEPRINT_NAMES["INCIDENT_COMMUNICATION"] = "Incident communication";
    BLUEPRINT_NAMES["INCIDENT_POSTMORTEM"] = "Incident postmortem";
    BLUEPRINT_NAMES["JOB_DESCRIPTION"] = "Job description";
    BLUEPRINT_NAMES["LENNYS_PERFORMANCE_REVIEW"] = "Lenny's Performance Review";
    BLUEPRINT_NAMES["LENNYS_PRODUCT_REQUIREMENTS"] = "Lenny's product requirements";
    BLUEPRINT_NAMES["MARKETING_PLAN"] = "Marketing plan";
    BLUEPRINT_NAMES["MEETING_NOTES"] = "Meeting notes";
    BLUEPRINT_NAMES["MESSAGE_HOUSE"] = "Message house";
    BLUEPRINT_NAMES["OKRS"] = "OKRs";
    BLUEPRINT_NAMES["PERSONA"] = "Persona";
    BLUEPRINT_NAMES["PRESENTER_MODE"] = "Presenter mode";
    BLUEPRINT_NAMES["PRODUCT_REQUIREMENTS"] = "Product Requirements";
    BLUEPRINT_NAMES["PRODUCT_ROADMAP"] = "Product roadmap";
    BLUEPRINT_NAMES["PROJECT_KICKOFF"] = "Project Kickoff";
    BLUEPRINT_NAMES["PROJECT_PLAN"] = "Project plan";
    BLUEPRINT_NAMES["PROJECT_STATUS"] = "Project status";
    BLUEPRINT_NAMES["PROJECT_TIMELINE_TEMPLATE"] = "Project Timeline Template";
    BLUEPRINT_NAMES["QTC_ACQUISITION"] = "QTC Acquisition";
    BLUEPRINT_NAMES["QUARTERLY_CHECK_IN"] = "Quarterly check in";
    BLUEPRINT_NAMES["REMOTE_TEAM_MEETING"] = "Remote team meeting";
    BLUEPRINT_NAMES["RISK_ASSESSMENT_MATRIX"] = "Risk assessment matrix";
    BLUEPRINT_NAMES["ROLES_AND_RESPONSIBILITIES"] = "Roles and responsibilities play";
    BLUEPRINT_NAMES["SMART_GOALS"] = "SMART Goals";
    BLUEPRINT_NAMES["SWOT_ANALYSIS"] = "SWOT analysis";
    BLUEPRINT_NAMES["SALES_PORTAL"] = "Sales Portal";
    BLUEPRINT_NAMES["SALES_ACCOUNT_PLANNING"] = "Sales account planning";
    BLUEPRINT_NAMES["SERVICE_TEAM_HEALTH_MONITOR"] = "Service team health monitor";
    BLUEPRINT_NAMES["SOFTWARE_ARCHITECTURE_REVIEW"] = "Software Architecture Review";
    BLUEPRINT_NAMES["SPRINT_PLANNING_MEETING"] = "Sprint planning meeting";
    BLUEPRINT_NAMES["STAKEHOLDER_COMMUNICATIONS"] = "Stakeholder communications";
    BLUEPRINT_NAMES["STANDARD_OPERATING_PROCEDURE_TEMPLATE"] = "Standard Operating Procedure (SOP) Template";
    BLUEPRINT_NAMES["STRATEGIC_PLAN"] = "Strategic plan";
    BLUEPRINT_NAMES["TEAM_HOMEPAGE"] = "Team homepage";
    BLUEPRINT_NAMES["TEAM_POSTER"] = "Team poster";
    BLUEPRINT_NAMES["TO_DO_LIST"] = "To-do list";
    BLUEPRINT_NAMES["TROUBLESHOOTING_ARTICLE"] = "Troubleshooting article";
    BLUEPRINT_NAMES["VENDOR_AGREEMENT"] = "Vendor agreement";
    BLUEPRINT_NAMES["VIRTUAL_EVENT"] = "Virtual event";
    BLUEPRINT_NAMES["VISION_TO_VALUES"] = "Vision to values";
    BLUEPRINT_NAMES["END_OF_WEEK_STATUS_REPORT"] = "End of week status report";
    BLUEPRINT_NAMES["WEEKLY_MEETING_NOTES"] = "Weekly meeting notes";
    BLUEPRINT_NAMES["WORK_TRIP_PLANNER"] = "Work trip planner";
    BLUEPRINT_NAMES["WORKSHOP_PLANNER"] = "Workshop planner";
    BLUEPRINT_NAMES["WRITING_GUIDELINES"] = "Writing guidelines";
    BLUEPRINT_NAMES["AWS_ARCHITECTURE_DIAGRAM"] = "AWS architecture diagram";
    BLUEPRINT_NAMES["MARKETING_BLOG_POST"] = "Marketing blog post";
    BLUEPRINT_NAMES["MARKETING_CAMPAIGN"] = "Marketing campaign";
    BLUEPRINT_NAMES["HIRING_PROCESS"] = "Hiring process";
    BLUEPRINT_NAMES["MUTUAL_ACTION_PLAN"] = "Mutual action plan";
    BLUEPRINT_NAMES["ITSM_WEEKLY_MAJOR_INCIDENT_REPORT"] = "ITSM weekly major incident report";
    BLUEPRINT_NAMES["DISRUPTIVE_BRAINSTORMING"] = "Disruptive brainstorming";
    return BLUEPRINT_NAMES;
}({});
const $522761dd0b51db26$export$c42db12dd3d44bb8 = new Set(Object.values($522761dd0b51db26$export$82e276cacb9013c9));
const $522761dd0b51db26$export$d7a793aff6267afc = {
    ["90-day plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-item',
        contentBlueprintId: 'b18bd4b0-cb12-4c8a-be83-bb5769b25481'
    },
    ["All hands meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-item',
        contentBlueprintId: '67dddaa6-f038-45bf-b21f-8259dcf441db'
    },
    ["Annual plan one-pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-item',
        contentBlueprintId: '2823fda6-dfb4-4b81-8394-2e19e96b99fb'
    },
    ["Executive business review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-item',
        contentBlueprintId: '9433bfd2-c7b2-41cf-b493-d4a1feb39210'
    },
    ["Business status update"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-item',
        contentBlueprintId: 'f877653e-87e1-4654-a915-3591b3dd0db3'
    },
    ["Business plan one-pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-item',
        contentBlueprintId: '6db15ae0-081f-4a9b-9936-15dec72492ee'
    },
    ["Career development plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-item',
        contentBlueprintId: '2b75697e-04cd-4e68-8eec-c3828a0d8c36'
    },
    ["Competitive analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-item',
        contentBlueprintId: '1f0e6e6e-766b-4e98-9022-90ab4ef6194f'
    },
    ["Content design glossary"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-item',
        contentBlueprintId: 'bc251e1b-c784-4593-a360-d5a5bbccd56b'
    },
    ["Content strategy"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-item',
        contentBlueprintId: '30735803-4a23-40df-9848-1ab97067e66c'
    },
    ["Customer Impact Assessment"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-item',
        contentBlueprintId: '71a66b1f-49c9-4f9e-87fa-895850e1d2db'
    },
    ["Customer Interview Report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-item',
        contentBlueprintId: '5322e0f4-2f85-45f3-8ffe-94fba1d571d8'
    },
    ["DACI: Decision documentation"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item',
        contentBlueprintId: '7edaef4a-329f-47c9-abfe-7e241c9e17ba'
    },
    ["Design decision"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-item',
        contentBlueprintId: 'fb9933f8-841d-43ea-a872-ef06abd7f725'
    },
    ["Design review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-item',
        contentBlueprintId: '22f59064-c993-4fa9-bfd7-6a9e1be0ba4c'
    },
    ["Design sprint"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-item',
        contentBlueprintId: '3acf77bc-919c-4bd5-a8ee-cf1f045d01d5'
    },
    ["Design systems"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-item',
        contentBlueprintId: '337e0487-2a9c-4ce9-95b0-4212c228379a'
    },
    ["DevOps runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-item',
        contentBlueprintId: 'eb916d7d-a90d-4d18-955b-445e28ce08a5'
    },
    ["Employee handbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-item',
        contentBlueprintId: '705c6810-8621-4c26-8d4e-ec51c92fd395'
    },
    ["HR Knowledge Base Management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-item',
        contentBlueprintId: '62eb020a-ab61-4a64-8f96-788745e1761c'
    },
    ["How-to article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-item',
        contentBlueprintId: '74323bcf-829b-4d71-a765-facc886accdd'
    },
    ["ITSM Known Errors"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-item',
        contentBlueprintId: '55c00b7d-e8e9-4644-ae6c-08bc4a480b70'
    },
    ["ITSM change management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-item',
        contentBlueprintId: '0ad3bc27-3852-4166-af6b-d5ffe48060e9'
    },
    ["ITSM post incident reviews"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-item',
        contentBlueprintId: '0d50396d-ca50-4c57-90aa-91dea817d4db'
    },
    ["ITSM runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-item',
        contentBlueprintId: '9866346f-4709-4ae3-ba43-05bd2c30f689'
    },
    ["Incident communication"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-item',
        contentBlueprintId: '45175536-78b0-4f59-a44c-47b0994037d0'
    },
    ["Incident postmortem"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-item',
        contentBlueprintId: '08117408-2841-483d-a2f6-7fe1c8985b8d'
    },
    ["Job description"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-item',
        contentBlueprintId: '2571ed8f-b86b-4f30-aadd-997bbb259906'
    },
    ["Lenny's Performance Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-item',
        contentBlueprintId: '8c187053-1bc6-4fef-a9f1-3d22e02b94b4'
    },
    ["Lenny's product requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-item',
        contentBlueprintId: '245dd102-5d0f-41a2-b26c-048d43b60005'
    },
    ["Marketing plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-item',
        contentBlueprintId: '857e112e-50f1-4a24-b4f5-d6a717e4e279'
    },
    ["Meeting notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item',
        contentBlueprintId: 'ec8ecc7e-7e4b-4f8a-aa3f-a6a7f2df4ac9'
    },
    ["Message house"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-item',
        contentBlueprintId: '43864f05-5531-44c1-b54b-66b97993fc9f'
    },
    ["OKRs"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-item',
        contentBlueprintId: '1e2fb2f7-e6d6-4825-8f1e-47033a15bd52'
    },
    ["Persona"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-item',
        contentBlueprintId: '181f2ea7-5fd6-4cbc-aa8f-d314f62c2483'
    },
    ["Presenter mode"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-item',
        contentBlueprintId: 'b414482f-1bd4-460e-bf14-8607879a93cb'
    },
    ["Product Requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item',
        contentBlueprintId: '4443a61a-9a9a-4712-b81e-a84e3ae51554'
    },
    ["Product roadmap"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-item',
        contentBlueprintId: '72f7004a-2f37-4ea4-a95f-2daade784d58'
    },
    ["Project Kickoff"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-item',
        contentBlueprintId: '4342057b-f7b0-4385-9317-2b8de25ee952'
    },
    ["Project plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-item',
        contentBlueprintId: 'f7a9afa1-19c0-4558-abd4-f8060829f9fc'
    },
    ["Project status"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-item',
        contentBlueprintId: 'a2484be7-df58-4f17-a347-2fecb7b22bb9'
    },
    ["Project Timeline Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-item',
        contentBlueprintId: 'ecd39da6-2163-4ea4-b6c7-280b7662681b'
    },
    ["QTC Acquisition"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-item',
        contentBlueprintId: 'feafa3b9-bf33-46af-9452-1fbcbe36e0a2'
    },
    ["Remote team meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-item',
        contentBlueprintId: '5a273376-0251-49ca-9ee8-197e643bdfd3'
    },
    ["Risk assessment matrix"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-item',
        contentBlueprintId: '7f67b5e5-fd5e-4517-9006-0775f3f2f8ec'
    },
    ["Roles and responsibilities play"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-item',
        contentBlueprintId: 'be29e5eb-fbe7-4213-b16f-5fb25b13f2d8'
    },
    ["SMART Goals"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-item',
        contentBlueprintId: 'e97d646a-8b86-4561-9daf-ae7ee2de4a19'
    },
    ["SWOT analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-item',
        contentBlueprintId: '2f7a20e6-4b0d-478f-96cf-1f093470f571'
    },
    ["Sales Portal"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-item',
        contentBlueprintId: '985c2d47-6f30-4a58-915a-3103786a9f8f'
    },
    ["Sales account planning"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-item',
        contentBlueprintId: 'cd9f6877-6926-4f48-b178-0d897b70b99c'
    },
    ["Software Architecture Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-item',
        contentBlueprintId: 'd1e47ac0-cc06-4699-a939-b012a4ead2f8'
    },
    ["Sprint planning meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-item',
        contentBlueprintId: '611f84bb-1b6e-4a35-ba13-b67fdbeebfb6'
    },
    ["Stakeholder communications"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-item',
        contentBlueprintId: 'b6c3445f-bbc5-4de3-8b06-919619d9a82f'
    },
    ["Standard Operating Procedure (SOP) Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-item',
        contentBlueprintId: '14d6eb8f-cac0-494c-a22d-0e41bd76e9f9'
    },
    ["Strategic plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-item',
        contentBlueprintId: '43da1e9b-652d-4a0c-9570-cfdcbfc38c10'
    },
    ["Team homepage"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-item',
        contentBlueprintId: 'c9160e85-fb5c-4502-a6b9-c39c3f8f9d2a'
    },
    ["Team poster"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-item',
        contentBlueprintId: '2e0ddf37-d490-4bc8-9476-0597d928fe06'
    },
    ["To-do list"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-item',
        contentBlueprintId: 'c5ad620d-c78d-4d72-84aa-adf07798dc81'
    },
    ["Troubleshooting article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-item',
        contentBlueprintId: 'e864ea83-270e-47de-b573-b21d1cc537cd'
    },
    ["Vendor agreement"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-item',
        contentBlueprintId: '9f11fe97-3ee7-43d7-8ad0-05253c80c12e'
    },
    ["Virtual event"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-item',
        contentBlueprintId: '65012d82-c253-41de-8875-552cb92baa1d'
    },
    ["Vision to values"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-item',
        contentBlueprintId: '00361a2d-c2c9-4670-9cfc-49d8c4126122'
    },
    ["End of week status report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-item',
        contentBlueprintId: '6873d89c-765f-4677-b370-048005c7470b'
    },
    ["Weekly meeting notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-item',
        contentBlueprintId: '7c19a101-d13e-4d67-870b-279e6342c6bc'
    },
    ["Work trip planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-item',
        contentBlueprintId: 'b3c70113-a13a-4419-b906-7cac93bcd092'
    },
    ["Workshop planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-item',
        contentBlueprintId: 'e9889133-019b-4283-a4d2-9f916081cc76'
    },
    ["Writing guidelines"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-item',
        contentBlueprintId: '0193f684-d07b-4af1-af11-7dc20d7d7bc4'
    },
    ["Quarterly check in"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-item',
        contentBlueprintId: 'e2a1cea6-c5e7-4de1-b397-862efddc17d8'
    },
    ["AWS architecture diagram"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-item',
        contentBlueprintId: '777e5e10-8151-411b-9d3a-e18c32e1ccf9'
    },
    ["Marketing blog post"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-item',
        contentBlueprintId: '77b5e06c-c8a6-4fa5-b104-69b4b2c3006d'
    },
    ["Marketing campaign"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-item',
        contentBlueprintId: '4254b414-5ba3-4178-85fd-03c93166d92b'
    },
    ["Hiring process"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-item',
        contentBlueprintId: '29e1a62b-919d-4a1d-9325-ab26e1539bba'
    },
    ["Mutual action plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-item',
        contentBlueprintId: 'cd7d12fc-79c5-45fc-97e0-275b5fe09063'
    },
    ["ITSM weekly major incident report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-item',
        contentBlueprintId: '00917469-8d47-4375-8148-8f6e42db13a6'
    },
    ["Disruptive brainstorming"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-item',
        contentBlueprintId: '01e2cb00-2daf-41d8-aec2-e409c985bcbb'
    }
};
const $522761dd0b51db26$export$749d5881ec6896ca = (templates)=>{
    const blueprintModuleKeyToTemplate = {};
    templates?.allTemplates?.nodes?.forEach((template)=>{
        if (template?.blueprintModuleCompleteKey) blueprintModuleKeyToTemplate[template.blueprintModuleCompleteKey] = template;
    });
    return blueprintModuleKeyToTemplate;
};
module.exports["BLUEPRINT_NAMES"] = $522761dd0b51db26$export$82e276cacb9013c9;
module.exports["BLUEPRINT_NAMES_SET"] = $522761dd0b51db26$export$c42db12dd3d44bb8;
module.exports["BLUEPRINT_NAME_TO_IDS_MAPPING"] = $522761dd0b51db26$export$d7a793aff6267afc;
module.exports["mapBlueprintModuleKeyToTemplate"] = $522761dd0b51db26$export$749d5881ec6896ca;

});

parcelRegister("lNMA9", function(module, exports) {

var $8E5P5 = parcelRequire("8E5P5");


var $aZID8 = parcelRequire("aZID8");

const $238db7033b629672$export$eaa4084616ac3256 = {
    'SOFTWARE DEVELOPMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
        (0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART,
        (0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING,
        (0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM
    ],
    'CUSTOMER SERVICE': [
        (0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT,
        (0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION,
        (0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS
    ],
    'IT SUPPORT': [
        (0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS,
        (0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK,
        (0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT
    ],
    'PRODUCT MANAGEMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS,
        (0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    'PROJECT MANAGEMENT': [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).OKRS,
        (0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF
    ],
    DESIGN: [
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM,
        (0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    MARKETING: [
        (0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW
    ],
    SALES: [
        (0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE,
        (0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING,
        (0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW
    ],
    OPERATIONS: [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR,
        (0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING,
        (0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN
    ],
    RESEARCH: [
        (0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $8E5P5.BLUEPRINT_NAMES).PERSONA,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE
    ],
    FINANCE: [
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT,
        (0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION,
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX
    ],
    'HUMAN RESOURCES': [
        (0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT,
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART,
        (0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK,
        (0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION,
        (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN,
        (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
        (0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES
    ],
    LEGAL: [
        (0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX,
        (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES
    ],
    OTHER: [
        (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
        (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE
    ]
};
module.exports["teamToTemplatesMapping"] = $238db7033b629672$export$eaa4084616ac3256;

});

parcelRegister("aZID8", function(module, exports) {
/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */ 
var $kSwu1 = parcelRequire("kSwu1");

const $1b4f1e6e0b571adc$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    databaseTemplateType: {
        id: "experiment-personalized-templates-v2.database.template",
        defaultMessage: "Database template"
    },
    getStartedHeader: {
        id: "experiment-personalized-templates-v2.getting.started.header",
        defaultMessage: "Get started"
    },
    simpleRetrospectiveTemplate: {
        id: "experiment-personalized-templates-v2.simple.retrospective.template",
        defaultMessage: "Simple retrospective"
    },
    flowchartTemplate: {
        id: "experiment-personalized-templates-v2.flowchart.template",
        defaultMessage: "Flowchart"
    },
    prioritizationMatrixTemplate: {
        id: "experiment-personalized-templates-v2.prioritization.matrix.template",
        defaultMessage: "Prioritization matrix"
    },
    brainwritingTemplate: {
        id: "experiment-personalized-templates-v2.brainwriting.template",
        defaultMessage: "Brainwriting"
    },
    incidentPostmortemTemplate: {
        id: "experiment-personalized-templates-v2.incident.postmortem.template",
        defaultMessage: "Incident postmortem"
    },
    fourLsTemplate: {
        id: "experiment-personalized-templates-v2.four.ls.template",
        defaultMessage: "4 Ls Retro"
    },
    networkOfTeamsTemplate: {
        id: "experiment-personalized-templates-v2.network.of.teams.template",
        defaultMessage: "Network of teams"
    },
    disruptiveBrainstormTemplate: {
        id: "experiment-personalized-templates-v2.disruptive.brainstorm.template",
        defaultMessage: "Disruptive brainstorm"
    },
    conceptMapTemplate: {
        id: "experiment-personalized-templates-v2.concept.map.template",
        defaultMessage: "Concept map"
    },
    swimlanesProcessMapTemplate: {
        id: "experiment-personalized-templates-v2.swimlanes.process.map.template",
        defaultMessage: "Swimlanes process map"
    },
    swotAnalysisTemplate: {
        id: "experiment-personalized-templates-v2.swot.analysis.template",
        defaultMessage: "SWOT Analysis"
    },
    focusAreaDiagramTemplate: {
        id: "experiment-personalized-templates-v2.focus.area.diagram.template",
        defaultMessage: "Focus area diagram"
    },
    userStoryMapTemplate: {
        id: "experiment-personalized-templates-v2.user.story.map.template",
        defaultMessage: "User story map"
    },
    fishboneDiagramTemplate: {
        id: "experiment-personalized-templates-v2.fishbone.diagram.template",
        defaultMessage: "Fishbone diagram"
    },
    orgChartTemplate: {
        id: "experiment-personalized-templates-v2.org.chart.template",
        defaultMessage: "Org chart"
    },
    icebreakersTemplate: {
        id: "experiment-personalized-templates-v2.icebreakers.template",
        defaultMessage: "Icebreakers"
    },
    serviceBlueprintTemplate: {
        id: "experiment-personalized-templates-v2.service.blueprint.template",
        defaultMessage: "Service blueprint"
    },
    productVisionTemplate: {
        id: "experiment-personalized-templates-v2.product.vision.board.template",
        defaultMessage: "Product vision board"
    },
    workflowTemplate: {
        id: "experiment-personalized-templates-v2.workflow.template",
        defaultMessage: "Workflow"
    },
    timelineWorkflowTemplate: {
        id: "experiment-personalized-templates-v2.timeline.workflow.template",
        defaultMessage: "Timeline workflow"
    },
    teamHealthMonitorTemplate: {
        id: "experiment-personalized-templates-v2.team.health.monitor.template",
        defaultMessage: "Team health monitor"
    },
    teamCharterTemplate: {
        id: "experiment-personalized-templates-v2.team.charter.template",
        defaultMessage: "Team charter template"
    },
    actionPlanTemplate: {
        id: "experiment-personalized-templates-v2.action.plan.template",
        defaultMessage: "Action plan"
    },
    gapAnalysisTemplate: {
        id: "experiment-personalized-templates-v2.gap.analysis.template",
        defaultMessage: "Gap analysis"
    },
    productRoadmapTemplate: {
        id: "experiment-personalized-templates-v2.product.roadmap.template",
        defaultMessage: "Product roadmap"
    },
    crazy8sBrainstormingTemplate: {
        id: "experiment-personalized-templates-v2.product.crazy-8s-brainstorming.template",
        defaultMessage: "Crazy 8s brainstorming"
    },
    annualCalendarTemplate: {
        id: "experiment-personalized-templates-v2.product.annual-calendar.template",
        defaultMessage: "Annual Calendar"
    },
    stakeholderMappingTemplate: {
        id: "experiment-personalized-templates-v2.product.stakeholder-mapping.template",
        defaultMessage: "Stakeholder mapping"
    },
    rootCauseTemplate: {
        id: "experiment-personalized-templates-v2.product.root-cause.template",
        defaultMessage: "Root cause analysis"
    },
    executiveSummaryTemplate: {
        id: "experiment-personalized-templates-v2.product.executive-summary.template",
        defaultMessage: "Executive summary"
    },
    elevatorPitchTemplate: {
        id: "experiment-personalized-templates-v2.product.elevator-pitch.template",
        defaultMessage: "Elevator pitch"
    }
});


var $1c49274cbb1cbf62$export$2f1a3cf395e54495 = /*#__PURE__*/ function(WHITEBOARD_TEMPLATE_IDS) {
    WHITEBOARD_TEMPLATE_IDS["ACTION_PLAN"] = "action-plan";
    WHITEBOARD_TEMPLATE_IDS["ANNUAL_CALENDAR"] = "annual-calendar-2025-2026";
    WHITEBOARD_TEMPLATE_IDS["BRAINWRITING"] = "brainwriting";
    WHITEBOARD_TEMPLATE_IDS["CONCEPT_MAP"] = "concept-map";
    WHITEBOARD_TEMPLATE_IDS["CRAZY_8S_BRAINSTORMING"] = "crazy-8s";
    WHITEBOARD_TEMPLATE_IDS["DISRUPTIVE_BRAINSTORM"] = "disruptive-brainstorm";
    WHITEBOARD_TEMPLATE_IDS["EXECUTIVE_SUMMARY"] = "executive-summary";
    WHITEBOARD_TEMPLATE_IDS["FISHBONE_DIAGRAM"] = "fishbone-diagram";
    WHITEBOARD_TEMPLATE_IDS["FLOWCHART"] = "flow-chart";
    WHITEBOARD_TEMPLATE_IDS["FOCUS_AREA_DIAGRAM"] = "focus-area-diagram";
    WHITEBOARD_TEMPLATE_IDS["FOURLS_RETRO"] = "4ls-retro";
    WHITEBOARD_TEMPLATE_IDS["GAP_ANALYSIS"] = "gap-analysis";
    WHITEBOARD_TEMPLATE_IDS["ICEBREAKERS"] = "ice-breakers";
    WHITEBOARD_TEMPLATE_IDS["INCIDENT_POSTMORTEM"] = "incident-postmortem";
    WHITEBOARD_TEMPLATE_IDS["NETWORK_OF_TEAMS"] = "network-of-teams";
    WHITEBOARD_TEMPLATE_IDS["ORG_CHART"] = "org-chart";
    WHITEBOARD_TEMPLATE_IDS["PRIORITIZATION_MATRIX"] = "prioritization";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_ROADMAP"] = "product-roadmap";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_VISION_BOARD"] = "product-vision-board";
    WHITEBOARD_TEMPLATE_IDS["ROOT_CAUSE_TEMPLATE"] = "root-cause-analysis";
    WHITEBOARD_TEMPLATE_IDS["SERVICE_BLUEPRINT"] = "service-blueprint";
    WHITEBOARD_TEMPLATE_IDS["SIMPLE_RETROSPECTIVE"] = "simple-retrospective";
    WHITEBOARD_TEMPLATE_IDS["STAKEHOLDER_MAPPING"] = "stakeholder-mapping";
    WHITEBOARD_TEMPLATE_IDS["SWIMLANES_PROCESS_MAP"] = "swimlanes";
    WHITEBOARD_TEMPLATE_IDS["SWOT_ANALYSIS"] = "swot-analysis";
    WHITEBOARD_TEMPLATE_IDS["TEAM_CHARTER_TEMPLATE"] = "team-formation-guide";
    WHITEBOARD_TEMPLATE_IDS["TEAM_HEALTH_MONITOR"] = "health-monitor";
    WHITEBOARD_TEMPLATE_IDS["TIMELINE_WORKFLOW"] = "timeline-workflow";
    WHITEBOARD_TEMPLATE_IDS["USER_STORY_MAP"] = "user-story-map";
    WHITEBOARD_TEMPLATE_IDS["WORKFLOW_TEMPLATE"] = "workflow";
    WHITEBOARD_TEMPLATE_IDS["ELEVATOR_PITCH"] = "elevator-pitch";
    return WHITEBOARD_TEMPLATE_IDS;
}({});
const $1c49274cbb1cbf62$export$e6f6ad6a6a9f5ec0 = {
    ["simple-retrospective"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).simpleRetrospectiveTemplate,
    ["prioritization"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).prioritizationMatrixTemplate,
    ["brainwriting"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).brainwritingTemplate,
    ["incident-postmortem"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).incidentPostmortemTemplate,
    ["4ls-retro"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).fourLsTemplate,
    ["network-of-teams"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).networkOfTeamsTemplate,
    ["disruptive-brainstorm"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).disruptiveBrainstormTemplate,
    ["concept-map"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).conceptMapTemplate,
    ["swimlanes"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).swimlanesProcessMapTemplate,
    ["swot-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).swotAnalysisTemplate,
    ["focus-area-diagram"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).focusAreaDiagramTemplate,
    ["user-story-map"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).userStoryMapTemplate,
    ["timeline-workflow"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).timelineWorkflowTemplate,
    ["fishbone-diagram"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).fishboneDiagramTemplate,
    ["org-chart"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).orgChartTemplate,
    ["ice-breakers"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).icebreakersTemplate,
    ["service-blueprint"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).serviceBlueprintTemplate,
    ["product-vision-board"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).productVisionTemplate,
    ["workflow"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).workflowTemplate,
    ["health-monitor"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).teamHealthMonitorTemplate,
    ["flow-chart"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).flowchartTemplate,
    ["team-formation-guide"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).teamCharterTemplate,
    ["action-plan"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).actionPlanTemplate,
    ["executive-summary"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).executiveSummaryTemplate,
    ["root-cause-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).rootCauseTemplate,
    ["stakeholder-mapping"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).stakeholderMappingTemplate,
    ["gap-analysis"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).gapAnalysisTemplate,
    ["annual-calendar-2025-2026"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).annualCalendarTemplate,
    ["crazy-8s"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).crazy8sBrainstormingTemplate,
    ["product-roadmap"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).productRoadmapTemplate,
    ["elevator-pitch"]: (0, $1b4f1e6e0b571adc$export$a7357cdd1f0b0168).elevatorPitchTemplate
};
const $1c49274cbb1cbf62$export$e29ba58b8013030 = new Set(Object.values($1c49274cbb1cbf62$export$2f1a3cf395e54495));
module.exports["WHITEBOARD_TEMPLATE_IDS"] = $1c49274cbb1cbf62$export$2f1a3cf395e54495;
module.exports["WHITEBOARD_TEMPLATE_TITLE_MAPPING"] = $1c49274cbb1cbf62$export$e6f6ad6a6a9f5ec0;

});

parcelRegister("k70KU", function(module, exports) {

var $8E5P5 = parcelRequire("8E5P5");


var $aZID8 = parcelRequire("aZID8");

const $f3ad0d73036ec58e$export$2c95017061b2237f = [
    (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN,
    (0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
    (0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES,
    (0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER,
    (0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
    (0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE,
    (0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
    (0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST
];
module.exports["DEFAULT_POPULAR_TEMPLATES"] = $f3ad0d73036ec58e$export$2c95017061b2237f;

});

parcelRegister("7eJWX", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $1gy7x = parcelRequire("1gy7x");

const $ee10c3f51286dbb8$var$deserializeTemplateUsage = (serializedTemplateUsage, templateList)=>{
    try {
        const parsedTemplateUsage = JSON.parse(serializedTemplateUsage || '{}');
        if (typeof parsedTemplateUsage !== 'object') return {};
        // There's no control over the shape of the object that's deserialized,
        // so we need to filter out any keys and values that aren't valid.
        const templateListSet = new Set(templateList);
        return Object.keys(parsedTemplateUsage).reduce((acc, key)=>templateListSet.has(key) ? {
                ...acc,
                [key]: parsedTemplateUsage[key]
            } : acc, {});
    } catch (e) {
        return {};
    }
};
const $ee10c3f51286dbb8$var$serializeTemplateUsage = (deserializedTemplateUsage)=>{
    return JSON.stringify(deserializedTemplateUsage);
};
const $ee10c3f51286dbb8$export$eade43de7a369096 = (serializedTemplateUsage, templateList, templateUsageKey = (0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS).templateUsageValues)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const deserializedTemplateUsage = $ee10c3f51286dbb8$var$deserializeTemplateUsage(serializedTemplateUsage, templateList);
    const incrementTemplateUsage = (templateId)=>{
        const updatedTemplateUsage = {
            ...deserializedTemplateUsage,
            [templateId]: (deserializedTemplateUsage[templateId] || 0) + 1
        };
        setOnboardingState({
            key: templateUsageKey,
            value: $ee10c3f51286dbb8$var$serializeTemplateUsage(updatedTemplateUsage)
        });
    };
    return {
        deserializedTemplateUsage: deserializedTemplateUsage,
        incrementTemplateUsage: incrementTemplateUsage
    };
};
module.exports["usePTV2TemplateUsage"] = $ee10c3f51286dbb8$export$eade43de7a369096;

});

parcelRegister("25bKr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bDjVc = parcelRequire("bDjVc");


var $9DHhW = parcelRequire("9DHhW");


var $cJ0FD = parcelRequire("cJ0FD");


var $bZSO8 = parcelRequire("bZSO8");


var $dPJCf = parcelRequire("dPJCf");


var $dR5is = parcelRequire("dR5is");


var $aZID8 = parcelRequire("aZID8");


var $34yV7 = parcelRequire("34yV7");


var $hxdG1 = parcelRequire("hxdG1");

const $e8e43144b9c01ae5$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    whiteboardTemplateType: {
        id: "experiment-personalized-templates-v2.whiteboard.template",
        defaultMessage: "Whiteboard template"
    }
});
const $e8e43144b9c01ae5$export$8e3c134254b621fa = ({ usage: usage, templateName: templateName, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { personalSpaceKey: personalSpaceKey, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source } = (0, $hxdG1.usePTV2State)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateCardPTV2',
                source: source ?? 'cc-onboarding-personalized-templates-v2',
                attributes: {
                    templateType: 'whiteboard',
                    templateId: templateName,
                    personalizationHeuristic: // whiteboard template names are already the IDs
                    personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                }
            }
        }).fire();
        onClick();
        push((0, $bZSO8.buildCreationLink)({
            contentType: 'whiteboard',
            source: 'cc-onboarding-personalized-templates-v2',
            spaceKey: personalSpaceKey,
            insertTemplateWithKey: templateName,
            openTemplatePicker: false
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dR5is.PTV2TemplateCard), {
        usage: usage,
        subTitle: formatMessage($e8e43144b9c01ae5$export$a7357cdd1f0b0168.whiteboardTemplateType),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
            label: ""
        }),
        onClick: handleClick,
        title: formatMessage((0, $aZID8.WHITEBOARD_TEMPLATE_TITLE_MAPPING)[templateName]),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, $34yV7.WHITEBOARD_TEMPLATE_TO_IMG_MAPPING)[templateName] || (0, $34yV7.defaultImgSrc),
            srcDark: (0, $34yV7.WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING)[templateName] || (0, $34yV7.defaultDarkImgSrc),
            alt: ""
        })
    });
};
module.exports["PTV2WhiteboardTemplateCard"] = $e8e43144b9c01ae5$export$8e3c134254b621fa;

});

parcelRegister("bTccH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $cJ0FD = parcelRequire("cJ0FD");


var $kLlYX = parcelRequire("kLlYX");


var $2YJkl = parcelRequire("2YJkl");


var $dR5is = parcelRequire("dR5is");


var $34yV7 = parcelRequire("34yV7");


var $hxdG1 = parcelRequire("hxdG1");


var $8E5P5 = parcelRequire("8E5P5");

const $db0a355b403329ac$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    pageTemplateType: {
        id: "experiment-personalized-templates-v2.page.template",
        defaultMessage: "Page template"
    },
    documentTemplateType: {
        id: "experiment-personalized-templates-v2.document.template",
        defaultMessage: "Document template"
    }
});
const $db0a355b403329ac$export$2744e97e4feefb02 = ({ usage: usage, templateName: templateName, onClick: onClick, blueprintModuleKeyToTemplate: blueprintModuleKeyToTemplate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { personalSpaceKey: personalSpaceKey, personalizationHeuristic: personalizationHeuristic, onboardingPeriodDay: onboardingPeriodDay, isXflow: isXflow, source: source } = (0, $hxdG1.usePTV2State)();
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const blueprintIds = (0, $8E5P5.BLUEPRINT_NAME_TO_IDS_MAPPING)[templateName];
    if (!blueprintIds) return null;
    const { blueprintModuleCompleteKey: blueprintModuleCompleteKey } = blueprintIds;
    const template = blueprintModuleKeyToTemplate[blueprintModuleCompleteKey];
    if (!template || !template?.name) return null;
    const handleClick = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateCardPTV2',
                source: source ?? 'cc-onboarding-personalized-templates-v2',
                attributes: {
                    templateType: 'blueprint',
                    templateId: blueprintModuleCompleteKey.substring(blueprintModuleCompleteKey.lastIndexOf(':') + 1),
                    personalizationHeuristic: personalizationHeuristic,
                    onboardingPeriodDay: onboardingPeriodDay,
                    isXflow: isXflow
                }
            }
        }).fire();
        onClick();
        try {
            await createFromTemplate(template, personalSpaceKey, {
                subType: 'live'
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'template',
                    actionSubjectId: template?.name,
                    source: 'cc-onboarding-personalized-templates-v2',
                    attributes: {
                        isXflow: isXflow
                    }
                }
            }).fire();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'template',
                    actionSubjectId: template?.name,
                    source: 'cc-onboarding-personalized-templates-v2',
                    attributes: {
                        errorMessage: error.message,
                        isXflow: isXflow
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dR5is.PTV2TemplateCard), {
        usage: usage,
        title: template?.name,
        subTitle: formatMessage($db0a355b403329ac$export$a7357cdd1f0b0168.documentTemplateType),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            label: ""
        }),
        onClick: handleClick,
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, $34yV7.BLUEPRINT_NAME_TO_IMG_MAPPING)[templateName] || (0, $34yV7.defaultImgSrc),
            srcDark: (0, $34yV7.BLUEPRINT_IMG_MAP_DARK)[templateName] || (0, $34yV7.defaultDarkImgSrc),
            alt: ""
        })
    });
};
module.exports["PTV2BlueprintTemplateCard"] = $db0a355b403329ac$export$2744e97e4feefb02;

});

parcelRegister("atAUv", function(module, exports) {

let $7a093e6cf24928d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a093e6cf24928d5$var$load("5R843").then(()=>parcelRequire('fB9FN'));

});

parcelRegister("lunzW", function(module, exports) {

let $fa4eb08cf2227af3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa4eb08cf2227af3$var$load("5DMKu").then(()=>parcelRequire('lCxJe'));

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("ctLrB", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $5T18X = parcelRequire("5T18X");


var $kSwu1 = parcelRequire("kSwu1");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["SLIDE"] = "SLIDE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $kSwu1.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $5T18X.NetworkStatus).loading || networkStatus === (0, $5T18X.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $5T18X.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent) {
        if (content) {
            content.type = content.type?.toLowerCase();
            if (content.type === 'blog_post') content.type = 'blogpost';
            content.subtype = content.subtype?.toLowerCase();
            // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
            // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
            // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
            content.status = [
                content.status,
                content.pageStatus,
                content.blogStatus
            ].find((status)=>status)?.toLowerCase();
            // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
            if (content.status === 'draft' && content.createdAt) content.status = 'current';
        }
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("iQ6OW", function(module, exports) {

let $db725fbfe5717ba3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db725fbfe5717ba3$var$load("64FEU"),
    $db725fbfe5717ba3$var$load("VXbA1"),
    $db725fbfe5717ba3$var$load("5sDt8")
]).then(()=>parcelRequire('g5UrS'));

});

parcelRegister("2HmqS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    resultLastModifiedContent: {
        id: "entity-view.content.lastmodified",
        defaultMessage: "Updated"
    },
    resultLastModifiedAttachment: {
        id: "entity-view.attachment.lastmodified",
        defaultMessage: "Uploaded"
    },
    contentDraft: {
        id: "entity-view.content.draft",
        defaultMessage: "Draft"
    },
    contentArchived: {
        id: "entity-view.content.archived",
        defaultMessage: "Archived"
    },
    contentUnpublished: {
        id: "entity-view.content.unpublishes",
        defaultMessage: "Unpublished changes"
    },
    contentUntitled: {
        id: "entity-view.content.untitled",
        defaultMessage: "Untitled"
    },
    spaceArchived: {
        id: "entity-view.content.spaceArchived",
        defaultMessage: "archived"
    },
    spaceStarred: {
        id: "entity-view.content.spaceStarred",
        defaultMessage: "starred"
    },
    contentScheduled: {
        id: "entity-view.content.scheduled",
        defaultMessage: "Publish scheduled"
    }
});
module.exports["i18n"] = $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("brn6e", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $iDrrr.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_iconNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("dbXpw", function(module, exports) {
/* AgentSessionListItemView.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxRuntime classic */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bLfHG = parcelRequire("bLfHG");


var $chu6R = parcelRequire("chu6R");


var $fxA94 = parcelRequire("fxA94");


var $aOjGz = parcelRequire("aOjGz");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");


var $lpNn5 = parcelRequire("lpNn5");


var $f6wWZ = parcelRequire("f6wWZ");


var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $lTWbV = parcelRequire("lTWbV");


var $hA174 = parcelRequire("hA174");


var $e6wiu = parcelRequire("e6wiu");

const $d11af17e400c7f9f$var$styles = {
    title: "_2O5Vij7dHp _1EqgXlN91d _4ouGXIdnbC",
    titleText: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbvLZJ _1UtDYzy7kJ _1kk5Tkf7mX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
    metadata: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7",
    separator: "_3YEZNOdnbC _0GTcwR1Y8M _2xTnZx1Y8M",
    spaceLinkWrapper: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _42Yu6B7dHp _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _17lj8p1Y8M",
    agentMetadata: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _17lj8p1Y8M",
    agentPicture: "_0bjKvDS5Zs _3YEZNOdnbC _00EA0eiObl",
    statusIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg",
    sessionLocation: "_3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _17lj8p1Y8M",
    status: "_2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _3YEZNOdnbC _17lj8p1Y8M _4ouGXIT0NC _4kiQYAoWWg",
    workingStatus: "_1UtDYzZpcK",
    needsInputStatus: "_1UtDYzZpcK",
    finishedStatus: "_1UtDYzGL5O",
    spaceLink: "_4bt5LAnQyn _2WAcuGnQyn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _39HuIbz8Lp _4DXJrK98eZ _4yBLMOYbGa _2QcX5c6wH8 _2nTuUYKGUX _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMKGUX"
};
const $d11af17e400c7f9f$var$AgentSessionStatus = ({ status: status })=>{
    switch(status){
        case 'working':
            return /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": "agent-session-working-status",
                className: (0, $hekY6.default)([
                    $d11af17e400c7f9f$var$styles.status,
                    $d11af17e400c7f9f$var$styles.workingStatus
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $hA174.recentWorkMessages).working), /*#__PURE__*/ $cozmU.createElement((0, $f6wWZ.EllipsesAnimation), null));
        case 'finished':
            return /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": "agent-session-finished-status",
                className: (0, $hekY6.default)([
                    $d11af17e400c7f9f$var$styles.status,
                    $d11af17e400c7f9f$var$styles.finishedStatus
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $hA174.recentWorkMessages).finished), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $d11af17e400c7f9f$var$styles.statusIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-success, #6A9A23)",
                testId: "agent-session-finished-icon"
            })));
        case 'needs-input':
        default:
            return /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": "agent-session-needs-input-status",
                className: (0, $hekY6.default)([
                    $d11af17e400c7f9f$var$styles.status,
                    $d11af17e400c7f9f$var$styles.needsInputStatus
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $hA174.recentWorkMessages).needsInput), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $d11af17e400c7f9f$var$styles.statusIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxA94))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-information, #357DE8)",
                testId: "agent-session-needs-input-icon"
            })));
    }
};
const $d11af17e400c7f9f$export$3f110ad00123adad = ({ title: title, url: url, onClick: onClick, agentName: agentName, agentPicture: agentPicture, contentType: contentType, contentSubType: contentSubType, space: space, status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const titleContent = title || formatMessage((0, $hA174.recentWorkMessages).agentSession);
    const resolvedAgentName = agentName || formatMessage((0, $hA174.recentWorkMessages).rovoAgent);
    const contentTypeMessage = (0, $e6wiu.getContentTypeMessage)(contentType, contentSubType) || (0, $hA174.recentWorkMessages).chat;
    const primary = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: titleContent,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d11af17e400c7f9f$var$styles.title,
            testId: "agent-session-card-title",
            ...tooltipProps
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $d11af17e400c7f9f$var$styles.titleText
            ])
        }, titleContent)));
    const secondary = /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d11af17e400c7f9f$var$styles.metadata
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $d11af17e400c7f9f$var$styles.agentMetadata
        ])
    }, agentPicture && /*#__PURE__*/ $cozmU.createElement("img", {
        src: agentPicture,
        width: 12,
        height: 12,
        alt: "",
        "data-testid": "agent-session-agent-picture",
        className: (0, $hekY6.default)([
            $d11af17e400c7f9f$var$styles.agentPicture
        ])
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": "agent-session-agent-name"
    }, resolvedAgentName)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d11af17e400c7f9f$var$styles.separator,
        "aria-hidden": "true"
    }, "\xb7"), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), contentTypeMessage), space?.name && /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $d11af17e400c7f9f$var$styles.sessionLocation
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d11af17e400c7f9f$var$styles.separator,
        "aria-hidden": "true"
    }, "\xb7"), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d11af17e400c7f9f$var$styles.spaceLinkWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        testId: "agent-session-space-icon"
    }), space.spaceKey ? /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        xcss: $d11af17e400c7f9f$var$styles.spaceLink,
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: space.spaceKey
        })
    }, space.name) : space.name)));
    const row = /*#__PURE__*/ $cozmU.createElement((0, $lTWbV.RecentWorkListItemLayout), {
        url: url,
        onClick: onClick,
        ariaLabel: titleContent,
        testId: "agent-session-list-item",
        icon: contentType ? (0, $e6wiu.getContentIcon)(contentType, contentSubType) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            testId: "agent-session-chat-icon"
        }),
        secondary: secondary,
        actions: status ? /*#__PURE__*/ $cozmU.createElement($d11af17e400c7f9f$var$AgentSessionStatus, {
            status: status
        }) : undefined
    }, primary);
    return url ? /*#__PURE__*/ $cozmU.createElement((0, $hXDOc.HoverPreloader), {
        name: "agent-session-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, row) : row;
};
module.exports["AgentSessionListItemView"] = $d11af17e400c7f9f$export$3f110ad00123adad;

});

parcelRegister("f6wWZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $942fc30d2b38e6cb$var$animation = null;
const $942fc30d2b38e6cb$var$animation1 = null;
const $942fc30d2b38e6cb$var$animation2 = null;
const $942fc30d2b38e6cb$var$dot1 = null;
const $942fc30d2b38e6cb$var$dot2 = null;
const $942fc30d2b38e6cb$var$dot3 = null;
const $942fc30d2b38e6cb$var$animatedOpacity = null;
const $942fc30d2b38e6cb$export$c0e6915bcce7d1d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isAnimated: t1 } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const t2 = isAnimated && "";
    const t3 = isAnimated && "_2fBhteHasb";
    const t4 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t5,
            d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
            fill: "#1868DB"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isAnimated && "";
    const t8 = isAnimated && "_2fBhteVjaG";
    const t9 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t10;
    if ($[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t10 = (0, $hekY6.default)([
            t7,
            t8,
            t9
        ]);
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t10,
            d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
            fill: "#BF63F3"
        });
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const t12 = isAnimated && "";
    const t13 = isAnimated && "_2fBhtegMFr";
    const t14 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t15;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
        t15 = (0, $hekY6.default)([
            t12,
            t13,
            t14
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t15,
            d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
            fill: "#FCA700"
        });
        $[16] = t15;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== t11 || $[19] !== t16 || $[20] !== t6) {
        t17 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t6, t11, t16);
        $[18] = t11;
        $[19] = t16;
        $[20] = t6;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteHasb",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteVjaG",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhtegMFr",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};
module.exports["EllipsesAnimation"] = $942fc30d2b38e6cb$export$c0e6915bcce7d1d0;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("1jsae", function(module, exports) {
module.exports = new URL("RecentEmptyStateDark.f3f34e0a.svg", import.meta.url).toString();

});

parcelRegister("lKplK", function(module, exports) {
module.exports = new URL("RecentEmptyStateLight.623e8d6d.svg", import.meta.url).toString();

});

parcelRegister("iGOxg", function(module, exports) {
module.exports = new URL("SearchErrorImage.5b33bcd4.svg", import.meta.url).toString();

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("6YrB3", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("f9XbP")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $f9XbP = parcelRequire("f9XbP");


var $293056f9068f55f6$export$2e2bcd8739ae039 = (0, $f9XbP.StorageClient);

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $4KkEB = parcelRequire("4KkEB");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $4KkEB.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("4KkEB", function(module, exports) {
const $0745f528b71a1a3c$export$3364800d9d60baf9 = 'localStorage';
module.exports["DEFAULT_STORAGE_ENGINE"] = $0745f528b71a1a3c$export$3364800d9d60baf9;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ 
var $4o0zT = parcelRequire("4o0zT");


var $EBNuL = parcelRequire("EBNuL");

const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $EBNuL.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    if (!ari && (0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11')) return undefined;
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getLocationScope"] = $a2c616dead6b3b85$export$36d45714d1e88dec;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("EBNuL", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $059546548da04295$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $059546548da04295$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match?.[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $059546548da04295$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match?.[2]) return match[2];
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $059546548da04295$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $059546548da04295$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID = 'description';
const $059546548da04295$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $059546548da04295$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $059546548da04295$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch?.[1] && workItemMatch[2]) return $059546548da04295$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    return fieldValueParts && $059546548da04295$var$toJiraFieldLocation(fieldValueParts);
};
module.exports["getJiraIssueAriFromSourceAri"] = $059546548da04295$export$9d29a8e91440be5c;
module.exports["parseJiraFieldLocation"] = $059546548da04295$export$decd92eb8dd00bf5;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("5BvyC", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/blogpost/manifest.ts
var $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $4148e3160e6a23b4$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $4148e3160e6a23b4$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<0fb7b778e884fde647da24980606dd2b>>
 * @relayHash 0e97369e1bfa5659fc7cb13e5e23293d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalExpirationConfig"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceSettings",
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentStateSettings",
                                "kind": "LinkedField",
                                "name": "contentStateSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ContentState",
                                        "kind": "LinkedField",
                                        "name": "spaceContentStates",
                                        "plural": true,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "success"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v21 = [
        v8 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v15 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v22 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v13 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "condition": "includeApprovalExpirationConfig",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ConfluenceApprovalExpirationConfig",
                                        "kind": "LinkedField",
                                        "name": "approvalExpirationConfig",
                                        "plural": false,
                                        "selections": [
                                            v14 /*: any*/ ,
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationInterval",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    v15 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unit"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "restartApproval"
                                            },
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                                                "kind": "LinkedField",
                                                "name": "changeStatus",
                                                "plural": false,
                                                "selections": [
                                                    v14 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "expireToContentStateId"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v21 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "status"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v26 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v28 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v29 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v30 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v32 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v33 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v35 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v37 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v38 = [
        v15 /*: any*/ 
    ], v39 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ]
    }, v40 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v41 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0e97369e1bfa5659fc7cb13e5e23293d",
            "id": "ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a285f0ce20dbf6d66aa1a29a488d317f";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("8j5U7", function(module, exports) {

var $6lBQA = parcelRequire("6lBQA");

//#region src/static.ts
function $60c4ad8333edba96$var$assertContentDescriptor(value, path) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) throw new Error(`defineContent: ${path} must be a descriptor object`);
    const { id: id, defaultMessage: defaultMessage, description: description, role: role, ...rest } = value;
    const [unsupported] = Object.keys(rest);
    if (unsupported !== void 0) throw new Error(`defineContent: ${path}.${unsupported} is not supported`);
    if (typeof id !== "string" || id.length === 0) throw new Error(`defineContent: ${path}.id must be a non-empty string`);
    if (typeof defaultMessage !== "string") throw new Error(`defineContent: ${path}.defaultMessage must be a string`);
    if (description !== void 0 && typeof description !== "string") throw new Error(`defineContent: ${path}.description must be a string when provided`);
    if (role !== void 0 && !(0, $6lBQA.t).includes(role)) throw new Error(`defineContent: ${path}.role must be 'title' or 'description'`);
}
function $60c4ad8333edba96$var$assertContentUnit(value, contentId) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) throw new Error(`defineContent: content["${contentId}"] must be a content unit object`);
    const keysByRole = /* @__PURE__ */ new Map();
    for (const [key, descriptor] of Object.entries(value)){
        $60c4ad8333edba96$var$assertContentDescriptor(descriptor, `content["${contentId}"]["${key}"]`);
        if (descriptor.role !== void 0) keysByRole.set(descriptor.role, [
            ...keysByRole.get(descriptor.role) ?? [],
            key
        ]);
    }
    for (const role of (0, $6lBQA.t)){
        const keys = keysByRole.get(role) ?? [];
        if (keys.length !== 1) throw new Error(keys.length === 0 ? `defineContent: content["${contentId}"] needs a descriptor with role: '${role}'` : `defineContent: content["${contentId}"] has more than one descriptor with role: '${role}' (${keys.join(", ")})`);
    }
}
function $60c4ad8333edba96$var$toDefinedContent(content) {
    if (typeof content !== "object" || content === null || Array.isArray(content)) throw new Error("defineContent: content must be a content map");
    if (!("default" in content)) throw new Error("defineContent: content.default is required");
    for (const [contentId, contentUnit] of Object.entries(content))$60c4ad8333edba96$var$assertContentUnit(contentUnit, contentId);
    return content;
}
//#endregion
//#region src/index.ts
/**
* Register a static content map for intl extraction and offline discovery. The map holds one
* content unit per config set, plus a `default`; each unit labels one descriptor `role: 'title'`
* and one `role: 'description'`, which is the copy the reranker reads. Providers that resolve
* content at runtime import from `@post-office/define-content/dynamic` instead.
*
* A unit that labels a role wrongly fails the call and names itself, whether or not the export
* carries an annotation. The same rules are enforced again on load, which is what covers copy
* assembled somewhere the compiler cannot follow.
*
* The return is `NoInfer` so an annotation on the export cannot become a second candidate for
* `TContent`. A candidate that disagrees with the argument resolves to the constraint, which would
* run the role check against `ContentUnit` and report a role missing from every unit.
*/ function $60c4ad8333edba96$export$9e779e5a685ebe98(content) {
    return $60c4ad8333edba96$var$toDefinedContent(content);
}
 //# sourceMappingURL=index.mjs.map
module.exports["defineContent"] = $60c4ad8333edba96$export$9e779e5a685ebe98;

});

parcelRegister("6lBQA", function(module, exports) {
//#region src/content-contract.ts
const $49f20fe667b281a7$export$625550452a3fa3ec = [
    "title",
    "description"
];
const $49f20fe667b281a7$export$7ccc53e8f1e7dfc5 = (value)=>$49f20fe667b281a7$export$625550452a3fa3ec.includes(value);
 //# sourceMappingURL=content-contract-BEyp29FQ.mjs.map
module.exports["t"] = $49f20fe667b281a7$export$625550452a3fa3ec;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("8a6td", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $4Df0x = parcelRequire("4Df0x");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $43cf7dd3eda107a4$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
const $43cf7dd3eda107a4$export$602140a6a10b02bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira Product Discovery" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
            svg: $43cf7dd3eda107a4$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function JiraProductDiscoveryLogoCS({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Df0x.LogoWrapper), {
        svg: $43cf7dd3eda107a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraProductDiscoveryLogoCS"] = $43cf7dd3eda107a4$export$602140a6a10b02bf;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    t3,
                    icon
                ]
            })
        });
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_iconNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("1LXnB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

const $12a75cc47e499450$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
module.exports["WidthObserver"] = $12a75cc47e499450$export$b2ad68b9bc407b80;

});

parcelRegister("69NJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("1NWCx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $19a7da84dd2786d0$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
module.exports["useLayoutEffect"] = $19a7da84dd2786d0$export$e5c5a5f917a5871c;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("303LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f44c32aa84ec90$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $22f44c32aa84ec90$var$n() {
    return $22f44c32aa84ec90$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $22f44c32aa84ec90$var$n.apply(this, arguments);
}
const $22f44c32aa84ec90$var$r = [
    "children",
    "options"
], $22f44c32aa84ec90$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $22f44c32aa84ec90$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $22f44c32aa84ec90$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $22f44c32aa84ec90$var$c = [
    "style",
    "script",
    "pre"
], $22f44c32aa84ec90$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $22f44c32aa84ec90$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $22f44c32aa84ec90$var$l = /\n{2,}$/, $22f44c32aa84ec90$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $22f44c32aa84ec90$var$f = /^ *> ?/gm, $22f44c32aa84ec90$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $22f44c32aa84ec90$var$d = /^ {2,}\n/, $22f44c32aa84ec90$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $22f44c32aa84ec90$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $22f44c32aa84ec90$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $22f44c32aa84ec90$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $22f44c32aa84ec90$var$m = /^(?:\n *)*\n/, $22f44c32aa84ec90$var$k = /\r\n?/g, $22f44c32aa84ec90$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $22f44c32aa84ec90$var$q = /^\[\^([^\]]+)]/, $22f44c32aa84ec90$var$v = /\f/g, $22f44c32aa84ec90$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $22f44c32aa84ec90$var$$ = /^\s*?\[(x|\s)\]/, $22f44c32aa84ec90$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $22f44c32aa84ec90$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $22f44c32aa84ec90$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $22f44c32aa84ec90$var$B = /^<!--[\s\S]*?(?:-->)/, $22f44c32aa84ec90$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $22f44c32aa84ec90$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $22f44c32aa84ec90$var$j = /^\{.*\}$/, $22f44c32aa84ec90$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $22f44c32aa84ec90$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $22f44c32aa84ec90$var$T = /-([a-z])?/gi, $22f44c32aa84ec90$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $22f44c32aa84ec90$var$w = /^[^\n]+(?:  \n|\n{2,})/, $22f44c32aa84ec90$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $22f44c32aa84ec90$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $22f44c32aa84ec90$var$N = /\t/g, $22f44c32aa84ec90$var$G = /(^ *\||\| *$)/g, $22f44c32aa84ec90$var$U = /^ *:-+: *$/, $22f44c32aa84ec90$var$V = /^ *:-+ *$/, $22f44c32aa84ec90$var$H = /^ *-+: *$/, $22f44c32aa84ec90$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $22f44c32aa84ec90$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $22f44c32aa84ec90$var$J = RegExp(`^([*_])\\1${$22f44c32aa84ec90$var$Q(1)}${$22f44c32aa84ec90$var$W}\\1\\1(?!\\1)`), $22f44c32aa84ec90$var$K = RegExp(`^([*_])${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1(?!\\1)`), $22f44c32aa84ec90$var$X = RegExp(`^(==)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$Y = RegExp(`^(~~)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $22f44c32aa84ec90$var$ne = /^\\([^0-9A-Za-z\s])/, $22f44c32aa84ec90$var$re = /\\([^0-9A-Za-z\s])/g, $22f44c32aa84ec90$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $22f44c32aa84ec90$var$oe = /^\n+/, $22f44c32aa84ec90$var$ae = /^([ \t]*)/, $22f44c32aa84ec90$var$ce = /(?:^|\n)( *)$/, $22f44c32aa84ec90$var$ie = "(?:\\d+\\.)", $22f44c32aa84ec90$var$ue = "(?:[*+-])";
function $22f44c32aa84ec90$var$le(e) {
    return "( *)(" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + ") +";
}
const $22f44c32aa84ec90$var$se = $22f44c32aa84ec90$var$le(1), $22f44c32aa84ec90$var$fe = $22f44c32aa84ec90$var$le(2);
function $22f44c32aa84ec90$var$_e(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe));
}
const $22f44c32aa84ec90$var$de = $22f44c32aa84ec90$var$_e(1), $22f44c32aa84ec90$var$pe = $22f44c32aa84ec90$var$_e(2);
function $22f44c32aa84ec90$var$ye(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $22f44c32aa84ec90$var$he = $22f44c32aa84ec90$var$ye(1), $22f44c32aa84ec90$var$ge = $22f44c32aa84ec90$var$ye(2);
function $22f44c32aa84ec90$var$me(e) {
    const n = 1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $22f44c32aa84ec90$var$ke = $22f44c32aa84ec90$var$me(1), $22f44c32aa84ec90$var$xe = $22f44c32aa84ec90$var$me(2);
function $22f44c32aa84ec90$var$qe(e, n) {
    const r = 1 === n, t = r ? $22f44c32aa84ec90$var$ke : $22f44c32aa84ec90$var$xe, o = r ? $22f44c32aa84ec90$var$he : $22f44c32aa84ec90$var$ge, a = r ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $22f44c32aa84ec90$var$je(function(e, n) {
            const r = $22f44c32aa84ec90$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($22f44c32aa84ec90$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $22f44c32aa84ec90$var$Se(l) + "\n\n") : (t.inline = !0, p = $22f44c32aa84ec90$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $22f44c32aa84ec90$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $22f44c32aa84ec90$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $22f44c32aa84ec90$var$$e(e) {
    return "string" == typeof e;
}
function $22f44c32aa84ec90$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $22f44c32aa84ec90$var$ze(e, n) {
    return e.startsWith(n);
}
function $22f44c32aa84ec90$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($22f44c32aa84ec90$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $22f44c32aa84ec90$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $22f44c32aa84ec90$var$Re(e) {
    return $22f44c32aa84ec90$var$H.test(e) ? "right" : $22f44c32aa84ec90$var$U.test(e) ? "center" : $22f44c32aa84ec90$var$V.test(e) ? "left" : null;
}
function $22f44c32aa84ec90$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $22f44c32aa84ec90$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($22f44c32aa84ec90$var$G, "").split("|").map($22f44c32aa84ec90$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $22f44c32aa84ec90$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $22f44c32aa84ec90$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $22f44c32aa84ec90$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $22f44c32aa84ec90$var$je(e) {
    return e.inline = 1, e;
}
function $22f44c32aa84ec90$var$Ce(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Ie(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $22f44c32aa84ec90$var$Me(e) {
    return $22f44c32aa84ec90$var$je(function(n) {
        return e.exec(n);
    });
}
const $22f44c32aa84ec90$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $22f44c32aa84ec90$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($22f44c32aa84ec90$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $22f44c32aa84ec90$var$Fe(e) {
    return e ? e.replace($22f44c32aa84ec90$var$re, "$1") : e;
}
function $22f44c32aa84ec90$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $22f44c32aa84ec90$var$Ge = (e, n, r)=>({
        children: $22f44c32aa84ec90$var$Pe(n, e[2], r)
    });
function $22f44c32aa84ec90$var$Ue() {
    return {};
}
function $22f44c32aa84ec90$var$Ve() {
    return null;
}
function $22f44c32aa84ec90$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $22f44c32aa84ec90$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $22f44c32aa84ec90$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $22f44c32aa84ec90$var$n({}, $22f44c32aa84ec90$var$a, t.namedCodesToUnicode) : $22f44c32aa84ec90$var$a;
    const l = t.slugify || $22f44c32aa84ec90$export$c383cdd2a518017a, G = t.sanitizer || $22f44c32aa84ec90$export$3e2338ea76b578c9, U = t.createElement || $cozmU.createElement, V = [
        $22f44c32aa84ec90$var$s,
        $22f44c32aa84ec90$var$y,
        $22f44c32aa84ec90$var$h,
        t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S,
        $22f44c32aa84ec90$var$E,
        $22f44c32aa84ec90$var$M,
        $22f44c32aa84ec90$var$ke,
        $22f44c32aa84ec90$var$xe
    ], H = [
        ...V,
        $22f44c32aa84ec90$var$w,
        $22f44c32aa84ec90$var$A,
        $22f44c32aa84ec90$var$B,
        $22f44c32aa84ec90$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $22f44c32aa84ec90$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $22f44c32aa84ec90$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $22f44c32aa84ec90$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $22f44c32aa84ec90$var$n({}, r, a, {
            className: $22f44c32aa84ec90$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($22f44c32aa84ec90$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $22f44c32aa84ec90$var$Z.test(e));
        const r = fe(se(n ? e : $22f44c32aa84ec90$var$Se(e).replace($22f44c32aa84ec90$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $22f44c32aa84ec90$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($22f44c32aa84ec90$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($22f44c32aa84ec90$var$L) && (e = e.replace($22f44c32aa84ec90$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $22f44c32aa84ec90$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $22f44c32aa84ec90$var$i.indexOf(n) ? t($22f44c32aa84ec90$var$Fe(r), e, n) : (r.match($22f44c32aa84ec90$var$j) && (r = $22f44c32aa84ec90$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($22f44c32aa84ec90$var$A.test(l) || $22f44c32aa84ec90$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$22f44c32aa84ec90$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($22f44c32aa84ec90$var$f, "").match($22f44c32aa84ec90$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $22f44c32aa84ec90$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$d),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$p),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $22f44c32aa84ec90$var$Fe($22f44c32aa84ec90$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $22f44c32aa84ec90$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$g),
            i: 3,
            u: (e)=>({
                    text: $22f44c32aa84ec90$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $22f44c32aa84ec90$var$Te(t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[2], r),
                    id: l(e[2], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($22f44c32aa84ec90$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $22f44c32aa84ec90$var$Ne : $22f44c32aa84ec90$var$Pe, u = e[1].toLowerCase(), l = -1 !== $22f44c32aa84ec90$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$B),
            i: 1,
            u: ()=>({}),
            l: $22f44c32aa84ec90$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$be),
            i: 1,
            u: (e)=>({
                    alt: $22f44c32aa84ec90$var$Fe(e[1]),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Ze(n, e[1], r),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($22f44c32aa84ec90$var$ze(e, "http://") || $22f44c32aa84ec90$var$ze(e, "https://")),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $22f44c32aa84ec90$var$qe(W, 1),
        33: $22f44c32aa84ec90$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$m),
            i: 3,
            u: $22f44c32aa84ec90$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $22f44c32aa84ec90$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $22f44c32aa84ec90$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$M),
            i: 1,
            u: $22f44c32aa84ec90$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $22f44c32aa84ec90$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $22f44c32aa84ec90$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                let r;
                return $22f44c32aa84ec90$var$ze(e, ":") && (r = $22f44c32aa84ec90$var$ee.exec(e)), r || $22f44c32aa84ec90$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($22f44c32aa84ec90$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$X),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$Y),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $22f44c32aa84ec90$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($22f44c32aa84ec90$var$k, "\n").replace($22f44c32aa84ec90$var$v, "").replace($22f44c32aa84ec90$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $22f44c32aa84ec90$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $22f44c32aa84ec90$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $22f44c32aa84ec90$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $22f44c32aa84ec90$var$r);
    return $cozmU.cloneElement($22f44c32aa84ec90$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};
 //# sourceMappingURL=index.modern.js.map

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("kpg4X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $kC6NK = parcelRequire("kC6NK");

const $277e2498b554872e$export$56ccbea3229cc4c3 = async (isProductInUnitsRollout)=>{
    // 1. Units GA killswitch, then this product's own rollout gate.
    if (!((0, $iDrrr.fg)('cc-units-ga') && isProductInUnitsRollout())) return false;
    // 2. This organisation's actual units state, read from AGG once per page load.
    const { boundaryEnforced: boundaryEnforced, endUsersLaunched: endUsersLaunched } = await (0, $kC6NK.getUnitsRolloutSettings)();
    return endUsersLaunched && boundaryEnforced;
};
module.exports["shouldUseUnitCompliantApi"] = $277e2498b554872e$export$56ccbea3229cc4c3;

});

parcelRegister("kC6NK", function(module, exports) {
/**
 * Reads where the current organisation is in the units migration from AGG.
 *
 * It takes two queries, because the settings are keyed by org id and the browser only knows the
 * host it is served from: first resolve the host to an org id, then read that org's unit settings.
 *
 * Only `shouldUseUnitCompliantApi` should need this - see that file for how the result is used.
 */ 
var $j39Hd = parcelRequire("j39Hd");


var $9uAJX = parcelRequire("9uAJX");

const $09ebff3e34cc36dc$var$AGG_URL = '/gateway/api/graphql';
/**
 * The operation names are the ones `@atlaskit/link-datasource` already sends from production, and
 * they are deliberately kept as they are now that the caller has moved into this package: AGG side
 * observability - dashboards, per operation traffic and rate limiting - is keyed off them, so
 * renaming them would silently orphan it.
 */ const $09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME = 'link_datasource_tenantContext';
const $09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME = 'link_datasource_unitSettings';
/**
 * `Query.admin_unitSettings` is keyed by org id, which the browser does not know, so the org id
 * is resolved from the host the product is currently served from.
 */ const $09ebff3e34cc36dc$var$tenantContextQuery = `
	query ${$09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME}($hostNames: [String!]) {
		tenantContexts(hostNames: $hostNames) {
			orgId
		}
	}
`;
/**
 * `admin_unitSettings` exposes both flags of the rollout and is callable with the session of the
 * end user, so no opt-in directive or admin OAuth scope is needed from the browser.
 */ const $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery = `
	query ${$09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME}($orgId: ID!) {
		admin_unitSettings(orgId: $orgId) {
			boundaryEnforced
			endUsersLaunched
		}
	}
`;
/**
 * When the rollout settings cannot be resolved we keep the pre-isolation behaviour, which is
 * what every org gets today while the unit settings are unset. The settings are only
 * written when an org is activated - they are not backfilled - so `null` is expected for orgs
 * that have not been activated yet and must be read as `false`.
 */ const $09ebff3e34cc36dc$var$DEFAULT_SETTINGS = {
    boundaryEnforced: false,
    endUsersLaunched: false
};
/**
 * AGG answers with a 200 and an `errors` array for query level failures, so those have to be
 * turned into a rejection explicitly rather than being read as an empty response.
 */ const $09ebff3e34cc36dc$var$requestGraphQL = async (operationName, query, variables)=>{
    const response = await (0, $j39Hd.request)('post', $09ebff3e34cc36dc$var$AGG_URL, {
        operationName: operationName,
        query: query,
        variables: variables
    });
    if (response?.errors?.length) {
        const messages = response.errors.map((error)=>error?.message).filter(Boolean).join(', ');
        throw new Error(`${operationName} failed: ${messages || 'unknown error'}`);
    }
    return response?.data ?? undefined;
};
const $09ebff3e34cc36dc$var$fetchOrgId = async ()=>{
    const hostName = typeof window !== 'undefined' ? window.location?.hostname : undefined;
    if (!hostName) return undefined;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME, $09ebff3e34cc36dc$var$tenantContextQuery, {
        hostNames: [
            hostName
        ]
    });
    for (const tenantContext of data?.tenantContexts ?? []){
        if (tenantContext?.orgId) return tenantContext.orgId;
    }
    return undefined;
};
const $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings = async ()=>{
    const orgId = await $09ebff3e34cc36dc$var$fetchOrgId();
    if (!orgId) return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME, $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery, {
        orgId: orgId
    });
    const settings = data?.admin_unitSettings;
    return {
        boundaryEnforced: settings?.boundaryEnforced ?? false,
        endUsersLaunched: settings?.endUsersLaunched ?? false
    };
};
const $09ebff3e34cc36dc$export$2523e3b63c956620 = ()=>{
    if (!(0, $9uAJX.cache).promise) (0, $9uAJX.cache).promise = $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings().catch(()=>{
        (0, $9uAJX.cache).promise = undefined;
        return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    });
    return (0, $9uAJX.cache).promise;
};
module.exports["getUnitsRolloutSettings"] = $09ebff3e34cc36dc$export$2523e3b63c956620;

});

parcelRegister("9uAJX", function(module, exports) {
const $6f4e12ab20c1322c$export$69a3209f1a06c04d = {};
module.exports["cache"] = $6f4e12ab20c1322c$export$69a3209f1a06c04d;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("6wOvs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");

const $b90e25146b4dbd96$var$shimmerAnimation = null;
const $b90e25146b4dbd96$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $b90e25146b4dbd96$var$truncateSingleLine = null;
const $b90e25146b4dbd96$export$f35c7d979dec8662 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { as: t1, children: children, size: t2, weight: t3, truncate: t4 } = t0;
    const as = t1 === undefined ? "div" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const weight = t3 === undefined ? "regular" : t3;
    const truncate = t4 === undefined ? false : t4;
    let t5;
    if ($[0] !== children || $[1] !== size || $[2] !== weight) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: size,
            weight: weight,
            color: "color.text.subtlest"
        }, children);
        $[0] = children;
        $[1] = size;
        $[2] = weight;
        $[3] = t5;
    } else t5 = $[3];
    const content = t5;
    if (as === "span") {
        const t6 = truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d";
        let t7;
        if ($[4] !== t6) {
            t7 = (0, $hekY6.default)([
                "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
                t6
            ]);
            $[4] = t6;
            $[5] = t7;
        } else t7 = $[5];
        let t8;
        if ($[6] !== content || $[7] !== t7) {
            t8 = /*#__PURE__*/ $cozmU.createElement("span", {
                className: t7
            }, content);
            $[6] = content;
            $[7] = t7;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const t6 = truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d";
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            t6
        ]);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== content || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t7
        }, content);
        $[11] = content;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ as: as = 'div', children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    const content = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children);
    if (as === 'span') return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, content);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, content);
};
module.exports["ShimmerText"] = $b90e25146b4dbd96$export$f35c7d979dec8662;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
            isReduced: isReduced
        }),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent,
            customerCardDataLoader: customerCardDataLoader,
            isReduced: isReduced
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent, isReduced: isReduced, analyticsAttributes: analyticsAttributes, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, onOpen: onOpen }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        isReduced,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        isReduced: isReduced,
        analyticsAttributes: analyticsAttributes,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        onOpen: onOpen,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent,
                                    customerCardDataLoader: customerCardDataLoader,
                                    isReduced: isReduced
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                                    isReduced: isReduced
                                })
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("2yWJZ", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $2khPJ.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("k9SFD", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

const $00f984e1ee672b7a$var$getAppType = (userType)=>userType === 'APP' || userType === 'AGENT' ? 'agent' : 'user';
const $00f984e1ee672b7a$var$enrichMentionNodeData = (mention, data)=>({
        ...data,
        appType: data?.appType ?? $00f984e1ee672b7a$var$getAppType(mention.userType)
    });
const $00f984e1ee672b7a$var$toMentionNode = ({ id: id, userType: userType })=>({
        attrs: {
            id: id,
            // NodeDataProvider uses an ADF node internally, so normalize the runtime-only value.
            userType: userType === 'AGENT' ? 'APP' : userType
        },
        type: 'mention'
    });
const $00f984e1ee672b7a$var$isMentionNode = (node)=>node.type === 'mention' && node.attrs !== undefined && 'id' in node.attrs && typeof node.attrs.id === 'string';
const $00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX = 'mention-node-data-provider';
let $00f984e1ee672b7a$var$subscriptionKeyCounter = 0;
const $00f984e1ee672b7a$var$cacheMentionData = (cache, mentions)=>{
    mentions.forEach((mention)=>{
        if (mention.isPlaceholder || !mention.avatarUrl) {
            cache.delete(mention.id);
            return;
        }
        cache.set(mention.id, {
            avatarUrl: mention.avatarUrl,
            appType: mention.appType
        });
    });
};
class $00f984e1ee672b7a$export$d2331d8e30b7662 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return $00f984e1ee672b7a$var$isMentionNode(node) && node.attrs.userType !== 'SPECIAL';
    }
    nodeDataKey(node) {
        return node.attrs.id;
    }
    async fetchNodesData(nodes) {
        const accountIds = Array.from(new Set(nodes.map(({ attrs: attrs })=>attrs.id)));
        const dataByAccountId = await this.enqueueFetch(accountIds);
        return nodes.map(({ attrs: attrs })=>$00f984e1ee672b7a$var$enrichMentionNodeData(attrs, dataByAccountId[attrs.id]));
    }
    getMentionData(mention, callback) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) {
            callback({
                data: $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData)
            });
            return;
        }
        this.getData($00f984e1ee672b7a$var$toMentionNode(mention), callback);
    }
    getMentionDataFromCache(mention) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) return $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData);
        const data = this.getNodeDataFromCache($00f984e1ee672b7a$var$toMentionNode(mention))?.data;
        return data ? $00f984e1ee672b7a$var$enrichMentionNodeData(mention, data) : undefined;
    }
    connect(mentionResource) {
        if (this.lastMentionResource && this.lastMentionResource !== mentionResource) {
            this.emittedMentionCache.clear();
            this.resetCache();
        }
        this.lastMentionResource = mentionResource;
        if (this.abortControllerRef.current.signal.aborted) this.abortControllerRef.current = new AbortController();
        let isDisconnected = false;
        let subscribedMentionProvider;
        mentionResource.then((mentionProvider)=>{
            if (isDisconnected) return;
            subscribedMentionProvider = mentionProvider;
            mentionProvider.subscribe(this.subscriptionKey, (mentions)=>{
                $00f984e1ee672b7a$var$cacheMentionData(this.emittedMentionCache, mentions);
            });
        }).catch(()=>undefined);
        return ()=>{
            isDisconnected = true;
            this.abortControllerRef.current.abort();
            subscribedMentionProvider?.unsubscribe(this.subscriptionKey);
            subscribedMentionProvider = undefined;
        };
    }
    resolveMentionNodeDataFromCache(mention) {
        return this.resolveMentionNodeData?.(mention) ?? this.emittedMentionCache.get(mention.id);
    }
    enqueueFetch(accountIds) {
        const result = new Promise((resolve, reject)=>{
            this.queuedFetches.push({
                accountIds: accountIds,
                reject: reject,
                resolve: resolve
            });
        });
        if (!this.isFlushScheduled) {
            this.isFlushScheduled = true;
            Promise.resolve().then(()=>this.flushFetches());
        }
        return result;
    }
    async flushFetches() {
        this.isFlushScheduled = false;
        const queuedFetches = this.queuedFetches;
        this.queuedFetches = [];
        const accountIds = Array.from(new Set(queuedFetches.flatMap((request)=>request.accountIds)));
        try {
            const data = await this.fetchMentionNodeData(accountIds, this.abortControllerRef.current.signal);
            queuedFetches.forEach(({ resolve: resolve })=>resolve(data));
        } catch (error) {
            queuedFetches.forEach(({ reject: reject })=>reject(error));
        }
    }
    constructor(fetchMentionNodeData, resolveMentionNodeData){
        super(), this.fetchMentionNodeData = fetchMentionNodeData, this.resolveMentionNodeData = resolveMentionNodeData;
        this.name = 'mentionNodeDataProvider';
        this.abortControllerRef = {
            current: new AbortController()
        };
        this.emittedMentionCache = new Map();
        this.subscriptionKey = `${$00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX}:${++$00f984e1ee672b7a$var$subscriptionKeyCounter}`;
        this.lastMentionResource = void 0;
        this.queuedFetches = [];
        this.isFlushScheduled = false;
    }
}
module.exports["MentionNodeDataProvider"] = $00f984e1ee672b7a$export$d2331d8e30b7662;

});

parcelRegister("lT7Mv", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/database/manifest.ts
var $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $fef4c53c0d169c78$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $fef4c53c0d169c78$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("k0a0F", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/embed/manifest.ts
var $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $e8fb927b13f87211$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $e8fb927b13f87211$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("bAV6O", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/folder/manifest.ts
var $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $870f5b1ead2b6083$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $870f5b1ead2b6083$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $iDrrr.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $iDrrr.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $99V2N = parcelRequire("99V2N");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $99V2N.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $99V2N.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $lT7Mv = parcelRequire("lT7Mv");

var $k0a0F = parcelRequire("k0a0F");

var $bAV6O = parcelRequire("bAV6O");

var $8jDil = parcelRequire("8jDil");

var $dLbqW = parcelRequire("dLbqW");

var $7GbwS = parcelRequire("7GbwS");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $8jDil.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $5BvyC.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $7GbwS.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $lT7Mv.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $k0a0F.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $bAV6O.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $dLbqW.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("dLbqW", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/slide/manifest.ts
var $a04888a2b5576260$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $a04888a2b5576260$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $a04888a2b5576260$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("7GbwS", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/whiteboard/manifest.ts
var $597566211494b449$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $597566211494b449$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $597566211494b449$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $7rovI = parcelRequire("7rovI");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage || isAccessLinkEdit && isAccessLinkEditing) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("7rovI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $deabcafb397cc045$var$initialState = {
    isAvailable: false,
    isEditMode: false
};
const $deabcafb397cc045$var$setAvailable = (isAvailable)=>({ setState: setState })=>{
        // Leaving the route must also clear edit mode, or a later visit inherits it.
        setState(isAvailable ? {
            isAvailable: isAvailable
        } : {
            isAvailable: false,
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$enterEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: true
        });
    };
const $deabcafb397cc045$var$exitEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$actions = {
    setAvailable: $deabcafb397cc045$var$setAvailable,
    enterEditMode: $deabcafb397cc045$var$enterEditMode,
    exitEditMode: $deabcafb397cc045$var$exitEditMode
};
const $deabcafb397cc045$var$AccessLinkEditModeStore = (0, $8s9DV.createStore)({
    initialState: $deabcafb397cc045$var$initialState,
    actions: $deabcafb397cc045$var$actions,
    name: 'AccessLinkEditModeStore'
});
const $deabcafb397cc045$var$useAccessLinkEditModeStore = (0, $kBr4q.createHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$var$isOnAccessLinkRouteArgs = {
    selector: (routeName)=>{
        return (0, $1NBp8.ACCESS_LINK).name === routeName;
    }
};
/** Actions without a state subscription, so callers that only dispatch do not re-render. */ const $deabcafb397cc045$var$useAccessLinkEditModeStoreActions = (0, $kBr4q.createActionsHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$export$87e25a0d26a92fdb = ()=>{
    const isAvailable = (0, $dPJCf.useRouteName)($deabcafb397cc045$var$isOnAccessLinkRouteArgs);
    const [{ isEditMode: isEditMode }, { enterEditMode: enter, exitEditMode: exit }] = $deabcafb397cc045$var$useAccessLinkEditModeStore();
    return {
        isAvailable: isAvailable,
        isEditMode: isEditMode,
        enterEditMode: enter,
        exitEditMode: exit
    };
};
const $deabcafb397cc045$export$b9623d5da41a49e7 = ({ children: children })=>{
    const { exitEditMode: exitEditMode } = $deabcafb397cc045$var$useAccessLinkEditModeStoreActions();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            exitEditMode();
        };
    }, [
        exitEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["useAccessLinkEditMode"] = $deabcafb397cc045$export$87e25a0d26a92fdb;
module.exports["AccessLinkEditModeProvider"] = $deabcafb397cc045$export$b9623d5da41a49e7;

});

parcelRegister("lfBMY", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    showSidebarControlIfNoPanel: ()=>({ setState: setState, getState: getState })=>{
            // Read the store at dispatch time rather than relying on a React render snapshot.
            // A deeplink can open the panel between render and a passive effect being flushed.
            if (!getState().isObjectSidebarShown) setState({
                sidebarControlState: 'shown'
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $hMCZS.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("hcnuR", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $62bc818b780bdfc1$export$68a914b05fdf9ed1 = (classification)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_non_production_build_analytics')) return {};
    const isNonProductionBuild = typeof classification === 'function' ? classification() : classification;
    return isNonProductionBuild !== undefined ? {
        isNonProductionBuild: isNonProductionBuild
    } : {};
};
module.exports["getNonProductionBuildAnalyticsAttributes"] = $62bc818b780bdfc1$export$68a914b05fdf9ed1;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("8ld8H", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $ca70a3574c04adc8$var$BRANCH_COOKIE = 'useFrontendBranch';
const $ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE = 'bifrost-override';
const $ca70a3574c04adc8$var$isActiveBranchCookie = (value)=>{
    if (!value || value === 'off') return false;
    const override = JSON.parse(value);
    if (!override || typeof override !== 'object' || Array.isArray(override)) return undefined;
    const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
    if (version === undefined) return false;
    return typeof version === 'string' ? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off') : undefined;
};
const $ca70a3574c04adc8$export$89ba981936f5422e = ()=>{
    try {
        const { RELEASE_TRACK: RELEASE_TRACK } = (0, $eSuZj.getBuildInfo)();
        if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') return true;
        if (![
            'prod',
            'hello',
            'canary'
        ].includes(RELEASE_TRACK)) return undefined;
        if (window.__SSR_RENDERED__) {
            let bifrostOverride;
            try {
                bifrostOverride = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE);
            } catch  {
            // Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
            }
            if (bifrostOverride) return $ca70a3574c04adc8$var$isActiveBranchCookie(bifrostOverride);
        }
        const branchVersion = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BRANCH_COOKIE);
        return Boolean(branchVersion && branchVersion !== 'off');
    } catch  {
        return undefined;
    }
};
module.exports["getConfluenceNonProductionBuild"] = $ca70a3574c04adc8$export$89ba981936f5422e;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $422HI = parcelRequire("422HI");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8jDil = parcelRequire("8jDil");

var $5FMVr = parcelRequire("5FMVr");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $8jDil.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $5FMVr.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("dUYBA"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("dUYBA", function(module, exports) {

let $a21f843f3a21a18d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a21f843f3a21a18d$var$load("jXx9i"),
    $a21f843f3a21a18d$var$load("6wr18"),
    $a21f843f3a21a18d$var$load("2xKrc"),
    $a21f843f3a21a18d$var$load("4AElS"),
    $a21f843f3a21a18d$var$load("hhss7"),
    $a21f843f3a21a18d$var$load("ffEVr"),
    $a21f843f3a21a18d$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $hcnuR = parcelRequire("hcnuR");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("ltKTq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    CALENDAR_CONTEXT["MACRO"] = "macro";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $cozmU.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $cozmU.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $cozmU.useReducer)(reducer, initialState);
    const actions = (0, $cozmU.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $cozmU.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gXfti = parcelRequire("gXfti");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $gXfti.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEdDL8 _4bt5LAnQyn _2WAcuGnQyn _4kiQYAoWWg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("jn9ek", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});

parcelRegister("gqypm", function(module, exports) {

var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ skip: skip, fetchPolicy: fetchPolicy })=>{
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip,
        fetchPolicy: fetchPolicy
    });
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("4yg2A", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $c550e533eafdac36$export$a13b342a3f580b52 = /*#__PURE__*/ function(FeedType) {
    FeedType["DIRECT"] = "DIRECT";
    FeedType["FOLLOWING"] = "FOLLOWING";
    FeedType["POPULAR"] = "POPULAR";
    FeedType["WELCOME"] = "WELCOME";
    FeedType["FAREWELL"] = "FAREWELL";
    return FeedType;
}({});
module.exports["FeedType"] = $c550e533eafdac36$export$a13b342a3f580b52;

});

parcelRegister("4Cx0V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $6U5eU = parcelRequire("6U5eU");


var $2tp0D = parcelRequire("2tp0D");


var $5KMtM = parcelRequire("5KMtM");




/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $b8pma = parcelRequire("b8pma");


var $a9aSv = parcelRequire("a9aSv");

const $bf2b3f9711f917e5$var$placeholderStyles = null;
const $bf2b3f9711f917e5$export$a762e2300443622e = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8pma.default), {
        name: "confluence-home-banner-loading",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "confluence-home-banner-loading-skeleton",
            className: (0, $hekY6.default)([
                "_4FKVYEVa5s _4bt5LAnQyn _2WAcuGnQyn _30huDKNCjk _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKxmn _0jFU0VS40j _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _1DCdHiNHnM _0M4C5Y5zaO"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignInline: "center",
                alignBlock: "center",
                spread: "space-between",
                grow: "fill",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "145px",
                        height: "44px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "460px",
                                height: "25px",
                                isShimmering: true
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "460px",
                                height: "25px",
                                isShimmering: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "195px",
                        height: "40px",
                        isShimmering: true
                    })
                ]
            })
        })
    });
};
var $bf2b3f9711f917e5$export$2e2bcd8739ae039 = $bf2b3f9711f917e5$export$a762e2300443622e;


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 






var $b2eRs = parcelRequire("b2eRs");

const $cc35046634815caf$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $cc35046634815caf$export$78c758434c34d601 = $cc35046634815caf$var$clientPipeline.createRender;
const $cc35046634815caf$export$2859a83e4d6da57d = $cc35046634815caf$var$clientPipeline.createValidate;
const $cc35046634815caf$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $cc35046634815caf$export$c905bc718befd59b = $cc35046634815caf$var$serverPipeline.createHydrate;
const $cc35046634815caf$export$1f41223e5b0a6622 = $cc35046634815caf$var$serverPipeline.createHydrateExample;
const $cc35046634815caf$export$88fe13b4d13f8423 = $cc35046634815caf$var$serverPipeline.createTransformMetadata;


/* RovoAwarenessHomeBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $6Pqow = parcelRequire("6Pqow");


var $2wCqQ = parcelRequire("2wCqQ");


var $kz1Yj = parcelRequire("kz1Yj");


var $kA6Zo = parcelRequire("kA6Zo");


var $etoPX = parcelRequire("etoPX");


var $9TNXZ = parcelRequire("9TNXZ");


var $7NHN3 = parcelRequire("7NHN3");


var $3jNKT = parcelRequire("3jNKT");




const $47264dbfbbfedc88$export$ded08279a8be4c83 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "559",
        height: "236",
        viewBox: "0 0 559 236",
        fill: "none",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M486.715 -22.1858C399.169 -23.4656 463.766 115.967 484.311 156.606C471.045 195.777 442.988 233.946 398.078 233.725C365.725 238.299 341.145 207.89 321.729 186.073C282.999 141.94 293.781 141.377 297.127 86.9212C298.623 42.6571 289.341 -120.166 218.936 -104.546C183.866 -85.2976 208.931 -21.7725 216.562 8.24497C229.031 46.0692 245.459 82.5164 264.304 117.012C276.954 137.358 286.835 150.602 276.871 175.343C260.333 247.95 195.641 407.036 98.0428 352.814C32.5853 300.187 20.1514 207.1 0.939751 133.851C-10.6341 67.5089 -46.5223 29.1707 -85.2953 8.74892C-140.761 -27.0993 -168.346 76.8881 -158.546 122.131C-149.976 162.209 -114.859 183.068 -71.9156 200.208C-40.0898 212.775 -10.9346 220.607 20.1294 234.881C41.7226 243.92 61.4652 237.894 81.0551 237.094C106.299 236.099 130.996 233.819 155.098 227.577C191.174 219.14 226.024 201.797 251.923 176.099C280.639 147.534 299.348 111.127 318.057 74.72C335.486 42.0988 355.024 8.62926 387.855 -11.8486C425.638 -35.8068 468.166 -13.3476 486.715 -22.1858Z",
            fill: "#505258"
        })
    });
};





const $5c356f3b24ab6a04$export$ae0370cf11de76d = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "32",
        height: "31",
        viewBox: "0 0 32 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M0.600098 0H1.5626V30.8H0.600098V0Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M0.600098 0H27.4501C29.5764 0 31.3001 1.7237 31.3001 3.85V11.55C31.3001 13.6763 29.5764 15.4 27.4501 15.4H0.600098V0Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M5.18683 11.2V4.19745H7.80456C8.34033 4.19745 8.7915 4.29144 9.15808 4.47943C9.52466 4.66742 9.80194 4.9306 9.98993 5.26898C10.1779 5.60423 10.2719 5.9943 10.2719 6.43921C10.2719 6.88411 10.1763 7.27106 9.98523 7.60004C9.79724 7.92902 9.51839 8.1828 9.14868 8.36139C8.77897 8.53998 8.32466 8.62927 7.78576 8.62927H5.91528V7.59064H7.62127C7.93772 7.59064 8.19621 7.54677 8.39673 7.45905C8.59725 7.36818 8.74607 7.23659 8.8432 7.06427C8.94033 6.89195 8.98889 6.68359 8.98889 6.43921C8.98889 6.18785 8.94033 5.98406 8.8432 5.82785C8.74607 5.66835 8.59482 5.55054 8.39031 5.47442C8.18892 5.39831 7.92699 5.36024 7.6045 5.36024H6.38394V11.2H5.18683Z",
                fill: "white"
            })
        ]
    });
};


/* CarouselModal.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $iMnC5 = parcelRequire("iMnC5");





var $4aRua = parcelRequire("4aRua");


var $aRGok = parcelRequire("aRGok");


var $9Umtx = parcelRequire("9Umtx");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $jq995 = parcelRequire("jq995");


var $7aRdF = parcelRequire("7aRdF");


var $iDrrr = parcelRequire("iDrrr");


var $cJ0FD = parcelRequire("cJ0FD");





var $aRvnq = parcelRequire("aRvnq");


var $kdlgT = parcelRequire("kdlgT");


var $lb2UL = parcelRequire("lb2UL");





var $I7hWB = parcelRequire("I7hWB");


var $9KSWX = parcelRequire("9KSWX");

var $b296f6600f191906$exports = {};
$b296f6600f191906$exports = new URL("GenerateBriefing.12cd6d89.gif", import.meta.url).toString();


var $2d9487cff3360c0e$exports = {};
$2d9487cff3360c0e$exports = new URL("CreateWithRovo.900b022b.gif", import.meta.url).toString();


var $3274d8ce7d61182b$exports = {};
$3274d8ce7d61182b$exports = new URL("WhiteboardFlow.1ec4e94d.gif", import.meta.url).toString();


const $2835868660bc2f69$export$ded52cdae27d2770 = ({ index: index, selectedIndex: selectedIndex, onStepChanged: onStepChanged })=>{
    if (index === selectedIndex) return;
    onStepChanged({
        interactionIdentifier: 'carouselProgressIndicator',
        direction: index > selectedIndex ? 'next' : 'previous',
        fromStep: selectedIndex,
        toStep: index
    });
};


const $30d32c26274e909d$var$i18n = (0, $kSwu1.defineMessages)({
    carouselModalTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.title",
        defaultMessage: "More ways to Rovo"
    },
    carouselModalDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.description",
        defaultMessage: "Discover how you can use Rovo to make your life easier."
    },
    carouselModalAudioTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.audio-title",
        defaultMessage: "Get briefed on the go"
    },
    carouselModalAudioDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.audio-description",
        defaultMessage: "Rovo\u2032s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."
    },
    carouselModalCreateTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.create-title",
        defaultMessage: "Bye-bye blank page"
    },
    carouselModalCreateDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.create-description",
        defaultMessage: "You describe, Rovo creates. Pages, live docs, whiteboards, databases \u2014 Rovo does it all."
    },
    carouselModalDiagramTitle: {
        id: "confluence-home-rovo-awareness.carousel-modal.diagram-title",
        defaultMessage: "Let flow charts flow"
    },
    carouselModalDiagramDescription: {
        id: "confluence-home-rovo-awareness.carousel-modal.diagram-description",
        defaultMessage: "Rovo can draw the diagrams for you that clearly communicate your ideas."
    },
    carouselModalCarouselImageAlt: {
        id: "confluence-home-rovo-awareness.carousel-modal.carousel-image-alt",
        defaultMessage: "New Feature"
    },
    carouselModalPreviousLabel: {
        id: "confluence-home-rovo-awareness.carousel-modal.previous-label",
        defaultMessage: "Previous"
    },
    carouselModalNextLabel: {
        id: "confluence-home-rovo-awareness.carousel-modal.next-label",
        defaultMessage: "Next"
    },
    carouselModalLozengeNew: {
        id: "confluence-home-rovo-awareness.carousel-modal.lozenge-new",
        defaultMessage: "New"
    },
    carouselModalLozengeComingSoon: {
        id: "confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon",
        defaultMessage: "Coming soon"
    }
});
const $30d32c26274e909d$var$getCarouselSlides = (formatMessage)=>[
        {
            title: formatMessage($30d32c26274e909d$var$i18n.carouselModalAudioTitle),
            description: formatMessage($30d32c26274e909d$var$i18n.carouselModalAudioDescription),
            imageAlt: formatMessage($30d32c26274e909d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($b296f6600f191906$exports))),
            lozenge: {
                text: formatMessage($30d32c26274e909d$var$i18n.carouselModalLozengeNew),
                appearance: 'new'
            }
        },
        {
            title: formatMessage($30d32c26274e909d$var$i18n.carouselModalCreateTitle),
            description: formatMessage($30d32c26274e909d$var$i18n.carouselModalCreateDescription),
            imageAlt: formatMessage($30d32c26274e909d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($2d9487cff3360c0e$exports))),
            lozenge: {
                text: formatMessage($30d32c26274e909d$var$i18n.carouselModalLozengeComingSoon),
                appearance: 'inprogress'
            }
        },
        {
            title: formatMessage($30d32c26274e909d$var$i18n.carouselModalDiagramTitle),
            description: formatMessage($30d32c26274e909d$var$i18n.carouselModalDiagramDescription),
            imageAlt: formatMessage($30d32c26274e909d$var$i18n.carouselModalCarouselImageAlt),
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($3274d8ce7d61182b$exports))),
            lozenge: {
                text: formatMessage($30d32c26274e909d$var$i18n.carouselModalLozengeNew),
                appearance: 'new'
            }
        }
    ];
const $30d32c26274e909d$var$styles = {
    carouselContainer: "_4bt5LAnQyn _2WAcuGnQyn _2mHwu88HPE _3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _1OHb6iLkD4 _3h2tDz3EvU _313842kG2W",
    slideWrapper: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEN91d _2mHwu82ADO _3yilb87p2s _4ouGXIN91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _2fwxA5ecOK",
    textContainer: "_2mHwu8FQfX _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _3138425zaO",
    imageStyles: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdRAKS _0KLXrujOvk _39xV02N91d _1EqgXlOAqP _3v5uP0OL1o _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _00EA0eiObl",
    lozengeOverlay: "_1mT5xdWVPG _2IhTon5zaO _3OE6xY5zaO _42Yu6B7dHp",
    controlsContainer: "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _39xV02N91d _3138425zaO"
};
const $30d32c26274e909d$var$CarouselSlide = ({ title: title, description: description, imageAlt: imageAlt, imageSrc: imageSrc, lozenge: lozenge, index: index, selectedIndex: selectedIndex })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (cardRef.current && selectedIndex === index) cardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        selectedIndex,
        index
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $30d32c26274e909d$var$styles.slideWrapper,
        ref: cardRef,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $30d32c26274e909d$var$styles.imageStyles,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                        src: imageSrc,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $30d32c26274e909d$var$styles.lozengeOverlay,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                            appearance: lozenge.appearance,
                            isBold: true,
                            maxWidth: "None",
                            children: lozenge.text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $30d32c26274e909d$var$styles.textContainer,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "large",
                        weight: "semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: description
                    })
                ]
            })
        ]
    });
};
const $30d32c26274e909d$var$CarouselModalContent = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedIndex, setSelectedIndex] = (0, $cozmU.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onStepChanged: onStepChanged } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const carouselSlides = (0, $cozmU.useMemo)(()=>$30d32c26274e909d$var$getCarouselSlides(formatMessage), [
        formatMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'RovoAwarenessCarouselModal'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handlePrevious = ()=>{
        const newIndex = selectedIndex === 0 ? carouselSlides.length - 1 : selectedIndex - 1; // Wrap-around from the first slide reports direction 'previous' to reflect the
        // button the user actually pressed, even though toStep (length - 1) > fromStep (0).
        onStepChanged({
            interactionIdentifier: 'carouselPrevious',
            direction: 'previous',
            fromStep: selectedIndex,
            toStep: newIndex
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselPreviousButton',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: newIndex
            }
        });
        setSelectedIndex(newIndex);
    };
    const handleNext = ()=>{
        const newIndex = selectedIndex === carouselSlides.length - 1 ? 0 : selectedIndex + 1; // Wrap-around from the last slide reports direction 'next' to reflect the
        // button the user actually pressed, even though toStep (0) < fromStep (length - 1).
        onStepChanged({
            interactionIdentifier: 'carouselNext',
            direction: 'next',
            fromStep: selectedIndex,
            toStep: newIndex
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselNextButton',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: newIndex
            }
        });
        setSelectedIndex(newIndex);
    };
    const handleSelectIndex = (index)=>{
        (0, $2835868660bc2f69$export$ded52cdae27d2770)({
            index: index,
            selectedIndex: selectedIndex,
            onStepChanged: onStepChanged
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessCarouselProgressIndicator',
            attributes: {
                fromSlideIndex: selectedIndex,
                toSlideIndex: index
            }
        });
        setSelectedIndex(index);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7aRdF.default), {
        onClose: onClose,
        width: "850px",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $etoPX.RovoIcon), {
                            size: "small",
                            appearance: "brand"
                        }),
                        (0, $iDrrr.fg)('platform_dst_modal-dialog-use-modal-title') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                size: "xlarge",
                                as: "span",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$30d32c26274e909d$var$i18n.carouselModalTitle
                                })
                            })
                        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            size: "xlarge",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$30d32c26274e909d$var$i18n.carouselModalTitle
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $fEPJS.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...$30d32c26274e909d$var$i18n.carouselModalDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $30d32c26274e909d$var$styles.carouselContainer,
                        children: carouselSlides.map((slide, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)($30d32c26274e909d$var$CarouselSlide, {
                                title: slide.title,
                                description: slide.description,
                                imageAlt: slide.imageAlt,
                                imageSrc: slide.imageSrc,
                                lozenge: slide.lozenge,
                                index: index,
                                selectedIndex: selectedIndex
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                    xcss: $30d32c26274e909d$var$styles.controlsContainer,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            shape: "circle",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                                    ...iconProps,
                                    size: "medium"
                                }),
                            label: formatMessage($30d32c26274e909d$var$i18n.carouselModalPreviousLabel),
                            onClick: handlePrevious
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lb2UL.default), {
                            onSelect: ({ event: _, index: index })=>handleSelectIndex(index),
                            selectedIndex: selectedIndex,
                            values: carouselSlides.map((_, i)=>i)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            shape: "circle",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                                    ...iconProps,
                                    size: "medium"
                                }),
                            label: formatMessage($30d32c26274e909d$var$i18n.carouselModalNextLabel),
                            onClick: handleNext
                        })
                    ]
                })
            })
        ]
    });
};
const $30d32c26274e909d$export$260b9a691de17a4b = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)($30d32c26274e909d$var$CarouselModalContent, {
            onClose: onClose
        })
    });
};





const $fcda8fc477c88b06$export$fdc3038398c14da = ({ fireAnalyticsEvent: fireAnalyticsEvent, onClosed: onClosed, onCtaActioned: onCtaActioned, onDismissed: onDismissed, setIsModalOpen: setIsModalOpen })=>{
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        onClosed({
            interactionIdentifier: 'dismissBanner'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerDismiss'
        });
        onDismissed();
    }, [
        fireAnalyticsEvent,
        onClosed,
        onDismissed
    ]);
    const handleAskRovoClick = (0, $cozmU.useCallback)(()=>{
        onCtaActioned({
            interactionIdentifier: 'askRovo'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerAskRovo'
        });
    // Ask Rovo handler - can be expanded as needed
    }, [
        fireAnalyticsEvent,
        onCtaActioned
    ]);
    const handleMoreIdeasClick = (0, $cozmU.useCallback)(()=>{
        onCtaActioned({
            interactionIdentifier: 'moreIdeas'
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoAwarenessHomeBannerMoreIdeas'
        });
        setIsModalOpen(true);
    }, [
        fireAnalyticsEvent,
        onCtaActioned,
        setIsModalOpen
    ]);
    return (0, $cozmU.useMemo)(()=>({
            handleDismiss: handleDismiss,
            handleAskRovoClick: handleAskRovoClick,
            handleMoreIdeasClick: handleMoreIdeasClick
        }), [
        handleDismiss,
        handleAskRovoClick,
        handleMoreIdeasClick
    ]);
};


const $05571191ed58a793$var$i18n = (0, $kSwu1.defineMessages)({
    bannerHeader: {
        id: "confluence-home-rovo-awareness.banner.header",
        defaultMessage: "Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."
    },
    bannerDescription: {
        id: "confluence-home-rovo-awareness.banner.description",
        defaultMessage: "Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."
    },
    bannerAskAnythingCTA: {
        id: "confluence-home-rovo-awareness.banner.ask-anything-cta",
        defaultMessage: "Ask Rovo"
    },
    bannerMoreIdeasCTA: {
        id: "confluence-home-rovo-awareness.banner.more-ideas-cta",
        defaultMessage: "More ideas"
    },
    searchBarImageText: {
        id: "confluence-home-rovo-awareness.banner.search-bar-image-text",
        defaultMessage: "If you Rovo, you know..."
    },
    dismissBannerCTA: {
        id: "confluence-home-rovo-awareness.banner.dismiss-banner-cta",
        defaultMessage: "Close banner"
    }
});
const $05571191ed58a793$export$29f9650e7f5c44eb = ({ onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onClosed: onClosed, onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'RovoAwarenessHomeBanner'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleDismiss: handleDismiss, handleAskRovoClick: handleAskRovoClick, handleMoreIdeasClick: handleMoreIdeasClick } = (0, $fcda8fc477c88b06$export$fdc3038398c14da)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        onClosed: onClosed,
        onCtaActioned: onCtaActioned,
        onDismissed: onDismissed,
        setIsModalOpen: setIsModalOpen
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _30huDK9r67 _1mT5xdRAKS _0KLXruRvDB _1UtDYze5R3 _0Of8r2S40j _1wydGWS40j _2Zuz6QS40j _1ZnuxbS40j _3iDTPbgBM8 _2iEGP2UfmU _3n40gWMdGV _0u2WMmrU95 _4cQPhCLmr7"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.Stack), {
                xcss: $05571191ed58a793$var$styles.contentStyles,
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.Stack), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kA6Zo.Flex), {
                                direction: "row",
                                alignItems: "center",
                                gap: "space.100",
                                xcss: $05571191ed58a793$var$styles.relativeStyles,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $etoPX.RovoIcon), {
                                        size: "large",
                                        appearance: "brand"
                                    }),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                        className: (0, $hekY6.default)([
                                            $05571191ed58a793$var$unboundStyles.headerStyles,
                                            $05571191ed58a793$var$unboundStyles.whiteTextColor
                                        ]),
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$05571191ed58a793$var$i18n.bannerHeader
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                                size: "large",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    className: (0, $hekY6.default)([
                                        $05571191ed58a793$var$unboundStyles.whiteTextColor
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...$05571191ed58a793$var$i18n.bannerDescription
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                                onClick: handleAskRovoClick,
                                "data-testid": "ask-rovo-button",
                                className: (0, $hekY6.default)([
                                    $05571191ed58a793$var$unboundStyles.buttonStyles,
                                    $05571191ed58a793$var$unboundStyles.primaryButtonStyles,
                                    $05571191ed58a793$var$unboundStyles.whiteTextColor
                                ]),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$05571191ed58a793$var$i18n.bannerAskAnythingCTA
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                                onClick: handleMoreIdeasClick,
                                className: (0, $hekY6.default)([
                                    $05571191ed58a793$var$unboundStyles.buttonStyles,
                                    $05571191ed58a793$var$unboundStyles.defaultButtonStyles
                                ]),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$05571191ed58a793$var$i18n.bannerMoreIdeasCTA
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    $05571191ed58a793$var$unboundStyles.rightContainerStyles
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        $05571191ed58a793$var$unboundStyles.searchBarStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                $05571191ed58a793$var$unboundStyles.headerStyles,
                                $05571191ed58a793$var$unboundStyles.rovoTelepointerSpacerStyles,
                                $05571191ed58a793$var$unboundStyles.rovoGradientText
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$05571191ed58a793$var$i18n.searchBarImageText
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5c356f3b24ab6a04$export$ae0370cf11de76d), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    $05571191ed58a793$var$unboundStyles.dismissIconStyles
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    isTooltipDisabled: false,
                    label: formatMessage($05571191ed58a793$var$i18n.dismissBannerCTA),
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                    onClick: handleDismiss
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    $05571191ed58a793$var$unboundStyles.greySwirlContainerStyles
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $05571191ed58a793$var$unboundStyles.greySwirlStyles
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $47264dbfbbfedc88$export$ded08279a8be4c83), {})
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $30d32c26274e909d$export$260b9a691de17a4b), {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false)
            })
        ]
    });
};
const $05571191ed58a793$var$containerStyles = null; /**
                               * Every single eslint disable here is based on the design of the banner being the same between dark and light mode. This means
                               * we can't use any tokens as they automatically update between the two themes as well as most ADS components as they also use tokens internally.
                               * This means we can't use Headings, Texts, and Buttons (all variations of buttons).
                               */ 
const $05571191ed58a793$var$unboundStyles = {
    rightContainerStyles: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _0aFT5vf5Xk _42Yu6B7dHp _0zcZvFYbGa",
    headerStyles: "_4ya3eEoWWg",
    whiteTextColor: "_1UtDYzt28M",
    searchBarPositioner: "_3iDTPbQ4SZ _37wbyuDIqT _0aFT5vf5Xk",
    searchBarReverse: "_39xV02N91d _3iDTPbQ4SZ",
    searchBarStyles: "_4bt5LAnQyn _2WAcuGnQyn _4FKVYE5zaO _2C2kUQKxmn _1v9SsVKxmn _0KLXrut28M _1EqgXlwBC3 _1ANEUSLRg7",
    rovoTelepointerSpacerStyles: "_0adFHs1Y8M",
    greySwirlContainerStyles: "_1mT5xdWVPG _42Yu6BdnbC _4ApkO2dnbC _0jFU0VN91d",
    greySwirlStyles: "_0jFU0VN91d",
    rovoGradientText: "_3CkH9oxD5a _07XDTDJxkL _1UtDYzjOvk",
    buttonStyles: "_0Of8r2Zimw _1ZnuxbxpxF _1wydGWZimw _2Zuz6QxpxF _30huDKYbGa _0bjKvDKTcp _2sNsIgmnOE _1UtDYzt28M _1kk5Tkf7mX _0jFU0VUofl _24h04i2Njc _0wOv4Q7zJH",
    primaryButtonStyles: "_0KLXrucPj8 _1eOmH6IMFZ _3gzVzLIsoM",
    primaryButtonPressedStyles: "_0KLXruIsoM",
    defaultButtonStyles: "_30huDKSCIf _1UtDYzt28M _0KLXruCZ0C _0clgaMt28M _1eOmH6IcTM",
    dismissIconStyles: "_2IhTon8HPE _4ApkO28HPE _1mT5xdWVPG _0wOv4Q7zJH _42Yu6B7dHp _0lpMcxt28M _3VVnIUCZ0C _1og2ZtIcTM _3xw7MJt28M _0c7P3At28M"
};
const $05571191ed58a793$var$styles = {
    contentStyles: "_4ouGXIqJJ5 _42Yu6B7dHp",
    headerContainerStyles: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d",
    inlineBlockStyles: "_3iDTPbvbI6",
    relativeStyles: "_1mT5xdRAKS"
};


const $468519a303fee8de$export$b3890eb0ae9dca99 = (0, $cc35046634815caf$export$78c758434c34d601)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $05571191ed58a793$export$29f9650e7f5c44eb), {
        onDismissed: onDismissed
    }));
var $468519a303fee8de$export$2e2bcd8739ae039 = $468519a303fee8de$export$b3890eb0ae9dca99;








const $ae00c03b0f022038$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $ae00c03b0f022038$export$78c758434c34d601 = $ae00c03b0f022038$var$clientPipeline.createRender;
const $ae00c03b0f022038$export$2859a83e4d6da57d = $ae00c03b0f022038$var$clientPipeline.createValidate;
const $ae00c03b0f022038$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $ae00c03b0f022038$export$c905bc718befd59b = $ae00c03b0f022038$var$serverPipeline.createHydrate;
const $ae00c03b0f022038$export$1f41223e5b0a6622 = $ae00c03b0f022038$var$serverPipeline.createHydrateExample;
const $ae00c03b0f022038$export$88fe13b4d13f8423 = $ae00c03b0f022038$var$serverPipeline.createTransformMetadata;


const $aa41f63d4b035ba7$export$b3890eb0ae9dca99 = (0, $ae00c03b0f022038$export$78c758434c34d601)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)("button", {
        children: "This is an example test button"
    }));
var $aa41f63d4b035ba7$export$2e2bcd8739ae039 = $aa41f63d4b035ba7$export$b3890eb0ae9dca99;






var $IQ4Dz = parcelRequire("IQ4Dz");

/* recommendation.tsx generated by @compiled/babel-plugin v3.0.2 */ 








/* message.tsx generated by @compiled/babel-plugin v3.0.2 */ 





parcelRequire("63sT2");
var $8NccQ = parcelRequire("8NccQ");





var $baFbJ = parcelRequire("baFbJ");




const $4f0899fabab419b1$export$1c3f82bc53516a2a = (crossflowOptions, interactionIdentifier)=>{
    const crossflow = (0, $8NccQ.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $baFbJ.useMessageEvent)();
    const { onCtaActioned: onCtaActioned } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        messageClicked().catch(()=>{});
        onCtaActioned({
            interactionIdentifier: interactionIdentifier,
            additionalMetadata: {}
        });
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        interactionIdentifier,
        messageClicked,
        onCtaActioned
    ]);
    return {
        handleClick: handleClick
    };
};



var $k4HA2 = parcelRequire("k4HA2");

parcelRequire("cozmU");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");











var $lpNn5 = parcelRequire("lpNn5");


var $c25Cq = parcelRequire("c25Cq");










const $08c804ed3c071218$var$DismissButton = ({ onDismissed: onDismissed })=>{
    const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    const { onClosed: onClosed } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const intl = (0, $kSwu1.useIntl)();
    const tooltip = intl.formatMessage({
        id: "post-office.close-button.tooltip",
        defaultMessage: "Close"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            shape: "default",
            appearance: "subtle",
            label: "close",
            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: ()=>{
                onDismissed();
                messageDismissed().catch(()=>{});
                onClosed({
                    interactionIdentifier: 'close',
                    additionalMetadata: {}
                });
            }
        })
    });
};
const $08c804ed3c071218$var$actionsStyles = null;
const $08c804ed3c071218$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                iconSize: "small",
                onDismissed: onDismissed,
                showWhyAmISeeingThis: true,
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($08c804ed3c071218$var$DismissButton, {
                onDismissed: onDismissed
            })
        ]
    });
};


const $b65254b6abc671bb$var$confluenceBannerMessageStylesCss = null;
const $b65254b6abc671bb$export$8e69ee67bea8fbdd = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent, ctaContent: ctaContent, crossflowOptions: crossflowOptions })=>{
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const { handleClick: handleClick } = (0, $4f0899fabab419b1$export$1c3f82bc53516a2a)(crossflowOptions, 'recommendation-message');
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const handleMessageClick = (e)=>{
        const currentTarget = e.currentTarget;
        let target = e.target;
        while(target.parentNode){
            if (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'html' // this is for the modal & its transparent background
            ) // Don't open Cross-flow since these child elements should've already handled the click
            return;
             // Open Cross-flow if the click is on the banner message itself
            if (target === currentTarget) {
                handleClick();
                return;
            } // Keep traversing up the DOM tree
            target = target.parentNode;
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": "confluence-banner-message",
        onClick: handleMessageClick,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2Y7lL4p0Oa _4c065UNHnM _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXruVva3 _4kiQYAS40j _42Yu6BdnbC _1DCdHiNHnM _4nqctAkRPw _0ReiIH7zJH _0M4C5Y5zaO _3Pkc9rNHnM"
        ]),
        children: [
            bodyContent,
            ctaContent,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $08c804ed3c071218$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId)
            })
        ]
    });
};









var $buxP3 = parcelRequire("buxP3");





var $ad7Ou = parcelRequire("ad7Ou");


var $kh0hi = parcelRequire("kh0hi");


const $f4dca97d735bda4d$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $4f0899fabab419b1$export$1c3f82bc53516a2a)(crossflowOptions, 'cta');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $f4dca97d735bda4d$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $4f0899fabab419b1$export$1c3f82bc53516a2a)(crossflowOptions, 'cta');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $f4dca97d735bda4d$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $4f0899fabab419b1$export$1c3f82bc53516a2a)(crossflowOptions, 'cta');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};





const $2cabe59e22a12f9d$var$JOURNEY = 'get-started';
const $2cabe59e22a12f9d$var$SOURCE_COMPONENT = 'confluence-home-banner';
const $2cabe59e22a12f9d$export$f88093e38da354ae = ({ app: app, sourceContext: sourceContext })=>({
        targetProduct: app.hamsIdentifier,
        journey: $2cabe59e22a12f9d$var$JOURNEY,
        sourceComponent: $2cabe59e22a12f9d$var$SOURCE_COMPONENT,
        sourceContext: sourceContext
    });


const $d73d54d8be746c68$var$buttonText = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
    id: "post-office.confluence-banner-first-party-recommendation.try-it-now",
    defaultMessage: "Try it now"
});
const $d73d54d8be746c68$var$ctaButtonStyles = (0, $buxP3.xcss)({
    minWidth: '100px',
    color: 'color.link',
    marginRight: 'space.100',
    backgroundColor: 'color.background.accent.blue.subtlest',
    paddingInline: 'space.150',
    paddingBlock: 'space.100',
    fontWeight: 'font.weight.medium',
    borderRadius: 'radius.small',
    fontSize: '14px',
    ':hover': {
        backgroundColor: 'color.background.accent.blue.subtler'
    }
});
const $d73d54d8be746c68$export$bd36621ef7814117 = ({ app: app })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4dca97d735bda4d$export$585a4ef79f2a8b77), {
        crossflowOptions: (0, $2cabe59e22a12f9d$export$f88093e38da354ae)({
            app: app,
            sourceContext: 'tryItNow'
        }),
        ctaText: $d73d54d8be746c68$var$buttonText,
        pressableStyle: $d73d54d8be746c68$var$ctaButtonStyles
    });
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");




const $a40ff93fed4739ed$var$dividerStyles = null;
const $a40ff93fed4739ed$export$2e0a83ec2e27ecbb = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_2XghbETcBG _4xdlr0FlnN _39xV02Ze1d _0KLXru9r67"
        ])
    });
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");




const $6188d4c20b1754b8$var$valuePropositionStyles = null;
const $6188d4c20b1754b8$var$headerStyles = null;
const $6188d4c20b1754b8$var$bodyStyles = null;
const $6188d4c20b1754b8$export$41a3c9c96d264ad5 = ({ app: app })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0adFHsNHnM"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                role: "presentation",
                className: (0, $hekY6.default)([
                    "_2sNsIgEqul _1UtDYzy7kJ"
                ]),
                children: app.header
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
                className: (0, $hekY6.default)([
                    "_2sNsIgmnOE _3138421Y8M _1UtDYzZpcK"
                ]),
                children: app.description
            })
        ]
    });
};



const $0b6f6411acbf62b1$var$bodyContentContainerStyles = null;
const $0b6f6411acbf62b1$var$logoContainerStyles = null;
const $0b6f6411acbf62b1$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0jFU0VE6Kk _39xV02N91d"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VhzUg _0adFHsey7F _3co5ZJTTQh _2S9CkHTTQh"
                ]),
                children: app.logo
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a40ff93fed4739ed$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6188d4c20b1754b8$export$41a3c9c96d264ad5), {
                app: app
            })
        ]
    });
};
const $0b6f6411acbf62b1$var$CtaContent = ({ app: app })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d73d54d8be746c68$export$bd36621ef7814117), {
        app: app
    });
const $0b6f6411acbf62b1$var$RECOMMENDATION_MESSAGE_SOURCE_CONTEXT = 'recommendation-message';
const $0b6f6411acbf62b1$export$486c30dd11c42f3 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const crossflowOptions = (0, $cozmU.useMemo)(()=>(0, $2cabe59e22a12f9d$export$f88093e38da354ae)({
            app: app,
            sourceContext: $0b6f6411acbf62b1$var$RECOMMENDATION_MESSAGE_SOURCE_CONTEXT
        }), [
        app
    ]);
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b65254b6abc671bb$export$8e69ee67bea8fbdd), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $8aG6j.jsx)($0b6f6411acbf62b1$var$BodyContent, {
            app: app
        }),
        ctaContent: /*#__PURE__*/ (0, $8aG6j.jsx)($0b6f6411acbf62b1$var$CtaContent, {
            app: app
        }),
        crossflowOptions: crossflowOptions
    });
};








const $e516fc51a18830b4$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $e516fc51a18830b4$export$78c758434c34d601 = $e516fc51a18830b4$var$clientPipeline.createRender;
const $e516fc51a18830b4$export$2859a83e4d6da57d = $e516fc51a18830b4$var$clientPipeline.createValidate;
const $e516fc51a18830b4$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $e516fc51a18830b4$export$c905bc718befd59b = $e516fc51a18830b4$var$serverPipeline.createHydrate;
const $e516fc51a18830b4$export$1f41223e5b0a6622 = $e516fc51a18830b4$var$serverPipeline.createHydrateExample;
const $e516fc51a18830b4$export$88fe13b4d13f8423 = $e516fc51a18830b4$var$serverPipeline.createTransformMetadata;





const $d69c60cff589a5eb$export$193c7b53f1a3a6ab = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "39",
        viewBox: "0 0 110 39",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#clip0_1258_173043)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                        id: "mask0_1258_173043",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "110",
                        height: "39",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M110 0H0V38.6813H110V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                        mask: "url(#mask0_1258_173043)",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                                id: "mask1_1258_173043",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "2",
                                width: "14",
                                height: "14",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M13.1678 2.68506H0V15.8528H13.1678V2.68506Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                                mask: "url(#mask1_1258_173043)",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M7.64859 2.69168C9.40568 3.20713 11.18 3.20713 12.9371 2.69168C13.0921 2.65732 13.1955 2.76041 13.161 2.91504C12.6615 4.71909 12.6615 6.38573 13.161 8.18977C13.1955 8.32721 13.0921 8.44749 12.9371 8.39595C11.18 7.91485 9.40568 7.91485 7.64859 8.39595C7.51074 8.44749 7.39019 8.32721 7.44184 8.18977C7.90694 6.38573 7.90694 4.71909 7.44184 2.91504C7.39019 2.76041 7.51074 2.65732 7.64859 2.69168ZM8.35484 9.08323V9.37531C8.35484 10.7326 7.40739 11.7292 6.23599 11.7292C5.06459 11.7292 4.13435 10.7842 4.13435 9.61582C4.13435 8.44749 5.0818 7.5197 6.40825 7.5197H6.75279V3.41331C6.58054 3.39612 6.40825 3.39612 6.23599 3.39612C2.79069 3.39612 0 6.17955 0 9.63303C0 13.0865 2.79069 15.8527 6.23599 15.8527C9.68129 15.8527 12.4892 13.0693 12.4892 9.63303V9.08323H8.35484Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M91.2968 32.9161H90.2589L86.9041 24.2418H88.6093L91.5748 32.1747L94.5404 24.2418H96.2456L92.7425 33.2127C91.7046 35.8631 91.1115 37.2347 88.7575 37.2347C87.9605 37.2347 87.5157 37.1606 87.0523 36.9752V35.6037C87.5898 35.7705 88.2015 35.8261 88.6649 35.8261C89.9623 35.8261 90.5369 34.9364 91.2968 32.9161Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M83.2901 28.0415V33.5093H81.7332V24.2419H83.2901V25.8729C83.8276 24.7794 84.7543 24.0009 86.5707 24.1121V25.6691C84.5319 25.4652 83.2901 26.0768 83.2901 28.0415Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M75.7574 25.5022C74.0707 25.5022 73.2181 26.5958 73.0513 28.2083H78.2225C78.1298 26.4846 77.3513 25.5022 75.7574 25.5022ZM79.316 33.1386C78.5561 33.5463 77.3884 33.6946 76.4431 33.6946C72.9771 33.6946 71.4573 31.6929 71.4573 28.857C71.4573 26.0583 73.0142 24.0565 75.8315 24.0565C78.6858 24.0565 79.835 26.0397 79.835 28.857V29.5799H73.0698C73.2922 31.1553 74.3116 32.1748 76.4987 32.1748C77.5738 32.1748 78.482 31.9709 79.316 31.6743V33.1386Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M67.3994 33.5092H65.2679L61.6721 24.2418H63.3403L66.3429 32.1562L69.327 24.2418H70.9951L67.3994 33.5092Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M56.8451 33.6946C54.0649 33.6946 52.4338 31.6373 52.4338 28.857C52.4338 26.0768 54.0649 24.0565 56.8451 24.0565C59.6068 24.0565 61.2193 26.0768 61.2193 28.857C61.2193 31.6373 59.6068 33.6946 56.8451 33.6946ZM56.8451 25.5393C54.8619 25.5393 53.9908 27.0962 53.9908 28.857C53.9908 30.6178 54.8619 32.2118 56.8451 32.2118C58.8098 32.2118 59.6624 30.6178 59.6624 28.857C59.6624 27.0962 58.8098 25.5393 56.8451 25.5393Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M51.1701 31.8411V33.2683C50.6141 33.5649 49.7615 33.6946 48.9089 33.6946C45.6097 33.6946 44.0713 31.6929 44.0713 28.857C44.0713 26.0583 45.6097 24.0565 48.9089 24.0565C49.7429 24.0565 50.3917 24.1677 51.1145 24.5014V25.9841C50.5214 25.7061 49.8912 25.5393 49.0201 25.5393C46.6106 25.5393 45.6282 27.0592 45.6282 28.857C45.6282 30.6549 46.6291 32.1748 49.0572 32.1748C50.0024 32.1748 50.5955 32.045 51.1701 31.8411Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M42.7864 30.9885C42.7864 32.5269 41.7855 33.6946 39.3019 33.6946C37.9118 33.6946 36.7811 33.3795 36.0768 33.0088V31.3222C36.8738 31.7855 38.2083 32.2304 39.376 32.2304C40.5993 32.2304 41.2295 31.7299 41.2295 31.0071C41.2295 30.3027 40.692 29.895 38.9312 29.4687C36.8738 28.9682 36.0027 28.1712 36.0027 26.6514C36.0027 25.0389 37.2445 24.0565 39.3575 24.0565C40.5622 24.0565 41.6558 24.3531 42.3415 24.7238V26.3734C41.2295 25.8173 40.3213 25.5208 39.339 25.5208C38.1713 25.5208 37.5411 25.9285 37.5411 26.6514C37.5411 27.3001 37.9859 27.7079 39.6911 28.1156C41.7484 28.6161 42.7864 29.376 42.7864 30.9885Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M32.0952 21.7954C32.0952 21.0911 32.5586 20.6833 33.2073 20.6833C33.856 20.6833 34.3194 21.0911 34.3194 21.7954C34.3194 22.4998 33.856 22.9075 33.2073 22.9075C32.5586 22.9075 32.0952 22.4998 32.0952 21.7954ZM32.3918 33.5094V24.242H33.9858V33.5094H32.3918Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M24.6881 22.926H21.945V31.9154H24.7808C27.561 31.9154 28.9511 30.4511 28.9511 27.5041C28.9511 24.5385 27.6352 22.926 24.6881 22.926ZM20.2769 33.5094V21.332H24.7623C28.7102 21.332 30.6193 23.7972 30.6193 27.4485C30.6193 31.1369 28.6917 33.5094 24.7623 33.5094H20.2769Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M107.361 12.1015C107.361 12.917 107.843 13.4731 108.825 13.4731C109.196 13.4731 109.548 13.3989 109.826 13.3433V14.8817C109.548 14.9559 109.233 15.03 108.751 15.03C106.768 15.03 105.804 13.8623 105.804 12.1386V7.18978H104.302V5.707H105.804V3.74231H107.361V5.707H109.826V7.18978H107.361V12.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M103.336 13.3063V14.7335C102.78 15.0301 101.927 15.1598 101.074 15.1598C97.7752 15.1598 96.2368 13.1581 96.2368 10.3222C96.2368 7.52349 97.7752 5.52173 101.074 5.52173C101.908 5.52173 102.557 5.63294 103.28 5.96656V7.44935C102.687 7.17133 102.057 7.00451 101.186 7.00451C98.7761 7.00451 97.7937 8.52437 97.7937 10.3222C97.7937 12.1201 98.7946 13.64 101.223 13.64C102.168 13.64 102.761 13.5102 103.336 13.3063Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M86.5076 11.1377V5.70703H88.1016V11.3045C88.1016 12.9727 88.7688 13.7141 90.2887 13.7141C91.7715 13.7141 92.7909 12.7317 92.7909 10.8597V5.70703H94.3849V14.9744H92.7909V13.4546C92.1977 14.5481 91.1042 15.1598 89.8624 15.1598C87.7309 15.1598 86.5076 13.6955 86.5076 11.1377Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M77.4497 10.3408C77.4497 12.565 78.3394 13.6771 79.989 13.6771C81.4162 13.6771 82.6951 12.7689 82.6951 10.7115V9.97014C82.6951 7.91278 81.5274 7.00457 80.1743 7.00457C78.3764 7.00457 77.4497 8.1908 77.4497 10.3408ZM82.6951 14.9745V13.3064C82.1019 14.5297 80.9899 15.1599 79.5627 15.1599C77.0975 15.1599 75.8557 13.0654 75.8557 10.3408C75.8557 7.72743 77.1532 5.52179 79.748 5.52179C81.1011 5.52179 82.139 6.13343 82.6951 7.3382V1.83337H84.289V14.9745H82.6951Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M70.1852 15.1598C67.405 15.1598 65.7739 13.1025 65.7739 10.3222C65.7739 7.54202 67.405 5.52173 70.1852 5.52173C72.9469 5.52173 74.5594 7.54202 74.5594 10.3222C74.5594 13.1025 72.9469 15.1598 70.1852 15.1598ZM70.1852 7.00451C68.202 7.00451 67.3308 8.56144 67.3308 10.3222C67.3308 12.083 68.202 13.677 70.1852 13.677C72.1499 13.677 73.0025 12.083 73.0025 10.3222C73.0025 8.56144 72.1499 7.00451 70.1852 7.00451Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M61.8594 9.50672V14.9745H60.3025V5.70709H61.8594V7.33815C62.3969 6.2446 63.3237 5.46613 65.1401 5.57734V7.13427C63.1012 6.93038 61.8594 7.54203 61.8594 9.50672Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.836 6.85635C58.836 9.50683 57.3532 10.9896 54.3135 10.9896H51.8854V14.9746H50.2173V2.79724H54.3135C57.3532 2.79724 58.836 4.35416 58.836 6.85635ZM54.1281 9.39562C56.2782 9.46976 57.1122 8.45035 57.1122 6.89342C57.1122 5.41064 56.2782 4.39123 54.1281 4.39123H51.8854V9.39562H54.1281Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.2849 10.3408C37.2849 12.565 38.1746 13.677 39.8242 13.677C41.2515 13.677 42.5304 12.7688 42.5304 10.7115V9.97008C42.5304 7.91272 41.3627 7.00451 40.0095 7.00451C38.2117 7.00451 37.2849 8.19074 37.2849 10.3408ZM42.5304 14.9745V13.3063C41.9373 14.5296 40.8252 15.1598 39.3979 15.1598C36.9328 15.1598 35.6909 13.0654 35.6909 10.3408C35.6909 7.72737 36.9884 5.52173 39.5832 5.52173C40.9364 5.52173 41.9744 6.13338 42.5304 7.33814V5.70708H44.1244V14.9745H42.5304Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M31.7764 9.50672V14.9745H30.2195V5.70709H31.7764V7.33815C32.3139 6.2446 33.2407 5.46613 35.0571 5.57734V7.13427C33.0182 6.93038 31.7764 7.54203 31.7764 9.50672Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M25.9229 3.26065C25.9229 2.55633 26.3862 2.14856 27.0349 2.14856C27.6837 2.14856 28.147 2.55633 28.147 3.26065C28.147 3.96499 27.6837 4.37275 27.0349 4.37275C26.3862 4.37275 25.9229 3.96499 25.9229 3.26065ZM26.2194 14.9747V5.70726H27.8134V14.9747H26.2194Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M22.3345 11.3788V2.79724H24.0026V11.2676C24.0026 13.5103 23.0203 15.0487 20.722 15.0487C19.8508 15.0487 19.1836 14.9005 18.7202 14.7336V13.1211C19.2207 13.325 19.8323 13.4362 20.444 13.4362C21.8526 13.4362 22.3345 12.5836 22.3345 11.3788Z",
                                fill: "#E2E3E4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_1258_173043",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "110",
                        height: "38.6813",
                        fill: "white"
                    })
                })
            })
        ]
    });





const $59325bc0cbf81342$export$2177945c83322624 = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "39",
        viewBox: "0 0 110 39",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#clip0_1258_173148)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                        id: "mask0_1258_173148",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "110",
                        height: "39",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M110 0H0V38.6813H110V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                        mask: "url(#mask0_1258_173148)",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                                id: "mask1_1258_173148",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "2",
                                width: "14",
                                height: "14",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M13.1678 2.68506H0V15.8528H13.1678V2.68506Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                                mask: "url(#mask1_1258_173148)",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M7.64859 2.69168C9.40568 3.20713 11.18 3.20713 12.9371 2.69168C13.0921 2.65732 13.1955 2.76041 13.161 2.91504C12.6615 4.71909 12.6615 6.38573 13.161 8.18977C13.1955 8.32721 13.0921 8.44749 12.9371 8.39595C11.18 7.91485 9.40568 7.91485 7.64859 8.39595C7.51074 8.44749 7.39019 8.32721 7.44184 8.18977C7.90694 6.38573 7.90694 4.71909 7.44184 2.91504C7.39019 2.76041 7.51074 2.65732 7.64859 2.69168ZM8.35484 9.08323V9.37531C8.35484 10.7326 7.40739 11.7292 6.23599 11.7292C5.06459 11.7292 4.13435 10.7842 4.13435 9.61582C4.13435 8.44749 5.0818 7.5197 6.40825 7.5197H6.75279V3.41331C6.58054 3.39612 6.40825 3.39612 6.23599 3.39612C2.79069 3.39612 0 6.17955 0 9.63303C0 13.0865 2.79069 15.8527 6.23599 15.8527C9.68129 15.8527 12.4892 13.0693 12.4892 9.63303V9.08323H8.35484Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M91.2968 32.9161H90.2589L86.9041 24.2418H88.6093L91.5748 32.1747L94.5404 24.2418H96.2456L92.7425 33.2127C91.7046 35.8631 91.1115 37.2347 88.7575 37.2347C87.9605 37.2347 87.5157 37.1606 87.0523 36.9752V35.6037C87.5898 35.7705 88.2015 35.8261 88.6649 35.8261C89.9623 35.8261 90.5369 34.9364 91.2968 32.9161Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M83.2901 28.0415V33.5093H81.7332V24.2419H83.2901V25.8729C83.8276 24.7794 84.7543 24.0009 86.5707 24.1121V25.6691C84.5319 25.4652 83.2901 26.0768 83.2901 28.0415Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M75.7574 25.5022C74.0707 25.5022 73.2181 26.5958 73.0513 28.2083H78.2225C78.1298 26.4846 77.3513 25.5022 75.7574 25.5022ZM79.316 33.1386C78.5561 33.5463 77.3884 33.6946 76.4431 33.6946C72.9771 33.6946 71.4573 31.6929 71.4573 28.857C71.4573 26.0583 73.0142 24.0565 75.8315 24.0565C78.6858 24.0565 79.835 26.0397 79.835 28.857V29.5799H73.0698C73.2922 31.1553 74.3116 32.1748 76.4987 32.1748C77.5738 32.1748 78.482 31.9709 79.316 31.6743V33.1386Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M67.3994 33.5092H65.2679L61.6721 24.2418H63.3403L66.3429 32.1562L69.327 24.2418H70.9951L67.3994 33.5092Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M56.8451 33.6946C54.0649 33.6946 52.4338 31.6373 52.4338 28.857C52.4338 26.0768 54.0649 24.0565 56.8451 24.0565C59.6068 24.0565 61.2193 26.0768 61.2193 28.857C61.2193 31.6373 59.6068 33.6946 56.8451 33.6946ZM56.8451 25.5393C54.8619 25.5393 53.9908 27.0962 53.9908 28.857C53.9908 30.6178 54.8619 32.2118 56.8451 32.2118C58.8098 32.2118 59.6624 30.6178 59.6624 28.857C59.6624 27.0962 58.8098 25.5393 56.8451 25.5393Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M51.1701 31.8411V33.2683C50.6141 33.5649 49.7615 33.6946 48.9089 33.6946C45.6097 33.6946 44.0713 31.6929 44.0713 28.857C44.0713 26.0583 45.6097 24.0565 48.9089 24.0565C49.7429 24.0565 50.3917 24.1677 51.1145 24.5014V25.9841C50.5214 25.7061 49.8912 25.5393 49.0201 25.5393C46.6106 25.5393 45.6282 27.0592 45.6282 28.857C45.6282 30.6549 46.6291 32.1748 49.0572 32.1748C50.0024 32.1748 50.5955 32.045 51.1701 31.8411Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M42.7864 30.9885C42.7864 32.5269 41.7855 33.6946 39.3019 33.6946C37.9118 33.6946 36.7811 33.3795 36.0768 33.0088V31.3222C36.8738 31.7855 38.2083 32.2304 39.376 32.2304C40.5993 32.2304 41.2295 31.7299 41.2295 31.0071C41.2295 30.3027 40.692 29.895 38.9312 29.4687C36.8738 28.9682 36.0027 28.1712 36.0027 26.6514C36.0027 25.0389 37.2445 24.0565 39.3575 24.0565C40.5622 24.0565 41.6558 24.3531 42.3415 24.7238V26.3734C41.2295 25.8173 40.3213 25.5208 39.339 25.5208C38.1713 25.5208 37.5411 25.9285 37.5411 26.6514C37.5411 27.3001 37.9859 27.7079 39.6911 28.1156C41.7484 28.6161 42.7864 29.376 42.7864 30.9885Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M32.0952 21.7954C32.0952 21.0911 32.5586 20.6833 33.2073 20.6833C33.856 20.6833 34.3194 21.0911 34.3194 21.7954C34.3194 22.4998 33.856 22.9075 33.2073 22.9075C32.5586 22.9075 32.0952 22.4998 32.0952 21.7954ZM32.3918 33.5094V24.242H33.9858V33.5094H32.3918Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M24.6881 22.926H21.945V31.9154H24.7808C27.561 31.9154 28.9511 30.4511 28.9511 27.5041C28.9511 24.5385 27.6352 22.926 24.6881 22.926ZM20.2769 33.5094V21.332H24.7623C28.7102 21.332 30.6193 23.7972 30.6193 27.4485C30.6193 31.1369 28.6917 33.5094 24.7623 33.5094H20.2769Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M107.361 12.1015C107.361 12.917 107.843 13.4731 108.825 13.4731C109.196 13.4731 109.548 13.3989 109.826 13.3433V14.8817C109.548 14.9559 109.233 15.03 108.751 15.03C106.768 15.03 105.804 13.8623 105.804 12.1386V7.18978H104.302V5.707H105.804V3.74231H107.361V5.707H109.826V7.18978H107.361V12.1015Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M103.336 13.3063V14.7335C102.78 15.0301 101.927 15.1598 101.074 15.1598C97.7752 15.1598 96.2368 13.1581 96.2368 10.3222C96.2368 7.52349 97.7752 5.52173 101.074 5.52173C101.908 5.52173 102.557 5.63294 103.28 5.96656V7.44935C102.687 7.17133 102.057 7.00451 101.186 7.00451C98.7761 7.00451 97.7937 8.52437 97.7937 10.3222C97.7937 12.1201 98.7946 13.64 101.223 13.64C102.168 13.64 102.761 13.5102 103.336 13.3063Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M86.5076 11.1377V5.70703H88.1016V11.3045C88.1016 12.9727 88.7688 13.7141 90.2887 13.7141C91.7715 13.7141 92.7909 12.7317 92.7909 10.8597V5.70703H94.3849V14.9744H92.7909V13.4546C92.1977 14.5481 91.1042 15.1598 89.8624 15.1598C87.7309 15.1598 86.5076 13.6955 86.5076 11.1377Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M77.4497 10.3408C77.4497 12.565 78.3394 13.6771 79.989 13.6771C81.4162 13.6771 82.6951 12.7689 82.6951 10.7115V9.97014C82.6951 7.91278 81.5274 7.00457 80.1743 7.00457C78.3764 7.00457 77.4497 8.1908 77.4497 10.3408ZM82.6951 14.9745V13.3064C82.1019 14.5297 80.9899 15.1599 79.5627 15.1599C77.0975 15.1599 75.8557 13.0654 75.8557 10.3408C75.8557 7.72743 77.1532 5.52179 79.748 5.52179C81.1011 5.52179 82.139 6.13343 82.6951 7.3382V1.83337H84.289V14.9745H82.6951Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M70.1852 15.1598C67.405 15.1598 65.7739 13.1025 65.7739 10.3222C65.7739 7.54202 67.405 5.52173 70.1852 5.52173C72.9469 5.52173 74.5594 7.54202 74.5594 10.3222C74.5594 13.1025 72.9469 15.1598 70.1852 15.1598ZM70.1852 7.00451C68.202 7.00451 67.3308 8.56144 67.3308 10.3222C67.3308 12.083 68.202 13.677 70.1852 13.677C72.1499 13.677 73.0025 12.083 73.0025 10.3222C73.0025 8.56144 72.1499 7.00451 70.1852 7.00451Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M61.8594 9.50672V14.9745H60.3025V5.70709H61.8594V7.33815C62.3969 6.2446 63.3237 5.46613 65.1401 5.57734V7.13427C63.1012 6.93038 61.8594 7.54203 61.8594 9.50672Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.836 6.85635C58.836 9.50683 57.3532 10.9896 54.3135 10.9896H51.8854V14.9746H50.2173V2.79724H54.3135C57.3532 2.79724 58.836 4.35416 58.836 6.85635ZM54.1281 9.39562C56.2782 9.46976 57.1122 8.45035 57.1122 6.89342C57.1122 5.41064 56.2782 4.39123 54.1281 4.39123H51.8854V9.39562H54.1281Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.2849 10.3408C37.2849 12.565 38.1746 13.677 39.8242 13.677C41.2515 13.677 42.5304 12.7688 42.5304 10.7115V9.97008C42.5304 7.91272 41.3627 7.00451 40.0095 7.00451C38.2117 7.00451 37.2849 8.19074 37.2849 10.3408ZM42.5304 14.9745V13.3063C41.9373 14.5296 40.8252 15.1598 39.3979 15.1598C36.9328 15.1598 35.6909 13.0654 35.6909 10.3408C35.6909 7.72737 36.9884 5.52173 39.5832 5.52173C40.9364 5.52173 41.9744 6.13338 42.5304 7.33814V5.70708H44.1244V14.9745H42.5304Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M31.7764 9.50672V14.9745H30.2195V5.70709H31.7764V7.33815C32.3139 6.2446 33.2407 5.46613 35.0571 5.57734V7.13427C33.0182 6.93038 31.7764 7.54203 31.7764 9.50672Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M25.9229 3.26065C25.9229 2.55633 26.3862 2.14856 27.0349 2.14856C27.6837 2.14856 28.147 2.55633 28.147 3.26065C28.147 3.96499 27.6837 4.37275 27.0349 4.37275C26.3862 4.37275 25.9229 3.96499 25.9229 3.26065ZM26.2194 14.9747V5.70726H27.8134V14.9747H26.2194Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M22.3345 11.3788V2.79724H24.0026V11.2676C24.0026 13.5103 23.0203 15.0487 20.722 15.0487C19.8508 15.0487 19.1836 14.9005 18.7202 14.7336V13.1211C19.2207 13.325 19.8323 13.4362 20.444 13.4362C21.8526 13.4362 22.3345 12.5836 22.3345 11.3788Z",
                                fill: "#101214"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_1258_173148",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "110",
                        height: "38.6813",
                        fill: "white"
                    })
                })
            })
        ]
    });


const $e5b0108a4d2c8c2c$var$jpdLogoByTheme = (colorMode)=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59325bc0cbf81342$export$2177945c83322624), {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d69c60cff589a5eb$export$193c7b53f1a3a6ab), {});
};
const $e5b0108a4d2c8c2c$export$b3890eb0ae9dca99 = (0, $e516fc51a18830b4$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b6f6411acbf62b1$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-product-discovery',
            ccpProductId: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
            logo: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                role: "img",
                "aria-label": intl.formatMessage({
                    id: "post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Discovery Product Logo"
                }),
                children: $e5b0108a4d2c8c2c$var$jpdLogoByTheme(colorMode || 'light')
            }),
            header: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jpd.confluence-home-banner.header",
                defaultMessage: "Capture your ideas and customer feedback all in one place"
            }),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jpd.confluence-home-banner.description",
                defaultMessage: "Make sure your team is building the right things with Jira Product Discovery."
            })
        },
        onDismissed: onDismissed
    });
});
var $e5b0108a4d2c8c2c$export$2e2bcd8739ae039 = $e5b0108a4d2c8c2c$export$b3890eb0ae9dca99;















const $3c8f093dca8dd302$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $3c8f093dca8dd302$export$78c758434c34d601 = $3c8f093dca8dd302$var$clientPipeline.createRender;
const $3c8f093dca8dd302$export$2859a83e4d6da57d = $3c8f093dca8dd302$var$clientPipeline.createValidate;
const $3c8f093dca8dd302$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $3c8f093dca8dd302$export$c905bc718befd59b = $3c8f093dca8dd302$var$serverPipeline.createHydrate;
const $3c8f093dca8dd302$export$1f41223e5b0a6622 = $3c8f093dca8dd302$var$serverPipeline.createHydrateExample;
const $3c8f093dca8dd302$export$88fe13b4d13f8423 = $3c8f093dca8dd302$var$serverPipeline.createTransformMetadata;





const $6726bcc641ae4767$export$5a3585ff193409c7 = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "40",
        viewBox: "0 0 130 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#clip0_1258_173086)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                        id: "mask0_1258_173086",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "130",
                        height: "40",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M130 0H0V39.6947H130V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                        mask: "url(#mask0_1258_173086)",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                                id: "mask1_1258_173086",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "1",
                                width: "14",
                                height: "18",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M13.8944 1.65393H0V18.028H13.8944V1.65393Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                                mask: "url(#mask1_1258_173086)",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M8.68839 8.09373H13.1939C13.8706 8.09373 14.1016 8.74269 13.689 9.25856L6.64189 18.028C4.36439 16.1976 4.57891 13.3021 6.24582 11.1888L8.68839 8.09373ZM5.20607 11.5882H0.700536C0.0238782 11.5882 -0.207175 10.9392 0.20542 10.4233L7.25257 1.65393C9.53007 3.48436 9.28253 6.3465 7.63215 8.47645L5.20607 11.5882Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M127.245 31.7846C127.245 32.6215 127.735 33.1921 128.735 33.1921C129.113 33.1921 129.471 33.116 129.754 33.059V34.6377C129.471 34.7137 129.15 34.7898 128.66 34.7898C126.641 34.7898 125.66 33.5915 125.66 31.8226V26.7442H124.132V25.2226H125.66V23.2064H127.245V25.2226H129.754V26.7442H127.245V31.7846Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M122.738 29.1599V34.7329H121.116V28.9887C121.116 27.2769 120.437 26.5161 118.89 26.5161C117.381 26.5161 116.343 27.5241 116.343 29.4452V34.7329H114.721V25.2227H116.343V26.7823C116.947 25.6601 118.06 25.0325 119.324 25.0325C121.493 25.0325 122.738 26.5351 122.738 29.1599Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M108.638 26.5161C106.922 26.5161 106.054 27.6383 105.884 29.293H111.147C111.053 27.5241 110.261 26.5161 108.638 26.5161ZM112.26 34.3524C111.487 34.7709 110.299 34.9231 109.336 34.9231C105.809 34.9231 104.262 32.8689 104.262 29.9587C104.262 27.0867 105.847 25.0325 108.714 25.0325C111.619 25.0325 112.789 27.0676 112.789 29.9587V30.7005H105.903C106.13 32.3173 107.167 33.3634 109.393 33.3634C110.487 33.3634 111.412 33.1542 112.26 32.8498V34.3524Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M96.1729 29.4452V34.7329H94.5505V28.9887C94.5505 27.2769 93.8714 26.5161 92.3245 26.5161C90.8154 26.5161 89.7778 27.5241 89.7778 29.4452V34.7329H88.1555V25.2227H89.7778V26.7823C90.3815 25.6601 91.4945 25.0325 92.7584 25.0325C94.3619 25.0325 95.456 25.8503 95.9276 27.353C96.4558 25.8884 97.7197 25.0325 99.2855 25.0325C101.398 25.0325 102.568 26.478 102.568 29.1599V34.7329H100.946V29.4452C100.946 27.4861 100.266 26.5161 98.7196 26.5161C97.2104 26.5161 96.1729 27.5241 96.1729 29.4452Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M82.0736 26.5161C80.3569 26.5161 79.4891 27.6383 79.3194 29.293H84.5825C84.4882 27.5241 83.6959 26.5161 82.0736 26.5161ZM85.6955 34.3524C84.9221 34.7709 83.7336 34.9231 82.7715 34.9231C79.2439 34.9231 77.697 32.8689 77.697 29.9587C77.697 27.0867 79.2816 25.0325 82.149 25.0325C85.0541 25.0325 86.2237 27.0676 86.2237 29.9587V30.7005H79.3382C79.5646 32.3173 80.6021 33.3634 82.8281 33.3634C83.9223 33.3634 84.8466 33.1542 85.6955 32.8498V34.3524Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M74.2301 33.972V33.021C73.6264 34.2764 72.4946 34.9231 71.042 34.9231C68.5519 34.9231 67.3069 32.7738 67.3069 29.9778C67.3069 27.2959 68.6085 25.0325 71.2307 25.0325C72.6078 25.0325 73.6642 25.6601 74.2301 26.8965V25.2227H75.8147V33.8769C75.8147 36.6729 74.5131 38.5559 71.1363 38.5559C69.5517 38.5559 68.684 38.3467 67.7785 38.0424V36.4447C68.816 36.7871 69.8913 37.0153 71.0609 37.0153C73.4189 37.0153 74.2301 35.7409 74.2301 33.972ZM68.8915 29.9778C68.8915 32.2602 69.797 33.4014 71.4759 33.4014C72.9285 33.4014 74.2301 32.4694 74.2301 30.3582V29.5974C74.2301 27.4861 73.0417 26.5541 71.6646 26.5541C69.8347 26.5541 68.8915 27.7714 68.8915 29.9778Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.4656 29.9778C58.4656 32.2602 59.3711 33.4014 61.05 33.4014C62.5026 33.4014 63.8042 32.4694 63.8042 30.3582V29.5974C63.8042 27.4861 62.6158 26.5541 61.2387 26.5541C59.4088 26.5541 58.4656 27.7714 58.4656 29.9778ZM63.8042 34.7329V33.021C63.2005 34.2764 62.0687 34.9231 60.6161 34.9231C58.1072 34.9231 56.8433 32.7738 56.8433 29.9778C56.8433 27.2959 58.1638 25.0325 60.8048 25.0325C62.1819 25.0325 63.2383 25.6601 63.8042 26.8965V25.2227H65.4265V34.7329H63.8042Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M55.1467 29.1599V34.7329H53.5244V28.9887C53.5244 27.2769 52.8453 26.5161 51.2984 26.5161C49.7893 26.5161 48.7517 27.5241 48.7517 29.4452V34.7329H47.1294V25.2227H48.7517V26.7823C49.3554 25.6601 50.4684 25.0325 51.7323 25.0325C53.9017 25.0325 55.1467 26.5351 55.1467 29.1599Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.7219 29.9778C37.7219 32.2602 38.6274 33.4014 40.3064 33.4014C41.759 33.4014 43.0606 32.4694 43.0606 30.3582V29.5974C43.0606 27.4861 41.8722 26.5541 40.495 26.5541C38.6652 26.5541 37.7219 27.7714 37.7219 29.9778ZM43.0606 34.7329V33.021C42.457 34.2764 41.3251 34.9231 39.8725 34.9231C37.3635 34.9231 36.0996 32.7738 36.0996 29.9778C36.0996 27.2959 37.4201 25.0325 40.0611 25.0325C41.4383 25.0325 42.4947 25.6601 43.0606 26.8965V25.2227H44.683V34.7329H43.0606Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M23.7176 27.9044L22.0198 23.2634V34.7327H20.322V22.2363H23.2649L26.0757 29.407L27.2264 32.8497L28.3771 29.407L31.2068 22.2363H33.9421V34.7327H32.2443V23.3966L30.7917 27.9044L28.0564 34.7327H26.4152L23.7176 27.9044Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M102.891 7.49567C101.174 7.49567 100.306 8.61787 100.136 10.2726H105.4C105.305 8.50375 104.513 7.49567 102.891 7.49567ZM106.513 15.3321C105.739 15.7505 104.551 15.9027 103.589 15.9027C100.061 15.9027 98.5142 13.8485 98.5142 10.9384C98.5142 8.06628 100.099 6.01208 102.966 6.01208C105.871 6.01208 107.041 8.04726 107.041 10.9384V11.6802H100.155C100.382 13.2969 101.419 14.343 103.645 14.343C104.739 14.343 105.664 14.1338 106.513 13.8295V15.3321Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M97.2282 14.0006V15.4652C96.6623 15.7695 95.7945 15.9027 94.9268 15.9027C91.5689 15.9027 90.0032 13.8485 90.0032 10.9384C90.0032 8.06628 91.5689 6.01208 94.9268 6.01208C95.7757 6.01208 96.4359 6.12621 97.1716 6.46857V7.9902C96.568 7.7049 95.9266 7.53371 95.04 7.53371C92.5876 7.53371 91.5878 9.09338 91.5878 10.9384C91.5878 12.7833 92.6065 14.343 95.0777 14.343C96.0398 14.343 96.6434 14.2099 97.2282 14.0006Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M86.196 3.69164C86.196 2.96886 86.6677 2.55042 87.3279 2.55042C87.9882 2.55042 88.4598 2.96886 88.4598 3.69164C88.4598 4.41442 87.9882 4.83287 87.3279 4.83287C86.6677 4.83287 86.196 4.41442 86.196 3.69164ZM86.4979 15.7125V6.20234H88.1202V15.7125H86.4979Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M81.4328 15.7124H79.2634L75.6038 6.20227H77.3016L80.3576 14.324L83.3947 6.20227H85.0925L81.4328 15.7124Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M71.9262 10.1015V15.7125H70.3416V6.20234H71.9262V7.87613C72.4732 6.75393 73.4164 5.95507 75.2652 6.0692V7.66691C73.1901 7.45768 71.9262 8.08535 71.9262 10.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M64.2593 7.49567C62.5427 7.49567 61.6749 8.61787 61.5051 10.2726H66.7683C66.674 8.50375 65.8817 7.49567 64.2593 7.49567ZM67.8813 15.3321C67.1079 15.7505 65.9194 15.9027 64.9573 15.9027C61.4297 15.9027 59.8828 13.8485 59.8828 10.9384C59.8828 8.06628 61.4674 6.01208 64.3348 6.01208C67.2399 6.01208 68.4095 8.04726 68.4095 10.9384V11.6802H61.524C61.7504 13.2969 62.7879 14.343 65.0139 14.343C66.108 14.343 67.0324 14.1338 67.8813 13.8295V15.3321Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.4533 12.2698C58.4533 14.4381 57.1705 15.9027 54.0956 15.9027C51.6998 15.9027 50.5868 15.4272 49.6248 14.9326V13.1828C50.7755 13.7914 52.5487 14.2289 54.1899 14.2289C56.0575 14.2289 56.7555 13.4871 56.7555 12.3839C56.7555 11.2807 56.0764 10.6911 53.7183 10.1205C50.9264 9.43575 49.6813 8.46571 49.6813 6.41151C49.6813 4.47144 51.1528 3.02588 54.039 3.02588C55.8311 3.02588 56.9819 3.46335 57.8308 3.93886V5.6507C56.5857 4.92793 55.2463 4.69968 53.9636 4.69968C52.3412 4.69968 51.3791 5.27029 51.3791 6.41151C51.3791 7.43861 52.1714 7.95216 54.3597 8.50375C56.9819 9.16947 58.4533 10.0254 58.4533 12.2698Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.5379 10.9574C37.5379 13.2398 38.4434 14.381 40.1223 14.381C41.575 14.381 42.8766 13.449 42.8766 11.3378V10.577C42.8766 8.46571 41.6882 7.53371 40.3109 7.53371C38.4811 7.53371 37.5379 8.75102 37.5379 10.9574ZM42.8766 15.7125V14.0006C42.273 15.256 41.1411 15.9027 39.6884 15.9027C37.1794 15.9027 35.9155 13.7534 35.9155 10.9574C35.9155 8.27551 37.236 6.01208 39.877 6.01208C41.2543 6.01208 42.3107 6.63976 42.8766 7.87608V6.20229H44.499V15.7125H42.8766Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M31.9313 10.1015V15.7125H30.3467V6.20234H31.9313V7.87613C32.4784 6.75393 33.4216 5.95507 35.2703 6.0692V7.66691C33.1952 7.45768 31.9313 8.08535 31.9313 10.1015Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M25.9736 3.69164C25.9736 2.96886 26.4452 2.55042 27.1055 2.55042C27.7657 2.55042 28.2374 2.96886 28.2374 3.69164C28.2374 4.41442 27.7657 4.83287 27.1055 4.83287C26.4452 4.83287 25.9736 4.41442 25.9736 3.69164ZM26.2755 15.7125V6.20234H27.8978V15.7125H26.2755Z",
                                fill: "#E2E3E4"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M22.3214 12.0225V3.21606H24.0192V11.9084C24.0192 14.2098 23.0194 15.7885 20.6802 15.7885C19.7935 15.7885 19.1144 15.6363 18.6428 15.4652V13.8104C19.1522 14.0196 19.7747 14.1337 20.3972 14.1337C21.8309 14.1337 22.3214 13.2588 22.3214 12.0225Z",
                                fill: "#E2E3E4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_1258_173086",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "130",
                        height: "39.6947",
                        fill: "white"
                    })
                })
            })
        ]
    });





const $ceff1fa477ed0862$export$3a6e642edb89de35 = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "130",
        height: "40",
        viewBox: "0 0 130 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#clip0_906_52755)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                        id: "mask0_906_52755",
                        style: {
                            maskType: 'luminance'
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "130",
                        height: "40",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M130 0H0V39.6947H130V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                        mask: "url(#mask0_906_52755)",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                                id: "mask1_906_52755",
                                style: {
                                    maskType: 'luminance'
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "1",
                                width: "14",
                                height: "18",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M13.8944 1.65393H0V18.028H13.8944V1.65393Z",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                                mask: "url(#mask1_906_52755)",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                    d: "M8.68839 8.09373H13.1939C13.8706 8.09373 14.1016 8.74269 13.689 9.25856L6.64189 18.028C4.36439 16.1976 4.57891 13.3021 6.24582 11.1888L8.68839 8.09373ZM5.20607 11.5882H0.700536C0.0238782 11.5882 -0.207175 10.9392 0.20542 10.4233L7.25257 1.65393C9.53007 3.48436 9.28253 6.3465 7.63215 8.47645L5.20607 11.5882Z",
                                    fill: "#1868DB"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M127.245 31.7848C127.245 32.6217 127.736 33.1924 128.736 33.1924C129.113 33.1924 129.471 33.1163 129.754 33.0592V34.6379C129.471 34.714 129.151 34.7901 128.66 34.7901C126.642 34.7901 125.661 33.5918 125.661 31.8229V26.7445H124.133V25.2228H125.661V23.2067H127.245V25.2228H129.754V26.7445H127.245V31.7848Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M122.736 29.1598V34.7327H121.114V28.9886C121.114 27.2768 120.435 26.5159 118.888 26.5159C117.379 26.5159 116.341 27.524 116.341 29.4451V34.7327H114.719V25.2226H116.341V26.7822C116.945 25.66 118.058 25.0323 119.322 25.0323C121.491 25.0323 122.736 26.535 122.736 29.1598Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M108.638 26.5159C106.922 26.5159 106.054 27.6381 105.884 29.2929H111.147C111.053 27.524 110.261 26.5159 108.638 26.5159ZM112.26 34.3523C111.487 34.7708 110.298 34.9229 109.336 34.9229C105.809 34.9229 104.262 32.8687 104.262 29.9586C104.262 27.0865 105.846 25.0323 108.714 25.0323C111.619 25.0323 112.788 27.0675 112.788 29.9586V30.7004H105.903C106.129 32.3171 107.167 33.3633 109.393 33.3633C110.487 33.3633 111.411 33.154 112.26 32.8497V34.3523Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M96.1736 29.4451V34.7327H94.5513V28.9886C94.5513 27.2768 93.8721 26.5159 92.3253 26.5159C90.8161 26.5159 89.7786 27.524 89.7786 29.4451V34.7327H88.1562V25.2226H89.7786V26.7822C90.3822 25.66 91.4952 25.0323 92.7592 25.0323C94.3626 25.0323 95.4568 25.8502 95.9284 27.3528C96.4566 25.8883 97.7205 25.0323 99.2862 25.0323C101.399 25.0323 102.569 26.4779 102.569 29.1598V34.7327H100.946V29.4451C100.946 27.486 100.267 26.5159 98.7203 26.5159C97.2111 26.5159 96.1736 27.524 96.1736 29.4451Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M82.0718 26.5159C80.3552 26.5159 79.4874 27.6381 79.3177 29.2929H84.5808C84.4865 27.524 83.6942 26.5159 82.0718 26.5159ZM85.6938 34.3523C84.9204 34.7708 83.7319 34.9229 82.7698 34.9229C79.2422 34.9229 77.6953 32.8687 77.6953 29.9586C77.6953 27.0865 79.2799 25.0323 82.1473 25.0323C85.0524 25.0323 86.222 27.0675 86.222 29.9586V30.7004H79.3365C79.5629 32.3171 80.6004 33.3633 82.8264 33.3633C83.9206 33.3633 84.8449 33.154 85.6938 32.8497V34.3523Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M74.2318 33.9719V33.0209C73.6282 34.2762 72.4963 34.9229 71.0437 34.9229C68.5536 34.9229 67.3086 32.7736 67.3086 29.9776C67.3086 27.2958 68.6102 25.0323 71.2324 25.0323C72.6095 25.0323 73.6659 25.66 74.2318 26.8963V25.2226H75.8164V33.8768C75.8164 36.6728 74.5148 38.5558 71.1381 38.5558C69.5535 38.5558 68.6857 38.3466 67.7802 38.0423V36.4446C68.8177 36.7869 69.893 37.0152 71.0626 37.0152C73.4206 37.0152 74.2318 35.7408 74.2318 33.9719ZM68.8932 29.9776C68.8932 32.2601 69.7987 33.4013 71.4776 33.4013C72.9302 33.4013 74.2318 32.4693 74.2318 30.358V29.5972C74.2318 27.486 73.0434 26.554 71.6663 26.554C69.8364 26.554 68.8932 27.7713 68.8932 29.9776Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.4661 29.9776C58.4661 32.2601 59.3716 33.4013 61.0505 33.4013C62.5031 33.4013 63.8047 32.4693 63.8047 30.358V29.5972C63.8047 27.486 62.6162 26.554 61.2391 26.554C59.4093 26.554 58.4661 27.7713 58.4661 29.9776ZM63.8047 34.7327V33.0209C63.201 34.2762 62.0692 34.9229 60.6166 34.9229C58.1077 34.9229 56.8438 32.7736 56.8438 29.9776C56.8438 27.2958 58.1643 25.0323 60.8053 25.0323C62.1824 25.0323 63.2388 25.66 63.8047 26.8963V25.2226H65.427V34.7327H63.8047Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M55.1463 29.1598V34.7327H53.5239V28.9886C53.5239 27.2768 52.8448 26.5159 51.2979 26.5159C49.7888 26.5159 48.7512 27.524 48.7512 29.4451V34.7327H47.1289V25.2226H48.7512V26.7822C49.3549 25.66 50.4679 25.0323 51.7318 25.0323C53.9012 25.0323 55.1463 26.535 55.1463 29.1598Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.7239 29.9776C37.7239 32.2601 38.6294 33.4013 40.3083 33.4013C41.7609 33.4013 43.0626 32.4693 43.0626 30.358V29.5972C43.0626 27.486 41.8741 26.554 40.497 26.554C38.6671 26.554 37.7239 27.7713 37.7239 29.9776ZM43.0626 34.7327V33.0209C42.4589 34.2762 41.3271 34.9229 39.8744 34.9229C37.3655 34.9229 36.1016 32.7736 36.1016 29.9776C36.1016 27.2958 37.4221 25.0323 40.0631 25.0323C41.4403 25.0323 42.4967 25.66 43.0626 26.8963V25.2226H44.6849V34.7327H43.0626Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M23.7159 27.9045L22.0181 23.2635V34.7328H20.3203V22.2365H23.2632L26.0739 29.4071L27.2247 32.8498L28.3754 29.4071L31.205 22.2365H33.9404V34.7328H32.2426V23.3967L30.79 27.9045L28.0547 34.7328H26.4135L23.7159 27.9045Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M102.892 7.49543C101.175 7.49543 100.308 8.61763 100.138 10.2724H105.401C105.307 8.50351 104.514 7.49543 102.892 7.49543ZM106.514 15.3318C105.741 15.7503 104.552 15.9024 103.59 15.9024C100.062 15.9024 98.5156 13.8482 98.5156 10.9381C98.5156 8.06604 100.1 6.01184 102.968 6.01184C105.873 6.01184 107.042 8.04702 107.042 10.9381V11.6799H100.157C100.383 13.2966 101.421 14.3428 103.647 14.3428C104.741 14.3428 105.665 14.1335 106.514 13.8292V15.3318Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M97.229 14.0004V15.465C96.663 15.7693 95.7953 15.9024 94.9275 15.9024C91.5697 15.9024 90.0039 13.8482 90.0039 10.9381C90.0039 8.06604 91.5697 6.01184 94.9275 6.01184C95.7764 6.01184 96.4367 6.12596 97.1724 6.46833V7.98996C96.5687 7.70465 95.9273 7.53347 95.0407 7.53347C92.5883 7.53347 91.5885 9.09314 91.5885 10.9381C91.5885 12.7831 92.6072 14.3428 95.0784 14.3428C96.0405 14.3428 96.6442 14.2096 97.229 14.0004Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M86.1953 3.69164C86.1953 2.96886 86.6669 2.55042 87.3272 2.55042C87.9874 2.55042 88.459 2.96886 88.459 3.69164C88.459 4.41442 87.9874 4.83287 87.3272 4.83287C86.6669 4.83287 86.1953 4.41442 86.1953 3.69164ZM86.4971 15.7125V6.20234H88.1195V15.7125H86.4971Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M81.4346 15.7124H79.2652L75.6055 6.20227H77.3033L80.3593 14.324L83.3964 6.20227H85.0942L81.4346 15.7124Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M71.9245 10.1014V15.7124H70.3398V6.20222H71.9245V7.87601C72.4715 6.75381 73.4147 5.95495 75.2634 6.06907V7.66679C73.1884 7.45756 71.9245 8.08523 71.9245 10.1014Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M64.2593 7.49567C62.5427 7.49567 61.6749 8.61787 61.5051 10.2726H66.7683C66.674 8.50375 65.8817 7.49567 64.2593 7.49567ZM67.8813 15.3321C67.1079 15.7505 65.9194 15.9027 64.9573 15.9027C61.4297 15.9027 59.8828 13.8485 59.8828 10.9384C59.8828 8.06628 61.4674 6.01208 64.3348 6.01208C67.2399 6.01208 68.4095 8.04726 68.4095 10.9384V11.6802H61.524C61.7504 13.2969 62.7879 14.343 65.0139 14.343C66.108 14.343 67.0324 14.1338 67.8813 13.8295V15.3321Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M58.4535 12.2699C58.4535 14.4382 57.1707 15.9028 54.0959 15.9028C51.7001 15.9028 50.5871 15.4273 49.625 14.9328V13.1829C50.7757 13.7915 52.549 14.229 54.1902 14.229C56.0577 14.229 56.7557 13.4872 56.7557 12.384C56.7557 11.2808 56.0766 10.6912 53.7186 10.1206C50.9266 9.43587 49.6816 8.46584 49.6816 6.41164C49.6816 4.47156 51.153 3.026 54.0393 3.026C55.8314 3.026 56.9821 3.46347 57.831 3.93898V5.65082C56.5859 4.92805 55.2466 4.6998 53.9638 4.6998C52.3415 4.6998 51.3794 5.27042 51.3794 6.41164C51.3794 7.43874 52.1717 7.95229 54.36 8.50388C56.9821 9.16959 58.4535 10.0255 58.4535 12.2699Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.5364 10.9571C37.5364 13.2396 38.4419 14.3808 40.1208 14.3808C41.5735 14.3808 42.8752 13.4488 42.8752 11.3375V10.5767C42.8752 8.46547 41.6867 7.53347 40.3095 7.53347C38.4796 7.53347 37.5364 8.75077 37.5364 10.9571ZM42.8752 15.7122V14.0004C42.2715 15.2557 41.1397 15.9024 39.6869 15.9024C37.178 15.9024 35.9141 13.7531 35.9141 10.9571C35.9141 8.27526 37.2346 6.01184 39.8756 6.01184C41.2528 6.01184 42.3092 6.63951 42.8752 7.87584V6.20204H44.4975V15.7122H42.8752Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M31.9323 10.1014V15.7124H30.3477V6.20222H31.9323V7.87601C32.4793 6.75381 33.4225 5.95495 35.2713 6.06907V7.66679C33.1962 7.45756 31.9323 8.08523 31.9323 10.1014Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M25.9727 3.69164C25.9727 2.96886 26.4443 2.55042 27.1045 2.55042C27.7648 2.55042 28.2364 2.96886 28.2364 3.69164C28.2364 4.41442 27.7648 4.83287 27.1045 4.83287C26.4443 4.83287 25.9727 4.41442 25.9727 3.69164ZM26.2745 15.7125V6.20234H27.8968V15.7125H26.2745Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M22.3231 12.0224V3.21594H24.0209V11.9082C24.0209 14.2097 23.0211 15.7884 20.6819 15.7884C19.7953 15.7884 19.1161 15.6362 18.6445 15.465V13.8103C19.1539 14.0195 19.7764 14.1336 20.3989 14.1336C21.8326 14.1336 22.3231 13.2587 22.3231 12.0224Z",
                                fill: "#101214"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_906_52755",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "130",
                        height: "39.6947",
                        fill: "white"
                    })
                })
            })
        ]
    });


const $659bcacf438a9fb5$var$jsmLogoByTheme = (colorMode)=>{
    return colorMode === 'light' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ceff1fa477ed0862$export$3a6e642edb89de35), {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6726bcc641ae4767$export$5a3585ff193409c7), {});
};
const $659bcacf438a9fb5$export$b3890eb0ae9dca99 = (0, $3c8f093dca8dd302$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b6f6411acbf62b1$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-servicedesk.ondemand',
            ccpProductId: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
            logo: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                role: "img",
                "aria-label": intl.formatMessage({
                    id: "post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Service Management Product Logo"
                }),
                children: $659bcacf438a9fb5$var$jsmLogoByTheme(colorMode || 'light')
            }),
            header: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsm.confluence-home-banner.header",
                defaultMessage: "See the whole picture, from request to resolution"
            }),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsm.confluence-home-banner.description",
                defaultMessage: "Automatically turn Slack, Teams, and email requests into tickets."
            })
        },
        onDismissed: onDismissed
    });
});
var $659bcacf438a9fb5$export$2e2bcd8739ae039 = $659bcacf438a9fb5$export$b3890eb0ae9dca99;






var $0VqrM = parcelRequire("0VqrM");


parcelRequire("cozmU");







const $438493ab41aa05c6$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $438493ab41aa05c6$export$78c758434c34d601 = $438493ab41aa05c6$var$clientPipeline.createRender;
const $438493ab41aa05c6$export$2859a83e4d6da57d = $438493ab41aa05c6$var$clientPipeline.createValidate;
const $438493ab41aa05c6$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $438493ab41aa05c6$export$c905bc718befd59b = $438493ab41aa05c6$var$serverPipeline.createHydrate;
const $438493ab41aa05c6$export$1f41223e5b0a6622 = $438493ab41aa05c6$var$serverPipeline.createHydrateExample;
const $438493ab41aa05c6$export$88fe13b4d13f8423 = $438493ab41aa05c6$var$serverPipeline.createTransformMetadata;


const $0b4a42c729534a5d$export$b3890eb0ae9dca99 = (0, $438493ab41aa05c6$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b6f6411acbf62b1$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-software.ondemand',
            ccpProductId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
            logo: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0VqrM.JiraLogoCS), {
                size: "small",
                appearance: "brand",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header",
                defaultMessage: "Sync real-time data from Jira to any document in Confluence"
            }),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description",
                defaultMessage: "See analytics and insights about what your team is working on at any moment"
            })
        },
        onDismissed: onDismissed
    });
});
var $0b4a42c729534a5d$export$2e2bcd8739ae039 = $0b4a42c729534a5d$export$b3890eb0ae9dca99;









parcelRequire("cozmU");







const $795338d7a7be5d71$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $795338d7a7be5d71$export$78c758434c34d601 = $795338d7a7be5d71$var$clientPipeline.createRender;
const $795338d7a7be5d71$export$2859a83e4d6da57d = $795338d7a7be5d71$var$clientPipeline.createValidate;
const $795338d7a7be5d71$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $795338d7a7be5d71$export$c905bc718befd59b = $795338d7a7be5d71$var$serverPipeline.createHydrate;
const $795338d7a7be5d71$export$1f41223e5b0a6622 = $795338d7a7be5d71$var$serverPipeline.createHydrateExample;
const $795338d7a7be5d71$export$88fe13b4d13f8423 = $795338d7a7be5d71$var$serverPipeline.createTransformMetadata;


const $264e42aee34d1df1$export$b3890eb0ae9dca99 = (0, $795338d7a7be5d71$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b6f6411acbf62b1$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: 'jira-software.ondemand',
            ccpProductId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
            logo: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0VqrM.JiraLogoCS), {
                size: "small",
                appearance: "brand",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header",
                defaultMessage: "Build world-class products, fast"
            }),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description",
                defaultMessage: "76% customers shipped projects faster after adding Confluence and Jira."
            })
        },
        onDismissed: onDismissed
    });
});
var $264e42aee34d1df1$export$2e2bcd8739ae039 = $264e42aee34d1df1$export$b3890eb0ae9dca99;









parcelRequire("cozmU");







const $18772a4b5ba84228$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $18772a4b5ba84228$export$78c758434c34d601 = $18772a4b5ba84228$var$clientPipeline.createRender;
const $18772a4b5ba84228$export$2859a83e4d6da57d = $18772a4b5ba84228$var$clientPipeline.createValidate;
const $18772a4b5ba84228$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $18772a4b5ba84228$export$c905bc718befd59b = $18772a4b5ba84228$var$serverPipeline.createHydrate;
const $18772a4b5ba84228$export$1f41223e5b0a6622 = $18772a4b5ba84228$var$serverPipeline.createHydrateExample;
const $18772a4b5ba84228$export$88fe13b4d13f8423 = $18772a4b5ba84228$var$serverPipeline.createTransformMetadata;


const $7f55443a83900db0$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $7f55443a83900db0$export$5fca8a2477be63d = 'jira-software.ondemand';
const $7f55443a83900db0$export$a75e537c279a265a = 'Jira';


const $608151e147d50e0c$export$b3890eb0ae9dca99 = (0, $18772a4b5ba84228$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b6f6411acbf62b1$export$486c30dd11c42f3), {
        app: {
            hamsIdentifier: (0, $7f55443a83900db0$export$5fca8a2477be63d),
            ccpProductId: (0, $7f55443a83900db0$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0VqrM.JiraLogoCS), {
                appearance: "brand",
                size: "small",
                label: intl.formatMessage({
                    id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text",
                    defaultMessage: "Jira Product Logo"
                })
            }),
            header: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header",
                defaultMessage: "Visualize any project in a list, board, backlog, and more"
            }),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description",
                defaultMessage: "Jira lets you view your project and tasks in a way that works for you and your team."
            })
        },
        onDismissed: onDismissed
    });
});
var $608151e147d50e0c$export$2e2bcd8739ae039 = $608151e147d50e0c$export$b3890eb0ae9dca99;








const $7564adfca26758a7$var$clientPipeline = (0, $b2eRs.createClientPipeline)();
const $7564adfca26758a7$export$78c758434c34d601 = $7564adfca26758a7$var$clientPipeline.createRender;
const $7564adfca26758a7$export$2859a83e4d6da57d = $7564adfca26758a7$var$clientPipeline.createValidate;
const $7564adfca26758a7$var$serverPipeline = (0, $b2eRs.createServerPipeline)();
const $7564adfca26758a7$export$c905bc718befd59b = $7564adfca26758a7$var$serverPipeline.createHydrate;
const $7564adfca26758a7$export$1f41223e5b0a6622 = $7564adfca26758a7$var$serverPipeline.createHydrateExample;
const $7564adfca26758a7$export$88fe13b4d13f8423 = $7564adfca26758a7$var$serverPipeline.createTransformMetadata;


const $4dca2c76b45fa149$export$b3890eb0ae9dca99 = (0, $7564adfca26758a7$export$78c758434c34d601)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)("button", {
        children: "This is an example test button"
    }));
var $4dca2c76b45fa149$export$2e2bcd8739ae039 = $4dca2c76b45fa149$export$b3890eb0ae9dca99;


const $1ed54553f84f8f6e$export$e30378e28ad3e6ab = {
    'confluence-rovo-awareness-home-banner': (0, $468519a303fee8de$export$2e2bcd8739ae039),
    'message-template-template': (0, $aa41f63d4b035ba7$export$2e2bcd8739ae039),
    'recommendation-jpd': (0, $e5b0108a4d2c8c2c$export$2e2bcd8739ae039),
    'recommendation-jsm': (0, $659bcacf438a9fb5$export$2e2bcd8739ae039),
    'recommendation-jsw-real-time-updates': (0, $0b4a42c729534a5d$export$2e2bcd8739ae039),
    'recommendation-jsw-tech-teams': (0, $264e42aee34d1df1$export$2e2bcd8739ae039),
    'recommendation-jsw-visualize-work': (0, $608151e147d50e0c$export$2e2bcd8739ae039),
    'test-message-inapp': (0, $4dca2c76b45fa149$export$2e2bcd8739ae039)
};
const $1ed54553f84f8f6e$var$messageRenderer = (0, $2tp0D.asMessageRenderer)($1ed54553f84f8f6e$export$e30378e28ad3e6ab, 'confluence-home-banner');
const $1ed54553f84f8f6e$export$bce4e5106d86e473 = $1ed54553f84f8f6e$var$messageRenderer.initializeMessageRenderer;
const $1ed54553f84f8f6e$export$2df1250b8f917a59 = $1ed54553f84f8f6e$var$messageRenderer.MessageRenderer;


/* GeneratedContentHash: 31aea97eca3fb427d03f67c1f7441dc55b0c7dddfeed2b93043e44c5ef7e2378 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $6a6f0d4cb0250ffc$export$a5cfae247d8360ef = 'confluence-home-banner';


const $7231f940d5139130$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
/**
 * Confluence Home Banner does not have IntlProvider, all it's translations are managed by Confluence
 *
 * @see confluence/next/packages/i18n/src/messages.ts
 */ const $7231f940d5139130$var$ConfluenceHomeBanner = (0, $6U5eU.createPlacementComponent)((0, $6a6f0d4cb0250ffc$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $cozmU.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData })=>{
    const { data: data, isLoading: isLoading } = (0, $5KMtM.useInitialData)(initialData);
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents, @typescript-eslint/no-unsafe-assignment
    const [{ message: message, status: status }, setMessageState] = (0, $cozmU.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            message: preloadedInitialData?.messages[0],
            status: 'done'
        } : {
            message: undefined,
            status: 'done'
        };
        return {
            message: undefined,
            status: 'loading'
        };
    });
    const handleOnDismissed = (0, $cozmU.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    const isDone = status === 'done';
    (0, $cozmU.useEffect)(()=>{
        if (!isLoading && !isDone) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const newMessage = (data?.messages || []).filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            (dataMessage)=>!$7231f940d5139130$var$excludedMessages.has(dataMessage.messageTemplateId))[0];
            setMessageState({
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        isLoading,
        isDone,
        data
    ]);
    if (status === 'loading') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bf2b3f9711f917e5$export$a762e2300443622e), {});
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: message && // Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
        // This error exists because confluence is using react 16 and post-office is using react 18
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1ed54553f84f8f6e$export$2df1250b8f917a59), {
            ...message,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            id: message.messageInstanceId,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            messageInstanceId: message.messageInstanceId,
            onDismissed: handleOnDismissed,
            SuspenseBoundary: (0, $2tp0D.MaybeSuspenseBoundary)
        })
    });
}), {
    choreographer: {
        // Disabling this placement from being choreographed as it is not a pop-up
        isDefaultEnabled: false
    }
});
var $7231f940d5139130$export$2e2bcd8739ae039 = $7231f940d5139130$var$ConfluenceHomeBanner;



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $5kbLE = parcelRequire("5kbLE");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $luv00 = parcelRequire("luv00");

const $158bb15665e24ab2$export$56a6785e0b5d9ed3 = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const [preloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('confluence-home-banner');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const memoizedPlacementProps = (0, $cozmU.useMemo)(()=>({
            preloadedInitialData: preloadedInitialData
        }), [
        preloadedInitialData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "banner",
        "data-testid": "confluence-home-banner-placement",
        "data-vc": "confluence-home-banner-placement",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kbLE.default), {
        placementId: "confluence-home-banner",
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $7231f940d5139130$export$2e2bcd8739ae039),
        placementProps: memoizedPlacementProps,
        disableInitialData: Boolean(preloadedInitialData)
    })));
});
const $158bb15665e24ab2$export$56f554239fdb8ec2 = /*#__PURE__*/ (0, $cozmU.memo)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).POST_OFFICE
})($158bb15665e24ab2$export$56a6785e0b5d9ed3));
module.exports["PostOfficeHomeBanner"] = $158bb15665e24ab2$export$56f554239fdb8ec2;

});

parcelRegister("5mBfb", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");


var $lEClu = parcelRequire("lEClu");


var $a6XTh = parcelRequire("a6XTh");

const $77da95ec918c18a4$export$6f0e577fcefa598a = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { feedTypeOverride: feedTypeOverride } = (0, $fJ5kL.useFeedTypeOverride)();
    const { loading: loadingPreferences, feedType: feedType, hasSelectedFeedTypePreference: hasSelectedFeedTypePreference } = (0, $fJ5kL.useFeedTypeSelector)();
    const filterOrOverride = feedTypeOverride || feedType;
    const { followingFeedQuery: followingFeedQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const { popularFeedQuery: popularFeedQuery } = (0, $a6XTh.usePopularFeedWithTimeGranularityStorage)(true);
    // If the user is not logged in, they should not see the feed section. So we don't need to check if the feed is empty.
    if (!isLoggedIn) return {
        hasFeed: false
    };
    if (loadingPreferences) return {
        hasFeed: false
    };
    const hasFollowingFeed = !followingFeedQuery?.loading && Boolean(followingFeedQuery?.data?.feed?.nodes?.length);
    const hasPopularFeed = !popularFeedQuery?.loading && Boolean(popularFeedQuery?.data?.popularFeed?.nodes?.length);
    // If user has NOT selected a feed type preference, we default to checking if the user has any FOLLOWING feed first, and then POPULAR if there's no FOLLOWING.
    if (!hasSelectedFeedTypePreference) return {
        hasFeed: hasFollowingFeed || hasPopularFeed
    };
    // If user has selected a feed type preference, we first check if the overridden type is POPULAr
    if (filterOrOverride === (0, $4yg2A.FeedType).POPULAR) return {
        hasFeed: hasPopularFeed
    };
    // Otherwise, we default to checking if the user has any FOLLOWING feed
    return {
        hasFeed: hasFollowingFeed
    };
};


const $cb59cf9c5f23b9f9$export$486f604e62b3473b = ()=>{
    const { hasFeed: hasFeed } = (0, $77da95ec918c18a4$export$6f0e577fcefa598a)();
    return {
        isEligible: hasFeed
    };
};
module.exports["usePostOfficeHomeBannerEligible"] = $cb59cf9c5f23b9f9$export$486f604e62b3473b;

});

parcelRegister("h1Vf7", function(module, exports) {

var $5amEx = parcelRequire("5amEx");


var $lU1qY = parcelRequire("lU1qY");


var $lkQRq = parcelRequire("lkQRq");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");




const $3262dd47c4d650d8$var$useHomeWidgetStateQuery = (0, $lkQRq.default);
const $3262dd47c4d650d8$var$useHomeWidgetStateHomeWidgetsMutation = (0, $lU1qY.default);
const $3262dd47c4d650d8$export$86296873b62c42c0 = (id, defaultState, initialStateOverride)=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($3262dd47c4d650d8$var$useHomeWidgetStateQuery, {
        errorPolicy: 'all',
        // Use cache-first for both licensed and unlicensed users to allow cache reads
        fetchPolicy: 'cache-first',
        __callerPackage__: "home"
    });
    const [updateWidgetState, { error: mutationError }] = (0, $308Wd.useMutationInterop)($3262dd47c4d650d8$var$useHomeWidgetStateHomeWidgetsMutation, {
        __callerPackage__: "home"
    });
    const [stateOverride, setStateOverride] = (0, $cozmU.useState)(initialStateOverride);
    (0, $cozmU.useEffect)(()=>{
        setStateOverride(initialStateOverride);
    }, [
        initialStateOverride
    ]);
    // Use the widget state override, falling back to saved prefrence, falling back to defaultState, falling back to collapsed
    const widgetState = stateOverride || data?.userPreferences?.homeWidgets.find((widget)=>widget.id === id)?.state || defaultState || 'COLLAPSED';
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $5amEx.default),
        fragmentSpec: (0, $5amEx.default),
        __callerPackage__: "home"
    });
    const setWidgetState = (0, $cozmU.useCallback)((newState)=>{
        if (isLicensed) updateWidgetState({
            variables: {
                id: id,
                state: newState
            }
        });
        const homeWidgets = (data?.userPreferences?.homeWidgets || []).filter((widget)=>widget.id !== id);
        homeWidgets.push({
            id: id,
            state: newState,
            __typename: 'HomeWidget'
        });
        /**
     * This write into cache serves two purposes:
     *   1. To initially populate the cache in the case where
     *      a preference hasn't yet been saved or the user is unlicensed.
     *   2. To optimistically update the cache, since we're doing #1 anyway
     */ writeFragmentInterop({
            fragmentId: '$ROOT_QUERY.userPreferences',
            data: {
                homeWidgets: homeWidgets,
                __typename: 'UserPreferences'
            }
        });
        // After the user explicitly changes state, clear the state override
        setStateOverride(undefined);
    }, [
        id,
        data,
        isLicensed,
        updateWidgetState,
        writeFragmentInterop
    ]);
    const error = mutationError || queryError;
    return {
        widgetState: widgetState,
        setWidgetState: setWidgetState,
        loading: loading,
        error: error
    };
};
module.exports["useHomeWidgetState"] = $3262dd47c4d650d8$export$86296873b62c42c0;

});

parcelRegister("dR5is", function(module, exports) {
/* PTV2TemplateCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");


var $dinVW = parcelRequire("dinVW");


var $hBYtq = parcelRequire("hBYtq");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");

const $a3d10785a39c94e2$var$i18n = (0, $kSwu1.defineMessages)({
    usedBefore: {
        id: "experiment-personalized-templates-v2.template-list.template-card.used-before",
        defaultMessage: "{count, plural, one {Used {count} time before} other {Used {count} times before}}"
    },
    notUsedYet: {
        id: "experiment-personalized-templates-v2.template-list.template-card.havent-used-before",
        defaultMessage: "Not used yet"
    }
});
const $a3d10785a39c94e2$var$styles = {
    borderStyles: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM",
    containerStyles: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0Voaux _0KLXrunmFW _2Zuz6Q5zaO _0Of8r25zaO _1Znuxb5zaO _24h04i2Njc _1eOmH6o126",
    contentContainerStyles: "_2mHwu85zaO _0jFU0VN91d _2fwxA57p2s",
    imageContainerStyles: "_4bt5LAnQyn _2WAcuGnQyn _2V7sgOdnbC _0jFU0VaXQy _39xV02N91d _2C2kUQKxmn _1Lz9loKxmn",
    pressableStyles: "_4FKVYEPgdg _2XghbEPgdg _0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VN91d _0KLXrujOvk",
    iconContainerStyles: "_4FKVYE2ADO _0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8",
    headerStyles: "_2mHwu88HPE _0hPCNLDIqT"
};
const $a3d10785a39c94e2$export$bc66431553f37afa = ({ title: title, subTitle: subTitle, onClick: onClick, icon: icon, image: image, usage: usage })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const rernderedSubTitle = usage && isHovered ? formatMessage($a3d10785a39c94e2$var$i18n.usedBefore, {
        count: usage
    }) : subTitle;
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: "ptv2-template-card-button",
        xcss: (0, $w6R6I.cx)($a3d10785a39c94e2$var$styles.pressableStyles, $a3d10785a39c94e2$var$styles.borderStyles),
        onClick: onClick,
        role: "link"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $a3d10785a39c94e2$var$styles.containerStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $a3d10785a39c94e2$var$styles.contentContainerStyles,
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: $a3d10785a39c94e2$var$styles.headerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $a3d10785a39c94e2$var$styles.iconContainerStyles
    }, icon), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1,
        weight: "bold"
    }, title), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1,
        color: "color.text.subtlest",
        size: "small"
    }, rernderedSubTitle))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $a3d10785a39c94e2$var$styles.imageContainerStyles
        ])
    }, image))));
};
module.exports["PTV2TemplateCard"] = $a3d10785a39c94e2$export$bc66431553f37afa;

});

parcelRegister("34yV7", function(module, exports) {

var $aZID8 = parcelRequire("aZID8");


var $8E5P5 = parcelRequire("8E5P5");

const $b9d52551482b648b$export$e272c57b679d644 = `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/`;
const $b9d52551482b648b$export$343b29b08adb8468 = 'https://dam-cdn.atl.orangelogic.com/AssetLink/24jio0s0f10wt00f100x8ka51g80147d.png';
const $b9d52551482b648b$export$e6bc61fd26441f1d = 'https://dam-cdn.atl.orangelogic.com/AssetLink/ka6xb0k673ogce3fr8663jhc11v815cv.svg';
const $b9d52551482b648b$export$ff18b1f7218e1365 = {
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v775766xlw833sa16cqlc03tuw1tflc2.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gt8mxd565jnlxpcla58q6fik18u0o5b2.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/286roqo0x24518bmu83f668tu5dvgms2.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/em34t20hd3k5d3y5lou7ac3pt8nwh53w.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hhhhhjyr0k0tkwqj64550117ytp50i1e.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v4n83g7myc10be1f0uahh76jls455i8u.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54i677d21ed42r1d7ws1bfd37nwf36s8.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/16065dh57ba4b022x51r0tkqbd28dl87.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26814iat2a7ndfjrs0uq5i2g0x72867y.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o7sw2x42srn06s00a0esiq788283341p.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hu6yl738y22o50t0pr2vo4o05wan62n1.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0dn87kk6o66hvf420nfqjg45615k4m73.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d765023oqb4btu13pj7wdw5343wx6vv.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8i66o10j7qu27884l2c3si1xh0335w14.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l5343a3n0485ax1nh434373xq8g5l6s7.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e1c2vi1r8376b5t834kd607uqt0ymyp.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cm3igo2rky6iip0h1t3wy67pek85mla5.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6a51tvn7g1o3tl3vqvg0nsb14p60w77d.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/76p747np1oon57pu221347ohfjvnm180.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/617mv306vsf7w6sp43b6w6pas8xt4djd.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5ks001pi5jng10bnv131n7nu0k40l3xo.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/370bf03j886cokvq31658l4l3w66wv6p.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30u4108cdrbb83082p01f6810dtf1of4.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w814j2a58v56xuxoi444u5biqctwlhub.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kl7cn5h28ysoc3ti2gwyx6025v2b2nac.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e56m4o21348hk5j226181v4elqwi0w1.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t520b6d576imhfl70je80l8x8d77bduo.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m3hvi182obpt68vrr0x32k7kpcn7j844.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b4gx5wo7fsn6we642b242q7188gsq386.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w2w6e854gvt71756v2q53318t6t3vei3.png',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u8b4i1104l3d762gb8023m1itq7l34x.svg'
};
const $b9d52551482b648b$export$72f354715b8d4636 = {
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8y8sc20314pf86r8887x1rh3j57t7v0m.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/a6x7e6e50ynr0m1117k686cu15f702xn.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g0o1ks846i88hr5a3b64682r5om4202q.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ywpy0ek1o1o4rwao564k64v15ex4618.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/31t5j2o00j2s7t5ew0n6pr4kp4phvt04.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o360h3o63u55epg1ai452ds5mms5i8x5.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ul7j8s4v6o2336il6a781m566t0rr6sc.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/715fur87612t53h5m4bwg11k5j5w3771.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t3mfg1hxryf30du04apjsn3rf6i53ujn.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nc8ogfbk5y7nugu56gy14cbk8564k4m1.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/650c73qh4cx735v8v40530xf4l5gr263.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7a32ce1yafkbwyroef6b5ty6y7684560.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mg40lr1ans63vk7t0rqwq53hx3mv3x0a.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8543ywanoenx7v0w2fo57874w081rs50.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dp08ln0x64w03f6855vt5k25xttu8y1y.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kpq78wcv70g231k70x6083uw1oj35x15.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qi6q25nj7657c511n5t06gu6a6cf7nk4.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dd47fnm3l1ngnqcie3ad4oj747251s37.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eu16r33866w646j52x351lpsceof0057.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g1um66bc1q5ia7x04gsdl0rgx87j6jvm.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fe1f2sv15s3q667sqp4w2l3271qp431y.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yxsr7cv8cc4ox20f6am0788u13tx8731.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dptnm3xu130487m1a3eo1y780g274c38.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ao2nw5gfffwms6j4w0fd07126007215.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i88nc0mpr1j8m2v045a7s6ik0x827ero.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i622u0u2h5d2o0b23abf1qx57h36p8a8.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x1687g5ye71fs1qfym3a653nls22g460.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/17uws3bph888pu42v71k12nbq27i4k5a.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1l6gk820v5e7h17h0y4b27sb4l5whvy3.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1hquucr1ec0b4l1ht06l68sh80r0rs4q.svg',
    [(0, $aZID8.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ltv22274128075mvb5h842f082vd35ik.svg'
};
const $b9d52551482b648b$export$c88a6d0afe4f1305 = {
    [(0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: '90-day-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'all-hands-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'annual-plan-one-pager',
    [(0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'executive-business-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'business-status-update',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'business-plan-one-pager',
    [(0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'career-development-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'competitive-analysis',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'content-design-glossary',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'content-strategy',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'customer-impact-assessment',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'customer-interview-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'decision',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION]: 'design-decision',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'design-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'design-sprint',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'design-system',
    [(0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'devops-runbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'employee-handbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'hr-knowledge-base',
    [(0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'how-to-article',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'itsm-known-errors',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'itsm-change-management',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'itsm-post-incident-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'itsm-runbook',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'incident-communication',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'incident-postmortem',
    [(0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'job-description',
    [(0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW]: 'lennys-performance-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS]: 'lennys-product-requirements',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN]: 'marketing-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES]: 'meeting-notes',
    [(0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'message-house',
    [(0, $8E5P5.BLUEPRINT_NAMES).OKRS]: 'okrs',
    [(0, $8E5P5.BLUEPRINT_NAMES).PERSONA]: 'persona',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE]: 'presenter-mode',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'product-requirements',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'product-roadmap',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'project-kickoff',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN]: 'project-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS]: 'project-status',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE]: 'project-timeline',
    [(0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'qtc-acquisition',
    [(0, $8E5P5.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'remote-team-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'risk-assessment',
    [(0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'roles-and-responsibilities',
    [(0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS]: 'smart-goals',
    [(0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'swot-analysis',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL]: 'sales-portal',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'sales-account-planning',
    [(0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW]: 'software-architecture-review',
    [(0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'sprint-planning-meeting',
    [(0, $8E5P5.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'stakeholder-communications',
    [(0, $8E5P5.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE]: 'sop',
    [(0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'strategic-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'team-homepage',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER]: 'team-poster',
    [(0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST]: 'to-do-list',
    [(0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'troubleshooting-article',
    [(0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'vendor-agreement',
    [(0, $8E5P5.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'virtual-event',
    [(0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'vision-to-values',
    [(0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'end-of-week-status-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'weekly-meeting-notes',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'work-trip-planner',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'workshop-planner',
    [(0, $8E5P5.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'writing-guidelines',
    [(0, $8E5P5.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'quarterly-check-in',
    [(0, $8E5P5.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'aws-architecture-diagram',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'marketing-blog-post',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'marketing-campaign',
    [(0, $8E5P5.BLUEPRINT_NAMES).HIRING_PROCESS]: 'hiring-process',
    [(0, $8E5P5.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'mutual-action-plan',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'itsm-weekly-major-incident-report',
    [(0, $8E5P5.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'disruptive-brainstorming'
};
const $b9d52551482b648b$var$blueprintsWithoutImages = new Set([
    (0, $8E5P5.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE,
    (0, $8E5P5.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE,
    (0, $8E5P5.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
    (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
    (0, $8E5P5.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS
]);
const $b9d52551482b648b$export$3e4521316af54a8c = Object.keys($b9d52551482b648b$export$c88a6d0afe4f1305).reduce((mappings, key)=>{
    mappings[key] = $b9d52551482b648b$var$blueprintsWithoutImages.has(key) ? $b9d52551482b648b$export$343b29b08adb8468 : `${$b9d52551482b648b$export$e272c57b679d644}${$b9d52551482b648b$export$c88a6d0afe4f1305[key]}.svg`;
    return mappings;
}, {});
const $b9d52551482b648b$export$5afae992b84a32d5 = {
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h4k3b710fj7203m0hj43j3cc425cuy76.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olpn6123xee0naxqm57sf3bpnr3mvglw.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_DECISION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1x53580r2xjt08816apkqrwq6g7ga107.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/juc54l2t2c16lx8k1g3e3q1076ckmfng.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e473ir7jdwlcoyls06uc04iim077741.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06ipqhy7no6d5ab6qrd7kqfhlggy2ni.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ayg5h2aq885e62ysr47865rg461uw2we.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ms2f3506w5a41lv6jk38ucy8882yky4e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1s4ovxh8tpsk74g33lmd4ujw0np3o731.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s8644uajks6cw0fj2o0q1e7tf645pjdq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q7243b5o3jvm6vo3504p7rc8o667pmy6.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g5y6q6oqf15txlpv1q2m53648sh1888w.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/843prjia43re78n53vh4f1nkvm5lbb43.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/waj1m80wt58g346m3bx1l82cq5fn785e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2sb43g4320785m6k44k8djm3d7487s01.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/871dux30tosjc8ipe18fr346rmqe4juf.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2atvs27hd5w232sg773008l3q2fssr4o.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eub8wfax8n446u54req1vvq0i5y4ai51.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l8c1g33u3a37qc73v4v0ple4bt7582u8.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q23316jb58686pa5na5l23hp4tmlym5q.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PERSONA]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3288qdj186qk418dt7p3fp5m1ngy1204.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3r6x6daq4gj0a8w55gv4l0mi0l2jq676.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55p8fe88y7345bq5o8ld1wo4b3s6x7fk.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/322w834s7iv5cv55sawmnvnj214165l8.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d154e06qu2wc6f4rvf24qn5q352ni5y5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x80i888ygwk623tn3b1i1ol70p7v7sa1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8wx1f2120m7qo2osbgh3m26o0h13b460.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3p11p1kfnqf1xtj2i6282pup7500v5v7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/07h8i0ldabdfh18e0f3406xfw32fk787.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/un7420lmym06873pxv6i7us28442i30e.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3lwqq2rfxv426g7op1js2b8470g26sfu.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/626r1r03m1i01w37o72r6y7n57t0plmq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRESENTER_MODE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x763b1j8e1y71f0lh286048tn6q30035.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36p554e65x6ub45035dacj50l08mjpo0.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p204067765c1yfd83im6hpt7cv4mfkc7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3sj6n68sjtf332lau0l627qr3ot3qe2v.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x2n21bdg03i16s3t16tprkv6537446s5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26a3wch8758m13o012m762xxv25ch8vg.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SMART_GOALS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2bf67v33y7f2ln226xipfru2n7kns60b.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c0i6b28xct78230ggb358m1047081ww5.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_POSTER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k4r783xvvwvviw60i728w66g3nl8a1sn.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ok5ycecnech333n2m582ix021r2jy65k.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rnr6dq077l1x5wx53q036arpk780f2p.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wmlg4wd6587651183as8031t301d4o85.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).TO_DO_LIST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1asf3cijux7ga204cbc7qg6ra367nhc7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ogmwu64w8pwoxp2ho80nd87kp2x2pa3g.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64524bi14mrls3rem07y1p25hkumv16u.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u0nub00c433fl778atn5yhgjoh782l13.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0i7w3ks85280ehvpr28lpu5yg3ja0a7.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7mx000d02pi8r2ueg3rw7v01lgbj55dp.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0wtr2h661307rsnsoolf1k4502semf22.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).OKRS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/363722lk1ks8ut57cxor25f1d0864170.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tt73e3c4016001x617mxxitl5g3u1n65.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0b2egux177m04b0dxo628v4m3s103460.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SALES_PORTAL]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j233apow7he8t03o2dn0o51g52mnw15j.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7cknim011u00041rmw2yw1vr3w65xan1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ek48h0gx82ks3j46480m6c6cu2h1e7wq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).PROJECT_STATUS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vwpc40ldd857guo662l34831851l8h1x.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vkq707lue205jypgy6kiy30u650u566x.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wldn3c51e68086nl43q8wpk1x8yrcg17.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d25x120oi2118101kxfmt10aqm2g8cvv.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j1bvq02m82l623fy575sd7of2djd7my.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3575i1013te6m8sp1xr08f54e8053egq.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xfw4001fj343b5k7fteg177lb3175blr.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/70u14cws7507hm18ak4lp7eq5k0a8582.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).HIRING_PROCESS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dc3418xr3v7522y6dv4gg636nmvf8y41.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gm7gxjca3f0i7eon74md67f57c0r3qq1.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/57ib28g38e3c0h5tj3ak5fxn3g2ppq7o.svg',
    [(0, $8E5P5.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/38dc3au247c7a030ya5c7f3ajp7131lq.svg'
};
module.exports["defaultImgSrc"] = $b9d52551482b648b$export$343b29b08adb8468;
module.exports["defaultDarkImgSrc"] = $b9d52551482b648b$export$e6bc61fd26441f1d;
module.exports["WHITEBOARD_TEMPLATE_TO_IMG_MAPPING"] = $b9d52551482b648b$export$ff18b1f7218e1365;
module.exports["WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING"] = $b9d52551482b648b$export$72f354715b8d4636;
module.exports["BLUEPRINT_NAME_TO_IMG_MAPPING"] = $b9d52551482b648b$export$3e4521316af54a8c;
module.exports["BLUEPRINT_IMG_MAP_DARK"] = $b9d52551482b648b$export$5afae992b84a32d5;

});

parcelRegister("lTWbV", function(module, exports) {
/* RecentWorkListItemLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxRuntime classic */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7vK9E = parcelRequire("7vK9E");


var $hBYtq = parcelRequire("hBYtq");

const $9af07245c4471ba3$var$styles = {
    listItem: "_0bjKvDKxmn _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _4kiQYAfI2J _46hvQm8HPE _0xmtko8HPE _0LQT5E5zaO _03SyCP5zaO _17lj8p8HPE _1eOmH6o126",
    coverLink: "_0bjKvDKxmn _1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _0KLXrujOvk",
    icon: "_0bjKvDKxmn _3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXruDMqu",
    content: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4ouGXIdnbC _42d1HAdnbC",
    secondary: "_2sNsIg7NXe _1UtDYzKGUX",
    lastModified: "_2sNsIg7NXe _3YEZNOdnbC _0GTcwR5zaO _1UtDYzKGUX _1ANEUSLRg7",
    actions: "_1mT5xdRAKS _42Yu6B7dHp _3YEZNOdnbC"
};
const $9af07245c4471ba3$export$9029d13a4b370b56 = ({ url: url, ariaLabel: ariaLabel, children: children, icon: icon, secondary: secondary, lastModified: lastModified, actions: actions, onClick: onClick, testId: testId })=>/*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.listItem
        ])
    }, url && /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        xcss: $9af07245c4471ba3$var$styles.coverLink,
        href: url,
        "aria-label": ariaLabel,
        onClick: onClick,
        draggable: false
    }), !url && onClick && /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $9af07245c4471ba3$var$styles.coverLink,
        "aria-label": ariaLabel,
        onClick: onClick
    }), icon && /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "list-item-icon",
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.icon
        ])
    }, icon), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.content
        ])
    }, children, secondary && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.secondary
        ])
    }, secondary)), lastModified && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.lastModified
        ])
    }, lastModified), actions && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9af07245c4471ba3$var$styles.actions
        ])
    }, actions));
module.exports["RecentWorkListItemLayout"] = $9af07245c4471ba3$export$9029d13a4b370b56;

});

parcelRegister("hA174", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b3ca3575e95bd557$export$2bfda787a2abf0c2 = (0, $kSwu1.defineMessages)({
    contentUntitled: {
        id: "entity-view.recent-work.content-untitled",
        defaultMessage: "Untitled"
    },
    contentTypePage: {
        id: "entity-view.recent-work.content-type.page",
        defaultMessage: "Page"
    },
    contentTypeLiveDoc: {
        id: "entity-view.recent-work.content-type.live-doc",
        defaultMessage: "Live doc"
    },
    contentTypeBlogPost: {
        id: "entity-view.recent-work.content-type.blog-post",
        defaultMessage: "Blog post"
    },
    contentTypeWhiteboard: {
        id: "entity-view.recent-work.content-type.whiteboard",
        defaultMessage: "Whiteboard"
    },
    contentTypeDatabase: {
        id: "entity-view.recent-work.content-type.database",
        defaultMessage: "Database"
    },
    contentTypeSmartLink: {
        id: "entity-view.recent-work.content-type.smart-link",
        defaultMessage: "Smart Link"
    },
    contentTypeSlide: {
        id: "entity-view.recent-work.content-type.slide",
        defaultMessage: "Slide"
    },
    agentSession: {
        id: "entity-view.recent-work.agent-session",
        defaultMessage: "Agent session"
    },
    chat: {
        id: "entity-view.recent-work.agent-session.chat",
        defaultMessage: "Chat"
    },
    working: {
        id: "entity-view.recent-work.agent-session.working",
        defaultMessage: "Working"
    },
    needsInput: {
        id: "entity-view.recent-work.agent-session.needs-input",
        defaultMessage: "Needs input"
    },
    finished: {
        id: "entity-view.recent-work.agent-session.finished",
        defaultMessage: "Finished"
    },
    rovoAgent: {
        id: "entity-view.recent-work.agent-session.rovo-agent",
        defaultMessage: "Rovo"
    }
});
module.exports["recentWorkMessages"] = $b3ca3575e95bd557$export$2bfda787a2abf0c2;

});

parcelRegister("e6wiu", function(module, exports) {
/* recentWorkContent.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxRuntime classic */ 
var $cozmU = parcelRequire("cozmU");


var $cSGyR = parcelRequire("cSGyR");


var $bCECL = parcelRequire("bCECL");


var $hA174 = parcelRequire("hA174");

const $befe57b5d5b5b9ac$var$getContentIconColor = (type, subType)=>{
    if (type === 'page' && subType === 'live' || type === 'liveDoc') return "var(--ds-icon-accent-magenta, #CD519D)";
    if (type === 'page' || type === 'blogpost') return "var(--ds-icon-accent-blue, #357DE8)";
    if (type === 'whiteboard' || type === 'slide') return "var(--ds-icon-accent-teal, #2898BD)";
    if (type === 'database') return "var(--ds-icon-accent-purple, #AF59E1)";
    if (type === 'embed') return "var(--ds-icon-accent-gray, #7D818A)";
    return undefined;
};
const $befe57b5d5b5b9ac$export$3fde1d23d659ad2b = (type, subType)=>{
    if (type === 'page' && subType === 'live' || type === 'liveDoc') return (0, $hA174.recentWorkMessages).contentTypeLiveDoc;
    const messages = {
        page: (0, $hA174.recentWorkMessages).contentTypePage,
        blogpost: (0, $hA174.recentWorkMessages).contentTypeBlogPost,
        whiteboard: (0, $hA174.recentWorkMessages).contentTypeWhiteboard,
        database: (0, $hA174.recentWorkMessages).contentTypeDatabase,
        embed: (0, $hA174.recentWorkMessages).contentTypeSmartLink,
        slide: (0, $hA174.recentWorkMessages).contentTypeSlide
    };
    return type ? messages[type] : undefined;
};
const $befe57b5d5b5b9ac$export$55d42216d2b1abe6 = (type, subType, emoji)=>emoji ? /*#__PURE__*/ $cozmU.createElement((0, $bCECL.ContentIcon), {
        type: type || '',
        subType: subType || '',
        emoji: emoji
    }) : type === 'embed' ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
        label: "",
        color: $befe57b5d5b5b9ac$var$getContentIconColor(type, subType),
        testId: "recent-work-smart-link-icon"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bCECL.ContentIcon), {
        type: type || '',
        subType: subType || '',
        color: $befe57b5d5b5b9ac$var$getContentIconColor(type, subType)
    });
module.exports["getContentTypeMessage"] = $befe57b5d5b5b9ac$export$3fde1d23d659ad2b;
module.exports["getContentIcon"] = $befe57b5d5b5b9ac$export$55d42216d2b1abe6;

});

parcelRegister("fJ5kL", function(module, exports) {

var $jLqGt = parcelRequire("jLqGt");


var $9BHAW = parcelRequire("9BHAW");


var $g4evd = parcelRequire("g4evd");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $ij4CE = parcelRequire("ij4CE");


var $jMyy4 = parcelRequire("jMyy4");





var $308Wd = parcelRequire("308Wd");


var $9bkOo = parcelRequire("9bkOo");


var $4yg2A = parcelRequire("4yg2A");

const $28645bc3a2212d0f$var$useFeedTypeSelectorRefreshQuery = (0, $g4evd.default);
const $28645bc3a2212d0f$var$useFeedTypeSelectorFeedTypeSelectorRefreshMutation = (0, $9BHAW.default);
const $28645bc3a2212d0f$export$f7f2ed889afe71b4 = (defaultPreference = (0, $9bkOo.FeedType).FOLLOWING)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $jLqGt.default),
        fragmentSpec: (0, $jLqGt.default),
        __callerPackage__: "feed"
    });
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($28645bc3a2212d0f$var$useFeedTypeSelectorRefreshQuery, {
        skip: !isLoggedIn,
        __callerPackage__: "feed"
    });
    const feedType = data?.userPreferences?.feedTab || defaultPreference;
    const [feedTypeSelectorMutation, { error: mutationError }] = (0, $308Wd.useMutationInterop)($28645bc3a2212d0f$var$useFeedTypeSelectorFeedTypeSelectorRefreshMutation, {
        __callerPackage__: "feed"
    });
    const updateFeedType = (updatedFeedType)=>{
        if (isLoggedIn) {
            const variables = {
                feedTab: updatedFeedType
            };
            feedTypeSelectorMutation({
                variables: variables,
                optimisticResponse: {
                    __typename: 'Mutation',
                    updateUserPreferences: {
                        __typename: 'UserPreferences',
                        feedTab: updatedFeedType
                    }
                }
            }).catch(()=>{}); // Ignore the error here since it is handled in useMutation
            // Always write to the cache so the user sees the preference even if there is an error
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    ...variables,
                    //handles either feedType or feedTab depending on FF
                    __typename: 'UserPreferences'
                }
            });
        }
    };
    return {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        feedType: feedType,
        updateFeedType: updateFeedType,
        hasSelectedFeedTypePreference: Boolean(data?.userPreferences?.feedTab)
    };
};
const $28645bc3a2212d0f$export$bc03ece1cfb914e3 = (defaultPreference = (0, $9bkOo.FeedType).FOLLOWING)=>{
    const [feedType, setFeedType] = (0, $cozmU.useState)(defaultPreference);
    const [hasSelectedFeedTypePreference, setHasSelectedFeedTypePreference] = (0, $cozmU.useState)(false);
    return {
        loading: false,
        feedType: feedType,
        updateFeedType: (feedType)=>{
            setFeedType(feedType);
            setHasSelectedFeedTypePreference(true);
        },
        hasSelectedFeedTypePreference: hasSelectedFeedTypePreference
    };
};
const $28645bc3a2212d0f$var$getFeedType = (feedQueryParam)=>feedQueryParam && Object.values((0, $9bkOo.FeedType)).includes(feedQueryParam) ? feedQueryParam : undefined;
const $28645bc3a2212d0f$export$58e655f86753a7c1 = ()=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const feedQueryParam = (0, $c3Qwv.getSingleParam)(getQueryParams(), 'feedType');
    const [feedTypeOverride, setFeedTypeOverride] = (0, $cozmU.useState)($28645bc3a2212d0f$var$getFeedType(feedQueryParam));
    (0, $cozmU.useEffect)(()=>{
        setQueryParams({
            feedType: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    const clearFeedTypeOverride = ()=>{
        setFeedTypeOverride(undefined);
    };
    return {
        feedTypeOverride: feedTypeOverride,
        clearFeedTypeOverride: clearFeedTypeOverride
    };
};
module.exports["useFeedTypeSelector"] = $28645bc3a2212d0f$export$f7f2ed889afe71b4;
module.exports["useAnonymousFeedTypeSelector"] = $28645bc3a2212d0f$export$bc03ece1cfb914e3;
module.exports["useFeedTypeOverride"] = $28645bc3a2212d0f$export$58e655f86753a7c1;

});

parcelRegister("lEClu", function(module, exports) {

var $3cztU = parcelRequire("3cztU");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");


var $kGgWH = parcelRequire("kGgWH");


var $kLaAt = parcelRequire("kLaAt");


var $2rlHJ = parcelRequire("2rlHJ");

const $c7452f13f73deba3$export$e7c2074107ea4cc7 = (0, $3cztU.default);
const $c7452f13f73deba3$export$68c012d92086743d = ()=>{
    const { value: value, setValue: setValue, query: query } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.FollowingFeedSortByValue).Relevant,
        sessionStorageKey: (0, $1UApO.keys).HOME_FOLLOWING_FEED_SORTING,
        skipQuery: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true)
    }, {
        query: $c7452f13f73deba3$export$e7c2074107ea4cc7,
        variables: (sorting)=>({
                sortBy: sorting
            })
    });
    const { value: valueWithSnippets, setValue: setValueWithSnippets, query: queryWithSnippets } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.FollowingFeedSortByValue).Relevant,
        sessionStorageKey: (0, $1UApO.keys).HOME_FOLLOWING_FEED_SORTING,
        skipQuery: !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true),
        interopApolloAggClient: true
    }, {
        query: (0, $kGgWH.FollowingFeedWithSortByStorageSnippetsQuery),
        variables: (sorting)=>({
                sortBy: sorting
            })
    });
    return {
        followingFeedSortBy: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? valueWithSnippets : value,
        setFollowingFeedSortBy: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? setValueWithSnippets : setValue,
        followingFeedQuery: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? queryWithSnippets : query
    };
};
module.exports["useFollowingFeedWithSortByStorage"] = $c7452f13f73deba3$export$68c012d92086743d;

});

parcelRegister("a6XTh", function(module, exports) {

var $lNpDX = parcelRequire("lNpDX");


var $1UApO = parcelRequire("1UApO");


var $bQm3c = parcelRequire("bQm3c");


var $kLaAt = parcelRequire("kLaAt");


var $2rlHJ = parcelRequire("2rlHJ");


var $afN8s = parcelRequire("afN8s");

const $0305a9034492a0e3$export$8f658981599c0d01 = (0, $lNpDX.default);
const $0305a9034492a0e3$export$e2ce202e4769830c = (renderPopularFeed)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { value: value, setValue: setValue, query: query } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
        sessionStorageKey: (0, $1UApO.keys).HOME_POPULAR_FEED_TIME_GRANULARITY,
        // Skip vanilla V1 when the V2 query is going to fire for this user.
        // Otherwise vanilla V1 is the safe fallback that must always run.
        //
        // V2 fires when the user is Rovo-enabled; everyone else gets
        // vanilla V1.
        skipQuery: !renderPopularFeed || isRovoLLMEnabled
    }, {
        query: $0305a9034492a0e3$export$8f658981599c0d01,
        variables: (timeGranularity)=>({
                timeGranularity: timeGranularity
            })
    });
    // V2 path: uses aiProperty directly on PopularFeedItem (parallel with Confluence hop).
    // Active when the user has Rovo LLM enabled — AI snippets only render for
    // Rovo-enabled users, so non-Rovo users fall back to the vanilla V1 query.
    const { value: valueWithSnippetsV2, setValue: setValueWithSnippetsV2, query: queryWithSnippetsV2 } = (0, $2rlHJ.useFeedDropdownStorage)({
        defaultValue: (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
        sessionStorageKey: (0, $1UApO.keys).HOME_POPULAR_FEED_TIME_GRANULARITY,
        skipQuery: !renderPopularFeed || !isRovoLLMEnabled,
        // Use the AGG (interop) client — V2 goes through AGG.
        interopApolloAggClient: true
    }, {
        query: (0, $afN8s.PopularFeedWithTimeGranularityStorageSnippetsV2Query),
        variables: (timeGranularity)=>({
                timeGranularity: timeGranularity,
                // The V2 `skipQuery` above already gates on `!isRovoLLMEnabled`,
                // so this variables function is only ever invoked when Rovo LLM
                // is enabled. Pass `true` unconditionally — avoids dead-code
                // branching. This mirrors how `preloadFeed.ts` already handles
                // this (also passes `true` unconditionally in the V2 branch).
                isRovoLLMEnabled: true
            })
    });
    return {
        popularFeedTimeGranularity: isRovoLLMEnabled ? valueWithSnippetsV2 : value,
        setPopularFeedTimeGranularity: isRovoLLMEnabled ? setValueWithSnippetsV2 : setValue,
        // Cast required: V2 query has a structurally compatible shape (the
        // `aiProperty` field is additive on PopularFeedItem) but TS can't infer
        // the union assignability for legacy callers that expect the V1 type.
        // Safe at runtime because PopularFeedCard reads only `content`/`id`.
        popularFeedQuery: isRovoLLMEnabled ? queryWithSnippetsV2 : query
    };
};
module.exports["usePopularFeedWithTimeGranularityStorage"] = $0305a9034492a0e3$export$e2ce202e4769830c;

});

parcelRegister("5amEx", function(module, exports) {
/**
 * @generated SignedSource<<16a71ce035eebac5f7f89da8cfff5eb1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2f312e63a5e94e2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useHomeWidgetStateUserPreferencesFragment",
        "selections": [
            {
                "concreteType": "HomeWidget",
                "kind": "LinkedField",
                "name": "homeWidgets",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "UserPreferences"
    };
}();
$a2f312e63a5e94e2$var$node.hash = "0c62eafb1ea633f1257ca52f851d7e59";
var $a2f312e63a5e94e2$export$2e2bcd8739ae039 = $a2f312e63a5e94e2$var$node;
module.exports["default"] = $a2f312e63a5e94e2$export$2e2bcd8739ae039;

});

parcelRegister("lU1qY", function(module, exports) {
/**
 * @generated SignedSource<<49f2cb0cedfb1093f04282156c2fb602>>
 * @relayHash a5ed50647af6fea569a4ab5e15cf4bc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a
const $53defb598c8d71bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "id"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "state",
                                    "variableName": "state"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "homeWidget"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HomeWidget",
                    "kind": "LinkedField",
                    "name": "homeWidgets",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a5ed50647af6fea569a4ab5e15cf4bc1",
            "id": "bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a",
            "metadata": {},
            "name": "useHomeWidgetStateHomeWidgetsMutation",
            "operationKind": "mutation",
            "text": "mutation useHomeWidgetStateHomeWidgetsMutation($id:ID!,$state:HomeWidgetState!){updateUserPreferences(userPreferences:{homeWidget:{id:$id,state:$state}}){homeWidgets{id,state}}}"
        }
    };
}();
$53defb598c8d71bd$var$node.hash = "5471258689abf3a3cbbbc72377571311";
var $53defb598c8d71bd$export$2e2bcd8739ae039 = $53defb598c8d71bd$var$node;
module.exports["default"] = $53defb598c8d71bd$export$2e2bcd8739ae039;

});

parcelRegister("jLqGt", function(module, exports) {
/**
 * @generated SignedSource<<556a2c13741bfd3154bc1fc9c77382b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $32aa9732e4ed9d66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeedTypeSelectorWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "feedTab"
        }
    ],
    "type": "UserPreferences"
};
$32aa9732e4ed9d66$var$node.hash = "4d2d2b2e6fd75a844316ed9aca89be96";
var $32aa9732e4ed9d66$export$2e2bcd8739ae039 = $32aa9732e4ed9d66$var$node;
module.exports["default"] = $32aa9732e4ed9d66$export$2e2bcd8739ae039;

});

parcelRegister("9BHAW", function(module, exports) {
/**
 * @generated SignedSource<<5cd880fe094ee4cedc5e7868f7e450d2>>
 * @relayHash 1dea07045fdc805115ac232cb227baba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78
const $545242dd4ac6b8fd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "feedTab"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "feedTab",
                            "variableName": "feedTab"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dea07045fdc805115ac232cb227baba",
            "id": "deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78",
            "metadata": {},
            "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedTypeSelectorFeedTypeSelectorRefreshMutation($feedTab:String!){updateUserPreferences(userPreferences:{feedTab:$feedTab}){feedTab}}"
        }
    };
}();
$545242dd4ac6b8fd$var$node.hash = "6a96de700fa7869ef1acedccaf8591a7";
var $545242dd4ac6b8fd$export$2e2bcd8739ae039 = $545242dd4ac6b8fd$var$node;
module.exports["default"] = $545242dd4ac6b8fd$export$2e2bcd8739ae039;

});

parcelRegister("9bkOo", function(module, exports) {
var $1c116a80351d70cc$export$a13b342a3f580b52 = /*#__PURE__*/ function(FeedType) {
    FeedType["DIRECT"] = "DIRECT";
    FeedType["FOLLOWING"] = "FOLLOWING";
    FeedType["POPULAR"] = "POPULAR";
    return FeedType;
}({});
module.exports["FeedType"] = $1c116a80351d70cc$export$a13b342a3f580b52;

});

parcelRegister("kGgWH", function(module, exports) {

var $Yc1IN = parcelRequire("Yc1IN");

const $2c92c921647a6942$export$b29ff2301d2c3d56 = (0, $Yc1IN.default);
module.exports["FollowingFeedWithSortByStorageSnippetsQuery"] = $2c92c921647a6942$export$b29ff2301d2c3d56;

});

parcelRegister("kLaAt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $aRGok = parcelRequire("aRGok");


var $7akNQ = parcelRequire("7akNQ");


var $5x1q6 = parcelRequire("5x1q6");


var $jXbuX = parcelRequire("jXbuX");


var $60Yxm = parcelRequire("60Yxm");


var $fNTq8 = parcelRequire("fNTq8");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $1UApO = parcelRequire("1UApO");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $95rLf = parcelRequire("95rLf");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $dG9Mj = parcelRequire("dG9Mj");


var $bQm3c = parcelRequire("bQm3c");


var $kvJHJ = parcelRequire("kvJHJ");


var $kUDSV = parcelRequire("kUDSV");


var $fhzlo = parcelRequire("fhzlo");


var $cUsnC = parcelRequire("cUsnC");

var $1Itw6 = parcelRequire("1Itw6");


var $cjYUn = parcelRequire("cjYUn");


var $8cmRU = parcelRequire("8cmRU");


var $4yg2A = parcelRequire("4yg2A");

var $fJ5kL = parcelRequire("fJ5kL");


var $d442j = parcelRequire("d442j");


var $28g78 = parcelRequire("28g78");


var $bxcP5 = parcelRequire("bxcP5");


var $6GgH7 = parcelRequire("6GgH7");


var $73voS = parcelRequire("73voS");


var $anKV5 = parcelRequire("anKV5");


var $4kEyG = parcelRequire("4kEyG");


var $lEClu = parcelRequire("lEClu");


var $a6XTh = parcelRequire("a6XTh");


var $92tNT = parcelRequire("92tNT");


var $hJGpd = parcelRequire("hJGpd");


var $4styE = parcelRequire("4styE");


var $927dV = parcelRequire("927dV");

const $1a7c1e3f737c78a8$var$i18n = (0, $kSwu1.defineMessages)({
    welcomeFeedLabel: {
        id: "feed.welcome-label",
        defaultMessage: "Welcome"
    },
    farewellFeedLabel: {
        id: "feed.farewell-label",
        defaultMessage: "Farewell"
    },
    whatsNewInConfluenceFeedLabel: {
        id: "feed.whatsNew-label",
        defaultMessage: "What\u2019s new in Confluence"
    },
    meetingsFeedLabel: {
        id: "feed.meetings-label",
        defaultMessage: "Meetings"
    }
});
var $1a7c1e3f737c78a8$export$f27524bff21c0156 = /*#__PURE__*/ function(PopularFeedTimeGranularityValue) {
    PopularFeedTimeGranularityValue["Day"] = "day";
    PopularFeedTimeGranularityValue["Default"] = "default";
    // default is 2 weeks. cc-analytics expects "default" as a parameter for 2 weeks
    PopularFeedTimeGranularityValue["Month"] = "month";
    PopularFeedTimeGranularityValue["Week"] = "week";
    PopularFeedTimeGranularityValue["Year"] = "year";
    return PopularFeedTimeGranularityValue;
}({});
var $1a7c1e3f737c78a8$export$eff547a168b0f0ed = /*#__PURE__*/ function(FollowingFeedSortByValue) {
    FollowingFeedSortByValue["Relevant"] = "relevant";
    FollowingFeedSortByValue["Recent"] = "chronological";
    return FollowingFeedSortByValue;
}({});
const $1a7c1e3f737c78a8$var$PANELS_WITHOUT_WRAPPER = [
    'confluence.home.welcome',
    'confluence.home.farewell'
];
const $1a7c1e3f737c78a8$var$shouldRenderWithoutWrapper = (panel)=>panel.renderWithoutWrapper || $1a7c1e3f737c78a8$var$PANELS_WITHOUT_WRAPPER.includes(panel.key);
const $1a7c1e3f737c78a8$var$NoWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
const $1a7c1e3f737c78a8$var$CustomPanelWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28g78.SimpleWrapper), {
        role: "none",
        "data-testid": "custom-panel-wrapper"
    }, children);
const $1a7c1e3f737c78a8$var$ConditionalWrapper = ({ condition: condition, WrapperIfTrue: WrapperIfTrue, WrapperIfFalse: WrapperIfFalse, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperIfTrue, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperIfFalse, null, children);
const $1a7c1e3f737c78a8$var$aiAnalyticsConfig = {
    product: 'confluence',
    subproduct: 'confluence',
    source: 'feed',
    aiFeatureName: 'aiSnippetsInFeeds',
    proactiveGeneratedAI: 0,
    userGeneratedAI: 0
};
const $1a7c1e3f737c78a8$var$FeedComponent = ({ renderPopularFeed: renderPopularFeed, customPanels: customPanels })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { feedTypeOverride: feedTypeOverride, clearFeedTypeOverride: clearFeedTypeOverride } = (0, $fJ5kL.useFeedTypeOverride)();
    const loggedInFeedTypeSelector = (0, $fJ5kL.useFeedTypeSelector)();
    const anonymousFeedTypeSelector = (0, $fJ5kL.useAnonymousFeedTypeSelector)();
    const popularFeedPillRef = (0, $cozmU.useRef)(null);
    const followingFeedPillRef = (0, $cozmU.useRef)(null);
    const welcomeFeedPillRef = (0, $cozmU.useRef)(null);
    const farewellFeedPillRef = (0, $cozmU.useRef)(null);
    const meetingsFeedPillRef = (0, $cozmU.useRef)(null);
    // `shouldShow` is true only for gate-on + eligible + treatment users, so
    // control/ineligible users never see the pill. Query is skipped when gate off.
    const { shouldShow: shouldShowMeetingsPill } = (0, $4styE.useMeetingsVisibility)({
        enabled: (0, $9wGTI.fg)('meetings-tab-confluence-for-you-gate')
    });
    // "New" lozenge state for the Meetings pill; only evaluated/persisted when the pill is shown.
    const { showLozenge: showMeetingsPillNewLozenge, incrementClickCount: onMeetingsPillClick } = (0, $927dV.useMeetingsPillNewLozenge)(shouldShowMeetingsPill);
    const handleFocusRef = (feedPillRef)=>{
        const feedPillRefButton = feedPillRef.current;
        if (feedPillRefButton) feedPillRefButton.focus();
    };
    const { loading: loadingPreferences, queryError: queryError, mutationError: mutationError, feedType: feedType, updateFeedType: updateFeedType, hasSelectedFeedTypePreference: hasSelectedFeedTypePreference } = isLoggedIn ? loggedInFeedTypeSelector : anonymousFeedTypeSelector;
    const filterOrOverride = feedTypeOverride || feedType;
    const updateFeedTypeAndClearOverride = (0, $cozmU.useCallback)((updatedFeedType)=>{
        clearFeedTypeOverride();
        updateFeedType(updatedFeedType);
    }, [
        updateFeedType,
        clearFeedTypeOverride
    ]);
    const handleFeedSelectorChange = (0, $cozmU.useCallback)((updatedFeedType)=>{
        experienceTracker.start({
            name: (0, $irVI7.FEED_EXPERIENCE),
            attributes: {
                feedTypeChange: true
            }
        });
        updateFeedTypeAndClearOverride(updatedFeedType);
    }, [
        experienceTracker,
        updateFeedTypeAndClearOverride
    ]);
    const { followingFeedSortBy: followingFeedSortBy, setFollowingFeedSortBy: setFollowingFeedSortBy, followingFeedQuery: feedContentQuery } = (0, $lEClu.useFollowingFeedWithSortByStorage)();
    const hasFollowedAnyone = (feedContentQuery?.data?.getFeedUserConfig?.users?.length || 0) > 0 || (feedContentQuery?.data?.getFeedUserConfig?.spaces?.length || 0) > 0;
    if (feedContentQuery?.error) {
        if ((0, $95rLf.isExpectedApolloError)(feedContentQuery.error)) (0, $7Sm4c.markErrorAsHandled)(feedContentQuery.error);
    }
    const refetchFeedContentQuery = feedContentQuery.refetch;
    const handleActivityFilterModalSave = (0, $cozmU.useCallback)(()=>{
        refetchFeedContentQuery?.({
            sortBy: followingFeedSortBy
        });
        handleFeedSelectorChange((0, $4yg2A.FeedType).FOLLOWING);
    }, [
        refetchFeedContentQuery,
        followingFeedSortBy,
        handleFeedSelectorChange
    ]);
    const handleFollowingFeedSortByDropdownChange = (0, $cozmU.useCallback)((sortBy)=>{
        setFollowingFeedSortBy(sortBy);
        refetchFeedContentQuery?.({
            sortBy: sortBy
        });
    }, [
        refetchFeedContentQuery,
        setFollowingFeedSortBy
    ]);
    const { popularFeedTimeGranularity: popularFeedTimeGranularity, setPopularFeedTimeGranularity: setPopularFeedTimeGranularity, popularFeedQuery: popularFeedQuery } = (0, $a6XTh.usePopularFeedWithTimeGranularityStorage)(renderPopularFeed);
    const refetchPopularFeedQuery = popularFeedQuery.refetch;
    const handlePopularFeedTimeGranularityDropdownChange = (0, $cozmU.useCallback)((timeGranularity)=>{
        setPopularFeedTimeGranularity(timeGranularity);
        refetchPopularFeedQuery?.({
            timeGranularity: timeGranularity
        });
    }, [
        refetchPopularFeedQuery,
        setPopularFeedTimeGranularity
    ]);
    (0, $cjYUn.useFeedRenderedTrackEvent)(filterOrOverride, feedContentQuery.data, popularFeedQuery.data);
    const followFeedSessionId = (0, $anKV5.useFeedSession)(feedContentQuery, (0, $1UApO.keys).HOME_FOLLOWING_FEED_SESSION_ID);
    const followingFeedContext = (0, $cozmU.useMemo)(()=>{
        return {
            feedSessionId: followFeedSessionId
        };
    }, [
        followFeedSessionId
    ]);
    const popularFeedSessionId = (0, $anKV5.useFeedSession)(popularFeedQuery, (0, $1UApO.keys).HOME_POPULAR_FEED_SESSION_ID);
    const popularFeedContext = (0, $cozmU.useMemo)(()=>{
        return {
            feedSessionId: popularFeedSessionId
        };
    }, [
        popularFeedSessionId
    ]);
    const { activityFilterModalOpen: activityFilterModalOpen, openActivityFilterModal: openActivityFilterModal, closeActivityFilterModal: closeActivityFilterModal } = (0, $8cmRU.useActivityFilterModalState)();
    const welcomeAndFarewellPanels = [
        {
            title: intl.formatMessage($1a7c1e3f737c78a8$var$i18n.welcomeFeedLabel),
            key: 'confluence.home.welcome',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5x1q6))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4kEyG.FilterByLabelFeed), {
                handleFocusRef: ()=>handleFocusRef(welcomeFeedPillRef),
                filterByLabel: "welcome-blog"
            }),
            ref: welcomeFeedPillRef
        },
        {
            title: intl.formatMessage($1a7c1e3f737c78a8$var$i18n.farewellFeedLabel),
            key: 'confluence.home.farewell',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4kEyG.FilterByLabelFeed), {
                handleFocusRef: ()=>handleFocusRef(farewellFeedPillRef),
                filterByLabel: "farewell-blog"
            }),
            ref: farewellFeedPillRef
        }
    ];
    const meetingsPanel = {
        title: intl.formatMessage($1a7c1e3f737c78a8$var$i18n.meetingsFeedLabel),
        key: 'confluence.home.meetings',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92tNT.LoadableMeetingsPanel), null),
        ref: meetingsFeedPillRef,
        // Each meeting renders as its own bordered card, so opt out of the shared
        // CustomPanelWrapper to avoid a redundant border around the whole list.
        renderWithoutWrapper: true,
        titleSuffix: showMeetingsPillNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hJGpd.MeetingsPillNewLozenge), null) : undefined,
        onSelect: onMeetingsPillClick
    };
    const updatedPanels = [
        ...(0, $9wGTI.fg)('confluence_welcome_farewell_feed') || (0, $1xpoY.default).getBoolean('confluence-welcome-farewell-feed-internal', false) ? welcomeAndFarewellPanels : [],
        ...shouldShowMeetingsPill ? [
            meetingsPanel
        ] : [],
        ...customPanels || []
    ];
    const renderPanel = (panel)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "tabpanel",
            id: `tabpanel-${panel.key}`,
            "aria-labelledby": `tab-${panel.key}`,
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, panel.content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess //if we render an external panel we'll consider it a success, as the data is fetched externally
        ), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            key: panel.key,
            attributes: {
                feedType: panel.key
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
        }));
    };
    if (loadingPreferences) return null;
    const renderFeedCards = ()=>{
        if (updatedPanels && !!updatedPanels.length && !Object.values((0, $4yg2A.FeedType)).includes(filterOrOverride) // ensures the custom panel isn't just one of the expected panels
        ) {
            const panel = updatedPanels.find((element)=>element.key === filterOrOverride);
            if (panel?.content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a7c1e3f737c78a8$var$ConditionalWrapper, {
                condition: $1a7c1e3f737c78a8$var$shouldRenderWithoutWrapper(panel),
                WrapperIfTrue: $1a7c1e3f737c78a8$var$NoWrapper,
                WrapperIfFalse: $1a7c1e3f737c78a8$var$CustomPanelWrapper
            }, renderPanel(panel));
        }
        if (!hasSelectedFeedTypePreference) {
            if (feedContentQuery?.data?.feed?.nodes?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GgH7.FeedContext).Provider, {
                value: followingFeedContext
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cUsnC.ActivityFeedCards), {
                feedContentQuery: feedContentQuery,
                openActivityFilterModal: openActivityFilterModal,
                handleFocusRef: ()=>handleFocusRef(followingFeedPillRef),
                followingFeedSortBy: followingFeedSortBy,
                hasFollowedAnyone: hasFollowedAnyone
            }));
            else if (popularFeedQuery?.data?.popularFeed?.nodes?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GgH7.FeedContext).Provider, {
                value: popularFeedContext
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Itw6.PopularFeedCards), {
                popularFeedQuery: popularFeedQuery,
                handleFocusRef: ()=>handleFocusRef(popularFeedPillRef),
                popularFeedTimeGranularity: popularFeedTimeGranularity
            }));
        }
        if (filterOrOverride === (0, $4yg2A.FeedType).POPULAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GgH7.FeedContext).Provider, {
            value: popularFeedContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Itw6.PopularFeedCards), {
            popularFeedQuery: popularFeedQuery,
            handleFocusRef: ()=>handleFocusRef(popularFeedPillRef),
            popularFeedTimeGranularity: popularFeedTimeGranularity
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GgH7.FeedContext).Provider, {
            value: followingFeedContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cUsnC.ActivityFeedCards), {
            feedContentQuery: feedContentQuery,
            openActivityFilterModal: openActivityFilterModal,
            handleFocusRef: ()=>handleFocusRef(followingFeedPillRef),
            followingFeedSortBy: followingFeedSortBy,
            hasFollowedAnyone: hasFollowedAnyone
        }));
    };
    const isFollowingOrPopularFeed = filterOrOverride === (0, $4yg2A.FeedType).FOLLOWING || filterOrOverride === (0, $4yg2A.FeedType).POPULAR;
    const followingFeedHasVisibleResults = Boolean(feedContentQuery?.data?.feed?.nodes?.some((0, $73voS.isVisibleFollowingFeedNode)));
    const popularFeedHasVisibleResults = Boolean(popularFeedQuery?.data?.popularFeed?.nodes?.some((0, $73voS.isVisiblePopularFeedNode)));
    const isFollowingEmptyStateBanner = filterOrOverride === (0, $4yg2A.FeedType).FOLLOWING && Boolean(feedContentQuery?.data) && !followingFeedHasVisibleResults;
    const isPopularEmptyStateBanner = filterOrOverride === (0, $4yg2A.FeedType).POPULAR && Boolean(popularFeedQuery?.data) && !popularFeedHasVisibleResults;
    const isFeedEmptyStateBanner = (0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true) && (isFollowingEmptyStateBanner || isPopularEmptyStateBanner);
    // Hide the "Summaries use AI. Verify results." row when the Popular or Following empty-state banner
    // is shown (Popular tab OR Following tab + no visible results + experiment on)
    const shouldRenderSnippetsFeedback = isFollowingOrPopularFeed && (0, $6mKj3.expValEquals)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) && !isFeedEmptyStateBanner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $1a7c1e3f737c78a8$var$aiAnalyticsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "activity-feed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kUDSV.FeedHeader), {
        openActivityFilterModal: openActivityFilterModal,
        renderPopularFeed: renderPopularFeed,
        feedType: filterOrOverride,
        setFeedType: handleFeedSelectorChange,
        customPanels: updatedPanels,
        popularFeedPillRef: popularFeedPillRef,
        followingFeedPillRef: followingFeedPillRef,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        handlePopularFeedTimeGranularityDropdownChange: handlePopularFeedTimeGranularityDropdownChange,
        followingFeedSortBy: followingFeedSortBy,
        handleFollowingFeedSortByDropdownChange: handleFollowingFeedSortByDropdownChange,
        hasFollowedAnyone: hasFollowedAnyone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, shouldRenderSnippetsFeedback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fhzlo.FeedSnippetsFeedbackComponent), null) : null, renderFeedCards(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, activityFilterModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dG9Mj.ActivityFilterDialog), {
        onChanged: handleActivityFilterModalSave,
        onClose: closeActivityFilterModal
    })), queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    })))));
};
const $1a7c1e3f737c78a8$export$833919a382305440 = ({ renderPopularFeed: renderPopularFeed = false, customPanels: customPanels })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failFeedExperience = (0, $cozmU.useCallback)((error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.FEED_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d442j.GenericFeedError), null),
        onError: failFeedExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a7c1e3f737c78a8$var$FeedComponent, {
        renderPopularFeed: renderPopularFeed,
        customPanels: customPanels
    })));
};
module.exports["PopularFeedTimeGranularityValue"] = $1a7c1e3f737c78a8$export$f27524bff21c0156;
module.exports["FollowingFeedSortByValue"] = $1a7c1e3f737c78a8$export$eff547a168b0f0ed;
module.exports["Feed"] = $1a7c1e3f737c78a8$export$833919a382305440;

});

parcelRegister("2rlHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $jMyy4 = parcelRequire("jMyy4");

function $0f4198ebf1ecfafa$export$8976bb5184850728(config, queryConfig) {
    const { defaultValue: defaultValue, sessionStorageKey: sessionStorageKey, skipQuery: skipQuery, interopApolloAggClient: interopApolloAggClient } = config;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = window.__SSR_RENDERED__;
    // Initialize state with session storage or default
    const [value, setValue] = (0, $cozmU.useState)(()=>{
        if (!isSSR) {
            const sessionValue = (0, $17wUi.confluenceSessionStorageInstance).getItem(sessionStorageKey);
            if (sessionValue && sessionValue !== defaultValue) return sessionValue;
        }
        return defaultValue;
    });
    const isFollowingFeed = defaultValue === 'relevant';
    const popularFeedInitialPageSize = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_spa', 5);
    const initialPageSize = isFollowingFeed ? (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_spa', 5) : popularFeedInitialPageSize;
    const query = (0, $jMyy4.useQueryInterop)(queryConfig.query, {
        variables: {
            first: initialPageSize,
            ...queryConfig.variables(value)
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
        skip: skipQuery,
        interopApolloAggClient: interopApolloAggClient,
        __callerPackage__: "feed"
    });
    (0, $cozmU.useEffect)(()=>{
        (0, $17wUi.confluenceSessionStorageInstance).setItem(sessionStorageKey, value);
    }, [
        value,
        sessionStorageKey
    ]);
    return {
        value: value,
        setValue: setValue,
        query: query
    };
}
module.exports["useFeedDropdownStorage"] = $0f4198ebf1ecfafa$export$8976bb5184850728;

});

parcelRegister("afN8s", function(module, exports) {

var $d7td2 = parcelRequire("d7td2");

const $6db752ccb866e30d$export$f978d54afe83bffb = (0, $d7td2.default);
module.exports["PopularFeedWithTimeGranularityStorageSnippetsV2Query"] = $6db752ccb866e30d$export$f978d54afe83bffb;

});

parcelRegister("dG9Mj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $213605160dd82c06$export$1cba263d7c89b8bd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LLSlx",
    name: "ActivityFilterDialog",
    loader: async ()=>(await (parcelRequire("2U3gG"))).ActivityFilterDialog
});
module.exports["ActivityFilterDialog"] = $213605160dd82c06$export$1cba263d7c89b8bd;

});

parcelRegister("kUDSV", function(module, exports) {
/* FeedHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $9wGTI = parcelRequire("9wGTI");


var $215Eu = parcelRequire("215Eu");


var $4yg2A = parcelRequire("4yg2A");


var $kLaAt = parcelRequire("kLaAt");

const $3cd87315866bd329$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    feedTitle: {
        id: "feed.title",
        defaultMessage: "Discover what\u2019s happening"
    },
    manageFeed: {
        id: "feed.header.manage.following",
        defaultMessage: "Edit feed"
    },
    sortByRelevant: {
        id: "feed.header.sortBy.following.relevant",
        defaultMessage: "Sort by: Most relevant"
    },
    sortByRecent: {
        id: "feed.header.sortBy.following.recent",
        defaultMessage: "Sort by: Last activity"
    },
    day: {
        id: "feed.popular.day",
        defaultMessage: "Today"
    },
    week: {
        id: "feed.popular.week",
        defaultMessage: "Past 7 days"
    },
    twoWeeks: {
        id: "feed.popular.twoWeeks",
        defaultMessage: "Past 14 days"
    },
    month: {
        id: "feed.popular.month",
        defaultMessage: "Past 30 days"
    },
    year: {
        id: "feed.popular.year",
        defaultMessage: "Past year"
    },
    popularDay: {
        id: "feed.popular.dropdown.prefix.day",
        defaultMessage: "Popular: Today"
    },
    popularWeek: {
        id: "feed.popular.dropdown.prefix.week",
        defaultMessage: "Popular: Past 7 days"
    },
    popularTwoWeeks: {
        id: "feed.popular.dropdown.prefix.twoWeeks",
        defaultMessage: "Popular: Past 14 days"
    },
    popularMonth: {
        id: "feed.popular.dropdown.prefix.month",
        defaultMessage: "Popular: Past 30 days"
    },
    popularYear: {
        id: "feed.popular.dropdown.prefix.year",
        defaultMessage: "Popular: Past year"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$FeedTitleAndActions = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _37wbyuI7V3 _3iDTPbQ4SZ _3TGfC9HnLE _1DCdHi5zaO _0aFT5vbt8w",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$SelectorAndActions = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _1ANEUSLRg7 _3138422ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cd87315866bd329$var$FeedTitleHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0jFU0VVa5s",
            __cmplp.className
        ])
    });
});
const $3cd87315866bd329$var$SpotlightContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _1mT5xdWVPG _2IhTondnbC _3OE6xY5UaJ _0jFU0VN91d _39xV02N91d _1pp6NdYbGa",
            __cmplp.className
        ])
    });
});
var $3cd87315866bd329$var$FeedHeaderDropdownType = /*#__PURE__*/ function(FeedHeaderDropdownType) {
    FeedHeaderDropdownType["FOLLOWING_FEED_SORT_BY"] = "followingSortBy";
    FeedHeaderDropdownType["POPULAR_FEED_TIME_GRANULARITY"] = "popularTimeGranularity";
    return FeedHeaderDropdownType;
}($3cd87315866bd329$var$FeedHeaderDropdownType || {});
const $3cd87315866bd329$export$691a0baee9d17455 = ({ openActivityFilterModal: openActivityFilterModal, renderPopularFeed: renderPopularFeed, feedType: feedType, setFeedType: setFeedType, customPanels: customPanels, popularFeedPillRef: popularFeedPillRef, followingFeedPillRef: followingFeedPillRef, popularFeedTimeGranularity: popularFeedTimeGranularity, handlePopularFeedTimeGranularityDropdownChange: handlePopularFeedTimeGranularityDropdownChange, followingFeedSortBy: followingFeedSortBy, handleFollowingFeedSortByDropdownChange: handleFollowingFeedSortByDropdownChange, hasFollowedAnyone: hasFollowedAnyone, hasResults: hasResults = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleManageButtonClick = (0, $cozmU.useCallback)(()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'editFeed',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openActivityFilterModal
    ]);
    const getPopularFeedTimeGranularityDropDownText = ()=>{
        switch(popularFeedTimeGranularity){
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Day:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularDay);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Week:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularWeek);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Month:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularMonth);
            case (0, $kLaAt.PopularFeedTimeGranularityValue).Year:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularYear);
            default:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.popularTwoWeeks);
        }
    };
    const getFollowingFeedSortByDropDownText = ()=>{
        switch(followingFeedSortBy){
            case (0, $kLaAt.FollowingFeedSortByValue).Recent:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.sortByRecent);
            default:
                return formatMessage($3cd87315866bd329$export$a7357cdd1f0b0168.sortByRelevant);
        }
    };
    const handleDropdownChange = (0, $cozmU.useCallback)((type, value)=>{
        // if the value is the same as the current value, do nothing
        if (type === "popularTimeGranularity" && value === popularFeedTimeGranularity || type === "followingSortBy" && value === followingFeedSortBy) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: type,
                source: 'homeScreen',
                attributes: {
                    [type === "popularTimeGranularity" ? 'timeGranularity' : 'sortBy']: value
                }
            }
        }).fire();
        if (type === "popularTimeGranularity") handlePopularFeedTimeGranularityDropdownChange(value);
        else handleFollowingFeedSortByDropdownChange(value);
    }, [
        handleFollowingFeedSortByDropdownChange,
        handlePopularFeedTimeGranularityDropdownChange,
        createAnalyticsEvent,
        followingFeedSortBy,
        popularFeedTimeGranularity
    ]);
    const handleDropdownOpenChange = (type, isOpen)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'toggled',
                actionSubject: 'dropdown',
                actionSubjectId: type,
                source: 'homeScreen',
                attributes: {
                    isOpen: isOpen
                }
            }
        }).fire();
    };
    const handlePopularFeedTimeGranularityDropdownOpenChange = (isOpen)=>{
        handleDropdownOpenChange("popularTimeGranularity", isOpen);
    };
    const handleFollowingFeedSortByDropdownOpenChange = (isOpen)=>{
        handleDropdownOpenChange("followingSortBy", isOpen);
    };
    const followingFeedSortByDropdownText = getFollowingFeedSortByDropDownText();
    const popularFeedTimeGranularityDropdownText = getPopularFeedTimeGranularityDropDownText();
    const renderFollowingFeedSortByItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: followingFeedSortBy === (0, $kLaAt.FollowingFeedSortByValue).Relevant,
            onClick: ()=>handleDropdownChange("followingSortBy", (0, $kLaAt.FollowingFeedSortByValue).Relevant)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.sortByRelevant)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: followingFeedSortBy === (0, $kLaAt.FollowingFeedSortByValue).Recent,
            onClick: ()=>handleDropdownChange("followingSortBy", (0, $kLaAt.FollowingFeedSortByValue).Recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.sortByRecent)));
    const renderFollowingFeedSortByDropdown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            onOpenChange: (onOpenChangeAttributes)=>handleFollowingFeedSortByDropdownOpenChange(onOpenChangeAttributes.isOpen),
            trigger: followingFeedSortByDropdownText,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, renderFollowingFeedSortByItems()));
    const renderPopularFeedTimeGranularityDropdown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "popular-feed-dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            onOpenChange: (onOpenChangeAttributes)=>handlePopularFeedTimeGranularityDropdownOpenChange(onOpenChangeAttributes.isOpen),
            trigger: popularFeedTimeGranularityDropdownText,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Day,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Day)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.day)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Week,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Week)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.week)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Default,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Default)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.twoWeeks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Month,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Month)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.month)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: popularFeedTimeGranularity === (0, $kLaAt.PopularFeedTimeGranularityValue).Year,
            onClick: ()=>handleDropdownChange("popularTimeGranularity", (0, $kLaAt.PopularFeedTimeGranularityValue).Year)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.year)))));
    const renderFollowingFeedActions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, renderFollowingFeedSortByDropdown(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleManageButtonClick,
            testId: "manage-feed-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.manageFeed)));
    const shouldRenderActions = ()=>!(feedType === (0, $4yg2A.FeedType).FOLLOWING && hasFollowedAnyone === false && !hasResults) && (feedType === (0, $4yg2A.FeedType).POPULAR && !(0, $9wGTI.fg)('confluence_ai_feeds_home_banner') || feedType === (0, $4yg2A.FeedType).FOLLOWING);
    const renderActions = ()=>{
        if (!shouldRenderActions()) return null;
        if (feedType === (0, $4yg2A.FeedType).POPULAR && !(0, $9wGTI.fg)('confluence_ai_feeds_home_banner')) return renderPopularFeedTimeGranularityDropdown();
        else if (feedType === (0, $4yg2A.FeedType).FOLLOWING) return renderFollowingFeedActions();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3cd87315866bd329$var$FeedTitleAndActions, {
        "data-testid": "feed-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3cd87315866bd329$var$SpotlightContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3cd87315866bd329$var$FeedTitleHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2",
        id: "tablist-feedtypes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3cd87315866bd329$export$a7357cdd1f0b0168.feedTitle)), renderActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3cd87315866bd329$var$SelectorAndActions, null, renderPopularFeed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $215Eu.FeedTypeSelector), {
        selectedFeedType: feedType,
        setSelectedFeedType: setFeedType,
        customPanels: customPanels,
        popularFeedPillRef: popularFeedPillRef,
        followingFeedPillRef: followingFeedPillRef
    })));
};
module.exports["FeedHeader"] = $3cd87315866bd329$export$691a0baee9d17455;

});

parcelRegister("fhzlo", function(module, exports) {
/* FeedSnippetsFeedbackComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1l0kj = parcelRequire("1l0kj");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $fodiz = parcelRequire("fodiz");


var $w6R6I = parcelRequire("w6R6I");


var $cHkK6 = parcelRequire("cHkK6");


var $5JhlM = parcelRequire("5JhlM");

const $bee7b2081924512d$var$AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID = 'bd3af97d-5e24-463c-a29a-6e23233bbe8a';
const $bee7b2081924512d$var$i18n = (0, $kSwu1.defineMessages)({
    aiDisclaimerText: {
        id: "feed.ai-disclaimer-text",
        defaultMessage: "Summaries use AI. Verify results."
    },
    statusInformationIconLabel: {
        id: "feed.status-information-icon-label",
        defaultMessage: "Summaries use AI. Verify results."
    }
});
const $bee7b2081924512d$var$aiDisclaimerStyles = {
    disclaimer: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0adFHsgVvo",
    icon: "_0adFHsgVvo",
    container: "_0Of8r22ADO _1wydGW8HPE _1DCdHi1Y8M"
};
const $bee7b2081924512d$export$7114e2b0a1fb113e = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const disclaimerMessage = intl.formatMessage($bee7b2081924512d$var$i18n.aiDisclaimerText);
    const statusInformationIconLabel = intl.formatMessage($bee7b2081924512d$var$i18n.statusInformationIconLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $bee7b2081924512d$var$AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: (0, $w6R6I.cx)($bee7b2081924512d$var$aiDisclaimerStyles.container)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($bee7b2081924512d$var$aiDisclaimerStyles.disclaimer),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($bee7b2081924512d$var$aiDisclaimerStyles.icon)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: statusInformationIconLabel,
        size: "small",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, disclaimerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: "ai-snippets-popular-following-feeds"
    })));
};
module.exports["FeedSnippetsFeedbackComponent"] = $bee7b2081924512d$export$7114e2b0a1fb113e;

});

parcelRegister("cUsnC", function(module, exports) {
/* ActivityFeedCards.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5T18X = parcelRequire("5T18X");


var $9DHhW = parcelRequire("9DHhW");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $5SGpQ = parcelRequire("5SGpQ");


var $gVrmv = parcelRequire("gVrmv");


var $6mKj3 = parcelRequire("6mKj3");


var $4yg2A = parcelRequire("4yg2A");


var $73voS = parcelRequire("73voS");


var $YAWAX = parcelRequire("YAWAX");


var $8FX3K = parcelRequire("8FX3K");

var $lYst4 = parcelRequire("lYst4");


var $9yPX0 = parcelRequire("9yPX0");


var $gusOH = parcelRequire("gusOH");


var $28g78 = parcelRequire("28g78");


var $8BIV2 = parcelRequire("8BIV2");


var $6zZYs = parcelRequire("6zZYs");

const $6408708fd25031c0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    allActivity: {
        id: "feed.fallback.message",
        defaultMessage: "To see personalized activity edit your feed by following people and spaces."
    },
    manageFeed: {
        id: "feed.fallback.manage.following",
        defaultMessage: "Edit feed"
    }
});
const $6408708fd25031c0$var$feedRecommendationsContainerStyle = null;
const $6408708fd25031c0$var$fallbackToAllActivityBannerWrapperStyle = null;
const $6408708fd25031c0$var$spinnerWrapperStyle = null;
const $6408708fd25031c0$export$3e88c5c2a61da20e = ({ feedContentQuery: feedContentQuery, openActivityFilterModal: openActivityFilterModal, handleFocusRef: handleFocusRef, followingFeedSortBy: followingFeedSortBy, hasFollowedAnyone: hasFollowedAnyone })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = feedContentQuery;
    const [consecutiveOnboardingPulls, setConsecutiveOnboardingPulls] = (0, $cozmU.useState)(0);
    const MAX_ONBOARDING_PULLS = 3;
    const shouldIncludeItem = (0, $cozmU.useCallback)((item)=>(0, $73voS.isVisibleFollowingFeedNode)(item), []);
    const hasNextPage = data?.feed?.pageInfo?.hasNextPage && ((0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test') ? consecutiveOnboardingPulls < MAX_ONBOARDING_PULLS : true);
    const endCursor = data?.feed?.pageInfo?.endCursor;
    const allResults = data?.feed?.nodes || [];
    const results = allResults.filter(shouldIncludeItem);
    const servingRecommendations = !!data?.getFeedUserConfig?.servingRecommendations;
    const isFollowingEmptyStateBanner = Boolean(data) && results.length === 0 && (0, $6mKj3.expVal)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', false);
    const { showFeedRecs: showFeedRecs, setShowFeedRecs: setShowFeedRecs, recsLoading: recsLoading, recs: recs, setRecs: setRecs, feedRecError: feedRecError } = (0, $lYst4.useFeedRecommendations)();
    const shouldHideComments = (0, $gusOH.useFeedShouldHideComments)();
    (0, $cozmU.useEffect)(()=>{
        if (data && allResults.length > 0 && results.length === 0 && (0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) setConsecutiveOnboardingPulls(1);
    }, [
        data,
        allResults.length,
        results.length
    ]);
    const linkButtonTheme = (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                fontWeight: "var(--ds-font-weight-regular, 400)"
            },
            spinnerStyles: spinnerStyles
        };
    };
    const injectFeedSortByIntoCursor = (cursor, feedSortBy)=>{
        if (!feedSortBy) return cursor;
        const decodedCursor = atob(cursor);
        const parsedCursor = JSON.parse(decodedCursor);
        if (parsedCursor.feedSortOrder === feedSortBy.toUpperCase()) return cursor;
        return btoa(JSON.stringify({
            ...parsedCursor,
            feedSortOrder: feedSortBy.toUpperCase()
        }));
    };
    const loadNextPage = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: (0, $9yPX0.FETCH_MORE_PAGE_SIZE),
                    after: endCursor,
                    sortBy: followingFeedSortBy
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                     // Deep clone required — a shallow spread shares node references with Apollo's
                    // InMemoryCache and corrupts the cache write on fetchMore.
                    const fetchMoreResultCopy = JSON.parse(JSON.stringify(fetchMoreResult));
                    const newNodes = fetchMoreResultCopy.feed?.nodes || [];
                    const filteredNewNodes = newNodes.filter(shouldIncludeItem);
                    if ((0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) {
                        if (filteredNewNodes.length === 0 && newNodes.length > 0) setConsecutiveOnboardingPulls((prev)=>prev + 1);
                        else setConsecutiveOnboardingPulls(0);
                    }
                    if (fetchMoreResultCopy.feed?.nodes && prevResults.feed?.nodes) {
                        fetchMoreResultCopy.feed.nodes = prevResults.feed.nodes.concat(filteredNewNodes);
                        if (fetchMoreResultCopy.feed.pageInfo.endCursor) fetchMoreResultCopy.feed.pageInfo.endCursor = injectFeedSortByIntoCursor(fetchMoreResultCopy.feed.pageInfo.endCursor, followingFeedSortBy);
                        else fetchMoreResultCopy.feed.pageInfo.endCursor = prevResults.feed?.pageInfo?.endCursor ?? '';
                    }
                    return fetchMoreResultCopy;
                }
            });
            if (newResult.data) {
                const previousVisibleCount = (data?.feed?.nodes || []).filter(shouldIncludeItem).length;
                const newVisibleCount = (newResult.data.feed?.nodes || []).filter(shouldIncludeItem).length;
                const visibleItemsAdded = newVisibleCount - previousVisibleCount;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'paginated',
                        actionSubject: 'feed',
                        source: 'homeScreen',
                        attributes: {
                            resultCount: visibleItemsAdded
                        }
                    }
                }).fire();
            }
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        endCursor,
        fetchMore,
        followingFeedSortBy,
        createAnalyticsEvent,
        data,
        setConsecutiveOnboardingPulls,
        shouldIncludeItem
    ]);
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    const handleManageButtonClick = (0, $cozmU.useCallback)(()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'editFeed',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openActivityFilterModal
    ]);
    const shouldFallbackBasedOnCursor = (cursor)=>{
        if (!cursor) return false;
        try {
            const decodedCursor = atob(cursor);
            const parsedCursor = JSON.parse(decodedCursor);
            return results.length > 0 ? parsedCursor.fallbackToAllActivity ?? false : false;
        } catch  {
            return false;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !isFollowingEmptyStateBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $YAWAX.FeedOnboardingMessage), {
        openActivityFilterModal: openActivityFilterModal,
        servingRecommendations: servingRecommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        openActivityFilterModal: openActivityFilterModal,
        feedType: (0, $4yg2A.FeedType).FOLLOWING,
        hasFollowedAnyone: hasFollowedAnyone,
        hasResults: results.length > 0
    }, shouldFallbackBasedOnCursor(endCursor) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "fallback-to-all-activity-banner",
        className: (0, $hekY6.default)([
            "_2uo31fMfVm _4FKVYE8HPE _0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _2fwxA5ecOK _1DCdHi5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($6408708fd25031c0$export$a7357cdd1f0b0168.allActivity))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        onClick: handleManageButtonClick,
        theme: linkButtonTheme,
        appearance: "link",
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($6408708fd25031c0$export$a7357cdd1f0b0168.manageFeed))))), results.map((result, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: result.content?.id
        }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28g78.FeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation,
            shouldHideComments: shouldHideComments,
            followingFeedSortBy: followingFeedSortBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "following-feed",
            feedCardIndex: index
        }), index === 2 && showFeedRecs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2uo31f7Cj1 _4FKVYEzcuf _4bt5LAnQyn _2WAcuGnQyn _30huDKOeNX _0bjKvD8fU6 _1mT5xdRAKS _1wydGW5zaO _1DCdHi5zaO _0jFU0V5UNa _3fSdSTzwhj"
            ])
        }, recsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "large"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FX3K.FeedRecommendations), {
            position: index + 1,
            setShowFeedRecs: setShowFeedRecs,
            recs: recs,
            setRecs: setRecs,
            feedRecError: feedRecError
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "following-feed",
            isAfterRecommendations: true
        })));
    })));
};
module.exports["ActivityFeedCards"] = $6408708fd25031c0$export$3e88c5c2a61da20e;

});

parcelRegister("1Itw6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $5T18X = parcelRequire("5T18X");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $4yg2A = parcelRequire("4yg2A");


var $73voS = parcelRequire("73voS");


var $9yPX0 = parcelRequire("9yPX0");


var $6wpcc = parcelRequire("6wpcc");


var $3xaH7 = parcelRequire("3xaH7");


var $8BIV2 = parcelRequire("8BIV2");


var $6zZYs = parcelRequire("6zZYs");

function $9a8dddbd019a8775$export$7bdb387412b5d100(results) {
    const deduplicatedResultsMap = new Map();
    const removedResultsMap = new Map();
    results.forEach((item, index)=>{
        const id = item?.content?.id;
        if (!id) return;
        if (deduplicatedResultsMap.has(id)) removedResultsMap.set(id, {
            index: index,
            id: id
        });
        else deduplicatedResultsMap.set(id, item);
    });
    return {
        deduplicatedResults: Array.from(deduplicatedResultsMap.values()),
        removedResults: Array.from(removedResultsMap.values())
    };
}
const $9a8dddbd019a8775$export$6551caf568a95d42 = ({ popularFeedQuery: popularFeedQuery, handleFocusRef: handleFocusRef, popularFeedTimeGranularity: popularFeedTimeGranularity })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = popularFeedQuery;
    const hasNextPage = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? false : data?.popularFeed?.pageInfo?.hasNextPage;
    const endCursor = data?.popularFeed?.pageInfo?.endCursor;
    const allResults = data?.popularFeed?.nodes;
    const results = (0, $cozmU.useMemo)(()=>(allResults ?? []).filter((0, $73voS.isVisiblePopularFeedNode)), [
        allResults
    ]);
    const { deduplicatedResults: deduplicatedResults, removedResults: removedResults } = $9a8dddbd019a8775$export$7bdb387412b5d100(results);
    // Build a stable Set of removed content IDs to use as a useEffect dependency
    // instead of JSON.stringify(removedResults), which serializes on every render.
    const removedResultIds = removedResults.map(({ id: id })=>id).join(',');
    const finalResults = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? deduplicatedResults.slice(0, 3) : deduplicatedResults;
    // When the Popular empty-state banner is shown (feed empty + experiment on), it should be the
    // only promoted surface in the slot, so suppress the mobile app promo above it. Gated behind
    // the experiment so legacy behaviour is preserved for users not in the experiment; the
    // experiment call is last so exposure only fires for users with an empty Popular feed.
    const shouldSuppressMobilePromoForEmptyStateBanner = finalResults.length === 0 && (0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true);
    const loadNextPage = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: (0, $9yPX0.FETCH_MORE_PAGE_SIZE),
                    after: endCursor,
                    timeGranularity: popularFeedTimeGranularity
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult || !fetchMoreResult.popularFeed) return prevResults;
                    // Deep clone required — a shallow spread shares node references with Apollo's
                    // InMemoryCache and corrupts the cache write on fetchMore.
                    const fetchMoreResultCopy = JSON.parse(JSON.stringify(fetchMoreResult));
                    if (prevResults.popularFeed?.nodes) fetchMoreResultCopy.popularFeed.nodes = prevResults.popularFeed.nodes.concat(fetchMoreResultCopy.popularFeed.nodes);
                    return fetchMoreResultCopy;
                }
            });
            if (newResult.data) {
                const newVisibleCount = newResult.data?.popularFeed?.nodes.filter((0, $73voS.isVisiblePopularFeedNode)).length ?? 0;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'paginated',
                        actionSubject: 'popularFeed',
                        source: 'homeScreen',
                        attributes: {
                            resultCount: newVisibleCount
                        }
                    }
                }).fire();
            }
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        fetchMore,
        createAnalyticsEvent,
        endCursor,
        popularFeedTimeGranularity
    ]);
    (0, $cozmU.useEffect)(()=>{
        removedResults.forEach(({ index: index, id: id })=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'duplicate',
                    actionSubjectId: 'popularFeedCard',
                    source: 'homeScreen',
                    attributes: {
                        ranking: index,
                        contentId: id
                    }
                }
            }).fire();
        });
    // Only report when removed results change. We use a joined string of IDs
    // (removedResultIds) as a stable dependency instead of JSON.stringify(removedResults),
    // which would serialize the full array on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        removedResultIds
    ]);
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        feedType: (0, $4yg2A.FeedType).POPULAR,
        hasResults: finalResults.length > 0
    }, (0, $1xpoY.default).getBoolean('cc_mobile_app_promo_popular_feed_config', false) && !shouldSuppressMobilePromoForEmptyStateBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wpcc.MobileAppPromo), null), finalResults.map((result, index)=>{
        return result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: result.content.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3xaH7.PopularFeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation,
            timeGranularity: popularFeedTimeGranularity
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "popular-feed",
            feedCardIndex: index
        }));
    }));
};
module.exports["PopularFeedCards"] = $9a8dddbd019a8775$export$6551caf568a95d42;

});

parcelRegister("cjYUn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $56QzY = parcelRequire("56QzY");


var $9bkOo = parcelRequire("9bkOo");

const $7958fdcfcd0693ed$export$fee5b5a066c6d977 = (feedType, followingFeedData, popularFeedData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isFollowing = feedType === (0, $9bkOo.FeedType).FOLLOWING;
    const isPopular = feedType === (0, $9bkOo.FeedType).POPULAR;
    const hasData = isFollowing ? Boolean(followingFeedData) : Boolean(popularFeedData);
    const resultCount = (isFollowing ? followingFeedData?.feed?.nodes?.length : popularFeedData?.popularFeed?.nodes?.length) || 0;
    const spacesFollowing = isFollowing ? followingFeedData?.getFeedUserConfig?.spaces?.length || 0 : undefined;
    const peopleFollowing = isFollowing ? followingFeedData?.getFeedUserConfig?.users?.length || 0 : undefined;
    // should fire the "rendered" analytics event only once,
    // including when switching between feed types
    const renderedEventLastFeedTypeRef = (0, $cozmU.useRef)('');
    const firedRenderedEvent = feedType === renderedEventLastFeedTypeRef.current;
    (0, $cozmU.useEffect)(()=>{
        if (hasData && !firedRenderedEvent) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'homeScreen',
                    action: 'rendered',
                    actionSubject: 'feed',
                    actionSubjectId: 'feedAlpha',
                    attributes: {
                        feedType: feedType.toLowerCase(),
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        homeVersion: 'visualRefresh',
                        ...isFollowing || isPopular ? {
                            resultCount: resultCount,
                            // TODO: The logic of this entire hook must be reworked so that the workaround below is no longer necessary.
                            // resultCount will only be 2 on SSR load, so there is no risk to this change (CCI-1817).
                            isSSR: resultCount === 2,
                            spacesFollowing: spacesFollowing,
                            peopleFollowing: peopleFollowing
                        } : {}
                    }
                }
            }).fire();
            renderedEventLastFeedTypeRef.current = feedType;
        }
    }, [
        hasData,
        feedType,
        resultCount,
        spacesFollowing,
        peopleFollowing,
        firedRenderedEvent,
        isFollowing,
        isPopular,
        createAnalyticsEvent
    ]);
};
module.exports["useFeedRenderedTrackEvent"] = $7958fdcfcd0693ed$export$fee5b5a066c6d977;

});

parcelRegister("8cmRU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7c187e9ac8c8c769$export$6bf07b55b4e954e1 = ()=>{
    const [activityFilterModalOpen, setActivityFilterModalOpen] = (0, $cozmU.useState)(false);
    const openActivityFilterModal = (0, $cozmU.useCallback)(()=>{
        setActivityFilterModalOpen(true);
    }, [
        setActivityFilterModalOpen
    ]);
    const closeActivityFilterModal = (0, $cozmU.useCallback)(()=>{
        setActivityFilterModalOpen(false);
    }, [
        setActivityFilterModalOpen
    ]);
    return {
        activityFilterModalOpen: activityFilterModalOpen,
        openActivityFilterModal: openActivityFilterModal,
        closeActivityFilterModal: closeActivityFilterModal
    };
};
module.exports["useActivityFilterModalState"] = $7c187e9ac8c8c769$export$6bf07b55b4e954e1;

});

parcelRegister("d442j", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $7ZB0A = parcelRequire("7ZB0A");


var $iKkTC = parcelRequire("iKkTC");

const $777d195b4cddad40$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorHeader: {
        id: "feed.error.generic.header",
        defaultMessage: "We couldn\u2019t load the feed"
    },
    errorDescription: {
        id: "feed.error.generic.description",
        defaultMessage: "Refresh to try again."
    },
    buttonText: {
        id: "feed.error.generic.button.text",
        defaultMessage: "Refresh"
    }
});
const $777d195b4cddad40$var$GenericFeedErrorComponent = ({ intl: intl })=>{
    const handleRefreshPage = (0, $cozmU.useCallback)(()=>{
        window.location.reload();
    }, []);
    const refreshButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: handleRefreshPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $777d195b4cddad40$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage($777d195b4cddad40$export$a7357cdd1f0b0168.errorHeader),
        description: intl.formatMessage($777d195b4cddad40$export$a7357cdd1f0b0168.errorDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iKkTC))),
        imageHeight: 95,
        primaryAction: refreshButton
    });
};
const $777d195b4cddad40$export$cb06f6f9ccf65f65 = (0, $kSwu1.injectIntl)($777d195b4cddad40$var$GenericFeedErrorComponent);
module.exports["GenericFeedError"] = $777d195b4cddad40$export$cb06f6f9ccf65f65;

});

parcelRegister("28g78", function(module, exports) {
/* FeedCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $fs6LW = parcelRequire("fs6LW");


var $8rneB = parcelRequire("8rneB");


var $fgRQY = parcelRequire("fgRQY");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $1RkMx = parcelRequire("1RkMx");


var $fYx4v = parcelRequire("fYx4v");

var $6OiEk = parcelRequire("6OiEk");


var $3WnxN = parcelRequire("3WnxN");


var $9HGVt = parcelRequire("9HGVt");


var $dKup5 = parcelRequire("dKup5");


var $fWjNm = parcelRequire("fWjNm");


var $cYSIK = parcelRequire("cYSIK");


var $gW7vR = parcelRequire("gW7vR");


var $hsR9s = parcelRequire("hsR9s");

const $61d33b405399253c$var$simpleWrapperStyle = null;
const $61d33b405399253c$export$a5a8a7b85f8f9317 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_2uo31fqi9L _30huDKOeNX _0bjKvD8fU6 _4FKVYE5zaO _3iDTPbQ4SZ _0aFT5v1qpb _1DCdHi8HPE _0luBOg98eZ _2h5UOz0Rl6 _3W2WEt6wH8 _1Oh6lc98eZ _38ddKyYbGa _4i4dA66wH8 _0DlTgX98eZ _27PHXJ0Rl6 _2IWu1s6wH8 _0Dldr1N91d"
        ])
    });
const $61d33b405399253c$var$wrapperStyle = null;
const $61d33b405399253c$var$actionMenuStyle = null;
const $61d33b405399253c$var$fadeIn = null;
const $61d33b405399253c$var$fadeInAnimation = null; // Note: this component extracts the props that we don't want to send to the DOM
const $61d33b405399253c$export$e6dfd72ab29f8598 = ({ isActionMenuOpen: isActionMenuOpen, disableAnimation: disableAnimation, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...rest,
        className: (0, $hekY6.default)([
            "_2uo31fqi9L _30huDKOeNX _0bjKvD8fU6 _4FKVYE5zaO _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5v1qpb _1DCdHi8HPE _2FQ0OxdnbC _3fSdSTzwhj _46URyz7zJH _06ZIf37zJH _0ReiIH7zJH _2U1j4nHZdu _1mn8dVHZdu _4gEIokHZdu _39Ohv4YbGa _1SdfoHYbGa",
            isActionMenuOpen && "_2FQ0OxHZdu",
            !disableAnimation && "",
            !disableAnimation && "_2fBhteWOhi"
        ])
    });
const $61d33b405399253c$var$avatarWrapperStyle = null;
const $61d33b405399253c$var$contentWrapperStyle = null;
const $61d33b405399253c$var$summaryLineStyle = null;
const $61d33b405399253c$var$summaryLineRelevantActionStyle = null;
const $61d33b405399253c$var$summaryLineActionsStyle = null;
const $61d33b405399253c$var$spacerStyle = null;
const $61d33b405399253c$export$f7c7741d7ae5c510 = /*#__PURE__*/ (0, $cozmU.memo)(({ feedItem: feedItem, ranking: ranking, disableAnimation: disableAnimation, shouldHideComments: shouldHideComments, followingFeedSortBy: followingFeedSortBy })=>{
    const isMounted = (0, $dKup5.useIsMounted)();
    const [, setHasBeenHovered] = (0, $cozmU.useState)(false);
    const [isActionMenuOpen] = (0, $cozmU.useState)(false);
    const bottomOfCardRef = (0, $cozmU.useRef)(null);
    const mainUpdate = feedItem.summaryLineUpdate;
    const recentActionsCount = feedItem.recentActionsCount;
    const mainUpdateUserId = (0, $1RkMx.getUserAccountId)(mainUpdate.user);
    const updateType = mainUpdate?.type;
    const contentUrl = (0, $1RkMx.getContentLink)(feedItem.content);
    const updateTime = mainUpdate?.datetime;
    const contentId = feedItem?.content?.id || '';
    const updateLink = (0, $1RkMx.getLinkForSummaryLinkUpdate)(mainUpdate, contentUrl, contentId);
    const contentType = feedItem?.content?.type || 'page';
    const contentSubType = feedItem?.content?.subType;
    const contentTitle = feedItem?.content?.title || '';
    const contentExcerpt = feedItem.content?.excerpt;
    const aiSnippet = feedItem?.content?.aiProperty?.objectData;
    const authorName = feedItem?.content?.history?.createdBy?.displayName || '';
    const ownerName = feedItem?.content?.history?.ownedBy?.displayName || '';
    const spaceId = feedItem?.content?.space?.id || '';
    const spaceName = feedItem?.content?.space?.name || '';
    const emoji = (0, $8rneB.getEmojiValueFromContent)(feedItem.content);
    const numComments = feedItem?.content?.metadata?.comments?.commentsCount || 0;
    const spaceUrl = (0, $1RkMx.getSpaceLink)(feedItem.content);
    const authorId = (0, $1RkMx.getUserAccountId)(feedItem.content?.history?.createdBy) || '';
    const ownerId = (0, $1RkMx.getUserAccountId)(feedItem.content?.history?.ownedBy) || '';
    const hasNullComment = updateType === (0, $fWjNm.FeedEventType).COMMENT && mainUpdate.comment === null;
    const supportedEvent = (0, $1RkMx.isSupportedEvent)(feedItem.summaryLineUpdate.type);
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    const hasAiSnippet = aiSnippet && (0, $6mKj3.expValEquals)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true);
    const summaryContent = hasAiSnippet ? aiSnippet : contentExcerpt;
    const sourceIds = feedItem.source.reduce((filtered, source)=>{
        if (source === (0, $fWjNm.FeedItemSourceType).PERSON && mainUpdateUserId) filtered.push(mainUpdateUserId);
        else if (source === (0, $fWjNm.FeedItemSourceType).SPACE && spaceId) filtered.push(spaceId);
        return filtered;
    }, []);
    const handleMouseEnter = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        setHasBeenHovered(true);
    }, [
        setHasBeenHovered
    ]);
    const fireAnalyticsEvent = (0, $9HGVt.useFeedCardAnalyticsEvents)(contentId, spaceId, 'following', {
        ranking: ranking,
        contentType: contentType,
        updateType: updateType,
        sourceIds: sourceIds,
        isFromSource: feedItem.source,
        recentActionsCount: recentActionsCount,
        commentsCount: numComments,
        lastUpdated: new Date(mainUpdate.datetime).getTime()
    });
    const onObserved = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'observed',
            actionSubject: 'feedCard'
        });
    }, [
        fireAnalyticsEvent
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onObserved);
    (0, $cozmU.useEffect)(()=>{
        if (hasNullComment) fireAnalyticsEvent({
            type: 'sendOperationalEvent',
            action: 'hidden',
            actionSubject: 'nullCommentFeedCard'
        });
    }, [
        hasNullComment,
        fireAnalyticsEvent
    ]);
    const feedCardContextValue = (0, $cozmU.useMemo)(()=>({
            fireAnalyticsEvent: fireAnalyticsEvent
        }), [
        fireAnalyticsEvent
    ]);
    if (hasNullComment || !supportedEvent) return null;
    const cardHref = shouldHideComments && updateType === (0, $fWjNm.FeedEventType).COMMENT ? updateLink : contentUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYSIK.FeedCardContext).Provider, {
        value: feedCardContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "feed-card",
        preloadUrl: cardHref,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61d33b405399253c$export$e6dfd72ab29f8598, {
        "data-testid": "feed-card",
        isActionMenuOpen: isActionMenuOpen,
        disableAnimation: isMounted || disableAnimation,
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsR9s.FeedCardInvisibleFullSizedLink), {
        href: cardHref,
        contentType: contentType,
        followingFeedSortBy: followingFeedSortBy,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1Znuxb5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: mainUpdateUserId,
        src: mainUpdate.user?.profilePicture?.path || '',
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _1DCdHi8HPE"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _4FKVYE1Y8M _2XghbE5UaJ _3iDTPbQ4SZ _0aFT5v1qpb _1UtDYzZpcK _39HuIbz8Lp _1ANEUSLRg7 _0hPCNLDIqT _2O5Vij7dHp _0adFHs1Y8M"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYx4v.ActivityLineUpdateLink), {
        type: updateType,
        userDisplayName: mainUpdate.user?.displayName || null,
        link: updateLink,
        groupSize: mainUpdate.groupSize,
        activityDropdownLineItem: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XghbEChhn"
        ])
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WnxN.ActionTime), {
        actionTime: updateTime
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
        ])
    }, (recentActionsCount > 1 || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_analytics_use_topn_query_in_feed_experiment', 'cohort', 'test')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OiEk.AllActivityDropdown), {
        contentUrl: contentUrl,
        contentId: contentId,
        recentActionsCount: recentActionsCount,
        shouldShowRecentActionsCountNumber: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_analytics_use_topn_query_in_feed_experiment', 'cohort', 'control') === 'control'
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gW7vR.FeedCardBody), {
        contentId: contentId,
        emoji: emoji,
        contentTitle: contentTitle,
        contentType: contentType,
        contentSubType: contentSubType,
        contentUrl: contentUrl,
        spaceId: spaceId,
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        authorName: authorName,
        authorId: authorId,
        ownerName: ownerName,
        ownerId: ownerId,
        contentExcerpt: summaryContent,
        numComments: numComments,
        comment: updateType === (0, $fWjNm.FeedEventType).COMMENT ? mainUpdate : undefined,
        source: "following-feed",
        shouldHideComments: shouldHideComments,
        followingFeedSortby: followingFeedSortBy,
        hasAiSnippet: !!hasAiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: bottomOfCardRef
    }))))));
});
module.exports["SimpleWrapper"] = $61d33b405399253c$export$a5a8a7b85f8f9317;
module.exports["Wrapper"] = $61d33b405399253c$export$e6dfd72ab29f8598;
module.exports["FeedCard"] = $61d33b405399253c$export$f7c7741d7ae5c510;

});

parcelRegister("6GgH7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ef487b545dccb1a5$export$e75d2edbfa99b7d8 = (0, $cozmU.createContext)({
    feedSessionId: null
});
module.exports["FeedContext"] = $ef487b545dccb1a5$export$e75d2edbfa99b7d8;

});

parcelRegister("73voS", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $92da2dfaff95b756$export$72b10860f30c3e76 = (item)=>item?.content?.contentProperties?.latest?.generatedBy !== 'ONBOARDING' || !(0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test');
const $92da2dfaff95b756$export$9531f809d2adc26d = (item)=>{
    if (item?.content?.labels?.nodes?.some((value)=>value?.name === 'farewell-blog' || value?.name === 'welcome-blog') && ((0, $9wGTI.fg)('confluence_welcome_farewell_feed') || (0, $1xpoY.default).getBoolean('confluence-welcome-farewell-feed-internal', false))) return false;
    if (item?.content?.contentProperties?.latest?.generatedBy === 'ONBOARDING' && (0, $6mKj3.expValEquals)('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')) return false;
    return true;
};
module.exports["isVisibleFollowingFeedNode"] = $92da2dfaff95b756$export$72b10860f30c3e76;
module.exports["isVisiblePopularFeedNode"] = $92da2dfaff95b756$export$9531f809d2adc26d;

});

parcelRegister("anKV5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5T18X = parcelRequire("5T18X");


var $kyKWe = parcelRequire("kyKWe");


var $17wUi = parcelRequire("17wUi");

const $dd9b0509e0327438$export$f76be7c0556c5409 = (feedContentQuery, sessionStorageKey)=>{
    // Fetch the initial feed id from session storage or generate a new one
    const feedSessionIdInitial = feedContentQuery.data ? (0, $17wUi.confluenceSessionStorageInstance)?.getItem(sessionStorageKey) || (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const [feedSessionId, setFeedSessionId] = (0, $cozmU.useState)(feedSessionIdInitial);
    // Update the session storage with the new feed id if it changes
    (0, $cozmU.useEffect)(()=>{
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem(sessionStorageKey, feedSessionId);
    }, [
        sessionStorageKey,
        feedSessionId
    ]);
    // Regenerate session id when refetching
    (0, $cozmU.useEffect)(()=>{
        if (feedContentQuery.networkStatus === (0, $5T18X.NetworkStatus).refetch) setFeedSessionId((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    }, [
        feedContentQuery.networkStatus
    ]);
    return feedSessionId;
};
module.exports["useFeedSession"] = $dd9b0509e0327438$export$f76be7c0556c5409;

});

parcelRegister("4kEyG", function(module, exports) {

var $kZ8dV = parcelRequire("kZ8dV");


var $cozmU = parcelRequire("cozmU");


var $5T18X = parcelRequire("5T18X");


var $9wGTI = parcelRequire("9wGTI");


var $8BIV2 = parcelRequire("8BIV2");


var $4yg2A = parcelRequire("4yg2A");


var $3xaH7 = parcelRequire("3xaH7");


var $6zZYs = parcelRequire("6zZYs");


var $jMyy4 = parcelRequire("jMyy4");

const $5c36509cc983df2b$var$FilterByLabelFeedQuery = (0, $kZ8dV.default);
const $5c36509cc983df2b$export$90b19fb7c85a6759 = ({ filterByLabel: filterByLabel, handleFocusRef: handleFocusRef })=>{
    const { data: data, loading: loading, error: error, networkStatus: networkStatus, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($5c36509cc983df2b$var$FilterByLabelFeedQuery, {
        variables: {
            cql: `label = "${filterByLabel}" AND created >= now(\"-2w\") order by created desc`,
            first: (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : 5
        },
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "feed"
    });
    const results = data?.search?.nodes || [];
    const hasNextPage = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? false : data?.search?.pageInfo?.hasNextPage || false;
    // Must convert `endCursor` to `string | undefined`; never null.
    const endCursor = data?.search?.pageInfo?.endCursor ?? undefined;
    const disableAnimation = Boolean(window.__SSR_RENDERED__ && networkStatus !== (0, $5T18X.NetworkStatus).fetchMore);
    const feedType = filterByLabel === 'welcome-blog' ? (0, $4yg2A.FeedType).WELCOME : (0, $4yg2A.FeedType).FAREWELL;
    const loadNextPage = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!endCursor) return undefined;
            const newResult = await fetchMore({
                variables: {
                    first: 5,
                    after: endCursor
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                    if (fetchMoreResult?.search?.nodes && prevResults?.search?.nodes) fetchMoreResult.search.nodes = prevResults.search.nodes.concat(fetchMoreResult.search.nodes);
                    return fetchMoreResult;
                }
            });
            if (newResult.errors) throw newResult.errors;
            return newResult;
        } catch (e) {
            throw e;
        }
    }, [
        fetchMore,
        endCursor
    ]);
    const feedItems = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? results.slice(0, 3) : results;
    // The `endCursor` *must* be passed in, otherwise the `InfiniteScroll` component paginates at most *once*.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BIV2.FeedCardsWrapper), {
        loading: loading,
        firstPageError: error,
        networkStatus: networkStatus,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loadNextPage: loadNextPage,
        feedType: feedType
    }, feedItems.map((result, index)=>{
        return result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: result.content?.id ?? index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3xaH7.PopularFeedCard), {
            feedItem: result,
            ranking: index,
            disableAnimation: disableAnimation
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zZYs.ExitFeedAllyButton), {
            onExit: handleFocusRef,
            source: "popular-feed",
            feedCardIndex: index
        }));
    }));
};
module.exports["FilterByLabelFeed"] = $5c36509cc983df2b$export$90b19fb7c85a6759;

});

parcelRegister("92tNT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f70d92fc830292bd$export$50d10e3ba5d10a60 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nDtMb",
    name: "LoadableMeetingsPanel",
    loader: async ()=>(await (parcelRequire("76C68"))).MeetingsPanelWithProvider
});
module.exports["LoadableMeetingsPanel"] = $f70d92fc830292bd$export$50d10e3ba5d10a60;

});

parcelRegister("hJGpd", function(module, exports) {
/* MeetingsPillNewLozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

const $f11cd2798946334f$var$i18n = (0, $kSwu1.defineMessages)({
    newLozenge: {
        id: "feed.meetings.pill.new-lozenge",
        defaultMessage: "New"
    }
});
const $f11cd2798946334f$var$styles = {
    lozenge: "_0bjKvDKxmn _2sNsIg7NXe _2Y7lL41Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKHceTh _3iDTPbccYA _0hPCNLDIqT _2XsHFM2ADO _0jFU0Vey7F _0KLXru66of _1UtDYzy7kJ _1kk5Tkf7mX _41LZZBAv7U _1ANEUSLRg7"
}; /**
    * The "New" badge rendered next to the Meetings pill title.
    * Outlined discovery style (transparent fill, purple border) per design.
    * Visibility is decided by the caller (see useMeetingsPillNewLozenge).
    */ 
const $f11cd2798946334f$export$2e68a48dc8ad7ccf = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $f11cd2798946334f$var$styles.lozenge
    }, formatMessage($f11cd2798946334f$var$i18n.newLozenge));
};
module.exports["MeetingsPillNewLozenge"] = $f11cd2798946334f$export$2e68a48dc8ad7ccf;

});

parcelRegister("927dV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ivb8S = parcelRequire("ivb8S");


var $kijQ0 = parcelRequire("kijQ0");

// Hide the "New" lozenge once EITHER of these thresholds is reached, whichever comes first.
const $287dbfb4c2f4d7fb$var$MAX_CLICK_COUNT = 3;
const $287dbfb4c2f4d7fb$var$MAX_DAYS_SINCE_FIRST_SEEN = 14;
const $287dbfb4c2f4d7fb$var$MS_PER_DAY = 86400000;
const $287dbfb4c2f4d7fb$export$edd349489c57e853 = (enabled)=>{
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $kijQ0.MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY),
        (0, $kijQ0.MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY)
    ], /* skip */ !enabled);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const state = (0, $ivb8S.deserializeState)(data);
    const firstSeenAt = state?.firstSeenAt;
    const clickCount = Number(state?.clickCount ?? 0);
    const hasReachedClickLimit = clickCount >= $287dbfb4c2f4d7fb$var$MAX_CLICK_COUNT;
    const hasExpired = !!firstSeenAt && Date.now() - new Date(firstSeenAt).getTime() >= $287dbfb4c2f4d7fb$var$MAX_DAYS_SINCE_FIRST_SEEN * $287dbfb4c2f4d7fb$var$MS_PER_DAY;
    const showLozenge = enabled && !loading && !error && !hasReachedClickLimit && !hasExpired;
    // Stamp the first-seen timestamp exactly once, the first time the lozenge is shown.
    // Guard on `!error` so a failed onboarding-state query doesn't record a bogus first-seen time.
    (0, $cozmU.useEffect)(()=>{
        if (enabled && !loading && !error && !firstSeenAt) setOnboardingState({
            key: (0, $kijQ0.MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY),
            value: new Date().toISOString()
        });
    }, [
        enabled,
        loading,
        error,
        firstSeenAt,
        setOnboardingState
    ]);
    const incrementClickCount = (0, $cozmU.useCallback)(()=>{
        // Once the limit is hit there's no need to keep writing.
        if (clickCount >= $287dbfb4c2f4d7fb$var$MAX_CLICK_COUNT) return;
        setOnboardingState({
            key: (0, $kijQ0.MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY),
            value: String(clickCount + 1)
        });
    }, [
        clickCount,
        setOnboardingState
    ]);
    return {
        showLozenge: showLozenge,
        incrementClickCount: incrementClickCount
    };
};
module.exports["useMeetingsPillNewLozenge"] = $287dbfb4c2f4d7fb$export$edd349489c57e853;

});

parcelRegister("215Eu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $1TvTa = parcelRequire("1TvTa");


var $fBqzD = parcelRequire("fBqzD");


var $4yg2A = parcelRequire("4yg2A");


var $k11sS = parcelRequire("k11sS");

const $29db5a39384177a9$var$i18n = (0, $kSwu1.defineMessages)({
    following: {
        id: "feed.card.categories.following",
        defaultMessage: "Following"
    },
    popular: {
        id: "feed.card.categories.popular",
        defaultMessage: "Popular"
    }
});
const $29db5a39384177a9$var$containerStyle = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.050'
});
const $29db5a39384177a9$export$55981cdcb801b395 = ({ selectedFeedType: selectedFeedType, setSelectedFeedType: setSelectedFeedType, customPanels: customPanels, popularFeedPillRef: popularFeedPillRef, followingFeedPillRef: followingFeedPillRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $29db5a39384177a9$var$containerStyle,
        wrap: "wrap",
        role: "tablist",
        "aria-labelledby": "tablist-feedtypes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k11sS.FeedTypePill), {
        feedType: (0, $4yg2A.FeedType).FOLLOWING,
        selectedFeedType: selectedFeedType,
        setFeedType: setSelectedFeedType,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))),
        ref: followingFeedPillRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29db5a39384177a9$var$i18n.following)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k11sS.FeedTypePill), {
        feedType: (0, $4yg2A.FeedType).POPULAR,
        selectedFeedType: selectedFeedType,
        setFeedType: setSelectedFeedType,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))),
        ref: popularFeedPillRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $29db5a39384177a9$var$i18n.popular)), customPanels && customPanels.map((item)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k11sS.FeedTypePill), {
            key: item.key,
            feedType: item.key,
            selectedFeedType: selectedFeedType,
            setFeedType: setSelectedFeedType,
            Icon: item.icon,
            ref: item.ref,
            isPulseActive: item.isPulseActive,
            onPulseClick: item.onPulseClick,
            titleSuffix: item.titleSuffix,
            onSelect: item.onSelect
        }, item.title);
    }));
};
module.exports["FeedTypeSelector"] = $29db5a39384177a9$export$55981cdcb801b395;

});

parcelRegister("YAWAX", function(module, exports) {
/* FeedOnboardingMessage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");


var $9oxdN = parcelRequire("9oxdN");


var $b3j2Y = parcelRequire("b3j2Y");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $9yPX0 = parcelRequire("9yPX0");


var $16IT4 = parcelRequire("16IT4");


var $do0Qf = parcelRequire("do0Qf");


var $kNKJA = parcelRequire("kNKJA");


var $bIIJl = parcelRequire("bIIJl");

const $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    headerTitle: {
        id: "feed.header.title",
        defaultMessage: "We\u2019re keeping you in the loop"
    },
    headerDescription: {
        id: "feed.header.description",
        defaultMessage: "Stay in-the-know by following people and spaces. Their activity will show up in your feed, but you won\u2019t receive email notifications about it. Add to, or edit, your feed anytime."
    },
    editFeed: {
        id: "feed.header.editFeed",
        defaultMessage: "Edit feed"
    },
    closeMessageLabel: {
        id: "feed.header.closeLabel",
        defaultMessage: "Close message box"
    },
    headerDescriptionV2: {
        id: "feed.header.description.v2",
        defaultMessage: "We\u2019ve automatically followed top recommended spaces and people for you, so you never miss important updates. You can add or remove spaces and people from your feed at any time to tailor what you see."
    },
    customizeFeed: {
        id: "feed.header.customizeFeed",
        defaultMessage: "Customize feed"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$BodyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKOeNX _0bjKvD8fU6 _2uo31flfZc _4FKVYEBGue _24h04i2Njc _3iDTPbQ4SZ _1DCdHiNHnM",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$MessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _0adFHskG2W _1DCdHiNHnM",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$descriptionTextStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3b8f8d03a12c5fa$var$OnBoardingImage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $cJ0FD.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlgZxp _0NUa3roaux _3YEZNOdnbC _4xdlr0z9WS _0adFHs2ADO",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$CloseButtonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC",
            __cmplp.className
        ])
    });
});
const $c3b8f8d03a12c5fa$var$defaultContentConfig = {
    lightImage: (0, (/*@__PURE__*/$parcel$interopDefault($do0Qf))),
    darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($16IT4))),
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "large",
        weight: "regular"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerDescription)),
    button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.editFeed),
    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "large",
        weight: "regular"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerTitle)))
};
const $c3b8f8d03a12c5fa$var$autoFollowContentConfig = {
    lightImage: (0, (/*@__PURE__*/$parcel$interopDefault($bIIJl))),
    darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($kNKJA))),
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "large",
        weight: "regular",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerDescriptionV2)),
    button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.customizeFeed)),
    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.headerTitle))
};
const $c3b8f8d03a12c5fa$var$FeedOnboardingMessageComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal, servingRecommendations: servingRecommendations })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [showFeature, stop, featureDiscoveryError] = (0, $9oxdN.useFeatureDiscovery)((0, $9yPX0.onboardingFeedHeaderCard));
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES);
    const { hasAutoFollowedSpaces: hasAutoFollowedSpaces } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const contentConfig = (0, $cozmU.useMemo)(()=>{
        if (hasAutoFollowedSpaces) // > 10 users
        return $c3b8f8d03a12c5fa$var$autoFollowContentConfig;
        return $c3b8f8d03a12c5fa$var$defaultContentConfig;
    }, [
        hasAutoFollowedSpaces
    ]);
    const error = featureDiscoveryError || onboardingStateError;
    (0, $cozmU.useEffect)(()=>{
        if ((servingRecommendations || Boolean(hasAutoFollowedSpaces)) && showFeature && !error && !onboardingStateLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: hasAutoFollowedSpaces
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        error,
        showFeature,
        servingRecommendations,
        onboardingStateLoading,
        hasAutoFollowedSpaces
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (onboardingStateLoading || !showFeature || // When spaces are auto-followed, servingRecommendations will be set to false
    // This is a workaround to ignore the value if the follow is not user-initiated
    !servingRecommendations && !hasAutoFollowedSpaces) return null;
    const handleClick = ()=>{
        openActivityFilterModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'feedOnboardingUpdateFeed',
                source: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: Boolean(hasAutoFollowedSpaces)
                }
            }
        }).fire();
    };
    const handleDismiss = ()=>{
        stop();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'feedOnboardingDismiss',
                source: 'feedOnboardingMessage',
                attributes: {
                    isAutoFollowContent: Boolean(hasAutoFollowedSpaces)
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b8f8d03a12c5fa$var$BodyContainer, {
        "data-testid": "feed-onboarding-message",
        "data-vc": "feed-onboarding-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b8f8d03a12c5fa$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, contentConfig.title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c3b8f8d03a12c5fa$var$descriptionTextStyles
    }, contentConfig.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleClick
    }, contentConfig.button))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b8f8d03a12c5fa$var$OnBoardingImage, {
        src: contentConfig.lightImage,
        srcDark: contentConfig.darkImage,
        width: "200",
        height: "160",
        alt: "",
        "data-vc": "following-onboarding-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b8f8d03a12c5fa$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: handleDismiss,
        spacing: "compact",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: intl.formatMessage($c3b8f8d03a12c5fa$export$a7357cdd1f0b0168.closeMessageLabel),
        isTooltipDisabled: false
    })));
};
const $c3b8f8d03a12c5fa$export$124b813167fe9112 = (0, $kSwu1.injectIntl)($c3b8f8d03a12c5fa$var$FeedOnboardingMessageComponent);
module.exports["FeedOnboardingMessage"] = $c3b8f8d03a12c5fa$export$124b813167fe9112;

});

parcelRegister("8FX3K", function(module, exports) {

var $dFUHi = parcelRequire("dFUHi");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $iW7aI = parcelRequire("iW7aI");


var $9DHhW = parcelRequire("9DHhW");


var $5SGpQ = parcelRequire("5SGpQ");


var $6TaGl = parcelRequire("6TaGl");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $I7hWB = parcelRequire("I7hWB");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $fgRQY = parcelRequire("fgRQY");


var $lIZtA = parcelRequire("lIZtA");


var $kPlM7 = parcelRequire("kPlM7");


var $b29u2 = parcelRequire("b29u2");

const $e3eb4432e25cc607$var$FeedRecommendationsFeedRecDismissMutation = (0, $dFUHi.default);
const $e3eb4432e25cc607$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "feed.recommendation.title",
        defaultMessage: "Improve your feed"
    },
    dismiss: {
        id: "feed.recommendation.dismiss",
        defaultMessage: "Hide suggestions"
    },
    dismissDescription: {
        id: "feed.recommendation.dismiss.description",
        defaultMessage: "Don\u2019t show this card for one month"
    },
    flagErrorTitle: {
        id: "feed.recommendation.flag.dismiss.error",
        defaultMessage: "Could not dismiss recommendations"
    },
    flagErrorDescription: {
        id: "feed.recommendation.flag.dismiss.error.description",
        defaultMessage: "Please try again later"
    },
    moreIconLabel: {
        id: "feed.recommendations.more.label",
        defaultMessage: "Show more options"
    },
    leftCarouselLabel: {
        id: "feed.recommendations.carousel.left",
        defaultMessage: "Scroll left"
    },
    rightCarouselLabel: {
        id: "feed.recommendations.carousel.right",
        defaultMessage: "Scroll right"
    }
});
const $e3eb4432e25cc607$var$menuButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            '&:hover': {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            },
            "&[aria-expanded='true']": {
                backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                color: "var(--ds-text-inverse, #FFFFFF)"
            }
        },
        spinnerStyles: spinnerStyles
    };
};
const $e3eb4432e25cc607$var$titleAndMenuWrapperStyle = null;
const $e3eb4432e25cc607$var$menuWrapperStyle = null;
const $e3eb4432e25cc607$var$tilesWrapperStyle = null;
const $e3eb4432e25cc607$var$isIgnorableError = (error)=>{
    return error.graphQLErrors.every((0, $lIZtA.isFeedRecDeletedSpaceError));
};
const $e3eb4432e25cc607$var$updateFeedRecDismiss = (_cache, { data: data })=>{
    const timestamp = data?.updateUserPreferences?.feedRecommendedUserSettingsDismissTimestamp;
    const cachedata = (0, $l1uFv.readQueryInterop)({
        query: (0, $b29u2.FeedRecommendationQuery),
        __callerPackage__: "feed"
    });
    if (timestamp && cachedata) {
        const newData = {
            ...cachedata
        };
        newData.userPreferences.feedRecommendedUserSettingsDismissTimestamp = timestamp;
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b29u2.FeedRecommendationQuery),
            data: newData,
            __callerPackage__: "feed"
        });
    }
};
const $e3eb4432e25cc607$var$FeedRecommendationsComponent = ({ position: position, recs: recs, setRecs: setRecs, feedRecError: feedRecError, setShowFeedRecs: setShowFeedRecs })=>{
    const intl = (0, $kSwu1.useIntl)();
    const bottomOfCardRef = (0, $cozmU.useRef)(null);
    const tilesWrapperRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [recOffset, setRecOffset] = (0, $cozmU.useState)(0);
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const recsToShow = recs.slice(recOffset, recOffset + (0, $kPlM7.PAGE_SIZE));
    const isRightmostPage = recOffset === recs.length - (0, $kPlM7.PAGE_SIZE) && recOffset !== 0;
    const onRecommendationsViewed = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestionsCard',
                source: 'homeScreen',
                attributes: {
                    pos: position,
                    numSuggestions: recs.length,
                    followSuggestions: recsToShow.map((rec)=>rec.id),
                    followSuggestionTypes: recsToShow.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        position,
        recs,
        recsToShow
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onRecommendationsViewed);
    const onDismissError = (0, $cozmU.useCallback)(()=>{
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e3eb4432e25cc607$var$i18n.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e3eb4432e25cc607$var$i18n.flagErrorDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag
    ]);
    const hideFeedRecs = ()=>{
        setShowFeedRecs(false);
    };
    const [dismissFeedRec, { error: dismissError }] = (0, $308Wd.useMutationInterop)($e3eb4432e25cc607$var$FeedRecommendationsFeedRecDismissMutation, {
        onCompleted: hideFeedRecs,
        update: $e3eb4432e25cc607$var$updateFeedRecDismiss,
        onError: onDismissError,
        __callerPackage__: "feed"
    });
    const handleDismissClick = (0, $cozmU.useCallback)(()=>{
        const date = new Date();
        dismissFeedRec({
            variables: {
                dismissTime: date.toISOString()
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'suggestionsDismissal',
                source: 'suggestionsCard',
                attributes: {
                    timestamp: date.toISOString(),
                    pos: position,
                    numSuggestions: recs.length,
                    followSuggestions: recsToShow.map((rec)=>rec.id),
                    followSuggestionTypes: recsToShow.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        dismissFeedRec,
        createAnalyticsEvent,
        position,
        recs,
        recsToShow
    ]);
    const scrollTilesWrapper = (0, $cozmU.useCallback)((newRecOffset)=>{
        if (tilesWrapperRef.current) {
            const scrollPosition = newRecOffset * (tilesWrapperRef.current.offsetWidth / (0, $kPlM7.PAGE_SIZE) - (0, $kPlM7.TILE_MARGIN) / (0, $kPlM7.PAGE_SIZE));
            tilesWrapperRef.current.scroll({
                left: scrollPosition,
                behavior: 'smooth'
            });
            setRecOffset(newRecOffset);
        }
    }, [
        tilesWrapperRef,
        setRecOffset
    ]);
    const dismissTile = (0, $cozmU.useCallback)((id)=>{
        const newRecs = recs.filter((rec)=>rec.id !== id);
        const newShownRecs = isRightmostPage ? newRecs.slice(recOffset - 1, recOffset - 1 + (0, $kPlM7.PAGE_SIZE)) : newRecs.slice(recOffset, recOffset + (0, $kPlM7.PAGE_SIZE));
        if (isRightmostPage) scrollTilesWrapper(recOffset - 1);
        setRecs(newRecs);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestionsCard',
                source: 'homeScreen',
                attributes: {
                    pos: position,
                    numSuggestions: newRecs.length,
                    followSuggestions: newShownRecs.map((rec)=>rec.id),
                    followSuggestionTypes: newShownRecs.map((rec)=>rec.type)
                }
            }
        }).fire();
    }, [
        recs,
        recOffset,
        isRightmostPage,
        setRecs,
        createAnalyticsEvent,
        position,
        scrollTilesWrapper
    ]);
    const handleLeftCarousel = (0, $cozmU.useCallback)(()=>{
        scrollTilesWrapper(Math.max(0, recOffset - 4));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'leftCarousel',
                source: 'suggestionsCard',
                attributes: {
                    pos: position
                }
            }
        }).fire();
    }, [
        scrollTilesWrapper,
        recOffset,
        createAnalyticsEvent,
        position
    ]);
    const handleRightCarousel = (0, $cozmU.useCallback)(()=>{
        scrollTilesWrapper(Math.min(recs.length - (0, $kPlM7.PAGE_SIZE), recOffset + 4));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'rightCarousel',
                source: 'suggestionsCard',
                attributes: {
                    pos: position
                }
            }
        }).fire();
    }, [
        recs,
        scrollTilesWrapper,
        recOffset,
        createAnalyticsEvent,
        position
    ]);
    const getDropdownTriggerButton = (0, $cozmU.useCallback)(({ triggerRef: triggerRef, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            ...props,
            ref: triggerRef,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: intl.formatMessage($e3eb4432e25cc607$var$i18n.moreIconLabel),
                spacing: "spacious"
            }),
            theme: $e3eb4432e25cc607$var$menuButtonTheme
        });
    }, [
        intl
    ]);
    if (feedRecError && !$e3eb4432e25cc607$var$isIgnorableError(feedRecError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: feedRecError
    });
    if (recs.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, dismissError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _1DCdHi2ADO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e3eb4432e25cc607$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        theme: $e3eb4432e25cc607$var$menuButtonTheme,
        onClick: handleLeftCarousel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
            label: intl.formatMessage($e3eb4432e25cc607$var$i18n.leftCarouselLabel),
            spacing: "spacious",
            size: "small"
        }),
        isDisabled: recOffset === 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        theme: $e3eb4432e25cc607$var$menuButtonTheme,
        onClick: handleRightCarousel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: intl.formatMessage($e3eb4432e25cc607$var$i18n.rightCarouselLabel),
            spacing: "spacious",
            size: "small"
        }),
        isDisabled: isRightmostPage || recs.length <= (0, $kPlM7.PAGE_SIZE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-end",
        trigger: getDropdownTriggerButton,
        testId: "feed-rec-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleDismissClick,
        description: intl.formatMessage($e3eb4432e25cc607$var$i18n.dismissDescription)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e3eb4432e25cc607$var$i18n.dismiss))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: tilesWrapperRef,
        "data-testid": "feed-rec-tiles-wrapper",
        className: (0, $hekY6.default)([
            "_2XghbEReCs _4FKVYEx7Ub _3iDTPbQ4SZ _37wbyuchRC _4bt5LAIZbP _1OHb6iLkD4 _0Dw3YSey7F _0jfunhYbGa _3oUqlsYbGa _1pp6NdYbGa _3cvhttYbGa"
        ])
    }, recs.map((rec, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kPlM7.RecommendationTile), {
            key: rec.id,
            name: rec.name,
            id: rec.id,
            url: rec.url,
            icon: rec.icon,
            type: rec.type,
            title: rec.title,
            dismissTile: dismissTile,
            cardIndex: index,
            position: position
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: bottomOfCardRef
    }));
};
const $e3eb4432e25cc607$export$e370efd4e286ab04 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e3eb4432e25cc607$var$FeedRecommendationsComponent, props));
});
module.exports["FeedRecommendations"] = $e3eb4432e25cc607$export$e370efd4e286ab04;

});

parcelRegister("lYst4", function(module, exports) {

var $947Tc = parcelRequire("947Tc");


var $cozmU = parcelRequire("cozmU");


var $4qzKl = parcelRequire("4qzKl");


var $cb6fO = parcelRequire("cb6fO");


var $jlIaF = parcelRequire("jlIaF");


var $jMyy4 = parcelRequire("jMyy4");


var $kPlM7 = parcelRequire("kPlM7");

const $60781568fe3da131$var$useFeedRecommendationsFeedRecommendationQuery = (0, $947Tc.default);
const $60781568fe3da131$export$2225b8d07ada6545 = ()=>{
    const { data: data, loading: recsLoading, error: feedRecError } = (0, $jMyy4.useQueryInterop)($60781568fe3da131$var$useFeedRecommendationsFeedRecommendationQuery, {
        errorPolicy: 'all',
        // Use cache-first to avoid a redundant network roundtrip on every mount
        // when recommendations data is already cached. Mutations that dismiss
        // recommendations update the cache directly, so freshness is maintained.
        fetchPolicy: 'cache-first',
        __callerPackage__: "feed"
    });
    const [recs, setRecs] = (0, $cozmU.useState)([]);
    const [initialRecSize, setInitialRec] = (0, $cozmU.useState)(0);
    const recsDismissed = data?.userPreferences?.feedRecommendedUserSettingsDismissTimestamp;
    const userRecs = data?.getRecommendedFeedUserConfig?.recommendedPeople;
    const spaceRecs = data?.getRecommendedFeedUserConfig?.recommendedSpaces;
    const msInMonth = 2629800000;
    const showRecs = recsDismissed && recsDismissed !== 'NO_VALUE_SET' ? Math.floor((new Date().getTime() - new Date(recsDismissed).getTime()) / msInMonth) >= 1 : recsDismissed === 'NO_VALUE_SET';
    const initialState = showRecs && initialRecSize >= (0, $kPlM7.PAGE_SIZE) && recs.length > 0;
    const [showFeedRecs, setShowFeedRecs] = (0, $cozmU.useState)(initialState);
    if (initialState != showFeedRecs) setShowFeedRecs(initialState);
    (0, $cozmU.useEffect)(()=>{
        const userRecsArray = [];
        const spaceRecsArray = [];
        if (userRecs) userRecs.forEach((user)=>{
            if (user.user && user.user.displayName && user.user.id && user.user.isActive) userRecsArray.push({
                score: user.score,
                name: user.user.displayName,
                icon: user.user.photos?.find((photo)=>photo?.isPrimary)?.value || '',
                id: user.user.id,
                url: (0, $4qzKl.getAtlassianPeopleProfileUrl)(user.user.id, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH)),
                title: user.user.title || '',
                type: 'user'
            });
        });
        if (spaceRecs) spaceRecs.forEach((space)=>{
            if (space.space && space.space.name && space.space.id && space.space.key) spaceRecsArray.push({
                score: space.score,
                name: space.space.name,
                icon: space.space.icon?.path || '',
                id: space.space.id,
                url: (0, $cb6fO.getSpaceLink)(space.space.key),
                type: 'space'
            });
        });
        userRecsArray.sort((a, b)=>b.score - a.score);
        spaceRecsArray.sort((a, b)=>b.score - a.score);
        const recsArray = userRecsArray.concat(spaceRecsArray);
        setRecs(recsArray);
        setInitialRec(recsArray.length);
    }, [
        userRecs,
        spaceRecs,
        setRecs,
        setInitialRec
    ]);
    return {
        showFeedRecs: showFeedRecs,
        setShowFeedRecs: setShowFeedRecs,
        recs: recs,
        setRecs: setRecs,
        recsLoading: recsLoading,
        feedRecError: feedRecError
    };
};
module.exports["useFeedRecommendations"] = $60781568fe3da131$export$2225b8d07ada6545;

});

parcelRegister("9yPX0", function(module, exports) {
const $9ad22e8e5a126d51$export$36e0baead2aaf9c7 = 5;
const $9ad22e8e5a126d51$export$ce4fd56db4138f46 = 85;
const $9ad22e8e5a126d51$export$de13fd770567d68 = 'home.feed.header.onboarding.followed-for-you';
module.exports["FETCH_MORE_PAGE_SIZE"] = $9ad22e8e5a126d51$export$36e0baead2aaf9c7;
module.exports["COMMENT_COLLAPSE_THRESHOLD"] = $9ad22e8e5a126d51$export$ce4fd56db4138f46;
module.exports["onboardingFeedHeaderCard"] = $9ad22e8e5a126d51$export$de13fd770567d68;

});

parcelRegister("gusOH", function(module, exports) {
const $2a951a36429b05e8$export$f0c535c2629aaab2 = ()=>{
    // we are returning false here so that we can quickly clean up the LD flag without extensive refactoring. Returning false here effectively turns off the feature. Context: https://atlassian.slack.com/archives/C05PQGP2PAQ/p1732581371074749
    return false;
};
module.exports["useFeedShouldHideComments"] = $2a951a36429b05e8$export$f0c535c2629aaab2;

});

parcelRegister("8BIV2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5T18X = parcelRequire("5T18X");


var $422HI = parcelRequire("422HI");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $l8oxh = parcelRequire("l8oxh");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $kvJHJ = parcelRequire("kvJHJ");


var $bQm3c = parcelRequire("bQm3c");


var $d442j = parcelRequire("d442j");

var $g9apM = parcelRequire("g9apM");


var $3HoFy = parcelRequire("3HoFy");

var $2Jztb = parcelRequire("2Jztb");


var $kVcC2 = parcelRequire("kVcC2");


var $8KJF2 = parcelRequire("8KJF2");


var $4yg2A = parcelRequire("4yg2A");


var $lIZtA = parcelRequire("lIZtA");


var $bxcP5 = parcelRequire("bxcP5");


var $g973h = parcelRequire("g973h");

const $270eb890b75251af$export$609954d45d804885 = ({ loading: loading, firstPageError: firstPageError, networkStatus: networkStatus, endCursor: endCursor, hasNextPage: hasNextPage, loadNextPage: loadNextPage, openActivityFilterModal: openActivityFilterModal, feedType: feedType, hasResults: hasResults = true, children: children, hasFollowedAnyone: hasFollowedAnyone })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const experienceTrackerStopAttributes = (0, $cozmU.useMemo)(()=>({
            feedType: feedType.toLowerCase()
        }), [
        feedType
    ]);
    const [nextPageError, setNextPageError] = (0, $cozmU.useState)();
    const error = firstPageError || nextPageError;
    const isExpectedError = Boolean(error && (0, $lIZtA.isExpectedApolloError)(error));
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const homeHref = `https://home.atlassian.com/o/${orgId}/discover/?cloudId=${cloudId}`;
    if (error && isExpectedError) (0, $7Sm4c.markErrorAsHandled)(error);
    const handlePagination = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!loading && hasNextPage) {
                experienceTracker.start({
                    name: (0, $irVI7.FEED_EXPERIENCE),
                    attributes: {
                        pagination: true
                    }
                });
                await loadNextPage();
                setNextPageError(null);
            }
        } catch (e) {
            const apolloError = new (0, $422HI.ApolloErrorInterop)({
                errorMessage: 'Feed cards failed to fetch more data',
                graphQLErrors: e
            });
            setNextPageError(apolloError);
        }
    }, [
        loading,
        hasNextPage,
        loadNextPage,
        setNextPageError,
        experienceTracker
    ]);
    const isFirstRenderAfterSSR = $270eb890b75251af$var$useIsFirstRenderAfterSSR();
    const renderPagination = ()=>{
        if (!hasNextPage) {
            if (feedType === (0, $4yg2A.FeedType).POPULAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8KJF2.EndOfPopularFeed), null);
            else if (feedType === (0, $4yg2A.FeedType).FOLLOWING) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kVcC2.EndOfFollowingFeed), {
                openActivityFilterModal: openActivityFilterModal,
                hasFollowedAnyone: hasFollowedAnyone,
                hasResults: hasResults
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3HoFy.EndOfFeed), {
                openActivityFilterModal: openActivityFilterModal
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8oxh.InfiniteScroll), {
            onScrollTo: handlePagination,
            cursor: endCursor,
            observerOptions: {
                root: null,
                rootMargin: '1000px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g973h.LoadingSkeleton), {
            useEntranceAnimation: !isFirstRenderAfterSSR
        }));
    };
    const renderEndOfFeed = ()=>{
        if (error && !isExpectedError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            error: error,
            attributes: experienceTrackerStopAttributes
        }), nextPageError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9apM.PaginationFeedError), {
            refetch: handlePagination
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d442j.GenericFeedError), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.FEED_EXPERIENCE),
            key: endCursor,
            attributes: experienceTrackerStopAttributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $bxcP5.HOME_OVERVIEW_FEED_PAGE_SEGMENT)
        }), renderPagination());
    };
    const alreadyLoaded = $270eb890b75251af$var$useAlreadyLoaded(loading);
    if (loading && (networkStatus === (0, $5T18X.NetworkStatus).refetch || networkStatus === (0, $5T18X.NetworkStatus).loading && !alreadyLoaded)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g973h.LoadingSkeleton), {
        useEntranceAnimation: !isFirstRenderAfterSSR
    });
    const isInPopularTypeFeed = feedType === (0, $4yg2A.FeedType).POPULAR || feedType === (0, $4yg2A.FeedType).FAREWELL || feedType === (0, $4yg2A.FeedType).WELCOME;
    // Check if we should show our new empty state instead of the banner
    const shouldShowNewEmptyState = !hasResults && feedType === (0, $4yg2A.FeedType).POPULAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: `tabpanel-${feedType.toLowerCase()}`,
        "aria-labelledby": `tab-${feedType.toLowerCase()}`,
        role: "tabpanel",
        tabIndex: 0
    }, children), isInPopularTypeFeed && !shouldShowNewEmptyState && (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Jztb.EndOfFeedHomeBanner), {
        linkHref: homeHref,
        feedType: feedType
    }) : renderEndOfFeed());
};
const $270eb890b75251af$var$useAlreadyLoaded = (loading)=>{
    const alreadyLoaded = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!loading) alreadyLoaded.current = true;
    }, [
        loading
    ]);
    return alreadyLoaded.current;
};
const $270eb890b75251af$var$useIsFirstRenderAfterSSR = ()=>{
    const isFirstRenderAfterSSR = (0, $cozmU.useRef)(Boolean(window.__SSR_RENDERED__));
    (0, $cozmU.useEffect)(()=>{
        isFirstRenderAfterSSR.current = false;
    }, []);
    return isFirstRenderAfterSSR.current;
};
module.exports["FeedCardsWrapper"] = $270eb890b75251af$export$609954d45d804885;

});

parcelRegister("6zZYs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $9DHhW = parcelRequire("9DHhW");

const $403bf0cb55748477$var$i18n = (0, $kSwu1.defineMessages)({
    exitFeed: {
        id: "feed.exit-feed-button",
        defaultMessage: "Exit feed"
    }
});
const $403bf0cb55748477$var$hideStyles = (0, $buxP3.xcss)({
    height: '0',
    overflow: 'hidden'
});
const $403bf0cb55748477$var$showStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.150',
    height: 'auto'
});
const $403bf0cb55748477$export$32879755d4094f2 = ({ onExit: onExit, source: source, feedCardIndex: feedCardIndex, isAfterRecommendations: isAfterRecommendations })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [showExitFeedButton, setShowExitFeedButton] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        onExit();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'exitFeedButton',
                attributes: {
                    feedCardIndex: feedCardIndex,
                    isAfterRecommendations: !!isAfterRecommendations
                }
            }
        }).fire();
    };
    const onFocus = ()=>{
        setShowExitFeedButton(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'exitFeedButton',
                attributes: {
                    feedCardIndex: feedCardIndex,
                    isAfterRecommendations: !!isAfterRecommendations
                }
            }
        }).fire();
    };
    const onBlur = ()=>{
        setShowExitFeedButton(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: showExitFeedButton ? $403bf0cb55748477$var$showStyles : $403bf0cb55748477$var$hideStyles,
        testId: "exit-feed-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: handleOnClick,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-vc": "exit-feed-a11y-button"
    }, intl.formatMessage($403bf0cb55748477$var$i18n.exitFeed))));
};
module.exports["ExitFeedAllyButton"] = $403bf0cb55748477$export$32879755d4094f2;

});

parcelRegister("6wpcc", function(module, exports) {
/* MobileAppPromo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $5lkNm = parcelRequire("5lkNm");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $i3jcY = parcelRequire("i3jcY");


var $lLUup = parcelRequire("lLUup");


var $fYQO1 = parcelRequire("fYQO1");


var $kCjG6 = parcelRequire("kCjG6");


var $2JWAq = parcelRequire("2JWAq");

const $baa3febee1410499$var$GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.atlassian.android.confluence.core&referrer=utm_source%3DconfluenceWeb%26utm_medium%3DUI%26utm_campaign%3DtestWebPopularFeedAudio';
const $baa3febee1410499$var$APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id1006971684?pt=696495&ct=testWebPopularFeedAudio&mt=8';
const $baa3febee1410499$var$i18n = (0, $kSwu1.defineMessages)({
    eyebrow: {
        id: "feed.mobile-app-promo.eyebrow",
        defaultMessage: "Try the mobile app"
    },
    headline: {
        id: "feed.mobile-app-promo.headline",
        defaultMessage: "Listen on-the-go with the mobile app"
    },
    description: {
        id: "feed.mobile-app-promo.description",
        defaultMessage: "Scan the QR code to listen to audio AI summaries with the Confluence mobile app. Perfect for your commute or when you need a screen break."
    },
    proTip: {
        id: "feed.mobile-app-promo.pro-tip",
        defaultMessage: "PRO TIP"
    },
    dismissLabel: {
        id: "feed.mobile-app-promo.close",
        defaultMessage: "Close"
    },
    dismissAccessibleLabel: {
        id: "feed.mobile-app-promo.dismiss.accessible-label",
        defaultMessage: "Close mobile app promotion"
    },
    qrAlt: {
        id: "feed.mobile-app-promo.qr.alt",
        defaultMessage: "QR code to download the Confluence mobile app"
    },
    googlePlayAlt: {
        id: "feed.mobile-app-promo.google-play.alt",
        defaultMessage: "Get the Confluence mobile app on Google Play"
    },
    appStoreAlt: {
        id: "feed.mobile-app-promo.app-store.alt",
        defaultMessage: "Download the Confluence mobile app on the App Store"
    }
});
const $baa3febee1410499$var$styles = {
    card: "_2mHwu85zaO _30huDKOeNX _0bjKvD8fU6 _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _0hPCNLDIqT _0Of8r25zaO _1wydGW5zaO _2Zuz6Q5zaO _1ZnuxbGXk2 _0KLXrulfZc _24h04i2Njc _1DCdHi5zaO",
    leadBlock: "_2mHwu85zaO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEe7g8 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _4ouGXIdnbC",
    logoTile: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _0KLXrutfbE _3YEZNOdnbC",
    eyebrow: "_2sNsIgEqul _1UtDYzGaer",
    heading: "_2sNsIg1kXk",
    message: "_2sNsIgmnOE",
    proTip: "_4xdlr07p2s",
    badgeLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbccYA _0hPCNLDIqT",
    badgeImage: "_0jFU0VuNcX _39xV02IZbP _3iDTPbvLZJ",
    dismissButton: "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO _42Yu6B7dHp",
    qrCode: "_0bjKvDKxmn _39xV02JgOI _0jFU0VJgOI _3YEZNOdnbC _00EA0egIor _0KLXrunmFW _3iDTPbvLZJ",
    storeLinks: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _3YEZNOdnbC _2XsHFMIZbP _3TGfC9HnLE _0hPCNLz9WS"
};
const $baa3febee1410499$export$626faae193981003 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($baa3febee1410499$var$MobileAppPromoInner, null);
};
const $baa3febee1410499$var$MobileAppPromoInner = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onAutoDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'autoDismissed',
                actionSubject: 'mobileAppPromo',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { isMobileAppPromoDismissed: isMobileAppPromoDismissed, onMobileAppPromoDismiss: onMobileAppPromoDismiss, onMobileAppPromoView: onMobileAppPromoView } = (0, $2JWAq.useMobileAppPromoDismiss)({
        onAutoDismiss: onAutoDismiss
    });
    if (isMobileAppPromoDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($baa3febee1410499$var$MobileAppPromoBanner, {
        onDismiss: onMobileAppPromoDismiss,
        onView: onMobileAppPromoView
    });
};
const $baa3febee1410499$var$MobileAppPromoBanner = ({ onDismiss: onDismiss, onView: onView })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        onView?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'mobileAppPromo',
                source: 'homeScreen'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'mobileAppPromoDismiss',
                source: 'homeScreen'
            }
        }).fire();
        onDismiss();
    }, [
        createAnalyticsEvent,
        onDismiss
    ]);
    const handleBadgeClick = (0, $cozmU.useCallback)((actionSubjectId)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: actionSubjectId,
                    source: 'homeScreen'
                }
            }).fire();
        }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "section",
        xcss: $baa3febee1410499$var$styles.card,
        testId: "mobile-app-promo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.dismissButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: intl.formatMessage($baa3febee1410499$var$i18n.dismissAccessibleLabel),
        tooltip: {
            content: intl.formatMessage($baa3febee1410499$var$i18n.dismissLabel)
        },
        onClick: handleDismiss,
        isTooltipDisabled: false,
        testId: "mobile-app-promo-dismiss"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.leadBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.logoTile,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lkNm.ConfluenceIcon), {
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.eyebrow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $baa3febee1410499$var$i18n.eyebrow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $baa3febee1410499$var$i18n.headline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $baa3febee1410499$var$i18n.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.proTip,
        testId: "mobile-app-promo-pro-tip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $baa3febee1410499$var$i18n.proTip))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.qrCode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kCjG6))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.qrAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.storeLinks
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        xcss: $baa3febee1410499$var$styles.badgeLink,
        href: $baa3febee1410499$var$GOOGLE_PLAY_URL,
        target: "_blank",
        newWindowLabel: intl.formatMessage($baa3febee1410499$var$i18n.googlePlayAlt),
        testId: "mobile-app-promo-google-play",
        onClick: handleBadgeClick('mobileAppPromoGooglePlayBadge')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.badgeImage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fYQO1))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.googlePlayAlt)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        xcss: $baa3febee1410499$var$styles.badgeLink,
        href: $baa3febee1410499$var$APP_STORE_URL,
        target: "_blank",
        newWindowLabel: intl.formatMessage($baa3febee1410499$var$i18n.appStoreAlt),
        testId: "mobile-app-promo-apple-store",
        onClick: handleBadgeClick('mobileAppPromoAppStoreBadge')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $baa3febee1410499$var$styles.badgeImage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lLUup))),
        alt: intl.formatMessage($baa3febee1410499$var$i18n.appStoreAlt)
    })))));
};
module.exports["MobileAppPromo"] = $baa3febee1410499$export$626faae193981003;

});

parcelRegister("3xaH7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $1NBp8 = parcelRequire("1NBp8");


var $fs6LW = parcelRequire("fs6LW");


var $8rneB = parcelRequire("8rneB");


var $fgRQY = parcelRequire("fgRQY");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $1RkMx = parcelRequire("1RkMx");


var $28g78 = parcelRequire("28g78");


var $gW7vR = parcelRequire("gW7vR");


var $hsR9s = parcelRequire("hsR9s");


var $cYSIK = parcelRequire("cYSIK");


var $9HGVt = parcelRequire("9HGVt");


var $dKup5 = parcelRequire("dKup5");

const $71e84ff29d608aa6$var$avatarWrapperStyles = (0, $buxP3.xcss)({
    paddingRight: 'space.200'
});
const $71e84ff29d608aa6$export$eb5305221596eaa9 = /*#__PURE__*/ (0, $cozmU.memo)(({ feedItem: feedItem, ranking: ranking, disableAnimation: disableAnimation, timeGranularity: timeGranularity })=>{
    const isMounted = (0, $dKup5.useIsMounted)();
    const [isActionMenuOpen] = (0, $cozmU.useState)(false);
    const bottomOfCardRef = (0, $cozmU.useRef)(null);
    const [, setHasBeenHovered] = (0, $cozmU.useState)(false);
    const authorName = feedItem?.content?.history?.createdBy?.displayName || '';
    const authorId = (0, $1RkMx.getUserAccountId)(feedItem?.content?.history?.createdBy) || '';
    const authorSrc = feedItem?.content?.history?.createdBy?.profilePicture?.path || '';
    const ownerName = feedItem?.content?.history?.ownedBy?.displayName || '';
    const ownerId = (0, $1RkMx.getUserAccountId)(feedItem?.content?.history?.ownedBy) || '';
    const ownerSrc = feedItem?.content?.history?.ownedBy?.profilePicture?.path || '';
    const contentUrl = (0, $1RkMx.getContentLink)(feedItem?.content);
    const contentId = feedItem?.content?.id || '';
    const contentType = feedItem?.content?.type || 'page';
    const contentSubType = feedItem?.content?.subType;
    const contentTitle = feedItem?.content?.title || '';
    const contentExcerpt = feedItem?.content?.excerpt;
    const creationDate = feedItem?.content?.history?.createdDate || '';
    const friendlyWhen = feedItem?.content?.version?.friendlyWhen || '';
    const spaceName = feedItem?.content?.space?.name || '';
    const spaceId = feedItem?.content?.space?.id || '';
    const spaceUrl = (0, $1RkMx.getSpaceLink)(feedItem?.content);
    const numComments = feedItem?.content?.metadata?.comments?.commentsCount || 0;
    const emoji = (0, $8rneB.getEmojiValueFromContent)(feedItem?.content);
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    // aiProperty is resolved directly on PopularFeedItem (parallel with content hop)
    // Narrow via 'in' check rather than type assertion (avoids no-unnecessary-type-assertion).
    const aiSnippet = feedItem && 'aiProperty' in feedItem ? feedItem.aiProperty?.objectData : undefined;
    // `aiSnippet` can be `null` when the GraphQL field resolved to `null`.
    // `contentExcerpt` prop is typed as `string | undefined`, so coerce nulls.
    const summaryContent = (aiSnippet || contentExcerpt) ?? undefined;
    const handleMouseEnter = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        setHasBeenHovered(true);
    }, [
        setHasBeenHovered
    ]);
    const fireAnalyticsEvent = (0, $9HGVt.useFeedCardAnalyticsEvents)(contentId, spaceId, 'popular', {
        ranking: ranking,
        contentType: contentType,
        creationDate: new Date(creationDate).getTime(),
        commentsCount: numComments,
        popularFeedTimeGranularity: timeGranularity
    });
    const onObserved = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'observed',
            actionSubject: 'popular-feedCard'
        });
    }, [
        fireAnalyticsEvent
    ]);
    (0, $fgRQY.useElementSeenCallback)(bottomOfCardRef, onObserved);
    const feedCardContextValue = (0, $cozmU.useMemo)(()=>({
            fireAnalyticsEvent: fireAnalyticsEvent
        }), [
        fireAnalyticsEvent
    ]);
    if (!contentId) return null;
    // check if page owner exists and content is not a blog
    // checking against the name here for the case of anonymous users
    const shouldUsePageOwner = ownerName && contentType === 'page';
    const preloadOptions = Boolean((0, $1NBp8.SPACE_OVERVIEW).match(contentUrl)) ? (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData : (0, $hXDOc.PreloadingPresets).onlyJS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYSIK.FeedCardContext).Provider, {
        value: feedCardContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "popular-feed-card",
        preloadUrl: contentUrl,
        preloadOptions: preloadOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28g78.Wrapper), {
        "data-testid": "popular-feed-card",
        isActionMenuOpen: isActionMenuOpen,
        disableAnimation: isMounted || disableAnimation,
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter,
        "data-vc": "popular-feed-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsR9s.FeedCardInvisibleFullSizedLink), {
        href: contentUrl,
        popularFeedTimeGranularity: timeGranularity,
        hasAiSnippet: !!aiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $71e84ff29d608aa6$var$avatarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: shouldUsePageOwner ? ownerId : authorId,
        src: shouldUsePageOwner ? ownerSrc : authorSrc,
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gW7vR.FeedCardBody), {
        emoji: emoji,
        contentId: contentId,
        contentTitle: contentTitle,
        contentType: contentType,
        contentSubType: contentSubType,
        contentUrl: contentUrl,
        authorName: authorName,
        authorId: authorId,
        ownerName: ownerName,
        ownerId: ownerId,
        spaceId: spaceId,
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        contentExcerpt: summaryContent,
        numComments: numComments,
        popularCardLayout: true,
        timestamp: friendlyWhen,
        source: "popular-feed",
        popularFeedTimeGranularity: timeGranularity,
        hasAiSnippet: !!aiSnippet
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: bottomOfCardRef
    })))));
});
module.exports["PopularFeedCard"] = $71e84ff29d608aa6$export$eb5305221596eaa9;

});

parcelRegister("iKkTC", function(module, exports) {
module.exports = new URL("GenericErrorImg.826dcb3b.svg", import.meta.url).toString();

});

parcelRegister("1RkMx", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $7d47f5bc91bbf66b$export$6ac0c298737bc979 = (content)=>{
    if (!content?.links?.webui) return '';
    return `${0, $jlIaF.CONTEXT_PATH}${content.links.webui}`;
};
const $7d47f5bc91bbf66b$export$e86d0abb53b9a540 = (comment)=>{
    if (!comment?.links?.webui) return '';
    return `${0, $jlIaF.CONTEXT_PATH}${comment.links.webui}`;
};
const $7d47f5bc91bbf66b$export$cefcfecf0835bcd9 = (content)=>{
    const spaceKey = content?.space?.key;
    if (!spaceKey) return '';
    const spaceAlias = content?.space?.alias || spaceKey;
    return (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceAlias
    });
};
const $7d47f5bc91bbf66b$export$7b19d7075992aee9 = (user)=>{
    if (user) return 'accountId' in user ? user.accountId : null;
    return null;
};
const $7d47f5bc91bbf66b$export$5590fc0a438aa324 = (update, contentUrl, contentId)=>{
    const type = update.type;
    if (type === 'COMMENT') {
        const commentLink = update.comment?.links.webui;
        if (commentLink) return `${0, $jlIaF.CONTEXT_PATH}${commentLink}`;
        else return '';
    }
    if (type === 'CREATE' || type === 'EDITLIVE' || type === 'PUBLISHLIVE' || type === 'EDIT' && (0, $9wGTI.fg)('confluence_should_remove_versions_from_feed_link')) return contentUrl;
    if (type === 'EDIT') {
        const version = update.version;
        const params = {
            query: {
                pageId: contentId,
                selectedPageVersions: [
                    version,
                    version - 1
                ]
            }
        };
        return (0, $1NBp8.PAGE_DIFF_BY_VERSION).toUrl({}, params);
    }
    return '';
};
const $7d47f5bc91bbf66b$var$supportedEventTypes = [
    'COMMENT',
    'CREATE',
    'EDIT',
    'EDITLIVE',
    'PUBLISHLIVE'
];
const $7d47f5bc91bbf66b$export$15fc850235b13c90 = (type)=>{
    return $7d47f5bc91bbf66b$var$supportedEventTypes.includes(type);
};
module.exports["getContentLink"] = $7d47f5bc91bbf66b$export$6ac0c298737bc979;
module.exports["getCommentLink"] = $7d47f5bc91bbf66b$export$e86d0abb53b9a540;
module.exports["getSpaceLink"] = $7d47f5bc91bbf66b$export$cefcfecf0835bcd9;
module.exports["getUserAccountId"] = $7d47f5bc91bbf66b$export$7b19d7075992aee9;
module.exports["getLinkForSummaryLinkUpdate"] = $7d47f5bc91bbf66b$export$5590fc0a438aa324;
module.exports["isSupportedEvent"] = $7d47f5bc91bbf66b$export$15fc850235b13c90;

});

parcelRegister("fYx4v", function(module, exports) {
/* ActivityLineUpdateLink.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $cYSIK = parcelRequire("cYSIK");


var $dmmkE = parcelRequire("dmmkE");

const $20d90973ca3cec9c$var$i18n = (0, $kSwu1.defineMessages)({
    anonymousUser: {
        id: "feed.card.anonymousUser",
        defaultMessage: "Anonymous User"
    },
    displayName: {
        id: "feed.card.displayName",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{name}"
    },
    createAction: {
        id: "feed.card.createAction",
        defaultMessage: "created"
    },
    editAction: {
        id: "feed.card.editAction",
        defaultMessage: "{num, plural,\n      one {edited}\n      other {edited {num} times}}"
    },
    updateAction: {
        id: "feed.card.updateAction",
        defaultMessage: "{num, plural,\n\t\t\tone {updated}\n\t\t\tother {updated {num} times}}"
    },
    publishLiveAction: {
        id: "feed.card.publishAction",
        defaultMessage: "published"
    },
    commentAction: {
        id: "feed.card.commentAction",
        defaultMessage: "{num, plural,\n      one {commented}\n      other {commented {num} times}}"
    },
    unknownAction: {
        id: "feed.card.unknownAction",
        defaultMessage: "Unknown update"
    }
});
const $20d90973ca3cec9c$var$NameWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _0adFHs1Y8M",
            __cmplp.className
        ])
    });
});
const $20d90973ca3cec9c$var$ActivityDescriptorContainer = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { activityDropdownLineItem: activityDropdownLineItem, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.activityDropdownLineItem ? "_1EqgXls38O" : "_1EqgXlOLYo",
            __cmplp.className
        ])
    });
});
const $20d90973ca3cec9c$var$ActionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlE6Kk",
            __cmplp.className
        ])
    });
});
// This component is used by both feed activities (FeedContentQuery's FeedEventType) and recent actions activities (FeedCardAllActivityQuery's PageActivityAction, mapped in activityLineHelpers.ts to match FeedEventType)
const $20d90973ca3cec9c$var$ActivityLineUpdateLinkComponent = ({ type: type, userDisplayName: userDisplayName, link: link, groupSize: groupSize, intl: intl, activityDropdownLineItem: activityDropdownLineItem })=>{
    const displayName = userDisplayName || intl.formatMessage($20d90973ca3cec9c$var$i18n.anonymousUser);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const [showNameWithTooltip, setShowNameWithTooltip] = (0, $cozmU.useState)(false);
    const activityDescriptorNode = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Check if the displayName is truncated before adding tooltip; 270 represents the available
        // flex area of the parent div (fixed width from dropdown)
        if (activityDescriptorNode.current && activityDescriptorNode.current.scrollWidth >= 270 && activityDropdownLineItem) setShowNameWithTooltip(true);
    }, [
        activityDropdownLineItem
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardActivityLink',
            includeNavdex: true,
            additionalAttributes: {
                activityType: type,
                isDropdown: activityDropdownLineItem
            }
        });
    }, [
        type,
        activityDropdownLineItem,
        fireAnalyticsEvent
    ]);
    const renderButtonBody = ()=>{
        const i18nValues = {
            num: groupSize
        };
        switch(type){
            case 'CREATE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $20d90973ca3cec9c$var$i18n.createAction);
            case 'EDIT':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.updateAction,
                    values: i18nValues
                });
            case 'EDITLIVE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.editAction,
                    values: i18nValues
                });
            case 'PUBLISHLIVE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $20d90973ca3cec9c$var$i18n.publishLiveAction);
            case 'COMMENT':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$20d90973ca3cec9c$var$i18n.commentAction,
                    values: i18nValues
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $20d90973ca3cec9c$var$i18n.unknownAction);
        }
    };
    const i18nNameValues = {
        name: displayName
    };
    const activityDescriptor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20d90973ca3cec9c$var$ActivityDescriptorContainer, {
        activityDropdownLineItem: activityDropdownLineItem,
        ref: activityDescriptorNode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20d90973ca3cec9c$var$NameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$20d90973ca3cec9c$var$i18n.displayName,
        values: i18nNameValues
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20d90973ca3cec9c$var$ActionWrapper, null, renderButtonBody()));
    const activityDescriptorTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$20d90973ca3cec9c$var$i18n.displayName,
            values: i18nNameValues
        }),
        testId: displayName
    }, activityDescriptor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dmmkE.SubtleLink), {
        href: link,
        onClick: handleClick,
        testId: `${displayName}-${type}-${groupSize}`
    }, showNameWithTooltip ? activityDescriptorTooltip : activityDescriptor);
};
const $20d90973ca3cec9c$export$99d1f46490b86fbf = (0, $kSwu1.injectIntl)($20d90973ca3cec9c$var$ActivityLineUpdateLinkComponent);
module.exports["ActivityLineUpdateLink"] = $20d90973ca3cec9c$export$99d1f46490b86fbf;

});

parcelRegister("6OiEk", function(module, exports) {

var $wHo13 = parcelRequire("wHo13");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $l8oxh = parcelRequire("l8oxh");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $lsxnT = parcelRequire("lsxnT");


var $cYSIK = parcelRequire("cYSIK");


var $aOmNU = parcelRequire("aOmNU");


var $j9RXG = parcelRequire("j9RXG");


var $9WXEQ = parcelRequire("9WXEQ");


var $ip3cc = parcelRequire("ip3cc");


var $jMyy4 = parcelRequire("jMyy4");

const $502d75b496aac139$var$AllActivityDropdownFeedCardAllActivityQuery = (0, $wHo13.default);
const $502d75b496aac139$var$i18n = (0, $kSwu1.defineMessages)({
    otherActions: {
        id: "feed.card.otherActions",
        defaultMessage: "{num} recent {num, plural, one {action} other {actions} }"
    },
    otherActionsWithoutNumber: {
        id: "feed.card.otherActionsWithoutNumber",
        defaultMessage: "Recent actions"
    }
});
// Inline dialog component wraps this with 16px 24px padding by default,
// so we need to compensate for that with a negative margin
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $502d75b496aac139$var$ActionDialog = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02qMLO _0NUa3rdoBh _2WAcuGIZbP _4bt5LAnQyn _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r25zaO _1wydGWFQfX",
            __cmplp.className
        ])
    });
});
const $502d75b496aac139$var$buttonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            marginRight: "var(--ds-space-050, 4px)",
            fontWeight: "var(--ds-font-weight-regular, 400)",
            color: "var(--ds-text-subtle, #505258)"
        },
        spinnerStyles: spinnerStyles
    };
};
const $502d75b496aac139$var$AllActivityDropdownComponent = ({ contentUrl: contentUrl, contentId: contentId, recentActionsCount: recentActionsCount, shouldShowRecentActionsCountNumber: shouldShowRecentActionsCountNumber = true })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, $cozmU.useState)(false);
    const [nextPageError, setNextPageError] = (0, $cozmU.useState)();
    const thirtyDaysAgo = (0, $cozmU.useMemo)(()=>{
        const currentDate = new Date();
        const date = new Date(currentDate.setDate(currentDate.getDate() - 30));
        return date.toISOString();
    }, []);
    const { data: data, error: firstPageError, loading: loading, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($502d75b496aac139$var$AllActivityDropdownFeedCardAllActivityQuery, {
        variables: {
            contentId: contentId,
            fromDate: thirtyDaysAgo
        },
        skip: !(dialogOpen || hovered),
        __callerPackage__: "feed"
    });
    const error = firstPageError || nextPageError;
    const hasNextPage = data?.pageActivity?.pageInfo?.hasNextPage;
    const endCursor = data?.pageActivity?.pageInfo?.endCursor;
    const onHover = (0, $cozmU.useCallback)(()=>{
        if (!hovered) setHovered(true);
    }, [
        setHovered,
        hovered
    ]);
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setDialogOpen((open)=>!open);
    }, [
        setDialogOpen
    ]);
    const closeDialog = (0, $cozmU.useCallback)(()=>{
        setDialogOpen(false);
    }, [
        setDialogOpen
    ]);
    const updates = data?.pageActivity?.nodes || [];
    (0, $cozmU.useEffect)(()=>{
        if (dialogOpen) fireAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'more',
            actionSubject: 'recentActions',
            actionSubjectId: 'feedCardRecentActionsPeak'
        });
    }, [
        dialogOpen,
        fireAnalyticsEvent
    ]);
    const handlePagination = (0, $cozmU.useCallback)(async ()=>{
        try {
            await fetchMore({
                variables: {
                    contentId: contentId,
                    after: endCursor,
                    fromDate: thirtyDaysAgo
                },
                updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prevResults;
                    fetchMoreResult.pageActivity.nodes = prevResults.pageActivity.nodes.concat(fetchMoreResult.pageActivity.nodes);
                    return fetchMoreResult;
                }
            });
        } catch (e) {
            setNextPageError(e);
        }
    }, [
        fetchMore,
        endCursor,
        contentId,
        thirtyDaysAgo
    ]);
    const renderEndOfActivityList = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9RXG.AllActivityError), null));
        if (!loading && hasNextPage && endCursor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8oxh.InfiniteScroll), {
            onScrollTo: handlePagination,
            cursor: endCursor,
            observerOptions: {
                root: null,
                threshold: 0.05
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9WXEQ.ActivityLineUpdateDetailSkeleton), null));
        return null;
    };
    const renderDialogBody = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9WXEQ.ActivityLineUpdateDetailSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, updates.map((update)=>{
            if (update) {
                const type = (0, $ip3cc.getSupportedUpdateType)(update.actionSubject, update.action);
                if (type) {
                    const userId = update.user?.id || null;
                    const avatarUrl = (0, $ip3cc.getAvatarUrl)(update.user?.photos || null);
                    const name = update.user?.displayName || null;
                    const actionTime = update.timestamp;
                    const link = (0, $ip3cc.getUpdateContentUrl)(update, contentUrl, contentId);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOmNU.ActivityLineUpdateDetail), {
                        key: `${type}-${userId}-${actionTime}`,
                        type: type,
                        actionTime: actionTime,
                        userId: userId,
                        avatarUrl: avatarUrl,
                        userDisplayName: name,
                        link: link,
                        groupSize: update.groupSize
                    });
                }
            }
            return null;
        }), renderEndOfActivityList());
    };
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: dialogOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($502d75b496aac139$var$ActionDialog, null, renderDialogBody()),
        onClose: closeDialog,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                onClick: toggleDialog,
                onMouseEnter: onHover,
                theme: $502d75b496aac139$var$buttonTheme,
                appearance: "subtle-link",
                spacing: "none",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...shouldShowRecentActionsCountNumber ? $502d75b496aac139$var$i18n.otherActions : $502d75b496aac139$var$i18n.otherActionsWithoutNumber,
                values: {
                    num: recentActionsCount
                }
            }))
    });
};
const $502d75b496aac139$export$8436016812042c6f = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).SMARTS
})($502d75b496aac139$var$AllActivityDropdownComponent);
module.exports["AllActivityDropdown"] = $502d75b496aac139$export$8436016812042c6f;

});

parcelRegister("3WnxN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $1YXTQ = parcelRequire("1YXTQ");

const $8830968965c7c211$export$dd2d586e2f48f039 = ({ actionTime: actionTime })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: new Date(actionTime).toLocaleString(),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: actionTime
    }));
};
module.exports["ActionTime"] = $8830968965c7c211$export$dd2d586e2f48f039;

});

parcelRegister("9HGVt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $56QzY = parcelRequire("56QzY");


var $6GgH7 = parcelRequire("6GgH7");

const $7a1c331147479904$var$getStatsObjectAndContainerAttributes = (contentId, spaceId, commentId)=>{
    if (commentId) return {
        containerType: 'page',
        containerId: contentId,
        objectType: 'comment',
        objectId: commentId
    };
    return {
        containerType: 'space',
        containerId: spaceId,
        objectType: 'page',
        objectId: contentId
    };
};
const $7a1c331147479904$export$6fb5b9efe5001412 = (contentId, spaceId, actionSubjectIdPrefix, baseAttributes)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const feedContext = (0, $cozmU.useContext)((0, $6GgH7.FeedContext));
    return (0, $cozmU.useCallback)(({ type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, commentId: commentId, additionalAttributes: additionalAttributes = {}, includeNavdex: includeNavdex = false })=>{
        const objectAndContainer = $7a1c331147479904$var$getStatsObjectAndContainerAttributes(contentId, spaceId, commentId);
        const getActionSubjectId = ()=>{
            if (actionSubjectId) return `${actionSubjectIdPrefix}-${actionSubjectId}`;
            return actionSubjectIdPrefix;
        };
        createAnalyticsEvent({
            type: type,
            data: {
                source: 'homeScreen',
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: getActionSubjectId(),
                ...objectAndContainer,
                attributes: {
                    ...baseAttributes,
                    ...additionalAttributes,
                    ...includeNavdex && {
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    },
                    feedSessionId: feedContext.feedSessionId
                }
            }
        }).fire();
    }, [
        contentId,
        spaceId,
        baseAttributes,
        actionSubjectIdPrefix,
        createAnalyticsEvent,
        feedContext.feedSessionId
    ]);
};
module.exports["useFeedCardAnalyticsEvents"] = $7a1c331147479904$export$6fb5b9efe5001412;

});

parcelRegister("dKup5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0c7f1f3745818de3$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true;
    }, []);
    return isMounted.current;
};
module.exports["useIsMounted"] = $0c7f1f3745818de3$export$80c2a3957bcb42ea;

});

parcelRegister("fWjNm", function(module, exports) {
const $b52ba06964ef5ea9$export$5cecd2906004a9f9 = {
    COMMENT: 'COMMENT',
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    EDITLIVE: 'EDITLIVE',
    PUBLISHLIVE: 'PUBLISHLIVE'
};
const $b52ba06964ef5ea9$export$27d1ac5a175e8bbf = {
    PERSON: 'PERSON',
    SPACE: 'SPACE'
};
module.exports["FeedEventType"] = $b52ba06964ef5ea9$export$5cecd2906004a9f9;
module.exports["FeedItemSourceType"] = $b52ba06964ef5ea9$export$27d1ac5a175e8bbf;

});

parcelRegister("cYSIK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cef4e67e3b7fa439$export$3d8687caae60568b = (0, $cozmU.createContext)({
    fireAnalyticsEvent: ()=>{}
});
module.exports["FeedCardContext"] = $cef4e67e3b7fa439$export$3d8687caae60568b;

});

parcelRegister("gW7vR", function(module, exports) {
/* FeedCardBody.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SCD6 = parcelRequire("8SCD6");


var $bJFcf = parcelRequire("bJFcf");


var $aG5uJ = parcelRequire("aG5uJ");


var $gk2mg = parcelRequire("gk2mg");


var $hlJJ7 = parcelRequire("hlJJ7");


var $8dkgs = parcelRequire("8dkgs");


var $37OMg = parcelRequire("37OMg");

const $73a9bc6a07a5ae59$var$FollowingCardBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _0Of8r22ADO",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PopularCardBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$ContentExcerpt = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0NUa3rUF4f _1DCdHi8HPE _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28 _39HuIbz8Lp _3W2Oc8wPeg",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PageDetails = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$TitleAndActionsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLchRC _1DCdHi8HPE",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$TitleAndBylineWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$PageDetailsContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4ouGXIdnbC _2O5Vij7dHp",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$CommentsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _3138428HPE _0Of8r28HPE _1wydGWdnbC",
            __cmplp.className
        ])
    });
});
const $73a9bc6a07a5ae59$var$getShowCommentState = (shouldHideComments, comment, commentVisible)=>{
    if (!shouldHideComments) return (0, $8dkgs.ShowCommentState).Number;
    if (!!comment) return commentVisible ? (0, $8dkgs.ShowCommentState).HideComment : (0, $8dkgs.ShowCommentState).ShowComment;
    return (0, $8dkgs.ShowCommentState).NoShow;
};
const $73a9bc6a07a5ae59$export$12ab4c22e8a2eeb5 = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentSubType: contentSubType, contentUrl: contentUrl, spaceId: spaceId, spaceName: spaceName, spaceUrl: spaceUrl, authorName: authorName, authorId: authorId, ownerName: ownerName, ownerId: ownerId, emoji: emoji, customIconUrl: customIconUrl, contentExcerpt: contentExcerpt, numComments: numComments, hideSocialProof: hideSocialProof, comment: comment, renderedContent: renderedContent, popularCardLayout: popularCardLayout = false, timestamp: timestamp, hideActions: hideActions, shouldHideComments: shouldHideComments, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby, hasAiSnippet: hasAiSnippet })=>{
    const CardBody = popularCardLayout ? $73a9bc6a07a5ae59$var$PopularCardBody : $73a9bc6a07a5ae59$var$FollowingCardBody;
    // check if page owner exists and content is not a blog
    // checking against the name here for the case of anonymous users
    const shouldUsePageOwner = ownerName && contentType === 'page';
    const [commentVisible, setCommentVisible] = (0, $cozmU.useState)(false);
    const onCommentToggleClick = (0, $cozmU.useCallback)(()=>{
        setCommentVisible(!commentVisible);
    }, [
        commentVisible
    ]);
    const showCommentState = $73a9bc6a07a5ae59$var$getShowCommentState(shouldHideComments, comment, commentVisible);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$PageDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$PageDetailsContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$TitleAndActionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$TitleAndBylineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk2mg.FeedCardTitle), {
        contentTitle: contentTitle,
        contentUrl: contentUrl,
        contentType: contentType,
        contentSubType: contentSubType,
        emoji: emoji,
        customIconUrl: customIconUrl,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby,
        hasAiSnippet: hasAiSnippet
    }), shouldUsePageOwner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hlJJ7.FeedCardByLine), {
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        ownerName: ownerName,
        ownerId: ownerId,
        timestamp: timestamp,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hlJJ7.FeedCardByLine), {
        spaceName: spaceName,
        spaceUrl: spaceUrl,
        authorName: authorName,
        authorId: authorId,
        timestamp: timestamp,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    })), !hideActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37OMg.FeedCardActions), {
        contentId: contentId
    })), contentExcerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$ContentExcerpt, null, contentExcerpt), !hideSocialProof && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8dkgs.FeedCardActionCounts), {
        numComments: numComments,
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        showCommentState: showCommentState,
        onCommentToggleClick: onCommentToggleClick,
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }))), comment && (!shouldHideComments || commentVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73a9bc6a07a5ae59$var$CommentsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJFcf.Comments), {
        comments: [
            comment
        ],
        pageId: contentId,
        contentType: contentType
    })), renderedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG5uJ.RenderedContent), {
        content: renderedContent
    })));
});
module.exports["FeedCardBody"] = $73a9bc6a07a5ae59$export$12ab4c22e8a2eeb5;

});

parcelRegister("hsR9s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5SGpQ = parcelRequire("5SGpQ");


var $cFVPs = parcelRequire("cFVPs");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $cYSIK = parcelRequire("cYSIK");

const $69c78bcd9639efb3$var$fullSizeButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%'
        },
        spinnerStyles: spinnerStyles
    };
};
const $69c78bcd9639efb3$export$a031aa7f3c991e0 = ({ href: href, contentType: contentType, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortBy: followingFeedSortBy, hasAiSnippet: hasAiSnippet })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { trackAIResultAction: trackAIResultAction } = (0, $cFVPs.useAIEventsInstrumentation)();
    const feedType = popularFeedTimeGranularity ? 'popularFeed' : 'followingFeed';
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        if (hasAiSnippet) trackAIResultAction(`${feedType}aiSnippetClicked`);
        if (contentType && contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.DISCOVER_ITEM_ON_HOME_PAGE_CLICK));
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCard',
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortBy: followingFeedSortBy
            }
        });
        e.preventDefault();
        if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(href, [
            (0, $71GjD.FeatureCode).HOME_FEED
        ]));
        else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(href, [
            (0, $71GjD.FeatureCode).HOME_FEED
        ]));
    }, [
        contentType,
        fireAnalyticsEvent,
        popularFeedTimeGranularity,
        followingFeedSortBy,
        href,
        push,
        hasAiSnippet,
        trackAIResultAction,
        feedType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        href: href,
        appearance: "link",
        theme: $69c78bcd9639efb3$var$fullSizeButtonTheme,
        onClick: handleClick,
        testId: "feed-card-body-link",
        "aria-hidden": true,
        tabIndex: -1
    });
};
module.exports["FeedCardInvisibleFullSizedLink"] = $69c78bcd9639efb3$export$a031aa7f3c991e0;

});

parcelRegister("kZ8dV", function(module, exports) {
/**
 * @generated SignedSource<<4057a69a30ca1b80345e1b53c6b245c9>>
 * @relayHash aa6cdcfd10bb544288b09784eefe7c84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2821f13a8a9d144e2ce53fda36afe64d8ae1da03d3110c5a29d7f58c140d051f
const $bc2208ff97e81e43$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v9 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v12 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v10 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v16 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v17 = {
        "kind": "InlineFragment",
        "selections": v16 /*: any*/ ,
        "type": "KnownUser"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": v16 /*: any*/ ,
        "type": "UnknownUser"
    }, v19 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FilterByLabelFeedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FilterByLabelFeedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "aa6cdcfd10bb544288b09784eefe7c84",
            "id": "2821f13a8a9d144e2ce53fda36afe64d8ae1da03d3110c5a29d7f58c140d051f",
            "metadata": {},
            "name": "FilterByLabelFeedQuery",
            "operationKind": "query",
            "text": "query FilterByLabelFeedQuery($cql:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,first:$first,after:$after){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$bc2208ff97e81e43$var$node.hash = "c1730f3bbce99bdbe9fb21dac52e8191";
var $bc2208ff97e81e43$export$2e2bcd8739ae039 = $bc2208ff97e81e43$var$node;
module.exports["default"] = $bc2208ff97e81e43$export$2e2bcd8739ae039;

});

parcelRegister("k11sS", function(module, exports) {
/* FeedTypePill.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $4Lw3A = parcelRequire("4Lw3A");

const $0a8bc1b292ee71ca$var$FeedTypePillButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _4FKVYE2ADO _0bjKvDS5Zs _24h04i2Njc _3iDTPbccYA _313842dnbC _20VacPYbGa _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7 _1RrJLiBwqQ _0wOv4Q7zJH _0hPCNLDIqT _0jFU0VUofl _2fqI0WXzJH _0xkEdpjOvk",
            __cmplp.selected ? "_0KLXruY9q9" : "_0KLXruDMqu",
            __cmplp.selected ? "_1UtDYzGaer" : "_1UtDYzy7kJ",
            __cmplp.selected ? "_1eOmH6sumd" : "_1eOmH6KcZT",
            __cmplp.selected ? "_30huDK1mZo" : "_30huDKfqb4",
            __cmplp.className
        ])
    });
});
const $0a8bc1b292ee71ca$var$finesseStyles = {
    selected: "_1UtDYzjTy9",
    unselected: "_3vBAKH9r67 _0KLXru66of _1eOmH6o126 _3gzVzLN4oS"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a8bc1b292ee71ca$var$IconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VN91d _0hPCNLDIqT _0adFHs1Y8M",
            __cmplp.className
        ])
    });
});
const $0a8bc1b292ee71ca$export$987ad80a1f37dfd7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ feedType: feedType, selectedFeedType: selectedFeedType, setFeedType: setFeedType, Icon: Icon, children: children, titleSuffix: titleSuffix, isPulseActive: isPulseActive = false, onPulseClick: onPulseClick = ()=>{}, onSelect: onSelect }, ref)=>{
    const { handleFeedTypeClick: handleFeedTypeClick, handleMouseDown: handleMouseDown, handlePulseClick: handlePulseClick } = (0, $4Lw3A.useFeedTypeSelectionAnalytics)({
        feedType: feedType,
        selectedFeedType: selectedFeedType,
        setFeedType: setFeedType,
        isPulseActive: isPulseActive,
        onPulseClick: onPulseClick
    });
    const selected = selectedFeedType === feedType;
    const testId = `${feedType.toLowerCase()}-feed-button`;
    const handleClick = ()=>{
        onSelect?.();
        handleFeedTypeClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050",
        onClick: handlePulseClick,
        role: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0a8bc1b292ee71ca$var$FeedTypePillButton, {
        selected: selected,
        role: "tab",
        id: `tab-${feedType.toLowerCase()}`,
        "aria-selected": selected,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $hekY6.default)([
            selected && (0, $9wGTI.fg)('platform-dst-tokens-finesse') && $0a8bc1b292ee71ca$var$finesseStyles.selected,
            !selected && (0, $9wGTI.fg)('platform-dst-tokens-finesse') && $0a8bc1b292ee71ca$var$finesseStyles.unselected
        ])
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0a8bc1b292ee71ca$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: selected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)"
    })), children, titleSuffix)));
});
module.exports["FeedTypePill"] = $0a8bc1b292ee71ca$export$987ad80a1f37dfd7;

});

parcelRegister("16IT4", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageDark.ce65ddfa.svg", import.meta.url).toString();

});

parcelRegister("do0Qf", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageLight.ce863139.svg", import.meta.url).toString();

});

parcelRegister("kNKJA", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageV2Dark.5795c228.svg", import.meta.url).toString();

});

parcelRegister("bIIJl", function(module, exports) {
module.exports = new URL("FeedOnboardingMessageV2Light.3c50255e.svg", import.meta.url).toString();

});

parcelRegister("dFUHi", function(module, exports) {
/**
 * @generated SignedSource<<30013acb727c6d9037378f04decf41d8>>
 * @relayHash b78a3d13d04f56d173c6257458e006c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a
const $0bffe2d62791c3e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "dismissTime"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "feedRecommendedUserSettingsDismissTimestamp",
                            "variableName": "dismissTime"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b78a3d13d04f56d173c6257458e006c5",
            "id": "d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a",
            "metadata": {},
            "name": "FeedRecommendationsFeedRecDismissMutation",
            "operationKind": "mutation",
            "text": "mutation FeedRecommendationsFeedRecDismissMutation($dismissTime:String!){updateUserPreferences(userPreferences:{feedRecommendedUserSettingsDismissTimestamp:$dismissTime}){feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$0bffe2d62791c3e6$var$node.hash = "a25c0690e1d844eea2512b1cc3580eb1";
var $0bffe2d62791c3e6$export$2e2bcd8739ae039 = $0bffe2d62791c3e6$var$node;
module.exports["default"] = $0bffe2d62791c3e6$export$2e2bcd8739ae039;

});

parcelRegister("lIZtA", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $j0RU5 = parcelRequire("j0RU5");

const $b9905c37d15f766d$export$288e4801a340fb3c = (error)=>{
    return error.graphQLErrors.every($b9905c37d15f766d$var$isExpectedGraphqlError);
};
const $b9905c37d15f766d$var$isExpectedGraphqlError = (error)=>{
    return (0, $j0RU5.isFeedConfigDeletedSpaceError)(error) || (0, $j0RU5.isFeedConfigSpacePermissionError)(error) || (0, $j0RU5.isFeedConfigUserPermissionError)(error) || $b9905c37d15f766d$var$isFeedDeletedCommentError(error) || $b9905c37d15f766d$export$457f8167a5536003(error) || $b9905c37d15f766d$export$21160c2a9f84c3b7(error);
};
const $b9905c37d15f766d$var$commentErrorPath = [
    'summaryLineUpdate',
    'comment'
];
// Deleted comment error for when the feed attempts to hydrate a deleted comment
const $b9905c37d15f766d$var$isFeedDeletedCommentError = (error)=>{
    return $b9905c37d15f766d$var$commentErrorPath.every((path)=>error.path?.includes(path)) && error.message?.includes('No comment found for the given id');
};
const $b9905c37d15f766d$var$feedRecDeletedSpacePath = [
    'getRecommendedFeedUserConfig',
    'recommendedSpaces',
    'space'
];
const $b9905c37d15f766d$export$457f8167a5536003 = (error)=>{
    return $b9905c37d15f766d$var$feedRecDeletedSpacePath.every((path)=>error.path?.includes(path)) && error.message.includes('Cannot find space with id');
};
const $b9905c37d15f766d$var$summaryLineUpdateUserPath = [
    'feed',
    'nodes',
    'summaryLineUpdate',
    'user'
];
const $b9905c37d15f766d$export$21160c2a9f84c3b7 = (error)=>{
    return $b9905c37d15f766d$var$summaryLineUpdateUserPath.every((path)=>error.path?.includes(path)) && error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $b9905c37d15f766d$export$288e4801a340fb3c;
module.exports["isFeedRecDeletedSpaceError"] = $b9905c37d15f766d$export$457f8167a5536003;

});

parcelRegister("kPlM7", function(module, exports) {

var $lSGGk = parcelRequire("lSGGk");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $ad7Ou = parcelRequire("ad7Ou");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");


var $lpNn5 = parcelRequire("lpNn5");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $24dy7 = parcelRequire("24dy7");


var $b3j2Y = parcelRequire("b3j2Y");


var $iKskQ = parcelRequire("iKskQ");


var $308Wd = parcelRequire("308Wd");


var $hOSkW = parcelRequire("hOSkW");

const $08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation = (0, $lSGGk.default);
const $08135afd8c895fad$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "feed.recommendation.tile.follow",
        defaultMessage: "Follow"
    },
    followLabel: {
        id: "feed.recommendation.tile.follow.label",
        defaultMessage: "Follow {name}"
    },
    space: {
        id: "feed.recommendation.tile.space",
        defaultMessage: "Space"
    },
    dismissLabel: {
        id: "feed.recommendation.tile.dismiss.label",
        defaultMessage: "Dismiss {name} recommendation"
    },
    flagFollowTitle: {
        id: "feed.recommendation.flag.follow.success",
        defaultMessage: "Followed {name}"
    },
    flagFollowAction: {
        id: "feed.recommendation.flag.follow.action",
        defaultMessage: "Dismiss"
    },
    flagErrorTitle: {
        id: "feed.recommendation.flag.follow.error",
        defaultMessage: "Could not follow {name}"
    },
    flagErrorDescription: {
        id: "feed.recommendation.flag.follow.error.description",
        defaultMessage: "Please try again later"
    },
    profileTile: {
        id: "feed.recommendation.tile.profile",
        defaultMessage: "{name} profile"
    }
});
const $08135afd8c895fad$export$f2a133baea81f082 = 16;
const $08135afd8c895fad$export$8ec3d08588d2eeda = 4;
const $08135afd8c895fad$var$TILE_WIDTH_PERCENT = 100 / $08135afd8c895fad$export$8ec3d08588d2eeda;
const $08135afd8c895fad$var$TILE_MARGIN_WIDTH = $08135afd8c895fad$export$f2a133baea81f082 * (($08135afd8c895fad$export$8ec3d08588d2eeda - 1) / $08135afd8c895fad$export$8ec3d08588d2eeda);
const $08135afd8c895fad$var$fullSizeButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            width: '100%',
            height: '100%'
        },
        spinnerStyles: spinnerStyles
    };
};
const $08135afd8c895fad$var$dismissTileButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            position: 'absolute',
            top: "var(--ds-space-050, 4px)",
            right: "var(--ds-space-050, 4px)",
            width: '28px',
            height: '28px'
        },
        spinnerStyles: spinnerStyles
    };
};
const $08135afd8c895fad$var$tileWrapperStyle = null;
const $08135afd8c895fad$var$titleHover = null;
const $08135afd8c895fad$var$loadingStyle = null;
const $08135afd8c895fad$var$userIconStyle = null;
const $08135afd8c895fad$var$nameAndTypeWrapperStyle = null;
const $08135afd8c895fad$var$nameWrapperStyle = null;
const $08135afd8c895fad$var$titlePlaceholderStyle = null;
const $08135afd8c895fad$var$titleOrTypeWrapperStyle = null;
const $08135afd8c895fad$export$debb778f17cf50d6 = ({ name: name, id: id, url: url, icon: icon, type: type, title: title, dismissTile: dismissTile, cardIndex: cardIndex, position: position })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const [tileHover, setTileHover] = (0, $cozmU.useState)(true);
    const enableTileHover = (0, $cozmU.useCallback)(()=>{
        setTileHover(true);
    }, [
        setTileHover
    ]);
    const disableTileHover = (0, $cozmU.useCallback)(()=>{
        setTileHover(false);
    }, [
        setTileHover
    ]);
    const onFollowSuccess = (0, $cozmU.useCallback)(()=>{
        dismissTile(id);
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$08135afd8c895fad$var$i18n.flagFollowTitle,
                values: {
                    name: name
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "Success",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        dismissTile,
        id,
        name,
        showFlag
    ]);
    const onFollowError = (0, $cozmU.useCallback)(()=>{
        showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$08135afd8c895fad$var$i18n.flagErrorTitle,
                values: {
                    name: name
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $08135afd8c895fad$var$i18n.flagErrorDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "error",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    }, [
        name,
        showFlag
    ]);
    const [changeFeedFollows, { loading: followLoading, error: followError }] = (0, $308Wd.useMutationInterop)($08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation, {
        onCompleted: onFollowSuccess,
        onError: onFollowError,
        refetchQueries: [
            {
                query: (0, $hOSkW.default)
            }
        ],
        __callerPackage__: "feed"
    });
    const [dismissRecTile, { loading: unfollowLoading, error: unfollowError }] = (0, $308Wd.useMutationInterop)($08135afd8c895fad$var$RecommendationTileFeedFollowRecommendationMutation, {
        __callerPackage__: "feed"
    });
    const handleTileLinkButton = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'item',
                actionSubjectId: 'tile',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        id,
        type,
        cardIndex,
        position
    ]);
    const handleTileDismissButton = (0, $cozmU.useCallback)(async ()=>{
        dismissRecTile({
            variables: type === 'user' ? {
                unfollowUser: [
                    id
                ]
            } : {
                unfollowSpace: [
                    id
                ]
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
        dismissTile(id);
    }, [
        dismissTile,
        id,
        dismissRecTile,
        type,
        createAnalyticsEvent,
        cardIndex,
        position
    ]);
    const handleFollowButton = (0, $cozmU.useCallback)(()=>{
        changeFeedFollows({
            variables: type === 'user' ? {
                followUser: [
                    id
                ]
            } : {
                followSpace: [
                    id
                ]
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'follow',
                source: 'suggestionsCard',
                attributes: {
                    settingId: id,
                    settingType: type,
                    recommendationRank: cardIndex,
                    pos: position
                }
            }
        }).fire();
    }, [
        changeFeedFollows,
        type,
        id,
        createAnalyticsEvent,
        cardIndex,
        position
    ]);
    const titleOrType = type === 'user' ? title : intl.formatMessage($08135afd8c895fad$var$i18n.space);
    const renderFollowButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: handleFollowButton,
            onMouseEnter: disableTileHover,
            onMouseLeave: enableTileHover,
            appearance: "primary",
            isDisabled: followLoading,
            "aria-label": intl.formatMessage($08135afd8c895fad$var$i18n.followLabel, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $08135afd8c895fad$var$i18n.follow));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "feed-rec-tile-wrapper",
        className: (0, $hekY6.default)([
            "_2uo31f7Cj1 _30huDKOeNX _0bjKvDzXzM _4FKVYE2ADO _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuZHm0 _0jFU0VP8hX _3YEZNOdnbC _4ouGXIdnbC _39xV02bj7b _3yilb87p2s _24h04i2Njc _2fwxA5DIqT _1pp6NdIZbP _0adFHsey7F _1YKVNs7dHp",
            (unfollowLoading || followLoading) && "_1YKVNsXvJ3",
            tileHover && "_30zrXRqWX3"
        ])
    }, followError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: followError
    }), unfollowError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: unfollowError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        href: url,
        onClick: handleTileLinkButton,
        target: "_blank",
        appearance: "link",
        theme: $08135afd8c895fad$var$fullSizeButtonTheme,
        testId: "feed-rec-tile-link",
        "aria-label": intl.formatMessage($08135afd8c895fad$var$i18n.profileTile, {
            name: name
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        appearance: "subtle",
        theme: $08135afd8c895fad$var$dismissTileButtonTheme,
        onClick: handleTileDismissButton,
        onMouseEnter: disableTileHover,
        onMouseLeave: enableTileHover,
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: intl.formatMessage($08135afd8c895fad$var$i18n.dismissLabel, {
                name: name
            })
        }),
        isDisabled: unfollowLoading
    }), type === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: icon,
        alt: "",
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _39xV02Uofl _0jFU0VUofl"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
        src: icon,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02N91d"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _1mT5xdRAKS"
        ])
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VEbN9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: titleOrType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _39HuIbz8Lp _1ANEUSLRg7 _1mT5xdRAKS"
        ])
    }, titleOrType)))), renderFollowButton());
};
module.exports["TILE_MARGIN"] = $08135afd8c895fad$export$f2a133baea81f082;
module.exports["PAGE_SIZE"] = $08135afd8c895fad$export$8ec3d08588d2eeda;
module.exports["RecommendationTile"] = $08135afd8c895fad$export$debb778f17cf50d6;

});

parcelRegister("b29u2", function(module, exports) {

var $22wWM = parcelRequire("22wWM");

const $31e467a602725ad9$export$db2714a6b5ad421e = (0, $22wWM.default);
module.exports["FeedRecommendationQuery"] = $31e467a602725ad9$export$db2714a6b5ad421e;

});

parcelRegister("947Tc", function(module, exports) {
/**
 * @generated SignedSource<<66af68bb45ffd72b420e5908d8c4be42>>
 * @relayHash 0a96cc03e37bbf3867e6744daa23017e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13
const $816d87a7d012cf39$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "score"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "RecommendedFeedUserConfig",
            "kind": "LinkedField",
            "name": "getRecommendedFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "RecommendedSpaceItem",
                    "kind": "LinkedField",
                    "name": "recommendedSpaces",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "RecommendedPeopleItem",
                    "kind": "LinkedField",
                    "name": "recommendedPeople",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isActive"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0a96cc03e37bbf3867e6744daa23017e",
            "id": "efcaebfa892eb7b5401d08c3aae85bece7d435ed2ea26e7a97b3ebeb61c6ce13",
            "metadata": {},
            "name": "useFeedRecommendationsFeedRecommendationQuery",
            "operationKind": "query",
            "text": "query useFeedRecommendationsFeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$816d87a7d012cf39$var$node.hash = "f23db13107460d6f583073e645fa5821";
var $816d87a7d012cf39$export$2e2bcd8739ae039 = $816d87a7d012cf39$var$node;
module.exports["default"] = $816d87a7d012cf39$export$2e2bcd8739ae039;

});

parcelRegister("g9apM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $vIR70 = parcelRequire("vIR70");


var $iKkTC = parcelRequire("iKkTC");

const $58f18573d7e609e7$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorHeader: {
        id: "feed.error.pagination.header",
        defaultMessage: "We couldn\u2019t load more content"
    },
    buttonText: {
        id: "feed.error.pagination.button.text",
        defaultMessage: "Try again"
    }
});
const $58f18573d7e609e7$var$PaginationFeedErrorComponent = ({ refetch: refetch, intl: intl })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const handleRefresh = (0, $cozmU.useCallback)(async ()=>{
        setLoading(true);
        await refetch();
        setLoading(false);
    }, [
        refetch,
        setLoading
    ]);
    const refreshButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        onClick: handleRefresh,
        isLoading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $58f18573d7e609e7$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage($58f18573d7e609e7$export$a7357cdd1f0b0168.errorHeader),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iKkTC))),
        imageHeight: 95,
        primaryAction: refreshButton
    });
};
const $58f18573d7e609e7$export$9d195d5a23115090 = (0, $kSwu1.injectIntl)($58f18573d7e609e7$var$PaginationFeedErrorComponent);
module.exports["PaginationFeedError"] = $58f18573d7e609e7$export$9d195d5a23115090;

});

parcelRegister("3HoFy", function(module, exports) {
/* EndOfFeed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $cJ0FD = parcelRequire("cJ0FD");


var $RfroO = parcelRequire("RfroO");


var $7ZB0A = parcelRequire("7ZB0A");


var $ae97Z = parcelRequire("ae97Z");


var $jPuSk = parcelRequire("jPuSk");

const $63720c22c6efb9f3$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    header: {
        id: "feed.end-of-feed.header",
        defaultMessage: "No more activity"
    },
    description: {
        id: "feed.end-of-feed.description",
        defaultMessage: "Check back later or refine your feed for more updates"
    },
    buttonText: {
        id: "feed.end-of-feed.button.text",
        defaultMessage: "Edit feed"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63720c22c6efb9f3$var$EndOfFeedImage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $cJ0FD.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlLrr0 _0NUa3rLrr0",
            __cmplp.className
        ])
    });
});
const $63720c22c6efb9f3$var$EndOfFeedComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal })=>{
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: openActivityFilterModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $63720c22c6efb9f3$export$a7357cdd1f0b0168.buttonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "end-of-feed-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage($63720c22c6efb9f3$export$a7357cdd1f0b0168.header),
        description: openActivityFilterModal ? intl.formatMessage($63720c22c6efb9f3$export$a7357cdd1f0b0168.description) : undefined,
        primaryAction: openActivityFilterModal ? actionButton : undefined,
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63720c22c6efb9f3$var$EndOfFeedImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ae97Z))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jPuSk))),
                width: "74",
                height: "74",
                alt: ""
            }),
        imageHeight: 74
    }));
};
const $63720c22c6efb9f3$export$da82081e1e4aa68f = (0, $kSwu1.injectIntl)($63720c22c6efb9f3$var$EndOfFeedComponent);
module.exports["EndOfFeed"] = $63720c22c6efb9f3$export$da82081e1e4aa68f;

});

parcelRegister("2Jztb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $V3JOP = parcelRequire("V3JOP");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $kz1Yj = parcelRequire("kz1Yj");


var $6Pqow = parcelRequire("6Pqow");


var $l8Rhq = parcelRequire("l8Rhq");


var $buxP3 = parcelRequire("buxP3");


var $NlHoa = parcelRequire("NlHoa");


var $5x1q6 = parcelRequire("5x1q6");


var $jXbuX = parcelRequire("jXbuX");


var $4yg2A = parcelRequire("4yg2A");

const $c2d7df2e9e74f714$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    popularEndBannerText: {
        id: "feed.end-of-feed-home-banner.popular-banner",
        defaultMessage: "Discover what else is popular across your organisation"
    },
    popularEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.popular-link",
        defaultMessage: "View all popular content"
    },
    welcomeEndBannerText: {
        id: "feed.end-of-feed-home-banner.welcome-banner",
        defaultMessage: "See who else is new at Atlassian"
    },
    welcomeEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.welcome-link",
        defaultMessage: "View all welcomes"
    },
    farewellEndBannerText: {
        id: "feed.end-of-feed-home-banner.farewell-banner",
        defaultMessage: "See who else is leaving Atlassian"
    },
    farewellEndBannerLinkText: {
        id: "feed.end-of-feed-home-banner.farewell-link",
        defaultMessage: "View all farewells"
    },
    welcomeIconLabel: {
        id: "feed.end-of-feed-home-banner.welcome-icon",
        defaultMessage: "Welcome"
    },
    farewellIconLabel: {
        id: "feed.end-of-feed-home-banner.farewell-icon",
        defaultMessage: "Farewell"
    }
});
const $c2d7df2e9e74f714$var$linkTextStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $c2d7df2e9e74f714$var$anchorStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    textDecoration: 'none',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.100',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    marginRight: 'space.100',
    paddingRight: 'space.100',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $c2d7df2e9e74f714$var$bannerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.input.hovered',
    borderRadius: 'radius.small',
    marginTop: 'space.100',
    padding: 'space.100',
    height: '64px'
});
const $c2d7df2e9e74f714$var$bannerTextStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100'
});
const $c2d7df2e9e74f714$var$singleIconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.200'
});
const $c2d7df2e9e74f714$var$homeIconStyles = (0, $buxP3.xcss)({
    height: '32px'
});
const $c2d7df2e9e74f714$var$getBannerText = (feedType)=>{
    switch(feedType){
        case (0, $4yg2A.FeedType).WELCOME:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeEndBannerLinkText
            ];
        case (0, $4yg2A.FeedType).FAREWELL:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellEndBannerLinkText
            ];
        case (0, $4yg2A.FeedType).POPULAR:
            return [
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.popularEndBannerText,
                $c2d7df2e9e74f714$export$a7357cdd1f0b0168.popularEndBannerLinkText
            ];
        default:
            return [];
    }
};
const $c2d7df2e9e74f714$export$cadca85bfc944b3 = ({ linkHref: linkHref, feedType: feedType })=>{
    const [text, linkText] = $c2d7df2e9e74f714$var$getBannerText(feedType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const getLinkToRender = ()=>{
        switch(feedType){
            case (0, $4yg2A.FeedType).WELCOME:
                return `${linkHref}&tab=welcome`;
            case (0, $4yg2A.FeedType).FAREWELL:
                return `${linkHref}&tab=farewell`;
            case (0, $4yg2A.FeedType).POPULAR:
            default:
                return linkHref;
        }
    };
    const renderIcons = ()=>{
        switch(feedType){
            case (0, $4yg2A.FeedType).POPULAR:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                    testId: "icon-group",
                    xcss: [
                        $c2d7df2e9e74f714$var$singleIconStyles,
                        $c2d7df2e9e74f714$var$homeIconStyles
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), null));
            case (0, $4yg2A.FeedType).WELCOME:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    testId: "welcome-icon",
                    xcss: $c2d7df2e9e74f714$var$singleIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5x1q6))), {
                    label: $c2d7df2e9e74f714$export$a7357cdd1f0b0168.welcomeIconLabel.defaultMessage
                }));
            case (0, $4yg2A.FeedType).FAREWELL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    testId: "farewell-icon",
                    xcss: $c2d7df2e9e74f714$var$singleIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))), {
                    label: $c2d7df2e9e74f714$export$a7357cdd1f0b0168.farewellIconLabel.defaultMessage
                }));
        }
    };
    const handleLinkClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'reducedFeed',
                action: 'clicked',
                actionSubject: 'link',
                attributes: {
                    feedType: feedType
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        testId: "end-of-feed-home-banner",
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $c2d7df2e9e74f714$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c2d7df2e9e74f714$var$bannerTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center"
    }, renderIcons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
        xcss: $c2d7df2e9e74f714$var$anchorStyles,
        href: getLinkToRender(),
        onClick: handleLinkClick,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c2d7df2e9e74f714$var$linkTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), linkText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "Open",
        size: "small"
    })))));
};
module.exports["EndOfFeedHomeBanner"] = $c2d7df2e9e74f714$export$cadca85bfc944b3;

});

parcelRegister("kVcC2", function(module, exports) {
/* EndOfFollowingFeed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $RfroO = parcelRequire("RfroO");


var $cJ0FD = parcelRequire("cJ0FD");


var $6mKj3 = parcelRequire("6mKj3");


var $c9bsS = parcelRequire("c9bsS");


var $h25ik = parcelRequire("h25ik");


var $3bXrA = parcelRequire("3bXrA");


var $8ljLC = parcelRequire("8ljLC");


var $lwwxZ = parcelRequire("lwwxZ");

const $c54cc9644fd2fde7$var$messages = (0, $kSwu1.defineMessages)({
    preFollowingHeading: {
        id: "feed.end-of-following.pre-follow.header",
        defaultMessage: "Stay connected with your team"
    },
    preFollowingDescription: {
        id: "feed.end-of-following.pre-follow.description",
        defaultMessage: "Follow people and spaces to see their latest work in your feed."
    },
    preFollowingCta: {
        id: "feed.end-of-following.pre-follow.cta",
        defaultMessage: "Follow people"
    },
    postFollowingHeading: {
        id: "feed.end-of-following.post-follow.header",
        defaultMessage: "You're all caught up"
    },
    postFollowingDescription: {
        id: "feed.end-of-following.post-follow.description",
        defaultMessage: "Check back later or follow other teammates to see new updates."
    },
    postFollowingCta: {
        id: "feed.end-of-following.post-follow.cta",
        defaultMessage: "Edit feed"
    }
});
const $c54cc9644fd2fde7$var$endOfFeedImageStyles = null;
const $c54cc9644fd2fde7$var$dividerContainerStyles = null;
const $c54cc9644fd2fde7$var$EndOfFollowingFeedComponent = ({ intl: intl, openActivityFilterModal: openActivityFilterModal, hasFollowedAnyone: hasFollowedAnyone = false, hasResults: hasResults = true })=>{
    const isFollowingEmpty = !hasResults;
    const isPreFollowing = !hasFollowedAnyone && isFollowingEmpty;
    if (isFollowingEmpty && (0, $6mKj3.expVal)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwwxZ.FollowingFeedEmptyStateBanner), {
        openActivityFilterModal: openActivityFilterModal
    });
    const heading = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingHeading : $c54cc9644fd2fde7$var$messages.postFollowingHeading;
    const description = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingDescription : $c54cc9644fd2fde7$var$messages.postFollowingDescription;
    const ctaText = isPreFollowing ? $c54cc9644fd2fde7$var$messages.preFollowingCta : $c54cc9644fd2fde7$var$messages.postFollowingCta;
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: openActivityFilterModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), ctaText));
    const emptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage(heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), description),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: isPreFollowing ? (0, (/*@__PURE__*/$parcel$interopDefault($c9bsS))) : (0, (/*@__PURE__*/$parcel$interopDefault($3bXrA))),
                srcDark: isPreFollowing ? (0, (/*@__PURE__*/$parcel$interopDefault($h25ik))) : (0, (/*@__PURE__*/$parcel$interopDefault($8ljLC))),
                width: "74",
                height: "74",
                alt: "",
                className: (0, $hekY6.default)([
                    "_1EqgXlLrr0 _0NUa3rLrr0"
                ])
            }),
        primaryAction: openActivityFilterModal ? actionButton : undefined
    });
    return isPreFollowing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _0Of8r25zaO _3138425zaO"
        ])
    }, emptyState) : emptyState;
};
const $c54cc9644fd2fde7$export$9fb63a8d2c93fe03 = (0, $kSwu1.injectIntl)($c54cc9644fd2fde7$var$EndOfFollowingFeedComponent);
module.exports["EndOfFollowingFeed"] = $c54cc9644fd2fde7$export$9fb63a8d2c93fe03;

});

parcelRegister("8KJF2", function(module, exports) {
/* EndOfPopularFeed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $7ZB0A = parcelRequire("7ZB0A");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $6mKj3 = parcelRequire("6mKj3");


var $7EIq6 = parcelRequire("7EIq6");


var $VHj6G = parcelRequire("VHj6G");


var $ep3mz = parcelRequire("ep3mz");


var $ggZ0S = parcelRequire("ggZ0S");


var $iArlt = parcelRequire("iArlt");


var $8n54R = parcelRequire("8n54R");


var $kuc4Y = parcelRequire("kuc4Y");


var $flZ2G = parcelRequire("flZ2G");

const $0e232958555543fb$var$CREATE_DOC_SOURCE = 'popularFeedEmptyState';
const $0e232958555543fb$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        id: "feed.end-of-popular.header",
        defaultMessage: "Nothing's trending just yet"
    },
    emptyStateBannerTitle: {
        id: "feed.end-of-popular.banner.title",
        defaultMessage: "Nothing's trending just yet."
    },
    description: {
        id: "feed.end-of-popular.description",
        defaultMessage: "Kick things off by creating something others will want to read, react to, and share."
    },
    ctaCreateDoc: {
        id: "feed.end-of-popular.cta.create-doc",
        defaultMessage: "Create doc"
    },
    ctaCreatePage: {
        id: "feed.end-of-popular.cta.create-page",
        defaultMessage: "Create page"
    }
});
const $0e232958555543fb$var$endOfFeedImageStyles = null;
const $0e232958555543fb$var$dividerContainerStyles = null;
const $0e232958555543fb$var$skeletonCardImageStyles = null;
const $0e232958555543fb$var$emptyStateBannerStyles = {
    banner: "_0bjKvDyzSk _4c065U8HPE _2Y7lL45zaO _3138422ADO",
    content: "_4ouGXIdnbC",
    text: "_4ouGXIdnbC",
    iconSlot: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _0hPCNLDIqT _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02Uofl"
};
const $0e232958555543fb$var$popularFeedImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
), {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($ggZ0S))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($iArlt))),
    width: "74",
    height: "74",
    alt: "",
    className: (0, $hekY6.default)([
        "_1EqgXlLrr0 _0NUa3rLrr0"
    ])
}); /**
                                                                                                                                          * Popular feed empty state (rendered when `cc_mohiti_for_you_empty_states_exp` is off).
                                                                                                                                          * Unchanged behaviour: label toggles between "Create doc" / "Create page" and the CTA routes
                                                                                                                                          * through the existing {@link useCreateDoc} flow.
                                                                                                                                          */ 
const $0e232958555543fb$var$PopularFeedEmptyState = ({ intl: intl })=>{
    const { createDoc: createDoc } = (0, $flZ2G.useCreateDoc)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: createDoc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isCreateLiveDocEnabled ? $0e232958555543fb$var$messages.ctaCreateDoc : $0e232958555543fb$var$messages.ctaCreatePage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _0Of8r25zaO _3138425zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage($0e232958555543fb$var$messages.heading),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0e232958555543fb$var$messages.description),
        renderImage: ()=>$0e232958555543fb$var$popularFeedImage,
        primaryAction: actionButton
    }));
};
const $0e232958555543fb$var$PopularFeedSkeletonCards = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "popular-feed-skeleton-cards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        testId: "popular-feed-skeleton-card",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8n54R))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuc4Y))),
        alt: "",
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _0jFU0VIZbP _39xV02N91d"
        ])
    })); /**
          * Popular feed empty-state banner (rendered when `cc_mohiti_for_you_empty_states_exp` is on).
          *
          * Delegates the "Create doc" CTA to the {@link useCreateHomeEmptyStateDoc} helper, whose
          * fallback chain is: personal-space live doc -> CWR -> creation link.
          */ 
const $0e232958555543fb$var$PopularFeedEmptyStateBanner = ()=>{
    const { createDoc: createDoc } = (0, $VHj6G.useCreateHomeEmptyStateDoc)({
        source: $0e232958555543fb$var$CREATE_DOC_SOURCE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        backgroundColor: "elevation.surface.sunken",
        xcss: $0e232958555543fb$var$emptyStateBannerStyles.banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        space: "space.200",
        xcss: $0e232958555543fb$var$emptyStateBannerStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e232958555543fb$var$emptyStateBannerStyles.iconSlot,
        testId: "popular-feed-empty-icon",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ggZ0S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($iArlt))),
        width: "32",
        height: "32",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e232958555543fb$var$emptyStateBannerStyles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0e232958555543fb$var$messages.emptyStateBannerTitle)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0e232958555543fb$var$messages.description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: createDoc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0e232958555543fb$var$messages.ctaCreateDoc)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e232958555543fb$var$PopularFeedSkeletonCards, null));
};
const $0e232958555543fb$var$EndOfPopularFeedComponent = ({ intl: intl })=>{
    if ((0, $6mKj3.expValEquals)('cc_mohiti_for_you_empty_states_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e232958555543fb$var$PopularFeedEmptyStateBanner, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e232958555543fb$var$PopularFeedEmptyState, {
        intl: intl
    });
};
const $0e232958555543fb$export$5546b04b9c06a7cf = (0, $kSwu1.injectIntl)($0e232958555543fb$var$EndOfPopularFeedComponent);
module.exports["EndOfPopularFeed"] = $0e232958555543fb$export$5546b04b9c06a7cf;

});

parcelRegister("g973h", function(module, exports) {
/* FeedCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");


var $hc9K5 = parcelRequire("hc9K5");

const $00506369c0094ae9$var$skeletonWrapperStyle = null;
const $00506369c0094ae9$var$skeletonBodyStyle = null;
const $00506369c0094ae9$export$1e1e3a5bb38df355 = ({ useEntranceAnimation: useEntranceAnimation })=>{
    if (useEntranceAnimation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        entranceDirection: "bottom"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...animationProps,
            "data-testid": "feed-card-skeleton",
            className: (0, $hekY6.default)([
                "_1DCdHi5zaO _39Ohv4YbGa _1SdfoHYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "skeleton-body",
            className: (0, $hekY6.default)([
                "_2uo31fGsB2 _0bjKvD8fU6 _0jFU0V24oa _39xV02N91d"
            ])
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "feed-card-skeleton",
        className: (0, $hekY6.default)([
            "_1DCdHi5zaO _39Ohv4YbGa _1SdfoHYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "skeleton-body",
        className: (0, $hekY6.default)([
            "_2uo31fGsB2 _0bjKvD8fU6 _0jFU0V24oa _39xV02N91d"
        ])
    }));
};
const $00506369c0094ae9$export$44c18d210d5de37b = /*#__PURE__*/ (0, $cozmU.memo)(({ useEntranceAnimation: useEntranceAnimation })=>{
    const Wrapper = useEntranceAnimation ? (0, $hc9K5.default) : (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        columns: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00506369c0094ae9$export$1e1e3a5bb38df355, {
        useEntranceAnimation: useEntranceAnimation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00506369c0094ae9$export$1e1e3a5bb38df355, {
        useEntranceAnimation: useEntranceAnimation
    }));
}, ()=>true);
module.exports["LoadingSkeleton"] = $00506369c0094ae9$export$44c18d210d5de37b;

});

parcelRegister("lLUup", function(module, exports) {
module.exports = new URL("appStoreBadge.eba12d98.svg", import.meta.url).toString();

});

parcelRegister("fYQO1", function(module, exports) {
module.exports = new URL("googlePlayBadge.eb604ba3.svg", import.meta.url).toString();

});

parcelRegister("kCjG6", function(module, exports) {
module.exports = new URL("qrCode.5273b9c3.svg", import.meta.url).toString();

});

parcelRegister("2JWAq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $7d1d3b157043f9aa$var$TWO_WEEKS_MS = 1209600000;
const $7d1d3b157043f9aa$var$getIsDismissed = ()=>{
    const now = Date.now();
    const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED);
    // Permanently dismissed
    if (value === 'true') return {
        isDismissed: true,
        isAutoDismissed: false
    };
    // Value is not set or blank
    if (!value || value.trim() === '') return {
        isDismissed: false,
        isAutoDismissed: false
    };
    // Check if the value is a first-seen timestamp
    const firstSeenDate = parseInt(value, 10);
    const isTimestamp = !isNaN(firstSeenDate);
    const isExpired = isTimestamp && now - firstSeenDate > $7d1d3b157043f9aa$var$TWO_WEEKS_MS;
    if (isTimestamp && !isExpired) return {
        isDismissed: false,
        isAutoDismissed: false
    };
    // Default: timestamp exceeded 2 weeks or is unrecognizable (corrupted) — dismiss
    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, 'true');
    // Only fire auto-dismissal analytics if it was a legitimate time-based expiry
    return {
        isDismissed: true,
        isAutoDismissed: isExpired
    };
};
const $7d1d3b157043f9aa$var$onMobileAppPromoView = ()=>{
    const now = Date.now();
    const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED);
    // Only record the first-seen timestamp if nothing is stored yet
    if (!value) (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, now.toString());
};
const $7d1d3b157043f9aa$export$69b45bc725cebf2c = (options)=>{
    const [{ isDismissed: isDismissed, isAutoDismissed: isAutoDismissed }, setDismissState] = (0, $cozmU.useState)($7d1d3b157043f9aa$var$getIsDismissed);
    (0, $cozmU.useEffect)(()=>{
        if (isAutoDismissed) options?.onAutoDismiss?.();
    // We only want to run this once on mount when the state is initialized
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onMobileAppPromoDismiss = (0, $cozmU.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_MOBILE_APP_PROMO_DISMISSED, 'true');
        setDismissState({
            isDismissed: true,
            isAutoDismissed: false
        });
    }, []);
    return {
        isMobileAppPromoDismissed: isDismissed,
        onMobileAppPromoDismiss: onMobileAppPromoDismiss,
        onMobileAppPromoView: $7d1d3b157043f9aa$var$onMobileAppPromoView
    };
};
module.exports["useMobileAppPromoDismiss"] = $7d1d3b157043f9aa$export$69b45bc725cebf2c;

});

parcelRegister("dmmkE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5SGpQ = parcelRequire("5SGpQ");

const $64085d8549e7e41d$var$subtleLinkButtonTheme = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            color: `${"var(--ds-text-subtle, #505258)"} !important`,
            fontWeight: "var(--ds-font-weight-regular, 400)"
        },
        spinnerStyles: spinnerStyles
    };
};
const $64085d8549e7e41d$export$902dde2c01bb0707 = ({ href: href, onClick: onClick, testId: testId, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        href: href,
        onClick: onClick,
        theme: $64085d8549e7e41d$var$subtleLinkButtonTheme,
        appearance: "subtle-link",
        spacing: "none",
        testId: testId
    }, children);
};
module.exports["SubtleLink"] = $64085d8549e7e41d$export$902dde2c01bb0707;

});

parcelRegister("wHo13", function(module, exports) {
/**
 * @generated SignedSource<<e16f8b7f8e00acdb9b4561cd1ce383bc>>
 * @relayHash ec4d8643ad14f845c672ac02c6477a9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3
const $52baa5aeaf71ebad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fromDate"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "fromDate",
            "variableName": "fromDate"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "timestamp"
    }, v5 = {
        "kind": "ScalarField",
        "name": "action"
    }, v6 = {
        "kind": "ScalarField",
        "name": "actionSubject"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    }, v11 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventCreatedPage"
    }, v13 = {
        "kind": "ScalarField",
        "name": "pageVersion"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v7 /*: any*/ ,
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventUpdatedPage"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "concreteType": "Map_LinkType_String",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "webui"
                            }
                        ]
                    }
                ]
            },
            v11 /*: any*/ 
        ],
        "type": "PageActivityEventCreatedComment"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v13 /*: any*/ ,
        v7 /*: any*/ ,
        v17 /*: any*/ ,
        v16 /*: any*/ 
    ], v19 = {
        "concreteType": "PageActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v20 = [
        v13 /*: any*/ ,
        v7 /*: any*/ ,
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPageActivity",
                    "kind": "LinkedField",
                    "name": "pageActivity",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventStartedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventSnapshottedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v18 /*: any*/ ,
                                    "type": "PageActivityEventPublishedPage"
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPageActivity",
                    "kind": "LinkedField",
                    "name": "pageActivity",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventStartedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventSnapshottedPage"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v20 /*: any*/ ,
                                    "type": "PageActivityEventPublishedPage"
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ec4d8643ad14f845c672ac02c6477a9a",
            "id": "294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3",
            "metadata": {},
            "name": "AllActivityDropdownFeedCardAllActivityQuery",
            "operationKind": "query",
            "text": "query AllActivityDropdownFeedCardAllActivityQuery($contentId:ID!,$after:String,$fromDate:String){pageActivity(contentId:$contentId,after:$after,fromDate:$fromDate){nodes{__typename,timestamp,action,actionSubject,...on PageActivityEventCreatedPage{groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventUpdatedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventCreatedComment{groupSize,comment{id,links{webui}},user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventStartedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventSnapshottedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventPublishedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$52baa5aeaf71ebad$var$node.hash = "ece1744e2c59bb61b408ccc9b612626e";
var $52baa5aeaf71ebad$export$2e2bcd8739ae039 = $52baa5aeaf71ebad$var$node;
module.exports["default"] = $52baa5aeaf71ebad$export$2e2bcd8739ae039;

});

parcelRegister("aOmNU", function(module, exports) {
/* ActivityLineUpdateDetail.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $fs6LW = parcelRequire("fs6LW");


var $3WnxN = parcelRequire("3WnxN");


var $fYx4v = parcelRequire("fYx4v");

const $3351eb88a16189f4$var$ActionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4kiQYAe65H _1DCdHi8HPE",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$var$profileWrapperStyles = (0, $buxP3.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3351eb88a16189f4$var$ActionMessage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2HEQWwmnOE _0ojMq8y7kJ _3SAfpPy7kJ",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$var$ActionTimeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $3351eb88a16189f4$export$ed487d3c096aa527 = ({ type: type, actionTime: actionTime, userId: userId, avatarUrl: avatarUrl, userDisplayName: userDisplayName, link: link, groupSize: groupSize })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3351eb88a16189f4$var$ActionWrapper, {
        "data-testid": "activity-update-detail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3351eb88a16189f4$var$profileWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        canViewProfile: true,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3351eb88a16189f4$var$ActionMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYx4v.ActivityLineUpdateLink), {
        type: type,
        userDisplayName: userDisplayName,
        link: link,
        groupSize: groupSize,
        activityDropdownLineItem: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3351eb88a16189f4$var$ActionTimeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WnxN.ActionTime), {
        actionTime: actionTime
    }))));
};
module.exports["ActivityLineUpdateDetail"] = $3351eb88a16189f4$export$ed487d3c096aa527;

});

parcelRegister("j9RXG", function(module, exports) {
/* AllActivityError.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $iKkTC = parcelRequire("iKkTC");

const $1d330f1d32728694$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    error: {
        id: "feed.card.activity.error.image.alt",
        defaultMessage: "Error"
    },
    errorMessage: {
        id: "feed.card.activity.error.generic.message",
        defaultMessage: "We couldn\u2019t load the recent actions"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d330f1d32728694$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHi8HPE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $1d330f1d32728694$var$Image = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9aYkv.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0jFU0VuEhg _1DCdHi5zaO",
            __cmplp.className
        ])
    });
});
const $1d330f1d32728694$export$824e2da99dfa6504 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d330f1d32728694$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d330f1d32728694$var$Image, {
        height: 65,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iKkTC))),
        alt: intl.formatMessage($1d330f1d32728694$export$a7357cdd1f0b0168.error)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1d330f1d32728694$export$a7357cdd1f0b0168.errorMessage));
};
module.exports["AllActivityError"] = $1d330f1d32728694$export$824e2da99dfa6504;

});

parcelRegister("9WXEQ", function(module, exports) {
/* ActivityLineUpdateDetailSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $17d31874853c3173$var$SkeletonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VcGqM _1DCdHi8HPE",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Avatar = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fDMqu _2XghbEFQfX _0bjKvDS5Zs _0jFU0VUofl _39xV02Uofl _0adFHs8HPE",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Action = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fDMqu _0bjKvDS5Zs _39xV02eSJV _1DCdHigVvo _0jFU0VEbN9",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$var$Time = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fDMqu _0bjKvDS5Zs _39xV02j2U4 _0jFU0VdLIE",
            __cmplp.className
        ])
    });
});
const $17d31874853c3173$export$ab8d550fbc7c1fd1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17d31874853c3173$var$SkeletonWrapper, {
        "data-testid": "activity-detail-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17d31874853c3173$var$Avatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17d31874853c3173$var$Action, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17d31874853c3173$var$Time, null)));
module.exports["ActivityLineUpdateDetailSkeleton"] = $17d31874853c3173$export$ab8d550fbc7c1fd1;

});

parcelRegister("ip3cc", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $b6yoO = parcelRequire("b6yoO");

// We map PageActivityActionSubject to more closely match FeedContentQuery's FeedEventType
// because the FE displays them the same by ActivityLineUpdateLink, even though these are used for Recent Actions and FeedEventType is used for the feed card itself.
const $e356c594c5c0f12c$var$supportedUpdateTypes = {
    [(0, $b6yoO.PageActivityActionSubject).page]: {
        [(0, $b6yoO.PageActivityAction).created]: 'CREATE',
        [(0, $b6yoO.PageActivityAction).started]: 'CREATE',
        [(0, $b6yoO.PageActivityAction).updated]: 'EDIT',
        [(0, $b6yoO.PageActivityAction).snapshotted]: 'EDITLIVE',
        [(0, $b6yoO.PageActivityAction).published]: 'PUBLISHLIVE'
    },
    [(0, $b6yoO.PageActivityActionSubject).comment]: {
        [(0, $b6yoO.PageActivityAction).created]: 'COMMENT'
    }
};
const $e356c594c5c0f12c$export$42a9f90d0b7de10d = (actionSubject, action)=>{
    return $e356c594c5c0f12c$var$supportedUpdateTypes[actionSubject]?.[action];
};
const $e356c594c5c0f12c$export$b4f8f1f54acec99b = (photos)=>{
    return photos?.find((photo)=>photo?.isPrimary)?.value || '';
};
const $e356c594c5c0f12c$export$5c5c1edd93b1722b = (activity, contentUrl, contentId)=>{
    const type = $e356c594c5c0f12c$export$42a9f90d0b7de10d(activity.actionSubject, activity.action);
    if (type === 'COMMENT') {
        const commentLink = activity.comment.links.webui;
        if (commentLink) return `${0, $jlIaF.CONTEXT_PATH}${commentLink}`;
    }
    if (type === 'CREATE' || type === 'PUBLISHLIVE') return contentUrl;
    if (type === 'EDIT' || type === 'EDITLIVE') {
        const version = activity.pageVersion;
        const params = {
            query: {
                pageId: contentId,
                selectedPageVersions: [
                    version,
                    version - 1
                ]
            }
        };
        return (0, $1NBp8.PAGE_DIFF_BY_VERSION).toUrl({}, params);
    }
    return '';
};
module.exports["getSupportedUpdateType"] = $e356c594c5c0f12c$export$42a9f90d0b7de10d;
module.exports["getAvatarUrl"] = $e356c594c5c0f12c$export$b4f8f1f54acec99b;
module.exports["getUpdateContentUrl"] = $e356c594c5c0f12c$export$5c5c1edd93b1722b;

});

parcelRegister("bJFcf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6uluu = parcelRequire("6uluu");

const $bfdeb8aabeb4e669$export$434c217d363ea16 = /*#__PURE__*/ (0, $cozmU.memo)(({ comments: comments, pageId: pageId, contentType: contentType })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "feed-card-comments"
    }, comments.map((commentData)=>{
        if (commentData?.comment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6uluu.Comment), {
            key: commentData.comment.id,
            user: commentData.user,
            comment: commentData.comment,
            pageId: pageId,
            contentType: contentType
        });
        return null;
    }));
});
module.exports["Comments"] = $bfdeb8aabeb4e669$export$434c217d363ea16;

});

parcelRegister("aG5uJ", function(module, exports) {
/* RenderedContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $hEeUR = parcelRequire("hEeUR");


var $9yPX0 = parcelRequire("9yPX0");


var $cYSIK = parcelRequire("cYSIK");

const $ab6d11ccc649509c$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "feed.card.comment.showMore",
        defaultMessage: "Show more"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab6d11ccc649509c$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ContentBlur = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3CkH9olQi4 _0jFU0VoWWg _39xV02N91d _0Bm75GLl21 _1mT5xdWVPG _42Yu6B7dHp _3iDTPbQ4SZ _37wbyuz9WS",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ExpandContent = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31f7Cj1 _4xdlr0z9WS",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$var$ClearFix = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uxTLTZSoF",
            __cmplp.className
        ])
    });
});
const $ab6d11ccc649509c$export$d2a6a47af75be715 = ({ content: content })=>{
    const contentId = content.id;
    const adfValue = (!content.body.format || content.body.format === 'ADF') && JSON.parse(content.body.value);
    const [contentEl, setContentEl] = (0, $cozmU.useState)(null);
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(false);
    const observerRef = (0, $cozmU.useRef)(null);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    (0, $cozmU.useEffect)(()=>{
        if (contentEl) {
            if (!observerRef.current) observerRef.current = new ResizeObserver((entries)=>{
                if (entries[0].contentRect.height > (0, $9yPX0.COMMENT_COLLAPSE_THRESHOLD)) setCollapsed(true);
            });
            observerRef.current.observe(contentEl);
        }
    }, [
        contentEl,
        observerRef
    ]);
    const expandContent = (0, $cozmU.useCallback)(()=>{
        observerRef.current?.disconnect();
        setCollapsed(false);
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'seeMore',
            commentId: contentId,
            contentId: contentId
        });
    }, [
        observerRef,
        setCollapsed,
        contentId,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab6d11ccc649509c$var$ContentWrapper, {
        ref: setContentEl,
        collapsed: collapsed
    }, content.body.format === 'TEXT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, content.body.value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: adfValue,
        portal: contentEl ?? undefined,
        contentId: contentId,
        isTruncatedContent: collapsed,
        fadeOutHeight: 0,
        maxHeight: (0, $9yPX0.COMMENT_COLLAPSE_THRESHOLD),
        allowStickyHeaders: false,
        appearance: "comment"
    }), collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab6d11ccc649509c$var$ContentBlur, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab6d11ccc649509c$var$ExpandContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: expandContent,
        appearance: "subtle-link",
        spacing: "none"
    }, "\u2026", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ab6d11ccc649509c$var$i18n.showMore)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab6d11ccc649509c$var$ClearFix, null));
};
module.exports["RenderedContent"] = $ab6d11ccc649509c$export$d2a6a47af75be715;

});

parcelRegister("gk2mg", function(module, exports) {
/* FeedCardTitle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $cFVPs = parcelRequire("cFVPs");


var $di8q4 = parcelRequire("di8q4");


var $bCECL = parcelRequire("bCECL");


var $dPJCf = parcelRequire("dPJCf");


var $1dnxO = parcelRequire("1dnxO");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $7uUnJ = parcelRequire("7uUnJ");


var $cYSIK = parcelRequire("cYSIK");

const $741a9cf59ba50c0c$var$styles = null;
const $741a9cf59ba50c0c$var$tooltipContainerSelector = 'feed.TooltipContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$TooltipContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
$741a9cf59ba50c0c$var$TooltipContainer.defaultProps = {
    'data-styled-selector': $741a9cf59ba50c0c$var$tooltipContainerSelector
};
const $741a9cf59ba50c0c$var$TooltipTag = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741a9cf59ba50c0c$var$TooltipContainer, {
        ...rest,
        ref: ref
    }, children);
});
const $741a9cf59ba50c0c$var$titleSelector = 'feed.Title'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$Title = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg20Hp _4bt5LAnQyn _2WAcuGnQyn _2XghbE1Y8M _1mT5xdRAKS _1kk5Tkf7mX _1ANEUSLRg7 _39HuIbz8Lp _1Znuxb1Y8M",
            __cmplp.className
        ])
    });
});
$741a9cf59ba50c0c$var$Title.defaultProps = {
    'data-styled-selector': $741a9cf59ba50c0c$var$titleSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _093nHy98eZ _1ZP3lGYbGa _3d4Huv6wH8 _1wqX9GZpcK _3rjclpy7kJ _05LT73Jejw",
            __cmplp.className
        ])
    });
});
const $741a9cf59ba50c0c$var$ContentIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1AhVZwey7F _30BPNvDqSm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $741a9cf59ba50c0c$var$EmojiContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg20Hp _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F _39xV02ey7F _2QgxMxdnbC _3whNuZdnbC _41uVfTdnbC _306kDGdnbC",
            __cmplp.className
        ])
    });
});
const $741a9cf59ba50c0c$export$fc776ba33c7e14ab = ({ contentTitle: contentTitle, contentUrl: contentUrl, contentType: contentType, contentSubType: contentSubType, emoji: emoji, customIconUrl: customIconUrl, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby, hasAiSnippet: hasAiSnippet })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { trackAIResultAction: trackAIResultAction } = (0, $cFVPs.useAIEventsInstrumentation)();
    const feedType = popularFeedTimeGranularity ? 'popularFeed' : 'followingFeed';
    const handleLinkClick = (0, $cozmU.useCallback)((e)=>{
        if (hasAiSnippet) trackAIResultAction(`${feedType}aiSnippetClicked`);
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.DISCOVER_ITEM_ON_HOME_PAGE_CLICK));
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCard',
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }
        });
        e.preventDefault();
        if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(contentUrl, [
            (0, $71GjD.FeatureCode).HOME_FEED
        ]));
        else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(contentUrl, [
            (0, $71GjD.FeatureCode).HOME_FEED
        ]));
    }, [
        contentType,
        fireAnalyticsEvent,
        popularFeedTimeGranularity,
        followingFeedSortby,
        contentUrl,
        push,
        feedType,
        hasAiSnippet,
        trackAIResultAction
    ]);
    const icon = $741a9cf59ba50c0c$var$getIcon(contentType, contentSubType, customIconUrl, emoji);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741a9cf59ba50c0c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741a9cf59ba50c0c$var$ContentIconWrapper, null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: contentTitle,
        tag: $741a9cf59ba50c0c$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($741a9cf59ba50c0c$var$Title, {
        href: contentUrl,
        onClick: handleLinkClick,
        "data-testid": "feed-card-title-link"
    }, contentTitle)));
};
const $741a9cf59ba50c0c$var$getIcon = (contentType, contentSubType, customIconUrl, emoji)=>{
    const isLivePage = contentType === 'page' && contentSubType === 'live';
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const color = isLivePage ? "var(--ds-icon-accent-magenta, #CD519D)" : "var(--ds-icon-accent-blue, #357DE8)";
    if (customIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        src: customIconUrl,
        width: "16",
        height: "16",
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_1RrJLiUWqv"
        ])
    });
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        emoji: emoji,
        subType: contentSubType,
        color: color
    });
    if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        context: "feedCardBodyIcon",
        height: 16,
        wrapper: $741a9cf59ba50c0c$var$EmojiContainer
    });
    return isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7uUnJ.LiveDocsIconTile), {
        label: "live-doc-tile",
        testId: "live-doc-icon-tile-feed-card",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
        type: contentType
    });
};
module.exports["FeedCardTitle"] = $741a9cf59ba50c0c$export$fc776ba33c7e14ab;

});

parcelRegister("hlJJ7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $jlIaF = parcelRequire("jlIaF");


var $cYSIK = parcelRequire("cYSIK");

const $28bd75c4b6504aaa$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $28bd75c4b6504aaa$var$i18n = (0, $kSwu1.defineMessages)({
    createdBy: {
        id: "feed.card.byline.createdBy",
        defaultMessage: "Created by {name}"
    },
    ownedBy: {
        id: "feed.card.byline.ownedBy",
        defaultMessage: "Owned by {name}"
    },
    profile: {
        id: "feed.card.byline.profile",
        defaultMessage: "profile"
    },
    space: {
        id: "feed.card.byline.space",
        defaultMessage: "space"
    }
});
const $28bd75c4b6504aaa$export$577deec5d331f6be = (currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            textDecoration: 'underline'
        },
        spinnerStyles: spinnerStyles
    };
};
const $28bd75c4b6504aaa$var$LinkOrText = ({ children: children, url: url, analyticsId: analyticsId, label: label, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: analyticsId,
            includeNavdex: true,
            additionalAttributes: {
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }
        });
    }, [
        fireAnalyticsEvent,
        analyticsId,
        popularFeedTimeGranularity,
        followingFeedSortby
    ]);
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        href: url,
        "aria-label": label,
        onClick: handleClick,
        theme: $28bd75c4b6504aaa$export$577deec5d331f6be,
        appearance: "subtle-link",
        spacing: "none"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, children);
};
const $28bd75c4b6504aaa$export$a7ff0168af7e69e = ({ spaceName: spaceName, spaceUrl: spaceUrl, authorName: authorName, authorId: authorId, ownerName: ownerName, ownerId: ownerId, timestamp: timestamp = '', popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const authorUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(authorId, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH));
    const ownerUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(ownerId, 'feed-alpha', (0, $jlIaF.CONTEXT_PATH));
    const intl = (0, $kSwu1.useIntl)();
    const id = ownerId || authorId;
    const name = ownerName || authorName;
    const url = ownerUrl || authorUrl;
    const bylineText = ownerName ? $28bd75c4b6504aaa$var$i18n.ownedBy : $28bd75c4b6504aaa$var$i18n.createdBy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        wrap: "wrap",
        gap: "space.050",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        xcss: $28bd75c4b6504aaa$var$styles
    }, name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        tagName: "div",
        ...bylineText,
        values: {
            name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28bd75c4b6504aaa$var$LinkOrText, {
                label: `${name}, ${intl.formatMessage($28bd75c4b6504aaa$var$i18n.profile)}`,
                url: url,
                analyticsId: "feedCardContentAuthor",
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                userId: id
            }, name))
        }
    }), name && timestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, "\u2022"), timestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, timestamp), spaceName && (name || timestamp) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, "\u2022"), spaceName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28bd75c4b6504aaa$var$LinkOrText, {
        label: `${spaceName}, ${intl.formatMessage($28bd75c4b6504aaa$var$i18n.space)}`,
        url: spaceUrl,
        analyticsId: "feedCardSpace",
        popularFeedTimeGranularity: popularFeedTimeGranularity,
        followingFeedSortby: followingFeedSortby
    }, spaceName));
};
module.exports["FeedCardByLine"] = $28bd75c4b6504aaa$export$a7ff0168af7e69e;

});

parcelRegister("8dkgs", function(module, exports) {
/* FeedCardActionCounts.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");


var $7ZB0A = parcelRequire("7ZB0A");


var $3FlVr = parcelRequire("3FlVr");


var $1NF8X = parcelRequire("1NF8X");


var $8SCD6 = parcelRequire("8SCD6");


var $cYSIK = parcelRequire("cYSIK");

const $30952aff407ac11f$var$i18n = (0, $kSwu1.defineMessages)({
    comments: {
        id: "feed.card.comments.label",
        defaultMessage: "Comments"
    }
});
// Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about isGlobalReactionsAndLikesEnabled being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $30952aff407ac11f$var$ReactionsWrapperBase = ({ isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30952aff407ac11f$var$ReactionsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $30952aff407ac11f$var$ReactionsWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1UtDYzZpcK _1kk5Tkf7mX _0hPCNLz9WS",
            __cmplp.isGlobalReactionsAndLikesEnabled ? "_37wbyuI7V3" : "_37wbyuz9WS",
            __cmplp.className
        ])
    });
});
const $30952aff407ac11f$var$CommentsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2Zuz6QFQfX _1wydGW1Y8M _37wbyu0dzo _4ouGXIfd2c _1UtDYzZpcK _1kk5Tku7m9 _1pdgJ41Y8M",
            __cmplp.className
        ])
    });
});
var $30952aff407ac11f$export$fd58c5b798cd3548 = /*#__PURE__*/ function(ShowCommentState) {
    ShowCommentState[ShowCommentState["Number"] = 0] = "Number";
    ShowCommentState[ShowCommentState["NoShow"] = 1] = "NoShow";
    ShowCommentState[ShowCommentState["ShowComment"] = 2] = "ShowComment";
    ShowCommentState[ShowCommentState["HideComment"] = 3] = "HideComment";
    return ShowCommentState;
}({});
const $30952aff407ac11f$var$FeedCardActionCountsComponent = ({ numComments: numComments, contentId: contentId, contentType: contentType, spaceId: spaceId, intl: intl, showCommentState: showCommentState, onCommentToggleClick: onCommentToggleClick, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const { isReactionsEnabled: isGlobalReactionsAndLikesEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const onToggleClick = (0, $cozmU.useCallback)(()=>{
        onCommentToggleClick();
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: showCommentState === 2 ? 'show-comment' : 'hide-comment',
            additionalAttributes: {
                followingFeedSortby: followingFeedSortby
            }
        });
    }, [
        onCommentToggleClick,
        fireAnalyticsEvent,
        showCommentState,
        followingFeedSortby
    ]);
    const location = contentType === 'page' ? (0, $3FlVr.ReactionLocation).FEED_PAGE : (0, $3FlVr.ReactionLocation).FEED_BLOGPOST;
    const commentToggle = showCommentState === 2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "feed.comment.expand",
        defaultMessage: "Show comment"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "feed.comment.collapse",
        defaultMessage: "Hide comment"
    });
    const commentCount = !!numComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30952aff407ac11f$var$CommentsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
        label: intl.formatMessage($30952aff407ac11f$var$i18n.comments)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "feed.comment.count",
        defaultMessage: "{numComments, plural, one {1 comment} other {# comments}}",
        values: {
            numComments: numComments
        }
    }));
    const optionalCommentToggle = showCommentState > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: onToggleClick,
        appearance: "subtle-link",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: intl.formatMessage($30952aff407ac11f$var$i18n.comments)
        })
    }, commentToggle);
    const renderComments = showCommentState == 0 ? commentCount : optionalCommentToggle;
    const renderReactionsAndComments = ()=>{
        if (contentId && contentType && spaceId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($30952aff407ac11f$var$ReactionsWrapper, {
            isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled,
            "data-testid": "feed-content-reactions"
        }, isGlobalReactionsAndLikesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoaderBackground), {
            contentId: contentId,
            location: location,
            containerId: spaceId,
            containerType: (0, $3FlVr.ReactionContainerType).SPACE,
            popularFeedTimeGranularity: popularFeedTimeGranularity,
            limit: undefined,
            sort: undefined
        }), renderComments));
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("small", null, renderReactionsAndComments());
};
const $30952aff407ac11f$export$a055795d89acf8f7 = (0, $kSwu1.injectIntl)($30952aff407ac11f$var$FeedCardActionCountsComponent);
module.exports["ShowCommentState"] = $30952aff407ac11f$export$fd58c5b798cd3548;
module.exports["FeedCardActionCounts"] = $30952aff407ac11f$export$a055795d89acf8f7;

});

parcelRegister("37OMg", function(module, exports) {

var $3aCVQ = parcelRequire("3aCVQ");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $b3j2Y = parcelRequire("b3j2Y");


var $h9jgP = parcelRequire("h9jgP");


var $jMyy4 = parcelRequire("jMyy4");

const $7d1be96f11cd1892$var$FeedCardActionsMenuQuery = (0, $3aCVQ.default);
const $7d1be96f11cd1892$var$actionsWrapperStyle = null;
const $7d1be96f11cd1892$var$ListItemWrapperStyles = (0, $buxP3.xcss)({
    listStyleType: 'none',
    margin: '0',
    padding: '0'
});
const $7d1be96f11cd1892$export$51e8c4c01930cbec = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId })=>{
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7d1be96f11cd1892$var$FeedCardActionsMenuQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "feed"
    });
    const renderStarAction = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        const isStarred = !!data?.singleContent?.metadata?.currentuser?.favourited?.isFavourite;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h9jgP.FeedCardStarAction), {
            contentId: contentId,
            isStarred: isStarred
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "feed-card-actions",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        as: "ul",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $7d1be96f11cd1892$var$ListItemWrapperStyles,
        as: "li"
    }, renderStarAction())));
});
module.exports["FeedCardActions"] = $7d1be96f11cd1892$export$51e8c4c01930cbec;

});

parcelRegister("4Lw3A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $ddefccd0b521809e$export$b061eda6f93fd096 = ({ feedType: feedType, selectedFeedType: selectedFeedType, setFeedType: setFeedType, isPulseActive: isPulseActive, onPulseClick: onPulseClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleFeedTypeClick = (0, $cozmU.useCallback)(()=>{
        if (selectedFeedType !== feedType) {
            setFeedType(feedType);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'feedTypeSelector',
                    actionSubjectId: feedType.toLowerCase(),
                    source: 'homeScreen',
                    attributes: {
                        homeVersion: 'visualRefresh'
                    }
                }
            }).fire();
        }
    }, [
        feedType,
        selectedFeedType,
        setFeedType,
        createAnalyticsEvent
    ]);
    const handleMouseDown = (0, $cozmU.useCallback)((event)=>{
        // prevent focus
        event.preventDefault();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (isPulseActive) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'feedTypeSelectorPulse',
                attributes: {
                    feedType: feedType.toLowerCase()
                }
            }
        }).fire();
    }, [
        isPulseActive,
        feedType,
        createAnalyticsEvent
    ]);
    const handlePulseClick = (0, $cozmU.useCallback)(()=>{
        if (isPulseActive) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedTypeSelectorPulse',
                    attributes: {
                        feedType: feedType.toLowerCase(),
                        homeVersion: 'visualRefresh'
                    },
                    source: 'homeScreen'
                }
            }).fire();
            onPulseClick();
        }
    }, [
        feedType,
        isPulseActive,
        onPulseClick,
        createAnalyticsEvent
    ]);
    return {
        handleFeedTypeClick: handleFeedTypeClick,
        handleMouseDown: handleMouseDown,
        handlePulseClick: handlePulseClick
    };
};
module.exports["useFeedTypeSelectionAnalytics"] = $ddefccd0b521809e$export$b061eda6f93fd096;

});

parcelRegister("lSGGk", function(module, exports) {
/**
 * @generated SignedSource<<3a4a4d6f32b92794ff02b97a24cc29fc>>
 * @relayHash 3563e2678c4f0230602a4caec9253cda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d
const $95c9b04afdd6549f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "followSpace"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "followUser"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "unfollowSpace"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "unfollowUser"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followSpaces",
                            "variableName": "followSpace"
                        },
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "followUser"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowSpaces",
                            "variableName": "unfollowSpace"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollowUser"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3563e2678c4f0230602a4caec9253cda",
            "id": "cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d",
            "metadata": {},
            "name": "RecommendationTileFeedFollowRecommendationMutation",
            "operationKind": "mutation",
            "text": "mutation RecommendationTileFeedFollowRecommendationMutation($followUser:[ID],$followSpace:[Long],$unfollowUser:[ID],$unfollowSpace:[Long]){setFeedUserConfig(input:{followUsers:$followUser,followSpaces:$followSpace,unfollowUsers:$unfollowUser,unfollowSpaces:$unfollowSpace}){success}}"
        }
    };
}();
$95c9b04afdd6549f$var$node.hash = "1a44a6518af9b607fdb62610585fe24e";
var $95c9b04afdd6549f$export$2e2bcd8739ae039 = $95c9b04afdd6549f$var$node;
module.exports["default"] = $95c9b04afdd6549f$export$2e2bcd8739ae039;

});

parcelRegister("22wWM", function(module, exports) {
/**
 * @generated SignedSource<<5cc3c4fc1668fe9299fea677364560a9>>
 * @relayHash 8ab18764e7c16c14216367e856dab0c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549
const $dfbb3f88faf3da86$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "score"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "RecommendedFeedUserConfig",
            "kind": "LinkedField",
            "name": "getRecommendedFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "RecommendedSpaceItem",
                    "kind": "LinkedField",
                    "name": "recommendedSpaces",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "RecommendedPeopleItem",
                    "kind": "LinkedField",
                    "name": "recommendedPeople",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isActive"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "feedRecommendedUserSettingsDismissTimestamp"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "FeedRecommendationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "FeedRecommendationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "8ab18764e7c16c14216367e856dab0c3",
            "id": "457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549",
            "metadata": {},
            "name": "FeedRecommendationQuery",
            "operationKind": "query",
            "text": "query FeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
        }
    };
}();
$dfbb3f88faf3da86$var$node.hash = "cd2b1cf86c5bfd971e4c48e39a4c5b14";
var $dfbb3f88faf3da86$export$2e2bcd8739ae039 = $dfbb3f88faf3da86$var$node;
module.exports["default"] = $dfbb3f88faf3da86$export$2e2bcd8739ae039;

});

parcelRegister("ae97Z", function(module, exports) {
module.exports = new URL("EndOfFeedLight.17ca263f.svg", import.meta.url).toString();

});

parcelRegister("jPuSk", function(module, exports) {
module.exports = new URL("EndOfFeedDark.84fb6c4b.svg", import.meta.url).toString();

});

parcelRegister("c9bsS", function(module, exports) {
module.exports = new URL("PreFollowingLight.f92d45c7.svg", import.meta.url).toString();

});

parcelRegister("h25ik", function(module, exports) {
module.exports = new URL("PreFollowingDark.38051ab6.svg", import.meta.url).toString();

});

parcelRegister("3bXrA", function(module, exports) {
module.exports = new URL("PostFollowingLight.c84c69f2.svg", import.meta.url).toString();

});

parcelRegister("8ljLC", function(module, exports) {
module.exports = new URL("PostFollowingDark.27906e92.svg", import.meta.url).toString();

});

parcelRegister("lwwxZ", function(module, exports) {
/* FollowingFeedEmptyStateBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $hSHWm = parcelRequire("hSHWm");


var $koZ31 = parcelRequire("koZ31");


var $ggZ0S = parcelRequire("ggZ0S");


var $iArlt = parcelRequire("iArlt");


var $8n54R = parcelRequire("8n54R");


var $kuc4Y = parcelRequire("kuc4Y");


var $3bXrA = parcelRequire("3bXrA");


var $8ljLC = parcelRequire("8ljLC");


var $6pqsH = parcelRequire("6pqsH");

const $4b4f521239aa1ad4$var$messages = (0, $kSwu1.defineMessages)({
    noTeamTitle: {
        id: "feed.end-of-following.banner.no-team.title",
        defaultMessage: "Nothing from your team yet."
    },
    inviteDescription: {
        id: "feed.end-of-following.banner.invite.description",
        defaultMessage: "Invite your teammates to see their updates and trending content."
    },
    caughtUpTitle: {
        id: "feed.end-of-following.banner.caught-up.title",
        defaultMessage: "You're all caught up!"
    },
    caughtUpDescription: {
        id: "feed.end-of-following.banner.caught-up.description",
        defaultMessage: "Check back later or follow other teammates to see new updates."
    },
    inviteCta: {
        id: "feed.end-of-following.banner.invite.cta",
        defaultMessage: "Invite teammates"
    },
    followCta: {
        id: "feed.end-of-following.banner.follow.cta",
        defaultMessage: "Follow teammates"
    }
});
const $4b4f521239aa1ad4$var$bannerStyles = {
    banner: "_0bjKvDyzSk _4c065U8HPE _2Y7lL45zaO _3138422ADO",
    content: "_4ouGXIdnbC",
    text: "_4ouGXIdnbC",
    iconSlot: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _0hPCNLDIqT _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02Uofl",
    ctaSkeleton: "_0bjKvDKxmn _0KLXruGsB2 _0jFU0VUofl _39xV02yJqx",
    skeletonImage: "_3iDTPbvLZJ _0jFU0VIZbP _39xV02N91d"
};
const $4b4f521239aa1ad4$var$FollowingFeedSkeletonCards = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "following-feed-skeleton-cards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        testId: "following-feed-skeleton-card",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8n54R))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuc4Y))),
        alt: "",
        className: (0, $hekY6.default)([
            $4b4f521239aa1ad4$var$bannerStyles.skeletonImage
        ])
    }));
const $4b4f521239aa1ad4$export$a460856f6fe602e9 = ({ openActivityFilterModal: openActivityFilterModal })=>{
    const { openCoreInvites: openCoreInvites } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hSHWm.CoreInvitesContext));
    const { inviteDecisionLoading: inviteDecisionLoading, shouldShowInviteCta: shouldShowInviteCta } = (0, $6pqsH.useFollowingFeedInviteDecision)({
        enabled: true
    });
    const handleInviteTeammatesClick = (event)=>{
        event.stopPropagation();
        openCoreInvites?.((0, $koZ31.CoreInvitesSource).PERSISTENT_INVITE_HOMESCREEN, {
            onModalClosed: ()=>null,
            onInviteCompleted: ()=>null
        });
    };
    const bannerTitle = shouldShowInviteCta ? $4b4f521239aa1ad4$var$messages.noTeamTitle : $4b4f521239aa1ad4$var$messages.caughtUpTitle;
    const bannerDescription = shouldShowInviteCta ? $4b4f521239aa1ad4$var$messages.inviteDescription : $4b4f521239aa1ad4$var$messages.caughtUpDescription;
    const getPrimaryAction = ()=>{
        switch(true){
            case inviteDecisionLoading:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $4b4f521239aa1ad4$var$bannerStyles.ctaSkeleton,
                    testId: "following-feed-cta-skeleton",
                    "aria-hidden": "true"
                });
            case shouldShowInviteCta:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    onClick: handleInviteTeammatesClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4b4f521239aa1ad4$var$messages.inviteCta));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    onClick: openActivityFilterModal
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4b4f521239aa1ad4$var$messages.followCta));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        backgroundColor: "elevation.surface.sunken",
        xcss: $4b4f521239aa1ad4$var$bannerStyles.banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        space: "space.200",
        xcss: $4b4f521239aa1ad4$var$bannerStyles.content
    }, shouldShowInviteCta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4b4f521239aa1ad4$var$bannerStyles.iconSlot,
        testId: "following-feed-invite-icon",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ggZ0S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($iArlt))),
        width: "32",
        height: "32",
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4b4f521239aa1ad4$var$bannerStyles.iconSlot,
        testId: "following-feed-caught-up-icon",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3bXrA))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8ljLC))),
        width: "32",
        height: "32",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4b4f521239aa1ad4$var$bannerStyles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), bannerTitle)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), bannerDescription)))), getPrimaryAction())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4b4f521239aa1ad4$var$FollowingFeedSkeletonCards, null));
};
module.exports["FollowingFeedEmptyStateBanner"] = $4b4f521239aa1ad4$export$a460856f6fe602e9;

});

parcelRegister("VHj6G", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $kcIQr = parcelRequire("kcIQr");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jyA9t = parcelRequire("jyA9t");


var $82duu = parcelRequire("82duu");


var $7EIq6 = parcelRequire("7EIq6");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");

const $57af89769f3b54f2$export$67da31843589e9bd = ({ resolved: resolved, personalSpaceKey: personalSpaceKey, hasPersonalSpace: hasPersonalSpace, isCreateLiveDocEnabled: isCreateLiveDocEnabled, canOpenCreateWithRovo: canOpenCreateWithRovo })=>{
    // Mirror the legacy useCreateDoc
    // (subType follows the site-default live-doc capability, no targeted space).
    if (!resolved) return {
        strategy: 'creationLink',
        kind: 'link',
        subType: isCreateLiveDocEnabled ? (0, $dkIiA.ConfluencePageSubType).LIVE : undefined,
        spaceKey: undefined,
        contentType: isCreateLiveDocEnabled ? 'liveDoc' : 'page'
    };
    // Personal space exists.
    if (hasPersonalSpace && personalSpaceKey) {
        // Branch 1: live docs enabled in the personal space.
        if (isCreateLiveDocEnabled) return {
            strategy: 'personalSpaceLiveDoc',
            kind: 'link',
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            spaceKey: personalSpaceKey,
            contentType: 'liveDoc'
        };
        // Branch 3: live docs disabled in the personal space -> plain page in that space.
        return {
            strategy: 'creationLink',
            kind: 'link',
            subType: undefined,
            spaceKey: personalSpaceKey,
            contentType: 'page'
        };
    }
    // Branch 2: no personal space -> CWR with live doc preselected.
    if (canOpenCreateWithRovo) return {
        strategy: 'cwrLiveDoc',
        kind: 'cwr',
        contentType: 'liveDoc'
    };
    // Branch 2 fallback: CWR unavailable -> existing creation-link behaviour with live-doc intent.
    return {
        strategy: 'creationLink',
        kind: 'link',
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
        spaceKey: undefined,
        contentType: 'liveDoc'
    };
};
const $57af89769f3b54f2$export$bb9ce0ccb004e4f8 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { source: source } = t0;
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: (0, $82duu.CreationSource).NTH_USER_ACCOUNT_SETUP
        };
        $[0] = t1;
    } else t1 = $[0];
    const { personalSpaceKeyData: personalSpaceKeyData, personalSpaceKeyLoading: personalSpaceKeyLoading } = (0, $82duu.useCreatePersonalSpace)(t1);
    const personalSpaceKey = personalSpaceKeyData?.user?.confluence?.space?.key ?? undefined;
    const hasPersonalSpace = Boolean(personalSpaceKeyData?.user?.confluence?.hasPersonalSpace);
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled, isLoading: spaceContentTypesLoading } = (0, $7EIq6.useSpaceEnabledContentTypes)(personalSpaceKey);
    let t2;
    if ($[1] !== createEvent || $[2] !== hasPersonalSpace || $[3] !== isCreateLiveDocEnabled || $[4] !== isLicensed || $[5] !== isRovoLLMEnabled || $[6] !== openModal || $[7] !== personalSpaceKey || $[8] !== personalSpaceKeyLoading || $[9] !== push || $[10] !== source || $[11] !== spaceContentTypesLoading) {
        t2 = ()=>{
            const resolved = !personalSpaceKeyLoading && (!personalSpaceKey || !spaceContentTypesLoading);
            const hasUsablePersonalSpace = resolved && hasPersonalSpace && Boolean(personalSpaceKey);
            const canOpenCreateWithRovo = resolved && !hasUsablePersonalSpace && isRovoLLMEnabled && isLicensed;
            const action = $57af89769f3b54f2$export$67da31843589e9bd({
                resolved: resolved,
                personalSpaceKey: personalSpaceKey,
                hasPersonalSpace: hasPersonalSpace,
                isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                canOpenCreateWithRovo: canOpenCreateWithRovo
            });
            createEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "createDoc",
                    source: source,
                    attributes: {
                        createDocStrategy: action.strategy,
                        hasPersonalSpace: hasPersonalSpace,
                        contentType: action.contentType
                    }
                }
            }).fire();
            if (action.kind === "cwr") {
                openModal({
                    entryPoint: source,
                    spaceKey: "",
                    initialOutcomeType: "liveDoc"
                });
                return;
            }
            push((0, $bZSO8.buildCreationLink)({
                contentType: "page",
                subType: action.subType,
                spaceKey: action.spaceKey,
                withFallback: true,
                source: source
            }));
        };
        $[1] = createEvent;
        $[2] = hasPersonalSpace;
        $[3] = isCreateLiveDocEnabled;
        $[4] = isLicensed;
        $[5] = isRovoLLMEnabled;
        $[6] = openModal;
        $[7] = personalSpaceKey;
        $[8] = personalSpaceKeyLoading;
        $[9] = push;
        $[10] = source;
        $[11] = spaceContentTypesLoading;
        $[12] = t2;
    } else t2 = $[12];
    const createDoc = t2;
    let t3;
    if ($[13] !== createDoc) {
        t3 = {
            createDoc: createDoc
        };
        $[13] = createDoc;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};
module.exports["useCreateHomeEmptyStateDoc"] = $57af89769f3b54f2$export$bb9ce0ccb004e4f8;

});

parcelRegister("ggZ0S", function(module, exports) {
module.exports = new URL("FeedIllustrationLight.134f07fb.svg", import.meta.url).toString();

});

parcelRegister("iArlt", function(module, exports) {
module.exports = new URL("FeedIllustrationDark.a08142ea.svg", import.meta.url).toString();

});

parcelRegister("8n54R", function(module, exports) {
module.exports = new URL("FeedSkeletonLight.c38b6528.svg", import.meta.url).toString();

});

parcelRegister("kuc4Y", function(module, exports) {
module.exports = new URL("FeedSkeletonDark.2b0b3f1c.svg", import.meta.url).toString();

});

parcelRegister("flZ2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $7EIq6 = parcelRequire("7EIq6");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");

const $999c2987f6929bed$export$822e2e1e2e135442 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const createDoc = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createDoc',
                source: 'popularFeedEmptyState',
                attributes: {
                    contentType: isCreateLiveDocEnabled ? 'liveDoc' : 'page',
                    hasSpaceContext: !!spaceKey
                }
            }
        }).fire();
        const createUrl = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: isCreateLiveDocEnabled ? (0, $dkIiA.ConfluencePageSubType).LIVE : undefined,
            spaceKey: spaceKey,
            withFallback: true,
            source: 'popularFeedEmptyState'
        });
        push(createUrl);
    }, [
        createAnalyticsEvent,
        push,
        isCreateLiveDocEnabled,
        spaceKey
    ]);
    return {
        createDoc: createDoc
    };
};
module.exports["useCreateDoc"] = $999c2987f6929bed$export$822e2e1e2e135442;

});

parcelRegister("b6yoO", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2d94e9ff28ef8e76$export$64ac2b5f448712fd = /*#__PURE__*/ function(PageActivityAction) {
    PageActivityAction["created"] = "created";
    PageActivityAction["updated"] = "updated";
    PageActivityAction["started"] = "started";
    PageActivityAction["snapshotted"] = "snapshotted";
    PageActivityAction["published"] = "published";
    return PageActivityAction;
}({});
var $2d94e9ff28ef8e76$export$2aad1bd9e74391f = /*#__PURE__*/ function(PageActivityActionSubject) {
    PageActivityActionSubject["comment"] = "comment";
    PageActivityActionSubject["page"] = "page";
    return PageActivityActionSubject;
}({});
module.exports["PageActivityAction"] = $2d94e9ff28ef8e76$export$64ac2b5f448712fd;
module.exports["PageActivityActionSubject"] = $2d94e9ff28ef8e76$export$2aad1bd9e74391f;

});

parcelRegister("6uluu", function(module, exports) {
/* Comment.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $fs6LW = parcelRequire("fs6LW");


var $1RkMx = parcelRequire("1RkMx");


var $aG5uJ = parcelRequire("aG5uJ");


var $cYSIK = parcelRequire("cYSIK");


var $gusOH = parcelRequire("gusOH");


var $bEsCw = parcelRequire("bEsCw");

const $6555f42ec60dd986$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$profileWrapperStyles = (0, $buxP3.xcss)({
    marginRight: 'space.150'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6555f42ec60dd986$var$FullWidth = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$ContentLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Q7zJH _1mT5xdWVPG _39xV02N91d _0jFU0VN91d _42Yu6B7dHp",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommentContent = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2uo31f7Cj1 _1mT5xdRAKS _1DCdHi1Y8M _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommenterName = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1kk5Tkf7mX _1DCdHi1Y8M _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommentInlineText = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2uo31fhxIM _4FKVYEhJSK _39HuIbz8Lp _1ANEUSLRg7 _39xV02E6Kk _1EqgXlN91d _2XsHFMLl21 _313842Ll21 _1DCdHi1Y8M",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$var$CommenterNameContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $6555f42ec60dd986$export$4d299b491347818a = ({ user: user, comment: comment, pageId: pageId, contentType: contentType })=>{
    const authorName = user.displayName;
    const url = (0, $1RkMx.getCommentLink)(comment);
    const authorId = (0, $1RkMx.getUserAccountId)(user);
    const authorAvatar = user?.profilePicture?.path;
    const inlineText = 'inlineText' in comment.location ? comment.location.inlineText : null;
    const commentId = comment.id;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const onContentLinkClicked = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardViewComment',
            commentId: commentId,
            includeNavdex: true
        });
    }, [
        fireAnalyticsEvent,
        commentId
    ]);
    const compactComment = (0, $gusOH.useFeedShouldHideComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$Wrapper, null, !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6555f42ec60dd986$var$profileWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: authorId,
        src: authorAvatar,
        canViewProfile: true,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$FullWidth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$CommentContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$ContentLink, {
        href: url,
        onClick: onContentLinkClicked,
        "data-testid": "comment-content-link"
    }), !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$CommenterNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$CommenterName, null, authorName)), inlineText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6555f42ec60dd986$var$CommentInlineText, null, inlineText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG5uJ.RenderedContent), {
        content: comment
    })), !compactComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEsCw.CommentInfoLine), {
        comment: comment,
        pageId: pageId,
        contentType: contentType
    })));
};
module.exports["Comment"] = $6555f42ec60dd986$export$4d299b491347818a;

});

parcelRegister("1dnxO", function(module, exports) {
/**
 * YOU SHOULD PROBABLY CALL `useIsNav4Enabled` INSTEAD OF THIS FUNCTION.
 * Please check with #cc-disco before using.
 */ /**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              useIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/ // eslint-disable-next-line confluence-feature-gating/inline-usage
const $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad = ()=>{
    return true;
};
module.exports["getIsNav4Enabled"] = $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad;

});

parcelRegister("3aCVQ", function(module, exports) {
/**
 * @generated SignedSource<<311c957afd48bb0ead082f5456544ead>>
 * @relayHash 9e9248aaab72f68632f4f93a01114a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c
const $0a818f05ef99c6b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FeedCardActionsMenuQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FeedCardActionsMenuQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9248aaab72f68632f4f93a01114a92",
            "id": "834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c",
            "metadata": {},
            "name": "FeedCardActionsMenuQuery",
            "operationKind": "query",
            "text": "query FeedCardActionsMenuQuery($contentId:ID!){singleContent(id:$contentId){id,metadata{currentuser{favourited{isFavourite}}}}}"
        }
    };
}();
$0a818f05ef99c6b1$var$node.hash = "5b51ad676490df42bb3f9849e1afbcc7";
var $0a818f05ef99c6b1$export$2e2bcd8739ae039 = $0a818f05ef99c6b1$var$node;
module.exports["default"] = $0a818f05ef99c6b1$export$2e2bcd8739ae039;

});

parcelRegister("h9jgP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $lbT4j = parcelRequire("lbT4j");


var $b3j2Y = parcelRequire("b3j2Y");


var $bvJMy = parcelRequire("bvJMy");


var $cYSIK = parcelRequire("cYSIK");


var $lzJSA = parcelRequire("lzJSA");


var $Vc0wc = parcelRequire("Vc0wc");

const $a04196ec1f03cb0e$var$i18n = (0, $kSwu1.defineMessages)({
    star: {
        id: "feed.card.star.general",
        defaultMessage: "Star"
    },
    unstar: {
        id: "feed.card.unstar.general",
        defaultMessage: "Unstar"
    }
});
const $a04196ec1f03cb0e$var$FeedCardStarActionComponent = ({ intl: intl, contentId: contentId, isStarred: isStarred })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const [toggleIsStar, starMutationError] = (0, $Vc0wc.useContentStar)(contentId);
    const handleStarButton = (0, $cozmU.useCallback)(async ()=>{
        await toggleIsStar(isStarred);
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: isStarred ? 'deleted' : 'created',
            actionSubject: 'favouritePage',
            actionSubjectId: 'feedCardDropdown'
        });
    }, [
        fireAnalyticsEvent,
        toggleIsStar,
        isStarred
    ]);
    const icon = isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvJMy.StarSelectedIcon), {
        label: intl.formatMessage($a04196ec1f03cb0e$var$i18n.unstar)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        label: intl.formatMessage($a04196ec1f03cb0e$var$i18n.star)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, starMutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: starMutationError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isStarred ? $a04196ec1f03cb0e$var$i18n.unstar : $a04196ec1f03cb0e$var$i18n.star),
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lzJSA.ActionButtonWrapper), {
        forceShow: isStarred
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lzJSA.StyledActionButton), {
        onClick: handleStarButton,
        appearance: "subtle",
        iconBefore: icon
    }))));
};
const $a04196ec1f03cb0e$export$5467f2b0a84fcc5a = (0, $kSwu1.injectIntl)($a04196ec1f03cb0e$var$FeedCardStarActionComponent);
module.exports["FeedCardStarAction"] = $a04196ec1f03cb0e$export$5467f2b0a84fcc5a;

});

parcelRegister("6pqsH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $dQNZA = parcelRequire("dQNZA");


var $bQm3c = parcelRequire("bQm3c");


var $cg30H = parcelRequire("cg30H");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $46df4cd6878a79a5$export$a3af7f0d79e72aa = ({ enabled: enabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setOnboardingState: setOnboardingState, called: called } = (0, $ivb8S.useSetOnboardingState)();
    // `undefined` means "not yet determined" — distinguishing it from a resolved `false` lets the
    // loading state cover the imperative permission fetch so the banner doesn't flash from the
    // caught-up state to the invite state once the fetch resolves.
    const [hasInvitePermissions, setInvitePermissions] = (0, $cozmU.useState)(undefined);
    // We read the small-team signal from the SSR-safe `confluence_cloud_site_has_over_10_enabled_users`
    // TAP trait rather than the slow, region-limited `licenseConsumingUserCount` AGG field (which
    // would risk homepage SSR/VC90 regressions). Only an explicit `isOverTenEU === true` (>10 enabled
    // users) rules out the invite branch; a missing/errored/not-yet-resolved trait (`null`) is treated
    // as a small site, so we still run the capability check and let invite permissions be the gate.
    const { isOverTenEU: isOverTenEU, loading: traitLoading } = (0, $cg30H.useIsOverTenEnabledUsers)({
        skipBootstrap: !enabled
    });
    const isSmallSite = isOverTenEU !== true;
    // Wait for the trait to resolve before running the capability check so we don't fire its BE
    // side-effect (onboarding-state cache write + analytics) for sites that turn out to have >10
    // enabled users.
    const skipInviteCapabilityCheck = !enabled || !isSmallSite || traitLoading;
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $dBcar.PERSISTENT_INVITE)), skipInviteCapabilityCheck);
    const { hasInviteCapabilities: hasInviteCapabilities } = (0, $ivb8S.deserializeState)(onboardingStateData);
    (0, $cozmU.useEffect)(()=>{
        const setInvitePermsEligibility = async ()=>{
            const invitePermission = await (0, $dQNZA.checkInviteCapabilities)(cloudId, setOnboardingState, createAnalyticsEvent, 'followingFeedEmptyState');
            setInvitePermissions(invitePermission);
        };
        if (skipInviteCapabilityCheck || onboardingStateLoading) return;
        if (hasInviteCapabilities !== undefined) {
            setInvitePermissions(hasInviteCapabilities);
            return;
        }
        if (!called) setInvitePermsEligibility();
    }, [
        called,
        cloudId,
        createAnalyticsEvent,
        hasInviteCapabilities,
        onboardingStateLoading,
        setOnboardingState,
        skipInviteCapabilityCheck
    ]);
    // On a small site we are still deciding until either the cached capability or the fetched
    // permission resolves; keep loading true across that window so the CTA skeleton stays up.
    const inviteCapabilityResolved = hasInviteCapabilities !== undefined || hasInvitePermissions !== undefined;
    return {
        inviteDecisionLoading: enabled && (traitLoading || isSmallSite && (onboardingStateLoading || !inviteCapabilityResolved)),
        shouldShowInviteCta: enabled && isSmallSite && Boolean(hasInviteCapabilities ?? hasInvitePermissions)
    };
};
module.exports["useFollowingFeedInviteDecision"] = $46df4cd6878a79a5$export$a3af7f0d79e72aa;

});

parcelRegister("bEsCw", function(module, exports) {
/* CommentInfoLine.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $3FlVr = parcelRequire("3FlVr");


var $1NF8X = parcelRequire("1NF8X");


var $8SCD6 = parcelRequire("8SCD6");


var $1RkMx = parcelRequire("1RkMx");


var $cYSIK = parcelRequire("cYSIK");

const $64eaba19d2411713$var$i18n = (0, $kSwu1.defineMessages)({
    viewComment: {
        id: "feed.card.comment.viewComment",
        defaultMessage: "View comment"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64eaba19d2411713$var$FlexWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$ReactionsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $64eaba19d2411713$var$FlexWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _1kk5Tkf7mX _0hPCNLz9WS",
            __cmplp.isGlobalReactionsAndLikesEnabled ? "_37wbyuI7V3" : "_37wbyuz9WS",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$ViewCommentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2Zuz6QFQfX _37wbyu0dzo _4ouGXIQEt6",
            __cmplp.className
        ])
    });
});
const $64eaba19d2411713$var$CommentInfoLineComponent = ({ comment: comment, pageId: pageId, contentType: contentType })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $cYSIK.FeedCardContext));
    const { isReactionsEnabled: isGlobalReactionsAndLikesEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const url = (0, $1RkMx.getCommentLink)(comment);
    const commentId = comment.id;
    const onViewCommentClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'feedCardViewComment',
            commentId: commentId,
            includeNavdex: true
        });
    }, [
        fireAnalyticsEvent,
        commentId
    ]);
    const containerType = contentType === 'page' ? (0, $3FlVr.ReactionContainerType).PAGE : (0, $3FlVr.ReactionContainerType).BLOGPOST;
    const renderReactionsAndComments = ()=>{
        if (commentId && pageId && contentType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64eaba19d2411713$var$ReactionsWrapper, {
            "data-testid": "feed-comment-reactions",
            isGlobalReactionsAndLikesEnabled: isGlobalReactionsAndLikesEnabled
        }, isGlobalReactionsAndLikesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoader), {
            contentId: commentId,
            location: (0, $3FlVr.ReactionLocation).FEED_COMMENT,
            containerId: pageId,
            containerType: containerType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64eaba19d2411713$var$ViewCommentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            href: url,
            onClick: onViewCommentClick,
            appearance: "subtle-link",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $64eaba19d2411713$var$i18n.viewComment)))));
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("small", null, renderReactionsAndComments());
};
const $64eaba19d2411713$export$731efa827102c551 = (0, $kSwu1.injectIntl)($64eaba19d2411713$var$CommentInfoLineComponent);
module.exports["CommentInfoLine"] = $64eaba19d2411713$export$731efa827102c551;

});

parcelRegister("lzJSA", function(module, exports) {
/* ActionButtonStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");

const $a537987504338da5$export$578eab857fe08277 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwUofl",
            __cmplp.isSelected ? "_4vhRtve5R3" : "_4vhRtvKGUX",
            __cmplp.className
        ])
    });
});
const $a537987504338da5$var$actionButtonWrapperStyle = null;
const $a537987504338da5$var$forceShowStyle = null; // Note: this component extracts the props that we don't want to send to the DOM
const $a537987504338da5$export$fb0bb875e597a5e3 = ({ forceShow: forceShow, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...rest,
        className: (0, $hekY6.default)([
            "_23rrnHbv7O _1YKVNsqGUA",
            forceShow && "_1YKVNs7dHp"
        ])
    });
module.exports["StyledActionButton"] = $a537987504338da5$export$578eab857fe08277;
module.exports["ActionButtonWrapper"] = $a537987504338da5$export$fb0bb875e597a5e3;

});

parcelRegister("Vc0wc", function(module, exports) {

var $j5afu = parcelRequire("j5afu");


var $9T0kv = parcelRequire("9T0kv");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $4MnFz = parcelRequire("4MnFz");


var $308Wd = parcelRequire("308Wd");

const $c0ad904515836ea9$var$useContentStarStarMutation = (0, $9T0kv.default);
const $c0ad904515836ea9$var$useContentStarUnstarMutation = (0, $j5afu.default);
const $c0ad904515836ea9$var$i18n = (0, $kSwu1.defineMessages)({
    starMutationErrorTitle: {
        id: "feed.card.star.mutation.error.title",
        defaultMessage: "We\u2019re having trouble starring that item"
    },
    unstarMutationErrorTitle: {
        id: "feed.card.unstar.mutation.error.title",
        defaultMessage: "We\u2019re having trouble unstarring that item"
    },
    starMutationErrorDescription: {
        id: "feed.card.star.mutation.error.description",
        defaultMessage: "Try it again."
    }
});
function $c0ad904515836ea9$export$a3a3fd423fa20c0d(contentId) {
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const onMutationError = (0, $cozmU.useCallback)((isStarred)=>()=>{
            showFlag({
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c0ad904515836ea9$var$i18n.starMutationErrorDescription),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isStarred ? $c0ad904515836ea9$var$i18n.unstarMutationErrorTitle : $c0ad904515836ea9$var$i18n.starMutationErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "error",
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious"
                }),
                isAutoDismiss: true
            });
        }, [
        showFlag
    ]);
    const [mutateStar, { error: starError }] = (0, $308Wd.useMutationInterop)($c0ad904515836ea9$var$useContentStarStarMutation, {
        variables: {
            contentId: contentId
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                __typename: 'FavouritedSummary',
                                isFavourite: true
                            }
                        }
                    }
                }
            }
        },
        onError: onMutationError(false),
        __callerPackage__: "feed"
    });
    const [mutateUnstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($c0ad904515836ea9$var$useContentStarUnstarMutation, {
        variables: {
            contentId: contentId
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        },
        onError: onMutationError(true),
        __callerPackage__: "feed"
    });
    const toggleStarState = (0, $cozmU.useCallback)(async (starred)=>{
        try {
            if (starred) await mutateUnstar();
            else await mutateStar();
        } catch  {} // errors handled via useMutation
    }, [
        mutateStar,
        mutateUnstar
    ]);
    return [
        toggleStarState,
        starError || unstarError
    ];
}
module.exports["useContentStar"] = $c0ad904515836ea9$export$a3a3fd423fa20c0d;

});

parcelRegister("dQNZA", function(module, exports) {

var $4krqA = parcelRequire("4krqA");


var $dBcar = parcelRequire("dBcar");

const $dbf885492cebe235$var$CONFLUENCE_KEY = 'confluence';
const $dbf885492cebe235$export$af9b00d198ddf6c9 = async (cloudId, setOnboardingState, createAnalyticsEvent, source = 'persistentInviteButton')=>{
    const response = await (0, $4krqA.memoizedGetInvitePermissions)(cloudId);
    const canInviteToConfluence = [
        ...response?.directInvite ?? [],
        ...response?.invitePendingApproval ?? []
    ].some((item)=>item.includes($dbf885492cebe235$var$CONFLUENCE_KEY));
    setOnboardingState({
        key: (0, $dBcar.PERSISTENT_INVITE).HAS_INVITE_CAPABILITIES,
        value: canInviteToConfluence
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'called',
            actionSubject: 'inviteCapabilitiesAPI',
            attributes: {
                hasPermission: canInviteToConfluence
            },
            source: source
        }
    }).fire();
    return canInviteToConfluence;
};
module.exports["checkInviteCapabilities"] = $dbf885492cebe235$export$af9b00d198ddf6c9;

});

parcelRegister("j5afu", function(module, exports) {
/**
 * @generated SignedSource<<69139d5fdacbca106a1e72733c02e36e>>
 * @relayHash f352cba41fdb7e45612ba8e8c63f4924
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3
const $0f9b28a2e9d4de51$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStarUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStarUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f352cba41fdb7e45612ba8e8c63f4924",
            "id": "06b92e70fa740f611534cdf8a6c534986b8fd02bf146f9efe7aae5e4330ec5d3",
            "metadata": {},
            "name": "useContentStarUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation useContentStarUnstarMutation($contentId:ID!){unfavouritePage(favouritePageInput:{pageId:$contentId}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0f9b28a2e9d4de51$var$node.hash = "93f47afb6f09bd32bab5f61b3e99d199";
var $0f9b28a2e9d4de51$export$2e2bcd8739ae039 = $0f9b28a2e9d4de51$var$node;
module.exports["default"] = $0f9b28a2e9d4de51$export$2e2bcd8739ae039;

});

parcelRegister("9T0kv", function(module, exports) {
/**
 * @generated SignedSource<<b95cb36a6f889f4e9906798d8e2944f3>>
 * @relayHash c0dd553a4d073bcedc8c1fca7c75cde7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 753d5cc9fd872f7a704bbfe19b4d5845ce0773de2f795afdbdafcad14ec14847
const $ce47c8c2a1b89c81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStarStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStarStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c0dd553a4d073bcedc8c1fca7c75cde7",
            "id": "753d5cc9fd872f7a704bbfe19b4d5845ce0773de2f795afdbdafcad14ec14847",
            "metadata": {},
            "name": "useContentStarStarMutation",
            "operationKind": "mutation",
            "text": "mutation useContentStarStarMutation($contentId:ID!){favouritePage(favouritePageInput:{pageId:$contentId}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$ce47c8c2a1b89c81$var$node.hash = "9040a024eb74fffcf9c56372e06501bd";
var $ce47c8c2a1b89c81$export$2e2bcd8739ae039 = $ce47c8c2a1b89c81$var$node;
module.exports["default"] = $ce47c8c2a1b89c81$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ForYou.7d8f30db.js.map
